import * as A from "react";
import E, { useRef as Ve, useEffect as Fe, useState as Se, useLayoutEffect as qn, useCallback as $e, useReducer as _i, useMemo as Je, forwardRef as ue, useContext as dt, createContext as xt, Children as Gr, isValidElement as Xn, createElement as sr, cloneElement as Wr, Fragment as ca, useImperativeHandle as Kv, lazy as de, Suspense as jO } from "react";
import * as Qv from "react-dom";
import ni, { flushSync as e8, createPortal as LO } from "react-dom";
const E2 = ["mousedown", "touchstart"];
function r8(e, r, t) {
  const n = Ve();
  return Fe(() => {
    const o = (a) => {
      const { target: i } = a != null ? a : {};
      if (Array.isArray(t)) {
        const l = (i == null ? void 0 : i.hasAttribute("data-ignore-outside-clicks")) || !document.body.contains(i) && i.tagName !== "HTML";
        t.every((u) => !!u && !a.composedPath().includes(u)) && !l && e();
      } else
        n.current && !n.current.contains(i) && e();
    };
    return (r || E2).forEach((a) => document.addEventListener(a, o)), () => {
      (r || E2).forEach((a) => document.removeEventListener(a, o));
    };
  }, [n, e, t]), n;
}
function zO(e, r) {
  try {
    return e.addEventListener("change", r), () => e.removeEventListener("change", r);
  } catch {
    return e.addListener(r), () => e.removeListener(r);
  }
}
function VO(e, r) {
  return typeof r == "boolean" ? r : typeof window != "undefined" && "matchMedia" in window ? window.matchMedia(e).matches : !1;
}
function t8(e, r, { getInitialValueInEffect: t } = {
  getInitialValueInEffect: !0
}) {
  const [n, o] = Se(t ? r : VO(e, r)), a = Ve();
  return Fe(() => {
    if ("matchMedia" in window)
      return a.current = window.matchMedia(e), o(a.current.matches), zO(a.current, (i) => o(i.matches));
  }, [e]), n;
}
function Co(e, r, t) {
  return Math.min(Math.max(e, r), t);
}
var FO = Object.defineProperty, R2 = Object.getOwnPropertySymbols, ZO = Object.prototype.hasOwnProperty, WO = Object.prototype.propertyIsEnumerable, A2 = (e, r, t) => r in e ? FO(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, k2 = (e, r) => {
  for (var t in r || (r = {}))
    ZO.call(r, t) && A2(e, t, r[t]);
  if (R2)
    for (var t of R2(r))
      WO.call(r, t) && A2(e, t, r[t]);
  return e;
};
const BO = {
  min: -1 / 0,
  max: 1 / 0
};
function t5e(e = 0, r) {
  const { min: t, max: n } = k2(k2({}, BO), r), [o, a] = Se(Co(e, t, n));
  return [o, { increment: () => a((d) => Co(d + 1, t, n)), decrement: () => a((d) => Co(d - 1, t, n)), set: (d) => a(Co(d, t, n)), reset: () => a(Co(e, t, n)) }];
}
function n5e(e, r, t = { leading: !1 }) {
  const [n, o] = Se(e), a = Ve(!1), i = Ve(null), l = Ve(!1), s = () => window.clearTimeout(i.current);
  return Fe(() => {
    a.current && (!l.current && t.leading ? (l.current = !0, o(e)) : (s(), i.current = window.setTimeout(() => {
      l.current = !1, o(e);
    }, r)));
  }, [e, t.leading, r]), Fe(() => (a.current = !0, s), []), [n, s];
}
const Vu = typeof document != "undefined" ? qn : Fe;
function ct(e, r) {
  const t = Ve(!1);
  Fe(() => () => {
    t.current = !1;
  }, []), Fe(() => {
    if (t.current)
      return e();
    t.current = !0;
  }, r);
}
function n8({ opened: e, shouldReturnFocus: r = !0 }) {
  const t = Ve(), n = () => {
    var o;
    t.current && "focus" in t.current && typeof t.current.focus == "function" && ((o = t.current) == null || o.focus({ preventScroll: !0 }));
  };
  return ct(() => {
    let o = -1;
    const a = (i) => {
      i.key === "Tab" && window.clearTimeout(o);
    };
    return document.addEventListener("keydown", a), e ? t.current = document.activeElement : r && (o = window.setTimeout(n, 10)), () => {
      window.clearTimeout(o), document.removeEventListener("keydown", a);
    };
  }, [e, r]), n;
}
const HO = /input|select|textarea|button|object/, o8 = "a, input, select, textarea, button, object, [tabindex]";
function GO(e) {
  return process.env.NODE_ENV === "test" ? !1 : e.style.display === "none";
}
function XO(e) {
  if (e.getAttribute("aria-hidden") || e.getAttribute("hidden") || e.getAttribute("type") === "hidden")
    return !1;
  let t = e;
  for (; t && !(t === document.body || t.nodeType === 11); ) {
    if (GO(t))
      return !1;
    t = t.parentNode;
  }
  return !0;
}
function a8(e) {
  let r = e.getAttribute("tabindex");
  return r === null && (r = void 0), parseInt(r, 10);
}
function Kd(e) {
  const r = e.nodeName.toLowerCase(), t = !Number.isNaN(a8(e));
  return (HO.test(r) && !e.disabled || e instanceof HTMLAnchorElement && e.href || t) && XO(e);
}
function i8(e) {
  const r = a8(e);
  return (Number.isNaN(r) || r >= 0) && Kd(e);
}
function YO(e) {
  return Array.from(e.querySelectorAll(o8)).filter(i8);
}
function UO(e, r) {
  const t = YO(e);
  if (!t.length) {
    r.preventDefault();
    return;
  }
  const n = t[r.shiftKey ? 0 : t.length - 1], o = e.getRootNode();
  if (!(n === o.activeElement || e === o.activeElement))
    return;
  r.preventDefault();
  const i = t[r.shiftKey ? t.length - 1 : 0];
  i && i.focus();
}
function B0() {
  return `mantine-${Math.random().toString(36).slice(2, 11)}`;
}
function JO(e, r = "body > :not(script)") {
  const t = B0(), n = Array.from(document.querySelectorAll(r)).map((o) => {
    var a;
    if ((a = o == null ? void 0 : o.shadowRoot) != null && a.contains(e) || o.contains(e))
      return;
    const i = o.getAttribute("aria-hidden"), l = o.getAttribute("data-hidden"), s = o.getAttribute("data-focus-id");
    return o.setAttribute("data-focus-id", t), i === null || i === "false" ? o.setAttribute("aria-hidden", "true") : !l && !s && o.setAttribute("data-hidden", i), {
      node: o,
      ariaHidden: l || null
    };
  });
  return () => {
    n.forEach((o) => {
      !o || t !== o.node.getAttribute("data-focus-id") || (o.ariaHidden === null ? o.node.removeAttribute("aria-hidden") : o.node.setAttribute("aria-hidden", o.ariaHidden), o.node.removeAttribute("data-focus-id"), o.node.removeAttribute("data-hidden"));
    });
  };
}
function qO(e = !0) {
  const r = Ve(), t = Ve(null), n = (a) => {
    let i = a.querySelector("[data-autofocus]");
    if (!i) {
      const l = Array.from(a.querySelectorAll(o8));
      i = l.find(i8) || l.find(Kd) || null, !i && Kd(a) && (i = a);
    }
    i ? i.focus({ preventScroll: !0 }) : process.env.NODE_ENV === "development" && console.warn("[@mantine/hooks/use-focus-trap] Failed to find focusable element within provided node", a);
  }, o = $e((a) => {
    if (e) {
      if (a === null) {
        t.current && (t.current(), t.current = null);
        return;
      }
      t.current = JO(a), r.current !== a && (a ? (setTimeout(() => {
        a.getRootNode() ? n(a) : process.env.NODE_ENV === "development" && console.warn("[@mantine/hooks/use-focus-trap] Ref node is not part of the dom", a);
      }), r.current = a) : r.current = null);
    }
  }, [e]);
  return Fe(() => {
    if (!e)
      return;
    r.current && setTimeout(() => n(r.current));
    const a = (i) => {
      i.key === "Tab" && r.current && UO(r.current, i);
    };
    return document.addEventListener("keydown", a), () => {
      document.removeEventListener("keydown", a), t.current && t.current();
    };
  }, [e]), o;
}
const KO = (e) => (e + 1) % 1e6;
function o5e() {
  const [, e] = _i(KO, 0);
  return e;
}
const QO = E.useId || (() => {
});
function eP() {
  const e = QO();
  return e ? `mantine-${e.replace(/:/g, "")}` : "";
}
function ke(e) {
  const r = eP(), [t, n] = Se(r);
  return Vu(() => {
    n(B0());
  }, []), typeof e == "string" ? e : typeof window == "undefined" ? r : t;
}
function a5e(e, r) {
  const [t, n] = Se(!1), o = Ve(), a = Ve();
  Fe(() => {
    a.current = e;
  }, [e]);
  const i = () => {
    n((u) => (!u && !o.current && (o.current = window.setInterval(a.current, r)), !0));
  }, l = () => {
    n(!1), window.clearInterval(o.current), o.current = void 0;
  };
  return { start: i, stop: l, toggle: () => {
    t ? l() : i();
  }, active: t };
}
function Cn(e, r, t) {
  Fe(() => (window.addEventListener(e, r, t), () => window.removeEventListener(e, r, t)), [e, r]);
}
function rP(e, r) {
  try {
    return JSON.stringify(e);
  } catch {
    throw new Error(`@mantine/hooks ${r}: Failed to serialize the value`);
  }
}
function tP(e) {
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}
function nP(e, r) {
  const t = e === "localStorage" ? "mantine-local-storage" : "mantine-session-storage";
  return function({
    key: o,
    defaultValue: a = void 0,
    getInitialValueInEffect: i = !0,
    deserialize: l = tP,
    serialize: s = (u) => rP(u, r)
  }) {
    const u = $e((h) => {
      if (typeof window == "undefined" || !(e in window) || window[e] === null || h)
        return a;
      const v = window[e].getItem(o);
      return v !== null ? l(v) : a;
    }, [o, a]), [d, f] = Se(u(i)), p = $e((h) => {
      h instanceof Function ? f((v) => {
        const y = h(v);
        return window[e].setItem(o, s(y)), window.dispatchEvent(new CustomEvent(t, { detail: { key: o, value: h(v) } })), y;
      }) : (window[e].setItem(o, s(h)), window.dispatchEvent(new CustomEvent(t, { detail: { key: o, value: h } })), f(h));
    }, [o]), g = $e(() => {
      window[e].removeItem(o), window.dispatchEvent(new CustomEvent(t, { detail: { key: o, value: a } }));
    }, []);
    return Cn("storage", (h) => {
      var v;
      h.storageArea === window[e] && h.key === o && f(l((v = h.newValue) != null ? v : void 0));
    }), Cn(t, (h) => {
      h.detail.key === o && f(h.detail.value);
    }), Fe(() => {
      a !== void 0 && d === void 0 && p(a);
    }, [a, d, p]), Fe(() => {
      i && f(u());
    }, [o]), [
      d === void 0 ? a : d,
      p,
      g
    ];
  };
}
function i5e(e) {
  return nP("localStorage", "use-local-storage")(e);
}
function l8(e, r) {
  typeof e == "function" ? e(r) : typeof e == "object" && e !== null && "current" in e && (e.current = r);
}
function s8(...e) {
  return (r) => {
    e.forEach((t) => l8(t, r));
  };
}
function Kn(...e) {
  return $e(s8(...e), e);
}
function Hr({
  value: e,
  defaultValue: r,
  finalValue: t,
  onChange: n = () => {
  }
}) {
  const [o, a] = Se(r !== void 0 ? r : t), i = (l) => {
    a(l), n == null || n(l);
  };
  return e !== void 0 ? [e, n, !0] : [o, i, !1];
}
function zn(e, r) {
  const t = r - e + 1;
  return Array.from({ length: t }, (n, o) => o + e);
}
const Gi = "dots";
function l5e({
  total: e,
  siblings: r = 1,
  boundaries: t = 1,
  page: n,
  initialPage: o = 1,
  onChange: a
}) {
  const i = Math.max(Math.trunc(e), 0), [l, s] = Hr({
    value: n,
    onChange: a,
    defaultValue: o,
    finalValue: o
  }), u = (v) => {
    v <= 0 ? s(1) : v > i ? s(i) : s(v);
  }, d = () => u(l + 1), f = () => u(l - 1), p = () => u(1), g = () => u(i);
  return {
    range: Je(() => {
      if (r * 2 + 3 + t * 2 >= i)
        return zn(1, i);
      const y = Math.max(l - r, t), w = Math.min(l + r, i - t), $ = y > t + 2, C = w < i - (t + 1);
      if (!$ && C) {
        const x = r * 2 + t + 2;
        return [...zn(1, x), Gi, ...zn(i - (t - 1), i)];
      }
      if ($ && !C) {
        const x = t + 1 + 2 * r;
        return [...zn(1, t), Gi, ...zn(i - x, i)];
      }
      return [
        ...zn(1, t),
        Gi,
        ...zn(y, w),
        Gi,
        ...zn(i - t + 1, i)
      ];
    }, [i, r, l]),
    active: l,
    setPage: u,
    next: d,
    previous: f,
    first: p,
    last: g
  };
}
function Fu(e, r) {
  return t8("(prefers-reduced-motion: reduce)", e, r);
}
const oP = (e) => e < 0.5 ? 2 * e * e : -1 + (4 - 2 * e) * e, aP = ({
  axis: e,
  target: r,
  parent: t,
  alignment: n,
  offset: o,
  isList: a
}) => {
  if (!r || !t && typeof document == "undefined")
    return 0;
  const i = !!t, s = (t || document.body).getBoundingClientRect(), u = r.getBoundingClientRect(), d = (f) => u[f] - s[f];
  if (e === "y") {
    const f = d("top");
    if (f === 0)
      return 0;
    if (n === "start") {
      const g = f - o;
      return g <= u.height * (a ? 0 : 1) || !a ? g : 0;
    }
    const p = i ? s.height : window.innerHeight;
    if (n === "end") {
      const g = f + o - p + u.height;
      return g >= -u.height * (a ? 0 : 1) || !a ? g : 0;
    }
    return n === "center" ? f - p / 2 + u.height / 2 : 0;
  }
  if (e === "x") {
    const f = d("left");
    if (f === 0)
      return 0;
    if (n === "start") {
      const g = f - o;
      return g <= u.width || !a ? g : 0;
    }
    const p = i ? s.width : window.innerWidth;
    if (n === "end") {
      const g = f + o - p + u.width;
      return g >= -u.width || !a ? g : 0;
    }
    return n === "center" ? f - p / 2 + u.width / 2 : 0;
  }
  return 0;
}, iP = ({ axis: e, parent: r }) => {
  if (!r && typeof document == "undefined")
    return 0;
  const t = e === "y" ? "scrollTop" : "scrollLeft";
  if (r)
    return r[t];
  const { body: n, documentElement: o } = document;
  return n[t] + o[t];
}, lP = ({ axis: e, parent: r, distance: t }) => {
  if (!r && typeof document == "undefined")
    return;
  const n = e === "y" ? "scrollTop" : "scrollLeft";
  if (r)
    r[n] = t;
  else {
    const { body: o, documentElement: a } = document;
    o[n] = t, a[n] = t;
  }
};
function sP({
  duration: e = 1250,
  axis: r = "y",
  onScrollFinish: t,
  easing: n = oP,
  offset: o = 0,
  cancelable: a = !0,
  isList: i = !1
} = {}) {
  const l = Ve(0), s = Ve(0), u = Ve(!1), d = Ve(null), f = Ve(null), p = Fu(), g = () => {
    l.current && cancelAnimationFrame(l.current);
  }, h = $e(({ alignment: y = "start" } = {}) => {
    var w;
    u.current = !1, l.current && g();
    const $ = (w = iP({ parent: d.current, axis: r })) != null ? w : 0, C = aP({
      parent: d.current,
      target: f.current,
      axis: r,
      alignment: y,
      offset: o,
      isList: i
    }) - (d.current ? 0 : $);
    function x() {
      s.current === 0 && (s.current = performance.now());
      const O = performance.now() - s.current, _ = p || e === 0 ? 1 : O / e, P = $ + C * n(_);
      lP({
        parent: d.current,
        axis: r,
        distance: P
      }), !u.current && _ < 1 ? l.current = requestAnimationFrame(x) : (typeof t == "function" && t(), s.current = 0, l.current = 0, g());
    }
    x();
  }, [r, e, n, i, o, t, p]), v = () => {
    a && (u.current = !0);
  };
  return Cn("wheel", v, {
    passive: !0
  }), Cn("touchmove", v, {
    passive: !0
  }), Fe(() => g, []), {
    scrollableRef: d,
    targetRef: f,
    scrollIntoView: h,
    cancel: g
  };
}
const cP = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
function uP() {
  const e = Ve(0), r = Ve(null), [t, n] = Se(cP), o = Je(() => typeof window != "undefined" ? new ResizeObserver((a) => {
    const i = a[0];
    i && (cancelAnimationFrame(e.current), e.current = requestAnimationFrame(() => {
      r.current && n(i.contentRect);
    }));
  }) : null, []);
  return Vu(() => (r.current && (o.observe(r.current), n(r.current.getBoundingClientRect())), () => {
    o.disconnect(), e.current && cancelAnimationFrame(e.current);
  }), [r.current]), [r, t];
}
function dP() {
  const [e, { width: r, height: t }] = uP();
  return { ref: e, width: r, height: t };
}
function fP(e = [!1, !0]) {
  const [[r], t] = _i((n, o) => {
    const a = o instanceof Function ? o(n[0]) : o, i = Math.abs(n.indexOf(a));
    return n.slice(i).concat(n.slice(0, i));
  }, e);
  return [r, t];
}
const M2 = {
  passive: !0
};
function s5e() {
  const [e, r] = Se({
    width: 0,
    height: 0
  }), t = $e(() => {
    r({ width: window.innerWidth || 0, height: window.innerHeight || 0 });
  }, []);
  return Cn("resize", t, M2), Cn("orientationchange", t, M2), Fe(t, []), e;
}
function N2() {
  const e = window.document;
  return e.fullscreenElement || e.webkitFullscreenElement || e.mozFullScreenElement || e.msFullscreenElement;
}
async function pP() {
  const e = window.document;
  return typeof e.exitFullscreen == "function" ? e.exitFullscreen() : typeof e.msExitFullscreen == "function" ? e.msExitFullscreen() : typeof e.webkitExitFullscreen == "function" ? e.webkitExitFullscreen() : typeof e.mozCancelFullScreen == "function" ? e.mozCancelFullScreen() : null;
}
async function gP(e) {
  var r, t, n, o, a;
  const i = e;
  return ((r = i.requestFullscreen) == null ? void 0 : r.call(i)) || ((t = i.msRequestFullscreen) == null ? void 0 : t.call(i)) || ((n = i.webkitEnterFullscreen) == null ? void 0 : n.call(i)) || ((o = i.webkitRequestFullscreen) == null ? void 0 : o.call(i)) || ((a = i.mozRequestFullscreen) == null ? void 0 : a.call(i));
}
const T2 = ["", "webkit", "moz", "ms"];
function D2(e, {
  onFullScreen: r,
  onError: t
}) {
  return T2.forEach((n) => {
    e.addEventListener(`${n}fullscreenchange`, r), e.addEventListener(`${n}fullscreenerror`, t);
  }), () => {
    T2.forEach((n) => {
      e.removeEventListener(`${n}fullscreenchange`, r), e.removeEventListener(`${n}fullscreenerror`, t);
    });
  };
}
function c5e() {
  const [e, r] = Se(!1), t = Ve(), n = $e((l) => {
    r(l.target === N2());
  }, [r]), o = $e((l) => {
    r(!1), console.error(`[@mantine/hooks] use-fullscreen: Error attempting full-screen mode method: ${l} (${l.target})`);
  }, [r]), a = $e(async () => {
    N2() ? await pP() : await gP(t.current);
  }, []), i = $e((l) => {
    l === null ? t.current = window.document.documentElement : t.current = l;
  }, []);
  return Fe(() => {
    if (!t.current && window.document)
      return t.current = window.document.documentElement, D2(t.current, {
        onFullScreen: n,
        onError: o
      });
    if (t.current)
      return D2(t.current, {
        onFullScreen: n,
        onError: o
      });
  }, []), { ref: i, toggle: a, fullscreen: e };
}
function u5e(e, r) {
  return Fe(() => (console.log(`${e} mounted`, ...r), () => console.log(`${e} unmounted`)), []), ct(() => {
    console.log(`${e} updated`, ...r);
  }, r), null;
}
function j2() {
  if (typeof window == "undefined")
    return "undetermined";
  const { userAgent: e } = window.navigator, r = /(Macintosh)|(MacIntel)|(MacPPC)|(Mac68K)/i, t = /(Win32)|(Win64)|(Windows)|(WinCE)/i, n = /(iPhone)|(iPad)|(iPod)/i;
  return r.test(e) ? "macos" : n.test(e) ? "ios" : t.test(e) ? "windows" : /Android/i.test(e) ? "android" : /Linux/i.test(e) ? "linux" : "undetermined";
}
function d5e(e = { getValueInEffect: !0 }) {
  const [r, t] = Se(e.getValueInEffect ? "undetermined" : j2());
  return Vu(() => {
    e.getValueInEffect && t(j2);
  }, []), r;
}
var vP = Object.defineProperty, L2 = Object.getOwnPropertySymbols, mP = Object.prototype.hasOwnProperty, hP = Object.prototype.propertyIsEnumerable, z2 = (e, r, t) => r in e ? vP(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, V2 = (e, r) => {
  for (var t in r || (r = {}))
    mP.call(r, t) && z2(e, t, r[t]);
  if (L2)
    for (var t of L2(r))
      hP.call(r, t) && z2(e, t, r[t]);
  return e;
};
function f5e(e) {
  const [r, t] = Se(e), n = $e((o) => t((a) => V2(V2({}, a), typeof o == "function" ? o(a) : o)), []);
  return [r, n];
}
function bP(e) {
  return (r) => {
    if (!r)
      e(r);
    else if (typeof r == "function")
      e(r);
    else if (typeof r == "object" && "nativeEvent" in r) {
      const { currentTarget: t } = r;
      t.type === "checkbox" ? e(t.checked) : e(t.value);
    } else
      e(r);
  };
}
function p5e(e) {
  const [r, t] = Se(e);
  return [r, bP(t)];
}
function H0(e = !1, r) {
  const { onOpen: t, onClose: n } = r || {}, [o, a] = Se(e), i = $e(() => {
    a((u) => u || (t == null || t(), !0));
  }, [t]), l = $e(() => {
    a((u) => u && (n == null || n(), !1));
  }, [n]), s = $e(() => {
    o ? l() : i();
  }, [l, i, o]);
  return [o, { open: i, close: l, toggle: s }];
}
var yP = Object.defineProperty, F2 = Object.getOwnPropertySymbols, CP = Object.prototype.hasOwnProperty, wP = Object.prototype.propertyIsEnumerable, Z2 = (e, r, t) => r in e ? yP(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Da = (e, r) => {
  for (var t in r || (r = {}))
    CP.call(r, t) && Z2(e, t, r[t]);
  if (F2)
    for (var t of F2(r))
      wP.call(r, t) && Z2(e, t, r[t]);
  return e;
};
function Xi() {
  if (typeof navigator == "undefined")
    return {};
  const e = navigator, r = e.connection || e.mozConnection || e.webkitConnection;
  return r ? {
    downlink: r == null ? void 0 : r.downlink,
    downlinkMax: r == null ? void 0 : r.downlinkMax,
    effectiveType: r == null ? void 0 : r.effectiveType,
    rtt: r == null ? void 0 : r.rtt,
    saveData: r == null ? void 0 : r.saveData,
    type: r == null ? void 0 : r.type
  } : {};
}
function g5e() {
  const [e, r] = Se({
    online: !0
  }), t = $e(() => r((n) => Da(Da({}, n), Xi())), []);
  return Cn("online", () => r(Da({ online: !0 }, Xi()))), Cn("offline", () => r(Da({ online: !1 }, Xi()))), Fe(() => {
    const n = navigator;
    if (n.connection)
      return r(Da({ online: n.onLine }, Xi())), n.connection.addEventListener("change", t), () => n.connection.removeEventListener("change", t);
  }, []), e;
}
function W2(e) {
  return typeof e != "string" ? "" : e.charAt(0).toUpperCase() + e.slice(1);
}
var _P = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const B2 = (e) => {
  let r;
  const t = /* @__PURE__ */ new Set(), n = (d, f) => {
    const p = typeof d == "function" ? d(r) : d;
    if (!Object.is(p, r)) {
      const g = r;
      r = (f != null ? f : typeof p != "object" || p === null) ? p : Object.assign({}, r, p), t.forEach((h) => h(r, g));
    }
  }, o = () => r, s = { setState: n, getState: o, getInitialState: () => u, subscribe: (d) => (t.add(d), () => t.delete(d)), destroy: () => {
    (_P ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), t.clear();
  } }, u = r = e(n, o, s);
  return s;
}, xP = (e) => e ? B2(e) : B2;
var Mo = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Qn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function eo(e) {
  if (e.__esModule)
    return e;
  var r = e.default;
  if (typeof r == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    t.prototype = r.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(t, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), t;
}
var Qd = { exports: {} }, z1 = {}, Yi = { exports: {} }, V1 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var H2;
function $P() {
  if (H2)
    return V1;
  H2 = 1;
  var e = E;
  function r(f, p) {
    return f === p && (f !== 0 || 1 / f === 1 / p) || f !== f && p !== p;
  }
  var t = typeof Object.is == "function" ? Object.is : r, n = e.useState, o = e.useEffect, a = e.useLayoutEffect, i = e.useDebugValue;
  function l(f, p) {
    var g = p(), h = n({ inst: { value: g, getSnapshot: p } }), v = h[0].inst, y = h[1];
    return a(function() {
      v.value = g, v.getSnapshot = p, s(v) && y({ inst: v });
    }, [f, g, p]), o(function() {
      return s(v) && y({ inst: v }), f(function() {
        s(v) && y({ inst: v });
      });
    }, [f]), i(g), g;
  }
  function s(f) {
    var p = f.getSnapshot;
    f = f.value;
    try {
      var g = p();
      return !t(f, g);
    } catch {
      return !0;
    }
  }
  function u(f, p) {
    return p();
  }
  var d = typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined" ? u : l;
  return V1.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : d, V1;
}
var F1 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var G2;
function OP() {
  return G2 || (G2 = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = E, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function t(C) {
      {
        for (var x = arguments.length, b = new Array(x > 1 ? x - 1 : 0), O = 1; O < x; O++)
          b[O - 1] = arguments[O];
        n("error", C, b);
      }
    }
    function n(C, x, b) {
      {
        var O = r.ReactDebugCurrentFrame, _ = O.getStackAddendum();
        _ !== "" && (x += "%s", b = b.concat([_]));
        var P = b.map(function(S) {
          return String(S);
        });
        P.unshift("Warning: " + x), Function.prototype.apply.call(console[C], console, P);
      }
    }
    function o(C, x) {
      return C === x && (C !== 0 || 1 / C === 1 / x) || C !== C && x !== x;
    }
    var a = typeof Object.is == "function" ? Object.is : o, i = e.useState, l = e.useEffect, s = e.useLayoutEffect, u = e.useDebugValue, d = !1, f = !1;
    function p(C, x, b) {
      d || e.startTransition !== void 0 && (d = !0, t("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var O = x();
      if (!f) {
        var _ = x();
        a(O, _) || (t("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
      }
      var P = i({
        inst: {
          value: O,
          getSnapshot: x
        }
      }), S = P[0].inst, I = P[1];
      return s(function() {
        S.value = O, S.getSnapshot = x, g(S) && I({
          inst: S
        });
      }, [C, O, x]), l(function() {
        g(S) && I({
          inst: S
        });
        var N = function() {
          g(S) && I({
            inst: S
          });
        };
        return C(N);
      }, [C]), u(O), O;
    }
    function g(C) {
      var x = C.getSnapshot, b = C.value;
      try {
        var O = x();
        return !a(b, O);
      } catch {
        return !0;
      }
    }
    function h(C, x, b) {
      return x();
    }
    var v = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", y = !v, w = y ? h : p, $ = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : w;
    F1.useSyncExternalStore = $, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), F1;
}
var X2;
function c8() {
  return X2 || (X2 = 1, process.env.NODE_ENV === "production" ? Yi.exports = $P() : Yi.exports = OP()), Yi.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y2;
function PP() {
  if (Y2)
    return z1;
  Y2 = 1;
  var e = E, r = c8();
  function t(u, d) {
    return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : t, o = r.useSyncExternalStore, a = e.useRef, i = e.useEffect, l = e.useMemo, s = e.useDebugValue;
  return z1.useSyncExternalStoreWithSelector = function(u, d, f, p, g) {
    var h = a(null);
    if (h.current === null) {
      var v = { hasValue: !1, value: null };
      h.current = v;
    } else
      v = h.current;
    h = l(function() {
      function w(O) {
        if (!$) {
          if ($ = !0, C = O, O = p(O), g !== void 0 && v.hasValue) {
            var _ = v.value;
            if (g(_, O))
              return x = _;
          }
          return x = O;
        }
        if (_ = x, n(C, O))
          return _;
        var P = p(O);
        return g !== void 0 && g(_, P) ? _ : (C = O, x = P);
      }
      var $ = !1, C, x, b = f === void 0 ? null : f;
      return [function() {
        return w(d());
      }, b === null ? void 0 : function() {
        return w(b());
      }];
    }, [d, f, p, g]);
    var y = o(u, h[0], h[1]);
    return i(function() {
      v.hasValue = !0, v.value = y;
    }, [y]), s(y), y;
  }, z1;
}
var Z1 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U2;
function SP() {
  return U2 || (U2 = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = E, r = c8();
    function t(d, f) {
      return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
    }
    var n = typeof Object.is == "function" ? Object.is : t, o = r.useSyncExternalStore, a = e.useRef, i = e.useEffect, l = e.useMemo, s = e.useDebugValue;
    function u(d, f, p, g, h) {
      var v = a(null), y;
      v.current === null ? (y = {
        hasValue: !1,
        value: null
      }, v.current = y) : y = v.current;
      var w = l(function() {
        var b = !1, O, _, P = function(k) {
          if (!b) {
            b = !0, O = k;
            var j = g(k);
            if (h !== void 0 && y.hasValue) {
              var R = y.value;
              if (h(R, j))
                return _ = R, R;
            }
            return _ = j, j;
          }
          var D = O, T = _;
          if (n(D, k))
            return T;
          var V = g(k);
          return h !== void 0 && h(T, V) ? T : (O = k, _ = V, V);
        }, S = p === void 0 ? null : p, I = function() {
          return P(f());
        }, N = S === null ? void 0 : function() {
          return P(S());
        };
        return [I, N];
      }, [f, p, g, h]), $ = w[0], C = w[1], x = o(d, $, C);
      return i(function() {
        y.hasValue = !0, y.value = x;
      }, [x]), s(x), x;
    }
    Z1.useSyncExternalStoreWithSelector = u, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Z1;
}
process.env.NODE_ENV === "production" ? Qd.exports = PP() : Qd.exports = SP();
var IP = Qd.exports;
const EP = /* @__PURE__ */ Qn(IP);
var u8 = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const { useDebugValue: RP } = E, { useSyncExternalStoreWithSelector: AP } = EP;
let J2 = !1;
const kP = (e) => e;
function Vt(e, r = kP, t) {
  (u8 ? "production" : void 0) !== "production" && t && !J2 && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), J2 = !0);
  const n = AP(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    r,
    t
  );
  return RP(n), n;
}
const q2 = (e) => {
  (u8 ? "production" : void 0) !== "production" && typeof e != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const r = typeof e == "function" ? xP(e) : e, t = (n, o) => Vt(r, n, o);
  return Object.assign(t, r), t;
}, Zu = (e) => e ? q2(e) : q2, MP = { primary: { 100: "#EEEBFF", 200: "#CDC5FF", 300: "#1900AF", 400: "#13007D", 500: "#0A0A32" }, secondary: { 100: "#FFEBEC", 200: "#FFB0B5", 300: "#FF646E", 400: "#803237", 500: "#4F1F22" }, tertiary: { 100: "#FCE1EB", 200: "#FFBEE6", 300: "#FF78AA", 400: "#803C55", 500: "#592A3B" } }, NP = { primary: { 100: "#DDD7EE", 200: "#D596FF", 300: "#A04FC9", 400: "#7C23A8", 500: "#4A245C" }, secondary: { 100: "#EEEBFF", 200: "#CDC5FF", 300: "#1900AF", 400: "#13007D", 500: "#0A0A32" }, tertiary: { 100: "#F2EFFF", 200: "#C5B0FF", 300: "#8053FF", 400: "#6843CC", 500: "#412A80" } }, d8 = { feedback: { success: { 100: "#ECFFEB", 200: "#CBFFC8", 300: "#098500", 400: "#076600", 500: "#055200" }, error: { 100: "#FFE6E5", 200: "#FFCAC9", 300: "#BD0700", 400: "#9E0500", 500: "#3D0201" }, warning: { 100: "#FFFAE4", 200: "#FFF5C5", 300: "#BD9C00", 400: "#695700", 500: "#3D3300" }, information: { 100: "#E3FCFF", 200: "#C3FFFF", 300: "#00CDE6", 400: "#005A66", 500: "#00343B" } }, neutral: { 100: "#E6E6F0", 200: "#9292A9", 300: "#555567", 400: "#42424F", 500: "#27272E" }, background: { gray: "#FAFAFC", white: "#FFFFFF" } }, TP = Object.assign({ brand: Object.assign({}, MP) }, d8), DP = Object.assign({ brand: Object.assign({}, NP) }, d8), jP = { none: "0px", xxs: "1px", xs: "4px", md: "6px", lg: "8px", xl: "16px", full: "99999px" };
var f8 = Object.freeze({ __proto__: null, radius: jP });
const LP = { sm: "640px", md: "768px", lg: "1024px", xl: "1280px", "2xl": "1536px" };
var p8 = Object.freeze({ __proto__: null, breakpoint: LP });
const g8 = { border: "0px 0px 1px 0px rgba(0, 0, 0, 0.1)", level1: "0px 2px 6px 0px rgba(0, 0, 0, 0.1)", level2: "6px 6px 12px 0px rgba(0, 0, 0, 0.1)", level3: "0px 12px 18px 0px rgba(0, 0, 0, 0.1)", level4: "0px 10px 24px 0px rgba(0, 0, 0, 0.1)" }, v8 = { xxs: "0.5rem", xs: "1rem", sm: "1.5rem", md: "2rem", lg: "3rem", xl: "4rem", "2xl": "5rem" }, m8 = { microCopy: { fontFamily: "'Source Sans 3', sans-serif", fontStyle: "normal", fontWeight: 400, fontSize: "12px", lineHeight: "16px", textDecoration: "none" }, linkUnderline: { fontFamily: "'Source Sans 3', sans-serif", fontStyle: "normal", fontWeight: 600, fontSize: "14px", lineHeight: "24px", textDecoration: "underline" }, link: { fontFamily: "'Source Sans 3', sans-serif", fontStyle: "normal", fontWeight: 600, fontSize: "16px", lineHeight: "24px", textDecoration: "none" }, label: { fontFamily: "'Source Sans 3', sans-serif", fontStyle: "normal", fontWeight: 400, fontSize: "14px", lineHeight: "24px", textDecoration: "none" }, button: { fontFamily: "'Sora', sans-serif", fontStyle: "normal", fontWeight: 600, fontSize: "16px", lineHeight: "24px", textDecoration: "none" }, paragraphSmall: { fontFamily: "'Source Sans 3', sans-serif", fontStyle: "normal", fontWeight: 400, fontSize: "14px", lineHeight: "24px", textDecoration: "none" }, paragraphLarge: { fontFamily: "'Source Sans 3', sans-serif", fontStyle: "normal", fontWeight: 400, fontSize: "16px", lineHeight: "24px", textDecoration: "none" }, subheading: { fontFamily: "'Sora', sans-serif", fontStyle: "normal", fontWeight: 600, fontSize: "16px", lineHeight: "24px", textDecoration: "none" }, headingSmall: { fontFamily: "'Sora', sans-serif", fontStyle: "normal", fontWeight: 600, fontSize: "18px", lineHeight: "24px" }, headingMedium: { fontFamily: "'Sora', sans-serif", fontStyle: "normal", fontWeight: 600, fontSize: "20px", lineHeight: "32px", textDecoration: "none" }, headingLarge: { fontFamily: "'Sora', sans-serif", fontStyle: "normal", fontWeight: 600, fontSize: "24px", lineHeight: "32px", textDecoration: "none" }, headingXLarge: { fontFamily: "'Sora', sans-serif", fontStyle: "normal", fontWeight: 700, fontSize: "32px", lineHeight: "48px", textDecoration: "none" }, headingDisplay: { fontFamily: "'Sora', sans-serif", fontStyle: "normal", fontWeight: 700, fontSize: "48px", lineHeight: "64px", textDecoration: "none" } }, h8 = { xxs: "0.625rem", xs: "0.75rem", sm: "0.875rem", md: "1rem", lg: "1.125rem", xl: "1.25rem", "2xl": "1.5rem", "4xl": "2rem", "5xl": "2.25rem", "6xl": "3rem", "7xl": "4rem", "8xl": "4.5rem", "9xl": "6rem" }, b8 = { normal: "400", bold: "600", extraBold: "700" }, y8 = [{ fontFamily: "Sora", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-Bold.ttf", format: "ttf" }, fontWeight: 700, fontDisplay: "swap" }, { fontFamily: "Sora", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-Bold.woff2", format: "woff2" }, fontWeight: 700, fontDisplay: "swap" }, { fontFamily: "Sora", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-SemiBold.ttf", format: "ttf" }, fontWeight: 600, fontDisplay: "swap" }, { fontFamily: "Sora", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-SemiBold.woff2", format: "woff2" }, fontWeight: 600, fontDisplay: "swap" }, { fontFamily: "Source Sans 3", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-SemiBold.ttf", format: "ttf" }, fontWeight: 600, fontDisplay: "swap" }, { fontFamily: "Source Sans 3", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Semibold.ttf.woff2", format: "woff2" }, fontWeight: 600, fontDisplay: "swap" }, { fontFamily: "Source Sans 3", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Regular.ttf", format: "ttf" }, fontWeight: 400, fontDisplay: "swap" }, { fontFamily: "Source Sans 3", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Regular.ttf.woff2", format: "woff2" }, fontWeight: 400, fontDisplay: "swap" }], Vl = { colors: TP, border: f8, grid: p8, shadow: g8, spacing: v8, typography: m8, fontSizes: h8, fontWeights: b8, fonts: y8 }, zP = { colors: DP, border: f8, grid: p8, shadow: g8, spacing: v8, typography: m8, fontSizes: h8, fontWeights: b8, fonts: y8 }, G0 = Zu((e) => ({
  theme: Vl,
  setTheme: (r) => e(() => ({
    theme: r
  }))
})), ur = () => {
  const {
    theme: e
  } = G0.getState();
  return e;
};
function C8(e) {
  for (const r in e)
    e[r] === null ? delete e[r] : typeof e[r] == "object" && (C8(e[r]), Object.keys(e[r]).length === 0 && delete e[r]);
}
const K2 = (e) => {
  if (typeof e == "object" && e !== null) {
    if (typeof Object.getPrototypeOf == "function") {
      const r = Object.getPrototypeOf(e);
      return r === Object.prototype || r === null;
    }
    return Object.prototype.toString.call(e) === "[object Object]";
  }
  return !1;
}, Mt = (...e) => e.reduce((r, t) => {
  if (Array.isArray(t))
    throw new TypeError("Arguments provided to ts-deepmerge must be objects, not arrays.");
  return Object.keys(t).forEach((n) => {
    ["__proto__", "constructor", "prototype"].includes(n) || (Array.isArray(r[n]) && Array.isArray(t[n]) ? r[n] = Mt.options.mergeArrays ? Mt.options.uniqueArrayItems ? Array.from(new Set(r[n].concat(t[n]))) : [...r[n], ...t[n]] : t[n] : K2(r[n]) && K2(t[n]) ? r[n] = Mt(r[n], t[n]) : r[n] = t[n] === void 0 ? Mt.options.allowUndefinedOverrides ? t[n] : r[n] : t[n]);
  }), r;
}, {}), e0 = {
  allowUndefinedOverrides: !0,
  mergeArrays: !0,
  uniqueArrayItems: !0
};
Mt.options = e0;
Mt.withOptions = (e, ...r) => {
  Mt.options = Object.assign(Object.assign({}, e0), e);
  const t = Mt(...r);
  return Mt.options = e0, t;
};
const VP = (e) => {
  const {
    setTheme: r
  } = G0.getState();
  if (e === "pv") {
    r(zP);
    return;
  }
  if (e === "cnx") {
    r(Vl);
    return;
  }
  if ("primary" in e && "secondary" in e && "tertiary" in e) {
    const n = Mt(Vl, {
      colors: {
        brand: e
      }
    });
    r(n);
    return;
  }
  C8(e);
  const t = Mt(Vl, e);
  r(t);
};
var r0 = { exports: {} }, ja = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Q2;
function FP() {
  if (Q2)
    return ja;
  Q2 = 1;
  var e = E, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(l, s, u) {
    var d, f = {}, p = null, g = null;
    u !== void 0 && (p = "" + u), s.key !== void 0 && (p = "" + s.key), s.ref !== void 0 && (g = s.ref);
    for (d in s)
      n.call(s, d) && !a.hasOwnProperty(d) && (f[d] = s[d]);
    if (l && l.defaultProps)
      for (d in s = l.defaultProps, s)
        f[d] === void 0 && (f[d] = s[d]);
    return { $$typeof: r, type: l, key: p, ref: g, props: f, _owner: o.current };
  }
  return ja.Fragment = t, ja.jsx = i, ja.jsxs = i, ja;
}
var La = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ep;
function ZP() {
  return ep || (ep = 1, process.env.NODE_ENV !== "production" && function() {
    var e = E, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), l = Symbol.for("react.context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), h = Symbol.iterator, v = "@@iterator";
    function y(H) {
      if (H === null || typeof H != "object")
        return null;
      var Ce = h && H[h] || H[v];
      return typeof Ce == "function" ? Ce : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(H) {
      {
        for (var Ce = arguments.length, ie = new Array(Ce > 1 ? Ce - 1 : 0), Re = 1; Re < Ce; Re++)
          ie[Re - 1] = arguments[Re];
        C("error", H, ie);
      }
    }
    function C(H, Ce, ie) {
      {
        var Re = w.ReactDebugCurrentFrame, ee = Re.getStackAddendum();
        ee !== "" && (Ce += "%s", ie = ie.concat([ee]));
        var K = ie.map(function(be) {
          return String(be);
        });
        K.unshift("Warning: " + Ce), Function.prototype.apply.call(console[H], console, K);
      }
    }
    var x = !1, b = !1, O = !1, _ = !1, P = !1, S;
    S = Symbol.for("react.module.reference");
    function I(H) {
      return !!(typeof H == "string" || typeof H == "function" || H === n || H === a || P || H === o || H === u || H === d || _ || H === g || x || b || O || typeof H == "object" && H !== null && (H.$$typeof === p || H.$$typeof === f || H.$$typeof === i || H.$$typeof === l || H.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      H.$$typeof === S || H.getModuleId !== void 0));
    }
    function N(H, Ce, ie) {
      var Re = H.displayName;
      if (Re)
        return Re;
      var ee = Ce.displayName || Ce.name || "";
      return ee !== "" ? ie + "(" + ee + ")" : ie;
    }
    function k(H) {
      return H.displayName || "Context";
    }
    function j(H) {
      if (H == null)
        return null;
      if (typeof H.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof H == "function")
        return H.displayName || H.name || null;
      if (typeof H == "string")
        return H;
      switch (H) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof H == "object")
        switch (H.$$typeof) {
          case l:
            var Ce = H;
            return k(Ce) + ".Consumer";
          case i:
            var ie = H;
            return k(ie._context) + ".Provider";
          case s:
            return N(H, H.render, "ForwardRef");
          case f:
            var Re = H.displayName || null;
            return Re !== null ? Re : j(H.type) || "Memo";
          case p: {
            var ee = H, K = ee._payload, be = ee._init;
            try {
              return j(be(K));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var R = Object.assign, D = 0, T, V, L, Z, z, W, U;
    function re() {
    }
    re.__reactDisabledLog = !0;
    function X() {
      {
        if (D === 0) {
          T = console.log, V = console.info, L = console.warn, Z = console.error, z = console.group, W = console.groupCollapsed, U = console.groupEnd;
          var H = {
            configurable: !0,
            enumerable: !0,
            value: re,
            writable: !0
          };
          Object.defineProperties(console, {
            info: H,
            log: H,
            warn: H,
            error: H,
            group: H,
            groupCollapsed: H,
            groupEnd: H
          });
        }
        D++;
      }
    }
    function J() {
      {
        if (D--, D === 0) {
          var H = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: R({}, H, {
              value: T
            }),
            info: R({}, H, {
              value: V
            }),
            warn: R({}, H, {
              value: L
            }),
            error: R({}, H, {
              value: Z
            }),
            group: R({}, H, {
              value: z
            }),
            groupCollapsed: R({}, H, {
              value: W
            }),
            groupEnd: R({}, H, {
              value: U
            })
          });
        }
        D < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Q = w.ReactCurrentDispatcher, se;
    function q(H, Ce, ie) {
      {
        if (se === void 0)
          try {
            throw Error();
          } catch (ee) {
            var Re = ee.stack.trim().match(/\n( *(at )?)/);
            se = Re && Re[1] || "";
          }
        return `
` + se + H;
      }
    }
    var te = !1, ae;
    {
      var ge = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new ge();
    }
    function G(H, Ce) {
      if (!H || te)
        return "";
      {
        var ie = ae.get(H);
        if (ie !== void 0)
          return ie;
      }
      var Re;
      te = !0;
      var ee = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var K;
      K = Q.current, Q.current = null, X();
      try {
        if (Ce) {
          var be = function() {
            throw Error();
          };
          if (Object.defineProperty(be.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(be, []);
            } catch (mn) {
              Re = mn;
            }
            Reflect.construct(H, [], be);
          } else {
            try {
              be.call();
            } catch (mn) {
              Re = mn;
            }
            H.call(be.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (mn) {
            Re = mn;
          }
          H();
        }
      } catch (mn) {
        if (mn && Re && typeof mn.stack == "string") {
          for (var pe = mn.stack.split(`
`), Ze = Re.stack.split(`
`), Ye = pe.length - 1, rr = Ze.length - 1; Ye >= 1 && rr >= 0 && pe[Ye] !== Ze[rr]; )
            rr--;
          for (; Ye >= 1 && rr >= 0; Ye--, rr--)
            if (pe[Ye] !== Ze[rr]) {
              if (Ye !== 1 || rr !== 1)
                do
                  if (Ye--, rr--, rr < 0 || pe[Ye] !== Ze[rr]) {
                    var Pr = `
` + pe[Ye].replace(" at new ", " at ");
                    return H.displayName && Pr.includes("<anonymous>") && (Pr = Pr.replace("<anonymous>", H.displayName)), typeof H == "function" && ae.set(H, Pr), Pr;
                  }
                while (Ye >= 1 && rr >= 0);
              break;
            }
        }
      } finally {
        te = !1, Q.current = K, J(), Error.prepareStackTrace = ee;
      }
      var Wt = H ? H.displayName || H.name : "", I2 = Wt ? q(Wt) : "";
      return typeof H == "function" && ae.set(H, I2), I2;
    }
    function oe(H, Ce, ie) {
      return G(H, !1);
    }
    function ne(H) {
      var Ce = H.prototype;
      return !!(Ce && Ce.isReactComponent);
    }
    function _e(H, Ce, ie) {
      if (H == null)
        return "";
      if (typeof H == "function")
        return G(H, ne(H));
      if (typeof H == "string")
        return q(H);
      switch (H) {
        case u:
          return q("Suspense");
        case d:
          return q("SuspenseList");
      }
      if (typeof H == "object")
        switch (H.$$typeof) {
          case s:
            return oe(H.render);
          case f:
            return _e(H.type, Ce, ie);
          case p: {
            var Re = H, ee = Re._payload, K = Re._init;
            try {
              return _e(K(ee), Ce, ie);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, Te = {}, we = w.ReactDebugCurrentFrame;
    function He(H) {
      if (H) {
        var Ce = H._owner, ie = _e(H.type, H._source, Ce ? Ce.type : null);
        we.setExtraStackFrame(ie);
      } else
        we.setExtraStackFrame(null);
    }
    function he(H, Ce, ie, Re, ee) {
      {
        var K = Function.call.bind(ye);
        for (var be in H)
          if (K(H, be)) {
            var pe = void 0;
            try {
              if (typeof H[be] != "function") {
                var Ze = Error((Re || "React class") + ": " + ie + " type `" + be + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof H[be] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ze.name = "Invariant Violation", Ze;
              }
              pe = H[be](Ce, be, Re, ie, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ye) {
              pe = Ye;
            }
            pe && !(pe instanceof Error) && (He(ee), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Re || "React class", ie, be, typeof pe), He(null)), pe instanceof Error && !(pe.message in Te) && (Te[pe.message] = !0, He(ee), $("Failed %s type: %s", ie, pe.message), He(null));
          }
      }
    }
    var xe = Array.isArray;
    function Le(H) {
      return xe(H);
    }
    function Ue(H) {
      {
        var Ce = typeof Symbol == "function" && Symbol.toStringTag, ie = Ce && H[Symbol.toStringTag] || H.constructor.name || "Object";
        return ie;
      }
    }
    function me(H) {
      try {
        return Ie(H), !1;
      } catch {
        return !0;
      }
    }
    function Ie(H) {
      return "" + H;
    }
    function er(H) {
      if (me(H))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ue(H)), Ie(H);
    }
    var Ke = w.ReactCurrentOwner, Me = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Pe, Qe, Sr;
    Sr = {};
    function Cr(H) {
      if (ye.call(H, "ref")) {
        var Ce = Object.getOwnPropertyDescriptor(H, "ref").get;
        if (Ce && Ce.isReactWarning)
          return !1;
      }
      return H.ref !== void 0;
    }
    function nr(H) {
      if (ye.call(H, "key")) {
        var Ce = Object.getOwnPropertyDescriptor(H, "key").get;
        if (Ce && Ce.isReactWarning)
          return !1;
      }
      return H.key !== void 0;
    }
    function De(H, Ce) {
      if (typeof H.ref == "string" && Ke.current && Ce && Ke.current.stateNode !== Ce) {
        var ie = j(Ke.current.type);
        Sr[ie] || ($('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(Ke.current.type), H.ref), Sr[ie] = !0);
      }
    }
    function Ge(H, Ce) {
      {
        var ie = function() {
          Pe || (Pe = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ce));
        };
        ie.isReactWarning = !0, Object.defineProperty(H, "key", {
          get: ie,
          configurable: !0
        });
      }
    }
    function lr(H, Ce) {
      {
        var ie = function() {
          Qe || (Qe = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ce));
        };
        ie.isReactWarning = !0, Object.defineProperty(H, "ref", {
          get: ie,
          configurable: !0
        });
      }
    }
    var Ir = function(H, Ce, ie, Re, ee, K, be) {
      var pe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: H,
        key: Ce,
        ref: ie,
        props: be,
        // Record the component responsible for creating this element.
        _owner: K
      };
      return pe._store = {}, Object.defineProperty(pe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(pe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Re
      }), Object.defineProperty(pe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ee
      }), Object.freeze && (Object.freeze(pe.props), Object.freeze(pe)), pe;
    };
    function Or(H, Ce, ie, Re, ee) {
      {
        var K, be = {}, pe = null, Ze = null;
        ie !== void 0 && (er(ie), pe = "" + ie), nr(Ce) && (er(Ce.key), pe = "" + Ce.key), Cr(Ce) && (Ze = Ce.ref, De(Ce, ee));
        for (K in Ce)
          ye.call(Ce, K) && !Me.hasOwnProperty(K) && (be[K] = Ce[K]);
        if (H && H.defaultProps) {
          var Ye = H.defaultProps;
          for (K in Ye)
            be[K] === void 0 && (be[K] = Ye[K]);
        }
        if (pe || Ze) {
          var rr = typeof H == "function" ? H.displayName || H.name || "Unknown" : H;
          pe && Ge(be, rr), Ze && lr(be, rr);
        }
        return Ir(H, pe, Ze, ee, Re, Ke.current, be);
      }
    }
    var $r = w.ReactCurrentOwner, ar = w.ReactDebugCurrentFrame;
    function cr(H) {
      if (H) {
        var Ce = H._owner, ie = _e(H.type, H._source, Ce ? Ce.type : null);
        ar.setExtraStackFrame(ie);
      } else
        ar.setExtraStackFrame(null);
    }
    var Vr;
    Vr = !1;
    function pt(H) {
      return typeof H == "object" && H !== null && H.$$typeof === r;
    }
    function et() {
      {
        if ($r.current) {
          var H = j($r.current.type);
          if (H)
            return `

Check the render method of \`` + H + "`.";
        }
        return "";
      }
    }
    function jn(H) {
      {
        if (H !== void 0) {
          var Ce = H.fileName.replace(/^.*[\\\/]/, ""), ie = H.lineNumber;
          return `

Check your code at ` + Ce + ":" + ie + ".";
        }
        return "";
      }
    }
    var St = {};
    function Er(H) {
      {
        var Ce = et();
        if (!Ce) {
          var ie = typeof H == "string" ? H : H.displayName || H.name;
          ie && (Ce = `

Check the top-level render call using <` + ie + ">.");
        }
        return Ce;
      }
    }
    function Ln(H, Ce) {
      {
        if (!H._store || H._store.validated || H.key != null)
          return;
        H._store.validated = !0;
        var ie = Er(Ce);
        if (St[ie])
          return;
        St[ie] = !0;
        var Re = "";
        H && H._owner && H._owner !== $r.current && (Re = " It was passed a child from " + j(H._owner.type) + "."), cr(H), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ie, Re), cr(null);
      }
    }
    function rt(H, Ce) {
      {
        if (typeof H != "object")
          return;
        if (Le(H))
          for (var ie = 0; ie < H.length; ie++) {
            var Re = H[ie];
            pt(Re) && Ln(Re, Ce);
          }
        else if (pt(H))
          H._store && (H._store.validated = !0);
        else if (H) {
          var ee = y(H);
          if (typeof ee == "function" && ee !== H.entries)
            for (var K = ee.call(H), be; !(be = K.next()).done; )
              pt(be.value) && Ln(be.value, Ce);
        }
      }
    }
    function gr(H) {
      {
        var Ce = H.type;
        if (Ce == null || typeof Ce == "string")
          return;
        var ie;
        if (typeof Ce == "function")
          ie = Ce.propTypes;
        else if (typeof Ce == "object" && (Ce.$$typeof === s || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ce.$$typeof === f))
          ie = Ce.propTypes;
        else
          return;
        if (ie) {
          var Re = j(Ce);
          he(ie, H.props, "prop", Re, H);
        } else if (Ce.PropTypes !== void 0 && !Vr) {
          Vr = !0;
          var ee = j(Ce);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ee || "Unknown");
        }
        typeof Ce.getDefaultProps == "function" && !Ce.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ar(H) {
      {
        for (var Ce = Object.keys(H.props), ie = 0; ie < Ce.length; ie++) {
          var Re = Ce[ie];
          if (Re !== "children" && Re !== "key") {
            cr(H), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Re), cr(null);
            break;
          }
        }
        H.ref !== null && (cr(H), $("Invalid attribute `ref` supplied to `React.Fragment`."), cr(null));
      }
    }
    function Yr(H, Ce, ie, Re, ee, K) {
      {
        var be = I(H);
        if (!be) {
          var pe = "";
          (H === void 0 || typeof H == "object" && H !== null && Object.keys(H).length === 0) && (pe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ze = jn(ee);
          Ze ? pe += Ze : pe += et();
          var Ye;
          H === null ? Ye = "null" : Le(H) ? Ye = "array" : H !== void 0 && H.$$typeof === r ? (Ye = "<" + (j(H.type) || "Unknown") + " />", pe = " Did you accidentally export a JSX literal instead of a component?") : Ye = typeof H, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ye, pe);
        }
        var rr = Or(H, Ce, ie, ee, K);
        if (rr == null)
          return rr;
        if (be) {
          var Pr = Ce.children;
          if (Pr !== void 0)
            if (Re)
              if (Le(Pr)) {
                for (var Wt = 0; Wt < Pr.length; Wt++)
                  rt(Pr[Wt], H);
                Object.freeze && Object.freeze(Pr);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              rt(Pr, H);
        }
        return H === n ? Ar(rr) : gr(rr), rr;
      }
    }
    function vn(H, Ce, ie) {
      return Yr(H, Ce, ie, !0);
    }
    function lo(H, Ce, ie) {
      return Yr(H, Ce, ie, !1);
    }
    var so = lo, co = vn;
    La.Fragment = n, La.jsx = so, La.jsxs = co;
  }()), La;
}
process.env.NODE_ENV === "production" ? r0.exports = FP() : r0.exports = ZP();
var le = r0.exports;
function WP(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function BP(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var HP = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(o) {
      var a;
      n.tags.length === 0 ? n.insertionPoint ? a = n.insertionPoint.nextSibling : n.prepend ? a = n.container.firstChild : a = n.before : a = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(o, a), n.tags.push(o);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(BP(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var a = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      a && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !a;
    }
    if (this.isSpeedy) {
      var i = WP(o);
      try {
        i.insertRule(n, i.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Kr = "-ms-", ts = "-moz-", fr = "-webkit-", X0 = "comm", Y0 = "rule", U0 = "decl", GP = "@import", w8 = "@keyframes", XP = "@layer", YP = Math.abs, Wu = String.fromCharCode, UP = Object.assign;
function JP(e, r) {
  return qr(e, 0) ^ 45 ? (((r << 2 ^ qr(e, 0)) << 2 ^ qr(e, 1)) << 2 ^ qr(e, 2)) << 2 ^ qr(e, 3) : 0;
}
function _8(e) {
  return e.trim();
}
function qP(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function pr(e, r, t) {
  return e.replace(r, t);
}
function t0(e, r) {
  return e.indexOf(r);
}
function qr(e, r) {
  return e.charCodeAt(r) | 0;
}
function di(e, r, t) {
  return e.slice(r, t);
}
function tn(e) {
  return e.length;
}
function J0(e) {
  return e.length;
}
function Ui(e, r) {
  return r.push(e), e;
}
function KP(e, r) {
  return e.map(r).join("");
}
var Bu = 1, ua = 1, x8 = 0, ut = 0, Fr = 0, wa = "";
function Hu(e, r, t, n, o, a, i) {
  return { value: e, root: r, parent: t, type: n, props: o, children: a, line: Bu, column: ua, length: i, return: "" };
}
function za(e, r) {
  return UP(Hu("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function QP() {
  return Fr;
}
function eS() {
  return Fr = ut > 0 ? qr(wa, --ut) : 0, ua--, Fr === 10 && (ua = 1, Bu--), Fr;
}
function Ct() {
  return Fr = ut < x8 ? qr(wa, ut++) : 0, ua++, Fr === 10 && (ua = 1, Bu++), Fr;
}
function ln() {
  return qr(wa, ut);
}
function Fl() {
  return ut;
}
function xi(e, r) {
  return di(wa, e, r);
}
function fi(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function $8(e) {
  return Bu = ua = 1, x8 = tn(wa = e), ut = 0, [];
}
function O8(e) {
  return wa = "", e;
}
function Zl(e) {
  return _8(xi(ut - 1, n0(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function rS(e) {
  for (; (Fr = ln()) && Fr < 33; )
    Ct();
  return fi(e) > 2 || fi(Fr) > 3 ? "" : " ";
}
function tS(e, r) {
  for (; --r && Ct() && !(Fr < 48 || Fr > 102 || Fr > 57 && Fr < 65 || Fr > 70 && Fr < 97); )
    ;
  return xi(e, Fl() + (r < 6 && ln() == 32 && Ct() == 32));
}
function n0(e) {
  for (; Ct(); )
    switch (Fr) {
      case e:
        return ut;
      case 34:
      case 39:
        e !== 34 && e !== 39 && n0(Fr);
        break;
      case 40:
        e === 41 && n0(e);
        break;
      case 92:
        Ct();
        break;
    }
  return ut;
}
function nS(e, r) {
  for (; Ct() && e + Fr !== 57; )
    if (e + Fr === 84 && ln() === 47)
      break;
  return "/*" + xi(r, ut - 1) + "*" + Wu(e === 47 ? e : Ct());
}
function oS(e) {
  for (; !fi(ln()); )
    Ct();
  return xi(e, ut);
}
function aS(e) {
  return O8(Wl("", null, null, null, [""], e = $8(e), 0, [0], e));
}
function Wl(e, r, t, n, o, a, i, l, s) {
  for (var u = 0, d = 0, f = i, p = 0, g = 0, h = 0, v = 1, y = 1, w = 1, $ = 0, C = "", x = o, b = a, O = n, _ = C; y; )
    switch (h = $, $ = Ct()) {
      case 40:
        if (h != 108 && qr(_, f - 1) == 58) {
          t0(_ += pr(Zl($), "&", "&\f"), "&\f") != -1 && (w = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        _ += Zl($);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        _ += rS(h);
        break;
      case 92:
        _ += tS(Fl() - 1, 7);
        continue;
      case 47:
        switch (ln()) {
          case 42:
          case 47:
            Ui(iS(nS(Ct(), Fl()), r, t), s);
            break;
          default:
            _ += "/";
        }
        break;
      case 123 * v:
        l[u++] = tn(_) * w;
      case 125 * v:
      case 59:
      case 0:
        switch ($) {
          case 0:
          case 125:
            y = 0;
          case 59 + d:
            w == -1 && (_ = pr(_, /\f/g, "")), g > 0 && tn(_) - f && Ui(g > 32 ? tp(_ + ";", n, t, f - 1) : tp(pr(_, " ", "") + ";", n, t, f - 2), s);
            break;
          case 59:
            _ += ";";
          default:
            if (Ui(O = rp(_, r, t, u, d, o, l, C, x = [], b = [], f), a), $ === 123)
              if (d === 0)
                Wl(_, r, O, O, x, a, f, l, b);
              else
                switch (p === 99 && qr(_, 3) === 110 ? 100 : p) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Wl(e, O, O, n && Ui(rp(e, O, O, 0, 0, o, l, C, o, x = [], f), b), o, b, f, l, n ? x : b);
                    break;
                  default:
                    Wl(_, O, O, O, [""], b, 0, l, b);
                }
        }
        u = d = g = 0, v = w = 1, C = _ = "", f = i;
        break;
      case 58:
        f = 1 + tn(_), g = h;
      default:
        if (v < 1) {
          if ($ == 123)
            --v;
          else if ($ == 125 && v++ == 0 && eS() == 125)
            continue;
        }
        switch (_ += Wu($), $ * v) {
          case 38:
            w = d > 0 ? 1 : (_ += "\f", -1);
            break;
          case 44:
            l[u++] = (tn(_) - 1) * w, w = 1;
            break;
          case 64:
            ln() === 45 && (_ += Zl(Ct())), p = ln(), d = f = tn(C = _ += oS(Fl())), $++;
            break;
          case 45:
            h === 45 && tn(_) == 2 && (v = 0);
        }
    }
  return a;
}
function rp(e, r, t, n, o, a, i, l, s, u, d) {
  for (var f = o - 1, p = o === 0 ? a : [""], g = J0(p), h = 0, v = 0, y = 0; h < n; ++h)
    for (var w = 0, $ = di(e, f + 1, f = YP(v = i[h])), C = e; w < g; ++w)
      (C = _8(v > 0 ? p[w] + " " + $ : pr($, /&\f/g, p[w]))) && (s[y++] = C);
  return Hu(e, r, t, o === 0 ? Y0 : l, s, u, d);
}
function iS(e, r, t) {
  return Hu(e, r, t, X0, Wu(QP()), di(e, 2, -2), 0);
}
function tp(e, r, t, n) {
  return Hu(e, r, t, U0, di(e, 0, n), di(e, n + 1, -1), n);
}
function oa(e, r) {
  for (var t = "", n = J0(e), o = 0; o < n; o++)
    t += r(e[o], o, e, r) || "";
  return t;
}
function lS(e, r, t, n) {
  switch (e.type) {
    case XP:
      if (e.children.length)
        break;
    case GP:
    case U0:
      return e.return = e.return || e.value;
    case X0:
      return "";
    case w8:
      return e.return = e.value + "{" + oa(e.children, n) + "}";
    case Y0:
      e.value = e.props.join(",");
  }
  return tn(t = oa(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function sS(e) {
  var r = J0(e);
  return function(t, n, o, a) {
    for (var i = "", l = 0; l < r; l++)
      i += e[l](t, n, o, a) || "";
    return i;
  };
}
function cS(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
var np = function(r) {
  var t = /* @__PURE__ */ new WeakMap();
  return function(n) {
    if (t.has(n))
      return t.get(n);
    var o = r(n);
    return t.set(n, o), o;
  };
};
function P8(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var uS = function(r, t, n) {
  for (var o = 0, a = 0; o = a, a = ln(), o === 38 && a === 12 && (t[n] = 1), !fi(a); )
    Ct();
  return xi(r, ut);
}, dS = function(r, t) {
  var n = -1, o = 44;
  do
    switch (fi(o)) {
      case 0:
        o === 38 && ln() === 12 && (t[n] = 1), r[n] += uS(ut - 1, t, n);
        break;
      case 2:
        r[n] += Zl(o);
        break;
      case 4:
        if (o === 44) {
          r[++n] = ln() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += Wu(o);
    }
  while (o = Ct());
  return r;
}, fS = function(r, t) {
  return O8(dS($8(r), t));
}, op = /* @__PURE__ */ new WeakMap(), pS = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, o = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !op.get(n)) && !o) {
      op.set(r, !0);
      for (var a = [], i = fS(t, a), l = n.props, s = 0, u = 0; s < i.length; s++)
        for (var d = 0; d < l.length; d++, u++)
          r.props[u] = a[s] ? i[s].replace(/&\f/g, l[d]) : l[d] + " " + i[s];
    }
  }
}, gS = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, vS = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", mS = function(r) {
  return r.type === "comm" && r.children.indexOf(vS) > -1;
}, hS = function(r) {
  return function(t, n, o) {
    if (!(t.type !== "rule" || r.compat)) {
      var a = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (a) {
        for (var i = !!t.parent, l = i ? t.parent.children : (
          // global rule at the root level
          o
        ), s = l.length - 1; s >= 0; s--) {
          var u = l[s];
          if (u.line < t.line)
            break;
          if (u.column < t.column) {
            if (mS(u))
              return;
            break;
          }
        }
        a.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, S8 = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, bS = function(r, t) {
  for (var n = r - 1; n >= 0; n--)
    if (!S8(t[n]))
      return !0;
  return !1;
}, ap = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, yS = function(r, t, n) {
  S8(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), ap(r)) : bS(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), ap(r)));
};
function I8(e, r) {
  switch (JP(e, r)) {
    case 5103:
      return fr + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return fr + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return fr + e + ts + e + Kr + e + e;
    case 6828:
    case 4268:
      return fr + e + Kr + e + e;
    case 6165:
      return fr + e + Kr + "flex-" + e + e;
    case 5187:
      return fr + e + pr(e, /(\w+).+(:[^]+)/, fr + "box-$1$2" + Kr + "flex-$1$2") + e;
    case 5443:
      return fr + e + Kr + "flex-item-" + pr(e, /flex-|-self/, "") + e;
    case 4675:
      return fr + e + Kr + "flex-line-pack" + pr(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return fr + e + Kr + pr(e, "shrink", "negative") + e;
    case 5292:
      return fr + e + Kr + pr(e, "basis", "preferred-size") + e;
    case 6060:
      return fr + "box-" + pr(e, "-grow", "") + fr + e + Kr + pr(e, "grow", "positive") + e;
    case 4554:
      return fr + pr(e, /([^-])(transform)/g, "$1" + fr + "$2") + e;
    case 6187:
      return pr(pr(pr(e, /(zoom-|grab)/, fr + "$1"), /(image-set)/, fr + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return pr(e, /(image-set\([^]*)/, fr + "$1$`$1");
    case 4968:
      return pr(pr(e, /(.+:)(flex-)?(.*)/, fr + "box-pack:$3" + Kr + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + fr + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return pr(e, /(.+)-inline(.+)/, fr + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (tn(e) - 1 - r > 6)
        switch (qr(e, r + 1)) {
          case 109:
            if (qr(e, r + 4) !== 45)
              break;
          case 102:
            return pr(e, /(.+:)(.+)-([^]+)/, "$1" + fr + "$2-$3$1" + ts + (qr(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~t0(e, "stretch") ? I8(pr(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (qr(e, r + 1) !== 115)
        break;
    case 6444:
      switch (qr(e, tn(e) - 3 - (~t0(e, "!important") && 10))) {
        case 107:
          return pr(e, ":", ":" + fr) + e;
        case 101:
          return pr(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + fr + (qr(e, 14) === 45 ? "inline-" : "") + "box$3$1" + fr + "$2$3$1" + Kr + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (qr(e, r + 11)) {
        case 114:
          return fr + e + Kr + pr(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return fr + e + Kr + pr(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return fr + e + Kr + pr(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return fr + e + Kr + e + e;
  }
  return e;
}
var CS = function(r, t, n, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case U0:
        r.return = I8(r.value, r.length);
        break;
      case w8:
        return oa([za(r, {
          value: pr(r.value, "@", "@" + fr)
        })], o);
      case Y0:
        if (r.length)
          return KP(r.props, function(a) {
            switch (qP(a, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return oa([za(r, {
                  props: [pr(a, /:(read-\w+)/, ":" + ts + "$1")]
                })], o);
              case "::placeholder":
                return oa([za(r, {
                  props: [pr(a, /:(plac\w+)/, ":" + fr + "input-$1")]
                }), za(r, {
                  props: [pr(a, /:(plac\w+)/, ":" + ts + "$1")]
                }), za(r, {
                  props: [pr(a, /:(plac\w+)/, Kr + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, wS = [CS], q0 = function(r) {
  var t = r.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(v) {
      var y = v.getAttribute("data-emotion");
      y.indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || wS;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var a = {}, i, l = [];
  i = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(v) {
      for (var y = v.getAttribute("data-emotion").split(" "), w = 1; w < y.length; w++)
        a[y[w]] = !0;
      l.push(v);
    }
  );
  var s, u = [pS, gS];
  process.env.NODE_ENV !== "production" && u.push(hS({
    get compat() {
      return h.compat;
    }
  }), yS);
  {
    var d, f = [lS, process.env.NODE_ENV !== "production" ? function(v) {
      v.root || (v.return ? d.insert(v.return) : v.value && v.type !== X0 && d.insert(v.value + "{}"));
    } : cS(function(v) {
      d.insert(v);
    })], p = sS(u.concat(o, f)), g = function(y) {
      return oa(aS(y), p);
    };
    s = function(y, w, $, C) {
      d = $, process.env.NODE_ENV !== "production" && w.map !== void 0 && (d = {
        insert: function(b) {
          $.insert(b + w.map);
        }
      }), g(y ? y + "{" + w.styles + "}" : w.styles), C && (h.inserted[w.name] = !0);
    };
  }
  var h = {
    key: t,
    sheet: new HP({
      key: t,
      container: i,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: a,
    registered: {},
    insert: s
  };
  return h.sheet.hydrate(l), h;
};
function F() {
  return F = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, F.apply(this, arguments);
}
var o0 = { exports: {} }, vr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ip;
function _S() {
  if (ip)
    return vr;
  ip = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
  function C(b) {
    if (typeof b == "object" && b !== null) {
      var O = b.$$typeof;
      switch (O) {
        case r:
          switch (b = b.type, b) {
            case s:
            case u:
            case n:
            case a:
            case o:
            case f:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case l:
                case d:
                case h:
                case g:
                case i:
                  return b;
                default:
                  return O;
              }
          }
        case t:
          return O;
      }
    }
  }
  function x(b) {
    return C(b) === u;
  }
  return vr.AsyncMode = s, vr.ConcurrentMode = u, vr.ContextConsumer = l, vr.ContextProvider = i, vr.Element = r, vr.ForwardRef = d, vr.Fragment = n, vr.Lazy = h, vr.Memo = g, vr.Portal = t, vr.Profiler = a, vr.StrictMode = o, vr.Suspense = f, vr.isAsyncMode = function(b) {
    return x(b) || C(b) === s;
  }, vr.isConcurrentMode = x, vr.isContextConsumer = function(b) {
    return C(b) === l;
  }, vr.isContextProvider = function(b) {
    return C(b) === i;
  }, vr.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === r;
  }, vr.isForwardRef = function(b) {
    return C(b) === d;
  }, vr.isFragment = function(b) {
    return C(b) === n;
  }, vr.isLazy = function(b) {
    return C(b) === h;
  }, vr.isMemo = function(b) {
    return C(b) === g;
  }, vr.isPortal = function(b) {
    return C(b) === t;
  }, vr.isProfiler = function(b) {
    return C(b) === a;
  }, vr.isStrictMode = function(b) {
    return C(b) === o;
  }, vr.isSuspense = function(b) {
    return C(b) === f;
  }, vr.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === u || b === a || b === o || b === f || b === p || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === g || b.$$typeof === i || b.$$typeof === l || b.$$typeof === d || b.$$typeof === y || b.$$typeof === w || b.$$typeof === $ || b.$$typeof === v);
  }, vr.typeOf = C, vr;
}
var mr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lp;
function xS() {
  return lp || (lp = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
    function C(G) {
      return typeof G == "string" || typeof G == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      G === n || G === u || G === a || G === o || G === f || G === p || typeof G == "object" && G !== null && (G.$$typeof === h || G.$$typeof === g || G.$$typeof === i || G.$$typeof === l || G.$$typeof === d || G.$$typeof === y || G.$$typeof === w || G.$$typeof === $ || G.$$typeof === v);
    }
    function x(G) {
      if (typeof G == "object" && G !== null) {
        var oe = G.$$typeof;
        switch (oe) {
          case r:
            var ne = G.type;
            switch (ne) {
              case s:
              case u:
              case n:
              case a:
              case o:
              case f:
                return ne;
              default:
                var _e = ne && ne.$$typeof;
                switch (_e) {
                  case l:
                  case d:
                  case h:
                  case g:
                  case i:
                    return _e;
                  default:
                    return oe;
                }
            }
          case t:
            return oe;
        }
      }
    }
    var b = s, O = u, _ = l, P = i, S = r, I = d, N = n, k = h, j = g, R = t, D = a, T = o, V = f, L = !1;
    function Z(G) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), z(G) || x(G) === s;
    }
    function z(G) {
      return x(G) === u;
    }
    function W(G) {
      return x(G) === l;
    }
    function U(G) {
      return x(G) === i;
    }
    function re(G) {
      return typeof G == "object" && G !== null && G.$$typeof === r;
    }
    function X(G) {
      return x(G) === d;
    }
    function J(G) {
      return x(G) === n;
    }
    function Q(G) {
      return x(G) === h;
    }
    function se(G) {
      return x(G) === g;
    }
    function q(G) {
      return x(G) === t;
    }
    function te(G) {
      return x(G) === a;
    }
    function ae(G) {
      return x(G) === o;
    }
    function ge(G) {
      return x(G) === f;
    }
    mr.AsyncMode = b, mr.ConcurrentMode = O, mr.ContextConsumer = _, mr.ContextProvider = P, mr.Element = S, mr.ForwardRef = I, mr.Fragment = N, mr.Lazy = k, mr.Memo = j, mr.Portal = R, mr.Profiler = D, mr.StrictMode = T, mr.Suspense = V, mr.isAsyncMode = Z, mr.isConcurrentMode = z, mr.isContextConsumer = W, mr.isContextProvider = U, mr.isElement = re, mr.isForwardRef = X, mr.isFragment = J, mr.isLazy = Q, mr.isMemo = se, mr.isPortal = q, mr.isProfiler = te, mr.isStrictMode = ae, mr.isSuspense = ge, mr.isValidElementType = C, mr.typeOf = x;
  }()), mr;
}
process.env.NODE_ENV === "production" ? o0.exports = _S() : o0.exports = xS();
var K0 = o0.exports, E8 = K0, $S = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, OS = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, R8 = {};
R8[E8.ForwardRef] = $S;
R8[E8.Memo] = OS;
var PS = !0;
function Gu(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : n += o + " ";
  }), n;
}
var Xu = function(r, t, n) {
  var o = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  PS === !1) && r.registered[o] === void 0 && (r.registered[o] = t.styles);
}, $i = function(r, t, n) {
  Xu(r, t, n);
  var o = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var a = t;
    do
      r.insert(t === a ? "." + o : "", a, r.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function SS(e) {
  for (var r = 0, t, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    t = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var IS = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, sp = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, ES = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", RS = /[A-Z]|^ms/g, A8 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Q0 = function(r) {
  return r.charCodeAt(1) === 45;
}, cp = function(r) {
  return r != null && typeof r != "boolean";
}, W1 = /* @__PURE__ */ P8(function(e) {
  return Q0(e) ? e : e.replace(RS, "-$&").toLowerCase();
}), ns = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(A8, function(n, o, a) {
          return Xt = {
            name: o,
            styles: a,
            next: Xt
          }, o;
        });
  }
  return IS[r] !== 1 && !Q0(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (process.env.NODE_ENV !== "production") {
  var AS = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, kS = ["normal", "none", "initial", "inherit", "unset"], MS = ns, NS = /^-ms-/, TS = /-(.)/g, up = {};
  ns = function(r, t) {
    if (r === "content" && (typeof t != "string" || kS.indexOf(t) === -1 && !AS.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var n = MS(r, t);
    return n !== "" && !Q0(r) && r.indexOf("-") !== -1 && up[r] === void 0 && (up[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(NS, "ms-").replace(TS, function(o, a) {
      return a.toUpperCase();
    }) + "?")), n;
  };
}
var k8 = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function pi(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && t.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(k8);
    return t;
  }
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return Xt = {
          name: t.name,
          styles: t.styles,
          next: Xt
        }, t.name;
      if (t.styles !== void 0) {
        var n = t.next;
        if (n !== void 0)
          for (; n !== void 0; )
            Xt = {
              name: n.name,
              styles: n.styles,
              next: Xt
            }, n = n.next;
        var o = t.styles + ";";
        return process.env.NODE_ENV !== "production" && t.map !== void 0 && (o += t.map), o;
      }
      return DS(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var a = Xt, i = t(e);
        return Xt = a, pi(e, r, i);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], s = t.replace(A8, function(d, f, p) {
          var g = "animation" + l.length;
          return l.push("const " + g + " = keyframes`" + p.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + g + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + s + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + s + "`"));
      }
      break;
  }
  if (r == null)
    return t;
  var u = r[t];
  return u !== void 0 ? u : t;
}
function DS(e, r, t) {
  var n = "";
  if (Array.isArray(t))
    for (var o = 0; o < t.length; o++)
      n += pi(e, r, t[o]) + ";";
  else
    for (var a in t) {
      var i = t[a];
      if (typeof i != "object")
        r != null && r[i] !== void 0 ? n += a + "{" + r[i] + "}" : cp(i) && (n += W1(a) + ":" + ns(a, i) + ";");
      else {
        if (a === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(k8);
        if (Array.isArray(i) && typeof i[0] == "string" && (r == null || r[i[0]] === void 0))
          for (var l = 0; l < i.length; l++)
            cp(i[l]) && (n += W1(a) + ":" + ns(a, i[l]) + ";");
        else {
          var s = pi(e, r, i);
          switch (a) {
            case "animation":
            case "animationName": {
              n += W1(a) + ":" + s + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && a === "undefined" && console.error(ES), n += a + "{" + s + "}";
          }
        }
      }
    }
  return n;
}
var dp = /label:\s*([^\s;\n{]+)\s*(;|$)/g, M8;
process.env.NODE_ENV !== "production" && (M8 = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Xt, So = function(r, t, n) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, a = "";
  Xt = void 0;
  var i = r[0];
  i == null || i.raw === void 0 ? (o = !1, a += pi(n, t, i)) : (process.env.NODE_ENV !== "production" && i[0] === void 0 && console.error(sp), a += i[0]);
  for (var l = 1; l < r.length; l++)
    a += pi(n, t, r[l]), o && (process.env.NODE_ENV !== "production" && i[l] === void 0 && console.error(sp), a += i[l]);
  var s;
  process.env.NODE_ENV !== "production" && (a = a.replace(M8, function(p) {
    return s = p, "";
  })), dp.lastIndex = 0;
  for (var u = "", d; (d = dp.exec(a)) !== null; )
    u += "-" + // $FlowFixMe we know it's not null
    d[1];
  var f = SS(a) + u;
  return process.env.NODE_ENV !== "production" ? {
    name: f,
    styles: a,
    map: s,
    next: Xt,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: f,
    styles: a,
    next: Xt
  };
}, jS = function(r) {
  return r();
}, N8 = A.useInsertionEffect ? A.useInsertionEffect : !1, ef = N8 || jS, fp = N8 || A.useLayoutEffect, Yu = {}.hasOwnProperty, rf = /* @__PURE__ */ A.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement != "undefined" ? /* @__PURE__ */ q0({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (rf.displayName = "EmotionCacheContext");
var LS = rf.Provider, Uu = function(r) {
  return /* @__PURE__ */ ue(function(t, n) {
    var o = dt(rf);
    return r(t, o, n);
  });
}, cn = /* @__PURE__ */ A.createContext({});
process.env.NODE_ENV !== "production" && (cn.displayName = "EmotionThemeContext");
var zS = function(r, t) {
  if (typeof t == "function") {
    var n = t(r);
    if (process.env.NODE_ENV !== "production" && (n == null || typeof n != "object" || Array.isArray(n)))
      throw new Error("[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!");
    return n;
  }
  if (process.env.NODE_ENV !== "production" && (t == null || typeof t != "object" || Array.isArray(t)))
    throw new Error("[ThemeProvider] Please make your theme prop a plain object");
  return F({}, r, t);
}, VS = /* @__PURE__ */ np(function(e) {
  return np(function(r) {
    return zS(e, r);
  });
}), T8 = function(r) {
  var t = A.useContext(cn);
  return r.theme !== t && (t = VS(t)(r.theme)), /* @__PURE__ */ A.createElement(cn.Provider, {
    value: t
  }, r.children);
}, pp = function(r) {
  var t = r.split(".");
  return t[t.length - 1];
}, FS = function(r) {
  var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (t || (t = /^([A-Za-z0-9$.]+)@/.exec(r), t))
    return pp(t[1]);
}, ZS = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), WS = function(r) {
  return r.replace(/\$/g, "-");
}, BS = function(r) {
  if (r)
    for (var t = r.split(`
`), n = 0; n < t.length; n++) {
      var o = FS(t[n]);
      if (o) {
        if (ZS.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return WS(o);
      }
    }
}, a0 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", i0 = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", D8 = function(r, t) {
  if (process.env.NODE_ENV !== "production" && typeof t.css == "string" && // check if there is a css declaration
  t.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
  var n = {};
  for (var o in t)
    Yu.call(t, o) && (n[o] = t[o]);
  if (n[a0] = r, process.env.NODE_ENV !== "production" && t.css && (typeof t.css != "object" || typeof t.css.name != "string" || t.css.name.indexOf("-") === -1)) {
    var a = BS(new Error().stack);
    a && (n[i0] = a);
  }
  return n;
}, HS = function(r) {
  var t = r.cache, n = r.serialized, o = r.isStringTag;
  return Xu(t, n, o), ef(function() {
    return $i(t, n, o);
  }), null;
}, j8 = /* @__PURE__ */ Uu(function(e, r, t) {
  var n = e.css;
  typeof n == "string" && r.registered[n] !== void 0 && (n = r.registered[n]);
  var o = e[a0], a = [n], i = "";
  typeof e.className == "string" ? i = Gu(r.registered, a, e.className) : e.className != null && (i = e.className + " ");
  var l = So(a, void 0, A.useContext(cn));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var s = e[i0];
    s && (l = So([l, "label:" + s + ";"]));
  }
  i += r.key + "-" + l.name;
  var u = {};
  for (var d in e)
    Yu.call(e, d) && d !== "css" && d !== a0 && (process.env.NODE_ENV === "production" || d !== i0) && (u[d] = e[d]);
  return u.ref = t, u.className = i, /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(HS, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ A.createElement(o, u));
});
process.env.NODE_ENV !== "production" && (j8.displayName = "EmotionCssPropInternal");
var L8 = j8, Br = le.Fragment;
function m(e, r, t) {
  return Yu.call(r, "css") ? le.jsx(L8, D8(e, r), t) : le.jsx(e, r, t);
}
function Y(e, r, t) {
  return Yu.call(r, "css") ? le.jsxs(L8, D8(e, r), t) : le.jsxs(e, r, t);
}
var GS = {
  name: "@emotion/react",
  version: "11.11.4",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      import: "./dist/emotion-react.cjs.mjs",
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        import: "./macro.d.mts",
        default: "./macro.d.ts"
      },
      default: "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.3",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.2",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            import: "./macro.d.mts",
            default: "./macro.d.ts"
          },
          default: "./macro.js"
        }
      }
    }
  }
}, gp = !1, No = /* @__PURE__ */ Uu(function(e, r) {
  process.env.NODE_ENV !== "production" && !gp && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), gp = !0);
  var t = e.styles, n = So([t], void 0, A.useContext(cn)), o = A.useRef();
  return fp(function() {
    var a = r.key + "-global", i = new r.sheet.constructor({
      key: a,
      nonce: r.sheet.nonce,
      container: r.sheet.container,
      speedy: r.sheet.isSpeedy
    }), l = !1, s = document.querySelector('style[data-emotion="' + a + " " + n.name + '"]');
    return r.sheet.tags.length && (i.before = r.sheet.tags[0]), s !== null && (l = !0, s.setAttribute("data-emotion", a), i.hydrate([s])), o.current = [i, l], function() {
      i.flush();
    };
  }, [r]), fp(function() {
    var a = o.current, i = a[0], l = a[1];
    if (l) {
      a[1] = !1;
      return;
    }
    if (n.next !== void 0 && $i(r, n.next, !0), i.tags.length) {
      var s = i.tags[i.tags.length - 1].nextElementSibling;
      i.before = s, i.flush();
    }
    r.insert("", n, i, !1);
  }, [r, n.name]), null;
});
process.env.NODE_ENV !== "production" && (No.displayName = "EmotionGlobal");
function M() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return So(r);
}
var ro = function() {
  var r = M.apply(void 0, arguments), t = "animation-" + r.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + r.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, XS = function e(r) {
  for (var t = r.length, n = 0, o = ""; n < t; n++) {
    var a = r[n];
    if (a != null) {
      var i = void 0;
      switch (typeof a) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(a))
            i = e(a);
          else {
            process.env.NODE_ENV !== "production" && a.styles !== void 0 && a.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), i = "";
            for (var l in a)
              a[l] && l && (i && (i += " "), i += l);
          }
          break;
        }
        default:
          i = a;
      }
      i && (o && (o += " "), o += i);
    }
  }
  return o;
};
function YS(e, r, t) {
  var n = [], o = Gu(e, n, t);
  return n.length < 2 ? t : o + r(n);
}
var US = function(r) {
  var t = r.cache, n = r.serializedArr;
  return ef(function() {
    for (var o = 0; o < n.length; o++)
      $i(t, n[o], !1);
  }), null;
}, JS = /* @__PURE__ */ Uu(function(e, r) {
  var t = !1, n = [], o = function() {
    if (t && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var u = arguments.length, d = new Array(u), f = 0; f < u; f++)
      d[f] = arguments[f];
    var p = So(d, r.registered);
    return n.push(p), Xu(r, p, !1), r.key + "-" + p.name;
  }, a = function() {
    if (t && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var u = arguments.length, d = new Array(u), f = 0; f < u; f++)
      d[f] = arguments[f];
    return YS(r.registered, o, XS(d));
  }, i = {
    css: o,
    cx: a,
    theme: A.useContext(cn)
  }, l = e.children(i);
  return t = !0, /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(US, {
    cache: r,
    serializedArr: n
  }), l);
});
process.env.NODE_ENV !== "production" && (JS.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var vp = !0, qS = typeof jest != "undefined" || typeof vi != "undefined";
  if (vp && !qS) {
    var mp = (
      // $FlowIgnore
      typeof globalThis != "undefined" ? globalThis : vp ? window : global
    ), hp = "__EMOTION_REACT_" + GS.version.split(".")[0] + "__";
    mp[hp] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), mp[hp] = !0;
  }
}
function Io(e) {
  let r = "https://mui.com/production-error/?code=" + e;
  for (let t = 1; t < arguments.length; t += 1)
    r += "&args[]=" + encodeURIComponent(arguments[t]);
  return "Minified MUI error #" + e + "; visit " + r + " for the full message.";
}
const KS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Io
}, Symbol.toStringTag, { value: "Module" })), da = "$$material";
function Xe(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), o, a;
  for (a = 0; a < n.length; a++)
    o = n[a], !(r.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
var QS = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, eI = /* @__PURE__ */ P8(
  function(e) {
    return QS.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), rI = eI, tI = function(r) {
  return r !== "theme";
}, bp = function(r) {
  return typeof r == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  r.charCodeAt(0) > 96 ? rI : tI;
}, yp = function(r, t, n) {
  var o;
  if (t) {
    var a = t.shouldForwardProp;
    o = r.__emotion_forwardProp && a ? function(i) {
      return r.__emotion_forwardProp(i) && a(i);
    } : a;
  }
  return typeof o != "function" && n && (o = r.__emotion_forwardProp), o;
}, Cp = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, nI = function(r) {
  var t = r.cache, n = r.serialized, o = r.isStringTag;
  return Xu(t, n, o), ef(function() {
    return $i(t, n, o);
  }), null;
}, oI = function e(r, t) {
  if (process.env.NODE_ENV !== "production" && r === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var n = r.__emotion_real === r, o = n && r.__emotion_base || r, a, i;
  t !== void 0 && (a = t.label, i = t.target);
  var l = yp(r, t, n), s = l || bp(o), u = !s("as");
  return function() {
    var d = arguments, f = n && r.__emotion_styles !== void 0 ? r.__emotion_styles.slice(0) : [];
    if (a !== void 0 && f.push("label:" + a + ";"), d[0] == null || d[0].raw === void 0)
      f.push.apply(f, d);
    else {
      process.env.NODE_ENV !== "production" && d[0][0] === void 0 && console.error(Cp), f.push(d[0][0]);
      for (var p = d.length, g = 1; g < p; g++)
        process.env.NODE_ENV !== "production" && d[0][g] === void 0 && console.error(Cp), f.push(d[g], d[0][g]);
    }
    var h = Uu(function(v, y, w) {
      var $ = u && v.as || o, C = "", x = [], b = v;
      if (v.theme == null) {
        b = {};
        for (var O in v)
          b[O] = v[O];
        b.theme = A.useContext(cn);
      }
      typeof v.className == "string" ? C = Gu(y.registered, x, v.className) : v.className != null && (C = v.className + " ");
      var _ = So(f.concat(x), y.registered, b);
      C += y.key + "-" + _.name, i !== void 0 && (C += " " + i);
      var P = u && l === void 0 ? bp($) : s, S = {};
      for (var I in v)
        u && I === "as" || // $FlowFixMe
        P(I) && (S[I] = v[I]);
      return S.className = C, S.ref = w, /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(nI, {
        cache: y,
        serialized: _,
        isStringTag: typeof $ == "string"
      }), /* @__PURE__ */ A.createElement($, S));
    });
    return h.displayName = a !== void 0 ? a : "Styled(" + (typeof o == "string" ? o : o.displayName || o.name || "Component") + ")", h.defaultProps = r.defaultProps, h.__emotion_real = h, h.__emotion_base = o, h.__emotion_styles = f, h.__emotion_forwardProp = l, Object.defineProperty(h, "toString", {
      value: function() {
        return i === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + i;
      }
    }), h.withComponent = function(v, y) {
      return e(v, F({}, t, y, {
        shouldForwardProp: yp(h, y, !0)
      })).apply(void 0, f);
    }, h;
  };
}, aI = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], l0 = oI.bind();
aI.forEach(function(e) {
  l0[e] = l0(e);
});
var s0 = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var B1, wp;
function iI() {
  if (wp)
    return B1;
  wp = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, l = 0; l < 10; l++)
        i["_" + String.fromCharCode(l)] = l;
      var s = Object.getOwnPropertyNames(i).map(function(d) {
        return i[d];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        u[d] = d;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return B1 = o() ? Object.assign : function(a, i) {
    for (var l, s = n(a), u, d = 1; d < arguments.length; d++) {
      l = Object(arguments[d]);
      for (var f in l)
        r.call(l, f) && (s[f] = l[f]);
      if (e) {
        u = e(l);
        for (var p = 0; p < u.length; p++)
          t.call(l, u[p]) && (s[u[p]] = l[u[p]]);
      }
    }
    return s;
  }, B1;
}
var H1, _p;
function tf() {
  if (_p)
    return H1;
  _p = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return H1 = e, H1;
}
var G1, xp;
function z8() {
  return xp || (xp = 1, G1 = Function.call.bind(Object.prototype.hasOwnProperty)), G1;
}
var X1, $p;
function lI() {
  if ($p)
    return X1;
  $p = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = tf(), t = {}, n = z8();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console != "undefined" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(a, i, l, s, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in a)
        if (n(a, d)) {
          var f;
          try {
            if (typeof a[d] != "function") {
              var p = Error(
                (s || "React class") + ": " + l + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = a[d](i, d, s, l, null, r);
          } catch (h) {
            f = h;
          }
          if (f && !(f instanceof Error) && e(
            (s || "React class") + ": type specification of " + l + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in t)) {
            t[f.message] = !0;
            var g = u ? u() : "";
            e(
              "Failed " + l + " type: " + f.message + (g != null ? g : "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, X1 = o, X1;
}
var Y1, Op;
function sI() {
  if (Op)
    return Y1;
  Op = 1;
  var e = K0, r = iI(), t = tf(), n = z8(), o = lI(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(l) {
    var s = "Warning: " + l;
    typeof console != "undefined" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Y1 = function(l, s) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(z) {
      var W = z && (u && z[u] || z[d]);
      if (typeof W == "function")
        return W;
    }
    var p = "<<anonymous>>", g = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: $(),
      arrayOf: C,
      element: x(),
      elementType: b(),
      instanceOf: O,
      node: I(),
      objectOf: P,
      oneOf: _,
      oneOfType: S,
      shape: k,
      exact: j
    };
    function h(z, W) {
      return z === W ? z !== 0 || 1 / z === 1 / W : z !== z && W !== W;
    }
    function v(z, W) {
      this.message = z, this.data = W && typeof W == "object" ? W : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function y(z) {
      if (process.env.NODE_ENV !== "production")
        var W = {}, U = 0;
      function re(J, Q, se, q, te, ae, ge) {
        if (q = q || p, ae = ae || se, ge !== t) {
          if (s) {
            var G = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw G.name = "Invariant Violation", G;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var oe = q + ":" + se;
            !W[oe] && // Avoid spamming the console because they are often not actionable except for lib authors
            U < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + ae + "` prop on `" + q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), W[oe] = !0, U++);
          }
        }
        return Q[se] == null ? J ? Q[se] === null ? new v("The " + te + " `" + ae + "` is marked as required " + ("in `" + q + "`, but its value is `null`.")) : new v("The " + te + " `" + ae + "` is marked as required in " + ("`" + q + "`, but its value is `undefined`.")) : null : z(Q, se, q, te, ae);
      }
      var X = re.bind(null, !1);
      return X.isRequired = re.bind(null, !0), X;
    }
    function w(z) {
      function W(U, re, X, J, Q, se) {
        var q = U[re], te = T(q);
        if (te !== z) {
          var ae = V(q);
          return new v(
            "Invalid " + J + " `" + Q + "` of type " + ("`" + ae + "` supplied to `" + X + "`, expected ") + ("`" + z + "`."),
            { expectedType: z }
          );
        }
        return null;
      }
      return y(W);
    }
    function $() {
      return y(i);
    }
    function C(z) {
      function W(U, re, X, J, Q) {
        if (typeof z != "function")
          return new v("Property `" + Q + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
        var se = U[re];
        if (!Array.isArray(se)) {
          var q = T(se);
          return new v("Invalid " + J + " `" + Q + "` of type " + ("`" + q + "` supplied to `" + X + "`, expected an array."));
        }
        for (var te = 0; te < se.length; te++) {
          var ae = z(se, te, X, J, Q + "[" + te + "]", t);
          if (ae instanceof Error)
            return ae;
        }
        return null;
      }
      return y(W);
    }
    function x() {
      function z(W, U, re, X, J) {
        var Q = W[U];
        if (!l(Q)) {
          var se = T(Q);
          return new v("Invalid " + X + " `" + J + "` of type " + ("`" + se + "` supplied to `" + re + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(z);
    }
    function b() {
      function z(W, U, re, X, J) {
        var Q = W[U];
        if (!e.isValidElementType(Q)) {
          var se = T(Q);
          return new v("Invalid " + X + " `" + J + "` of type " + ("`" + se + "` supplied to `" + re + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(z);
    }
    function O(z) {
      function W(U, re, X, J, Q) {
        if (!(U[re] instanceof z)) {
          var se = z.name || p, q = Z(U[re]);
          return new v("Invalid " + J + " `" + Q + "` of type " + ("`" + q + "` supplied to `" + X + "`, expected ") + ("instance of `" + se + "`."));
        }
        return null;
      }
      return y(W);
    }
    function _(z) {
      if (!Array.isArray(z))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function W(U, re, X, J, Q) {
        for (var se = U[re], q = 0; q < z.length; q++)
          if (h(se, z[q]))
            return null;
        var te = JSON.stringify(z, function(ge, G) {
          var oe = V(G);
          return oe === "symbol" ? String(G) : G;
        });
        return new v("Invalid " + J + " `" + Q + "` of value `" + String(se) + "` " + ("supplied to `" + X + "`, expected one of " + te + "."));
      }
      return y(W);
    }
    function P(z) {
      function W(U, re, X, J, Q) {
        if (typeof z != "function")
          return new v("Property `" + Q + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
        var se = U[re], q = T(se);
        if (q !== "object")
          return new v("Invalid " + J + " `" + Q + "` of type " + ("`" + q + "` supplied to `" + X + "`, expected an object."));
        for (var te in se)
          if (n(se, te)) {
            var ae = z(se, te, X, J, Q + "." + te, t);
            if (ae instanceof Error)
              return ae;
          }
        return null;
      }
      return y(W);
    }
    function S(z) {
      if (!Array.isArray(z))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var W = 0; W < z.length; W++) {
        var U = z[W];
        if (typeof U != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + L(U) + " at index " + W + "."
          ), i;
      }
      function re(X, J, Q, se, q) {
        for (var te = [], ae = 0; ae < z.length; ae++) {
          var ge = z[ae], G = ge(X, J, Q, se, q, t);
          if (G == null)
            return null;
          G.data && n(G.data, "expectedType") && te.push(G.data.expectedType);
        }
        var oe = te.length > 0 ? ", expected one of type [" + te.join(", ") + "]" : "";
        return new v("Invalid " + se + " `" + q + "` supplied to " + ("`" + Q + "`" + oe + "."));
      }
      return y(re);
    }
    function I() {
      function z(W, U, re, X, J) {
        return R(W[U]) ? null : new v("Invalid " + X + " `" + J + "` supplied to " + ("`" + re + "`, expected a ReactNode."));
      }
      return y(z);
    }
    function N(z, W, U, re, X) {
      return new v(
        (z || "React class") + ": " + W + " type `" + U + "." + re + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
      );
    }
    function k(z) {
      function W(U, re, X, J, Q) {
        var se = U[re], q = T(se);
        if (q !== "object")
          return new v("Invalid " + J + " `" + Q + "` of type `" + q + "` " + ("supplied to `" + X + "`, expected `object`."));
        for (var te in z) {
          var ae = z[te];
          if (typeof ae != "function")
            return N(X, J, Q, te, V(ae));
          var ge = ae(se, te, X, J, Q + "." + te, t);
          if (ge)
            return ge;
        }
        return null;
      }
      return y(W);
    }
    function j(z) {
      function W(U, re, X, J, Q) {
        var se = U[re], q = T(se);
        if (q !== "object")
          return new v("Invalid " + J + " `" + Q + "` of type `" + q + "` " + ("supplied to `" + X + "`, expected `object`."));
        var te = r({}, U[re], z);
        for (var ae in te) {
          var ge = z[ae];
          if (n(z, ae) && typeof ge != "function")
            return N(X, J, Q, ae, V(ge));
          if (!ge)
            return new v(
              "Invalid " + J + " `" + Q + "` key `" + ae + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify(U[re], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(z), null, "  ")
            );
          var G = ge(se, ae, X, J, Q + "." + ae, t);
          if (G)
            return G;
        }
        return null;
      }
      return y(W);
    }
    function R(z) {
      switch (typeof z) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !z;
        case "object":
          if (Array.isArray(z))
            return z.every(R);
          if (z === null || l(z))
            return !0;
          var W = f(z);
          if (W) {
            var U = W.call(z), re;
            if (W !== z.entries) {
              for (; !(re = U.next()).done; )
                if (!R(re.value))
                  return !1;
            } else
              for (; !(re = U.next()).done; ) {
                var X = re.value;
                if (X && !R(X[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function D(z, W) {
      return z === "symbol" ? !0 : W ? W["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && W instanceof Symbol : !1;
    }
    function T(z) {
      var W = typeof z;
      return Array.isArray(z) ? "array" : z instanceof RegExp ? "object" : D(W, z) ? "symbol" : W;
    }
    function V(z) {
      if (typeof z == "undefined" || z === null)
        return "" + z;
      var W = T(z);
      if (W === "object") {
        if (z instanceof Date)
          return "date";
        if (z instanceof RegExp)
          return "regexp";
      }
      return W;
    }
    function L(z) {
      var W = V(z);
      switch (W) {
        case "array":
        case "object":
          return "an " + W;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + W;
        default:
          return W;
      }
    }
    function Z(z) {
      return !z.constructor || !z.constructor.name ? p : z.constructor.name;
    }
    return g.checkPropTypes = o, g.resetWarningCache = o.resetWarningCache, g.PropTypes = g, g;
  }, Y1;
}
var U1, Pp;
function cI() {
  if (Pp)
    return U1;
  Pp = 1;
  var e = tf();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, U1 = function() {
    function n(i, l, s, u, d, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return a.PropTypes = a, a;
  }, U1;
}
if (process.env.NODE_ENV !== "production") {
  var uI = K0, dI = !0;
  s0.exports = sI()(uI.isElement, dI);
} else
  s0.exports = cI()();
var V8 = s0.exports;
const c = /* @__PURE__ */ Qn(V8);
let c0;
typeof document == "object" && (c0 = q0({
  key: "css",
  prepend: !0
}));
function nf(e) {
  const {
    injectFirst: r,
    children: t
  } = e;
  return r && c0 ? /* @__PURE__ */ le.jsx(LS, {
    value: c0,
    children: t
  }) : t;
}
process.env.NODE_ENV !== "production" && (nf.propTypes = {
  /**
   * Your component tree.
   */
  children: c.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: c.bool
});
function fI(e) {
  return e == null || Object.keys(e).length === 0;
}
function of(e) {
  const {
    styles: r,
    defaultTheme: t = {}
  } = e, n = typeof r == "function" ? (o) => r(fI(o) ? t : o) : r;
  return /* @__PURE__ */ le.jsx(No, {
    styles: n
  });
}
process.env.NODE_ENV !== "production" && (of.propTypes = {
  defaultTheme: c.object,
  styles: c.oneOfType([c.array, c.string, c.object, c.func])
});
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function pI(e, r) {
  const t = l0(e, r);
  return process.env.NODE_ENV !== "production" ? (...n) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((a) => a === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), t(...n);
  } : t;
}
const gI = (e, r) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = r(e.__emotion_styles));
}, vI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: of,
  StyledEngineProvider: nf,
  ThemeContext: cn,
  css: M,
  default: pI,
  internal_processStyles: gI,
  keyframes: ro
}, Symbol.toStringTag, { value: "Module" }));
function Zn(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const r = Object.getPrototypeOf(e);
  return (r === null || r === Object.prototype || Object.getPrototypeOf(r) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function F8(e) {
  if (!Zn(e))
    return e;
  const r = {};
  return Object.keys(e).forEach((t) => {
    r[t] = F8(e[t]);
  }), r;
}
function wt(e, r, t = {
  clone: !0
}) {
  const n = t.clone ? F({}, e) : e;
  return Zn(e) && Zn(r) && Object.keys(r).forEach((o) => {
    o !== "__proto__" && (Zn(r[o]) && o in e && Zn(e[o]) ? n[o] = wt(e[o], r[o], t) : t.clone ? n[o] = Zn(r[o]) ? F8(r[o]) : r[o] : n[o] = r[o]);
  }), n;
}
const mI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wt,
  isPlainObject: Zn
}, Symbol.toStringTag, { value: "Module" })), hI = ["values", "unit", "step"], bI = (e) => {
  const r = Object.keys(e).map((t) => ({
    key: t,
    val: e[t]
  })) || [];
  return r.sort((t, n) => t.val - n.val), r.reduce((t, n) => F({}, t, {
    [n.key]: n.val
  }), {});
};
function Z8(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: r = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: t = "px",
    step: n = 5
  } = e, o = Xe(e, hI), a = bI(r), i = Object.keys(a);
  function l(p) {
    return `@media (min-width:${typeof r[p] == "number" ? r[p] : p}${t})`;
  }
  function s(p) {
    return `@media (max-width:${(typeof r[p] == "number" ? r[p] : p) - n / 100}${t})`;
  }
  function u(p, g) {
    const h = i.indexOf(g);
    return `@media (min-width:${typeof r[p] == "number" ? r[p] : p}${t}) and (max-width:${(h !== -1 && typeof r[i[h]] == "number" ? r[i[h]] : g) - n / 100}${t})`;
  }
  function d(p) {
    return i.indexOf(p) + 1 < i.length ? u(p, i[i.indexOf(p) + 1]) : l(p);
  }
  function f(p) {
    const g = i.indexOf(p);
    return g === 0 ? l(i[1]) : g === i.length - 1 ? s(i[g]) : u(p, i[i.indexOf(p) + 1]).replace("@media", "@media not all and");
  }
  return F({
    keys: i,
    values: a,
    up: l,
    down: s,
    between: u,
    only: d,
    not: f,
    unit: t
  }, o);
}
const yI = {
  borderRadius: 4
}, CI = yI, wI = process.env.NODE_ENV !== "production" ? c.oneOfType([c.number, c.string, c.object, c.array]) : {}, to = wI;
function ai(e, r) {
  return r ? wt(e, r, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const af = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, Sp = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${af[e]}px)`
};
function wn(e, r, t) {
  const n = e.theme || {};
  if (Array.isArray(r)) {
    const a = n.breakpoints || Sp;
    return r.reduce((i, l, s) => (i[a.up(a.keys[s])] = t(r[s]), i), {});
  }
  if (typeof r == "object") {
    const a = n.breakpoints || Sp;
    return Object.keys(r).reduce((i, l) => {
      if (Object.keys(a.values || af).indexOf(l) !== -1) {
        const s = a.up(l);
        i[s] = t(r[l], l);
      } else {
        const s = l;
        i[s] = r[s];
      }
      return i;
    }, {});
  }
  return t(r);
}
function _I(e = {}) {
  var r;
  return ((r = e.keys) == null ? void 0 : r.reduce((n, o) => {
    const a = e.up(o);
    return n[a] = {}, n;
  }, {})) || {};
}
function xI(e, r) {
  return e.reduce((t, n) => {
    const o = t[n];
    return (!o || Object.keys(o).length === 0) && delete t[n], t;
  }, r);
}
function ze(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Io(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const $I = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ze
}, Symbol.toStringTag, { value: "Module" }));
function Ju(e, r, t = !0) {
  if (!r || typeof r != "string")
    return null;
  if (e && e.vars && t) {
    const n = `vars.${r}`.split(".").reduce((o, a) => o && o[a] ? o[a] : null, e);
    if (n != null)
      return n;
  }
  return r.split(".").reduce((n, o) => n && n[o] != null ? n[o] : null, e);
}
function os(e, r, t, n = t) {
  let o;
  return typeof e == "function" ? o = e(t) : Array.isArray(e) ? o = e[t] || n : o = Ju(e, t) || n, r && (o = r(o, n, e)), o;
}
function Lr(e) {
  const {
    prop: r,
    cssProperty: t = e.prop,
    themeKey: n,
    transform: o
  } = e, a = (i) => {
    if (i[r] == null)
      return null;
    const l = i[r], s = i.theme, u = Ju(s, n) || {};
    return wn(i, l, (f) => {
      let p = os(u, o, f);
      return f === p && typeof f == "string" && (p = os(u, o, `${r}${f === "default" ? "" : ze(f)}`, f)), t === !1 ? p : {
        [t]: p
      };
    });
  };
  return a.propTypes = process.env.NODE_ENV !== "production" ? {
    [r]: to
  } : {}, a.filterProps = [r], a;
}
function OI(e) {
  const r = {};
  return (t) => (r[t] === void 0 && (r[t] = e(t)), r[t]);
}
const PI = {
  m: "margin",
  p: "padding"
}, SI = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, Ip = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, II = OI((e) => {
  if (e.length > 2)
    if (Ip[e])
      e = Ip[e];
    else
      return [e];
  const [r, t] = e.split(""), n = PI[r], o = SI[t] || "";
  return Array.isArray(o) ? o.map((a) => n + a) : [n + o];
}), qu = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], Ku = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], EI = [...qu, ...Ku];
function Oi(e, r, t, n) {
  var o;
  const a = (o = Ju(e, r, !1)) != null ? o : t;
  return typeof a == "number" ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && typeof i != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${i}.`), a * i) : Array.isArray(a) ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && (Number.isInteger(i) ? i > a.length - 1 && console.error([`MUI: The value provided (${i}) overflows.`, `The supported values are: ${JSON.stringify(a)}.`, `${i} > ${a.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${r}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${r}\` as a number.`].join(`
`))), a[i]) : typeof a == "function" ? a : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${r}\` value (${a}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function W8(e) {
  return Oi(e, "spacing", 8, "spacing");
}
function Pi(e, r) {
  if (typeof r == "string" || r == null)
    return r;
  const t = Math.abs(r), n = e(t);
  return r >= 0 ? n : typeof n == "number" ? -n : `-${n}`;
}
function RI(e, r) {
  return (t) => e.reduce((n, o) => (n[o] = Pi(r, t), n), {});
}
function AI(e, r, t, n) {
  if (r.indexOf(t) === -1)
    return null;
  const o = II(t), a = RI(o, n), i = e[t];
  return wn(e, i, a);
}
function B8(e, r) {
  const t = W8(e.theme);
  return Object.keys(e).map((n) => AI(e, r, n, t)).reduce(ai, {});
}
function Tr(e) {
  return B8(e, qu);
}
Tr.propTypes = process.env.NODE_ENV !== "production" ? qu.reduce((e, r) => (e[r] = to, e), {}) : {};
Tr.filterProps = qu;
function Dr(e) {
  return B8(e, Ku);
}
Dr.propTypes = process.env.NODE_ENV !== "production" ? Ku.reduce((e, r) => (e[r] = to, e), {}) : {};
Dr.filterProps = Ku;
process.env.NODE_ENV !== "production" && EI.reduce((e, r) => (e[r] = to, e), {});
function kI(e = 8) {
  if (e.mui)
    return e;
  const r = W8({
    spacing: e
  }), t = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((a) => {
    const i = r(a);
    return typeof i == "number" ? `${i}px` : i;
  }).join(" "));
  return t.mui = !0, t;
}
function Qu(...e) {
  const r = e.reduce((n, o) => (o.filterProps.forEach((a) => {
    n[a] = o;
  }), n), {}), t = (n) => Object.keys(n).reduce((o, a) => r[a] ? ai(o, r[a](n)) : o, {});
  return t.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((n, o) => Object.assign(n, o.propTypes), {}) : {}, t.filterProps = e.reduce((n, o) => n.concat(o.filterProps), []), t;
}
function kt(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Ft(e, r) {
  return Lr({
    prop: e,
    themeKey: "borders",
    transform: r
  });
}
const MI = Ft("border", kt), NI = Ft("borderTop", kt), TI = Ft("borderRight", kt), DI = Ft("borderBottom", kt), jI = Ft("borderLeft", kt), LI = Ft("borderColor"), zI = Ft("borderTopColor"), VI = Ft("borderRightColor"), FI = Ft("borderBottomColor"), ZI = Ft("borderLeftColor"), WI = Ft("outline", kt), BI = Ft("outlineColor"), e1 = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const r = Oi(e.theme, "shape.borderRadius", 4, "borderRadius"), t = (n) => ({
      borderRadius: Pi(r, n)
    });
    return wn(e, e.borderRadius, t);
  }
  return null;
};
e1.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: to
} : {};
e1.filterProps = ["borderRadius"];
Qu(MI, NI, TI, DI, jI, LI, zI, VI, FI, ZI, e1, WI, BI);
const r1 = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const r = Oi(e.theme, "spacing", 8, "gap"), t = (n) => ({
      gap: Pi(r, n)
    });
    return wn(e, e.gap, t);
  }
  return null;
};
r1.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: to
} : {};
r1.filterProps = ["gap"];
const t1 = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const r = Oi(e.theme, "spacing", 8, "columnGap"), t = (n) => ({
      columnGap: Pi(r, n)
    });
    return wn(e, e.columnGap, t);
  }
  return null;
};
t1.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: to
} : {};
t1.filterProps = ["columnGap"];
const n1 = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const r = Oi(e.theme, "spacing", 8, "rowGap"), t = (n) => ({
      rowGap: Pi(r, n)
    });
    return wn(e, e.rowGap, t);
  }
  return null;
};
n1.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: to
} : {};
n1.filterProps = ["rowGap"];
const HI = Lr({
  prop: "gridColumn"
}), GI = Lr({
  prop: "gridRow"
}), XI = Lr({
  prop: "gridAutoFlow"
}), YI = Lr({
  prop: "gridAutoColumns"
}), UI = Lr({
  prop: "gridAutoRows"
}), JI = Lr({
  prop: "gridTemplateColumns"
}), qI = Lr({
  prop: "gridTemplateRows"
}), KI = Lr({
  prop: "gridTemplateAreas"
}), QI = Lr({
  prop: "gridArea"
});
Qu(r1, t1, n1, HI, GI, XI, YI, UI, JI, qI, KI, QI);
function aa(e, r) {
  return r === "grey" ? r : e;
}
const eE = Lr({
  prop: "color",
  themeKey: "palette",
  transform: aa
}), rE = Lr({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: aa
}), tE = Lr({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: aa
});
Qu(eE, rE, tE);
function bt(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const nE = Lr({
  prop: "width",
  transform: bt
}), lf = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const r = (t) => {
      var n, o;
      const a = ((n = e.theme) == null || (n = n.breakpoints) == null || (n = n.values) == null ? void 0 : n[t]) || af[t];
      return a ? ((o = e.theme) == null || (o = o.breakpoints) == null ? void 0 : o.unit) !== "px" ? {
        maxWidth: `${a}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: a
      } : {
        maxWidth: bt(t)
      };
    };
    return wn(e, e.maxWidth, r);
  }
  return null;
};
lf.filterProps = ["maxWidth"];
const oE = Lr({
  prop: "minWidth",
  transform: bt
}), aE = Lr({
  prop: "height",
  transform: bt
}), iE = Lr({
  prop: "maxHeight",
  transform: bt
}), lE = Lr({
  prop: "minHeight",
  transform: bt
});
Lr({
  prop: "size",
  cssProperty: "width",
  transform: bt
});
Lr({
  prop: "size",
  cssProperty: "height",
  transform: bt
});
const sE = Lr({
  prop: "boxSizing"
});
Qu(nE, lf, oE, aE, iE, lE, sE);
const cE = {
  // borders
  border: {
    themeKey: "borders",
    transform: kt
  },
  borderTop: {
    themeKey: "borders",
    transform: kt
  },
  borderRight: {
    themeKey: "borders",
    transform: kt
  },
  borderBottom: {
    themeKey: "borders",
    transform: kt
  },
  borderLeft: {
    themeKey: "borders",
    transform: kt
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: kt
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: e1
  },
  // palette
  color: {
    themeKey: "palette",
    transform: aa
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: aa
  },
  backgroundColor: {
    themeKey: "palette",
    transform: aa
  },
  // spacing
  p: {
    style: Dr
  },
  pt: {
    style: Dr
  },
  pr: {
    style: Dr
  },
  pb: {
    style: Dr
  },
  pl: {
    style: Dr
  },
  px: {
    style: Dr
  },
  py: {
    style: Dr
  },
  padding: {
    style: Dr
  },
  paddingTop: {
    style: Dr
  },
  paddingRight: {
    style: Dr
  },
  paddingBottom: {
    style: Dr
  },
  paddingLeft: {
    style: Dr
  },
  paddingX: {
    style: Dr
  },
  paddingY: {
    style: Dr
  },
  paddingInline: {
    style: Dr
  },
  paddingInlineStart: {
    style: Dr
  },
  paddingInlineEnd: {
    style: Dr
  },
  paddingBlock: {
    style: Dr
  },
  paddingBlockStart: {
    style: Dr
  },
  paddingBlockEnd: {
    style: Dr
  },
  m: {
    style: Tr
  },
  mt: {
    style: Tr
  },
  mr: {
    style: Tr
  },
  mb: {
    style: Tr
  },
  ml: {
    style: Tr
  },
  mx: {
    style: Tr
  },
  my: {
    style: Tr
  },
  margin: {
    style: Tr
  },
  marginTop: {
    style: Tr
  },
  marginRight: {
    style: Tr
  },
  marginBottom: {
    style: Tr
  },
  marginLeft: {
    style: Tr
  },
  marginX: {
    style: Tr
  },
  marginY: {
    style: Tr
  },
  marginInline: {
    style: Tr
  },
  marginInlineStart: {
    style: Tr
  },
  marginInlineEnd: {
    style: Tr
  },
  marginBlock: {
    style: Tr
  },
  marginBlockStart: {
    style: Tr
  },
  marginBlockEnd: {
    style: Tr
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: r1
  },
  rowGap: {
    style: n1
  },
  columnGap: {
    style: t1
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: bt
  },
  maxWidth: {
    style: lf
  },
  minWidth: {
    transform: bt
  },
  height: {
    transform: bt
  },
  maxHeight: {
    transform: bt
  },
  minHeight: {
    transform: bt
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, Si = cE;
function uE(...e) {
  const r = e.reduce((n, o) => n.concat(Object.keys(o)), []), t = new Set(r);
  return e.every((n) => t.size === Object.keys(n).length);
}
function dE(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function H8() {
  function e(t, n, o, a) {
    const i = {
      [t]: n,
      theme: o
    }, l = a[t];
    if (!l)
      return {
        [t]: n
      };
    const {
      cssProperty: s = t,
      themeKey: u,
      transform: d,
      style: f
    } = l;
    if (n == null)
      return null;
    if (u === "typography" && n === "inherit")
      return {
        [t]: n
      };
    const p = Ju(o, u) || {};
    return f ? f(i) : wn(i, n, (h) => {
      let v = os(p, d, h);
      return h === v && typeof h == "string" && (v = os(p, d, `${t}${h === "default" ? "" : ze(h)}`, h)), s === !1 ? v : {
        [s]: v
      };
    });
  }
  function r(t) {
    var n;
    const {
      sx: o,
      theme: a = {}
    } = t || {};
    if (!o)
      return null;
    const i = (n = a.unstable_sxConfig) != null ? n : Si;
    function l(s) {
      let u = s;
      if (typeof s == "function")
        u = s(a);
      else if (typeof s != "object")
        return s;
      if (!u)
        return null;
      const d = _I(a.breakpoints), f = Object.keys(d);
      let p = d;
      return Object.keys(u).forEach((g) => {
        const h = dE(u[g], a);
        if (h != null)
          if (typeof h == "object")
            if (i[g])
              p = ai(p, e(g, h, a, i));
            else {
              const v = wn({
                theme: a
              }, h, (y) => ({
                [g]: y
              }));
              uE(v, h) ? p[g] = r({
                sx: h,
                theme: a
              }) : p = ai(p, v);
            }
          else
            p = ai(p, e(g, h, a, i));
      }), xI(f, p);
    }
    return Array.isArray(o) ? o.map(l) : l(o);
  }
  return r;
}
const o1 = H8();
o1.filterProps = ["sx"];
function G8(e, r) {
  const t = this;
  return t.vars && typeof t.getColorSchemeSelector == "function" ? {
    [t.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: r
  } : t.palette.mode === e ? r : {};
}
const fE = ["breakpoints", "palette", "spacing", "shape"];
function sf(e = {}, ...r) {
  const {
    breakpoints: t = {},
    palette: n = {},
    spacing: o,
    shape: a = {}
  } = e, i = Xe(e, fE), l = Z8(t), s = kI(o);
  let u = wt({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: F({
      mode: "light"
    }, n),
    spacing: s,
    shape: F({}, CI, a)
  }, i);
  return u.applyStyles = G8, u = r.reduce((d, f) => wt(d, f), u), u.unstable_sxConfig = F({}, Si, i == null ? void 0 : i.unstable_sxConfig), u.unstable_sx = function(f) {
    return o1({
      sx: f,
      theme: this
    });
  }, u;
}
const pE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sf,
  private_createBreakpoints: Z8,
  unstable_applyStyles: G8
}, Symbol.toStringTag, { value: "Module" }));
function gE(e) {
  return Object.keys(e).length === 0;
}
function X8(e = null) {
  const r = A.useContext(cn);
  return !r || gE(r) ? e : r;
}
const vE = sf();
function cf(e = vE) {
  return X8(e);
}
function Y8({
  styles: e,
  themeId: r,
  defaultTheme: t = {}
}) {
  const n = cf(t), o = typeof e == "function" ? e(r && n[r] || n) : e;
  return /* @__PURE__ */ le.jsx(of, {
    styles: o
  });
}
process.env.NODE_ENV !== "production" && (Y8.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: c.object,
  /**
   * @ignore
   */
  styles: c.oneOfType([c.array, c.func, c.number, c.object, c.string, c.bool]),
  /**
   * @ignore
   */
  themeId: c.string
});
const mE = ["sx"], hE = (e) => {
  var r, t;
  const n = {
    systemProps: {},
    otherProps: {}
  }, o = (r = e == null || (t = e.theme) == null ? void 0 : t.unstable_sxConfig) != null ? r : Si;
  return Object.keys(e).forEach((a) => {
    o[a] ? n.systemProps[a] = e[a] : n.otherProps[a] = e[a];
  }), n;
};
function U8(e) {
  const {
    sx: r
  } = e, t = Xe(e, mE), {
    systemProps: n,
    otherProps: o
  } = hE(t);
  let a;
  return Array.isArray(r) ? a = [n, ...r] : typeof r == "function" ? a = (...i) => {
    const l = r(...i);
    return Zn(l) ? F({}, n, l) : n;
  } : a = F({}, n, r), F({}, o, {
    sx: a
  });
}
const bE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: o1,
  extendSxProp: U8,
  unstable_createStyleFunctionSx: H8,
  unstable_defaultSxConfig: Si
}, Symbol.toStringTag, { value: "Module" })), Ep = (e) => e, yE = () => {
  let e = Ep;
  return {
    configure(r) {
      e = r;
    },
    generate(r) {
      return e(r);
    },
    reset() {
      e = Ep;
    }
  };
}, CE = yE();
function J8(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (r = 0; r < o; r++)
        e[r] && (t = J8(e[r])) && (n && (n += " "), n += t);
    } else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function qe() {
  for (var e, r, t = 0, n = "", o = arguments.length; t < o; t++)
    (e = arguments[t]) && (r = J8(e)) && (n && (n += " "), n += r);
  return n;
}
const q8 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function yr(e, r, t = "Mui") {
  const n = q8[r];
  return n ? `${t}-${n}` : `${CE.generate(e)}-${r}`;
}
function wr(e, r, t = "Mui") {
  const n = {};
  return r.forEach((o) => {
    n[o] = yr(e, o, t);
  }), n;
}
var u0 = { exports: {} }, hr = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rp;
function wE() {
  if (Rp)
    return hr;
  Rp = 1;
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), l = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), h;
  h = Symbol.for("react.module.reference");
  function v(y) {
    if (typeof y == "object" && y !== null) {
      var w = y.$$typeof;
      switch (w) {
        case e:
          switch (y = y.type, y) {
            case t:
            case o:
            case n:
            case u:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case l:
                case i:
                case s:
                case p:
                case f:
                case a:
                  return y;
                default:
                  return w;
              }
          }
        case r:
          return w;
      }
    }
  }
  return hr.ContextConsumer = i, hr.ContextProvider = a, hr.Element = e, hr.ForwardRef = s, hr.Fragment = t, hr.Lazy = p, hr.Memo = f, hr.Portal = r, hr.Profiler = o, hr.StrictMode = n, hr.Suspense = u, hr.SuspenseList = d, hr.isAsyncMode = function() {
    return !1;
  }, hr.isConcurrentMode = function() {
    return !1;
  }, hr.isContextConsumer = function(y) {
    return v(y) === i;
  }, hr.isContextProvider = function(y) {
    return v(y) === a;
  }, hr.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, hr.isForwardRef = function(y) {
    return v(y) === s;
  }, hr.isFragment = function(y) {
    return v(y) === t;
  }, hr.isLazy = function(y) {
    return v(y) === p;
  }, hr.isMemo = function(y) {
    return v(y) === f;
  }, hr.isPortal = function(y) {
    return v(y) === r;
  }, hr.isProfiler = function(y) {
    return v(y) === o;
  }, hr.isStrictMode = function(y) {
    return v(y) === n;
  }, hr.isSuspense = function(y) {
    return v(y) === u;
  }, hr.isSuspenseList = function(y) {
    return v(y) === d;
  }, hr.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === t || y === o || y === n || y === u || y === d || y === g || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === f || y.$$typeof === a || y.$$typeof === i || y.$$typeof === s || y.$$typeof === h || y.getModuleId !== void 0);
  }, hr.typeOf = v, hr;
}
var br = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ap;
function _E() {
  return Ap || (Ap = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), l = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), h = !1, v = !1, y = !1, w = !1, $ = !1, C;
    C = Symbol.for("react.module.reference");
    function x(ne) {
      return !!(typeof ne == "string" || typeof ne == "function" || ne === t || ne === o || $ || ne === n || ne === u || ne === d || w || ne === g || h || v || y || typeof ne == "object" && ne !== null && (ne.$$typeof === p || ne.$$typeof === f || ne.$$typeof === a || ne.$$typeof === i || ne.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ne.$$typeof === C || ne.getModuleId !== void 0));
    }
    function b(ne) {
      if (typeof ne == "object" && ne !== null) {
        var _e = ne.$$typeof;
        switch (_e) {
          case e:
            var ye = ne.type;
            switch (ye) {
              case t:
              case o:
              case n:
              case u:
              case d:
                return ye;
              default:
                var Te = ye && ye.$$typeof;
                switch (Te) {
                  case l:
                  case i:
                  case s:
                  case p:
                  case f:
                  case a:
                    return Te;
                  default:
                    return _e;
                }
            }
          case r:
            return _e;
        }
      }
    }
    var O = i, _ = a, P = e, S = s, I = t, N = p, k = f, j = r, R = o, D = n, T = u, V = d, L = !1, Z = !1;
    function z(ne) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function W(ne) {
      return Z || (Z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function U(ne) {
      return b(ne) === i;
    }
    function re(ne) {
      return b(ne) === a;
    }
    function X(ne) {
      return typeof ne == "object" && ne !== null && ne.$$typeof === e;
    }
    function J(ne) {
      return b(ne) === s;
    }
    function Q(ne) {
      return b(ne) === t;
    }
    function se(ne) {
      return b(ne) === p;
    }
    function q(ne) {
      return b(ne) === f;
    }
    function te(ne) {
      return b(ne) === r;
    }
    function ae(ne) {
      return b(ne) === o;
    }
    function ge(ne) {
      return b(ne) === n;
    }
    function G(ne) {
      return b(ne) === u;
    }
    function oe(ne) {
      return b(ne) === d;
    }
    br.ContextConsumer = O, br.ContextProvider = _, br.Element = P, br.ForwardRef = S, br.Fragment = I, br.Lazy = N, br.Memo = k, br.Portal = j, br.Profiler = R, br.StrictMode = D, br.Suspense = T, br.SuspenseList = V, br.isAsyncMode = z, br.isConcurrentMode = W, br.isContextConsumer = U, br.isContextProvider = re, br.isElement = X, br.isForwardRef = J, br.isFragment = Q, br.isLazy = se, br.isMemo = q, br.isPortal = te, br.isProfiler = ae, br.isStrictMode = ge, br.isSuspense = G, br.isSuspenseList = oe, br.isValidElementType = x, br.typeOf = b;
  }()), br;
}
process.env.NODE_ENV === "production" ? u0.exports = wE() : u0.exports = _E();
var gi = u0.exports;
const xE = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function K8(e) {
  const r = `${e}`.match(xE);
  return r && r[1] || "";
}
function Q8(e, r = "") {
  return e.displayName || e.name || K8(e) || r;
}
function kp(e, r, t) {
  const n = Q8(r);
  return e.displayName || (n !== "" ? `${t}(${n})` : t);
}
function $E(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return Q8(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case gi.ForwardRef:
          return kp(e, e.render, "ForwardRef");
        case gi.Memo:
          return kp(e, e.type, "memo");
        default:
          return;
      }
  }
}
const OE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $E,
  getFunctionName: K8
}, Symbol.toStringTag, { value: "Module" }));
function e6(e, r) {
  const t = F({}, r);
  return Object.keys(e).forEach((n) => {
    if (n.toString().match(/^(components|slots)$/))
      t[n] = F({}, e[n], t[n]);
    else if (n.toString().match(/^(componentsProps|slotProps)$/)) {
      const o = e[n] || {}, a = r[n];
      t[n] = {}, !a || !Object.keys(a) ? t[n] = o : !o || !Object.keys(o) ? t[n] = a : (t[n] = F({}, a), Object.keys(o).forEach((i) => {
        t[n][i] = e6(o[i], a[i]);
      }));
    } else
      t[n] === void 0 && (t[n] = e[n]);
  }), t;
}
function PE(e) {
  const {
    theme: r,
    name: t,
    props: n
  } = e;
  return !r || !r.components || !r.components[t] || !r.components[t].defaultProps ? n : e6(r.components[t].defaultProps, n);
}
function SE({
  props: e,
  name: r,
  defaultTheme: t,
  themeId: n
}) {
  let o = cf(t);
  return n && (o = o[n] || o), PE({
    theme: o,
    name: r,
    props: e
  });
}
const _n = typeof window != "undefined" ? A.useLayoutEffect : A.useEffect;
function IE(e, r = Number.MIN_SAFE_INTEGER, t = Number.MAX_SAFE_INTEGER) {
  return Math.max(r, Math.min(e, t));
}
const EE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: IE
}, Symbol.toStringTag, { value: "Module" }));
function xn(e, r) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return e(...n) || r(...n);
  };
}
function RE(e) {
  const {
    prototype: r = {}
  } = e;
  return !!r.isReactComponent;
}
function r6(e, r, t, n, o) {
  const a = e[r], i = o || r;
  if (a == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window == "undefined")
    return null;
  let l;
  const s = a.type;
  return typeof s == "function" && !RE(s) && (l = "Did you accidentally use a plain function component for an element instead?"), l !== void 0 ? new Error(`Invalid ${n} \`${i}\` supplied to \`${t}\`. Expected an element that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const t6 = xn(c.element, r6);
t6.isRequired = xn(c.element.isRequired, r6);
const a1 = t6;
function AE(e) {
  const {
    prototype: r = {}
  } = e;
  return !!r.isReactComponent;
}
function kE(e, r, t, n, o) {
  const a = e[r], i = o || r;
  if (a == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window == "undefined")
    return null;
  let l;
  return typeof a == "function" && !AE(a) && (l = "Did you accidentally provide a plain function component instead?"), l !== void 0 ? new Error(`Invalid ${n} \`${i}\` supplied to \`${t}\`. Expected an element type that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const uf = xn(c.elementType, kE), ME = "exact-prop: ​";
function i1(e) {
  return process.env.NODE_ENV === "production" ? e : F({}, e, {
    [ME]: (r) => {
      const t = Object.keys(r).filter((n) => !e.hasOwnProperty(n));
      return t.length > 0 ? new Error(`The following props are not supported: ${t.map((n) => `\`${n}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function $n(e, r, t, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const a = e[r], i = o || r;
  return a == null ? null : a && a.nodeType !== 1 ? new Error(`Invalid ${n} \`${i}\` supplied to \`${t}\`. Expected an HTMLElement.`) : null;
}
const NE = c.oneOfType([c.func, c.object]), qt = NE;
function Mp(...e) {
  return e.reduce((r, t) => t == null ? r : function(...o) {
    r.apply(this, o), t.apply(this, o);
  }, () => {
  });
}
function n6(e, r = 166) {
  let t;
  function n(...o) {
    const a = () => {
      e.apply(this, o);
    };
    clearTimeout(t), t = setTimeout(a, r);
  }
  return n.clear = () => {
    clearTimeout(t);
  }, n;
}
function J1(e, r) {
  var t, n;
  return /* @__PURE__ */ A.isValidElement(e) && r.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (t = e.type.muiName) != null ? t : (n = e.type) == null || (n = n._payload) == null || (n = n.value) == null ? void 0 : n.muiName
  ) !== -1;
}
function tt(e) {
  return e && e.ownerDocument || document;
}
function Eo(e) {
  return tt(e).defaultView || window;
}
function as(e, r) {
  typeof e == "function" ? e(r) : e && (e.current = r);
}
let Np = 0;
function TE(e) {
  const [r, t] = A.useState(e), n = e || r;
  return A.useEffect(() => {
    r == null && (Np += 1, t(`mui-${Np}`));
  }, [r]), n;
}
const Tp = A.useId;
function df(e) {
  if (Tp !== void 0) {
    const r = Tp();
    return e != null ? e : r;
  }
  return TE(e);
}
function DE(e, r, t, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const a = o || r;
  return typeof e[r] != "undefined" ? new Error(`The prop \`${a}\` is not supported. Please remove it.`) : null;
}
function ia({
  controlled: e,
  default: r,
  name: t,
  state: n = "value"
}) {
  const {
    current: o
  } = A.useRef(e !== void 0), [a, i] = A.useState(r), l = o ? e : a;
  if (process.env.NODE_ENV !== "production") {
    A.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${n} state of ${t} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${t} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [n, t, e]);
    const {
      current: u
    } = A.useRef(r);
    A.useEffect(() => {
      !o && u !== r && console.error([`MUI: A component is changing the default ${n} state of an uncontrolled ${t} after being initialized. To suppress this warning opt to use a controlled ${t}.`].join(`
`));
    }, [JSON.stringify(r)]);
  }
  const s = A.useCallback((u) => {
    o || i(u);
  }, []);
  return [l, s];
}
function on(e) {
  const r = A.useRef(e);
  return _n(() => {
    r.current = e;
  }), A.useRef((...t) => (
    // @ts-expect-error hide `this`
    (0, r.current)(...t)
  )).current;
}
function Xr(...e) {
  return A.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    e.forEach((t) => {
      as(t, r);
    });
  }, e);
}
const Dp = {};
function jE(e, r) {
  const t = A.useRef(Dp);
  return t.current === Dp && (t.current = e(r)), t;
}
const LE = [];
function zE(e) {
  A.useEffect(e, LE);
}
class l1 {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new l1();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(r, t) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, t();
    }, r);
  }
}
function o6() {
  const e = jE(l1.create).current;
  return zE(e.disposeEffect), e;
}
let s1 = !0, d0 = !1;
const VE = new l1(), FE = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function ZE(e) {
  const {
    type: r,
    tagName: t
  } = e;
  return !!(t === "INPUT" && FE[r] && !e.readOnly || t === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function WE(e) {
  e.metaKey || e.altKey || e.ctrlKey || (s1 = !0);
}
function q1() {
  s1 = !1;
}
function BE() {
  this.visibilityState === "hidden" && d0 && (s1 = !0);
}
function HE(e) {
  e.addEventListener("keydown", WE, !0), e.addEventListener("mousedown", q1, !0), e.addEventListener("pointerdown", q1, !0), e.addEventListener("touchstart", q1, !0), e.addEventListener("visibilitychange", BE, !0);
}
function GE(e) {
  const {
    target: r
  } = e;
  try {
    return r.matches(":focus-visible");
  } catch {
  }
  return s1 || ZE(r);
}
function XE() {
  const e = A.useCallback((o) => {
    o != null && HE(o.ownerDocument);
  }, []), r = A.useRef(!1);
  function t() {
    return r.current ? (d0 = !0, VE.start(100, () => {
      d0 = !1;
    }), r.current = !1, !0) : !1;
  }
  function n(o) {
    return GE(o) ? (r.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: r,
    onFocus: n,
    onBlur: t,
    ref: e
  };
}
function a6(e) {
  const r = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - r);
}
const YE = (e) => {
  const r = A.useRef({});
  return A.useEffect(() => {
    r.current = e;
  }), r.current;
};
function UE(e) {
  const r = typeof e;
  switch (r) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return r;
  }
}
function JE(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const qE = Number.isInteger || JE;
function i6(e, r, t, n) {
  const o = e[r];
  if (o == null || !qE(o)) {
    const a = UE(o);
    return new RangeError(`Invalid ${n} \`${r}\` of type \`${a}\` supplied to \`${t}\`, expected \`integer\`.`);
  }
  return null;
}
function l6(e, r, ...t) {
  return e[r] === void 0 ? null : i6(e, r, ...t);
}
function f0() {
  return null;
}
l6.isRequired = i6;
f0.isRequired = f0;
const Wn = process.env.NODE_ENV === "production" ? f0 : l6;
function _r(e, r, t = void 0) {
  const n = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      n[o] = e[o].reduce((a, i) => {
        if (i) {
          const l = r(i);
          l !== "" && a.push(l), t && t[i] && a.push(t[i]);
        }
        return a;
      }, []).join(" ");
    }
  ), n;
}
const s6 = /* @__PURE__ */ A.createContext(null);
process.env.NODE_ENV !== "production" && (s6.displayName = "ThemeContext");
const c6 = s6;
function u6() {
  const e = A.useContext(c6);
  return process.env.NODE_ENV !== "production" && A.useDebugValue(e), e;
}
const KE = typeof Symbol == "function" && Symbol.for, QE = KE ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function eR(e, r) {
  if (typeof r == "function") {
    const t = r(e);
    return process.env.NODE_ENV !== "production" && (t || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), t;
  }
  return F({}, e, r);
}
function is(e) {
  const {
    children: r,
    theme: t
  } = e, n = u6();
  process.env.NODE_ENV !== "production" && n === null && typeof t == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const o = A.useMemo(() => {
    const a = n === null ? t : eR(n, t);
    return a != null && (a[QE] = n !== null), a;
  }, [t, n]);
  return /* @__PURE__ */ le.jsx(c6.Provider, {
    value: o,
    children: r
  });
}
process.env.NODE_ENV !== "production" && (is.propTypes = {
  /**
   * Your component tree.
   */
  children: c.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: c.oneOfType([c.object, c.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (is.propTypes = i1(is.propTypes));
const rR = ["value"], d6 = /* @__PURE__ */ A.createContext();
function f6(e) {
  let {
    value: r
  } = e, t = Xe(e, rR);
  return /* @__PURE__ */ le.jsx(d6.Provider, F({
    value: r != null ? r : !0
  }, t));
}
process.env.NODE_ENV !== "production" && (f6.propTypes = {
  children: c.node,
  value: c.bool
});
const p6 = () => {
  const e = A.useContext(d6);
  return e != null ? e : !1;
}, jp = {};
function Lp(e, r, t, n = !1) {
  return A.useMemo(() => {
    const o = e && r[e] || r;
    if (typeof t == "function") {
      const a = t(o), i = e ? F({}, r, {
        [e]: a
      }) : a;
      return n ? () => i : i;
    }
    return e ? F({}, r, {
      [e]: t
    }) : F({}, r, t);
  }, [e, r, t, n]);
}
function ls(e) {
  const {
    children: r,
    theme: t,
    themeId: n
  } = e, o = X8(jp), a = u6() || jp;
  process.env.NODE_ENV !== "production" && (o === null && typeof t == "function" || n && o && !o[n] && typeof t == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const i = Lp(n, o, t), l = Lp(n, a, t, !0), s = i.direction === "rtl";
  return /* @__PURE__ */ le.jsx(is, {
    theme: l,
    children: /* @__PURE__ */ le.jsx(cn.Provider, {
      value: i,
      children: /* @__PURE__ */ le.jsx(f6, {
        value: s,
        children: r
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (ls.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: c.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: c.oneOfType([c.func, c.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: c.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (ls.propTypes = i1(ls.propTypes));
function tR(e, r) {
  return F({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, r);
}
var zr = {}, g6 = { exports: {} };
(function(e) {
  function r(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(g6);
var v6 = g6.exports;
const nR = /* @__PURE__ */ eo(KS), oR = /* @__PURE__ */ eo(EE);
var m6 = v6;
Object.defineProperty(zr, "__esModule", {
  value: !0
});
var Mr = zr.alpha = C6;
zr.blend = mR;
zr.colorChannel = void 0;
var aR = zr.darken = pf;
zr.decomposeColor = Dt;
zr.emphasize = vR;
var zp = zr.getContrastRatio = dR;
zr.getLuminance = ss;
zr.hexToRgb = h6;
zr.hslToRgb = y6;
var iR = zr.lighten = gf;
zr.private_safeAlpha = fR;
zr.private_safeColorChannel = void 0;
zr.private_safeDarken = pR;
zr.private_safeEmphasize = w6;
zr.private_safeLighten = gR;
zr.recomposeColor = _a;
zr.rgbToHex = uR;
var Vp = m6(nR), lR = m6(oR);
function ff(e, r = 0, t = 1) {
  return process.env.NODE_ENV !== "production" && (e < r || e > t) && console.error(`MUI: The value provided ${e} is out of range [${r}, ${t}].`), (0, lR.default)(e, r, t);
}
function h6(e) {
  e = e.slice(1);
  const r = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let t = e.match(r);
  return t && t[0].length === 1 && (t = t.map((n) => n + n)), t ? `rgb${t.length === 4 ? "a" : ""}(${t.map((n, o) => o < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function sR(e) {
  const r = e.toString(16);
  return r.length === 1 ? `0${r}` : r;
}
function Dt(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Dt(h6(e));
  const r = e.indexOf("("), t = e.substring(0, r);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(t) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, Vp.default)(9, e));
  let n = e.substring(r + 1, e.length - 1), o;
  if (t === "color") {
    if (n = n.split(" "), o = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(o) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, Vp.default)(10, o));
  } else
    n = n.split(",");
  return n = n.map((a) => parseFloat(a)), {
    type: t,
    values: n,
    colorSpace: o
  };
}
const b6 = (e) => {
  const r = Dt(e);
  return r.values.slice(0, 3).map((t, n) => r.type.indexOf("hsl") !== -1 && n !== 0 ? `${t}%` : t).join(" ");
};
zr.colorChannel = b6;
const cR = (e, r) => {
  try {
    return b6(e);
  } catch {
    return r && process.env.NODE_ENV !== "production" && console.warn(r), e;
  }
};
zr.private_safeColorChannel = cR;
function _a(e) {
  const {
    type: r,
    colorSpace: t
  } = e;
  let {
    values: n
  } = e;
  return r.indexOf("rgb") !== -1 ? n = n.map((o, a) => a < 3 ? parseInt(o, 10) : o) : r.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), r.indexOf("color") !== -1 ? n = `${t} ${n.join(" ")}` : n = `${n.join(", ")}`, `${r}(${n})`;
}
function uR(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: r
  } = Dt(e);
  return `#${r.map((t, n) => sR(n === 3 ? Math.round(255 * t) : t)).join("")}`;
}
function y6(e) {
  e = Dt(e);
  const {
    values: r
  } = e, t = r[0], n = r[1] / 100, o = r[2] / 100, a = n * Math.min(o, 1 - o), i = (u, d = (u + t / 30) % 12) => o - a * Math.max(Math.min(d - 3, 9 - d, 1), -1);
  let l = "rgb";
  const s = [Math.round(i(0) * 255), Math.round(i(8) * 255), Math.round(i(4) * 255)];
  return e.type === "hsla" && (l += "a", s.push(r[3])), _a({
    type: l,
    values: s
  });
}
function ss(e) {
  e = Dt(e);
  let r = e.type === "hsl" || e.type === "hsla" ? Dt(y6(e)).values : e.values;
  return r = r.map((t) => (e.type !== "color" && (t /= 255), t <= 0.03928 ? t / 12.92 : ((t + 0.055) / 1.055) ** 2.4)), Number((0.2126 * r[0] + 0.7152 * r[1] + 0.0722 * r[2]).toFixed(3));
}
function dR(e, r) {
  const t = ss(e), n = ss(r);
  return (Math.max(t, n) + 0.05) / (Math.min(t, n) + 0.05);
}
function C6(e, r) {
  return e = Dt(e), r = ff(r), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${r}` : e.values[3] = r, _a(e);
}
function fR(e, r, t) {
  try {
    return C6(e, r);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function pf(e, r) {
  if (e = Dt(e), r = ff(r), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - r;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] *= 1 - r;
  return _a(e);
}
function pR(e, r, t) {
  try {
    return pf(e, r);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function gf(e, r) {
  if (e = Dt(e), r = ff(r), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * r;
  else if (e.type.indexOf("rgb") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] += (255 - e.values[t]) * r;
  else if (e.type.indexOf("color") !== -1)
    for (let t = 0; t < 3; t += 1)
      e.values[t] += (1 - e.values[t]) * r;
  return _a(e);
}
function gR(e, r, t) {
  try {
    return gf(e, r);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function vR(e, r = 0.15) {
  return ss(e) > 0.5 ? pf(e, r) : gf(e, r);
}
function w6(e, r, t) {
  try {
    return w6(e, r);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
}
function mR(e, r, t, n = 1) {
  const o = (s, u) => Math.round((s ** (1 / n) * (1 - t) + u ** (1 / n) * t) ** n), a = Dt(e), i = Dt(r), l = [o(a.values[0], i.values[0]), o(a.values[1], i.values[1]), o(a.values[2], i.values[2])];
  return _a({
    type: "rgb",
    values: l
  });
}
const hR = {
  black: "#000",
  white: "#fff"
}, mi = hR, bR = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, yR = bR, CR = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, Zo = CR, wR = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Wo = wR, _R = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Va = _R, xR = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Bo = xR, $R = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Ho = $R, OR = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, Go = OR, PR = ["mode", "contrastThreshold", "tonalOffset"], Fp = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: mi.white,
    default: mi.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, K1 = {
  text: {
    primary: mi.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: mi.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function Zp(e, r, t, n) {
  const o = n.light || n, a = n.dark || n * 1.5;
  e[r] || (e.hasOwnProperty(t) ? e[r] = e[t] : r === "light" ? e.light = iR(e.main, o) : r === "dark" && (e.dark = aR(e.main, a)));
}
function SR(e = "light") {
  return e === "dark" ? {
    main: Bo[200],
    light: Bo[50],
    dark: Bo[400]
  } : {
    main: Bo[700],
    light: Bo[400],
    dark: Bo[800]
  };
}
function IR(e = "light") {
  return e === "dark" ? {
    main: Zo[200],
    light: Zo[50],
    dark: Zo[400]
  } : {
    main: Zo[500],
    light: Zo[300],
    dark: Zo[700]
  };
}
function ER(e = "light") {
  return e === "dark" ? {
    main: Wo[500],
    light: Wo[300],
    dark: Wo[700]
  } : {
    main: Wo[700],
    light: Wo[400],
    dark: Wo[800]
  };
}
function RR(e = "light") {
  return e === "dark" ? {
    main: Ho[400],
    light: Ho[300],
    dark: Ho[700]
  } : {
    main: Ho[700],
    light: Ho[500],
    dark: Ho[900]
  };
}
function AR(e = "light") {
  return e === "dark" ? {
    main: Go[400],
    light: Go[300],
    dark: Go[700]
  } : {
    main: Go[800],
    light: Go[500],
    dark: Go[900]
  };
}
function kR(e = "light") {
  return e === "dark" ? {
    main: Va[400],
    light: Va[300],
    dark: Va[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Va[500],
    dark: Va[900]
  };
}
function MR(e) {
  const {
    mode: r = "light",
    contrastThreshold: t = 3,
    tonalOffset: n = 0.2
  } = e, o = Xe(e, PR), a = e.primary || SR(r), i = e.secondary || IR(r), l = e.error || ER(r), s = e.info || RR(r), u = e.success || AR(r), d = e.warning || kR(r);
  function f(v) {
    const y = zp(v, K1.text.primary) >= t ? K1.text.primary : Fp.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const w = zp(v, y);
      w < 3 && console.error([`MUI: The contrast ratio of ${w}:1 for ${y} on ${v}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return y;
  }
  const p = ({
    color: v,
    name: y,
    mainShade: w = 500,
    lightShade: $ = 300,
    darkShade: C = 700
  }) => {
    if (v = F({}, v), !v.main && v[w] && (v.main = v[w]), !v.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${y ? ` (${y})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${w}\` property.` : Io(11, y ? ` (${y})` : "", w));
    if (typeof v.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${y ? ` (${y})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(v.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Io(12, y ? ` (${y})` : "", JSON.stringify(v.main)));
    return Zp(v, "light", $, n), Zp(v, "dark", C, n), v.contrastText || (v.contrastText = f(v.main)), v;
  }, g = {
    dark: K1,
    light: Fp
  };
  return process.env.NODE_ENV !== "production" && (g[r] || console.error(`MUI: The palette mode \`${r}\` is not supported.`)), wt(F({
    // A collection of common colors.
    common: F({}, mi),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: r,
    // The colors used to represent primary interface elements for a user.
    primary: p({
      color: a,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: p({
      color: i,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: p({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: p({
      color: d,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: p({
      color: s,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: p({
      color: u,
      name: "success"
    }),
    // The grey colors.
    grey: yR,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: t,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: p,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n
  }, g[r]), o);
}
const NR = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function TR(e) {
  return Math.round(e * 1e5) / 1e5;
}
const Wp = {
  textTransform: "uppercase"
}, Bp = '"Roboto", "Helvetica", "Arial", sans-serif';
function DR(e, r) {
  const t = typeof r == "function" ? r(e) : r, {
    fontFamily: n = Bp,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: a = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: l = 500,
    fontWeightBold: s = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: u = 16,
    // Apply the CSS properties to all the variants.
    allVariants: d,
    pxToRem: f
  } = t, p = Xe(t, NR);
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof u != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = o / 14, h = f || ((w) => `${w / u * g}rem`), v = (w, $, C, x, b) => F({
    fontFamily: n,
    fontWeight: w,
    fontSize: h($),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: C
  }, n === Bp ? {
    letterSpacing: `${TR(x / $)}em`
  } : {}, b, d), y = {
    h1: v(a, 96, 1.167, -1.5),
    h2: v(a, 60, 1.2, -0.5),
    h3: v(i, 48, 1.167, 0),
    h4: v(i, 34, 1.235, 0.25),
    h5: v(i, 24, 1.334, 0),
    h6: v(l, 20, 1.6, 0.15),
    subtitle1: v(i, 16, 1.75, 0.15),
    subtitle2: v(l, 14, 1.57, 0.1),
    body1: v(i, 16, 1.5, 0.15),
    body2: v(i, 14, 1.43, 0.15),
    button: v(l, 14, 1.75, 0.4, Wp),
    caption: v(i, 12, 1.66, 0.4),
    overline: v(i, 12, 2.66, 1, Wp),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return wt(F({
    htmlFontSize: u,
    pxToRem: h,
    fontFamily: n,
    fontSize: o,
    fontWeightLight: a,
    fontWeightRegular: i,
    fontWeightMedium: l,
    fontWeightBold: s
  }, y), p, {
    clone: !1
    // No need to clone deep
  });
}
const jR = 0.2, LR = 0.14, zR = 0.12;
function Rr(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${jR})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${LR})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${zR})`].join(",");
}
const VR = ["none", Rr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Rr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Rr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Rr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Rr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Rr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Rr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Rr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Rr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Rr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Rr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Rr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Rr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Rr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Rr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Rr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Rr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Rr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Rr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Rr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Rr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Rr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Rr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Rr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], FR = ["duration", "easing", "delay"], ZR = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, WR = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Hp(e) {
  return `${Math.round(e)}ms`;
}
function BR(e) {
  if (!e)
    return 0;
  const r = e / 36;
  return Math.round((4 + 15 * r ** 0.25 + r / 5) * 10);
}
function HR(e) {
  const r = F({}, ZR, e.easing), t = F({}, WR, e.duration);
  return F({
    getAutoHeightDuration: BR,
    create: (o = ["all"], a = {}) => {
      const {
        duration: i = t.standard,
        easing: l = r.easeInOut,
        delay: s = 0
      } = a, u = Xe(a, FR);
      if (process.env.NODE_ENV !== "production") {
        const d = (p) => typeof p == "string", f = (p) => !isNaN(parseFloat(p));
        !d(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !f(i) && !d(i) && console.error(`MUI: Argument "duration" must be a number or a string but found ${i}.`), d(l) || console.error('MUI: Argument "easing" must be a string.'), !f(s) && !d(s) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof a != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(u).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(u).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((d) => `${d} ${typeof i == "string" ? i : Hp(i)} ${l} ${typeof s == "string" ? s : Hp(s)}`).join(",");
    }
  }, e, {
    easing: r,
    duration: t
  });
}
const GR = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, XR = GR, YR = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function _6(e = {}, ...r) {
  const {
    mixins: t = {},
    palette: n = {},
    transitions: o = {},
    typography: a = {}
  } = e, i = Xe(e, YR);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : Io(18));
  const l = MR(n), s = sf(e);
  let u = wt(s, {
    mixins: tR(s.breakpoints, t),
    palette: l,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: VR.slice(),
    typography: DR(l, a),
    transitions: HR(o),
    zIndex: F({}, XR)
  });
  if (u = wt(u, i), u = r.reduce((d, f) => wt(d, f), u), process.env.NODE_ENV !== "production") {
    const d = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], f = (p, g) => {
      let h;
      for (h in p) {
        const v = p[h];
        if (d.indexOf(h) !== -1 && Object.keys(v).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const y = yr("", h);
            console.error([`MUI: The \`${g}\` component increases the CSS specificity of the \`${h}\` internal state.`, "You can not override it like this: ", JSON.stringify(p, null, 2), "", `Instead, you need to use the '&.${y}' syntax:`, JSON.stringify({
              root: {
                [`&.${y}`]: v
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          p[h] = {};
        }
      }
    };
    Object.keys(u.components).forEach((p) => {
      const g = u.components[p].styleOverrides;
      g && p.indexOf("Mui") === 0 && f(g, p);
    });
  }
  return u.unstable_sxConfig = F({}, Si, i == null ? void 0 : i.unstable_sxConfig), u.unstable_sx = function(f) {
    return o1({
      sx: f,
      theme: this
    });
  }, u;
}
const UR = _6(), c1 = UR;
function vf() {
  const e = cf(c1);
  return process.env.NODE_ENV !== "production" && A.useDebugValue(e), e[da] || e;
}
function xr({
  props: e,
  name: r
}) {
  return SE({
    props: e,
    name: r,
    defaultTheme: c1,
    themeId: da
  });
}
var Ii = {}, Q1 = { exports: {} }, Gp;
function JR() {
  return Gp || (Gp = 1, function(e) {
    function r() {
      return e.exports = r = Object.assign ? Object.assign.bind() : function(t) {
        for (var n = 1; n < arguments.length; n++) {
          var o = arguments[n];
          for (var a in o)
            Object.prototype.hasOwnProperty.call(o, a) && (t[a] = o[a]);
        }
        return t;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r.apply(this, arguments);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Q1)), Q1.exports;
}
var ed = { exports: {} }, Xp;
function qR() {
  return Xp || (Xp = 1, function(e) {
    function r(t, n) {
      if (t == null)
        return {};
      var o = {}, a = Object.keys(t), i, l;
      for (l = 0; l < a.length; l++)
        i = a[l], !(n.indexOf(i) >= 0) && (o[i] = t[i]);
      return o;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(ed)), ed.exports;
}
const x6 = /* @__PURE__ */ eo(vI), KR = /* @__PURE__ */ eo(mI), QR = /* @__PURE__ */ eo($I), eA = /* @__PURE__ */ eo(OE), rA = /* @__PURE__ */ eo(pE), tA = /* @__PURE__ */ eo(bE);
var xa = v6;
Object.defineProperty(Ii, "__esModule", {
  value: !0
});
var nA = Ii.default = hA;
Ii.shouldForwardProp = Bl;
Ii.systemDefaultTheme = void 0;
var Rt = xa(JR()), p0 = xa(qR()), Yp = fA(x6), oA = KR, aA = xa(QR), iA = xa(eA), lA = xa(rA), sA = xa(tA);
const cA = ["ownerState"], uA = ["variants"], dA = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function $6(e) {
  if (typeof WeakMap != "function")
    return null;
  var r = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return ($6 = function(n) {
    return n ? t : r;
  })(e);
}
function fA(e, r) {
  if (!r && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var t = $6(r);
  if (t && t.has(e))
    return t.get(e);
  var n = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var a in e)
    if (a !== "default" && Object.prototype.hasOwnProperty.call(e, a)) {
      var i = o ? Object.getOwnPropertyDescriptor(e, a) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, a, i) : n[a] = e[a];
    }
  return n.default = e, t && t.set(e, n), n;
}
function pA(e) {
  return Object.keys(e).length === 0;
}
function gA(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Bl(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const vA = Ii.systemDefaultTheme = (0, lA.default)(), Up = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function Ji({
  defaultTheme: e,
  theme: r,
  themeId: t
}) {
  return pA(r) ? e : r[t] || r;
}
function mA(e) {
  return e ? (r, t) => t[e] : null;
}
function Hl(e, r) {
  let {
    ownerState: t
  } = r, n = (0, p0.default)(r, cA);
  const o = typeof e == "function" ? e((0, Rt.default)({
    ownerState: t
  }, n)) : e;
  if (Array.isArray(o))
    return o.flatMap((a) => Hl(a, (0, Rt.default)({
      ownerState: t
    }, n)));
  if (o && typeof o == "object" && Array.isArray(o.variants)) {
    const {
      variants: a = []
    } = o;
    let l = (0, p0.default)(o, uA);
    return a.forEach((s) => {
      let u = !0;
      typeof s.props == "function" ? u = s.props((0, Rt.default)({
        ownerState: t
      }, n, t)) : Object.keys(s.props).forEach((d) => {
        (t == null ? void 0 : t[d]) !== s.props[d] && n[d] !== s.props[d] && (u = !1);
      }), u && (Array.isArray(l) || (l = [l]), l.push(typeof s.style == "function" ? s.style((0, Rt.default)({
        ownerState: t
      }, n, t)) : s.style));
    }), l;
  }
  return o;
}
function hA(e = {}) {
  const {
    themeId: r,
    defaultTheme: t = vA,
    rootShouldForwardProp: n = Bl,
    slotShouldForwardProp: o = Bl
  } = e, a = (i) => (0, sA.default)((0, Rt.default)({}, i, {
    theme: Ji((0, Rt.default)({}, i, {
      defaultTheme: t,
      themeId: r
    }))
  }));
  return a.__mui_systemSx = !0, (i, l = {}) => {
    (0, Yp.internal_processStyles)(i, (b) => b.filter((O) => !(O != null && O.__mui_systemSx)));
    const {
      name: s,
      slot: u,
      skipVariantsResolver: d,
      skipSx: f,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: p = mA(Up(u))
    } = l, g = (0, p0.default)(l, dA), h = d !== void 0 ? d : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      u && u !== "Root" && u !== "root" || !1
    ), v = f || !1;
    let y;
    process.env.NODE_ENV !== "production" && s && (y = `${s}-${Up(u || "Root")}`);
    let w = Bl;
    u === "Root" || u === "root" ? w = n : u ? w = o : gA(i) && (w = void 0);
    const $ = (0, Yp.default)(i, (0, Rt.default)({
      shouldForwardProp: w,
      label: y
    }, g)), C = (b) => typeof b == "function" && b.__emotion_real !== b || (0, oA.isPlainObject)(b) ? (O) => Hl(b, (0, Rt.default)({}, O, {
      theme: Ji({
        theme: O.theme,
        defaultTheme: t,
        themeId: r
      })
    })) : b, x = (b, ...O) => {
      let _ = C(b);
      const P = O ? O.map(C) : [];
      s && p && P.push((N) => {
        const k = Ji((0, Rt.default)({}, N, {
          defaultTheme: t,
          themeId: r
        }));
        if (!k.components || !k.components[s] || !k.components[s].styleOverrides)
          return null;
        const j = k.components[s].styleOverrides, R = {};
        return Object.entries(j).forEach(([D, T]) => {
          R[D] = Hl(T, (0, Rt.default)({}, N, {
            theme: k
          }));
        }), p(N, R);
      }), s && !h && P.push((N) => {
        var k;
        const j = Ji((0, Rt.default)({}, N, {
          defaultTheme: t,
          themeId: r
        })), R = j == null || (k = j.components) == null || (k = k[s]) == null ? void 0 : k.variants;
        return Hl({
          variants: R
        }, (0, Rt.default)({}, N, {
          theme: j
        }));
      }), v || P.push(a);
      const S = P.length - O.length;
      if (Array.isArray(b) && S > 0) {
        const N = new Array(S).fill("");
        _ = [...b, ...N], _.raw = [...b.raw, ...N];
      }
      const I = $(_, ...P);
      if (process.env.NODE_ENV !== "production") {
        let N;
        s && (N = `${s}${(0, aA.default)(u || "")}`), N === void 0 && (N = `Styled(${(0, iA.default)(i)})`), I.displayName = N;
      }
      return i.muiName && (I.muiName = i.muiName), I;
    };
    return $.withConfig && (x.withConfig = $.withConfig), x;
  };
}
function O6(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const bA = (e) => O6(e) && e !== "classes", fn = bA, Be = nA({
  themeId: da,
  defaultTheme: c1,
  rootShouldForwardProp: fn
}), yA = ["theme"];
function P6(e) {
  let {
    theme: r
  } = e, t = Xe(e, yA);
  const n = r[da];
  return /* @__PURE__ */ le.jsx(ls, F({}, t, {
    themeId: n ? da : void 0,
    theme: n || r
  }));
}
process.env.NODE_ENV !== "production" && (P6.propTypes = {
  /**
   * Your component tree.
   */
  children: c.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: c.oneOfType([c.object, c.func]).isRequired
});
const Jp = (e) => {
  let r;
  return e < 1 ? r = 5.11916 * e ** 2 : r = 4.5 * Math.log(e + 1) + 2, (r / 100).toFixed(2);
};
function Ei(e, r) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: r }) : e.raw = r, e;
}
var CA = M(qp || (qp = Ei([`
  box-sizing: border-box;
  &:before,
  &:after,
  & *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`], [`
  box-sizing: border-box;
  &:before,
  &:after,
  & *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`]))), qp, wA = M(Kp || (Kp = Ei([`
  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
  }
  body {
    margin: 0;
  }
  main {
    display: block;
  }
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }
  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }
  pre {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  a {
    background-color: transparent;
  }
  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }
  b,
  strong {
    font-weight: bolder;
  }
  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  img {
    border-style: none;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }
  button,
  input {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }
  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }
  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 9999s ease-in-out 0s;
  }
  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }
  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }
  progress {
    vertical-align: baseline;
  }
  textarea {
    overflow: auto;
  }
  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }
  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }
  [type='search'] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
  details {
    display: block;
  }
  summary {
    display: list-item;
  }
  template {
    display: none;
  }
  [hidden] {
    display: none;
  }
`], [`
  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
  }
  body {
    margin: 0;
  }
  main {
    display: block;
  }
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }
  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }
  pre {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  a {
    background-color: transparent;
  }
  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }
  b,
  strong {
    font-weight: bolder;
  }
  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  img {
    border-style: none;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }
  button,
  input {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }
  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }
  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 9999s ease-in-out 0s;
  }
  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }
  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }
  progress {
    vertical-align: baseline;
  }
  textarea {
    overflow: auto;
  }
  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }
  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }
  [type='search'] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
  details {
    display: block;
  }
  summary {
    display: list-item;
  }
  template {
    display: none;
  }
  [hidden] {
    display: none;
  }
`]))), Kp, _A = M(Qp || (Qp = Ei([`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`], [`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`]))), Qp;
const xA = { primary: { 100: "#EEEBFF", 200: "#CDC5FF", 300: "#1900AF", 400: "#13007D", 500: "#0A0A32" }, secondary: { 100: "#FFEBEC", 200: "#FFB0B5", 300: "#FF646E", 400: "#803237", 500: "#4F1F22" }, tertiary: { 100: "#FCE1EB", 200: "#FFBEE6", 300: "#FF78AA", 400: "#803C55", 500: "#592A3B" } }, $A = { primary: { 100: "#DDD7EE", 200: "#D596FF", 300: "#A04FC9", 400: "#7C23A8", 500: "#4A245C" }, secondary: { 100: "#EEEBFF", 200: "#CDC5FF", 300: "#1900AF", 400: "#13007D", 500: "#0A0A32" }, tertiary: { 100: "#F2EFFF", 200: "#C5B0FF", 300: "#8053FF", 400: "#6843CC", 500: "#412A80" } }, S6 = { feedback: { success: { 100: "#ECFFEB", 200: "#CBFFC8", 300: "#098500", 400: "#076600", 500: "#055200" }, error: { 100: "#FFE6E5", 200: "#FFCAC9", 300: "#BD0700", 400: "#9E0500", 500: "#3D0201" }, warning: { 100: "#FFFAE4", 200: "#FFF5C5", 300: "#BD9C00", 400: "#695700", 500: "#3D3300" }, information: { 100: "#E3FCFF", 200: "#C3FFFF", 300: "#00CDE6", 400: "#005A66", 500: "#00343B" } }, neutral: { 100: "#E6E6F0", 200: "#9292A9", 300: "#555567", 400: "#42424F", 500: "#27272E" }, background: { gray: "#FAFAFC", white: "#FFFFFF" } };
Object.assign({ brand: Object.assign({}, xA) }, S6);
Object.assign({ brand: Object.assign({}, $A) }, S6);
const OA = [{ fontFamily: "Sora", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-Bold.ttf", format: "ttf" }, fontWeight: 700, fontDisplay: "swap" }, { fontFamily: "Sora", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-Bold.woff2", format: "woff2" }, fontWeight: 700, fontDisplay: "swap" }, { fontFamily: "Sora", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-SemiBold.ttf", format: "ttf" }, fontWeight: 600, fontDisplay: "swap" }, { fontFamily: "Sora", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/Sora-SemiBold.woff2", format: "woff2" }, fontWeight: 600, fontDisplay: "swap" }, { fontFamily: "Source Sans 3", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-SemiBold.ttf", format: "ttf" }, fontWeight: 600, fontDisplay: "swap" }, { fontFamily: "Source Sans 3", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Semibold.ttf.woff2", format: "woff2" }, fontWeight: 600, fontDisplay: "swap" }, { fontFamily: "Source Sans 3", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Regular.ttf", format: "ttf" }, fontWeight: 400, fontDisplay: "swap" }, { fontFamily: "Source Sans 3", webFont: { url: "https://cnx-fonts.s3.sa-east-1.amazonaws.com/fonts/SourceSans3-Regular.ttf.woff2", format: "woff2" }, fontWeight: 400, fontDisplay: "swap" }];
var I6 = function(e) {
  var r = e.fonts, t = function(o) {
    return o.webFont ? "src: url(".concat(o.webFont.url, ") format('").concat(o.webFont.format, "');") : "";
  }, n = function(o) {
    return o.map(function(a) {
      return `
          @font-face {
            font-family: '`.concat(a.fontFamily, `';
            font-style: `).concat(a.fontStyle ? a.fontStyle : "normal", `;
            font-weight: `).concat(a.fontWeight, `;
            font-display: `).concat(a.fontDisplay, `;
            `).concat(t(a), `
          }
        `);
    }).join(`
`);
  };
  return n(r);
}, PA = M(e5 || (e5 = Ei([`
  `, `
`], [`
  `, `
`])), I6({ fonts: OA })), e5, SA = function(e) {
  var r = e.customFonts;
  return m(No, { styles: M(r5 || (r5 = Ei([`
        `, `;
        `, `;
        `, `;
        `, `
        body {
          `, `;
        }
      `], [`
        `, `;
        `, `;
        `, `;
        `, `
        body {
          `, `;
        }
      `])), _A, wA, PA, r ? I6({ fonts: r }) : "", CA) });
}, r5;
const v5e = ({
  children: e,
  theme: r,
  fonts: t
}) => {
  const n = ur(), o = _6();
  return qn(() => {
    r && VP(r);
  }, [r]), /* @__PURE__ */ m(nf, { injectFirst: !0, children: /* @__PURE__ */ m(T8, { theme: n, children: /* @__PURE__ */ Y(P6, { theme: o, children: [
    /* @__PURE__ */ m(SA, { customFonts: t }),
    e
  ] }) }) });
}, IA = ur(), u1 = (e) => t8(`(min-width: ${IA.grid.breakpoint[e]})`);
var EA = Object.prototype.toString, E6 = function(r) {
  if (r === void 0)
    return "undefined";
  if (r === null)
    return "null";
  var t = typeof r;
  if (t === "boolean")
    return "boolean";
  if (t === "string")
    return "string";
  if (t === "number")
    return "number";
  if (t === "symbol")
    return "symbol";
  if (t === "function")
    return NA(r) ? "generatorfunction" : "function";
  if (RA(r))
    return "array";
  if (jA(r))
    return "buffer";
  if (DA(r))
    return "arguments";
  if (kA(r))
    return "date";
  if (AA(r))
    return "error";
  if (MA(r))
    return "regexp";
  switch (R6(r)) {
    case "Symbol":
      return "symbol";
    case "Promise":
      return "promise";
    case "WeakMap":
      return "weakmap";
    case "WeakSet":
      return "weakset";
    case "Map":
      return "map";
    case "Set":
      return "set";
    case "Int8Array":
      return "int8array";
    case "Uint8Array":
      return "uint8array";
    case "Uint8ClampedArray":
      return "uint8clampedarray";
    case "Int16Array":
      return "int16array";
    case "Uint16Array":
      return "uint16array";
    case "Int32Array":
      return "int32array";
    case "Uint32Array":
      return "uint32array";
    case "Float32Array":
      return "float32array";
    case "Float64Array":
      return "float64array";
  }
  if (TA(r))
    return "generator";
  switch (t = EA.call(r), t) {
    case "[object Object]":
      return "object";
    case "[object Map Iterator]":
      return "mapiterator";
    case "[object Set Iterator]":
      return "setiterator";
    case "[object String Iterator]":
      return "stringiterator";
    case "[object Array Iterator]":
      return "arrayiterator";
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
};
function R6(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function RA(e) {
  return Array.isArray ? Array.isArray(e) : e instanceof Array;
}
function AA(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function kA(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function MA(e) {
  return e instanceof RegExp ? !0 : typeof e.flags == "string" && typeof e.ignoreCase == "boolean" && typeof e.multiline == "boolean" && typeof e.global == "boolean";
}
function NA(e, r) {
  return R6(e) === "GeneratorFunction";
}
function TA(e) {
  return typeof e.throw == "function" && typeof e.return == "function" && typeof e.next == "function";
}
function DA(e) {
  try {
    if (typeof e.length == "number" && typeof e.callee == "function")
      return !0;
  } catch (r) {
    if (r.message.indexOf("callee") !== -1)
      return !0;
  }
  return !1;
}
function jA(e) {
  return e.constructor && typeof e.constructor.isBuffer == "function" ? e.constructor.isBuffer(e) : !1;
}
/*!
 * shallow-clone <https://github.com/jonschlinkert/shallow-clone>
 *
 * Copyright (c) 2015-present, Jon Schlinkert.
 * Released under the MIT License.
 */
const t5 = Symbol.prototype.valueOf, LA = E6;
function zA(e, r) {
  switch (LA(e)) {
    case "array":
      return e.slice();
    case "object":
      return Object.assign({}, e);
    case "date":
      return new e.constructor(Number(e));
    case "map":
      return new Map(e);
    case "set":
      return new Set(e);
    case "buffer":
      return WA(e);
    case "symbol":
      return BA(e);
    case "arraybuffer":
      return FA(e);
    case "float32array":
    case "float64array":
    case "int16array":
    case "int32array":
    case "int8array":
    case "uint16array":
    case "uint32array":
    case "uint8clampedarray":
    case "uint8array":
      return ZA(e);
    case "regexp":
      return VA(e);
    case "error":
      return Object.create(e);
    default:
      return e;
  }
}
function VA(e) {
  const r = e.flags !== void 0 ? e.flags : /\w+$/.exec(e) || void 0, t = new e.constructor(e.source, r);
  return t.lastIndex = e.lastIndex, t;
}
function FA(e) {
  const r = new e.constructor(e.byteLength);
  return new Uint8Array(r).set(new Uint8Array(e)), r;
}
function ZA(e, r) {
  return new e.constructor(e.buffer, e.byteOffset, e.length);
}
function WA(e) {
  const r = e.length, t = Buffer.allocUnsafe ? Buffer.allocUnsafe(r) : Buffer.from(r);
  return e.copy(t), t;
}
function BA(e) {
  return t5 ? Object(t5.call(e)) : {};
}
var HA = zA;
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var GA = function(r) {
  return r != null && typeof r == "object" && Array.isArray(r) === !1;
};
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var XA = GA;
function n5(e) {
  return XA(e) === !0 && Object.prototype.toString.call(e) === "[object Object]";
}
var YA = function(r) {
  var t, n;
  return !(n5(r) === !1 || (t = r.constructor, typeof t != "function") || (n = t.prototype, n5(n) === !1) || n.hasOwnProperty("isPrototypeOf") === !1);
};
const UA = HA, JA = E6, qA = YA;
function mf(e, r) {
  switch (JA(e)) {
    case "object":
      return KA(e, r);
    case "array":
      return QA(e, r);
    default:
      return UA(e);
  }
}
function KA(e, r) {
  if (typeof r == "function")
    return r(e);
  if (r || qA(e)) {
    const t = new e.constructor();
    for (let n in e)
      t[n] = mf(e[n], r);
    return t;
  }
  return e;
}
function QA(e, r) {
  const t = new e.constructor(e.length);
  for (let n = 0; n < e.length; n++)
    t[n] = mf(e[n], r);
  return t;
}
var ek = mf;
const rk = /* @__PURE__ */ Qn(ek);
function Ne(e) {
  return (t) => {
    const n = G0((a) => a.theme);
    return Je(() => {
      const a = rk(e), i = {};
      for (const [l, s] of Object.entries(a))
        Object.assign(i, {
          [l]: typeof s == "function" ? s(n, t) : s
        });
      return i;
    }, [t, n]);
  };
}
let qi;
const tk = new Uint8Array(16);
function nk() {
  if (!qi && (qi = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !qi))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return qi(tk);
}
const Jr = [];
for (let e = 0; e < 256; ++e)
  Jr.push((e + 256).toString(16).slice(1));
function ok(e, r = 0) {
  return Jr[e[r + 0]] + Jr[e[r + 1]] + Jr[e[r + 2]] + Jr[e[r + 3]] + "-" + Jr[e[r + 4]] + Jr[e[r + 5]] + "-" + Jr[e[r + 6]] + Jr[e[r + 7]] + "-" + Jr[e[r + 8]] + Jr[e[r + 9]] + "-" + Jr[e[r + 10]] + Jr[e[r + 11]] + Jr[e[r + 12]] + Jr[e[r + 13]] + Jr[e[r + 14]] + Jr[e[r + 15]];
}
const ak = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto), o5 = {
  randomUUID: ak
};
function ik(e, r, t) {
  if (o5.randomUUID && !r && !e)
    return o5.randomUUID();
  e = e || {};
  const n = e.random || (e.rng || nk)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, r) {
    t = t || 0;
    for (let o = 0; o < 16; ++o)
      r[t + o] = n[o];
    return r;
  }
  return ok(n);
}
const To = Zu((e) => ({
  toasts: [],
  containerPosition: "top-right",
  setContainerPosition: (r) => e(() => ({
    containerPosition: r
  })),
  removeToast: (r) => e((t) => ({
    toasts: t.toasts.filter((n) => n.id !== r)
  })),
  addToast: (r) => {
    const t = ik(), n = {
      id: t,
      ...r
    };
    return e((o) => ({
      toasts: [...o.toasts, n]
    })), t;
  },
  cleanAll: () => e(() => ({
    toasts: []
  }))
})), lk = (e) => {
  const {
    addToast: r
  } = To.getState();
  let t;
  if (typeof e == "string")
    return t = r({
      type: "Compact",
      message: e,
      autoClose: !0,
      variant: "success"
    }), t;
  const n = e;
  return e.autoClose === void 0 && (n.autoClose = !0), e.variant === void 0 && (n.variant = "success"), t = r(n), t;
};
lk.removeToast = (e) => To.getState().removeToast(e);
var nn = function() {
  return nn = Object.assign || function(r) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (r[a] = t[a]);
    }
    return r;
  }, nn.apply(this, arguments);
};
function A6(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
  return t;
}
function $a(e, r, t, n) {
  function o(a) {
    return a instanceof t ? a : new t(function(i) {
      i(a);
    });
  }
  return new (t || (t = Promise))(function(a, i) {
    function l(d) {
      try {
        u(n.next(d));
      } catch (f) {
        i(f);
      }
    }
    function s(d) {
      try {
        u(n.throw(d));
      } catch (f) {
        i(f);
      }
    }
    function u(d) {
      d.done ? a(d.value) : o(d.value).then(l, s);
    }
    u((n = n.apply(e, r || [])).next());
  });
}
function Oa(e, r) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, o, a, i;
  return i = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function l(u) {
    return function(d) {
      return s([u, d]);
    };
  }
  function s(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, u[0] && (t = 0)), t; )
      try {
        if (n = 1, o && (a = u[0] & 2 ? o.return : u[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, u[1])).done)
          return a;
        switch (o = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
          case 0:
          case 1:
            a = u;
            break;
          case 4:
            return t.label++, { value: u[1], done: !1 };
          case 5:
            t.label++, o = u[1], u = [0];
            continue;
          case 7:
            u = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              t = 0;
              continue;
            }
            if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
              t.label = u[1];
              break;
            }
            if (u[0] === 6 && t.label < a[1]) {
              t.label = a[1], a = u;
              break;
            }
            if (a && t.label < a[2]) {
              t.label = a[2], t.ops.push(u);
              break;
            }
            a[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        u = r.call(e, t);
      } catch (d) {
        u = [6, d], o = 0;
      } finally {
        n = a = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function a5(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), o, a = [], i;
  try {
    for (; (r === void 0 || r-- > 0) && !(o = n.next()).done; )
      a.push(o.value);
  } catch (l) {
    i = { error: l };
  } finally {
    try {
      o && !o.done && (t = n.return) && t.call(n);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return a;
}
function g0(e, r, t) {
  if (t || arguments.length === 2)
    for (var n = 0, o = r.length, a; n < o; n++)
      (a || !(n in r)) && (a || (a = Array.prototype.slice.call(r, 0, n)), a[n] = r[n]);
  return e.concat(a || Array.prototype.slice.call(r));
}
var Gl = "right-scroll-bar-position", Xl = "width-before-scroll-bar", sk = "with-scroll-bars-hidden", ck = "--removed-body-scroll-bar-size";
function rd(e, r) {
  return typeof e == "function" ? e(r) : e && (e.current = r), e;
}
function uk(e, r) {
  var t = Se(function() {
    return {
      // value
      value: e,
      // last callback
      callback: r,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(n) {
          var o = t.value;
          o !== n && (t.value = n, t.callback(n, o));
        }
      }
    };
  })[0];
  return t.callback = r, t.facade;
}
var dk = typeof window != "undefined" ? A.useLayoutEffect : A.useEffect, i5 = /* @__PURE__ */ new WeakMap();
function fk(e, r) {
  var t = uk(r || null, function(n) {
    return e.forEach(function(o) {
      return rd(o, n);
    });
  });
  return dk(function() {
    var n = i5.get(t);
    if (n) {
      var o = new Set(n), a = new Set(e), i = t.current;
      o.forEach(function(l) {
        a.has(l) || rd(l, null);
      }), a.forEach(function(l) {
        o.has(l) || rd(l, i);
      });
    }
    i5.set(t, e);
  }, [e]), t;
}
function pk(e) {
  return e;
}
function gk(e, r) {
  r === void 0 && (r = pk);
  var t = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(a) {
      var i = r(a, n);
      return t.push(i), function() {
        t = t.filter(function(l) {
          return l !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (n = !0; t.length; ) {
        var i = t;
        t = [], i.forEach(a);
      }
      t = {
        push: function(l) {
          return a(l);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(a) {
      n = !0;
      var i = [];
      if (t.length) {
        var l = t;
        t = [], l.forEach(a), i = t;
      }
      var s = function() {
        var d = i;
        i = [], d.forEach(a);
      }, u = function() {
        return Promise.resolve().then(s);
      };
      u(), t = {
        push: function(d) {
          i.push(d), u();
        },
        filter: function(d) {
          return i = i.filter(d), t;
        }
      };
    }
  };
  return o;
}
function vk(e) {
  e === void 0 && (e = {});
  var r = gk(null);
  return r.options = nn({ async: !0, ssr: !1 }, e), r;
}
var k6 = function(e) {
  var r = e.sideCar, t = A6(e, ["sideCar"]);
  if (!r)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = r.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return A.createElement(n, nn({}, t));
};
k6.isSideCarExport = !0;
function mk(e, r) {
  return e.useMedium(r), k6;
}
var M6 = vk(), td = function() {
}, d1 = A.forwardRef(function(e, r) {
  var t = A.useRef(null), n = A.useState({
    onScrollCapture: td,
    onWheelCapture: td,
    onTouchMoveCapture: td
  }), o = n[0], a = n[1], i = e.forwardProps, l = e.children, s = e.className, u = e.removeScrollBar, d = e.enabled, f = e.shards, p = e.sideCar, g = e.noIsolation, h = e.inert, v = e.allowPinchZoom, y = e.as, w = y === void 0 ? "div" : y, $ = e.gapMode, C = A6(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = p, b = fk([t, r]), O = nn(nn({}, C), o);
  return A.createElement(
    A.Fragment,
    null,
    d && A.createElement(x, { sideCar: M6, removeScrollBar: u, shards: f, noIsolation: g, inert: h, setCallbacks: a, allowPinchZoom: !!v, lockRef: t, gapMode: $ }),
    i ? A.cloneElement(A.Children.only(l), nn(nn({}, O), { ref: b })) : A.createElement(w, nn({}, O, { className: s, ref: b }), l)
  );
});
d1.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
d1.classNames = {
  fullWidth: Xl,
  zeroRight: Gl
};
var hk = function() {
  if (typeof __webpack_nonce__ != "undefined")
    return __webpack_nonce__;
};
function bk() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var r = hk();
  return r && e.setAttribute("nonce", r), e;
}
function yk(e, r) {
  e.styleSheet ? e.styleSheet.cssText = r : e.appendChild(document.createTextNode(r));
}
function Ck(e) {
  var r = document.head || document.getElementsByTagName("head")[0];
  r.appendChild(e);
}
var wk = function() {
  var e = 0, r = null;
  return {
    add: function(t) {
      e == 0 && (r = bk()) && (yk(r, t), Ck(r)), e++;
    },
    remove: function() {
      e--, !e && r && (r.parentNode && r.parentNode.removeChild(r), r = null);
    }
  };
}, _k = function() {
  var e = wk();
  return function(r, t) {
    A.useEffect(function() {
      return e.add(r), function() {
        e.remove();
      };
    }, [r && t]);
  };
}, N6 = function() {
  var e = _k(), r = function(t) {
    var n = t.styles, o = t.dynamic;
    return e(n, o), null;
  };
  return r;
}, xk = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, nd = function(e) {
  return parseInt(e || "", 10) || 0;
}, $k = function(e) {
  var r = window.getComputedStyle(document.body), t = r[e === "padding" ? "paddingLeft" : "marginLeft"], n = r[e === "padding" ? "paddingTop" : "marginTop"], o = r[e === "padding" ? "paddingRight" : "marginRight"];
  return [nd(t), nd(n), nd(o)];
}, Ok = function(e) {
  if (e === void 0 && (e = "margin"), typeof window == "undefined")
    return xk;
  var r = $k(e), t = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: r[0],
    top: r[1],
    right: r[2],
    gap: Math.max(0, n - t + r[2] - r[0])
  };
}, Pk = N6(), la = "data-scroll-locked", Sk = function(e, r, t, n) {
  var o = e.left, a = e.top, i = e.right, l = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(sk, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(l, "px ").concat(n, `;
  }
  body[`).concat(la, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    r && "position: relative ".concat(n, ";"),
    t === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(n, `;
    `),
    t === "padding" && "padding-right: ".concat(l, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Gl, ` {
    right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(Xl, ` {
    margin-right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(Gl, " .").concat(Gl, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Xl, " .").concat(Xl, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(la, `] {
    `).concat(ck, ": ").concat(l, `px;
  }
`);
}, l5 = function() {
  var e = parseInt(document.body.getAttribute(la) || "0", 10);
  return isFinite(e) ? e : 0;
}, Ik = function() {
  A.useEffect(function() {
    return document.body.setAttribute(la, (l5() + 1).toString()), function() {
      var e = l5() - 1;
      e <= 0 ? document.body.removeAttribute(la) : document.body.setAttribute(la, e.toString());
    };
  }, []);
}, Ek = function(e) {
  var r = e.noRelative, t = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  Ik();
  var a = A.useMemo(function() {
    return Ok(o);
  }, [o]);
  return A.createElement(Pk, { styles: Sk(a, !r, o, t ? "" : "!important") });
}, v0 = !1;
if (typeof window != "undefined")
  try {
    var Ki = Object.defineProperty({}, "passive", {
      get: function() {
        return v0 = !0, !0;
      }
    });
    window.addEventListener("test", Ki, Ki), window.removeEventListener("test", Ki, Ki);
  } catch {
    v0 = !1;
  }
var Xo = v0 ? { passive: !1 } : !1, Rk = function(e) {
  return e.tagName === "TEXTAREA";
}, T6 = function(e, r) {
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[r] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !Rk(e) && t[r] === "visible")
  );
}, Ak = function(e) {
  return T6(e, "overflowY");
}, kk = function(e) {
  return T6(e, "overflowX");
}, s5 = function(e, r) {
  var t = r.ownerDocument, n = r;
  do {
    typeof ShadowRoot != "undefined" && n instanceof ShadowRoot && (n = n.host);
    var o = D6(e, n);
    if (o) {
      var a = j6(e, n), i = a[1], l = a[2];
      if (i > l)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== t.body);
  return !1;
}, Mk = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, n = e.clientHeight;
  return [
    r,
    t,
    n
  ];
}, Nk = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, n = e.clientWidth;
  return [
    r,
    t,
    n
  ];
}, D6 = function(e, r) {
  return e === "v" ? Ak(r) : kk(r);
}, j6 = function(e, r) {
  return e === "v" ? Mk(r) : Nk(r);
}, Tk = function(e, r) {
  return e === "h" && r === "rtl" ? -1 : 1;
}, Dk = function(e, r, t, n, o) {
  var a = Tk(e, window.getComputedStyle(r).direction), i = a * n, l = t.target, s = r.contains(l), u = !1, d = i > 0, f = 0, p = 0;
  do {
    var g = j6(e, l), h = g[0], v = g[1], y = g[2], w = v - y - a * h;
    (h || w) && D6(e, l) && (f += w, p += h), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !s && l !== document.body || // self content
    s && (r.contains(l) || r === l)
  );
  return (d && (o && Math.abs(f) < 1 || !o && i > f) || !d && (o && Math.abs(p) < 1 || !o && -i > p)) && (u = !0), u;
}, Qi = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, c5 = function(e) {
  return [e.deltaX, e.deltaY];
}, u5 = function(e) {
  return e && "current" in e ? e.current : e;
}, jk = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, Lk = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, zk = 0, Yo = [];
function Vk(e) {
  var r = A.useRef([]), t = A.useRef([0, 0]), n = A.useRef(), o = A.useState(zk++)[0], a = A.useState(N6)[0], i = A.useRef(e);
  A.useEffect(function() {
    i.current = e;
  }, [e]), A.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var v = g0([e.lockRef.current], (e.shards || []).map(u5), !0).filter(Boolean);
      return v.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), v.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = A.useCallback(function(v, y) {
    if ("touches" in v && v.touches.length === 2)
      return !i.current.allowPinchZoom;
    var w = Qi(v), $ = t.current, C = "deltaX" in v ? v.deltaX : $[0] - w[0], x = "deltaY" in v ? v.deltaY : $[1] - w[1], b, O = v.target, _ = Math.abs(C) > Math.abs(x) ? "h" : "v";
    if ("touches" in v && _ === "h" && O.type === "range")
      return !1;
    var P = s5(_, O);
    if (!P)
      return !0;
    if (P ? b = _ : (b = _ === "v" ? "h" : "v", P = s5(_, O)), !P)
      return !1;
    if (!n.current && "changedTouches" in v && (C || x) && (n.current = b), !b)
      return !0;
    var S = n.current || b;
    return Dk(S, y, v, S === "h" ? C : x, !0);
  }, []), s = A.useCallback(function(v) {
    var y = v;
    if (!(!Yo.length || Yo[Yo.length - 1] !== a)) {
      var w = "deltaY" in y ? c5(y) : Qi(y), $ = r.current.filter(function(b) {
        return b.name === y.type && (b.target === y.target || y.target === b.shadowParent) && jk(b.delta, w);
      })[0];
      if ($ && $.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!$) {
        var C = (i.current.shards || []).map(u5).filter(Boolean).filter(function(b) {
          return b.contains(y.target);
        }), x = C.length > 0 ? l(y, C[0]) : !i.current.noIsolation;
        x && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = A.useCallback(function(v, y, w, $) {
    var C = { name: v, delta: y, target: w, should: $, shadowParent: Fk(w) };
    r.current.push(C), setTimeout(function() {
      r.current = r.current.filter(function(x) {
        return x !== C;
      });
    }, 1);
  }, []), d = A.useCallback(function(v) {
    t.current = Qi(v), n.current = void 0;
  }, []), f = A.useCallback(function(v) {
    u(v.type, c5(v), v.target, l(v, e.lockRef.current));
  }, []), p = A.useCallback(function(v) {
    u(v.type, Qi(v), v.target, l(v, e.lockRef.current));
  }, []);
  A.useEffect(function() {
    return Yo.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", s, Xo), document.addEventListener("touchmove", s, Xo), document.addEventListener("touchstart", d, Xo), function() {
      Yo = Yo.filter(function(v) {
        return v !== a;
      }), document.removeEventListener("wheel", s, Xo), document.removeEventListener("touchmove", s, Xo), document.removeEventListener("touchstart", d, Xo);
    };
  }, []);
  var g = e.removeScrollBar, h = e.inert;
  return A.createElement(
    A.Fragment,
    null,
    h ? A.createElement(a, { styles: Lk(o) }) : null,
    g ? A.createElement(Ek, { gapMode: e.gapMode }) : null
  );
}
function Fk(e) {
  for (var r = null; e !== null; )
    e instanceof ShadowRoot && (r = e.host, e = e.host), e = e.parentNode;
  return r;
}
const Zk = mk(M6, Vk);
var L6 = A.forwardRef(function(e, r) {
  return A.createElement(d1, nn({}, e, { ref: r, sideCar: Zk }));
});
L6.classNames = d1.classNames;
const Wk = L6;
function cs(e, r) {
  let t = e;
  for (; (t = t.parentElement) && !t.matches(r); )
    ;
  return t;
}
function Bk(e, r, t) {
  for (let n = e - 1; n >= 0; n -= 1)
    if (!r[n].disabled)
      return n;
  if (t) {
    for (let n = r.length - 1; n > -1; n -= 1)
      if (!r[n].disabled)
        return n;
  }
  return e;
}
function Hk(e, r, t) {
  for (let n = e + 1; n < r.length; n += 1)
    if (!r[n].disabled)
      return n;
  if (t) {
    for (let n = 0; n < r.length; n += 1)
      if (!r[n].disabled)
        return n;
  }
  return e;
}
function Gk(e, r, t) {
  return cs(e, t) === cs(r, t);
}
function z6({
  parentSelector: e,
  siblingSelector: r,
  onKeyDown: t,
  loop: n = !0,
  activateOnFocus: o = !1,
  dir: a = "rtl",
  orientation: i
}) {
  return (l) => {
    var s;
    t == null || t(l);
    const u = Array.from(((s = cs(l.currentTarget, e)) == null ? void 0 : s.querySelectorAll(r)) || []).filter((v) => Gk(l.currentTarget, v, e)), d = u.findIndex((v) => l.currentTarget === v), f = Hk(d, u, n), p = Bk(d, u, n), g = a === "rtl" ? p : f, h = a === "rtl" ? f : p;
    switch (l.key) {
      case "ArrowRight": {
        i === "horizontal" && (l.stopPropagation(), l.preventDefault(), u[g].focus(), o && u[g].click());
        break;
      }
      case "ArrowLeft": {
        i === "horizontal" && (l.stopPropagation(), l.preventDefault(), u[h].focus(), o && u[h].click());
        break;
      }
      case "ArrowUp": {
        i === "vertical" && (l.stopPropagation(), l.preventDefault(), u[p].focus(), o && u[p].click());
        break;
      }
      case "ArrowDown": {
        i === "vertical" && (l.stopPropagation(), l.preventDefault(), u[f].focus(), o && u[f].click());
        break;
      }
      case "Home": {
        l.stopPropagation(), l.preventDefault(), !u[0].disabled && u[0].focus();
        break;
      }
      case "End": {
        l.stopPropagation(), l.preventDefault();
        const v = u.length - 1;
        !u[v].disabled && u[v].focus();
        break;
      }
    }
  };
}
function Xk(e, r, t) {
  var n;
  return t ? Array.from(((n = cs(t, r)) == null ? void 0 : n.querySelectorAll(e)) || []).findIndex((o) => o === t) : null;
}
function no(e) {
  const r = xt(null);
  return [({ children: o, value: a }) => /* @__PURE__ */ E.createElement(r.Provider, {
    value: a
  }, o), () => {
    const o = dt(r);
    if (o === null)
      throw new Error(e);
    return o;
  }];
}
function f1(e) {
  return Array.isArray(e) ? e : [e];
}
function d5(e, r) {
  return (t) => {
    if (typeof t != "string" || t.trim().length === 0)
      throw new Error(r);
    return `${e}-${t}`;
  };
}
const Yk = () => {
};
function Uk(e, r = { active: !0 }) {
  return typeof e != "function" || !r.active ? r.onKeyDown || Yk : (t) => {
    var n;
    t.key === "Escape" && (e(t), (n = r.onTrigger) == null || n.call(r));
  };
}
function bn(e, r) {
  return (t) => {
    e == null || e(t), r == null || r(t);
  };
}
function Jk() {
  const [e, r] = Se(-1);
  return [e, { setHovered: r, resetHovered: () => r(-1) }];
}
function V6({ data: e }) {
  const r = [], t = [], n = e.reduce((o, a, i) => (a.group ? o[a.group] ? o[a.group].push(i) : o[a.group] = [i] : t.push(i), o), {});
  return Object.keys(n).forEach((o) => {
    r.push(...n[o].map((a) => e[a]));
  }), r.push(...t.map((o) => e[o])), r;
}
function Pa(e) {
  return Array.isArray(e) || e === null ? !1 : typeof e == "object" ? e.type !== E.Fragment : !1;
}
function F6(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (r = 0; r < e.length; r++)
        e[r] && (t = F6(e[r])) && (n && (n += " "), n += t);
    else
      for (r in e)
        e[r] && (n && (n += " "), n += r);
  return n;
}
function Z6() {
  for (var e = 0, r, t, n = ""; e < arguments.length; )
    (r = arguments[e++]) && (t = F6(r)) && (n && (n += " "), n += t);
  return n;
}
const qk = {
  dark: [
    "#C1C2C5",
    "#A6A7AB",
    "#909296",
    "#5c5f66",
    "#373A40",
    "#2C2E33",
    "#25262b",
    "#1A1B1E",
    "#141517",
    "#101113"
  ],
  gray: [
    "#f8f9fa",
    "#f1f3f5",
    "#e9ecef",
    "#dee2e6",
    "#ced4da",
    "#adb5bd",
    "#868e96",
    "#495057",
    "#343a40",
    "#212529"
  ],
  red: [
    "#fff5f5",
    "#ffe3e3",
    "#ffc9c9",
    "#ffa8a8",
    "#ff8787",
    "#ff6b6b",
    "#fa5252",
    "#f03e3e",
    "#e03131",
    "#c92a2a"
  ],
  pink: [
    "#fff0f6",
    "#ffdeeb",
    "#fcc2d7",
    "#faa2c1",
    "#f783ac",
    "#f06595",
    "#e64980",
    "#d6336c",
    "#c2255c",
    "#a61e4d"
  ],
  grape: [
    "#f8f0fc",
    "#f3d9fa",
    "#eebefa",
    "#e599f7",
    "#da77f2",
    "#cc5de8",
    "#be4bdb",
    "#ae3ec9",
    "#9c36b5",
    "#862e9c"
  ],
  violet: [
    "#f3f0ff",
    "#e5dbff",
    "#d0bfff",
    "#b197fc",
    "#9775fa",
    "#845ef7",
    "#7950f2",
    "#7048e8",
    "#6741d9",
    "#5f3dc4"
  ],
  indigo: [
    "#edf2ff",
    "#dbe4ff",
    "#bac8ff",
    "#91a7ff",
    "#748ffc",
    "#5c7cfa",
    "#4c6ef5",
    "#4263eb",
    "#3b5bdb",
    "#364fc7"
  ],
  blue: [
    "#e7f5ff",
    "#d0ebff",
    "#a5d8ff",
    "#74c0fc",
    "#4dabf7",
    "#339af0",
    "#228be6",
    "#1c7ed6",
    "#1971c2",
    "#1864ab"
  ],
  cyan: [
    "#e3fafc",
    "#c5f6fa",
    "#99e9f2",
    "#66d9e8",
    "#3bc9db",
    "#22b8cf",
    "#15aabf",
    "#1098ad",
    "#0c8599",
    "#0b7285"
  ],
  teal: [
    "#e6fcf5",
    "#c3fae8",
    "#96f2d7",
    "#63e6be",
    "#38d9a9",
    "#20c997",
    "#12b886",
    "#0ca678",
    "#099268",
    "#087f5b"
  ],
  green: [
    "#ebfbee",
    "#d3f9d8",
    "#b2f2bb",
    "#8ce99a",
    "#69db7c",
    "#51cf66",
    "#40c057",
    "#37b24d",
    "#2f9e44",
    "#2b8a3e"
  ],
  lime: [
    "#f4fce3",
    "#e9fac8",
    "#d8f5a2",
    "#c0eb75",
    "#a9e34b",
    "#94d82d",
    "#82c91e",
    "#74b816",
    "#66a80f",
    "#5c940d"
  ],
  yellow: [
    "#fff9db",
    "#fff3bf",
    "#ffec99",
    "#ffe066",
    "#ffd43b",
    "#fcc419",
    "#fab005",
    "#f59f00",
    "#f08c00",
    "#e67700"
  ],
  orange: [
    "#fff4e6",
    "#ffe8cc",
    "#ffd8a8",
    "#ffc078",
    "#ffa94d",
    "#ff922b",
    "#fd7e14",
    "#f76707",
    "#e8590c",
    "#d9480f"
  ]
};
function Kk(e) {
  return () => ({ fontFamily: e.fontFamily || "sans-serif" });
}
var Qk = Object.defineProperty, f5 = Object.getOwnPropertySymbols, eM = Object.prototype.hasOwnProperty, rM = Object.prototype.propertyIsEnumerable, p5 = (e, r, t) => r in e ? Qk(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, g5 = (e, r) => {
  for (var t in r || (r = {}))
    eM.call(r, t) && p5(e, t, r[t]);
  if (f5)
    for (var t of f5(r))
      rM.call(r, t) && p5(e, t, r[t]);
  return e;
};
function tM(e) {
  return (r) => ({
    WebkitTapHighlightColor: "transparent",
    [r || "&:focus"]: g5({}, e.focusRing === "always" || e.focusRing === "auto" ? e.focusRingStyles.styles(e) : e.focusRingStyles.resetStyles(e)),
    [r ? r.replace(":focus", ":focus:not(:focus-visible)") : "&:focus:not(:focus-visible)"]: g5({}, e.focusRing === "auto" || e.focusRing === "never" ? e.focusRingStyles.resetStyles(e) : null)
  });
}
function Ri(e) {
  return (r) => typeof e.primaryShade == "number" ? e.primaryShade : e.primaryShade[r || e.colorScheme];
}
function hf(e) {
  const r = Ri(e);
  return (t, n, o = !0, a = !0) => {
    if (typeof t == "string" && t.includes(".")) {
      const [l, s] = t.split("."), u = parseInt(s, 10);
      if (l in e.colors && u >= 0 && u < 10)
        return e.colors[l][typeof n == "number" && !a ? n : u];
    }
    const i = typeof n == "number" ? n : r();
    return t in e.colors ? e.colors[t][i] : o ? e.colors[e.primaryColor][i] : t;
  };
}
function W6(e) {
  let r = "";
  for (let t = 1; t < e.length - 1; t += 1)
    r += `${e[t]} ${t / (e.length - 1) * 100}%, `;
  return `${e[0]} 0%, ${r}${e[e.length - 1]} 100%`;
}
function nM(e, ...r) {
  return `linear-gradient(${e}deg, ${W6(r)})`;
}
function oM(...e) {
  return `radial-gradient(circle, ${W6(e)})`;
}
function B6(e) {
  const r = hf(e), t = Ri(e);
  return (n) => {
    const o = {
      from: (n == null ? void 0 : n.from) || e.defaultGradient.from,
      to: (n == null ? void 0 : n.to) || e.defaultGradient.to,
      deg: (n == null ? void 0 : n.deg) || e.defaultGradient.deg
    };
    return `linear-gradient(${o.deg}deg, ${r(o.from, t(), !1)} 0%, ${r(o.to, t(), !1)} 100%)`;
  };
}
function H6(e) {
  return (r) => {
    if (typeof r == "number")
      return `${r / 16}${e}`;
    if (typeof r == "string") {
      const t = r.replace("px", "");
      if (!Number.isNaN(Number(t)))
        return `${Number(t) / 16}${e}`;
    }
    return r;
  };
}
const B = H6("rem"), Nt = H6("em");
function ve({
  size: e,
  sizes: r,
  units: t
}) {
  return e in r ? r[e] : typeof e == "number" ? t === "em" ? Nt(e) : B(e) : e || r.md;
}
function $t(e) {
  return typeof e == "number" ? e : typeof e == "string" && e.includes("rem") ? Number(e.replace("rem", "")) * 16 : typeof e == "string" && e.includes("em") ? Number(e.replace("em", "")) * 16 : Number(e);
}
function aM(e) {
  return (r) => `@media (min-width: ${Nt($t(ve({ size: r, sizes: e.breakpoints })))})`;
}
function iM(e) {
  return (r) => `@media (max-width: ${Nt($t(ve({ size: r, sizes: e.breakpoints })) - 1)})`;
}
function lM(e) {
  return /^#?([0-9A-F]{3}){1,2}$/i.test(e);
}
function sM(e) {
  let r = e.replace("#", "");
  if (r.length === 3) {
    const i = r.split("");
    r = [
      i[0],
      i[0],
      i[1],
      i[1],
      i[2],
      i[2]
    ].join("");
  }
  const t = parseInt(r, 16), n = t >> 16 & 255, o = t >> 8 & 255, a = t & 255;
  return {
    r: n,
    g: o,
    b: a,
    a: 1
  };
}
function cM(e) {
  const [r, t, n, o] = e.replace(/[^0-9,.]/g, "").split(",").map(Number);
  return { r, g: t, b: n, a: o || 1 };
}
function bf(e) {
  return lM(e) ? sM(e) : e.startsWith("rgb") ? cM(e) : {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}
function ra(e, r) {
  if (typeof e != "string" || r > 1 || r < 0)
    return "rgba(0, 0, 0, 1)";
  if (e.startsWith("var(--"))
    return e;
  const { r: t, g: n, b: o } = bf(e);
  return `rgba(${t}, ${n}, ${o}, ${r})`;
}
function uM(e = 0) {
  return {
    position: "absolute",
    top: B(e),
    right: B(e),
    left: B(e),
    bottom: B(e)
  };
}
function dM(e, r) {
  if (typeof e == "string" && e.startsWith("var(--"))
    return e;
  const { r: t, g: n, b: o, a } = bf(e), i = 1 - r, l = (s) => Math.round(s * i);
  return `rgba(${l(t)}, ${l(n)}, ${l(o)}, ${a})`;
}
function fM(e, r) {
  if (typeof e == "string" && e.startsWith("var(--"))
    return e;
  const { r: t, g: n, b: o, a } = bf(e), i = (l) => Math.round(l + (255 - l) * r);
  return `rgba(${i(t)}, ${i(n)}, ${i(o)}, ${a})`;
}
function pM(e) {
  return (r) => {
    if (typeof r == "number")
      return B(r);
    const t = typeof e.defaultRadius == "number" ? e.defaultRadius : e.radius[e.defaultRadius] || e.defaultRadius;
    return e.radius[r] || r || t;
  };
}
function gM(e, r) {
  if (typeof e == "string" && e.includes(".")) {
    const [t, n] = e.split("."), o = parseInt(n, 10);
    if (t in r.colors && o >= 0 && o < 10)
      return { isSplittedColor: !0, key: t, shade: o };
  }
  return { isSplittedColor: !1 };
}
function vM(e) {
  const r = hf(e), t = Ri(e), n = B6(e);
  return ({ variant: o, color: a, gradient: i, primaryFallback: l }) => {
    const s = gM(a, e);
    switch (o) {
      case "light":
        return {
          border: "transparent",
          background: ra(r(a, e.colorScheme === "dark" ? 8 : 0, l, !1), e.colorScheme === "dark" ? 0.2 : 1),
          color: a === "dark" ? e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.dark[9] : r(a, e.colorScheme === "dark" ? 2 : t("light")),
          hover: ra(r(a, e.colorScheme === "dark" ? 7 : 1, l, !1), e.colorScheme === "dark" ? 0.25 : 0.65)
        };
      case "subtle":
        return {
          border: "transparent",
          background: "transparent",
          color: a === "dark" ? e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.dark[9] : r(a, e.colorScheme === "dark" ? 2 : t("light")),
          hover: ra(r(a, e.colorScheme === "dark" ? 8 : 0, l, !1), e.colorScheme === "dark" ? 0.2 : 1)
        };
      case "outline":
        return {
          border: r(a, e.colorScheme === "dark" ? 5 : t("light")),
          background: "transparent",
          color: r(a, e.colorScheme === "dark" ? 5 : t("light")),
          hover: e.colorScheme === "dark" ? ra(r(a, 5, l, !1), 0.05) : ra(r(a, 0, l, !1), 0.35)
        };
      case "default":
        return {
          border: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4],
          background: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
          color: e.colorScheme === "dark" ? e.white : e.black,
          hover: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[0]
        };
      case "white":
        return {
          border: "transparent",
          background: e.white,
          color: r(a, t()),
          hover: null
        };
      case "transparent":
        return {
          border: "transparent",
          color: a === "dark" ? e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.dark[9] : r(a, e.colorScheme === "dark" ? 2 : t("light")),
          background: "transparent",
          hover: null
        };
      case "gradient":
        return {
          background: n(i),
          color: e.white,
          border: "transparent",
          hover: null
        };
      default: {
        const u = t(), d = s.isSplittedColor ? s.shade : u, f = s.isSplittedColor ? s.key : a;
        return {
          border: "transparent",
          background: r(f, d, l),
          color: e.white,
          hover: r(f, d === 9 ? 8 : d + 1)
        };
      }
    }
  };
}
function mM(e) {
  return (r) => {
    const t = Ri(e)(r);
    return e.colors[e.primaryColor][t];
  };
}
function hM(e) {
  return {
    "@media (hover: hover)": {
      "&:hover": e
    },
    "@media (hover: none)": {
      "&:active": e
    }
  };
}
function bM(e) {
  return () => ({
    userSelect: "none",
    color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[5]
  });
}
function yM(e) {
  return () => e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6];
}
const Zr = {
  fontStyles: Kk,
  themeColor: hf,
  focusStyles: tM,
  linearGradient: nM,
  radialGradient: oM,
  smallerThan: iM,
  largerThan: aM,
  rgba: ra,
  cover: uM,
  darken: dM,
  lighten: fM,
  radius: pM,
  variant: vM,
  primaryShade: Ri,
  hover: hM,
  gradient: B6,
  primaryColor: mM,
  placeholderStyles: bM,
  dimmed: yM
};
var CM = Object.defineProperty, wM = Object.defineProperties, _M = Object.getOwnPropertyDescriptors, v5 = Object.getOwnPropertySymbols, xM = Object.prototype.hasOwnProperty, $M = Object.prototype.propertyIsEnumerable, m5 = (e, r, t) => r in e ? CM(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, OM = (e, r) => {
  for (var t in r || (r = {}))
    xM.call(r, t) && m5(e, t, r[t]);
  if (v5)
    for (var t of v5(r))
      $M.call(r, t) && m5(e, t, r[t]);
  return e;
}, PM = (e, r) => wM(e, _M(r));
function G6(e) {
  return PM(OM({}, e), {
    fn: {
      fontStyles: Zr.fontStyles(e),
      themeColor: Zr.themeColor(e),
      focusStyles: Zr.focusStyles(e),
      largerThan: Zr.largerThan(e),
      smallerThan: Zr.smallerThan(e),
      radialGradient: Zr.radialGradient,
      linearGradient: Zr.linearGradient,
      gradient: Zr.gradient(e),
      rgba: Zr.rgba,
      cover: Zr.cover,
      lighten: Zr.lighten,
      darken: Zr.darken,
      primaryShade: Zr.primaryShade(e),
      radius: Zr.radius(e),
      variant: Zr.variant(e),
      hover: Zr.hover,
      primaryColor: Zr.primaryColor(e),
      placeholderStyles: Zr.placeholderStyles(e),
      dimmed: Zr.dimmed(e)
    }
  });
}
const X6 = ["xs", "sm", "md", "lg", "xl"], SM = {
  dir: "ltr",
  primaryShade: {
    light: 6,
    dark: 8
  },
  focusRing: "auto",
  loader: "oval",
  colorScheme: "light",
  white: "#fff",
  black: "#000",
  defaultRadius: "sm",
  transitionTimingFunction: "ease",
  colors: qk,
  lineHeight: 1.55,
  fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
  primaryColor: "blue",
  respectReducedMotion: !0,
  cursorType: "default",
  defaultGradient: {
    from: "indigo",
    to: "cyan",
    deg: 45
  },
  shadows: {
    xs: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.1)",
    sm: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 0.625rem 0.9375rem -0.3125rem, rgba(0, 0, 0, 0.04) 0 0.4375rem 0.4375rem -0.3125rem",
    md: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 1.25rem 1.5625rem -0.3125rem, rgba(0, 0, 0, 0.04) 0 0.625rem 0.625rem -0.3125rem",
    lg: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 1.75rem 1.4375rem -0.4375rem, rgba(0, 0, 0, 0.04) 0 0.75rem 0.75rem -0.4375rem",
    xl: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 2.25rem 1.75rem -0.4375rem, rgba(0, 0, 0, 0.04) 0 1.0625rem 1.0625rem -0.4375rem"
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem"
  },
  radius: {
    xs: "0.125rem",
    sm: "0.25rem",
    md: "0.5rem",
    lg: "1rem",
    xl: "2rem"
  },
  spacing: {
    xs: "0.625rem",
    sm: "0.75rem",
    md: "1rem",
    lg: "1.25rem",
    xl: "1.5rem"
  },
  breakpoints: {
    xs: "36em",
    sm: "48em",
    md: "62em",
    lg: "75em",
    xl: "88em"
  },
  headings: {
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
    fontWeight: 700,
    sizes: {
      h1: { fontSize: "2.125rem", lineHeight: 1.3, fontWeight: void 0 },
      h2: { fontSize: "1.625rem", lineHeight: 1.35, fontWeight: void 0 },
      h3: { fontSize: "1.375rem", lineHeight: 1.4, fontWeight: void 0 },
      h4: { fontSize: "1.125rem", lineHeight: 1.45, fontWeight: void 0 },
      h5: { fontSize: "1rem", lineHeight: 1.5, fontWeight: void 0 },
      h6: { fontSize: "0.875rem", lineHeight: 1.5, fontWeight: void 0 }
    }
  },
  other: {},
  components: {},
  activeStyles: { transform: "translateY(0.0625rem)" },
  datesLocale: "en",
  globalStyles: void 0,
  focusRingStyles: {
    styles: (e) => ({
      outlineOffset: "0.125rem",
      outline: `0.125rem solid ${e.colors[e.primaryColor][e.colorScheme === "dark" ? 7 : 5]}`
    }),
    resetStyles: () => ({ outline: "none" }),
    inputStyles: (e) => ({
      outline: "none",
      borderColor: e.colors[e.primaryColor][typeof e.primaryShade == "object" ? e.primaryShade[e.colorScheme] : e.primaryShade]
    })
  }
}, yf = G6(SM);
var IM = Object.defineProperty, EM = Object.defineProperties, RM = Object.getOwnPropertyDescriptors, h5 = Object.getOwnPropertySymbols, AM = Object.prototype.hasOwnProperty, kM = Object.prototype.propertyIsEnumerable, b5 = (e, r, t) => r in e ? IM(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, MM = (e, r) => {
  for (var t in r || (r = {}))
    AM.call(r, t) && b5(e, t, r[t]);
  if (h5)
    for (var t of h5(r))
      kM.call(r, t) && b5(e, t, r[t]);
  return e;
}, NM = (e, r) => EM(e, RM(r));
function TM({ theme: e }) {
  return /* @__PURE__ */ E.createElement(No, {
    styles: {
      "*, *::before, *::after": {
        boxSizing: "border-box"
      },
      html: {
        colorScheme: e.colorScheme === "dark" ? "dark" : "light"
      },
      body: NM(MM({}, e.fn.fontStyles()), {
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white,
        color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
        lineHeight: e.lineHeight,
        fontSize: e.fontSizes.md,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale"
      })
    }
  });
}
function Fa(e, r, t, n = B) {
  Object.keys(r).forEach((o) => {
    e[`--mantine-${t}-${o}`] = n(r[o]);
  });
}
function DM({ theme: e }) {
  const r = {
    "--mantine-color-white": e.white,
    "--mantine-color-black": e.black,
    "--mantine-transition-timing-function": e.transitionTimingFunction,
    "--mantine-line-height": `${e.lineHeight}`,
    "--mantine-font-family": e.fontFamily,
    "--mantine-font-family-monospace": e.fontFamilyMonospace,
    "--mantine-font-family-headings": e.headings.fontFamily,
    "--mantine-heading-font-weight": `${e.headings.fontWeight}`
  };
  Fa(r, e.shadows, "shadow"), Fa(r, e.fontSizes, "font-size"), Fa(r, e.radius, "radius"), Fa(r, e.spacing, "spacing"), Fa(r, e.breakpoints, "breakpoints", Nt), Object.keys(e.colors).forEach((n) => {
    e.colors[n].forEach((o, a) => {
      r[`--mantine-color-${n}-${a}`] = o;
    });
  });
  const t = e.headings.sizes;
  return Object.keys(t).forEach((n) => {
    r[`--mantine-${n}-font-size`] = t[n].fontSize, r[`--mantine-${n}-line-height`] = `${t[n].lineHeight}`;
  }), /* @__PURE__ */ E.createElement(No, {
    styles: {
      ":root": r
    }
  });
}
var jM = Object.defineProperty, LM = Object.defineProperties, zM = Object.getOwnPropertyDescriptors, y5 = Object.getOwnPropertySymbols, VM = Object.prototype.hasOwnProperty, FM = Object.prototype.propertyIsEnumerable, C5 = (e, r, t) => r in e ? jM(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Kt = (e, r) => {
  for (var t in r || (r = {}))
    VM.call(r, t) && C5(e, t, r[t]);
  if (y5)
    for (var t of y5(r))
      FM.call(r, t) && C5(e, t, r[t]);
  return e;
}, od = (e, r) => LM(e, zM(r));
function ZM(e, r) {
  var t;
  if (!r)
    return e;
  const n = Object.keys(e).reduce((o, a) => {
    if (a === "headings" && r.headings) {
      const i = r.headings.sizes ? Object.keys(e.headings.sizes).reduce((l, s) => (l[s] = Kt(Kt({}, e.headings.sizes[s]), r.headings.sizes[s]), l), {}) : e.headings.sizes;
      return od(Kt({}, o), {
        headings: od(Kt(Kt({}, e.headings), r.headings), {
          sizes: i
        })
      });
    }
    if (a === "breakpoints" && r.breakpoints) {
      const i = Kt(Kt({}, e.breakpoints), r.breakpoints);
      return od(Kt({}, o), {
        breakpoints: Object.fromEntries(Object.entries(i).sort((l, s) => $t(l[1]) - $t(s[1])))
      });
    }
    return o[a] = typeof r[a] == "object" ? Kt(Kt({}, e[a]), r[a]) : typeof r[a] == "number" || typeof r[a] == "boolean" || typeof r[a] == "function" ? r[a] : r[a] || e[a], o;
  }, {});
  if (r != null && r.fontFamily && !((t = r == null ? void 0 : r.headings) != null && t.fontFamily) && (n.headings.fontFamily = r.fontFamily), !(n.primaryColor in n.colors))
    throw new Error("MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more – https://mantine.dev/theming/colors/#primary-color");
  return n;
}
function WM(e, r) {
  return G6(ZM(e, r));
}
function Y6(e) {
  return Object.keys(e).reduce((r, t) => (e[t] !== void 0 && (r[t] = e[t]), r), {});
}
const BM = {
  html: {
    fontFamily: "sans-serif",
    lineHeight: "1.15",
    textSizeAdjust: "100%"
  },
  body: {
    margin: 0
  },
  "article, aside, footer, header, nav, section, figcaption, figure, main": {
    display: "block"
  },
  h1: {
    fontSize: "2em"
  },
  hr: {
    boxSizing: "content-box",
    height: 0,
    overflow: "visible"
  },
  pre: {
    fontFamily: "monospace, monospace",
    fontSize: "1em"
  },
  a: {
    background: "transparent",
    textDecorationSkip: "objects"
  },
  "a:active, a:hover": {
    outlineWidth: 0
  },
  "abbr[title]": {
    borderBottom: "none",
    textDecoration: "underline"
  },
  "b, strong": {
    fontWeight: "bolder"
  },
  "code, kbp, samp": {
    fontFamily: "monospace, monospace",
    fontSize: "1em"
  },
  dfn: {
    fontStyle: "italic"
  },
  mark: {
    backgroundColor: "#ff0",
    color: "#000"
  },
  small: {
    fontSize: "80%"
  },
  "sub, sup": {
    fontSize: "75%",
    lineHeight: 0,
    position: "relative",
    verticalAlign: "baseline"
  },
  sup: {
    top: "-0.5em"
  },
  sub: {
    bottom: "-0.25em"
  },
  "audio, video": {
    display: "inline-block"
  },
  "audio:not([controls])": {
    display: "none",
    height: 0
  },
  img: {
    borderStyle: "none",
    verticalAlign: "middle"
  },
  "svg:not(:root)": {
    overflow: "hidden"
  },
  "button, input, optgroup, select, textarea": {
    fontFamily: "sans-serif",
    fontSize: "100%",
    lineHeight: "1.15",
    margin: 0
  },
  "button, input": {
    overflow: "visible"
  },
  "button, select": {
    textTransform: "none"
  },
  "button, [type=reset], [type=submit]": {
    WebkitAppearance: "button"
  },
  "button::-moz-focus-inner, [type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner": {
    borderStyle: "none",
    padding: 0
  },
  "button:-moz-focusring, [type=button]:-moz-focusring, [type=reset]:-moz-focusring, [type=submit]:-moz-focusring": {
    outline: `${B(1)} dotted ButtonText`
  },
  legend: {
    boxSizing: "border-box",
    color: "inherit",
    display: "table",
    maxWidth: "100%",
    padding: 0,
    whiteSpace: "normal"
  },
  progress: {
    display: "inline-block",
    verticalAlign: "baseline"
  },
  textarea: {
    overflow: "auto"
  },
  "[type=checkbox], [type=radio]": {
    boxSizing: "border-box",
    padding: 0
  },
  "[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button": {
    height: "auto"
  },
  "[type=search]": {
    appearance: "none"
  },
  "[type=search]::-webkit-search-cancel-button, [type=search]::-webkit-search-decoration": {
    appearance: "none"
  },
  "::-webkit-file-upload-button": {
    appearance: "button",
    font: "inherit"
  },
  "details, menu": {
    display: "block"
  },
  summary: {
    display: "list-item"
  },
  canvas: {
    display: "inline-block"
  },
  template: {
    display: "none"
  }
};
function HM() {
  return /* @__PURE__ */ E.createElement(No, {
    styles: BM
  });
}
var GM = Object.defineProperty, w5 = Object.getOwnPropertySymbols, XM = Object.prototype.hasOwnProperty, YM = Object.prototype.propertyIsEnumerable, _5 = (e, r, t) => r in e ? GM(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ii = (e, r) => {
  for (var t in r || (r = {}))
    XM.call(r, t) && _5(e, t, r[t]);
  if (w5)
    for (var t of w5(r))
      YM.call(r, t) && _5(e, t, r[t]);
  return e;
};
const us = xt({
  theme: yf
});
function ft() {
  var e;
  return ((e = dt(us)) == null ? void 0 : e.theme) || yf;
}
function UM(e) {
  const r = ft(), t = (n) => {
    var o, a, i, l;
    return {
      styles: ((o = r.components[n]) == null ? void 0 : o.styles) || {},
      classNames: ((a = r.components[n]) == null ? void 0 : a.classNames) || {},
      variants: (i = r.components[n]) == null ? void 0 : i.variants,
      sizes: (l = r.components[n]) == null ? void 0 : l.sizes
    };
  };
  return Array.isArray(e) ? e.map(t) : [t(e)];
}
function U6() {
  var e;
  return (e = dt(us)) == null ? void 0 : e.emotionCache;
}
function Oe(e, r, t) {
  var n;
  const o = ft(), a = (n = o.components[e]) == null ? void 0 : n.defaultProps, i = typeof a == "function" ? a(o) : a;
  return ii(ii(ii({}, r), i), Y6(t));
}
function JM({
  theme: e,
  emotionCache: r,
  withNormalizeCSS: t = !1,
  withGlobalStyles: n = !1,
  withCSSVariables: o = !1,
  inherit: a = !1,
  children: i
}) {
  const l = dt(us), s = WM(yf, a ? ii(ii({}, l.theme), e) : e);
  return /* @__PURE__ */ E.createElement(T8, {
    theme: s
  }, /* @__PURE__ */ E.createElement(us.Provider, {
    value: { theme: s, emotionCache: r }
  }, t && /* @__PURE__ */ E.createElement(HM, null), n && /* @__PURE__ */ E.createElement(TM, {
    theme: s
  }), o && /* @__PURE__ */ E.createElement(DM, {
    theme: s
  }), typeof s.globalStyles == "function" && /* @__PURE__ */ E.createElement(No, {
    styles: s.globalStyles(s)
  }), i));
}
JM.displayName = "@mantine/core/MantineProvider";
const qM = {
  app: 100,
  modal: 200,
  popover: 300,
  overlay: 400,
  max: 9999
};
function In(e) {
  return qM[e];
}
function KM(e, r) {
  const t = Ve();
  return (!t.current || r.length !== t.current.prevDeps.length || t.current.prevDeps.map((n, o) => n === r[o]).indexOf(!1) >= 0) && (t.current = {
    v: e(),
    prevDeps: [...r]
  }), t.current.v;
}
const QM = q0({ key: "mantine", prepend: !0 });
function eN() {
  return U6() || QM;
}
var rN = Object.defineProperty, x5 = Object.getOwnPropertySymbols, tN = Object.prototype.hasOwnProperty, nN = Object.prototype.propertyIsEnumerable, $5 = (e, r, t) => r in e ? rN(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, oN = (e, r) => {
  for (var t in r || (r = {}))
    tN.call(r, t) && $5(e, t, r[t]);
  if (x5)
    for (var t of x5(r))
      nN.call(r, t) && $5(e, t, r[t]);
  return e;
};
const ad = "ref";
function aN(e) {
  let r;
  if (e.length !== 1)
    return { args: e, ref: r };
  const [t] = e;
  if (!(t instanceof Object))
    return { args: e, ref: r };
  if (!(ad in t))
    return { args: e, ref: r };
  r = t[ad];
  const n = oN({}, t);
  return delete n[ad], { args: [n], ref: r };
}
const { cssFactory: iN } = /* @__PURE__ */ (() => {
  function e(t, n, o) {
    const a = [], i = Gu(t, a, o);
    return a.length < 2 ? o : i + n(a);
  }
  function r(t) {
    const { cache: n } = t, o = (...i) => {
      const { ref: l, args: s } = aN(i), u = So(s, n.registered);
      return $i(n, u, !1), `${n.key}-${u.name}${l === void 0 ? "" : ` ${l}`}`;
    };
    return { css: o, cx: (...i) => e(n.registered, o, Z6(i)) };
  }
  return { cssFactory: r };
})();
function J6() {
  const e = eN();
  return KM(() => iN({ cache: e }), [e]);
}
function lN({
  cx: e,
  classes: r,
  context: t,
  classNames: n,
  name: o,
  cache: a
}) {
  const i = t.reduce((l, s) => (Object.keys(s.classNames).forEach((u) => {
    typeof l[u] != "string" ? l[u] = `${s.classNames[u]}` : l[u] = `${l[u]} ${s.classNames[u]}`;
  }), l), {});
  return Object.keys(r).reduce((l, s) => (l[s] = e(r[s], i[s], n != null && n[s], Array.isArray(o) ? o.filter(Boolean).map((u) => `${(a == null ? void 0 : a.key) || "mantine"}-${u}-${s}`).join(" ") : o ? `${(a == null ? void 0 : a.key) || "mantine"}-${o}-${s}` : null), l), {});
}
var sN = Object.defineProperty, O5 = Object.getOwnPropertySymbols, cN = Object.prototype.hasOwnProperty, uN = Object.prototype.propertyIsEnumerable, P5 = (e, r, t) => r in e ? sN(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, id = (e, r) => {
  for (var t in r || (r = {}))
    cN.call(r, t) && P5(e, t, r[t]);
  if (O5)
    for (var t of O5(r))
      uN.call(r, t) && P5(e, t, r[t]);
  return e;
};
function m0(e, r) {
  return r && Object.keys(r).forEach((t) => {
    e[t] ? e[t] = id(id({}, e[t]), r[t]) : e[t] = id({}, r[t]);
  }), e;
}
function S5(e, r, t, n) {
  const o = (a) => typeof a == "function" ? a(r, t || {}, n) : a || {};
  return Array.isArray(e) ? e.map((a) => o(a.styles)).reduce((a, i) => m0(a, i), {}) : o(e);
}
function dN({ ctx: e, theme: r, params: t, variant: n, size: o }) {
  return e.reduce((a, i) => (i.variants && n in i.variants && m0(a, i.variants[n](r, t, { variant: n, size: o })), i.sizes && o in i.sizes && m0(a, i.sizes[o](r, t, { variant: n, size: o })), a), {});
}
function Ae(e) {
  const r = typeof e == "function" ? e : () => e;
  function t(n, o) {
    const a = ft(), i = UM(o == null ? void 0 : o.name), l = U6(), s = { variant: o == null ? void 0 : o.variant, size: o == null ? void 0 : o.size }, { css: u, cx: d } = J6(), f = r(a, n, s), p = S5(o == null ? void 0 : o.styles, a, n, s), g = S5(i, a, n, s), h = dN({
      ctx: i,
      theme: a,
      params: n,
      variant: o == null ? void 0 : o.variant,
      size: o == null ? void 0 : o.size
    }), v = Object.fromEntries(Object.keys(f).map((y) => {
      const w = d({ [u(f[y])]: !(o != null && o.unstyled) }, u(h[y]), u(g[y]), u(p[y]));
      return [y, w];
    }));
    return {
      classes: lN({
        cx: d,
        classes: v,
        context: i,
        classNames: o == null ? void 0 : o.classNames,
        name: o == null ? void 0 : o.name,
        cache: l
      }),
      cx: d,
      theme: a
    };
  }
  return t;
}
function Yt(e) {
  return `___ref-${e || ""}`;
}
var fN = Object.defineProperty, pN = Object.defineProperties, gN = Object.getOwnPropertyDescriptors, I5 = Object.getOwnPropertySymbols, vN = Object.prototype.hasOwnProperty, mN = Object.prototype.propertyIsEnumerable, E5 = (e, r, t) => r in e ? fN(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Za = (e, r) => {
  for (var t in r || (r = {}))
    vN.call(r, t) && E5(e, t, r[t]);
  if (I5)
    for (var t of I5(r))
      mN.call(r, t) && E5(e, t, r[t]);
  return e;
}, Wa = (e, r) => pN(e, gN(r));
const Ba = {
  in: { opacity: 1, transform: "scale(1)" },
  out: { opacity: 0, transform: `scale(.9) translateY(${B(10)})` },
  transitionProperty: "transform, opacity"
}, el = {
  fade: {
    in: { opacity: 1 },
    out: { opacity: 0 },
    transitionProperty: "opacity"
  },
  scale: {
    in: { opacity: 1, transform: "scale(1)" },
    out: { opacity: 0, transform: "scale(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-y": {
    in: { opacity: 1, transform: "scaleY(1)" },
    out: { opacity: 0, transform: "scaleY(0)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "scale-x": {
    in: { opacity: 1, transform: "scaleX(1)" },
    out: { opacity: 0, transform: "scaleX(0)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "skew-up": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: `translateY(-${B(20)}) skew(-10deg, -5deg)` },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "skew-down": {
    in: { opacity: 1, transform: "translateY(0) skew(0deg, 0deg)" },
    out: { opacity: 0, transform: `translateY(${B(20)}) skew(-10deg, -5deg)` },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-left": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: `translateY(${B(20)}) rotate(-5deg)` },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "rotate-right": {
    in: { opacity: 1, transform: "translateY(0) rotate(0deg)" },
    out: { opacity: 0, transform: `translateY(${B(20)}) rotate(5deg)` },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-down": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(-100%)" },
    common: { transformOrigin: "top" },
    transitionProperty: "transform, opacity"
  },
  "slide-up": {
    in: { opacity: 1, transform: "translateY(0)" },
    out: { opacity: 0, transform: "translateY(100%)" },
    common: { transformOrigin: "bottom" },
    transitionProperty: "transform, opacity"
  },
  "slide-left": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(100%)" },
    common: { transformOrigin: "left" },
    transitionProperty: "transform, opacity"
  },
  "slide-right": {
    in: { opacity: 1, transform: "translateX(0)" },
    out: { opacity: 0, transform: "translateX(-100%)" },
    common: { transformOrigin: "right" },
    transitionProperty: "transform, opacity"
  },
  pop: Wa(Za({}, Ba), {
    common: { transformOrigin: "center center" }
  }),
  "pop-bottom-left": Wa(Za({}, Ba), {
    common: { transformOrigin: "bottom left" }
  }),
  "pop-bottom-right": Wa(Za({}, Ba), {
    common: { transformOrigin: "bottom right" }
  }),
  "pop-top-left": Wa(Za({}, Ba), {
    common: { transformOrigin: "top left" }
  }),
  "pop-top-right": Wa(Za({}, Ba), {
    common: { transformOrigin: "top right" }
  })
};
var R5 = Object.getOwnPropertySymbols, hN = Object.prototype.hasOwnProperty, bN = Object.prototype.propertyIsEnumerable, yN = (e, r) => {
  var t = {};
  for (var n in e)
    hN.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && R5)
    for (var n of R5(e))
      r.indexOf(n) < 0 && bN.call(e, n) && (t[n] = e[n]);
  return t;
};
function En(e) {
  const r = e, {
    m: t,
    mx: n,
    my: o,
    mt: a,
    mb: i,
    ml: l,
    mr: s,
    p: u,
    px: d,
    py: f,
    pt: p,
    pb: g,
    pl: h,
    pr: v,
    bg: y,
    c: w,
    opacity: $,
    ff: C,
    fz: x,
    fw: b,
    lts: O,
    ta: _,
    lh: P,
    fs: S,
    tt: I,
    td: N,
    w: k,
    miw: j,
    maw: R,
    h: D,
    mih: T,
    mah: V,
    bgsz: L,
    bgp: Z,
    bgr: z,
    bga: W,
    pos: U,
    top: re,
    left: X,
    bottom: J,
    right: Q,
    inset: se,
    display: q
  } = r, te = yN(r, [
    "m",
    "mx",
    "my",
    "mt",
    "mb",
    "ml",
    "mr",
    "p",
    "px",
    "py",
    "pt",
    "pb",
    "pl",
    "pr",
    "bg",
    "c",
    "opacity",
    "ff",
    "fz",
    "fw",
    "lts",
    "ta",
    "lh",
    "fs",
    "tt",
    "td",
    "w",
    "miw",
    "maw",
    "h",
    "mih",
    "mah",
    "bgsz",
    "bgp",
    "bgr",
    "bga",
    "pos",
    "top",
    "left",
    "bottom",
    "right",
    "inset",
    "display"
  ]);
  return { systemStyles: Y6({
    m: t,
    mx: n,
    my: o,
    mt: a,
    mb: i,
    ml: l,
    mr: s,
    p: u,
    px: d,
    py: f,
    pt: p,
    pb: g,
    pl: h,
    pr: v,
    bg: y,
    c: w,
    opacity: $,
    ff: C,
    fz: x,
    fw: b,
    lts: O,
    ta: _,
    lh: P,
    fs: S,
    tt: I,
    td: N,
    w: k,
    miw: j,
    maw: R,
    h: D,
    mih: T,
    mah: V,
    bgsz: L,
    bgp: Z,
    bgr: z,
    bga: W,
    pos: U,
    top: re,
    left: X,
    bottom: J,
    right: Q,
    inset: se,
    display: q
  }), rest: te };
}
function CN(e, r) {
  const t = Object.keys(e).filter((n) => n !== "base").sort((n, o) => $t(ve({ size: n, sizes: r.breakpoints })) - $t(ve({ size: o, sizes: r.breakpoints })));
  return "base" in e ? ["base", ...t] : t;
}
function wN({ value: e, theme: r, getValue: t, property: n }) {
  if (e == null)
    return;
  if (typeof e == "object")
    return CN(e, r).reduce((i, l) => {
      if (l === "base" && e.base !== void 0) {
        const u = t(e.base, r);
        return Array.isArray(n) ? (n.forEach((d) => {
          i[d] = u;
        }), i) : (i[n] = u, i);
      }
      const s = t(e[l], r);
      return Array.isArray(n) ? (i[r.fn.largerThan(l)] = {}, n.forEach((u) => {
        i[r.fn.largerThan(l)][u] = s;
      }), i) : (i[r.fn.largerThan(l)] = {
        [n]: s
      }, i);
    }, {});
  const o = t(e, r);
  return Array.isArray(n) ? n.reduce((a, i) => (a[i] = o, a), {}) : { [n]: o };
}
function _N(e, r) {
  return e === "dimmed" ? r.colorScheme === "dark" ? r.colors.dark[2] : r.colors.gray[6] : r.fn.variant({ variant: "filled", color: e, primaryFallback: !1 }).background;
}
function xN(e) {
  return B(e);
}
function $N(e) {
  return e;
}
function ON(e, r) {
  return ve({ size: e, sizes: r.fontSizes });
}
const PN = ["-xs", "-sm", "-md", "-lg", "-xl"];
function SN(e, r) {
  return PN.includes(e) ? `calc(${ve({
    size: e.replace("-", ""),
    sizes: r.spacing
  })} * -1)` : ve({ size: e, sizes: r.spacing });
}
const IN = {
  identity: $N,
  color: _N,
  size: xN,
  fontSize: ON,
  spacing: SN
}, EN = {
  m: { type: "spacing", property: "margin" },
  mt: { type: "spacing", property: "marginTop" },
  mb: { type: "spacing", property: "marginBottom" },
  ml: { type: "spacing", property: "marginLeft" },
  mr: { type: "spacing", property: "marginRight" },
  mx: { type: "spacing", property: ["marginRight", "marginLeft"] },
  my: { type: "spacing", property: ["marginTop", "marginBottom"] },
  p: { type: "spacing", property: "padding" },
  pt: { type: "spacing", property: "paddingTop" },
  pb: { type: "spacing", property: "paddingBottom" },
  pl: { type: "spacing", property: "paddingLeft" },
  pr: { type: "spacing", property: "paddingRight" },
  px: { type: "spacing", property: ["paddingRight", "paddingLeft"] },
  py: { type: "spacing", property: ["paddingTop", "paddingBottom"] },
  bg: { type: "color", property: "background" },
  c: { type: "color", property: "color" },
  opacity: { type: "identity", property: "opacity" },
  ff: { type: "identity", property: "fontFamily" },
  fz: { type: "fontSize", property: "fontSize" },
  fw: { type: "identity", property: "fontWeight" },
  lts: { type: "size", property: "letterSpacing" },
  ta: { type: "identity", property: "textAlign" },
  lh: { type: "identity", property: "lineHeight" },
  fs: { type: "identity", property: "fontStyle" },
  tt: { type: "identity", property: "textTransform" },
  td: { type: "identity", property: "textDecoration" },
  w: { type: "spacing", property: "width" },
  miw: { type: "spacing", property: "minWidth" },
  maw: { type: "spacing", property: "maxWidth" },
  h: { type: "spacing", property: "height" },
  mih: { type: "spacing", property: "minHeight" },
  mah: { type: "spacing", property: "maxHeight" },
  bgsz: { type: "size", property: "backgroundSize" },
  bgp: { type: "identity", property: "backgroundPosition" },
  bgr: { type: "identity", property: "backgroundRepeat" },
  bga: { type: "identity", property: "backgroundAttachment" },
  pos: { type: "identity", property: "position" },
  top: { type: "identity", property: "top" },
  left: { type: "size", property: "left" },
  bottom: { type: "size", property: "bottom" },
  right: { type: "size", property: "right" },
  inset: { type: "size", property: "inset" },
  display: { type: "identity", property: "display" }
};
var RN = Object.defineProperty, A5 = Object.getOwnPropertySymbols, AN = Object.prototype.hasOwnProperty, kN = Object.prototype.propertyIsEnumerable, k5 = (e, r, t) => r in e ? RN(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, M5 = (e, r) => {
  for (var t in r || (r = {}))
    AN.call(r, t) && k5(e, t, r[t]);
  if (A5)
    for (var t of A5(r))
      kN.call(r, t) && k5(e, t, r[t]);
  return e;
};
function h0(e, r, t = EN) {
  return Object.keys(t).reduce((o, a) => (a in e && e[a] !== void 0 && o.push(wN({
    value: e[a],
    getValue: IN[t[a].type],
    property: t[a].property,
    theme: r
  })), o), []).reduce((o, a) => (Object.keys(a).forEach((i) => {
    typeof a[i] == "object" && a[i] !== null && i in o ? o[i] = M5(M5({}, o[i]), a[i]) : o[i] = a[i];
  }), o), {});
}
function N5(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function MN(e, r, t) {
  const n = ft(), { css: o, cx: a } = J6();
  return Array.isArray(e) ? a(t, o(h0(r, n)), e.map((i) => o(N5(i, n)))) : a(t, o(N5(e, n)), o(h0(r, n)));
}
var NN = Object.defineProperty, ds = Object.getOwnPropertySymbols, q6 = Object.prototype.hasOwnProperty, K6 = Object.prototype.propertyIsEnumerable, T5 = (e, r, t) => r in e ? NN(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, TN = (e, r) => {
  for (var t in r || (r = {}))
    q6.call(r, t) && T5(e, t, r[t]);
  if (ds)
    for (var t of ds(r))
      K6.call(r, t) && T5(e, t, r[t]);
  return e;
}, DN = (e, r) => {
  var t = {};
  for (var n in e)
    q6.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ds)
    for (var n of ds(e))
      r.indexOf(n) < 0 && K6.call(e, n) && (t[n] = e[n]);
  return t;
};
const Q6 = ue((e, r) => {
  var t = e, { className: n, component: o, style: a, sx: i } = t, l = DN(t, ["className", "component", "style", "sx"]);
  const { systemStyles: s, rest: u } = En(l), d = o || "div";
  return /* @__PURE__ */ E.createElement(d, TN({
    ref: r,
    className: MN(i, s, n),
    style: a
  }, u));
});
Q6.displayName = "@mantine/core/Box";
const We = Q6;
var jN = Object.defineProperty, LN = Object.defineProperties, zN = Object.getOwnPropertyDescriptors, D5 = Object.getOwnPropertySymbols, VN = Object.prototype.hasOwnProperty, FN = Object.prototype.propertyIsEnumerable, j5 = (e, r, t) => r in e ? jN(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, L5 = (e, r) => {
  for (var t in r || (r = {}))
    VN.call(r, t) && j5(e, t, r[t]);
  if (D5)
    for (var t of D5(r))
      FN.call(r, t) && j5(e, t, r[t]);
  return e;
}, ZN = (e, r) => LN(e, zN(r)), WN = Ae((e) => ({
  root: ZN(L5(L5({}, e.fn.focusStyles()), e.fn.fontStyles()), {
    cursor: "pointer",
    border: 0,
    padding: 0,
    appearance: "none",
    fontSize: e.fontSizes.md,
    backgroundColor: "transparent",
    textAlign: "left",
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    textDecoration: "none",
    boxSizing: "border-box"
  })
})), BN = Object.defineProperty, fs = Object.getOwnPropertySymbols, em = Object.prototype.hasOwnProperty, rm = Object.prototype.propertyIsEnumerable, z5 = (e, r, t) => r in e ? BN(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, HN = (e, r) => {
  for (var t in r || (r = {}))
    em.call(r, t) && z5(e, t, r[t]);
  if (fs)
    for (var t of fs(r))
      rm.call(r, t) && z5(e, t, r[t]);
  return e;
}, GN = (e, r) => {
  var t = {};
  for (var n in e)
    em.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && fs)
    for (var n of fs(e))
      r.indexOf(n) < 0 && rm.call(e, n) && (t[n] = e[n]);
  return t;
};
const tm = ue((e, r) => {
  const t = Oe("UnstyledButton", {}, e), {
    className: n,
    component: o = "button",
    unstyled: a,
    variant: i
  } = t, l = GN(t, [
    "className",
    "component",
    "unstyled",
    "variant"
  ]), { classes: s, cx: u } = WN(null, { name: "UnstyledButton", unstyled: a, variant: i });
  return /* @__PURE__ */ E.createElement(We, HN({
    component: o,
    ref: r,
    className: u(s.root, n),
    type: o === "button" ? "button" : void 0
  }, l));
});
tm.displayName = "@mantine/core/UnstyledButton";
const $o = tm;
var XN = Object.defineProperty, YN = Object.defineProperties, UN = Object.getOwnPropertyDescriptors, ps = Object.getOwnPropertySymbols, nm = Object.prototype.hasOwnProperty, om = Object.prototype.propertyIsEnumerable, V5 = (e, r, t) => r in e ? XN(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, uo = (e, r) => {
  for (var t in r || (r = {}))
    nm.call(r, t) && V5(e, t, r[t]);
  if (ps)
    for (var t of ps(r))
      om.call(r, t) && V5(e, t, r[t]);
  return e;
}, ld = (e, r) => YN(e, UN(r)), JN = (e, r) => {
  var t = {};
  for (var n in e)
    nm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ps)
    for (var n of ps(e))
      r.indexOf(n) < 0 && om.call(e, n) && (t[n] = e[n]);
  return t;
};
function qN(e) {
  if (!e || typeof e == "string")
    return 0;
  const r = e / 36;
  return Math.round((4 + 15 * r ** 0.25 + r / 5) * 10);
}
function sd(e) {
  return e != null && e.current ? e.current.scrollHeight : "auto";
}
const rl = typeof window != "undefined" && window.requestAnimationFrame;
function KN({
  transitionDuration: e,
  transitionTimingFunction: r = "ease",
  onTransitionEnd: t = () => {
  },
  opened: n
}) {
  const o = Ve(null), a = 0, i = {
    display: "none",
    height: 0,
    overflow: "hidden"
  }, [l, s] = Se(n ? {} : i), u = (h) => {
    e8(() => s(h));
  }, d = (h) => {
    u((v) => uo(uo({}, v), h));
  };
  function f(h) {
    return {
      transition: `height ${e || qN(h)}ms ${r}`
    };
  }
  ct(() => {
    rl(n ? () => {
      d({ willChange: "height", display: "block", overflow: "hidden" }), rl(() => {
        const h = sd(o);
        d(ld(uo({}, f(h)), { height: h }));
      });
    } : () => {
      const h = sd(o);
      d(ld(uo({}, f(h)), { willChange: "height", height: h })), rl(() => d({ height: a, overflow: "hidden" }));
    });
  }, [n]);
  const p = (h) => {
    if (!(h.target !== o.current || h.propertyName !== "height"))
      if (n) {
        const v = sd(o);
        v === l.height ? u({}) : d({ height: v }), t();
      } else
        l.height === a && (u(i), t());
  };
  function g(h = {}) {
    var v = h, { style: y = {}, refKey: w = "ref" } = v, $ = JN(v, ["style", "refKey"]);
    const C = $[w];
    return ld(uo({
      "aria-hidden": !n
    }, $), {
      [w]: s8(o, C),
      onTransitionEnd: p,
      style: uo(uo({ boxSizing: "border-box" }, y), l)
    });
  }
  return g;
}
var QN = Object.defineProperty, gs = Object.getOwnPropertySymbols, am = Object.prototype.hasOwnProperty, im = Object.prototype.propertyIsEnumerable, F5 = (e, r, t) => r in e ? QN(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, tl = (e, r) => {
  for (var t in r || (r = {}))
    am.call(r, t) && F5(e, t, r[t]);
  if (gs)
    for (var t of gs(r))
      im.call(r, t) && F5(e, t, r[t]);
  return e;
}, eT = (e, r) => {
  var t = {};
  for (var n in e)
    am.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && gs)
    for (var n of gs(e))
      r.indexOf(n) < 0 && im.call(e, n) && (t[n] = e[n]);
  return t;
};
const rT = {
  transitionDuration: 200,
  transitionTimingFunction: "ease",
  animateOpacity: !0
}, Cf = ue((e, r) => {
  const t = Oe("Collapse", rT, e), {
    children: n,
    in: o,
    transitionDuration: a,
    transitionTimingFunction: i,
    style: l,
    onTransitionEnd: s,
    animateOpacity: u
  } = t, d = eT(t, [
    "children",
    "in",
    "transitionDuration",
    "transitionTimingFunction",
    "style",
    "onTransitionEnd",
    "animateOpacity"
  ]), f = ft(), p = Fu(), h = (f.respectReducedMotion ? p : !1) ? 0 : a, { systemStyles: v, rest: y } = En(d), w = KN({
    opened: o,
    transitionDuration: h,
    transitionTimingFunction: i,
    onTransitionEnd: s
  });
  return h === 0 ? o ? /* @__PURE__ */ E.createElement(We, tl({}, y), n) : null : /* @__PURE__ */ E.createElement(We, tl({}, w(tl(tl({ style: l, ref: r }, y), v))), /* @__PURE__ */ E.createElement("div", {
    style: {
      opacity: o || !u ? 1 : 0,
      transition: u ? `opacity ${h}ms ${i}` : "none"
    }
  }, n));
});
Cf.displayName = "@mantine/core/Collapse";
var tT = Object.defineProperty, vs = Object.getOwnPropertySymbols, lm = Object.prototype.hasOwnProperty, sm = Object.prototype.propertyIsEnumerable, Z5 = (e, r, t) => r in e ? tT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, W5 = (e, r) => {
  for (var t in r || (r = {}))
    lm.call(r, t) && Z5(e, t, r[t]);
  if (vs)
    for (var t of vs(r))
      sm.call(r, t) && Z5(e, t, r[t]);
  return e;
}, nT = (e, r) => {
  var t = {};
  for (var n in e)
    lm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && vs)
    for (var n of vs(e))
      r.indexOf(n) < 0 && sm.call(e, n) && (t[n] = e[n]);
  return t;
};
function oT(e) {
  const r = e, { style: t } = r, n = nT(r, ["style"]);
  return /* @__PURE__ */ E.createElement("svg", W5({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: W5({ width: B(16), height: B(16) }, t)
  }, n), /* @__PURE__ */ E.createElement("path", {
    d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var aT = Object.defineProperty, iT = Object.defineProperties, lT = Object.getOwnPropertyDescriptors, B5 = Object.getOwnPropertySymbols, sT = Object.prototype.hasOwnProperty, cT = Object.prototype.propertyIsEnumerable, H5 = (e, r, t) => r in e ? aT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, b0 = (e, r) => {
  for (var t in r || (r = {}))
    sT.call(r, t) && H5(e, t, r[t]);
  if (B5)
    for (var t of B5(r))
      cT.call(r, t) && H5(e, t, r[t]);
  return e;
}, G5 = (e, r) => iT(e, lT(r));
const uT = [
  "subtle",
  "filled",
  "outline",
  "light",
  "default",
  "transparent",
  "gradient"
], nl = {
  xs: B(18),
  sm: B(22),
  md: B(28),
  lg: B(34),
  xl: B(44)
};
function dT({ variant: e, theme: r, color: t, gradient: n }) {
  const o = r.fn.variant({ color: t, variant: e, gradient: n });
  return e === "gradient" ? {
    border: 0,
    backgroundImage: o.background,
    color: o.color,
    "&:hover": r.fn.hover({
      backgroundSize: "200%"
    })
  } : uT.includes(e) ? b0({
    border: `${B(1)} solid ${o.border}`,
    backgroundColor: o.background,
    color: o.color
  }, r.fn.hover({
    backgroundColor: o.hover
  })) : null;
}
var fT = Ae((e, { radius: r, color: t, gradient: n }, { variant: o, size: a }) => ({
  root: G5(b0({
    position: "relative",
    borderRadius: e.fn.radius(r),
    padding: 0,
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: ve({ size: a, sizes: nl }),
    minHeight: ve({ size: a, sizes: nl }),
    width: ve({ size: a, sizes: nl }),
    minWidth: ve({ size: a, sizes: nl })
  }, dT({ variant: o, theme: e, color: t, gradient: n })), {
    "&:active": e.activeStyles,
    "& [data-action-icon-loader]": {
      maxWidth: "70%"
    },
    "&:disabled, &[data-disabled]": {
      color: e.colors.gray[e.colorScheme === "dark" ? 6 : 4],
      cursor: "not-allowed",
      backgroundColor: o === "transparent" ? void 0 : e.fn.themeColor("gray", e.colorScheme === "dark" ? 8 : 1),
      borderColor: o === "transparent" ? void 0 : e.fn.themeColor("gray", e.colorScheme === "dark" ? 8 : 1),
      backgroundImage: "none",
      pointerEvents: "none",
      "&:active": {
        transform: "none"
      }
    },
    "&[data-loading]": {
      pointerEvents: "none",
      "&::before": G5(b0({
        content: '""'
      }, e.fn.cover(B(-1))), {
        backgroundColor: e.colorScheme === "dark" ? e.fn.rgba(e.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
        borderRadius: e.fn.radius(r),
        cursor: "not-allowed"
      })
    }
  })
})), pT = Object.defineProperty, ms = Object.getOwnPropertySymbols, cm = Object.prototype.hasOwnProperty, um = Object.prototype.propertyIsEnumerable, X5 = (e, r, t) => r in e ? pT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Y5 = (e, r) => {
  for (var t in r || (r = {}))
    cm.call(r, t) && X5(e, t, r[t]);
  if (ms)
    for (var t of ms(r))
      um.call(r, t) && X5(e, t, r[t]);
  return e;
}, U5 = (e, r) => {
  var t = {};
  for (var n in e)
    cm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ms)
    for (var n of ms(e))
      r.indexOf(n) < 0 && um.call(e, n) && (t[n] = e[n]);
  return t;
};
function gT(e) {
  var r = e, { size: t, color: n } = r, o = U5(r, ["size", "color"]);
  const a = o, { style: i } = a, l = U5(a, ["style"]);
  return /* @__PURE__ */ E.createElement("svg", Y5({
    viewBox: "0 0 135 140",
    xmlns: "http://www.w3.org/2000/svg",
    fill: n,
    style: Y5({ width: t }, i)
  }, l), /* @__PURE__ */ E.createElement("rect", {
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ E.createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ E.createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ E.createElement("rect", {
    x: "30",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ E.createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ E.createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ E.createElement("rect", {
    x: "60",
    width: "15",
    height: "140",
    rx: "6"
  }, /* @__PURE__ */ E.createElement("animate", {
    attributeName: "height",
    begin: "0s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ E.createElement("animate", {
    attributeName: "y",
    begin: "0s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ E.createElement("rect", {
    x: "90",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ E.createElement("animate", {
    attributeName: "height",
    begin: "0.25s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ E.createElement("animate", {
    attributeName: "y",
    begin: "0.25s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ E.createElement("rect", {
    x: "120",
    y: "10",
    width: "15",
    height: "120",
    rx: "6"
  }, /* @__PURE__ */ E.createElement("animate", {
    attributeName: "height",
    begin: "0.5s",
    dur: "1s",
    values: "120;110;100;90;80;70;60;50;40;140;120",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ E.createElement("animate", {
    attributeName: "y",
    begin: "0.5s",
    dur: "1s",
    values: "10;15;20;25;30;35;40;45;50;0;10",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
}
var vT = Object.defineProperty, hs = Object.getOwnPropertySymbols, dm = Object.prototype.hasOwnProperty, fm = Object.prototype.propertyIsEnumerable, J5 = (e, r, t) => r in e ? vT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, q5 = (e, r) => {
  for (var t in r || (r = {}))
    dm.call(r, t) && J5(e, t, r[t]);
  if (hs)
    for (var t of hs(r))
      fm.call(r, t) && J5(e, t, r[t]);
  return e;
}, K5 = (e, r) => {
  var t = {};
  for (var n in e)
    dm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && hs)
    for (var n of hs(e))
      r.indexOf(n) < 0 && fm.call(e, n) && (t[n] = e[n]);
  return t;
};
function mT(e) {
  var r = e, { size: t, color: n } = r, o = K5(r, ["size", "color"]);
  const a = o, { style: i } = a, l = K5(a, ["style"]);
  return /* @__PURE__ */ E.createElement("svg", q5({
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: n,
    style: q5({ width: t, height: t }, i)
  }, l), /* @__PURE__ */ E.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ E.createElement("g", {
    transform: "translate(2.5 2.5)",
    strokeWidth: "5"
  }, /* @__PURE__ */ E.createElement("circle", {
    strokeOpacity: ".5",
    cx: "16",
    cy: "16",
    r: "16"
  }), /* @__PURE__ */ E.createElement("path", {
    d: "M32 16c0-9.94-8.06-16-16-16"
  }, /* @__PURE__ */ E.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 16 16",
    to: "360 16 16",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
}
var hT = Object.defineProperty, bs = Object.getOwnPropertySymbols, pm = Object.prototype.hasOwnProperty, gm = Object.prototype.propertyIsEnumerable, Q5 = (e, r, t) => r in e ? hT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, e7 = (e, r) => {
  for (var t in r || (r = {}))
    pm.call(r, t) && Q5(e, t, r[t]);
  if (bs)
    for (var t of bs(r))
      gm.call(r, t) && Q5(e, t, r[t]);
  return e;
}, r7 = (e, r) => {
  var t = {};
  for (var n in e)
    pm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && bs)
    for (var n of bs(e))
      r.indexOf(n) < 0 && gm.call(e, n) && (t[n] = e[n]);
  return t;
};
function bT(e) {
  var r = e, { size: t, color: n } = r, o = r7(r, ["size", "color"]);
  const a = o, { style: i } = a, l = r7(a, ["style"]);
  return /* @__PURE__ */ E.createElement("svg", e7({
    viewBox: "0 0 120 30",
    xmlns: "http://www.w3.org/2000/svg",
    fill: n,
    style: e7({ width: t }, i)
  }, l), /* @__PURE__ */ E.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }, /* @__PURE__ */ E.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ E.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ E.createElement("circle", {
    cx: "60",
    cy: "15",
    r: "9",
    fillOpacity: "0.3"
  }, /* @__PURE__ */ E.createElement("animate", {
    attributeName: "r",
    from: "9",
    to: "9",
    begin: "0s",
    dur: "0.8s",
    values: "9;15;9",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ E.createElement("animate", {
    attributeName: "fill-opacity",
    from: "0.5",
    to: "0.5",
    begin: "0s",
    dur: "0.8s",
    values: ".5;1;.5",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /* @__PURE__ */ E.createElement("circle", {
    cx: "105",
    cy: "15",
    r: "15"
  }, /* @__PURE__ */ E.createElement("animate", {
    attributeName: "r",
    from: "15",
    to: "15",
    begin: "0s",
    dur: "0.8s",
    values: "15;9;15",
    calcMode: "linear",
    repeatCount: "indefinite"
  }), /* @__PURE__ */ E.createElement("animate", {
    attributeName: "fill-opacity",
    from: "1",
    to: "1",
    begin: "0s",
    dur: "0.8s",
    values: "1;.5;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })));
}
var yT = Object.defineProperty, ys = Object.getOwnPropertySymbols, vm = Object.prototype.hasOwnProperty, mm = Object.prototype.propertyIsEnumerable, t7 = (e, r, t) => r in e ? yT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, CT = (e, r) => {
  for (var t in r || (r = {}))
    vm.call(r, t) && t7(e, t, r[t]);
  if (ys)
    for (var t of ys(r))
      mm.call(r, t) && t7(e, t, r[t]);
  return e;
}, wT = (e, r) => {
  var t = {};
  for (var n in e)
    vm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ys)
    for (var n of ys(e))
      r.indexOf(n) < 0 && mm.call(e, n) && (t[n] = e[n]);
  return t;
};
const cd = {
  bars: gT,
  oval: mT,
  dots: bT
}, _T = {
  xs: B(18),
  sm: B(22),
  md: B(36),
  lg: B(44),
  xl: B(58)
}, xT = {
  size: "md"
};
function wf(e) {
  const r = Oe("Loader", xT, e), { size: t, color: n, variant: o } = r, a = wT(r, ["size", "color", "variant"]), i = ft(), l = o in cd ? o : i.loader;
  return /* @__PURE__ */ E.createElement(We, CT({
    role: "presentation",
    component: cd[l] || cd.bars,
    size: ve({ size: t, sizes: _T }),
    color: i.fn.variant({
      variant: "filled",
      primaryFallback: !1,
      color: n || i.primaryColor
    }).background
  }, a));
}
wf.displayName = "@mantine/core/Loader";
var $T = Object.defineProperty, Cs = Object.getOwnPropertySymbols, hm = Object.prototype.hasOwnProperty, bm = Object.prototype.propertyIsEnumerable, n7 = (e, r, t) => r in e ? $T(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, o7 = (e, r) => {
  for (var t in r || (r = {}))
    hm.call(r, t) && n7(e, t, r[t]);
  if (Cs)
    for (var t of Cs(r))
      bm.call(r, t) && n7(e, t, r[t]);
  return e;
}, OT = (e, r) => {
  var t = {};
  for (var n in e)
    hm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Cs)
    for (var n of Cs(e))
      r.indexOf(n) < 0 && bm.call(e, n) && (t[n] = e[n]);
  return t;
};
const PT = {
  color: "gray",
  size: "md",
  variant: "subtle"
}, ym = ue((e, r) => {
  const t = Oe("ActionIcon", PT, e), {
    className: n,
    color: o,
    children: a,
    radius: i,
    size: l,
    variant: s,
    gradient: u,
    disabled: d,
    loaderProps: f,
    loading: p,
    unstyled: g,
    __staticSelector: h
  } = t, v = OT(t, [
    "className",
    "color",
    "children",
    "radius",
    "size",
    "variant",
    "gradient",
    "disabled",
    "loaderProps",
    "loading",
    "unstyled",
    "__staticSelector"
  ]), { classes: y, cx: w, theme: $ } = fT({ radius: i, color: o, gradient: u }, { name: ["ActionIcon", h], unstyled: g, size: l, variant: s }), C = /* @__PURE__ */ E.createElement(wf, o7({
    color: $.fn.variant({ color: o, variant: s }).color,
    size: "100%",
    "data-action-icon-loader": !0
  }, f));
  return /* @__PURE__ */ E.createElement($o, o7({
    className: w(y.root, n),
    ref: r,
    disabled: d,
    "data-disabled": d || void 0,
    "data-loading": p || void 0,
    unstyled: g
  }, v), p ? C : a);
});
ym.displayName = "@mantine/core/ActionIcon";
const p1 = ym;
var ST = Object.defineProperty, IT = Object.defineProperties, ET = Object.getOwnPropertyDescriptors, ws = Object.getOwnPropertySymbols, Cm = Object.prototype.hasOwnProperty, wm = Object.prototype.propertyIsEnumerable, a7 = (e, r, t) => r in e ? ST(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, RT = (e, r) => {
  for (var t in r || (r = {}))
    Cm.call(r, t) && a7(e, t, r[t]);
  if (ws)
    for (var t of ws(r))
      wm.call(r, t) && a7(e, t, r[t]);
  return e;
}, AT = (e, r) => IT(e, ET(r)), kT = (e, r) => {
  var t = {};
  for (var n in e)
    Cm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ws)
    for (var n of ws(e))
      r.indexOf(n) < 0 && wm.call(e, n) && (t[n] = e[n]);
  return t;
};
function _f(e) {
  const r = Oe("Portal", {}, e), { children: t, target: n, className: o, innerRef: a } = r, i = kT(r, ["children", "target", "className", "innerRef"]), l = ft(), [s, u] = Se(!1), d = Ve();
  return Vu(() => (u(!0), d.current = n ? typeof n == "string" ? document.querySelector(n) : n : document.createElement("div"), n || document.body.appendChild(d.current), () => {
    !n && document.body.removeChild(d.current);
  }), [n]), s ? LO(/* @__PURE__ */ E.createElement("div", AT(RT({
    className: o,
    dir: l.dir
  }, i), {
    ref: a
  }), t), d.current) : null;
}
_f.displayName = "@mantine/core/Portal";
var MT = Object.defineProperty, _s = Object.getOwnPropertySymbols, _m = Object.prototype.hasOwnProperty, xm = Object.prototype.propertyIsEnumerable, i7 = (e, r, t) => r in e ? MT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, NT = (e, r) => {
  for (var t in r || (r = {}))
    _m.call(r, t) && i7(e, t, r[t]);
  if (_s)
    for (var t of _s(r))
      xm.call(r, t) && i7(e, t, r[t]);
  return e;
}, TT = (e, r) => {
  var t = {};
  for (var n in e)
    _m.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && _s)
    for (var n of _s(e))
      r.indexOf(n) < 0 && xm.call(e, n) && (t[n] = e[n]);
  return t;
};
function Sa(e) {
  var r = e, { withinPortal: t = !0, children: n } = r, o = TT(r, ["withinPortal", "children"]);
  return t ? /* @__PURE__ */ E.createElement(_f, NT({}, o), n) : /* @__PURE__ */ E.createElement(E.Fragment, null, n);
}
Sa.displayName = "@mantine/core/OptionalPortal";
var DT = Object.defineProperty, jT = Object.defineProperties, LT = Object.getOwnPropertyDescriptors, l7 = Object.getOwnPropertySymbols, zT = Object.prototype.hasOwnProperty, VT = Object.prototype.propertyIsEnumerable, s7 = (e, r, t) => r in e ? DT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ud = (e, r) => {
  for (var t in r || (r = {}))
    zT.call(r, t) && s7(e, t, r[t]);
  if (l7)
    for (var t of l7(r))
      VT.call(r, t) && s7(e, t, r[t]);
  return e;
}, c7 = (e, r) => jT(e, LT(r));
function FT({ variant: e, color: r, theme: t }) {
  if (e === "filled")
    return {
      backgroundColor: t.fn.variant({ variant: "filled", color: r }).background,
      color: t.white
    };
  if (e === "outline") {
    const n = t.fn.variant({ variant: "outline", color: r });
    return {
      color: n.color,
      borderColor: n.border,
      backgroundColor: t.colorScheme === "dark" ? t.colors.dark[6] : t.white
    };
  }
  if (e === "light") {
    const n = t.fn.variant({ variant: "light", color: r });
    return {
      backgroundColor: n.background,
      color: n.color
    };
  }
  return null;
}
var ZT = Ae((e, { radius: r, color: t }, { variant: n }) => ({
  root: ud(c7(ud({}, e.fn.fontStyles()), {
    position: "relative",
    overflow: "hidden",
    paddingTop: e.spacing.sm,
    paddingBottom: e.spacing.sm,
    paddingLeft: e.spacing.md,
    paddingRight: e.spacing.sm,
    borderRadius: e.fn.radius(r),
    border: `${B(1)} solid transparent`
  }), FT({ variant: n, color: t, theme: e })),
  wrapper: {
    display: "flex"
  },
  body: {
    flex: 1
  },
  title: {
    boxSizing: "border-box",
    margin: 0,
    marginBottom: e.spacing.xs,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    lineHeight: e.lineHeight,
    fontSize: e.fontSizes.sm,
    fontWeight: 700,
    "&[data-with-close-button]": {
      paddingRight: e.spacing.md
    }
  },
  label: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  icon: {
    lineHeight: 1,
    width: B(20),
    height: B(20),
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginRight: e.spacing.md,
    marginTop: 1
  },
  message: c7(ud({}, e.fn.fontStyles()), {
    lineHeight: e.lineHeight,
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontSize: e.fontSizes.sm,
    color: n === "filled" ? e.white : e.colorScheme === "dark" ? n === "light" ? e.white : e.colors.dark[0] : e.black
  }),
  closeButton: {
    width: B(10),
    height: B(10),
    color: n === "filled" ? e.white : e.colorScheme === "dark" ? n === "light" ? e.white : e.colors.dark[0] : e.black
  }
})), WT = Object.defineProperty, xs = Object.getOwnPropertySymbols, $m = Object.prototype.hasOwnProperty, Om = Object.prototype.propertyIsEnumerable, u7 = (e, r, t) => r in e ? WT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, d7 = (e, r) => {
  for (var t in r || (r = {}))
    $m.call(r, t) && u7(e, t, r[t]);
  if (xs)
    for (var t of xs(r))
      Om.call(r, t) && u7(e, t, r[t]);
  return e;
}, BT = (e, r) => {
  var t = {};
  for (var n in e)
    $m.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && xs)
    for (var n of xs(e))
      r.indexOf(n) < 0 && Om.call(e, n) && (t[n] = e[n]);
  return t;
};
function Pm(e) {
  const r = e, { width: t, height: n, style: o } = r, a = BT(r, ["width", "height", "style"]);
  return /* @__PURE__ */ E.createElement("svg", d7({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: d7({ width: t, height: n }, o)
  }, a), /* @__PURE__ */ E.createElement("path", {
    d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
Pm.displayName = "@mantine/core/CloseIcon";
var HT = Object.defineProperty, $s = Object.getOwnPropertySymbols, Sm = Object.prototype.hasOwnProperty, Im = Object.prototype.propertyIsEnumerable, f7 = (e, r, t) => r in e ? HT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, GT = (e, r) => {
  for (var t in r || (r = {}))
    Sm.call(r, t) && f7(e, t, r[t]);
  if ($s)
    for (var t of $s(r))
      Im.call(r, t) && f7(e, t, r[t]);
  return e;
}, XT = (e, r) => {
  var t = {};
  for (var n in e)
    Sm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && $s)
    for (var n of $s(e))
      r.indexOf(n) < 0 && Im.call(e, n) && (t[n] = e[n]);
  return t;
};
const YT = {
  xs: B(12),
  sm: B(16),
  md: B(20),
  lg: B(28),
  xl: B(34)
}, UT = {
  size: "sm"
}, Em = ue((e, r) => {
  const t = Oe("CloseButton", UT, e), { iconSize: n, size: o, children: a } = t, i = XT(t, ["iconSize", "size", "children"]), l = B(n || YT[o]);
  return /* @__PURE__ */ E.createElement(p1, GT({
    ref: r,
    __staticSelector: "CloseButton",
    size: o
  }, i), a || /* @__PURE__ */ E.createElement(Pm, {
    width: l,
    height: l
  }));
});
Em.displayName = "@mantine/core/CloseButton";
const Ai = Em;
var JT = Object.defineProperty, Os = Object.getOwnPropertySymbols, Rm = Object.prototype.hasOwnProperty, Am = Object.prototype.propertyIsEnumerable, p7 = (e, r, t) => r in e ? JT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, qT = (e, r) => {
  for (var t in r || (r = {}))
    Rm.call(r, t) && p7(e, t, r[t]);
  if (Os)
    for (var t of Os(r))
      Am.call(r, t) && p7(e, t, r[t]);
  return e;
}, KT = (e, r) => {
  var t = {};
  for (var n in e)
    Rm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Os)
    for (var n of Os(e))
      r.indexOf(n) < 0 && Am.call(e, n) && (t[n] = e[n]);
  return t;
};
const QT = {
  variant: "light"
}, km = ue((e, r) => {
  const t = Oe("Alert", QT, e), {
    id: n,
    className: o,
    title: a,
    variant: i,
    children: l,
    color: s,
    classNames: u,
    icon: d,
    styles: f,
    onClose: p,
    radius: g,
    withCloseButton: h,
    closeButtonLabel: v,
    unstyled: y
  } = t, w = KT(t, [
    "id",
    "className",
    "title",
    "variant",
    "children",
    "color",
    "classNames",
    "icon",
    "styles",
    "onClose",
    "radius",
    "withCloseButton",
    "closeButtonLabel",
    "unstyled"
  ]), { classes: $, cx: C } = ZT({ color: s, radius: g }, { classNames: u, styles: f, unstyled: y, variant: i, name: "Alert" }), x = ke(n), b = a && `${x}-title`, O = `${x}-body`;
  return /* @__PURE__ */ E.createElement(We, qT({
    id: x,
    role: "alert",
    "aria-labelledby": b,
    "aria-describedby": O,
    className: C($.root, $[i], o),
    ref: r
  }, w), /* @__PURE__ */ E.createElement("div", {
    className: $.wrapper
  }, d && /* @__PURE__ */ E.createElement("div", {
    className: $.icon
  }, d), /* @__PURE__ */ E.createElement("div", {
    className: $.body
  }, a && /* @__PURE__ */ E.createElement("div", {
    className: $.title,
    "data-with-close-button": h || void 0
  }, /* @__PURE__ */ E.createElement("span", {
    id: b,
    className: $.label
  }, a)), /* @__PURE__ */ E.createElement("div", {
    id: O,
    className: $.message
  }, l)), h && /* @__PURE__ */ E.createElement(Ai, {
    className: $.closeButton,
    onClick: p,
    variant: "transparent",
    size: 16,
    iconSize: 16,
    "aria-label": v
  })));
});
km.displayName = "@mantine/core/Alert";
var eD = Object.defineProperty, rD = Object.defineProperties, tD = Object.getOwnPropertyDescriptors, g7 = Object.getOwnPropertySymbols, nD = Object.prototype.hasOwnProperty, oD = Object.prototype.propertyIsEnumerable, v7 = (e, r, t) => r in e ? eD(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ol = (e, r) => {
  for (var t in r || (r = {}))
    nD.call(r, t) && v7(e, t, r[t]);
  if (g7)
    for (var t of g7(r))
      oD.call(r, t) && v7(e, t, r[t]);
  return e;
}, aD = (e, r) => rD(e, tD(r));
function iD({
  underline: e,
  strikethrough: r
}) {
  const t = [];
  return e && t.push("underline"), r && t.push("line-through"), t.length > 0 ? t.join(" ") : "none";
}
function lD({ theme: e, color: r }) {
  return r === "dimmed" ? e.fn.dimmed() : typeof r == "string" && (r in e.colors || r.split(".")[0] in e.colors) ? e.fn.variant({ variant: "filled", color: r }).background : r || "inherit";
}
function sD(e) {
  return typeof e == "number" ? {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: e,
    WebkitBoxOrient: "vertical"
  } : null;
}
function cD({ theme: e, truncate: r }) {
  return r === "start" ? {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    direction: e.dir === "ltr" ? "rtl" : "ltr",
    textAlign: e.dir === "ltr" ? "right" : "left"
  } : r ? {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  } : null;
}
var uD = Ae((e, {
  color: r,
  lineClamp: t,
  truncate: n,
  inline: o,
  inherit: a,
  underline: i,
  gradient: l,
  weight: s,
  transform: u,
  align: d,
  strikethrough: f,
  italic: p
}, { size: g }) => {
  const h = e.fn.variant({ variant: "gradient", gradient: l });
  return {
    root: aD(ol(ol(ol(ol({}, e.fn.fontStyles()), e.fn.focusStyles()), sD(t)), cD({ theme: e, truncate: n })), {
      color: lD({ color: r, theme: e }),
      fontFamily: a ? "inherit" : e.fontFamily,
      fontSize: a || g === void 0 ? "inherit" : ve({ size: g, sizes: e.fontSizes }),
      lineHeight: a ? "inherit" : o ? 1 : e.lineHeight,
      textDecoration: iD({ underline: i, strikethrough: f }),
      WebkitTapHighlightColor: "transparent",
      fontWeight: a ? "inherit" : s,
      textTransform: u,
      textAlign: d,
      fontStyle: p ? "italic" : void 0
    }),
    gradient: {
      backgroundImage: h.background,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    }
  };
}), dD = Object.defineProperty, Ps = Object.getOwnPropertySymbols, Mm = Object.prototype.hasOwnProperty, Nm = Object.prototype.propertyIsEnumerable, m7 = (e, r, t) => r in e ? dD(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, fD = (e, r) => {
  for (var t in r || (r = {}))
    Mm.call(r, t) && m7(e, t, r[t]);
  if (Ps)
    for (var t of Ps(r))
      Nm.call(r, t) && m7(e, t, r[t]);
  return e;
}, pD = (e, r) => {
  var t = {};
  for (var n in e)
    Mm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ps)
    for (var n of Ps(e))
      r.indexOf(n) < 0 && Nm.call(e, n) && (t[n] = e[n]);
  return t;
};
const gD = {
  variant: "text"
}, Tm = ue((e, r) => {
  const t = Oe("Text", gD, e), {
    className: n,
    size: o,
    weight: a,
    transform: i,
    color: l,
    align: s,
    variant: u,
    lineClamp: d,
    truncate: f,
    gradient: p,
    inline: g,
    inherit: h,
    underline: v,
    strikethrough: y,
    italic: w,
    classNames: $,
    styles: C,
    unstyled: x,
    span: b,
    __staticSelector: O
  } = t, _ = pD(t, [
    "className",
    "size",
    "weight",
    "transform",
    "color",
    "align",
    "variant",
    "lineClamp",
    "truncate",
    "gradient",
    "inline",
    "inherit",
    "underline",
    "strikethrough",
    "italic",
    "classNames",
    "styles",
    "unstyled",
    "span",
    "__staticSelector"
  ]), { classes: P, cx: S } = uD({
    color: l,
    lineClamp: d,
    truncate: f,
    inline: g,
    inherit: h,
    underline: v,
    strikethrough: y,
    italic: w,
    weight: a,
    transform: i,
    align: s,
    gradient: p
  }, { unstyled: x, name: O || "Text", variant: u, size: o });
  return /* @__PURE__ */ E.createElement(We, fD({
    ref: r,
    className: S(P.root, { [P.gradient]: u === "gradient" }, n),
    component: b ? "span" : "div"
  }, _));
});
Tm.displayName = "@mantine/core/Text";
const Ia = Tm;
var vD = Object.defineProperty, h7 = Object.getOwnPropertySymbols, mD = Object.prototype.hasOwnProperty, hD = Object.prototype.propertyIsEnumerable, b7 = (e, r, t) => r in e ? vD(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, bD = (e, r) => {
  for (var t in r || (r = {}))
    mD.call(r, t) && b7(e, t, r[t]);
  if (h7)
    for (var t of h7(r))
      hD.call(r, t) && b7(e, t, r[t]);
  return e;
};
function yD({ theme: e, color: r }) {
  return r === "dimmed" ? e.fn.dimmed() : e.fn.themeColor(r || e.primaryColor, e.colorScheme === "dark" ? 4 : 7, !1, !0);
}
var CD = Ae((e, { color: r, underline: t }) => ({
  root: bD({
    backgroundColor: "transparent",
    cursor: "pointer",
    padding: 0,
    border: 0,
    color: yD({ theme: e, color: r })
  }, e.fn.hover({ textDecoration: t ? "underline" : "none" }))
})), wD = Object.defineProperty, Ss = Object.getOwnPropertySymbols, Dm = Object.prototype.hasOwnProperty, jm = Object.prototype.propertyIsEnumerable, y7 = (e, r, t) => r in e ? wD(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, C7 = (e, r) => {
  for (var t in r || (r = {}))
    Dm.call(r, t) && y7(e, t, r[t]);
  if (Ss)
    for (var t of Ss(r))
      jm.call(r, t) && y7(e, t, r[t]);
  return e;
}, _D = (e, r) => {
  var t = {};
  for (var n in e)
    Dm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ss)
    for (var n of Ss(e))
      r.indexOf(n) < 0 && jm.call(e, n) && (t[n] = e[n]);
  return t;
};
const xD = {
  underline: !0
}, Lm = ue((e, r) => {
  const t = Oe("Anchor", xD, e), { component: n, className: o, unstyled: a, variant: i, size: l, color: s, underline: u } = t, d = _D(t, ["component", "className", "unstyled", "variant", "size", "color", "underline"]), { classes: f, cx: p } = CD({ color: s, underline: u }, { name: "Anchor", unstyled: a, variant: i, size: l }), g = n === "button" ? { type: "button" } : null;
  return /* @__PURE__ */ E.createElement(Ia, C7(C7({
    component: n || "a",
    ref: r,
    className: p(f.root, o),
    size: l
  }, g), d));
});
Lm.displayName = "@mantine/core/Anchor";
const $D = Lm, OD = xt({
  zIndex: 1e3,
  fixed: !1,
  layout: "default"
}), PD = OD.Provider;
var SD = Object.defineProperty, w7 = Object.getOwnPropertySymbols, ID = Object.prototype.hasOwnProperty, ED = Object.prototype.propertyIsEnumerable, _7 = (e, r, t) => r in e ? SD(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, zm = (e, r) => {
  for (var t in r || (r = {}))
    ID.call(r, t) && _7(e, t, r[t]);
  if (w7)
    for (var t of w7(r))
      ED.call(r, t) && _7(e, t, r[t]);
  return e;
};
function RD(e, r) {
  const t = ve({ size: e.padding, sizes: r.spacing }), n = e.navbarOffsetBreakpoint ? ve({ size: e.navbarOffsetBreakpoint, sizes: r.breakpoints }) : null, o = e.asideOffsetBreakpoint ? ve({ size: e.asideOffsetBreakpoint, sizes: r.breakpoints }) : null;
  if (!e.fixed)
    return { padding: t };
  const a = $t(n), i = $t(o);
  return zm({
    minHeight: "100vh",
    paddingTop: `calc(var(--mantine-header-height, 0px) + ${t})`,
    paddingBottom: `calc(var(--mantine-footer-height, 0px) + ${t})`,
    paddingLeft: `calc(var(--mantine-navbar-width, 0px) + ${t})`,
    paddingRight: `calc(var(--mantine-aside-width, 0px) + ${t})`
  }, a === i ? {
    [`@media (max-width: ${Nt(a - 1)})`]: {
      paddingLeft: t,
      paddingRight: t
    }
  } : {
    [`@media (max-width: ${Nt(a - 1)})`]: {
      paddingLeft: t
    },
    [`@media (max-width: ${Nt(i - 1)})`]: {
      paddingRight: t
    }
  });
}
var AD = Ae((e, r) => ({
  root: {
    boxSizing: "border-box"
  },
  body: {
    display: "flex",
    boxSizing: "border-box"
  },
  main: zm({
    flex: 1,
    width: "100vw",
    boxSizing: "border-box"
  }, RD(r, e))
})), kD = Object.defineProperty, Is = Object.getOwnPropertySymbols, Vm = Object.prototype.hasOwnProperty, Fm = Object.prototype.propertyIsEnumerable, x7 = (e, r, t) => r in e ? kD(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, MD = (e, r) => {
  for (var t in r || (r = {}))
    Vm.call(r, t) && x7(e, t, r[t]);
  if (Is)
    for (var t of Is(r))
      Fm.call(r, t) && x7(e, t, r[t]);
  return e;
}, ND = (e, r) => {
  var t = {};
  for (var n in e)
    Vm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Is)
    for (var n of Is(e))
      r.indexOf(n) < 0 && Fm.call(e, n) && (t[n] = e[n]);
  return t;
};
const TD = {
  fixed: !0,
  padding: "md"
}, DD = ue((e, r) => {
  const t = Oe("AppShell", TD, e), {
    children: n,
    navbar: o,
    header: a,
    footer: i,
    aside: l,
    fixed: s,
    zIndex: u,
    padding: d,
    navbarOffsetBreakpoint: f,
    asideOffsetBreakpoint: p,
    className: g,
    styles: h,
    classNames: v,
    unstyled: y,
    hidden: w,
    layout: $,
    variant: C
  } = t, x = ND(t, [
    "children",
    "navbar",
    "header",
    "footer",
    "aside",
    "fixed",
    "zIndex",
    "padding",
    "navbarOffsetBreakpoint",
    "asideOffsetBreakpoint",
    "className",
    "styles",
    "classNames",
    "unstyled",
    "hidden",
    "layout",
    "variant"
  ]), { classes: b, cx: O } = AD({ padding: d, fixed: s, navbarOffsetBreakpoint: f, asideOffsetBreakpoint: p }, { styles: h, classNames: v, unstyled: y, name: "AppShell", variant: C });
  return w ? /* @__PURE__ */ E.createElement(E.Fragment, null, n) : /* @__PURE__ */ E.createElement(PD, {
    value: { fixed: s, zIndex: u, layout: $ }
  }, /* @__PURE__ */ E.createElement(We, MD({
    className: O(b.root, g),
    ref: r
  }, x), a, /* @__PURE__ */ E.createElement("div", {
    className: b.body
  }, o, /* @__PURE__ */ E.createElement("main", {
    className: b.main
  }, n), l), i));
});
DD.displayName = "@mantine/core/AppShell";
var jD = Object.defineProperty, LD = Object.defineProperties, zD = Object.getOwnPropertyDescriptors, $7 = Object.getOwnPropertySymbols, VD = Object.prototype.hasOwnProperty, FD = Object.prototype.propertyIsEnumerable, O7 = (e, r, t) => r in e ? jD(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ZD = (e, r) => {
  for (var t in r || (r = {}))
    VD.call(r, t) && O7(e, t, r[t]);
  if ($7)
    for (var t of $7(r))
      FD.call(r, t) && O7(e, t, r[t]);
  return e;
}, WD = (e, r) => LD(e, zD(r)), BD = Ae((e, { ratio: r }) => ({
  root: {
    position: "relative",
    maxWidth: "100%",
    "&::before": {
      content: '""',
      height: 0,
      display: "block",
      paddingBottom: `${1 / r * 100}%`
    },
    "&::after": {
      content: '""',
      display: "table",
      clear: "both"
    },
    "& > *:not(style)": WD(ZD({}, e.fn.cover()), {
      overflow: "hidden",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%"
    }),
    "& > img, & > video": {
      objectFit: "cover"
    }
  }
})), HD = Object.defineProperty, Es = Object.getOwnPropertySymbols, Zm = Object.prototype.hasOwnProperty, Wm = Object.prototype.propertyIsEnumerable, P7 = (e, r, t) => r in e ? HD(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, GD = (e, r) => {
  for (var t in r || (r = {}))
    Zm.call(r, t) && P7(e, t, r[t]);
  if (Es)
    for (var t of Es(r))
      Wm.call(r, t) && P7(e, t, r[t]);
  return e;
}, XD = (e, r) => {
  var t = {};
  for (var n in e)
    Zm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Es)
    for (var n of Es(e))
      r.indexOf(n) < 0 && Wm.call(e, n) && (t[n] = e[n]);
  return t;
};
const YD = ue((e, r) => {
  const t = Oe("AspectRatio", {}, e), { className: n, ratio: o, children: a, unstyled: i, variant: l } = t, s = XD(t, ["className", "ratio", "children", "unstyled", "variant"]), { classes: u, cx: d } = BD({ ratio: o }, { name: "AspectRatio", unstyled: i, variant: l });
  return /* @__PURE__ */ E.createElement(We, GD({
    ref: r,
    className: d(u.root, n)
  }, s), a);
});
YD.displayName = "@mantine/core/AspectRatio";
const al = {
  xs: B(1),
  sm: B(2),
  md: B(3),
  lg: B(4),
  xl: B(5)
};
function il(e, r) {
  const t = e.fn.variant({ variant: "outline", color: r }).border;
  return typeof r == "string" && (r in e.colors || r.split(".")[0] in e.colors) ? t : r === void 0 ? e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4] : r;
}
var UD = Ae((e, { color: r }, { size: t, variant: n }) => ({
  root: {},
  withLabel: {
    borderTop: "0 !important"
  },
  left: {
    "&::before": {
      display: "none"
    }
  },
  right: {
    "&::after": {
      display: "none"
    }
  },
  label: {
    display: "flex",
    alignItems: "center",
    "&::before": {
      content: '""',
      flex: 1,
      height: B(1),
      borderTop: `${ve({ size: t, sizes: al })} ${n} ${il(e, r)}`,
      marginRight: e.spacing.xs
    },
    "&::after": {
      content: '""',
      flex: 1,
      borderTop: `${ve({ size: t, sizes: al })} ${n} ${il(e, r)}`,
      marginLeft: e.spacing.xs
    }
  },
  labelDefaultStyles: {
    color: r === "dark" ? e.colors.dark[1] : e.fn.themeColor(r, e.colorScheme === "dark" ? 5 : e.fn.primaryShade(), !1)
  },
  horizontal: {
    border: 0,
    borderTopWidth: B(ve({ size: t, sizes: al })),
    borderTopColor: il(e, r),
    borderTopStyle: n,
    margin: 0
  },
  vertical: {
    border: 0,
    alignSelf: "stretch",
    height: "auto",
    borderLeftWidth: B(ve({ size: t, sizes: al })),
    borderLeftColor: il(e, r),
    borderLeftStyle: n
  }
})), JD = Object.defineProperty, qD = Object.defineProperties, KD = Object.getOwnPropertyDescriptors, Rs = Object.getOwnPropertySymbols, Bm = Object.prototype.hasOwnProperty, Hm = Object.prototype.propertyIsEnumerable, S7 = (e, r, t) => r in e ? JD(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, I7 = (e, r) => {
  for (var t in r || (r = {}))
    Bm.call(r, t) && S7(e, t, r[t]);
  if (Rs)
    for (var t of Rs(r))
      Hm.call(r, t) && S7(e, t, r[t]);
  return e;
}, QD = (e, r) => qD(e, KD(r)), ej = (e, r) => {
  var t = {};
  for (var n in e)
    Bm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Rs)
    for (var n of Rs(e))
      r.indexOf(n) < 0 && Hm.call(e, n) && (t[n] = e[n]);
  return t;
};
const rj = {
  orientation: "horizontal",
  size: "xs",
  labelPosition: "left",
  variant: "solid"
}, y0 = ue((e, r) => {
  const t = Oe("Divider", rj, e), {
    className: n,
    color: o,
    orientation: a,
    size: i,
    label: l,
    labelPosition: s,
    labelProps: u,
    variant: d,
    styles: f,
    classNames: p,
    unstyled: g
  } = t, h = ej(t, [
    "className",
    "color",
    "orientation",
    "size",
    "label",
    "labelPosition",
    "labelProps",
    "variant",
    "styles",
    "classNames",
    "unstyled"
  ]), { classes: v, cx: y } = UD({ color: o }, { classNames: p, styles: f, unstyled: g, name: "Divider", variant: d, size: i }), w = a === "vertical", $ = a === "horizontal", C = !!l && $, x = !(u != null && u.color);
  return /* @__PURE__ */ E.createElement(We, I7({
    ref: r,
    className: y(v.root, {
      [v.vertical]: w,
      [v.horizontal]: $,
      [v.withLabel]: C
    }, n),
    role: "separator"
  }, h), C && /* @__PURE__ */ E.createElement(Ia, QD(I7({}, u), {
    size: (u == null ? void 0 : u.size) || "xs",
    mt: B(2),
    className: y(v.label, v[s], {
      [v.labelDefaultStyles]: x
    })
  }), l));
});
y0.displayName = "@mantine/core/Divider";
var tj = Object.defineProperty, nj = Object.defineProperties, oj = Object.getOwnPropertyDescriptors, E7 = Object.getOwnPropertySymbols, aj = Object.prototype.hasOwnProperty, ij = Object.prototype.propertyIsEnumerable, R7 = (e, r, t) => r in e ? tj(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, A7 = (e, r) => {
  for (var t in r || (r = {}))
    aj.call(r, t) && R7(e, t, r[t]);
  if (E7)
    for (var t of E7(r))
      ij.call(r, t) && R7(e, t, r[t]);
  return e;
}, lj = (e, r) => nj(e, oj(r)), sj = Ae((e, r, { size: t }) => ({
  item: lj(A7({}, e.fn.fontStyles()), {
    boxSizing: "border-box",
    wordBreak: "break-all",
    textAlign: "left",
    width: "100%",
    padding: `calc(${ve({ size: t, sizes: e.spacing })} / 1.5) ${ve({
      size: t,
      sizes: e.spacing
    })}`,
    cursor: "pointer",
    fontSize: ve({ size: t, sizes: e.fontSizes }),
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    borderRadius: e.fn.radius(),
    "&[data-hovered]": {
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[1]
    },
    "&[data-selected]": A7({
      backgroundColor: e.fn.variant({ variant: "filled" }).background,
      color: e.fn.variant({ variant: "filled" }).color
    }, e.fn.hover({ backgroundColor: e.fn.variant({ variant: "filled" }).hover })),
    "&[data-disabled]": {
      cursor: "default",
      color: e.colors.dark[2]
    }
  }),
  nothingFound: {
    boxSizing: "border-box",
    color: e.colors.gray[6],
    paddingTop: `calc(${ve({ size: t, sizes: e.spacing })} / 2)`,
    paddingBottom: `calc(${ve({ size: t, sizes: e.spacing })} / 2)`,
    textAlign: "center"
  },
  separator: {
    boxSizing: "border-box",
    textAlign: "left",
    width: "100%",
    padding: `calc(${ve({ size: t, sizes: e.spacing })} / 1.5) ${ve({
      size: t,
      sizes: e.spacing
    })}`
  },
  separatorLabel: {
    color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[5]
  }
})), cj = Object.defineProperty, k7 = Object.getOwnPropertySymbols, uj = Object.prototype.hasOwnProperty, dj = Object.prototype.propertyIsEnumerable, M7 = (e, r, t) => r in e ? cj(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, fj = (e, r) => {
  for (var t in r || (r = {}))
    uj.call(r, t) && M7(e, t, r[t]);
  if (k7)
    for (var t of k7(r))
      dj.call(r, t) && M7(e, t, r[t]);
  return e;
};
function xf({
  data: e,
  hovered: r,
  classNames: t,
  styles: n,
  isItemSelected: o,
  uuid: a,
  __staticSelector: i,
  onItemHover: l,
  onItemSelect: s,
  itemsRefs: u,
  itemComponent: d,
  size: f,
  nothingFound: p,
  creatable: g,
  createLabel: h,
  unstyled: v,
  variant: y
}) {
  const { classes: w } = sj(null, {
    classNames: t,
    styles: n,
    unstyled: v,
    name: i,
    variant: y,
    size: f
  }), $ = [], C = [];
  let x = null;
  const b = (_, P) => {
    const S = typeof o == "function" ? o(_.value) : !1;
    return /* @__PURE__ */ E.createElement(d, fj({
      key: _.value,
      className: w.item,
      "data-disabled": _.disabled || void 0,
      "data-hovered": !_.disabled && r === P || void 0,
      "data-selected": !_.disabled && S || void 0,
      selected: S,
      onMouseEnter: () => l(P),
      id: `${a}-${P}`,
      role: "option",
      tabIndex: -1,
      "aria-selected": r === P,
      ref: (I) => {
        u && u.current && (u.current[_.value] = I);
      },
      onMouseDown: _.disabled ? null : (I) => {
        I.preventDefault(), s(_);
      },
      disabled: _.disabled,
      variant: y
    }, _));
  };
  let O = null;
  if (e.forEach((_, P) => {
    _.creatable ? x = P : _.group ? (O !== _.group && (O = _.group, C.push(/* @__PURE__ */ E.createElement("div", {
      className: w.separator,
      key: `__mantine-divider-${P}`
    }, /* @__PURE__ */ E.createElement(y0, {
      classNames: { label: w.separatorLabel },
      label: _.group
    })))), C.push(b(_, P))) : $.push(b(_, P));
  }), g) {
    const _ = e[x];
    $.push(/* @__PURE__ */ E.createElement("div", {
      key: B0(),
      className: w.item,
      "data-hovered": r === x || void 0,
      onMouseEnter: () => l(x),
      onMouseDown: (P) => {
        P.preventDefault(), s(_);
      },
      tabIndex: -1,
      ref: (P) => {
        u && u.current && (u.current[_.value] = P);
      }
    }, h));
  }
  return C.length > 0 && $.length > 0 && $.unshift(/* @__PURE__ */ E.createElement("div", {
    className: w.separator,
    key: "empty-group-separator"
  }, /* @__PURE__ */ E.createElement(y0, null))), C.length > 0 || $.length > 0 ? /* @__PURE__ */ E.createElement(E.Fragment, null, C, $) : /* @__PURE__ */ E.createElement(Ia, {
    size: f,
    unstyled: v,
    className: w.nothingFound
  }, p);
}
xf.displayName = "@mantine/core/SelectItems";
var pj = Object.defineProperty, As = Object.getOwnPropertySymbols, Gm = Object.prototype.hasOwnProperty, Xm = Object.prototype.propertyIsEnumerable, N7 = (e, r, t) => r in e ? pj(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, gj = (e, r) => {
  for (var t in r || (r = {}))
    Gm.call(r, t) && N7(e, t, r[t]);
  if (As)
    for (var t of As(r))
      Xm.call(r, t) && N7(e, t, r[t]);
  return e;
}, vj = (e, r) => {
  var t = {};
  for (var n in e)
    Gm.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && As)
    for (var n of As(e))
      r.indexOf(n) < 0 && Xm.call(e, n) && (t[n] = e[n]);
  return t;
};
const $f = ue((e, r) => {
  var t = e, { label: n, value: o } = t, a = vj(t, ["label", "value"]);
  return /* @__PURE__ */ E.createElement("div", gj({
    ref: r
  }, a), n || o);
});
$f.displayName = "@mantine/core/DefaultItem";
function mj(e, r) {
  typeof e == "function" ? e(r) : e != null && (e.current = r);
}
function Ym(...e) {
  return (r) => e.forEach(
    (t) => mj(t, r)
  );
}
function Do(...e) {
  return $e(Ym(...e), e);
}
const Um = /* @__PURE__ */ ue((e, r) => {
  const { children: t, ...n } = e, o = Gr.toArray(t), a = o.find(bj);
  if (a) {
    const i = a.props.children, l = o.map((s) => s === a ? Gr.count(i) > 1 ? Gr.only(null) : /* @__PURE__ */ Xn(i) ? i.props.children : null : s);
    return /* @__PURE__ */ sr(C0, F({}, n, {
      ref: r
    }), /* @__PURE__ */ Xn(i) ? /* @__PURE__ */ Wr(i, void 0, l) : null);
  }
  return /* @__PURE__ */ sr(C0, F({}, n, {
    ref: r
  }), t);
});
Um.displayName = "Slot";
const C0 = /* @__PURE__ */ ue((e, r) => {
  const { children: t, ...n } = e;
  return /* @__PURE__ */ Xn(t) ? /* @__PURE__ */ Wr(t, {
    ...yj(n, t.props),
    ref: Ym(r, t.ref)
  }) : Gr.count(t) > 1 ? Gr.only(null) : null;
});
C0.displayName = "SlotClone";
const hj = ({ children: e }) => /* @__PURE__ */ sr(ca, null, e);
function bj(e) {
  return /* @__PURE__ */ Xn(e) && e.type === hj;
}
function yj(e, r) {
  const t = {
    ...r
  };
  for (const n in r) {
    const o = e[n], a = r[n];
    /^on[A-Z]/.test(n) ? o && a ? t[n] = (...l) => {
      a(...l), o(...l);
    } : o && (t[n] = o) : n === "style" ? t[n] = {
      ...o,
      ...a
    } : n === "className" && (t[n] = [
      o,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...t
  };
}
const Cj = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ki = Cj.reduce((e, r) => {
  const t = /* @__PURE__ */ ue((n, o) => {
    const { asChild: a, ...i } = n, l = a ? Um : r;
    return Fe(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ sr(l, F({}, i, {
      ref: o
    }));
  });
  return t.displayName = `Primitive.${r}`, {
    ...e,
    [r]: t
  };
}, {}), w0 = globalThis != null && globalThis.document ? qn : () => {
};
function wj(e, r) {
  return _i((t, n) => {
    const o = r[t][n];
    return o != null ? o : t;
  }, e);
}
const Mi = (e) => {
  const { present: r, children: t } = e, n = _j(r), o = typeof t == "function" ? t({
    present: n.isPresent
  }) : Gr.only(t), a = Do(n.ref, o.ref);
  return typeof t == "function" || n.isPresent ? /* @__PURE__ */ Wr(o, {
    ref: a
  }) : null;
};
Mi.displayName = "Presence";
function _j(e) {
  const [r, t] = Se(), n = Ve({}), o = Ve(e), a = Ve("none"), i = e ? "mounted" : "unmounted", [l, s] = wj(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Fe(() => {
    const u = ll(n.current);
    a.current = l === "mounted" ? u : "none";
  }, [
    l
  ]), w0(() => {
    const u = n.current, d = o.current;
    if (d !== e) {
      const p = a.current, g = ll(u);
      e ? s("MOUNT") : g === "none" || (u == null ? void 0 : u.display) === "none" ? s("UNMOUNT") : s(d && p !== g ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    s
  ]), w0(() => {
    if (r) {
      const u = (f) => {
        const g = ll(n.current).includes(f.animationName);
        f.target === r && g && e8(
          () => s("ANIMATION_END")
        );
      }, d = (f) => {
        f.target === r && (a.current = ll(n.current));
      };
      return r.addEventListener("animationstart", d), r.addEventListener("animationcancel", u), r.addEventListener("animationend", u), () => {
        r.removeEventListener("animationstart", d), r.removeEventListener("animationcancel", u), r.removeEventListener("animationend", u);
      };
    } else
      s("ANIMATION_END");
  }, [
    r,
    s
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(l),
    ref: $e((u) => {
      u && (n.current = getComputedStyle(u)), t(u);
    }, [])
  };
}
function ll(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function xj(e, r = []) {
  let t = [];
  function n(a, i) {
    const l = /* @__PURE__ */ xt(i), s = t.length;
    t = [
      ...t,
      i
    ];
    function u(f) {
      const { scope: p, children: g, ...h } = f, v = (p == null ? void 0 : p[e][s]) || l, y = Je(
        () => h,
        Object.values(h)
      );
      return /* @__PURE__ */ sr(v.Provider, {
        value: y
      }, g);
    }
    function d(f, p) {
      const g = (p == null ? void 0 : p[e][s]) || l, h = dt(g);
      if (h)
        return h;
      if (i !== void 0)
        return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return u.displayName = a + "Provider", [
      u,
      d
    ];
  }
  const o = () => {
    const a = t.map((i) => /* @__PURE__ */ xt(i));
    return function(l) {
      const s = (l == null ? void 0 : l[e]) || a;
      return Je(
        () => ({
          [`__scope${e}`]: {
            ...l,
            [e]: s
          }
        }),
        [
          l,
          s
        ]
      );
    };
  };
  return o.scopeName = e, [
    n,
    $j(o, ...r)
  ];
}
function $j(...e) {
  const r = e[0];
  if (e.length === 1)
    return r;
  const t = () => {
    const n = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(a) {
      const i = n.reduce((l, { useScope: s, scopeName: u }) => {
        const f = s(a)[`__scope${u}`];
        return {
          ...l,
          ...f
        };
      }, {});
      return Je(
        () => ({
          [`__scope${r.scopeName}`]: i
        }),
        [
          i
        ]
      );
    };
  };
  return t.scopeName = r.scopeName, t;
}
function wo(e) {
  const r = Ve(e);
  return Fe(() => {
    r.current = e;
  }), Je(
    () => (...t) => {
      var n;
      return (n = r.current) === null || n === void 0 ? void 0 : n.call(r, ...t);
    },
    []
  );
}
const Oj = /* @__PURE__ */ xt(void 0);
function Pj(e) {
  const r = dt(Oj);
  return e || r || "ltr";
}
function Sj(e, [r, t]) {
  return Math.min(t, Math.max(r, e));
}
function Oo(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), t === !1 || !o.defaultPrevented)
      return r == null ? void 0 : r(o);
  };
}
function Ij(e, r) {
  return _i((t, n) => {
    const o = r[t][n];
    return o != null ? o : t;
  }, e);
}
const Jm = "ScrollArea", [qm, m5e] = xj(Jm), [Ej, Zt] = qm(Jm), Rj = /* @__PURE__ */ ue((e, r) => {
  const { __scopeScrollArea: t, type: n = "hover", dir: o, scrollHideDelay: a = 600, ...i } = e, [l, s] = Se(null), [u, d] = Se(null), [f, p] = Se(null), [g, h] = Se(null), [v, y] = Se(null), [w, $] = Se(0), [C, x] = Se(0), [b, O] = Se(!1), [_, P] = Se(!1), S = Do(
    r,
    (N) => s(N)
  ), I = Pj(o);
  return /* @__PURE__ */ sr(Ej, {
    scope: t,
    type: n,
    dir: I,
    scrollHideDelay: a,
    scrollArea: l,
    viewport: u,
    onViewportChange: d,
    content: f,
    onContentChange: p,
    scrollbarX: g,
    onScrollbarXChange: h,
    scrollbarXEnabled: b,
    onScrollbarXEnabledChange: O,
    scrollbarY: v,
    onScrollbarYChange: y,
    scrollbarYEnabled: _,
    onScrollbarYEnabledChange: P,
    onCornerWidthChange: $,
    onCornerHeightChange: x
  }, /* @__PURE__ */ sr(ki.div, F({
    dir: I
  }, i, {
    ref: S,
    style: {
      position: "relative",
      // Pass corner sizes as CSS vars to reduce re-renders of context consumers
      "--radix-scroll-area-corner-width": w + "px",
      "--radix-scroll-area-corner-height": C + "px",
      ...e.style
    }
  })));
}), Aj = "ScrollAreaViewport", kj = /* @__PURE__ */ ue((e, r) => {
  const { __scopeScrollArea: t, children: n, ...o } = e, a = Zt(Aj, t), i = Ve(null), l = Do(r, i, a.onViewportChange);
  return /* @__PURE__ */ sr(ca, null, /* @__PURE__ */ sr("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ sr(ki.div, F({
    "data-radix-scroll-area-viewport": ""
  }, o, {
    ref: l,
    style: {
      /**
      * We don't support `visible` because the intention is to have at least one scrollbar
      * if this component is used and `visible` will behave like `auto` in that case
      * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
      *
      * We don't handle `auto` because the intention is for the native implementation
      * to be hidden if using this component. We just want to ensure the node is scrollable
      * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
      * the browser from having to work out whether to render native scrollbars or not,
      * we tell it to with the intention of hiding them in CSS.
      */
      overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
      ...e.style
    }
  }), /* @__PURE__ */ sr("div", {
    ref: a.onContentChange,
    style: {
      minWidth: "100%",
      display: "table"
    }
  }, n)));
}), Rn = "ScrollAreaScrollbar", Mj = /* @__PURE__ */ ue((e, r) => {
  const { forceMount: t, ...n } = e, o = Zt(Rn, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: i } = o, l = e.orientation === "horizontal";
  return Fe(() => (l ? a(!0) : i(!0), () => {
    l ? a(!1) : i(!1);
  }), [
    l,
    a,
    i
  ]), o.type === "hover" ? /* @__PURE__ */ sr(Nj, F({}, n, {
    ref: r,
    forceMount: t
  })) : o.type === "scroll" ? /* @__PURE__ */ sr(Tj, F({}, n, {
    ref: r,
    forceMount: t
  })) : o.type === "auto" ? /* @__PURE__ */ sr(Km, F({}, n, {
    ref: r,
    forceMount: t
  })) : o.type === "always" ? /* @__PURE__ */ sr(Of, F({}, n, {
    ref: r
  })) : null;
}), Nj = /* @__PURE__ */ ue((e, r) => {
  const { forceMount: t, ...n } = e, o = Zt(Rn, e.__scopeScrollArea), [a, i] = Se(!1);
  return Fe(() => {
    const l = o.scrollArea;
    let s = 0;
    if (l) {
      const u = () => {
        window.clearTimeout(s), i(!0);
      }, d = () => {
        s = window.setTimeout(
          () => i(!1),
          o.scrollHideDelay
        );
      };
      return l.addEventListener("pointerenter", u), l.addEventListener("pointerleave", d), () => {
        window.clearTimeout(s), l.removeEventListener("pointerenter", u), l.removeEventListener("pointerleave", d);
      };
    }
  }, [
    o.scrollArea,
    o.scrollHideDelay
  ]), /* @__PURE__ */ sr(Mi, {
    present: t || a
  }, /* @__PURE__ */ sr(Km, F({
    "data-state": a ? "visible" : "hidden"
  }, n, {
    ref: r
  })));
}), Tj = /* @__PURE__ */ ue((e, r) => {
  const { forceMount: t, ...n } = e, o = Zt(Rn, e.__scopeScrollArea), a = e.orientation === "horizontal", i = v1(
    () => s("SCROLL_END"),
    100
  ), [l, s] = Ij("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return Fe(() => {
    if (l === "idle") {
      const u = window.setTimeout(
        () => s("HIDE"),
        o.scrollHideDelay
      );
      return () => window.clearTimeout(u);
    }
  }, [
    l,
    o.scrollHideDelay,
    s
  ]), Fe(() => {
    const u = o.viewport, d = a ? "scrollLeft" : "scrollTop";
    if (u) {
      let f = u[d];
      const p = () => {
        const g = u[d];
        f !== g && (s("SCROLL"), i()), f = g;
      };
      return u.addEventListener("scroll", p), () => u.removeEventListener("scroll", p);
    }
  }, [
    o.viewport,
    a,
    s,
    i
  ]), /* @__PURE__ */ sr(Mi, {
    present: t || l !== "hidden"
  }, /* @__PURE__ */ sr(Of, F({
    "data-state": l === "hidden" ? "hidden" : "visible"
  }, n, {
    ref: r,
    onPointerEnter: Oo(
      e.onPointerEnter,
      () => s("POINTER_ENTER")
    ),
    onPointerLeave: Oo(
      e.onPointerLeave,
      () => s("POINTER_LEAVE")
    )
  })));
}), Km = /* @__PURE__ */ ue((e, r) => {
  const t = Zt(Rn, e.__scopeScrollArea), { forceMount: n, ...o } = e, [a, i] = Se(!1), l = e.orientation === "horizontal", s = v1(() => {
    if (t.viewport) {
      const u = t.viewport.offsetWidth < t.viewport.scrollWidth, d = t.viewport.offsetHeight < t.viewport.scrollHeight;
      i(l ? u : d);
    }
  }, 10);
  return fa(t.viewport, s), fa(t.content, s), /* @__PURE__ */ sr(Mi, {
    present: n || a
  }, /* @__PURE__ */ sr(Of, F({
    "data-state": a ? "visible" : "hidden"
  }, o, {
    ref: r
  })));
}), Of = /* @__PURE__ */ ue((e, r) => {
  const { orientation: t = "vertical", ...n } = e, o = Zt(Rn, e.__scopeScrollArea), a = Ve(null), i = Ve(0), [l, s] = Se({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  }), u = th(l.viewport, l.content), d = {
    ...n,
    sizes: l,
    onSizesChange: s,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (p) => a.current = p,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (p) => i.current = p
  };
  function f(p, g) {
    return Wj(p, i.current, l, g);
  }
  return t === "horizontal" ? /* @__PURE__ */ sr(Dj, F({}, d, {
    ref: r,
    onThumbPositionChange: () => {
      if (o.viewport && a.current) {
        const p = o.viewport.scrollLeft, g = T7(p, l, o.dir);
        a.current.style.transform = `translate3d(${g}px, 0, 0)`;
      }
    },
    onWheelScroll: (p) => {
      o.viewport && (o.viewport.scrollLeft = p);
    },
    onDragScroll: (p) => {
      o.viewport && (o.viewport.scrollLeft = f(p, o.dir));
    }
  })) : t === "vertical" ? /* @__PURE__ */ sr(jj, F({}, d, {
    ref: r,
    onThumbPositionChange: () => {
      if (o.viewport && a.current) {
        const p = o.viewport.scrollTop, g = T7(p, l);
        a.current.style.transform = `translate3d(0, ${g}px, 0)`;
      }
    },
    onWheelScroll: (p) => {
      o.viewport && (o.viewport.scrollTop = p);
    },
    onDragScroll: (p) => {
      o.viewport && (o.viewport.scrollTop = f(p));
    }
  })) : null;
}), Dj = /* @__PURE__ */ ue((e, r) => {
  const { sizes: t, onSizesChange: n, ...o } = e, a = Zt(Rn, e.__scopeScrollArea), [i, l] = Se(), s = Ve(null), u = Do(r, s, a.onScrollbarXChange);
  return Fe(() => {
    s.current && l(getComputedStyle(s.current));
  }, [
    s
  ]), /* @__PURE__ */ sr(eh, F({
    "data-orientation": "horizontal"
  }, o, {
    ref: u,
    sizes: t,
    style: {
      bottom: 0,
      left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
      right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
      "--radix-scroll-area-thumb-width": g1(t) + "px",
      ...e.style
    },
    onThumbPointerDown: (d) => e.onThumbPointerDown(d.x),
    onDragScroll: (d) => e.onDragScroll(d.x),
    onWheelScroll: (d, f) => {
      if (a.viewport) {
        const p = a.viewport.scrollLeft + d.deltaX;
        e.onWheelScroll(p), oh(p, f) && d.preventDefault();
      }
    },
    onResize: () => {
      s.current && a.viewport && i && n({
        content: a.viewport.scrollWidth,
        viewport: a.viewport.offsetWidth,
        scrollbar: {
          size: s.current.clientWidth,
          paddingStart: ks(i.paddingLeft),
          paddingEnd: ks(i.paddingRight)
        }
      });
    }
  }));
}), jj = /* @__PURE__ */ ue((e, r) => {
  const { sizes: t, onSizesChange: n, ...o } = e, a = Zt(Rn, e.__scopeScrollArea), [i, l] = Se(), s = Ve(null), u = Do(r, s, a.onScrollbarYChange);
  return Fe(() => {
    s.current && l(getComputedStyle(s.current));
  }, [
    s
  ]), /* @__PURE__ */ sr(eh, F({
    "data-orientation": "vertical"
  }, o, {
    ref: u,
    sizes: t,
    style: {
      top: 0,
      right: a.dir === "ltr" ? 0 : void 0,
      left: a.dir === "rtl" ? 0 : void 0,
      bottom: "var(--radix-scroll-area-corner-height)",
      "--radix-scroll-area-thumb-height": g1(t) + "px",
      ...e.style
    },
    onThumbPointerDown: (d) => e.onThumbPointerDown(d.y),
    onDragScroll: (d) => e.onDragScroll(d.y),
    onWheelScroll: (d, f) => {
      if (a.viewport) {
        const p = a.viewport.scrollTop + d.deltaY;
        e.onWheelScroll(p), oh(p, f) && d.preventDefault();
      }
    },
    onResize: () => {
      s.current && a.viewport && i && n({
        content: a.viewport.scrollHeight,
        viewport: a.viewport.offsetHeight,
        scrollbar: {
          size: s.current.clientHeight,
          paddingStart: ks(i.paddingTop),
          paddingEnd: ks(i.paddingBottom)
        }
      });
    }
  }));
}), [Lj, Qm] = qm(Rn), eh = /* @__PURE__ */ ue((e, r) => {
  const { __scopeScrollArea: t, sizes: n, hasThumb: o, onThumbChange: a, onThumbPointerUp: i, onThumbPointerDown: l, onThumbPositionChange: s, onDragScroll: u, onWheelScroll: d, onResize: f, ...p } = e, g = Zt(Rn, t), [h, v] = Se(null), y = Do(
    r,
    (S) => v(S)
  ), w = Ve(null), $ = Ve(""), C = g.viewport, x = n.content - n.viewport, b = wo(d), O = wo(s), _ = v1(f, 10);
  function P(S) {
    if (w.current) {
      const I = S.clientX - w.current.left, N = S.clientY - w.current.top;
      u({
        x: I,
        y: N
      });
    }
  }
  return Fe(() => {
    const S = (I) => {
      const N = I.target;
      (h == null ? void 0 : h.contains(N)) && b(I, x);
    };
    return document.addEventListener("wheel", S, {
      passive: !1
    }), () => document.removeEventListener("wheel", S, {
      passive: !1
    });
  }, [
    C,
    h,
    x,
    b
  ]), Fe(O, [
    n,
    O
  ]), fa(h, _), fa(g.content, _), /* @__PURE__ */ sr(Lj, {
    scope: t,
    scrollbar: h,
    hasThumb: o,
    onThumbChange: wo(a),
    onThumbPointerUp: wo(i),
    onThumbPositionChange: O,
    onThumbPointerDown: wo(l)
  }, /* @__PURE__ */ sr(ki.div, F({}, p, {
    ref: y,
    style: {
      position: "absolute",
      ...p.style
    },
    onPointerDown: Oo(e.onPointerDown, (S) => {
      S.button === 0 && (S.target.setPointerCapture(S.pointerId), w.current = h.getBoundingClientRect(), $.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", P(S));
    }),
    onPointerMove: Oo(e.onPointerMove, P),
    onPointerUp: Oo(e.onPointerUp, (S) => {
      const I = S.target;
      I.hasPointerCapture(S.pointerId) && I.releasePointerCapture(S.pointerId), document.body.style.webkitUserSelect = $.current, w.current = null;
    })
  })));
}), _0 = "ScrollAreaThumb", zj = /* @__PURE__ */ ue((e, r) => {
  const { forceMount: t, ...n } = e, o = Qm(_0, e.__scopeScrollArea);
  return /* @__PURE__ */ sr(Mi, {
    present: t || o.hasThumb
  }, /* @__PURE__ */ sr(Vj, F({
    ref: r
  }, n)));
}), Vj = /* @__PURE__ */ ue((e, r) => {
  const { __scopeScrollArea: t, style: n, ...o } = e, a = Zt(_0, t), i = Qm(_0, t), { onThumbPositionChange: l } = i, s = Do(
    r,
    (f) => i.onThumbChange(f)
  ), u = Ve(), d = v1(() => {
    u.current && (u.current(), u.current = void 0);
  }, 100);
  return Fe(() => {
    const f = a.viewport;
    if (f) {
      const p = () => {
        if (d(), !u.current) {
          const g = Bj(f, l);
          u.current = g, l();
        }
      };
      return l(), f.addEventListener("scroll", p), () => f.removeEventListener("scroll", p);
    }
  }, [
    a.viewport,
    d,
    l
  ]), /* @__PURE__ */ sr(ki.div, F({
    "data-state": i.hasThumb ? "visible" : "hidden"
  }, o, {
    ref: s,
    style: {
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)",
      ...n
    },
    onPointerDownCapture: Oo(e.onPointerDownCapture, (f) => {
      const g = f.target.getBoundingClientRect(), h = f.clientX - g.left, v = f.clientY - g.top;
      i.onThumbPointerDown({
        x: h,
        y: v
      });
    }),
    onPointerUp: Oo(e.onPointerUp, i.onThumbPointerUp)
  }));
}), rh = "ScrollAreaCorner", Fj = /* @__PURE__ */ ue((e, r) => {
  const t = Zt(rh, e.__scopeScrollArea), n = !!(t.scrollbarX && t.scrollbarY);
  return t.type !== "scroll" && n ? /* @__PURE__ */ sr(Zj, F({}, e, {
    ref: r
  })) : null;
}), Zj = /* @__PURE__ */ ue((e, r) => {
  const { __scopeScrollArea: t, ...n } = e, o = Zt(rh, t), [a, i] = Se(0), [l, s] = Se(0), u = !!(a && l);
  return fa(o.scrollbarX, () => {
    var d;
    const f = ((d = o.scrollbarX) === null || d === void 0 ? void 0 : d.offsetHeight) || 0;
    o.onCornerHeightChange(f), s(f);
  }), fa(o.scrollbarY, () => {
    var d;
    const f = ((d = o.scrollbarY) === null || d === void 0 ? void 0 : d.offsetWidth) || 0;
    o.onCornerWidthChange(f), i(f);
  }), u ? /* @__PURE__ */ sr(ki.div, F({}, n, {
    ref: r,
    style: {
      width: a,
      height: l,
      position: "absolute",
      right: o.dir === "ltr" ? 0 : void 0,
      left: o.dir === "rtl" ? 0 : void 0,
      bottom: 0,
      ...e.style
    }
  })) : null;
});
function ks(e) {
  return e ? parseInt(e, 10) : 0;
}
function th(e, r) {
  const t = e / r;
  return isNaN(t) ? 0 : t;
}
function g1(e) {
  const r = th(e.viewport, e.content), t = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, n = (e.scrollbar.size - t) * r;
  return Math.max(n, 18);
}
function Wj(e, r, t, n = "ltr") {
  const o = g1(t), a = o / 2, i = r || a, l = o - i, s = t.scrollbar.paddingStart + i, u = t.scrollbar.size - t.scrollbar.paddingEnd - l, d = t.content - t.viewport, f = n === "ltr" ? [
    0,
    d
  ] : [
    d * -1,
    0
  ];
  return nh([
    s,
    u
  ], f)(e);
}
function T7(e, r, t = "ltr") {
  const n = g1(r), o = r.scrollbar.paddingStart + r.scrollbar.paddingEnd, a = r.scrollbar.size - o, i = r.content - r.viewport, l = a - n, s = t === "ltr" ? [
    0,
    i
  ] : [
    i * -1,
    0
  ], u = Sj(e, s);
  return nh([
    0,
    i
  ], [
    0,
    l
  ])(u);
}
function nh(e, r) {
  return (t) => {
    if (e[0] === e[1] || r[0] === r[1])
      return r[0];
    const n = (r[1] - r[0]) / (e[1] - e[0]);
    return r[0] + n * (t - e[0]);
  };
}
function oh(e, r) {
  return e > 0 && e < r;
}
const Bj = (e, r = () => {
}) => {
  let t = {
    left: e.scrollLeft,
    top: e.scrollTop
  }, n = 0;
  return function o() {
    const a = {
      left: e.scrollLeft,
      top: e.scrollTop
    }, i = t.left !== a.left, l = t.top !== a.top;
    (i || l) && r(), t = a, n = window.requestAnimationFrame(o);
  }(), () => window.cancelAnimationFrame(n);
};
function v1(e, r) {
  const t = wo(e), n = Ve(0);
  return Fe(
    () => () => window.clearTimeout(n.current),
    []
  ), $e(() => {
    window.clearTimeout(n.current), n.current = window.setTimeout(t, r);
  }, [
    t,
    r
  ]);
}
function fa(e, r) {
  const t = wo(r);
  w0(() => {
    let n = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(n), n = window.requestAnimationFrame(t);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(n), o.unobserve(e);
      };
    }
  }, [
    e,
    t
  ]);
}
const Hj = Rj, Gj = kj, D7 = Mj, j7 = zj, Xj = Fj;
var Yj = Ae((e, { scrollbarSize: r, offsetScrollbars: t, scrollbarHovered: n, hidden: o }) => ({
  root: {
    overflow: "hidden"
  },
  viewport: {
    width: "100%",
    height: "100%",
    paddingRight: t ? B(r) : void 0,
    paddingBottom: t ? B(r) : void 0
  },
  scrollbar: {
    display: o ? "none" : "flex",
    userSelect: "none",
    touchAction: "none",
    boxSizing: "border-box",
    padding: `calc(${B(r)}  / 5)`,
    transition: "background-color 150ms ease, opacity 150ms ease",
    "&:hover": {
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[8] : e.colors.gray[0],
      [`& .${Yt("thumb")}`]: {
        backgroundColor: e.colorScheme === "dark" ? e.fn.rgba(e.white, 0.5) : e.fn.rgba(e.black, 0.5)
      }
    },
    '&[data-orientation="vertical"]': {
      width: B(r)
    },
    '&[data-orientation="horizontal"]': {
      flexDirection: "column",
      height: B(r)
    },
    '&[data-state="hidden"]': {
      display: "none",
      opacity: 0
    }
  },
  thumb: {
    ref: Yt("thumb"),
    flex: 1,
    backgroundColor: e.colorScheme === "dark" ? e.fn.rgba(e.white, 0.4) : e.fn.rgba(e.black, 0.4),
    borderRadius: B(r),
    position: "relative",
    transition: "background-color 150ms ease",
    display: o ? "none" : void 0,
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      height: "100%",
      minWidth: B(44),
      minHeight: B(44)
    }
  },
  corner: {
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0],
    transition: "opacity 150ms ease",
    opacity: n ? 1 : 0,
    display: o ? "none" : void 0
  }
})), Uj = Object.defineProperty, Jj = Object.defineProperties, qj = Object.getOwnPropertyDescriptors, Ms = Object.getOwnPropertySymbols, ah = Object.prototype.hasOwnProperty, ih = Object.prototype.propertyIsEnumerable, L7 = (e, r, t) => r in e ? Uj(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, x0 = (e, r) => {
  for (var t in r || (r = {}))
    ah.call(r, t) && L7(e, t, r[t]);
  if (Ms)
    for (var t of Ms(r))
      ih.call(r, t) && L7(e, t, r[t]);
  return e;
}, lh = (e, r) => Jj(e, qj(r)), sh = (e, r) => {
  var t = {};
  for (var n in e)
    ah.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ms)
    for (var n of Ms(e))
      r.indexOf(n) < 0 && ih.call(e, n) && (t[n] = e[n]);
  return t;
};
const ch = {
  scrollbarSize: 12,
  scrollHideDelay: 1e3,
  type: "hover",
  offsetScrollbars: !1
}, m1 = ue((e, r) => {
  const t = Oe("ScrollArea", ch, e), {
    children: n,
    className: o,
    classNames: a,
    styles: i,
    scrollbarSize: l,
    scrollHideDelay: s,
    type: u,
    dir: d,
    offsetScrollbars: f,
    viewportRef: p,
    onScrollPositionChange: g,
    unstyled: h,
    variant: v,
    viewportProps: y
  } = t, w = sh(t, [
    "children",
    "className",
    "classNames",
    "styles",
    "scrollbarSize",
    "scrollHideDelay",
    "type",
    "dir",
    "offsetScrollbars",
    "viewportRef",
    "onScrollPositionChange",
    "unstyled",
    "variant",
    "viewportProps"
  ]), [$, C] = Se(!1), x = ft(), { classes: b, cx: O } = Yj({ scrollbarSize: l, offsetScrollbars: f, scrollbarHovered: $, hidden: u === "never" }, { name: "ScrollArea", classNames: a, styles: i, unstyled: h, variant: v });
  return /* @__PURE__ */ E.createElement(Hj, {
    type: u === "never" ? "always" : u,
    scrollHideDelay: s,
    dir: d || x.dir,
    ref: r,
    asChild: !0
  }, /* @__PURE__ */ E.createElement(We, x0({
    className: O(b.root, o)
  }, w), /* @__PURE__ */ E.createElement(Gj, lh(x0({}, y), {
    className: b.viewport,
    ref: p,
    onScroll: typeof g == "function" ? ({ currentTarget: _ }) => g({
      x: _.scrollLeft,
      y: _.scrollTop
    }) : void 0
  }), n), /* @__PURE__ */ E.createElement(D7, {
    orientation: "horizontal",
    className: b.scrollbar,
    forceMount: !0,
    onMouseEnter: () => C(!0),
    onMouseLeave: () => C(!1)
  }, /* @__PURE__ */ E.createElement(j7, {
    className: b.thumb
  })), /* @__PURE__ */ E.createElement(D7, {
    orientation: "vertical",
    className: b.scrollbar,
    forceMount: !0,
    onMouseEnter: () => C(!0),
    onMouseLeave: () => C(!1)
  }, /* @__PURE__ */ E.createElement(j7, {
    className: b.thumb
  })), /* @__PURE__ */ E.createElement(Xj, {
    className: b.corner
  })));
}), uh = ue((e, r) => {
  const t = Oe("ScrollAreaAutosize", ch, e), {
    children: n,
    classNames: o,
    styles: a,
    scrollbarSize: i,
    scrollHideDelay: l,
    type: s,
    dir: u,
    offsetScrollbars: d,
    viewportRef: f,
    onScrollPositionChange: p,
    unstyled: g,
    sx: h,
    variant: v,
    viewportProps: y
  } = t, w = sh(t, [
    "children",
    "classNames",
    "styles",
    "scrollbarSize",
    "scrollHideDelay",
    "type",
    "dir",
    "offsetScrollbars",
    "viewportRef",
    "onScrollPositionChange",
    "unstyled",
    "sx",
    "variant",
    "viewportProps"
  ]);
  return /* @__PURE__ */ E.createElement(We, lh(x0({}, w), {
    ref: r,
    sx: [{ display: "flex" }, ...f1(h)]
  }), /* @__PURE__ */ E.createElement(We, {
    sx: { display: "flex", flexDirection: "column", flex: 1 }
  }, /* @__PURE__ */ E.createElement(m1, {
    classNames: o,
    styles: a,
    scrollHideDelay: l,
    scrollbarSize: i,
    type: s,
    dir: u,
    offsetScrollbars: d,
    viewportRef: f,
    onScrollPositionChange: p,
    unstyled: g,
    variant: v,
    viewportProps: y
  }, n)));
});
uh.displayName = "@mantine/core/ScrollAreaAutosize";
m1.displayName = "@mantine/core/ScrollArea";
m1.Autosize = uh;
const dh = m1;
var Kj = Object.defineProperty, Qj = Object.defineProperties, eL = Object.getOwnPropertyDescriptors, Ns = Object.getOwnPropertySymbols, fh = Object.prototype.hasOwnProperty, ph = Object.prototype.propertyIsEnumerable, z7 = (e, r, t) => r in e ? Kj(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, V7 = (e, r) => {
  for (var t in r || (r = {}))
    fh.call(r, t) && z7(e, t, r[t]);
  if (Ns)
    for (var t of Ns(r))
      ph.call(r, t) && z7(e, t, r[t]);
  return e;
}, rL = (e, r) => Qj(e, eL(r)), tL = (e, r) => {
  var t = {};
  for (var n in e)
    fh.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ns)
    for (var n of Ns(e))
      r.indexOf(n) < 0 && ph.call(e, n) && (t[n] = e[n]);
  return t;
};
const h1 = ue((e, r) => {
  var t = e, { style: n } = t, o = tL(t, ["style"]);
  return /* @__PURE__ */ E.createElement(dh, rL(V7({}, o), {
    style: V7({ width: "100%" }, n),
    viewportProps: { tabIndex: -1 },
    viewportRef: r
  }), o.children);
});
h1.displayName = "@mantine/core/SelectScrollArea";
var nL = Ae(() => ({
  dropdown: {},
  itemsWrapper: {
    padding: B(4),
    display: "flex",
    width: "100%",
    boxSizing: "border-box"
  }
}));
const Ut = Math.min, Qr = Math.max, Ts = Math.round, sl = Math.floor, Un = (e) => ({
  x: e,
  y: e
}), oL = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, aL = {
  start: "end",
  end: "start"
};
function $0(e, r, t) {
  return Qr(e, Ut(r, t));
}
function On(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function Jt(e) {
  return e.split("-")[0];
}
function Ea(e) {
  return e.split("-")[1];
}
function Pf(e) {
  return e === "x" ? "y" : "x";
}
function Sf(e) {
  return e === "y" ? "height" : "width";
}
function jo(e) {
  return ["top", "bottom"].includes(Jt(e)) ? "y" : "x";
}
function If(e) {
  return Pf(jo(e));
}
function iL(e, r, t) {
  t === void 0 && (t = !1);
  const n = Ea(e), o = If(e), a = Sf(o);
  let i = o === "x" ? n === (t ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return r.reference[a] > r.floating[a] && (i = Ds(i)), [i, Ds(i)];
}
function lL(e) {
  const r = Ds(e);
  return [O0(e), r, O0(r)];
}
function O0(e) {
  return e.replace(/start|end/g, (r) => aL[r]);
}
function sL(e, r, t) {
  const n = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return t ? r ? o : n : r ? n : o;
    case "left":
    case "right":
      return r ? a : i;
    default:
      return [];
  }
}
function cL(e, r, t, n) {
  const o = Ea(e);
  let a = sL(Jt(e), t === "start", n);
  return o && (a = a.map((i) => i + "-" + o), r && (a = a.concat(a.map(O0)))), a;
}
function Ds(e) {
  return e.replace(/left|right|bottom|top/g, (r) => oL[r]);
}
function uL(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Ef(e) {
  return typeof e != "number" ? uL(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function pa(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function F7(e, r, t) {
  let {
    reference: n,
    floating: o
  } = e;
  const a = jo(r), i = If(r), l = Sf(i), s = Jt(r), u = a === "y", d = n.x + n.width / 2 - o.width / 2, f = n.y + n.height / 2 - o.height / 2, p = n[l] / 2 - o[l] / 2;
  let g;
  switch (s) {
    case "top":
      g = {
        x: d,
        y: n.y - o.height
      };
      break;
    case "bottom":
      g = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      g = {
        x: n.x + n.width,
        y: f
      };
      break;
    case "left":
      g = {
        x: n.x - o.width,
        y: f
      };
      break;
    default:
      g = {
        x: n.x,
        y: n.y
      };
  }
  switch (Ea(r)) {
    case "start":
      g[i] -= p * (t && u ? -1 : 1);
      break;
    case "end":
      g[i] += p * (t && u ? -1 : 1);
      break;
  }
  return g;
}
const dL = async (e, r, t) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = t, l = a.filter(Boolean), s = await (i.isRTL == null ? void 0 : i.isRTL(r));
  let u = await i.getElementRects({
    reference: e,
    floating: r,
    strategy: o
  }), {
    x: d,
    y: f
  } = F7(u, n, s), p = n, g = {}, h = 0;
  for (let v = 0; v < l.length; v++) {
    const {
      name: y,
      fn: w
    } = l[v], {
      x: $,
      y: C,
      data: x,
      reset: b
    } = await w({
      x: d,
      y: f,
      initialPlacement: n,
      placement: p,
      strategy: o,
      middlewareData: g,
      rects: u,
      platform: i,
      elements: {
        reference: e,
        floating: r
      }
    });
    d = $ != null ? $ : d, f = C != null ? C : f, g = {
      ...g,
      [y]: {
        ...g[y],
        ...x
      }
    }, b && h <= 50 && (h++, typeof b == "object" && (b.placement && (p = b.placement), b.rects && (u = b.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: r,
      strategy: o
    }) : b.rects), {
      x: d,
      y: f
    } = F7(u, p, s)), v = -1);
  }
  return {
    x: d,
    y: f,
    placement: p,
    strategy: o,
    middlewareData: g
  };
};
async function Rf(e, r) {
  var t;
  r === void 0 && (r = {});
  const {
    x: n,
    y: o,
    platform: a,
    rects: i,
    elements: l,
    strategy: s
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: g = 0
  } = On(r, e), h = Ef(g), y = l[p ? f === "floating" ? "reference" : "floating" : f], w = pa(await a.getClippingRect({
    element: (t = await (a.isElement == null ? void 0 : a.isElement(y))) == null || t ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(l.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: s
  })), $ = f === "floating" ? {
    ...i.floating,
    x: n,
    y: o
  } : i.reference, C = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l.floating)), x = await (a.isElement == null ? void 0 : a.isElement(C)) ? await (a.getScale == null ? void 0 : a.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = pa(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: $,
    offsetParent: C,
    strategy: s
  }) : $);
  return {
    top: (w.top - b.top + h.top) / x.y,
    bottom: (b.bottom - w.bottom + h.bottom) / x.y,
    left: (w.left - b.left + h.left) / x.x,
    right: (b.right - w.right + h.right) / x.x
  };
}
const fL = (e) => ({
  name: "arrow",
  options: e,
  async fn(r) {
    const {
      x: t,
      y: n,
      placement: o,
      rects: a,
      platform: i,
      elements: l,
      middlewareData: s
    } = r, {
      element: u,
      padding: d = 0
    } = On(e, r) || {};
    if (u == null)
      return {};
    const f = Ef(d), p = {
      x: t,
      y: n
    }, g = If(o), h = Sf(g), v = await i.getDimensions(u), y = g === "y", w = y ? "top" : "left", $ = y ? "bottom" : "right", C = y ? "clientHeight" : "clientWidth", x = a.reference[h] + a.reference[g] - p[g] - a.floating[h], b = p[g] - a.reference[g], O = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let _ = O ? O[C] : 0;
    (!_ || !await (i.isElement == null ? void 0 : i.isElement(O))) && (_ = l.floating[C] || a.floating[h]);
    const P = x / 2 - b / 2, S = _ / 2 - v[h] / 2 - 1, I = Ut(f[w], S), N = Ut(f[$], S), k = I, j = _ - v[h] - N, R = _ / 2 - v[h] / 2 + P, D = $0(k, R, j), T = !s.arrow && Ea(o) != null && R !== D && a.reference[h] / 2 - (R < k ? I : N) - v[h] / 2 < 0, V = T ? R < k ? R - k : R - j : 0;
    return {
      [g]: p[g] + V,
      data: {
        [g]: D,
        centerOffset: R - D - V,
        ...T && {
          alignmentOffset: V
        }
      },
      reset: T
    };
  }
}), pL = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(r) {
      var t, n;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: l,
        platform: s,
        elements: u
      } = r, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: g = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: v = !0,
        ...y
      } = On(e, r);
      if ((t = a.arrow) != null && t.alignmentOffset)
        return {};
      const w = Jt(o), $ = Jt(l) === l, C = await (s.isRTL == null ? void 0 : s.isRTL(u.floating)), x = p || ($ || !v ? [Ds(l)] : lL(l));
      !p && h !== "none" && x.push(...cL(l, v, h, C));
      const b = [l, ...x], O = await Rf(r, y), _ = [];
      let P = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (d && _.push(O[w]), f) {
        const k = iL(o, i, C);
        _.push(O[k[0]], O[k[1]]);
      }
      if (P = [...P, {
        placement: o,
        overflows: _
      }], !_.every((k) => k <= 0)) {
        var S, I;
        const k = (((S = a.flip) == null ? void 0 : S.index) || 0) + 1, j = b[k];
        if (j)
          return {
            data: {
              index: k,
              overflows: P
            },
            reset: {
              placement: j
            }
          };
        let R = (I = P.filter((D) => D.overflows[0] <= 0).sort((D, T) => D.overflows[1] - T.overflows[1])[0]) == null ? void 0 : I.placement;
        if (!R)
          switch (g) {
            case "bestFit": {
              var N;
              const D = (N = P.map((T) => [T.placement, T.overflows.filter((V) => V > 0).reduce((V, L) => V + L, 0)]).sort((T, V) => T[1] - V[1])[0]) == null ? void 0 : N[0];
              D && (R = D);
              break;
            }
            case "initialPlacement":
              R = l;
              break;
          }
        if (o !== R)
          return {
            reset: {
              placement: R
            }
          };
      }
      return {};
    }
  };
};
function gh(e) {
  const r = Ut(...e.map((a) => a.left)), t = Ut(...e.map((a) => a.top)), n = Qr(...e.map((a) => a.right)), o = Qr(...e.map((a) => a.bottom));
  return {
    x: r,
    y: t,
    width: n - r,
    height: o - t
  };
}
function gL(e) {
  const r = e.slice().sort((o, a) => o.y - a.y), t = [];
  let n = null;
  for (let o = 0; o < r.length; o++) {
    const a = r[o];
    !n || a.y - n.y > n.height / 2 ? t.push([a]) : t[t.length - 1].push(a), n = a;
  }
  return t.map((o) => pa(gh(o)));
}
const vL = function(e) {
  return e === void 0 && (e = {}), {
    name: "inline",
    options: e,
    async fn(r) {
      const {
        placement: t,
        elements: n,
        rects: o,
        platform: a,
        strategy: i
      } = r, {
        padding: l = 2,
        x: s,
        y: u
      } = On(e, r), d = Array.from(await (a.getClientRects == null ? void 0 : a.getClientRects(n.reference)) || []), f = gL(d), p = pa(gh(d)), g = Ef(l);
      function h() {
        if (f.length === 2 && f[0].left > f[1].right && s != null && u != null)
          return f.find((y) => s > y.left - g.left && s < y.right + g.right && u > y.top - g.top && u < y.bottom + g.bottom) || p;
        if (f.length >= 2) {
          if (jo(t) === "y") {
            const I = f[0], N = f[f.length - 1], k = Jt(t) === "top", j = I.top, R = N.bottom, D = k ? I.left : N.left, T = k ? I.right : N.right, V = T - D, L = R - j;
            return {
              top: j,
              bottom: R,
              left: D,
              right: T,
              width: V,
              height: L,
              x: D,
              y: j
            };
          }
          const y = Jt(t) === "left", w = Qr(...f.map((I) => I.right)), $ = Ut(...f.map((I) => I.left)), C = f.filter((I) => y ? I.left === $ : I.right === w), x = C[0].top, b = C[C.length - 1].bottom, O = $, _ = w, P = _ - O, S = b - x;
          return {
            top: x,
            bottom: b,
            left: O,
            right: _,
            width: P,
            height: S,
            x: O,
            y: x
          };
        }
        return p;
      }
      const v = await a.getElementRects({
        reference: {
          getBoundingClientRect: h
        },
        floating: n.floating,
        strategy: i
      });
      return o.reference.x !== v.reference.x || o.reference.y !== v.reference.y || o.reference.width !== v.reference.width || o.reference.height !== v.reference.height ? {
        reset: {
          rects: v
        }
      } : {};
    }
  };
};
async function mL(e, r) {
  const {
    placement: t,
    platform: n,
    elements: o
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), i = Jt(t), l = Ea(t), s = jo(t) === "y", u = ["left", "top"].includes(i) ? -1 : 1, d = a && s ? -1 : 1, f = On(r, e);
  let {
    mainAxis: p,
    crossAxis: g,
    alignmentAxis: h
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return l && typeof h == "number" && (g = l === "end" ? h * -1 : h), s ? {
    x: g * d,
    y: p * u
  } : {
    x: p * u,
    y: g * d
  };
}
const vh = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(r) {
      var t, n;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: l
      } = r, s = await mL(r, e);
      return i === ((t = l.offset) == null ? void 0 : t.placement) && (n = l.arrow) != null && n.alignmentOffset ? {} : {
        x: o + s.x,
        y: a + s.y,
        data: {
          ...s,
          placement: i
        }
      };
    }
  };
}, hL = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(r) {
      const {
        x: t,
        y: n,
        placement: o
      } = r, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: l = {
          fn: (y) => {
            let {
              x: w,
              y: $
            } = y;
            return {
              x: w,
              y: $
            };
          }
        },
        ...s
      } = On(e, r), u = {
        x: t,
        y: n
      }, d = await Rf(r, s), f = jo(Jt(o)), p = Pf(f);
      let g = u[p], h = u[f];
      if (a) {
        const y = p === "y" ? "top" : "left", w = p === "y" ? "bottom" : "right", $ = g + d[y], C = g - d[w];
        g = $0($, g, C);
      }
      if (i) {
        const y = f === "y" ? "top" : "left", w = f === "y" ? "bottom" : "right", $ = h + d[y], C = h - d[w];
        h = $0($, h, C);
      }
      const v = l.fn({
        ...r,
        [p]: g,
        [f]: h
      });
      return {
        ...v,
        data: {
          x: v.x - t,
          y: v.y - n
        }
      };
    }
  };
}, bL = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(r) {
      const {
        x: t,
        y: n,
        placement: o,
        rects: a,
        middlewareData: i
      } = r, {
        offset: l = 0,
        mainAxis: s = !0,
        crossAxis: u = !0
      } = On(e, r), d = {
        x: t,
        y: n
      }, f = jo(o), p = Pf(f);
      let g = d[p], h = d[f];
      const v = On(l, r), y = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (s) {
        const C = p === "y" ? "height" : "width", x = a.reference[p] - a.floating[C] + y.mainAxis, b = a.reference[p] + a.reference[C] - y.mainAxis;
        g < x ? g = x : g > b && (g = b);
      }
      if (u) {
        var w, $;
        const C = p === "y" ? "width" : "height", x = ["top", "left"].includes(Jt(o)), b = a.reference[f] - a.floating[C] + (x && ((w = i.offset) == null ? void 0 : w[f]) || 0) + (x ? 0 : y.crossAxis), O = a.reference[f] + a.reference[C] + (x ? 0 : (($ = i.offset) == null ? void 0 : $[f]) || 0) - (x ? y.crossAxis : 0);
        h < b ? h = b : h > O && (h = O);
      }
      return {
        [p]: g,
        [f]: h
      };
    }
  };
}, yL = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(r) {
      const {
        placement: t,
        rects: n,
        platform: o,
        elements: a
      } = r, {
        apply: i = () => {
        },
        ...l
      } = On(e, r), s = await Rf(r, l), u = Jt(t), d = Ea(t), f = jo(t) === "y", {
        width: p,
        height: g
      } = n.floating;
      let h, v;
      u === "top" || u === "bottom" ? (h = u, v = d === (await (o.isRTL == null ? void 0 : o.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (v = u, h = d === "end" ? "top" : "bottom");
      const y = g - s[h], w = p - s[v], $ = !r.middlewareData.shift;
      let C = y, x = w;
      if (f) {
        const O = p - s.left - s.right;
        x = d || $ ? Ut(w, O) : O;
      } else {
        const O = g - s.top - s.bottom;
        C = d || $ ? Ut(y, O) : O;
      }
      if ($ && !d) {
        const O = Qr(s.left, 0), _ = Qr(s.right, 0), P = Qr(s.top, 0), S = Qr(s.bottom, 0);
        f ? x = p - 2 * (O !== 0 || _ !== 0 ? O + _ : Qr(s.left, s.right)) : C = g - 2 * (P !== 0 || S !== 0 ? P + S : Qr(s.top, s.bottom));
      }
      await i({
        ...r,
        availableWidth: x,
        availableHeight: C
      });
      const b = await o.getDimensions(a.floating);
      return p !== b.width || g !== b.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Jn(e) {
  return mh(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function _t(e) {
  var r;
  return (e == null || (r = e.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function An(e) {
  var r;
  return (r = (mh(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : r.documentElement;
}
function mh(e) {
  return e instanceof Node || e instanceof _t(e).Node;
}
function Pn(e) {
  return e instanceof Element || e instanceof _t(e).Element;
}
function un(e) {
  return e instanceof HTMLElement || e instanceof _t(e).HTMLElement;
}
function Z7(e) {
  return typeof ShadowRoot == "undefined" ? !1 : e instanceof ShadowRoot || e instanceof _t(e).ShadowRoot;
}
function Ni(e) {
  const {
    overflow: r,
    overflowX: t,
    overflowY: n,
    display: o
  } = jt(e);
  return /auto|scroll|overlay|hidden|clip/.test(r + n + t) && !["inline", "contents"].includes(o);
}
function CL(e) {
  return ["table", "td", "th"].includes(Jn(e));
}
function Af(e) {
  const r = kf(), t = jt(e);
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !r && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !r && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (t.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (t.contain || "").includes(n));
}
function wL(e) {
  let r = ga(e);
  for (; un(r) && !b1(r); ) {
    if (Af(r))
      return r;
    r = ga(r);
  }
  return null;
}
function kf() {
  return typeof CSS == "undefined" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function b1(e) {
  return ["html", "body", "#document"].includes(Jn(e));
}
function jt(e) {
  return _t(e).getComputedStyle(e);
}
function y1(e) {
  return Pn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ga(e) {
  if (Jn(e) === "html")
    return e;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Z7(e) && e.host || // Fallback.
    An(e)
  );
  return Z7(r) ? r.host : r;
}
function hh(e) {
  const r = ga(e);
  return b1(r) ? e.ownerDocument ? e.ownerDocument.body : e.body : un(r) && Ni(r) ? r : hh(r);
}
function yn(e, r, t) {
  var n;
  r === void 0 && (r = []), t === void 0 && (t = !0);
  const o = hh(e), a = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = _t(o);
  return a ? r.concat(i, i.visualViewport || [], Ni(o) ? o : [], i.frameElement && t ? yn(i.frameElement) : []) : r.concat(o, yn(o, [], t));
}
function bh(e) {
  const r = jt(e);
  let t = parseFloat(r.width) || 0, n = parseFloat(r.height) || 0;
  const o = un(e), a = o ? e.offsetWidth : t, i = o ? e.offsetHeight : n, l = Ts(t) !== a || Ts(n) !== i;
  return l && (t = a, n = i), {
    width: t,
    height: n,
    $: l
  };
}
function Mf(e) {
  return Pn(e) ? e : e.contextElement;
}
function sa(e) {
  const r = Mf(e);
  if (!un(r))
    return Un(1);
  const t = r.getBoundingClientRect(), {
    width: n,
    height: o,
    $: a
  } = bh(r);
  let i = (a ? Ts(t.width) : t.width) / n, l = (a ? Ts(t.height) : t.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: i,
    y: l
  };
}
const _L = /* @__PURE__ */ Un(0);
function yh(e) {
  const r = _t(e);
  return !kf() || !r.visualViewport ? _L : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function xL(e, r, t) {
  return r === void 0 && (r = !1), !t || r && t !== _t(e) ? !1 : r;
}
function Ro(e, r, t, n) {
  r === void 0 && (r = !1), t === void 0 && (t = !1);
  const o = e.getBoundingClientRect(), a = Mf(e);
  let i = Un(1);
  r && (n ? Pn(n) && (i = sa(n)) : i = sa(e));
  const l = xL(a, t, n) ? yh(a) : Un(0);
  let s = (o.left + l.x) / i.x, u = (o.top + l.y) / i.y, d = o.width / i.x, f = o.height / i.y;
  if (a) {
    const p = _t(a), g = n && Pn(n) ? _t(n) : n;
    let h = p, v = h.frameElement;
    for (; v && n && g !== h; ) {
      const y = sa(v), w = v.getBoundingClientRect(), $ = jt(v), C = w.left + (v.clientLeft + parseFloat($.paddingLeft)) * y.x, x = w.top + (v.clientTop + parseFloat($.paddingTop)) * y.y;
      s *= y.x, u *= y.y, d *= y.x, f *= y.y, s += C, u += x, h = _t(v), v = h.frameElement;
    }
  }
  return pa({
    width: d,
    height: f,
    x: s,
    y: u
  });
}
const $L = [":popover-open", ":modal"];
function Ch(e) {
  return $L.some((r) => {
    try {
      return e.matches(r);
    } catch {
      return !1;
    }
  });
}
function OL(e) {
  let {
    elements: r,
    rect: t,
    offsetParent: n,
    strategy: o
  } = e;
  const a = o === "fixed", i = An(n), l = r ? Ch(r.floating) : !1;
  if (n === i || l && a)
    return t;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Un(1);
  const d = Un(0), f = un(n);
  if ((f || !f && !a) && ((Jn(n) !== "body" || Ni(i)) && (s = y1(n)), un(n))) {
    const p = Ro(n);
    u = sa(n), d.x = p.x + n.clientLeft, d.y = p.y + n.clientTop;
  }
  return {
    width: t.width * u.x,
    height: t.height * u.y,
    x: t.x * u.x - s.scrollLeft * u.x + d.x,
    y: t.y * u.y - s.scrollTop * u.y + d.y
  };
}
function PL(e) {
  return Array.from(e.getClientRects());
}
function wh(e) {
  return Ro(An(e)).left + y1(e).scrollLeft;
}
function SL(e) {
  const r = An(e), t = y1(e), n = e.ownerDocument.body, o = Qr(r.scrollWidth, r.clientWidth, n.scrollWidth, n.clientWidth), a = Qr(r.scrollHeight, r.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + wh(e);
  const l = -t.scrollTop;
  return jt(n).direction === "rtl" && (i += Qr(r.clientWidth, n.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: l
  };
}
function IL(e, r) {
  const t = _t(e), n = An(e), o = t.visualViewport;
  let a = n.clientWidth, i = n.clientHeight, l = 0, s = 0;
  if (o) {
    a = o.width, i = o.height;
    const u = kf();
    (!u || u && r === "fixed") && (l = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: l,
    y: s
  };
}
function EL(e, r) {
  const t = Ro(e, !0, r === "fixed"), n = t.top + e.clientTop, o = t.left + e.clientLeft, a = un(e) ? sa(e) : Un(1), i = e.clientWidth * a.x, l = e.clientHeight * a.y, s = o * a.x, u = n * a.y;
  return {
    width: i,
    height: l,
    x: s,
    y: u
  };
}
function W7(e, r, t) {
  let n;
  if (r === "viewport")
    n = IL(e, t);
  else if (r === "document")
    n = SL(An(e));
  else if (Pn(r))
    n = EL(r, t);
  else {
    const o = yh(e);
    n = {
      ...r,
      x: r.x - o.x,
      y: r.y - o.y
    };
  }
  return pa(n);
}
function _h(e, r) {
  const t = ga(e);
  return t === r || !Pn(t) || b1(t) ? !1 : jt(t).position === "fixed" || _h(t, r);
}
function RL(e, r) {
  const t = r.get(e);
  if (t)
    return t;
  let n = yn(e, [], !1).filter((l) => Pn(l) && Jn(l) !== "body"), o = null;
  const a = jt(e).position === "fixed";
  let i = a ? ga(e) : e;
  for (; Pn(i) && !b1(i); ) {
    const l = jt(i), s = Af(i);
    !s && l.position === "fixed" && (o = null), (a ? !s && !o : !s && l.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Ni(i) && !s && _h(e, i)) ? n = n.filter((d) => d !== i) : o = l, i = ga(i);
  }
  return r.set(e, n), n;
}
function AL(e) {
  let {
    element: r,
    boundary: t,
    rootBoundary: n,
    strategy: o
  } = e;
  const i = [...t === "clippingAncestors" ? RL(r, this._c) : [].concat(t), n], l = i[0], s = i.reduce((u, d) => {
    const f = W7(r, d, o);
    return u.top = Qr(f.top, u.top), u.right = Ut(f.right, u.right), u.bottom = Ut(f.bottom, u.bottom), u.left = Qr(f.left, u.left), u;
  }, W7(r, l, o));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function kL(e) {
  const {
    width: r,
    height: t
  } = bh(e);
  return {
    width: r,
    height: t
  };
}
function ML(e, r, t) {
  const n = un(r), o = An(r), a = t === "fixed", i = Ro(e, !0, a, r);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = Un(0);
  if (n || !n && !a)
    if ((Jn(r) !== "body" || Ni(o)) && (l = y1(r)), n) {
      const f = Ro(r, !0, a, r);
      s.x = f.x + r.clientLeft, s.y = f.y + r.clientTop;
    } else
      o && (s.x = wh(o));
  const u = i.left + l.scrollLeft - s.x, d = i.top + l.scrollTop - s.y;
  return {
    x: u,
    y: d,
    width: i.width,
    height: i.height
  };
}
function B7(e, r) {
  return !un(e) || jt(e).position === "fixed" ? null : r ? r(e) : e.offsetParent;
}
function xh(e, r) {
  const t = _t(e);
  if (!un(e) || Ch(e))
    return t;
  let n = B7(e, r);
  for (; n && CL(n) && jt(n).position === "static"; )
    n = B7(n, r);
  return n && (Jn(n) === "html" || Jn(n) === "body" && jt(n).position === "static" && !Af(n)) ? t : n || wL(e) || t;
}
const NL = async function(e) {
  const r = this.getOffsetParent || xh, t = this.getDimensions;
  return {
    reference: ML(e.reference, await r(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await t(e.floating)
    }
  };
};
function TL(e) {
  return jt(e).direction === "rtl";
}
const DL = {
  convertOffsetParentRelativeRectToViewportRelativeRect: OL,
  getDocumentElement: An,
  getClippingRect: AL,
  getOffsetParent: xh,
  getElementRects: NL,
  getClientRects: PL,
  getDimensions: kL,
  getScale: sa,
  isElement: Pn,
  isRTL: TL
};
function jL(e, r) {
  let t = null, n;
  const o = An(e);
  function a() {
    var l;
    clearTimeout(n), (l = t) == null || l.disconnect(), t = null;
  }
  function i(l, s) {
    l === void 0 && (l = !1), s === void 0 && (s = 1), a();
    const {
      left: u,
      top: d,
      width: f,
      height: p
    } = e.getBoundingClientRect();
    if (l || r(), !f || !p)
      return;
    const g = sl(d), h = sl(o.clientWidth - (u + f)), v = sl(o.clientHeight - (d + p)), y = sl(u), $ = {
      rootMargin: -g + "px " + -h + "px " + -v + "px " + -y + "px",
      threshold: Qr(0, Ut(1, s)) || 1
    };
    let C = !0;
    function x(b) {
      const O = b[0].intersectionRatio;
      if (O !== s) {
        if (!C)
          return i();
        O ? i(!1, O) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 100);
      }
      C = !1;
    }
    try {
      t = new IntersectionObserver(x, {
        ...$,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(x, $);
    }
    t.observe(e);
  }
  return i(!0), a;
}
function LL(e, r, t, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = n, u = Mf(e), d = o || a ? [...u ? yn(u) : [], ...yn(r)] : [];
  d.forEach((w) => {
    o && w.addEventListener("scroll", t, {
      passive: !0
    }), a && w.addEventListener("resize", t);
  });
  const f = u && l ? jL(u, t) : null;
  let p = -1, g = null;
  i && (g = new ResizeObserver((w) => {
    let [$] = w;
    $ && $.target === u && g && (g.unobserve(r), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var C;
      (C = g) == null || C.observe(r);
    })), t();
  }), u && !s && g.observe(u), g.observe(r));
  let h, v = s ? Ro(e) : null;
  s && y();
  function y() {
    const w = Ro(e);
    v && (w.x !== v.x || w.y !== v.y || w.width !== v.width || w.height !== v.height) && t(), v = w, h = requestAnimationFrame(y);
  }
  return t(), () => {
    var w;
    d.forEach(($) => {
      o && $.removeEventListener("scroll", t), a && $.removeEventListener("resize", t);
    }), f == null || f(), (w = g) == null || w.disconnect(), g = null, s && cancelAnimationFrame(h);
  };
}
const Nf = hL, $h = pL, zL = yL, H7 = fL, Oh = vL, VL = bL, FL = (e, r, t) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: DL,
    ...t
  }, a = {
    ...o.platform,
    _c: n
  };
  return dL(e, r, {
    ...o,
    platform: a
  });
}, Ph = (e) => {
  const {
    element: r,
    padding: t
  } = e;
  function n(o) {
    return Object.prototype.hasOwnProperty.call(o, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(o) {
      return n(r) ? r.current != null ? H7({
        element: r.current,
        padding: t
      }).fn(o) : {} : r ? H7({
        element: r,
        padding: t
      }).fn(o) : {};
    }
  };
};
var Yl = typeof document != "undefined" ? qn : Fe;
function js(e, r) {
  if (e === r)
    return !0;
  if (typeof e != typeof r)
    return !1;
  if (typeof e == "function" && e.toString() === r.toString())
    return !0;
  let t, n, o;
  if (e && r && typeof e == "object") {
    if (Array.isArray(e)) {
      if (t = e.length, t != r.length)
        return !1;
      for (n = t; n-- !== 0; )
        if (!js(e[n], r[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), t = o.length, t !== Object.keys(r).length)
      return !1;
    for (n = t; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, o[n]))
        return !1;
    for (n = t; n-- !== 0; ) {
      const a = o[n];
      if (!(a === "_owner" && e.$$typeof) && !js(e[a], r[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
}
function G7(e) {
  const r = A.useRef(e);
  return Yl(() => {
    r.current = e;
  }), r;
}
function ZL(e) {
  e === void 0 && (e = {});
  const {
    placement: r = "bottom",
    strategy: t = "absolute",
    middleware: n = [],
    platform: o,
    whileElementsMounted: a,
    open: i
  } = e, [l, s] = A.useState({
    x: null,
    y: null,
    strategy: t,
    placement: r,
    middlewareData: {},
    isPositioned: !1
  }), [u, d] = A.useState(n);
  js(u, n) || d(n);
  const f = A.useRef(null), p = A.useRef(null), g = A.useRef(l), h = G7(a), v = G7(o), [y, w] = A.useState(null), [$, C] = A.useState(null), x = A.useCallback((I) => {
    f.current !== I && (f.current = I, w(I));
  }, []), b = A.useCallback((I) => {
    p.current !== I && (p.current = I, C(I));
  }, []), O = A.useCallback(() => {
    if (!f.current || !p.current)
      return;
    const I = {
      placement: r,
      strategy: t,
      middleware: u
    };
    v.current && (I.platform = v.current), FL(f.current, p.current, I).then((N) => {
      const k = {
        ...N,
        isPositioned: !0
      };
      _.current && !js(g.current, k) && (g.current = k, Qv.flushSync(() => {
        s(k);
      }));
    });
  }, [u, r, t, v]);
  Yl(() => {
    i === !1 && g.current.isPositioned && (g.current.isPositioned = !1, s((I) => ({
      ...I,
      isPositioned: !1
    })));
  }, [i]);
  const _ = A.useRef(!1);
  Yl(() => (_.current = !0, () => {
    _.current = !1;
  }), []), Yl(() => {
    if (y && $) {
      if (h.current)
        return h.current(y, $, O);
      O();
    }
  }, [y, $, O, h]);
  const P = A.useMemo(() => ({
    reference: f,
    floating: p,
    setReference: x,
    setFloating: b
  }), [x, b]), S = A.useMemo(() => ({
    reference: y,
    floating: $
  }), [y, $]);
  return A.useMemo(() => ({
    ...l,
    update: O,
    refs: P,
    elements: S,
    reference: x,
    floating: b
  }), [l, O, P, S, x, b]);
}
var va = typeof document != "undefined" ? qn : Fe;
let dd = !1, WL = 0;
const X7 = () => "floating-ui-" + WL++;
function BL() {
  const [e, r] = A.useState(() => dd ? X7() : void 0);
  return va(() => {
    e == null && r(X7());
  }, []), A.useEffect(() => {
    dd || (dd = !0);
  }, []), e;
}
const HL = A.useId, Y7 = HL || BL;
function GL() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(r, t) {
      var n;
      (n = e.get(r)) == null || n.forEach((o) => o(t));
    },
    on(r, t) {
      e.set(r, [...e.get(r) || [], t]);
    },
    off(r, t) {
      e.set(r, (e.get(r) || []).filter((n) => n !== t));
    }
  };
}
const XL = /* @__PURE__ */ A.createContext(null), YL = /* @__PURE__ */ A.createContext(null), Sh = () => {
  var e;
  return ((e = A.useContext(XL)) == null ? void 0 : e.id) || null;
}, Tf = () => A.useContext(YL);
function Hn(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function UL() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function JL() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((r) => {
    let {
      brand: t,
      version: n
    } = r;
    return t + "/" + n;
  }).join(" ") : navigator.userAgent;
}
function Df(e) {
  return Hn(e).defaultView || window;
}
function an(e) {
  return e ? e instanceof Df(e).Element : !1;
}
function Ih(e) {
  return e ? e instanceof Df(e).HTMLElement : !1;
}
function qL(e) {
  if (typeof ShadowRoot == "undefined")
    return !1;
  const r = Df(e).ShadowRoot;
  return e instanceof r || e instanceof ShadowRoot;
}
function KL(e) {
  if (e.mozInputSource === 0 && e.isTrusted)
    return !0;
  const r = /Android/i;
  return (r.test(UL()) || r.test(JL())) && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function QL(e) {
  return e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0;
}
function Eh(e, r) {
  const t = ["mouse", "pen"];
  return r || t.push("", void 0), t.includes(e);
}
function U7(e) {
  const r = Ve(e);
  return va(() => {
    r.current = e;
  }), r;
}
const J7 = "data-floating-ui-safe-polygon";
function Ul(e, r, t) {
  return t && !Eh(t) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[r];
}
const ez = function(e, r) {
  let {
    enabled: t = !0,
    delay: n = 0,
    handleClose: o = null,
    mouseOnly: a = !1,
    restMs: i = 0,
    move: l = !0
  } = r === void 0 ? {} : r;
  const {
    open: s,
    onOpenChange: u,
    dataRef: d,
    events: f,
    elements: {
      domReference: p,
      floating: g
    },
    refs: h
  } = e, v = Tf(), y = Sh(), w = U7(o), $ = U7(n), C = A.useRef(), x = A.useRef(), b = A.useRef(), O = A.useRef(), _ = A.useRef(!0), P = A.useRef(!1), S = A.useRef(() => {
  }), I = A.useCallback(() => {
    var R;
    const D = (R = d.current.openEvent) == null ? void 0 : R.type;
    return (D == null ? void 0 : D.includes("mouse")) && D !== "mousedown";
  }, [d]);
  A.useEffect(() => {
    if (!t)
      return;
    function R() {
      clearTimeout(x.current), clearTimeout(O.current), _.current = !0;
    }
    return f.on("dismiss", R), () => {
      f.off("dismiss", R);
    };
  }, [t, f]), A.useEffect(() => {
    if (!t || !w.current || !s)
      return;
    function R() {
      I() && u(!1);
    }
    const D = Hn(g).documentElement;
    return D.addEventListener("mouseleave", R), () => {
      D.removeEventListener("mouseleave", R);
    };
  }, [g, s, u, t, w, d, I]);
  const N = A.useCallback(function(R) {
    R === void 0 && (R = !0);
    const D = Ul($.current, "close", C.current);
    D && !b.current ? (clearTimeout(x.current), x.current = setTimeout(() => u(!1), D)) : R && (clearTimeout(x.current), u(!1));
  }, [$, u]), k = A.useCallback(() => {
    S.current(), b.current = void 0;
  }, []), j = A.useCallback(() => {
    if (P.current) {
      const R = Hn(h.floating.current).body;
      R.style.pointerEvents = "", R.removeAttribute(J7), P.current = !1;
    }
  }, [h]);
  return A.useEffect(() => {
    if (!t)
      return;
    function R() {
      return d.current.openEvent ? ["click", "mousedown"].includes(d.current.openEvent.type) : !1;
    }
    function D(L) {
      if (clearTimeout(x.current), _.current = !1, a && !Eh(C.current) || i > 0 && Ul($.current, "open") === 0)
        return;
      d.current.openEvent = L;
      const Z = Ul($.current, "open", C.current);
      Z ? x.current = setTimeout(() => {
        u(!0);
      }, Z) : u(!0);
    }
    function T(L) {
      if (R())
        return;
      S.current();
      const Z = Hn(g);
      if (clearTimeout(O.current), w.current) {
        s || clearTimeout(x.current), b.current = w.current({
          ...e,
          tree: v,
          x: L.clientX,
          y: L.clientY,
          onClose() {
            j(), k(), N();
          }
        });
        const z = b.current;
        Z.addEventListener("mousemove", z), S.current = () => {
          Z.removeEventListener("mousemove", z);
        };
        return;
      }
      N();
    }
    function V(L) {
      R() || w.current == null || w.current({
        ...e,
        tree: v,
        x: L.clientX,
        y: L.clientY,
        onClose() {
          j(), k(), N();
        }
      })(L);
    }
    if (an(p)) {
      const L = p;
      return s && L.addEventListener("mouseleave", V), g == null || g.addEventListener("mouseleave", V), l && L.addEventListener("mousemove", D, {
        once: !0
      }), L.addEventListener("mouseenter", D), L.addEventListener("mouseleave", T), () => {
        s && L.removeEventListener("mouseleave", V), g == null || g.removeEventListener("mouseleave", V), l && L.removeEventListener("mousemove", D), L.removeEventListener("mouseenter", D), L.removeEventListener("mouseleave", T);
      };
    }
  }, [p, g, t, e, a, i, l, N, k, j, u, s, v, $, w, d]), va(() => {
    var R;
    if (t && s && (R = w.current) != null && R.__options.blockPointerEvents && I()) {
      const V = Hn(g).body;
      if (V.setAttribute(J7, ""), V.style.pointerEvents = "none", P.current = !0, an(p) && g) {
        var D, T;
        const L = p, Z = v == null || (D = v.nodesRef.current.find((z) => z.id === y)) == null || (T = D.context) == null ? void 0 : T.elements.floating;
        return Z && (Z.style.pointerEvents = ""), L.style.pointerEvents = "auto", g.style.pointerEvents = "auto", () => {
          L.style.pointerEvents = "", g.style.pointerEvents = "";
        };
      }
    }
  }, [t, s, y, g, p, v, w, d, I]), va(() => {
    s || (C.current = void 0, k(), j());
  }, [s, k, j]), A.useEffect(() => () => {
    k(), clearTimeout(x.current), clearTimeout(O.current), j();
  }, [t, k, j]), A.useMemo(() => {
    if (!t)
      return {};
    function R(D) {
      C.current = D.pointerType;
    }
    return {
      reference: {
        onPointerDown: R,
        onPointerEnter: R,
        onMouseMove() {
          s || i === 0 || (clearTimeout(O.current), O.current = setTimeout(() => {
            _.current || u(!0);
          }, i));
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(x.current);
        },
        onMouseLeave() {
          f.emit("dismiss", {
            type: "mouseLeave",
            data: {
              returnFocus: !1
            }
          }), N(!1);
        }
      }
    };
  }, [f, t, i, s, u, N]);
}, Rh = /* @__PURE__ */ A.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: () => {
  },
  setState: () => {
  },
  isInstantPhase: !1
}), Ah = () => A.useContext(Rh), rz = (e) => {
  let {
    children: r,
    delay: t,
    timeoutMs: n = 0
  } = e;
  const [o, a] = A.useReducer((s, u) => ({
    ...s,
    ...u
  }), {
    delay: t,
    timeoutMs: n,
    initialDelay: t,
    currentId: null,
    isInstantPhase: !1
  }), i = A.useRef(null), l = A.useCallback((s) => {
    a({
      currentId: s
    });
  }, []);
  return va(() => {
    o.currentId ? i.current === null ? i.current = o.currentId : a({
      isInstantPhase: !0
    }) : (a({
      isInstantPhase: !1
    }), i.current = null);
  }, [o.currentId]), /* @__PURE__ */ A.createElement(Rh.Provider, {
    value: A.useMemo(() => ({
      ...o,
      setState: a,
      setCurrentId: l
    }), [o, a, l])
  }, r);
}, tz = (e, r) => {
  let {
    open: t,
    onOpenChange: n
  } = e, {
    id: o
  } = r;
  const {
    currentId: a,
    setCurrentId: i,
    initialDelay: l,
    setState: s,
    timeoutMs: u
  } = Ah();
  A.useEffect(() => {
    a && (s({
      delay: {
        open: 1,
        close: Ul(l, "close")
      }
    }), a !== o && n(!1));
  }, [o, n, s, a, l]), A.useEffect(() => {
    function d() {
      n(!1), s({
        delay: l,
        currentId: null
      });
    }
    if (!t && a === o)
      if (u) {
        const f = window.setTimeout(d, u);
        return () => {
          clearTimeout(f);
        };
      } else
        d();
  }, [t, s, a, o, n, l, u]), A.useEffect(() => {
    t && i(o);
  }, [t, i, o]);
};
function nz(e) {
  let r = e.activeElement;
  for (; ((t = r) == null || (n = t.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var t, n;
    r = r.shadowRoot.activeElement;
  }
  return r;
}
function q7(e, r) {
  if (!e || !r)
    return !1;
  const t = r.getRootNode && r.getRootNode();
  if (e.contains(r))
    return !0;
  if (t && qL(t)) {
    let n = r;
    do {
      if (n && e === n)
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function fd(e, r) {
  let t = e.filter((o) => {
    var a;
    return o.parentId === r && ((a = o.context) == null ? void 0 : a.open);
  }) || [], n = t;
  for (; n.length; )
    n = e.filter((o) => {
      var a;
      return (a = n) == null ? void 0 : a.some((i) => {
        var l;
        return o.parentId === i.id && ((l = o.context) == null ? void 0 : l.open);
      });
    }) || [], t = t.concat(n);
  return t;
}
function oz(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const az = A.useInsertionEffect, iz = az || ((e) => e());
function kh(e) {
  const r = A.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return iz(() => {
    r.current = e;
  }), A.useCallback(function() {
    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
      n[o] = arguments[o];
    return r.current == null ? void 0 : r.current(...n);
  }, []);
}
function Jl(e, r) {
  if (r == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(r);
  const t = e;
  return t.target != null && r.contains(t.target);
}
const lz = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, sz = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, cz = function(e) {
  var r, t;
  return e === void 0 && (e = !0), {
    escapeKeyBubbles: typeof e == "boolean" ? e : (r = e.escapeKey) != null ? r : !0,
    outsidePressBubbles: typeof e == "boolean" ? e : (t = e.outsidePress) != null ? t : !0
  };
}, uz = function(e, r) {
  let {
    open: t,
    onOpenChange: n,
    events: o,
    nodeId: a,
    elements: {
      reference: i,
      domReference: l,
      floating: s
    },
    dataRef: u
  } = e, {
    enabled: d = !0,
    escapeKey: f = !0,
    outsidePress: p = !0,
    outsidePressEvent: g = "pointerdown",
    referencePress: h = !1,
    referencePressEvent: v = "pointerdown",
    ancestorScroll: y = !1,
    bubbles: w = !0
  } = r === void 0 ? {} : r;
  const $ = Tf(), C = Sh() != null, x = kh(typeof p == "function" ? p : () => !1), b = typeof p == "function" ? x : p, O = A.useRef(!1), {
    escapeKeyBubbles: _,
    outsidePressBubbles: P
  } = cz(w);
  return A.useEffect(() => {
    if (!t || !d)
      return;
    u.current.__escapeKeyBubbles = _, u.current.__outsidePressBubbles = P;
    function S(R) {
      if (R.key === "Escape") {
        const D = $ ? fd($.nodesRef.current, a) : [];
        if (D.length > 0) {
          let T = !0;
          if (D.forEach((V) => {
            var L;
            if ((L = V.context) != null && L.open && !V.context.dataRef.current.__escapeKeyBubbles) {
              T = !1;
              return;
            }
          }), !T)
            return;
        }
        o.emit("dismiss", {
          type: "escapeKey",
          data: {
            returnFocus: {
              preventScroll: !1
            }
          }
        }), n(!1);
      }
    }
    function I(R) {
      const D = O.current;
      if (O.current = !1, D || typeof b == "function" && !b(R))
        return;
      const T = oz(R);
      if (Ih(T) && s) {
        const Z = s.ownerDocument.defaultView || window, z = T.scrollWidth > T.clientWidth, W = T.scrollHeight > T.clientHeight;
        let U = W && R.offsetX > T.clientWidth;
        if (W && Z.getComputedStyle(T).direction === "rtl" && (U = R.offsetX <= T.offsetWidth - T.clientWidth), U || z && R.offsetY > T.clientHeight)
          return;
      }
      const V = $ && fd($.nodesRef.current, a).some((Z) => {
        var z;
        return Jl(R, (z = Z.context) == null ? void 0 : z.elements.floating);
      });
      if (Jl(R, s) || Jl(R, l) || V)
        return;
      const L = $ ? fd($.nodesRef.current, a) : [];
      if (L.length > 0) {
        let Z = !0;
        if (L.forEach((z) => {
          var W;
          if ((W = z.context) != null && W.open && !z.context.dataRef.current.__outsidePressBubbles) {
            Z = !1;
            return;
          }
        }), !Z)
          return;
      }
      o.emit("dismiss", {
        type: "outsidePress",
        data: {
          returnFocus: C ? {
            preventScroll: !0
          } : KL(R) || QL(R)
        }
      }), n(!1);
    }
    function N() {
      n(!1);
    }
    const k = Hn(s);
    f && k.addEventListener("keydown", S), b && k.addEventListener(g, I);
    let j = [];
    return y && (an(l) && (j = yn(l)), an(s) && (j = j.concat(yn(s))), !an(i) && i && i.contextElement && (j = j.concat(yn(i.contextElement)))), j = j.filter((R) => {
      var D;
      return R !== ((D = k.defaultView) == null ? void 0 : D.visualViewport);
    }), j.forEach((R) => {
      R.addEventListener("scroll", N, {
        passive: !0
      });
    }), () => {
      f && k.removeEventListener("keydown", S), b && k.removeEventListener(g, I), j.forEach((R) => {
        R.removeEventListener("scroll", N);
      });
    };
  }, [u, s, l, i, f, b, g, o, $, a, t, n, y, d, _, P, C]), A.useEffect(() => {
    O.current = !1;
  }, [b, g]), A.useMemo(() => d ? {
    reference: {
      [lz[v]]: () => {
        h && (o.emit("dismiss", {
          type: "referencePress",
          data: {
            returnFocus: !1
          }
        }), n(!1));
      }
    },
    floating: {
      [sz[g]]: () => {
        O.current = !0;
      }
    }
  } : {}, [d, o, h, g, v, n]);
}, dz = function(e, r) {
  let {
    open: t,
    onOpenChange: n,
    dataRef: o,
    events: a,
    refs: i,
    elements: {
      floating: l,
      domReference: s
    }
  } = e, {
    enabled: u = !0,
    keyboardOnly: d = !0
  } = r === void 0 ? {} : r;
  const f = A.useRef(""), p = A.useRef(!1), g = A.useRef();
  return A.useEffect(() => {
    if (!u)
      return;
    const v = Hn(l).defaultView || window;
    function y() {
      !t && Ih(s) && s === nz(Hn(s)) && (p.current = !0);
    }
    return v.addEventListener("blur", y), () => {
      v.removeEventListener("blur", y);
    };
  }, [l, s, t, u]), A.useEffect(() => {
    if (!u)
      return;
    function h(v) {
      (v.type === "referencePress" || v.type === "escapeKey") && (p.current = !0);
    }
    return a.on("dismiss", h), () => {
      a.off("dismiss", h);
    };
  }, [a, u]), A.useEffect(() => () => {
    clearTimeout(g.current);
  }, []), A.useMemo(() => u ? {
    reference: {
      onPointerDown(h) {
        let {
          pointerType: v
        } = h;
        f.current = v, p.current = !!(v && d);
      },
      onMouseLeave() {
        p.current = !1;
      },
      onFocus(h) {
        var v;
        p.current || h.type === "focus" && ((v = o.current.openEvent) == null ? void 0 : v.type) === "mousedown" && o.current.openEvent && Jl(o.current.openEvent, s) || (o.current.openEvent = h.nativeEvent, n(!0));
      },
      onBlur(h) {
        p.current = !1;
        const v = h.relatedTarget, y = an(v) && v.hasAttribute("data-floating-ui-focus-guard") && v.getAttribute("data-type") === "outside";
        g.current = setTimeout(() => {
          q7(i.floating.current, v) || q7(s, v) || y || n(!1);
        });
      }
    }
  } : {}, [u, d, s, i, o, n]);
}, fz = function(e, r) {
  let {
    open: t
  } = e, {
    enabled: n = !0,
    role: o = "dialog"
  } = r === void 0 ? {} : r;
  const a = Y7(), i = Y7();
  return A.useMemo(() => {
    const l = {
      id: a,
      role: o
    };
    return n ? o === "tooltip" ? {
      reference: {
        "aria-describedby": t ? a : void 0
      },
      floating: l
    } : {
      reference: {
        "aria-expanded": t ? "true" : "false",
        "aria-haspopup": o === "alertdialog" ? "dialog" : o,
        "aria-controls": t ? a : void 0,
        ...o === "listbox" && {
          role: "combobox"
        },
        ...o === "menu" && {
          id: i
        }
      },
      floating: {
        ...l,
        ...o === "menu" && {
          "aria-labelledby": i
        }
      }
    } : {};
  }, [n, o, t, a, i]);
};
function jf(e) {
  e === void 0 && (e = {});
  const {
    open: r = !1,
    onOpenChange: t,
    nodeId: n
  } = e, o = ZL(e), a = Tf(), i = A.useRef(null), l = A.useRef({}), s = A.useState(() => GL())[0], [u, d] = A.useState(null), f = A.useCallback((w) => {
    const $ = an(w) ? {
      getBoundingClientRect: () => w.getBoundingClientRect(),
      contextElement: w
    } : w;
    o.refs.setReference($);
  }, [o.refs]), p = A.useCallback((w) => {
    (an(w) || w === null) && (i.current = w, d(w)), (an(o.refs.reference.current) || o.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    w !== null && !an(w)) && o.refs.setReference(w);
  }, [o.refs]), g = A.useMemo(() => ({
    ...o.refs,
    setReference: p,
    setPositionReference: f,
    domReference: i
  }), [o.refs, p, f]), h = A.useMemo(() => ({
    ...o.elements,
    domReference: u
  }), [o.elements, u]), v = kh(t), y = A.useMemo(() => ({
    ...o,
    refs: g,
    elements: h,
    dataRef: l,
    nodeId: n,
    events: s,
    open: r,
    onOpenChange: v
  }), [o, n, s, r, v, g, h]);
  return va(() => {
    const w = a == null ? void 0 : a.nodesRef.current.find(($) => $.id === n);
    w && (w.context = y);
  }), A.useMemo(() => ({
    ...o,
    context: y,
    refs: g,
    reference: p,
    positionReference: f
  }), [o, g, y, p, f]);
}
function pd(e, r, t) {
  const n = /* @__PURE__ */ new Map();
  return {
    ...t === "floating" && {
      tabIndex: -1
    },
    ...e,
    ...r.map((o) => o ? o[t] : null).concat(e).reduce((o, a) => (a && Object.entries(a).forEach((i) => {
      let [l, s] = i;
      if (l.indexOf("on") === 0) {
        if (n.has(l) || n.set(l, []), typeof s == "function") {
          var u;
          (u = n.get(l)) == null || u.push(s), o[l] = function() {
            for (var d, f = arguments.length, p = new Array(f), g = 0; g < f; g++)
              p[g] = arguments[g];
            (d = n.get(l)) == null || d.forEach((h) => h(...p));
          };
        }
      } else
        o[l] = s;
    }), o), {})
  };
}
const pz = function(e) {
  e === void 0 && (e = []);
  const r = e, t = A.useCallback(
    (a) => pd(a, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), n = A.useCallback(
    (a) => pd(a, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), o = A.useCallback(
    (a) => pd(a, e, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((a) => a == null ? void 0 : a.item)
  );
  return A.useMemo(() => ({
    getReferenceProps: t,
    getFloatingProps: n,
    getItemProps: o
  }), [t, n, o]);
};
function Mh({
  opened: e,
  floating: r,
  position: t,
  positionDependencies: n
}) {
  const [o, a] = Se(0);
  Fe(() => {
    if (r.refs.reference.current && r.refs.floating.current)
      return LL(r.refs.reference.current, r.refs.floating.current, r.update);
  }, [
    r.refs.reference.current,
    r.refs.floating.current,
    e,
    o,
    t
  ]), ct(() => {
    r.update();
  }, n), ct(() => {
    a((i) => i + 1);
  }, [e]);
}
function gz(e) {
  const r = [vh(e.offset)];
  return e.middlewares.shift && r.push(Nf({ limiter: VL() })), e.middlewares.flip && r.push($h()), e.middlewares.inline && r.push(Oh()), r.push(Ph({ element: e.arrowRef, padding: e.arrowOffset })), r;
}
function vz(e) {
  const [r, t] = Hr({
    value: e.opened,
    defaultValue: e.defaultOpened,
    finalValue: !1,
    onChange: e.onChange
  }), n = () => {
    var i;
    (i = e.onClose) == null || i.call(e), t(!1);
  }, o = () => {
    var i, l;
    r ? ((i = e.onClose) == null || i.call(e), t(!1)) : ((l = e.onOpen) == null || l.call(e), t(!0));
  }, a = jf({
    placement: e.position,
    middleware: [
      ...gz(e),
      ...e.width === "target" ? [
        zL({
          apply({ rects: i }) {
            var l, s;
            Object.assign((s = (l = a.refs.floating.current) == null ? void 0 : l.style) != null ? s : {}, {
              width: `${i.reference.width}px`
            });
          }
        })
      ] : []
    ]
  });
  return Mh({
    opened: e.opened,
    position: e.position,
    positionDependencies: e.positionDependencies,
    floating: a
  }), ct(() => {
    var i;
    (i = e.onPositionChange) == null || i.call(e, a.placement);
  }, [a.placement]), ct(() => {
    var i, l;
    e.opened ? (l = e.onOpen) == null || l.call(e) : (i = e.onClose) == null || i.call(e);
  }, [e.opened]), {
    floating: a,
    controlled: typeof e.opened == "boolean",
    opened: r,
    onClose: n,
    onToggle: o
  };
}
const Nh = {
  context: "Popover component was not found in the tree",
  children: "Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
}, [mz, Th] = no(Nh.context);
var hz = Object.defineProperty, bz = Object.defineProperties, yz = Object.getOwnPropertyDescriptors, Ls = Object.getOwnPropertySymbols, Dh = Object.prototype.hasOwnProperty, jh = Object.prototype.propertyIsEnumerable, K7 = (e, r, t) => r in e ? hz(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, cl = (e, r) => {
  for (var t in r || (r = {}))
    Dh.call(r, t) && K7(e, t, r[t]);
  if (Ls)
    for (var t of Ls(r))
      jh.call(r, t) && K7(e, t, r[t]);
  return e;
}, Cz = (e, r) => bz(e, yz(r)), wz = (e, r) => {
  var t = {};
  for (var n in e)
    Dh.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ls)
    for (var n of Ls(e))
      r.indexOf(n) < 0 && jh.call(e, n) && (t[n] = e[n]);
  return t;
};
const _z = {
  refProp: "ref",
  popupType: "dialog",
  shouldOverrideDefaultTargetId: !0
}, Lh = ue((e, r) => {
  const t = Oe("PopoverTarget", _z, e), { children: n, refProp: o, popupType: a, shouldOverrideDefaultTargetId: i } = t, l = wz(t, ["children", "refProp", "popupType", "shouldOverrideDefaultTargetId"]);
  if (!Pa(n))
    throw new Error(Nh.children);
  const s = l, u = Th(), d = Kn(u.reference, n.ref, r), f = u.withRoles ? {
    "aria-haspopup": a,
    "aria-expanded": u.opened,
    "aria-controls": u.getDropdownId(),
    id: i ? u.getTargetId() : n.props.id
  } : {};
  return Wr(n, cl(Cz(cl(cl(cl({}, s), f), u.targetProps), {
    className: Z6(u.targetProps.className, s.className, n.props.className),
    [o]: d
  }), u.controlled ? null : { onClick: u.onToggle }));
});
Lh.displayName = "@mantine/core/PopoverTarget";
var xz = Ae((e, { radius: r, shadow: t }) => ({
  dropdown: {
    position: "absolute",
    backgroundColor: e.white,
    background: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
    border: `${B(1)} solid ${e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2]}`,
    padding: `${e.spacing.sm} ${e.spacing.md}`,
    boxShadow: e.shadows[t] || t || "none",
    borderRadius: e.fn.radius(r),
    "&:focus": {
      outline: 0
    }
  },
  arrow: {
    backgroundColor: "inherit",
    border: `${B(1)} solid ${e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2]}`,
    zIndex: 1
  }
}));
const $z = xz;
var Oz = Object.defineProperty, Q7 = Object.getOwnPropertySymbols, Pz = Object.prototype.hasOwnProperty, Sz = Object.prototype.propertyIsEnumerable, e3 = (e, r, t) => r in e ? Oz(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Uo = (e, r) => {
  for (var t in r || (r = {}))
    Pz.call(r, t) && e3(e, t, r[t]);
  if (Q7)
    for (var t of Q7(r))
      Sz.call(r, t) && e3(e, t, r[t]);
  return e;
};
const r3 = {
  entering: "in",
  entered: "in",
  exiting: "out",
  exited: "out",
  "pre-exiting": "out",
  "pre-entering": "out"
};
function Iz({
  transition: e,
  state: r,
  duration: t,
  timingFunction: n
}) {
  const o = {
    transitionDuration: `${t}ms`,
    transitionTimingFunction: n
  };
  return typeof e == "string" ? e in el ? Uo(Uo(Uo({
    transitionProperty: el[e].transitionProperty
  }, o), el[e].common), el[e][r3[r]]) : null : Uo(Uo(Uo({
    transitionProperty: e.transitionProperty
  }, o), e.common), e[r3[r]]);
}
function Ez({
  duration: e,
  exitDuration: r,
  timingFunction: t,
  mounted: n,
  onEnter: o,
  onExit: a,
  onEntered: i,
  onExited: l
}) {
  const s = ft(), u = Fu(), d = s.respectReducedMotion ? u : !1, [f, p] = Se(d ? 0 : e), [g, h] = Se(n ? "entered" : "exited"), v = Ve(-1), y = (w) => {
    const $ = w ? o : a, C = w ? i : l;
    h(w ? "pre-entering" : "pre-exiting"), window.clearTimeout(v.current);
    const x = d ? 0 : w ? e : r;
    if (p(x), x === 0)
      typeof $ == "function" && $(), typeof C == "function" && C(), h(w ? "entered" : "exited");
    else {
      const b = window.setTimeout(() => {
        typeof $ == "function" && $(), h(w ? "entering" : "exiting");
      }, 10);
      v.current = window.setTimeout(() => {
        window.clearTimeout(b), typeof C == "function" && C(), h(w ? "entered" : "exited");
      }, x);
    }
  };
  return ct(() => {
    y(n);
  }, [n]), Fe(() => () => window.clearTimeout(v.current), []), {
    transitionDuration: f,
    transitionStatus: g,
    transitionTimingFunction: t || s.transitionTimingFunction
  };
}
function Ra({
  keepMounted: e,
  transition: r,
  duration: t = 250,
  exitDuration: n = t,
  mounted: o,
  children: a,
  timingFunction: i,
  onExit: l,
  onEntered: s,
  onEnter: u,
  onExited: d
}) {
  const { transitionDuration: f, transitionStatus: p, transitionTimingFunction: g } = Ez({
    mounted: o,
    exitDuration: n,
    duration: t,
    timingFunction: i,
    onExit: l,
    onEntered: s,
    onEnter: u,
    onExited: d
  });
  return f === 0 ? o ? /* @__PURE__ */ E.createElement(E.Fragment, null, a({})) : e ? a({ display: "none" }) : null : p === "exited" ? e ? a({ display: "none" }) : null : /* @__PURE__ */ E.createElement(E.Fragment, null, a(Iz({
    transition: r,
    duration: f,
    state: p,
    timingFunction: g
  })));
}
Ra.displayName = "@mantine/core/Transition";
function Lf({
  children: e,
  active: r = !0,
  refProp: t = "ref"
}) {
  const n = qO(r), o = Kn(n, e == null ? void 0 : e.ref);
  return Pa(e) ? Wr(e, { [t]: o }) : e;
}
Lf.displayName = "@mantine/core/FocusTrap";
var Rz = Object.defineProperty, Az = Object.defineProperties, kz = Object.getOwnPropertyDescriptors, t3 = Object.getOwnPropertySymbols, Mz = Object.prototype.hasOwnProperty, Nz = Object.prototype.propertyIsEnumerable, n3 = (e, r, t) => r in e ? Rz(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Vn = (e, r) => {
  for (var t in r || (r = {}))
    Mz.call(r, t) && n3(e, t, r[t]);
  if (t3)
    for (var t of t3(r))
      Nz.call(r, t) && n3(e, t, r[t]);
  return e;
}, ul = (e, r) => Az(e, kz(r));
function o3(e, r, t, n) {
  return e === "center" || n === "center" ? { top: r } : e === "end" ? { bottom: t } : e === "start" ? { top: t } : {};
}
function a3(e, r, t, n, o) {
  return e === "center" || n === "center" ? { left: r } : e === "end" ? { [o === "ltr" ? "right" : "left"]: t } : e === "start" ? { [o === "ltr" ? "left" : "right"]: t } : {};
}
const Tz = {
  bottom: "borderTopLeftRadius",
  left: "borderTopRightRadius",
  right: "borderBottomLeftRadius",
  top: "borderBottomRightRadius"
};
function Dz({
  position: e,
  arrowSize: r,
  arrowOffset: t,
  arrowRadius: n,
  arrowPosition: o,
  arrowX: a,
  arrowY: i,
  dir: l
}) {
  const [s, u = "center"] = e.split("-"), d = {
    width: B(r),
    height: B(r),
    transform: "rotate(45deg)",
    position: "absolute",
    [Tz[s]]: B(n)
  }, f = B(-r / 2);
  return s === "left" ? ul(Vn(Vn({}, d), o3(u, i, t, o)), {
    right: f,
    borderLeftColor: "transparent",
    borderBottomColor: "transparent"
  }) : s === "right" ? ul(Vn(Vn({}, d), o3(u, i, t, o)), {
    left: f,
    borderRightColor: "transparent",
    borderTopColor: "transparent"
  }) : s === "top" ? ul(Vn(Vn({}, d), a3(u, a, t, o, l)), {
    bottom: f,
    borderTopColor: "transparent",
    borderLeftColor: "transparent"
  }) : s === "bottom" ? ul(Vn(Vn({}, d), a3(u, a, t, o, l)), {
    top: f,
    borderBottomColor: "transparent",
    borderRightColor: "transparent"
  }) : {};
}
var jz = Object.defineProperty, Lz = Object.defineProperties, zz = Object.getOwnPropertyDescriptors, zs = Object.getOwnPropertySymbols, zh = Object.prototype.hasOwnProperty, Vh = Object.prototype.propertyIsEnumerable, i3 = (e, r, t) => r in e ? jz(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Vz = (e, r) => {
  for (var t in r || (r = {}))
    zh.call(r, t) && i3(e, t, r[t]);
  if (zs)
    for (var t of zs(r))
      Vh.call(r, t) && i3(e, t, r[t]);
  return e;
}, Fz = (e, r) => Lz(e, zz(r)), Zz = (e, r) => {
  var t = {};
  for (var n in e)
    zh.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && zs)
    for (var n of zs(e))
      r.indexOf(n) < 0 && Vh.call(e, n) && (t[n] = e[n]);
  return t;
};
const zf = ue((e, r) => {
  var t = e, {
    position: n,
    arrowSize: o,
    arrowOffset: a,
    arrowRadius: i,
    arrowPosition: l,
    visible: s,
    arrowX: u,
    arrowY: d
  } = t, f = Zz(t, [
    "position",
    "arrowSize",
    "arrowOffset",
    "arrowRadius",
    "arrowPosition",
    "visible",
    "arrowX",
    "arrowY"
  ]);
  const p = ft();
  return s ? /* @__PURE__ */ E.createElement("div", Fz(Vz({}, f), {
    ref: r,
    style: Dz({
      position: n,
      arrowSize: o,
      arrowOffset: a,
      arrowRadius: i,
      arrowPosition: l,
      dir: p.dir,
      arrowX: u,
      arrowY: d
    })
  })) : null;
});
zf.displayName = "@mantine/core/FloatingArrow";
var Wz = Object.defineProperty, Bz = Object.defineProperties, Hz = Object.getOwnPropertyDescriptors, Vs = Object.getOwnPropertySymbols, Fh = Object.prototype.hasOwnProperty, Zh = Object.prototype.propertyIsEnumerable, l3 = (e, r, t) => r in e ? Wz(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Jo = (e, r) => {
  for (var t in r || (r = {}))
    Fh.call(r, t) && l3(e, t, r[t]);
  if (Vs)
    for (var t of Vs(r))
      Zh.call(r, t) && l3(e, t, r[t]);
  return e;
}, dl = (e, r) => Bz(e, Hz(r)), Gz = (e, r) => {
  var t = {};
  for (var n in e)
    Fh.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Vs)
    for (var n of Vs(e))
      r.indexOf(n) < 0 && Zh.call(e, n) && (t[n] = e[n]);
  return t;
};
const Xz = {};
function Wh(e) {
  var r;
  const t = Oe("PopoverDropdown", Xz, e), { style: n, className: o, children: a, onKeyDownCapture: i } = t, l = Gz(t, ["style", "className", "children", "onKeyDownCapture"]), s = Th(), { classes: u, cx: d } = $z({ radius: s.radius, shadow: s.shadow }, {
    name: s.__staticSelector,
    classNames: s.classNames,
    styles: s.styles,
    unstyled: s.unstyled,
    variant: s.variant
  }), f = n8({
    opened: s.opened,
    shouldReturnFocus: s.returnFocus
  }), p = s.withRoles ? {
    "aria-labelledby": s.getTargetId(),
    id: s.getDropdownId(),
    role: "dialog"
  } : {};
  return s.disabled ? null : /* @__PURE__ */ E.createElement(Sa, dl(Jo({}, s.portalProps), {
    withinPortal: s.withinPortal
  }), /* @__PURE__ */ E.createElement(Ra, dl(Jo({
    mounted: s.opened
  }, s.transitionProps), {
    transition: s.transitionProps.transition || "fade",
    duration: (r = s.transitionProps.duration) != null ? r : 150,
    keepMounted: s.keepMounted,
    exitDuration: typeof s.transitionProps.exitDuration == "number" ? s.transitionProps.exitDuration : s.transitionProps.duration
  }), (g) => {
    var h, v;
    return /* @__PURE__ */ E.createElement(Lf, {
      active: s.trapFocus
    }, /* @__PURE__ */ E.createElement(We, Jo(dl(Jo({}, p), {
      tabIndex: -1,
      ref: s.floating,
      style: dl(Jo(Jo({}, n), g), {
        zIndex: s.zIndex,
        top: (h = s.y) != null ? h : 0,
        left: (v = s.x) != null ? v : 0,
        width: s.width === "target" ? void 0 : B(s.width)
      }),
      className: d(u.dropdown, o),
      onKeyDownCapture: Uk(s.onClose, {
        active: s.closeOnEscape,
        onTrigger: f,
        onKeyDown: i
      }),
      "data-position": s.placement
    }), l), a, /* @__PURE__ */ E.createElement(zf, {
      ref: s.arrowRef,
      arrowX: s.arrowX,
      arrowY: s.arrowY,
      visible: s.withArrow,
      position: s.placement,
      arrowSize: s.arrowSize,
      arrowRadius: s.arrowRadius,
      arrowOffset: s.arrowOffset,
      arrowPosition: s.arrowPosition,
      className: u.arrow
    })));
  }));
}
Wh.displayName = "@mantine/core/PopoverDropdown";
function Bh(e, r) {
  if (e === "rtl" && (r.includes("right") || r.includes("left"))) {
    const [t, n] = r.split("-"), o = t === "right" ? "left" : "right";
    return n === void 0 ? o : `${o}-${n}`;
  }
  return r;
}
var s3 = Object.getOwnPropertySymbols, Yz = Object.prototype.hasOwnProperty, Uz = Object.prototype.propertyIsEnumerable, Jz = (e, r) => {
  var t = {};
  for (var n in e)
    Yz.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && s3)
    for (var n of s3(e))
      r.indexOf(n) < 0 && Uz.call(e, n) && (t[n] = e[n]);
  return t;
};
const qz = {
  position: "bottom",
  offset: 8,
  positionDependencies: [],
  transitionProps: { transition: "fade", duration: 150 },
  middlewares: { flip: !0, shift: !0, inline: !1 },
  arrowSize: 7,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  closeOnClickOutside: !0,
  withinPortal: !1,
  closeOnEscape: !0,
  trapFocus: !1,
  withRoles: !0,
  returnFocus: !1,
  clickOutsideEvents: ["mousedown", "touchstart"],
  zIndex: In("popover"),
  __staticSelector: "Popover",
  width: "max-content"
};
function nt(e) {
  var r, t, n, o, a, i;
  const l = Ve(null), s = Oe("Popover", qz, e), {
    children: u,
    position: d,
    offset: f,
    onPositionChange: p,
    positionDependencies: g,
    opened: h,
    transitionProps: v,
    width: y,
    middlewares: w,
    withArrow: $,
    arrowSize: C,
    arrowOffset: x,
    arrowRadius: b,
    arrowPosition: O,
    unstyled: _,
    classNames: P,
    styles: S,
    closeOnClickOutside: I,
    withinPortal: N,
    portalProps: k,
    closeOnEscape: j,
    clickOutsideEvents: R,
    trapFocus: D,
    onClose: T,
    onOpen: V,
    onChange: L,
    zIndex: Z,
    radius: z,
    shadow: W,
    id: U,
    defaultOpened: re,
    __staticSelector: X,
    withRoles: J,
    disabled: Q,
    returnFocus: se,
    variant: q,
    keepMounted: te
  } = s, ae = Jz(s, [
    "children",
    "position",
    "offset",
    "onPositionChange",
    "positionDependencies",
    "opened",
    "transitionProps",
    "width",
    "middlewares",
    "withArrow",
    "arrowSize",
    "arrowOffset",
    "arrowRadius",
    "arrowPosition",
    "unstyled",
    "classNames",
    "styles",
    "closeOnClickOutside",
    "withinPortal",
    "portalProps",
    "closeOnEscape",
    "clickOutsideEvents",
    "trapFocus",
    "onClose",
    "onOpen",
    "onChange",
    "zIndex",
    "radius",
    "shadow",
    "id",
    "defaultOpened",
    "__staticSelector",
    "withRoles",
    "disabled",
    "returnFocus",
    "variant",
    "keepMounted"
  ]), [ge, G] = Se(null), [oe, ne] = Se(null), _e = ke(U), ye = ft(), Te = vz({
    middlewares: w,
    width: y,
    position: Bh(ye.dir, d),
    offset: typeof f == "number" ? f + ($ ? C / 2 : 0) : f,
    arrowRef: l,
    arrowOffset: x,
    onPositionChange: p,
    positionDependencies: g,
    opened: h,
    defaultOpened: re,
    onChange: L,
    onOpen: V,
    onClose: T
  });
  r8(() => Te.opened && I && Te.onClose(), R, [ge, oe]);
  const we = $e((he) => {
    G(he), Te.floating.reference(he);
  }, [Te.floating.reference]), He = $e((he) => {
    ne(he), Te.floating.floating(he);
  }, [Te.floating.floating]);
  return /* @__PURE__ */ E.createElement(mz, {
    value: {
      returnFocus: se,
      disabled: Q,
      controlled: Te.controlled,
      reference: we,
      floating: He,
      x: Te.floating.x,
      y: Te.floating.y,
      arrowX: (n = (t = (r = Te.floating) == null ? void 0 : r.middlewareData) == null ? void 0 : t.arrow) == null ? void 0 : n.x,
      arrowY: (i = (a = (o = Te.floating) == null ? void 0 : o.middlewareData) == null ? void 0 : a.arrow) == null ? void 0 : i.y,
      opened: Te.opened,
      arrowRef: l,
      transitionProps: v,
      width: y,
      withArrow: $,
      arrowSize: C,
      arrowOffset: x,
      arrowRadius: b,
      arrowPosition: O,
      placement: Te.floating.placement,
      trapFocus: D,
      withinPortal: N,
      portalProps: k,
      zIndex: Z,
      radius: z,
      shadow: W,
      closeOnEscape: j,
      onClose: Te.onClose,
      onToggle: Te.onToggle,
      getTargetId: () => `${_e}-target`,
      getDropdownId: () => `${_e}-dropdown`,
      withRoles: J,
      targetProps: ae,
      __staticSelector: X,
      classNames: P,
      styles: S,
      unstyled: _,
      variant: q,
      keepMounted: te
    }
  }, u);
}
nt.Target = Lh;
nt.Dropdown = Wh;
nt.displayName = "@mantine/core/Popover";
var Kz = Object.defineProperty, Fs = Object.getOwnPropertySymbols, Hh = Object.prototype.hasOwnProperty, Gh = Object.prototype.propertyIsEnumerable, c3 = (e, r, t) => r in e ? Kz(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Qz = (e, r) => {
  for (var t in r || (r = {}))
    Hh.call(r, t) && c3(e, t, r[t]);
  if (Fs)
    for (var t of Fs(r))
      Gh.call(r, t) && c3(e, t, r[t]);
  return e;
}, eV = (e, r) => {
  var t = {};
  for (var n in e)
    Hh.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Fs)
    for (var n of Fs(e))
      r.indexOf(n) < 0 && Gh.call(e, n) && (t[n] = e[n]);
  return t;
};
function rV(e) {
  var r = e, {
    children: t,
    component: n = "div",
    maxHeight: o = 220,
    direction: a = "column",
    id: i,
    innerRef: l,
    __staticSelector: s,
    styles: u,
    classNames: d,
    unstyled: f
  } = r, p = eV(r, [
    "children",
    "component",
    "maxHeight",
    "direction",
    "id",
    "innerRef",
    "__staticSelector",
    "styles",
    "classNames",
    "unstyled"
  ]);
  const { classes: g } = nL(null, { name: s, styles: u, classNames: d, unstyled: f });
  return /* @__PURE__ */ E.createElement(nt.Dropdown, Qz({
    p: 0,
    onMouseDown: (h) => h.preventDefault()
  }, p), /* @__PURE__ */ E.createElement("div", {
    style: { maxHeight: B(o), display: "flex" }
  }, /* @__PURE__ */ E.createElement(We, {
    component: n || "div",
    id: `${i}-items`,
    "aria-labelledby": `${i}-label`,
    role: "listbox",
    onMouseDown: (h) => h.preventDefault(),
    style: { flex: 1, overflowY: n !== h1 ? "auto" : void 0 },
    "data-combobox-popover": !0,
    tabIndex: -1,
    ref: l
  }, /* @__PURE__ */ E.createElement("div", {
    className: g.itemsWrapper,
    style: { flexDirection: a }
  }, t))));
}
function Yn({
  opened: e,
  transitionProps: r = { transition: "fade", duration: 0 },
  shadow: t,
  withinPortal: n,
  portalProps: o,
  children: a,
  __staticSelector: i,
  onDirectionChange: l,
  switchDirectionOnFlip: s,
  zIndex: u,
  dropdownPosition: d,
  positionDependencies: f = [],
  classNames: p,
  styles: g,
  unstyled: h,
  readOnly: v,
  variant: y
}) {
  return /* @__PURE__ */ E.createElement(nt, {
    unstyled: h,
    classNames: p,
    styles: g,
    width: "target",
    withRoles: !1,
    opened: e,
    middlewares: { flip: d === "flip", shift: !1 },
    position: d === "flip" ? "bottom" : d,
    positionDependencies: f,
    zIndex: u,
    __staticSelector: i,
    withinPortal: n,
    portalProps: o,
    transitionProps: r,
    shadow: t,
    disabled: v,
    onPositionChange: (w) => s && (l == null ? void 0 : l(w === "top" ? "column-reverse" : "column")),
    variant: y
  }, a);
}
Yn.Target = nt.Target;
Yn.Dropdown = rV;
function tV({ data: e, limit: r, value: t, filter: n }) {
  const o = [];
  for (let a = 0; a < e.length && (n(t, e[a]) && o.push(e[a]), !(o.length >= r)); a += 1)
    ;
  return o;
}
var nV = Ae(() => ({
  wrapper: {
    position: "relative"
  }
})), oV = Object.defineProperty, aV = Object.defineProperties, iV = Object.getOwnPropertyDescriptors, Zs = Object.getOwnPropertySymbols, Xh = Object.prototype.hasOwnProperty, Yh = Object.prototype.propertyIsEnumerable, u3 = (e, r, t) => r in e ? oV(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, fl = (e, r) => {
  for (var t in r || (r = {}))
    Xh.call(r, t) && u3(e, t, r[t]);
  if (Zs)
    for (var t of Zs(r))
      Yh.call(r, t) && u3(e, t, r[t]);
  return e;
}, lV = (e, r) => aV(e, iV(r)), sV = (e, r) => {
  var t = {};
  for (var n in e)
    Xh.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Zs)
    for (var n of Zs(e))
      r.indexOf(n) < 0 && Yh.call(e, n) && (t[n] = e[n]);
  return t;
};
function Ti(e, r, t) {
  const n = Oe(e, r, t), {
    label: o,
    description: a,
    error: i,
    required: l,
    classNames: s,
    styles: u,
    className: d,
    unstyled: f,
    __staticSelector: p,
    sx: g,
    errorProps: h,
    labelProps: v,
    descriptionProps: y,
    wrapperProps: w,
    id: $,
    size: C,
    style: x,
    inputContainer: b,
    inputWrapperOrder: O,
    withAsterisk: _,
    variant: P
  } = n, S = sV(n, [
    "label",
    "description",
    "error",
    "required",
    "classNames",
    "styles",
    "className",
    "unstyled",
    "__staticSelector",
    "sx",
    "errorProps",
    "labelProps",
    "descriptionProps",
    "wrapperProps",
    "id",
    "size",
    "style",
    "inputContainer",
    "inputWrapperOrder",
    "withAsterisk",
    "variant"
  ]), I = ke($), { systemStyles: N, rest: k } = En(S), j = fl({
    label: o,
    description: a,
    error: i,
    required: l,
    classNames: s,
    className: d,
    __staticSelector: p,
    sx: g,
    errorProps: h,
    labelProps: v,
    descriptionProps: y,
    unstyled: f,
    styles: u,
    id: I,
    size: C,
    style: x,
    inputContainer: b,
    inputWrapperOrder: O,
    withAsterisk: _,
    variant: P
  }, w);
  return lV(fl({}, k), {
    classNames: s,
    styles: u,
    unstyled: f,
    wrapperProps: fl(fl({}, j), N),
    inputProps: {
      required: l,
      classNames: s,
      styles: u,
      unstyled: f,
      id: I,
      size: C,
      __staticSelector: p,
      error: i,
      variant: P
    }
  });
}
var cV = Ae((e, r, { size: t }) => ({
  label: {
    display: "inline-block",
    fontSize: ve({ size: t, sizes: e.fontSizes }),
    fontWeight: 500,
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.gray[9],
    wordBreak: "break-word",
    cursor: "default",
    WebkitTapHighlightColor: "transparent"
  },
  required: {
    color: e.fn.variant({ variant: "filled", color: "red" }).background
  }
})), uV = Object.defineProperty, Ws = Object.getOwnPropertySymbols, Uh = Object.prototype.hasOwnProperty, Jh = Object.prototype.propertyIsEnumerable, d3 = (e, r, t) => r in e ? uV(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, dV = (e, r) => {
  for (var t in r || (r = {}))
    Uh.call(r, t) && d3(e, t, r[t]);
  if (Ws)
    for (var t of Ws(r))
      Jh.call(r, t) && d3(e, t, r[t]);
  return e;
}, fV = (e, r) => {
  var t = {};
  for (var n in e)
    Uh.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ws)
    for (var n of Ws(e))
      r.indexOf(n) < 0 && Jh.call(e, n) && (t[n] = e[n]);
  return t;
};
const pV = {
  labelElement: "label",
  size: "sm"
}, Vf = ue((e, r) => {
  const t = Oe("InputLabel", pV, e), {
    labelElement: n,
    children: o,
    required: a,
    size: i,
    classNames: l,
    styles: s,
    unstyled: u,
    className: d,
    htmlFor: f,
    __staticSelector: p,
    variant: g,
    onMouseDown: h
  } = t, v = fV(t, [
    "labelElement",
    "children",
    "required",
    "size",
    "classNames",
    "styles",
    "unstyled",
    "className",
    "htmlFor",
    "__staticSelector",
    "variant",
    "onMouseDown"
  ]), { classes: y, cx: w } = cV(null, {
    name: ["InputWrapper", p],
    classNames: l,
    styles: s,
    unstyled: u,
    variant: g,
    size: i
  });
  return /* @__PURE__ */ E.createElement(We, dV({
    component: n,
    ref: r,
    className: w(y.label, d),
    htmlFor: n === "label" ? f : void 0,
    onMouseDown: ($) => {
      h == null || h($), !$.defaultPrevented && $.detail > 1 && $.preventDefault();
    }
  }, v), o, a && /* @__PURE__ */ E.createElement("span", {
    className: y.required,
    "aria-hidden": !0
  }, " *"));
});
Vf.displayName = "@mantine/core/InputLabel";
var gV = Ae((e, r, { size: t }) => ({
  error: {
    wordBreak: "break-word",
    color: e.fn.variant({ variant: "filled", color: "red" }).background,
    fontSize: `calc(${ve({ size: t, sizes: e.fontSizes })} - ${B(2)})`,
    lineHeight: 1.2,
    display: "block"
  }
})), vV = Object.defineProperty, Bs = Object.getOwnPropertySymbols, qh = Object.prototype.hasOwnProperty, Kh = Object.prototype.propertyIsEnumerable, f3 = (e, r, t) => r in e ? vV(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, mV = (e, r) => {
  for (var t in r || (r = {}))
    qh.call(r, t) && f3(e, t, r[t]);
  if (Bs)
    for (var t of Bs(r))
      Kh.call(r, t) && f3(e, t, r[t]);
  return e;
}, hV = (e, r) => {
  var t = {};
  for (var n in e)
    qh.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Bs)
    for (var n of Bs(e))
      r.indexOf(n) < 0 && Kh.call(e, n) && (t[n] = e[n]);
  return t;
};
const bV = {
  size: "sm"
}, Ff = ue((e, r) => {
  const t = Oe("InputError", bV, e), {
    children: n,
    className: o,
    classNames: a,
    styles: i,
    unstyled: l,
    size: s,
    __staticSelector: u,
    variant: d
  } = t, f = hV(t, [
    "children",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "size",
    "__staticSelector",
    "variant"
  ]), { classes: p, cx: g } = gV(null, {
    name: ["InputWrapper", u],
    classNames: a,
    styles: i,
    unstyled: l,
    variant: d,
    size: s
  });
  return /* @__PURE__ */ E.createElement(Ia, mV({
    className: g(p.error, o),
    ref: r
  }, f), n);
});
Ff.displayName = "@mantine/core/InputError";
var yV = Ae((e, r, { size: t }) => ({
  description: {
    wordBreak: "break-word",
    color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6],
    fontSize: `calc(${ve({ size: t, sizes: e.fontSizes })} - ${B(2)})`,
    lineHeight: 1.2,
    display: "block"
  }
})), CV = Object.defineProperty, Hs = Object.getOwnPropertySymbols, Qh = Object.prototype.hasOwnProperty, eb = Object.prototype.propertyIsEnumerable, p3 = (e, r, t) => r in e ? CV(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, wV = (e, r) => {
  for (var t in r || (r = {}))
    Qh.call(r, t) && p3(e, t, r[t]);
  if (Hs)
    for (var t of Hs(r))
      eb.call(r, t) && p3(e, t, r[t]);
  return e;
}, _V = (e, r) => {
  var t = {};
  for (var n in e)
    Qh.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Hs)
    for (var n of Hs(e))
      r.indexOf(n) < 0 && eb.call(e, n) && (t[n] = e[n]);
  return t;
};
const xV = {
  size: "sm"
}, Zf = ue((e, r) => {
  const t = Oe("InputDescription", xV, e), {
    children: n,
    className: o,
    classNames: a,
    styles: i,
    unstyled: l,
    size: s,
    __staticSelector: u,
    variant: d
  } = t, f = _V(t, [
    "children",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "size",
    "__staticSelector",
    "variant"
  ]), { classes: p, cx: g } = yV(null, {
    name: ["InputWrapper", u],
    classNames: a,
    styles: i,
    unstyled: l,
    variant: d,
    size: s
  });
  return /* @__PURE__ */ E.createElement(Ia, wV({
    color: "dimmed",
    className: g(p.description, o),
    ref: r,
    unstyled: l
  }, f), n);
});
Zf.displayName = "@mantine/core/InputDescription";
const rb = xt({
  offsetBottom: !1,
  offsetTop: !1,
  describedBy: void 0
}), $V = rb.Provider, OV = () => dt(rb);
function PV(e, { hasDescription: r, hasError: t }) {
  const n = e.findIndex((s) => s === "input"), o = e[n - 1], a = e[n + 1];
  return { offsetBottom: r && a === "description" || t && a === "error", offsetTop: r && o === "description" || t && o === "error" };
}
var SV = Object.defineProperty, IV = Object.defineProperties, EV = Object.getOwnPropertyDescriptors, g3 = Object.getOwnPropertySymbols, RV = Object.prototype.hasOwnProperty, AV = Object.prototype.propertyIsEnumerable, v3 = (e, r, t) => r in e ? SV(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, kV = (e, r) => {
  for (var t in r || (r = {}))
    RV.call(r, t) && v3(e, t, r[t]);
  if (g3)
    for (var t of g3(r))
      AV.call(r, t) && v3(e, t, r[t]);
  return e;
}, MV = (e, r) => IV(e, EV(r)), NV = Ae((e) => ({
  root: MV(kV({}, e.fn.fontStyles()), {
    lineHeight: e.lineHeight
  })
})), TV = Object.defineProperty, DV = Object.defineProperties, jV = Object.getOwnPropertyDescriptors, Gs = Object.getOwnPropertySymbols, tb = Object.prototype.hasOwnProperty, nb = Object.prototype.propertyIsEnumerable, m3 = (e, r, t) => r in e ? TV(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Fn = (e, r) => {
  for (var t in r || (r = {}))
    tb.call(r, t) && m3(e, t, r[t]);
  if (Gs)
    for (var t of Gs(r))
      nb.call(r, t) && m3(e, t, r[t]);
  return e;
}, h3 = (e, r) => DV(e, jV(r)), LV = (e, r) => {
  var t = {};
  for (var n in e)
    tb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Gs)
    for (var n of Gs(e))
      r.indexOf(n) < 0 && nb.call(e, n) && (t[n] = e[n]);
  return t;
};
const zV = {
  labelElement: "label",
  size: "sm",
  inputContainer: (e) => e,
  inputWrapperOrder: ["label", "description", "input", "error"]
}, ob = ue((e, r) => {
  const t = Oe("InputWrapper", zV, e), {
    className: n,
    label: o,
    children: a,
    required: i,
    id: l,
    error: s,
    description: u,
    labelElement: d,
    labelProps: f,
    descriptionProps: p,
    errorProps: g,
    classNames: h,
    styles: v,
    size: y,
    inputContainer: w,
    __staticSelector: $,
    unstyled: C,
    inputWrapperOrder: x,
    withAsterisk: b,
    variant: O
  } = t, _ = LV(t, [
    "className",
    "label",
    "children",
    "required",
    "id",
    "error",
    "description",
    "labelElement",
    "labelProps",
    "descriptionProps",
    "errorProps",
    "classNames",
    "styles",
    "size",
    "inputContainer",
    "__staticSelector",
    "unstyled",
    "inputWrapperOrder",
    "withAsterisk",
    "variant"
  ]), { classes: P, cx: S } = NV(null, {
    classNames: h,
    styles: v,
    name: ["InputWrapper", $],
    unstyled: C,
    variant: O,
    size: y
  }), I = {
    classNames: h,
    styles: v,
    unstyled: C,
    size: y,
    variant: O,
    __staticSelector: $
  }, N = typeof b == "boolean" ? b : i, k = l ? `${l}-error` : g == null ? void 0 : g.id, j = l ? `${l}-description` : p == null ? void 0 : p.id, D = `${!!s && typeof s != "boolean" ? k : ""} ${u ? j : ""}`, T = D.trim().length > 0 ? D.trim() : void 0, V = o && /* @__PURE__ */ E.createElement(Vf, Fn(Fn({
    key: "label",
    labelElement: d,
    id: l ? `${l}-label` : void 0,
    htmlFor: l,
    required: N
  }, I), f), o), L = u && /* @__PURE__ */ E.createElement(Zf, h3(Fn(Fn({
    key: "description"
  }, p), I), {
    size: (p == null ? void 0 : p.size) || I.size,
    id: (p == null ? void 0 : p.id) || j
  }), u), Z = /* @__PURE__ */ E.createElement(ca, {
    key: "input"
  }, w(a)), z = typeof s != "boolean" && s && /* @__PURE__ */ E.createElement(Ff, h3(Fn(Fn({}, g), I), {
    size: (g == null ? void 0 : g.size) || I.size,
    key: "error",
    id: (g == null ? void 0 : g.id) || k
  }), s), W = x.map((U) => {
    switch (U) {
      case "label":
        return V;
      case "input":
        return Z;
      case "description":
        return L;
      case "error":
        return z;
      default:
        return null;
    }
  });
  return /* @__PURE__ */ E.createElement($V, {
    value: Fn({
      describedBy: T
    }, PV(x, {
      hasDescription: !!L,
      hasError: !!z
    }))
  }, /* @__PURE__ */ E.createElement(We, Fn({
    className: S(P.root, n),
    ref: r
  }, _), W));
});
ob.displayName = "@mantine/core/InputWrapper";
var VV = Object.defineProperty, Xs = Object.getOwnPropertySymbols, ab = Object.prototype.hasOwnProperty, ib = Object.prototype.propertyIsEnumerable, b3 = (e, r, t) => r in e ? VV(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, FV = (e, r) => {
  for (var t in r || (r = {}))
    ab.call(r, t) && b3(e, t, r[t]);
  if (Xs)
    for (var t of Xs(r))
      ib.call(r, t) && b3(e, t, r[t]);
  return e;
}, ZV = (e, r) => {
  var t = {};
  for (var n in e)
    ab.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Xs)
    for (var n of Xs(e))
      r.indexOf(n) < 0 && ib.call(e, n) && (t[n] = e[n]);
  return t;
};
const WV = {}, lb = ue((e, r) => {
  const t = Oe("InputPlaceholder", WV, e), { sx: n } = t, o = ZV(t, ["sx"]);
  return /* @__PURE__ */ E.createElement(We, FV({
    component: "span",
    sx: [(a) => a.fn.placeholderStyles(), ...f1(n)],
    ref: r
  }, o));
});
lb.displayName = "@mantine/core/InputPlaceholder";
var BV = Object.defineProperty, HV = Object.defineProperties, GV = Object.getOwnPropertyDescriptors, y3 = Object.getOwnPropertySymbols, XV = Object.prototype.hasOwnProperty, YV = Object.prototype.propertyIsEnumerable, C3 = (e, r, t) => r in e ? BV(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, pl = (e, r) => {
  for (var t in r || (r = {}))
    XV.call(r, t) && C3(e, t, r[t]);
  if (y3)
    for (var t of y3(r))
      YV.call(r, t) && C3(e, t, r[t]);
  return e;
}, gd = (e, r) => HV(e, GV(r));
const ot = {
  xs: B(30),
  sm: B(36),
  md: B(42),
  lg: B(50),
  xl: B(60)
}, UV = ["default", "filled", "unstyled"];
function JV({ theme: e, variant: r }) {
  return UV.includes(r) ? r === "default" ? {
    border: `${B(1)} solid ${e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4]}`,
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
    transition: "border-color 100ms ease",
    "&:focus, &:focus-within": e.focusRingStyles.inputStyles(e)
  } : r === "filled" ? {
    border: `${B(1)} solid transparent`,
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[1],
    "&:focus, &:focus-within": e.focusRingStyles.inputStyles(e)
  } : {
    borderWidth: 0,
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    backgroundColor: "transparent",
    minHeight: B(28),
    outline: 0,
    "&:focus, &:focus-within": {
      outline: "none",
      borderColor: "transparent"
    },
    "&:disabled": {
      backgroundColor: "transparent",
      "&:focus, &:focus-within": {
        outline: "none",
        borderColor: "transparent"
      }
    }
  } : null;
}
var qV = Ae((e, {
  multiline: r,
  radius: t,
  invalid: n,
  rightSectionWidth: o,
  withRightSection: a,
  iconWidth: i,
  offsetBottom: l,
  offsetTop: s,
  pointer: u
}, { variant: d, size: f }) => {
  const p = e.fn.variant({
    variant: "filled",
    color: "red"
  }).background, g = d === "default" || d === "filled" ? {
    minHeight: ve({ size: f, sizes: ot }),
    paddingLeft: `calc(${ve({ size: f, sizes: ot })}  / 3)`,
    paddingRight: a ? o || ve({ size: f, sizes: ot }) : `calc(${ve({ size: f, sizes: ot })}  / 3)`,
    borderRadius: e.fn.radius(t)
  } : d === "unstyled" && a ? {
    paddingRight: o || ve({ size: f, sizes: ot })
  } : null;
  return {
    wrapper: {
      position: "relative",
      marginTop: s ? `calc(${e.spacing.xs} / 2)` : void 0,
      marginBottom: l ? `calc(${e.spacing.xs} / 2)` : void 0,
      "&:has(input:disabled)": {
        "& .mantine-Input-rightSection": {
          display: "none"
        }
      }
    },
    input: gd(pl(pl(gd(pl({}, e.fn.fontStyles()), {
      height: r ? d === "unstyled" ? void 0 : "auto" : ve({ size: f, sizes: ot }),
      WebkitTapHighlightColor: "transparent",
      lineHeight: r ? e.lineHeight : `calc(${ve({ size: f, sizes: ot })} - ${B(2)})`,
      appearance: "none",
      resize: "none",
      boxSizing: "border-box",
      fontSize: ve({ size: f, sizes: e.fontSizes }),
      width: "100%",
      color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
      display: "block",
      textAlign: "left",
      cursor: u ? "pointer" : void 0
    }), JV({ theme: e, variant: d })), g), {
      "&:disabled, &[data-disabled]": {
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[1],
        color: e.colors.dark[2],
        opacity: 0.6,
        cursor: "not-allowed",
        pointerEvents: "none",
        "&::placeholder": {
          color: e.colors.dark[2]
        }
      },
      "&[data-invalid]": {
        color: p,
        borderColor: p,
        "&::placeholder": {
          opacity: 1,
          color: p
        }
      },
      "&[data-with-icon]": {
        paddingLeft: typeof i == "number" ? B(i) : ve({ size: f, sizes: ot })
      },
      "&::placeholder": gd(pl({}, e.fn.placeholderStyles()), {
        opacity: 1
      }),
      "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button, &::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration": {
        appearance: "none"
      },
      "&[type=number]": {
        MozAppearance: "textfield"
      }
    }),
    icon: {
      pointerEvents: "none",
      position: "absolute",
      zIndex: 1,
      left: 0,
      top: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: i ? B(i) : ve({ size: f, sizes: ot }),
      color: n ? e.colors.red[e.colorScheme === "dark" ? 6 : 7] : e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[5]
    },
    rightSection: {
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: o || ve({ size: f, sizes: ot })
    }
  };
});
const KV = qV;
var QV = Object.defineProperty, eF = Object.defineProperties, rF = Object.getOwnPropertyDescriptors, Ys = Object.getOwnPropertySymbols, sb = Object.prototype.hasOwnProperty, cb = Object.prototype.propertyIsEnumerable, w3 = (e, r, t) => r in e ? QV(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, gl = (e, r) => {
  for (var t in r || (r = {}))
    sb.call(r, t) && w3(e, t, r[t]);
  if (Ys)
    for (var t of Ys(r))
      cb.call(r, t) && w3(e, t, r[t]);
  return e;
}, _3 = (e, r) => eF(e, rF(r)), tF = (e, r) => {
  var t = {};
  for (var n in e)
    sb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ys)
    for (var n of Ys(e))
      r.indexOf(n) < 0 && cb.call(e, n) && (t[n] = e[n]);
  return t;
};
const nF = {
  size: "sm",
  variant: "default"
}, Lo = ue((e, r) => {
  const t = Oe("Input", nF, e), {
    className: n,
    error: o,
    required: a,
    disabled: i,
    variant: l,
    icon: s,
    style: u,
    rightSectionWidth: d,
    iconWidth: f,
    rightSection: p,
    rightSectionProps: g,
    radius: h,
    size: v,
    wrapperProps: y,
    classNames: w,
    styles: $,
    __staticSelector: C,
    multiline: x,
    sx: b,
    unstyled: O,
    pointer: _
  } = t, P = tF(t, [
    "className",
    "error",
    "required",
    "disabled",
    "variant",
    "icon",
    "style",
    "rightSectionWidth",
    "iconWidth",
    "rightSection",
    "rightSectionProps",
    "radius",
    "size",
    "wrapperProps",
    "classNames",
    "styles",
    "__staticSelector",
    "multiline",
    "sx",
    "unstyled",
    "pointer"
  ]), { offsetBottom: S, offsetTop: I, describedBy: N } = OV(), { classes: k, cx: j } = KV({
    radius: h,
    multiline: x,
    invalid: !!o,
    rightSectionWidth: d ? B(d) : void 0,
    iconWidth: f,
    withRightSection: !!p,
    offsetBottom: S,
    offsetTop: I,
    pointer: _
  }, { classNames: w, styles: $, name: ["Input", C], unstyled: O, variant: l, size: v }), { systemStyles: R, rest: D } = En(P);
  return /* @__PURE__ */ E.createElement(We, gl(gl({
    className: j(k.wrapper, n),
    sx: b,
    style: u
  }, R), y), s && /* @__PURE__ */ E.createElement("div", {
    className: k.icon
  }, s), /* @__PURE__ */ E.createElement(We, _3(gl({
    component: "input"
  }, D), {
    ref: r,
    required: a,
    "aria-invalid": !!o,
    "aria-describedby": N,
    disabled: i,
    "data-disabled": i || void 0,
    "data-with-icon": !!s || void 0,
    "data-invalid": !!o || void 0,
    className: k.input
  })), p && /* @__PURE__ */ E.createElement("div", _3(gl({}, g), {
    className: k.rightSection
  }), p));
});
Lo.displayName = "@mantine/core/Input";
Lo.Wrapper = ob;
Lo.Label = Vf;
Lo.Description = Zf;
Lo.Error = Ff;
Lo.Placeholder = lb;
const jr = Lo;
var oF = Object.defineProperty, aF = Object.defineProperties, iF = Object.getOwnPropertyDescriptors, Us = Object.getOwnPropertySymbols, ub = Object.prototype.hasOwnProperty, db = Object.prototype.propertyIsEnumerable, x3 = (e, r, t) => r in e ? oF(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, vd = (e, r) => {
  for (var t in r || (r = {}))
    ub.call(r, t) && x3(e, t, r[t]);
  if (Us)
    for (var t of Us(r))
      db.call(r, t) && x3(e, t, r[t]);
  return e;
}, $3 = (e, r) => aF(e, iF(r)), lF = (e, r) => {
  var t = {};
  for (var n in e)
    ub.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Us)
    for (var n of Us(e))
      r.indexOf(n) < 0 && db.call(e, n) && (t[n] = e[n]);
  return t;
};
function sF(e, r) {
  return r.value.toLowerCase().trim().includes(e.toLowerCase().trim());
}
const cF = {
  required: !1,
  size: "sm",
  shadow: "sm",
  limit: 5,
  itemComponent: $f,
  transitionProps: { transition: "fade", duration: 0 },
  initiallyOpened: !1,
  filter: sF,
  switchDirectionOnFlip: !1,
  zIndex: In("popover"),
  dropdownPosition: "flip",
  maxDropdownHeight: "auto",
  positionDependencies: []
}, fb = ue((e, r) => {
  const t = Ti("Autocomplete", cF, e), {
    inputProps: n,
    wrapperProps: o,
    shadow: a,
    data: i,
    limit: l,
    value: s,
    defaultValue: u,
    onChange: d,
    unstyled: f,
    itemComponent: p,
    onItemSubmit: g,
    onKeyDown: h,
    onFocus: v,
    onBlur: y,
    onClick: w,
    transitionProps: $,
    initiallyOpened: C,
    classNames: x,
    styles: b,
    filter: O,
    nothingFound: _,
    onDropdownClose: P,
    onDropdownOpen: S,
    withinPortal: I,
    switchDirectionOnFlip: N,
    zIndex: k,
    dropdownPosition: j,
    maxDropdownHeight: R,
    dropdownComponent: D,
    positionDependencies: T,
    readOnly: V,
    hoverOnSearchChange: L
  } = t, Z = lF(t, [
    "inputProps",
    "wrapperProps",
    "shadow",
    "data",
    "limit",
    "value",
    "defaultValue",
    "onChange",
    "unstyled",
    "itemComponent",
    "onItemSubmit",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "transitionProps",
    "initiallyOpened",
    "classNames",
    "styles",
    "filter",
    "nothingFound",
    "onDropdownClose",
    "onDropdownOpen",
    "withinPortal",
    "switchDirectionOnFlip",
    "zIndex",
    "dropdownPosition",
    "maxDropdownHeight",
    "dropdownComponent",
    "positionDependencies",
    "readOnly",
    "hoverOnSearchChange"
  ]), { classes: z } = nV(null, { classNames: x, styles: b, name: "Autocomplete", unstyled: f }), [W, U] = Se(C), [re, X] = Se(-1), [J, Q] = Se("column"), se = Ve(null), [q, te] = Se(!1), [ae, ge] = Hr({
    value: s,
    defaultValue: u,
    finalValue: "",
    onChange: d
  }), G = (xe) => {
    U(xe);
    const Le = xe ? S : P;
    typeof Le == "function" && Le();
  };
  ct(() => {
    X(L && ae ? 0 : -1);
  }, [ae, L]);
  const oe = (xe) => {
    ge(xe.value), typeof g == "function" && g(xe), G(!1);
  }, ne = i.map((xe) => typeof xe == "string" ? { value: xe } : xe), _e = V6({
    data: tV({ data: ne, value: ae, limit: l, filter: O })
  }), ye = (xe) => {
    if (q)
      return;
    typeof h == "function" && h(xe);
    const Le = J === "column", Ue = () => {
      X((Ie) => Ie < _e.length - 1 ? Ie + 1 : Ie);
    }, me = () => {
      X((Ie) => Ie > 0 ? Ie - 1 : Ie);
    };
    switch (xe.key) {
      case "ArrowUp": {
        xe.preventDefault(), Le ? me() : Ue();
        break;
      }
      case "ArrowDown": {
        xe.preventDefault(), Le ? Ue() : me();
        break;
      }
      case "Enter": {
        _e[re] && W && (xe.preventDefault(), ge(_e[re].value), typeof g == "function" && g(_e[re]), G(!1));
        break;
      }
      case "Escape":
        W && (xe.preventDefault(), G(!1));
    }
  }, Te = (xe) => {
    typeof v == "function" && v(xe), G(!0);
  }, we = (xe) => {
    typeof y == "function" && y(xe), G(!1);
  }, He = (xe) => {
    typeof w == "function" && w(xe), G(!0);
  }, he = W && (_e.length > 0 || _e.length === 0 && !!_);
  return /* @__PURE__ */ E.createElement(jr.Wrapper, $3(vd({}, o), {
    __staticSelector: "Autocomplete"
  }), /* @__PURE__ */ E.createElement(Yn, {
    opened: he,
    transitionProps: $,
    shadow: "sm",
    withinPortal: I,
    __staticSelector: "Autocomplete",
    onDirectionChange: Q,
    switchDirectionOnFlip: N,
    zIndex: k,
    dropdownPosition: j,
    positionDependencies: T,
    classNames: x,
    styles: b,
    unstyled: f,
    readOnly: V,
    variant: n.variant
  }, /* @__PURE__ */ E.createElement(Yn.Target, null, /* @__PURE__ */ E.createElement("div", {
    className: z.wrapper,
    "aria-controls": n.id,
    onMouseLeave: () => X(-1),
    tabIndex: -1
  }, /* @__PURE__ */ E.createElement(jr, $3(vd(vd({
    type: "search",
    autoComplete: "off"
  }, n), Z), {
    readOnly: V,
    "data-mantine-stop-propagation": W,
    ref: Kn(r, se),
    onKeyDown: ye,
    classNames: x,
    styles: b,
    __staticSelector: "Autocomplete",
    value: ae,
    onChange: (xe) => {
      ge(xe.currentTarget.value), G(!0);
    },
    onFocus: Te,
    onBlur: we,
    onClick: He,
    onCompositionStart: () => te(!0),
    onCompositionEnd: () => te(!1),
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-owns": he ? `${n.id}-items` : null,
    "aria-expanded": he,
    "aria-autocomplete": "list",
    "aria-controls": he ? `${n.id}-items` : null,
    "aria-activedescendant": re >= 0 ? `${n.id}-${re}` : null
  })))), /* @__PURE__ */ E.createElement(Yn.Dropdown, {
    component: D || h1,
    maxHeight: R,
    direction: J,
    id: n.id,
    __staticSelector: "Autocomplete",
    classNames: x,
    styles: b
  }, /* @__PURE__ */ E.createElement(xf, {
    data: _e,
    hovered: re,
    classNames: x,
    styles: b,
    uuid: n.id,
    __staticSelector: "Autocomplete",
    onItemHover: X,
    onItemSelect: oe,
    itemComponent: p,
    size: n.size,
    nothingFound: _,
    variant: n.variant
  }))));
});
fb.displayName = "@mantine/core/Autocomplete";
var uF = Object.defineProperty, Js = Object.getOwnPropertySymbols, pb = Object.prototype.hasOwnProperty, gb = Object.prototype.propertyIsEnumerable, O3 = (e, r, t) => r in e ? uF(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, dF = (e, r) => {
  for (var t in r || (r = {}))
    pb.call(r, t) && O3(e, t, r[t]);
  if (Js)
    for (var t of Js(r))
      gb.call(r, t) && O3(e, t, r[t]);
  return e;
}, fF = (e, r) => {
  var t = {};
  for (var n in e)
    pb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Js)
    for (var n of Js(e))
      r.indexOf(n) < 0 && gb.call(e, n) && (t[n] = e[n]);
  return t;
};
function pF(e) {
  const r = e, { style: t } = r, n = fF(r, ["style"]);
  return /* @__PURE__ */ E.createElement("svg", dF({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: t
  }, n), /* @__PURE__ */ E.createElement("path", {
    d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var gF = Object.defineProperty, vF = Object.defineProperties, mF = Object.getOwnPropertyDescriptors, P3 = Object.getOwnPropertySymbols, hF = Object.prototype.hasOwnProperty, bF = Object.prototype.propertyIsEnumerable, S3 = (e, r, t) => r in e ? gF(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, yF = (e, r) => {
  for (var t in r || (r = {}))
    hF.call(r, t) && S3(e, t, r[t]);
  if (P3)
    for (var t of P3(r))
      bF.call(r, t) && S3(e, t, r[t]);
  return e;
}, CF = (e, r) => vF(e, mF(r));
const vb = xt(null);
function wF({ spacing: e, children: r }) {
  return /* @__PURE__ */ E.createElement(vb.Provider, {
    value: { spacing: e }
  }, r);
}
function _F() {
  const e = dt(vb);
  return e ? CF(yF({}, e), { withinGroup: !0 }) : { spacing: null, withinGroup: !1 };
}
var xF = Ae((e, { spacing: r }) => ({
  root: {
    display: "flex",
    paddingLeft: ve({ size: r, sizes: e.spacing })
  }
})), $F = Object.defineProperty, qs = Object.getOwnPropertySymbols, mb = Object.prototype.hasOwnProperty, hb = Object.prototype.propertyIsEnumerable, I3 = (e, r, t) => r in e ? $F(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, OF = (e, r) => {
  for (var t in r || (r = {}))
    mb.call(r, t) && I3(e, t, r[t]);
  if (qs)
    for (var t of qs(r))
      hb.call(r, t) && I3(e, t, r[t]);
  return e;
}, PF = (e, r) => {
  var t = {};
  for (var n in e)
    mb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && qs)
    for (var n of qs(e))
      r.indexOf(n) < 0 && hb.call(e, n) && (t[n] = e[n]);
  return t;
};
const SF = {}, bb = ue((e, r) => {
  const t = Oe("AvatarGroup", SF, e), {
    children: n,
    spacing: o = "sm",
    unstyled: a,
    className: i,
    variant: l
  } = t, s = PF(t, [
    "children",
    "spacing",
    "unstyled",
    "className",
    "variant"
  ]), { classes: u, cx: d } = xF({ spacing: o }, { name: "AvatarGroup", unstyled: a, variant: l });
  return /* @__PURE__ */ E.createElement(wF, {
    spacing: o
  }, /* @__PURE__ */ E.createElement(We, OF({
    ref: r,
    className: d(u.root, i)
  }, s), n));
});
bb.displayName = "@mantine/core/AvatarGroup";
var IF = Object.defineProperty, EF = Object.defineProperties, RF = Object.getOwnPropertyDescriptors, E3 = Object.getOwnPropertySymbols, AF = Object.prototype.hasOwnProperty, kF = Object.prototype.propertyIsEnumerable, R3 = (e, r, t) => r in e ? IF(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Ha = (e, r) => {
  for (var t in r || (r = {}))
    AF.call(r, t) && R3(e, t, r[t]);
  if (E3)
    for (var t of E3(r))
      kF.call(r, t) && R3(e, t, r[t]);
  return e;
}, A3 = (e, r) => EF(e, RF(r));
const MF = ["filled", "light", "gradient", "outline"], vl = {
  xs: B(16),
  sm: B(26),
  md: B(38),
  lg: B(56),
  xl: B(84)
};
function NF({ withinGroup: e, spacing: r, theme: t }) {
  return e ? {
    marginLeft: `calc(${ve({ size: r, sizes: t.spacing })} * -1)`,
    backgroundColor: `${t.colorScheme === "dark" ? t.colors.dark[7] : t.white}`,
    border: `${B(2)} solid ${t.colorScheme === "dark" ? t.colors.dark[7] : t.white}`
  } : null;
}
function TF({ theme: e, variant: r, color: t, gradient: n }) {
  const o = e.fn.variant({ variant: r, color: t, gradient: n });
  return MF.includes(r) ? {
    placeholder: {
      color: o.color,
      backgroundColor: o.background,
      backgroundImage: r === "gradient" ? o.background : void 0,
      border: `${B(r === "gradient" ? 0 : 1)} solid ${o.border}`
    },
    placeholderIcon: {
      color: o.color
    }
  } : {};
}
var DF = Ae((e, { radius: r, withinGroup: t, spacing: n, color: o, gradient: a }, { variant: i, size: l }) => {
  const s = TF({ theme: e, color: o, gradient: a, variant: i });
  return {
    root: Ha(A3(Ha({}, e.fn.focusStyles()), {
      WebkitTapHighlightColor: "transparent",
      boxSizing: "border-box",
      position: "relative",
      display: "block",
      userSelect: "none",
      overflow: "hidden",
      borderRadius: e.fn.radius(r),
      textDecoration: "none",
      border: 0,
      backgroundColor: "transparent",
      padding: 0,
      width: ve({ size: l, sizes: vl }),
      minWidth: ve({ size: l, sizes: vl }),
      height: ve({ size: l, sizes: vl })
    }), NF({ withinGroup: t, spacing: n, theme: e })),
    image: {
      objectFit: "cover",
      width: "100%",
      height: "100%",
      display: "block"
    },
    placeholder: Ha(A3(Ha({}, e.fn.fontStyles()), {
      fontWeight: 700,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      userSelect: "none",
      borderRadius: e.fn.radius(r),
      fontSize: `calc(${ve({ size: l, sizes: vl })} / 2.5)`
    }), s.placeholder),
    placeholderIcon: Ha({
      width: "70%",
      height: "70%"
    }, s.placeholderIcon)
  };
});
const jF = DF;
var LF = Object.defineProperty, zF = Object.defineProperties, VF = Object.getOwnPropertyDescriptors, Ks = Object.getOwnPropertySymbols, yb = Object.prototype.hasOwnProperty, Cb = Object.prototype.propertyIsEnumerable, k3 = (e, r, t) => r in e ? LF(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, M3 = (e, r) => {
  for (var t in r || (r = {}))
    yb.call(r, t) && k3(e, t, r[t]);
  if (Ks)
    for (var t of Ks(r))
      Cb.call(r, t) && k3(e, t, r[t]);
  return e;
}, FF = (e, r) => zF(e, VF(r)), ZF = (e, r) => {
  var t = {};
  for (var n in e)
    yb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ks)
    for (var n of Ks(e))
      r.indexOf(n) < 0 && Cb.call(e, n) && (t[n] = e[n]);
  return t;
};
const WF = {
  size: "md",
  color: "gray",
  variant: "light"
}, Wf = ue((e, r) => {
  const t = Oe("Avatar", WF, e), {
    className: n,
    size: o,
    src: a,
    alt: i,
    radius: l,
    children: s,
    color: u,
    variant: d,
    gradient: f,
    classNames: p,
    styles: g,
    imageProps: h,
    unstyled: v
  } = t, y = ZF(t, [
    "className",
    "size",
    "src",
    "alt",
    "radius",
    "children",
    "color",
    "variant",
    "gradient",
    "classNames",
    "styles",
    "imageProps",
    "unstyled"
  ]), w = _F(), [$, C] = Se(!a), { classes: x, cx: b } = jF({ color: u, radius: l, withinGroup: w.withinGroup, spacing: w.spacing, gradient: f }, { classNames: p, styles: g, unstyled: v, name: "Avatar", variant: d, size: o });
  return Fe(() => {
    C(!a);
  }, [a]), /* @__PURE__ */ E.createElement(We, M3({
    component: "div",
    className: b(x.root, n),
    ref: r
  }, y), $ ? /* @__PURE__ */ E.createElement("div", {
    className: x.placeholder,
    title: i
  }, s || /* @__PURE__ */ E.createElement(pF, {
    className: x.placeholderIcon
  })) : /* @__PURE__ */ E.createElement("img", FF(M3({}, h), {
    className: x.image,
    src: a,
    alt: i,
    onError: () => C(!0)
  })));
});
Wf.displayName = "@mantine/core/Avatar";
Wf.Group = bb;
const P0 = Wf;
var BF = Object.defineProperty, HF = Object.defineProperties, GF = Object.getOwnPropertyDescriptors, N3 = Object.getOwnPropertySymbols, XF = Object.prototype.hasOwnProperty, YF = Object.prototype.propertyIsEnumerable, T3 = (e, r, t) => r in e ? BF(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, md = (e, r) => {
  for (var t in r || (r = {}))
    XF.call(r, t) && T3(e, t, r[t]);
  if (N3)
    for (var t of N3(r))
      YF.call(r, t) && T3(e, t, r[t]);
  return e;
}, UF = (e, r) => HF(e, GF(r));
const JF = ["light", "filled", "outline", "dot", "gradient"], hd = {
  xs: { fontSize: B(9), height: B(16) },
  sm: { fontSize: B(10), height: B(18) },
  md: { fontSize: B(11), height: B(20) },
  lg: { fontSize: B(13), height: B(26) },
  xl: { fontSize: B(16), height: B(32) }
}, qF = {
  xs: B(4),
  sm: B(4),
  md: B(6),
  lg: B(8),
  xl: B(10)
};
function KF({ theme: e, variant: r, color: t, size: n, gradient: o }) {
  if (!JF.includes(r))
    return null;
  if (r === "dot") {
    const i = ve({ size: n, sizes: qF });
    return {
      backgroundColor: "transparent",
      color: e.colorScheme === "dark" ? e.colors.dark[0] : e.colors.gray[7],
      border: `${B(1)} solid ${e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[3]}`,
      paddingLeft: `calc(${ve({ size: n, sizes: e.spacing })} / 1.5 - ${i} / 2)`,
      "&::before": {
        content: '""',
        display: "block",
        width: i,
        height: i,
        borderRadius: i,
        backgroundColor: e.fn.themeColor(t, e.colorScheme === "dark" ? 4 : e.fn.primaryShade("light"), !0),
        marginRight: i
      }
    };
  }
  const a = e.fn.variant({ color: t, variant: r, gradient: o });
  return {
    background: a.background,
    color: a.color,
    border: `${B(r === "gradient" ? 0 : 1)} solid ${a.border}`
  };
}
var QF = Ae((e, { color: r, radius: t, gradient: n, fullWidth: o }, { variant: a, size: i }) => {
  const { fontSize: l, height: s } = i in hd ? hd[i] : hd.md;
  return {
    leftSection: {
      marginRight: `calc(${e.spacing.xs} / 2)`
    },
    rightSection: {
      marginLeft: `calc(${e.spacing.xs} / 2)`
    },
    inner: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    root: md(UF(md(md({}, e.fn.focusStyles()), e.fn.fontStyles()), {
      fontSize: l,
      height: s,
      WebkitTapHighlightColor: "transparent",
      lineHeight: `calc(${s} - ${B(2)})`,
      textDecoration: "none",
      padding: `0 calc(${ve({ size: i, sizes: e.spacing })} / 1.5)`,
      boxSizing: "border-box",
      display: o ? "flex" : "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: o ? "100%" : "auto",
      textTransform: "uppercase",
      borderRadius: e.fn.radius(t),
      fontWeight: 700,
      letterSpacing: B(0.25),
      cursor: "inherit",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }), KF({ theme: e, variant: a, color: r, size: i, gradient: n }))
  };
}), eZ = Object.defineProperty, Qs = Object.getOwnPropertySymbols, wb = Object.prototype.hasOwnProperty, _b = Object.prototype.propertyIsEnumerable, D3 = (e, r, t) => r in e ? eZ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, rZ = (e, r) => {
  for (var t in r || (r = {}))
    wb.call(r, t) && D3(e, t, r[t]);
  if (Qs)
    for (var t of Qs(r))
      _b.call(r, t) && D3(e, t, r[t]);
  return e;
}, tZ = (e, r) => {
  var t = {};
  for (var n in e)
    wb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Qs)
    for (var n of Qs(e))
      r.indexOf(n) < 0 && _b.call(e, n) && (t[n] = e[n]);
  return t;
};
const nZ = {
  variant: "light",
  size: "md",
  radius: "xl"
}, xb = ue((e, r) => {
  const t = Oe("Badge", nZ, e), {
    className: n,
    color: o,
    variant: a,
    fullWidth: i,
    children: l,
    size: s,
    leftSection: u,
    rightSection: d,
    radius: f,
    gradient: p,
    classNames: g,
    styles: h,
    unstyled: v
  } = t, y = tZ(t, [
    "className",
    "color",
    "variant",
    "fullWidth",
    "children",
    "size",
    "leftSection",
    "rightSection",
    "radius",
    "gradient",
    "classNames",
    "styles",
    "unstyled"
  ]), { classes: w, cx: $ } = QF({ fullWidth: i, color: o, radius: f, gradient: p }, { classNames: g, styles: h, name: "Badge", unstyled: v, variant: a, size: s });
  return /* @__PURE__ */ E.createElement(We, rZ({
    className: $(w.root, n),
    ref: r
  }, y), u && /* @__PURE__ */ E.createElement("span", {
    className: w.leftSection
  }, u), /* @__PURE__ */ E.createElement("span", {
    className: w.inner
  }, l), d && /* @__PURE__ */ E.createElement("span", {
    className: w.rightSection
  }, d));
});
xb.displayName = "@mantine/core/Badge";
const oZ = xb;
var aZ = Ae((e, { radius: r, shadow: t }) => ({
  root: {
    outline: 0,
    WebkitTapHighlightColor: "transparent",
    display: "block",
    textDecoration: "none",
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white,
    boxSizing: "border-box",
    borderRadius: e.fn.radius(r),
    boxShadow: e.shadows[t] || t || "none",
    "&[data-with-border]": {
      border: `${B(1)} solid ${e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3]}`
    }
  }
})), iZ = Object.defineProperty, ec = Object.getOwnPropertySymbols, $b = Object.prototype.hasOwnProperty, Ob = Object.prototype.propertyIsEnumerable, j3 = (e, r, t) => r in e ? iZ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, lZ = (e, r) => {
  for (var t in r || (r = {}))
    $b.call(r, t) && j3(e, t, r[t]);
  if (ec)
    for (var t of ec(r))
      Ob.call(r, t) && j3(e, t, r[t]);
  return e;
}, sZ = (e, r) => {
  var t = {};
  for (var n in e)
    $b.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ec)
    for (var n of ec(e))
      r.indexOf(n) < 0 && Ob.call(e, n) && (t[n] = e[n]);
  return t;
};
const cZ = {}, Pb = ue((e, r) => {
  const t = Oe("Paper", cZ, e), { className: n, children: o, radius: a, withBorder: i, shadow: l, unstyled: s, variant: u } = t, d = sZ(t, ["className", "children", "radius", "withBorder", "shadow", "unstyled", "variant"]), { classes: f, cx: p } = aZ({ radius: a, shadow: l }, { name: "Paper", unstyled: s, variant: u });
  return /* @__PURE__ */ E.createElement(We, lZ({
    className: p(f.root, n),
    "data-with-border": i || void 0,
    ref: r
  }, d), o);
});
Pb.displayName = "@mantine/core/Paper";
const uZ = Pb;
var dZ = Ae((e, { inline: r }) => ({
  root: {
    display: r ? "inline-flex" : "flex",
    alignItems: "center",
    justifyContent: "center"
  }
})), fZ = Object.defineProperty, rc = Object.getOwnPropertySymbols, Sb = Object.prototype.hasOwnProperty, Ib = Object.prototype.propertyIsEnumerable, L3 = (e, r, t) => r in e ? fZ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, pZ = (e, r) => {
  for (var t in r || (r = {}))
    Sb.call(r, t) && L3(e, t, r[t]);
  if (rc)
    for (var t of rc(r))
      Ib.call(r, t) && L3(e, t, r[t]);
  return e;
}, gZ = (e, r) => {
  var t = {};
  for (var n in e)
    Sb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && rc)
    for (var n of rc(e))
      r.indexOf(n) < 0 && Ib.call(e, n) && (t[n] = e[n]);
  return t;
};
const Eb = ue((e, r) => {
  const t = Oe("Center", {}, e), { inline: n, className: o, unstyled: a, variant: i } = t, l = gZ(t, ["inline", "className", "unstyled", "variant"]), { classes: s, cx: u } = dZ({ inline: n }, { name: "Center", unstyled: a, variant: i });
  return /* @__PURE__ */ E.createElement(We, pZ({
    ref: r,
    className: u(s.root, o)
  }, l));
});
Eb.displayName = "@mantine/core/Center";
const h5e = Eb, Rb = xt(null), vZ = Rb.Provider, mZ = () => dt(Rb);
var hZ = Object.defineProperty, tc = Object.getOwnPropertySymbols, Ab = Object.prototype.hasOwnProperty, kb = Object.prototype.propertyIsEnumerable, z3 = (e, r, t) => r in e ? hZ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, V3 = (e, r) => {
  for (var t in r || (r = {}))
    Ab.call(r, t) && z3(e, t, r[t]);
  if (tc)
    for (var t of tc(r))
      kb.call(r, t) && z3(e, t, r[t]);
  return e;
}, bZ = (e, r) => {
  var t = {};
  for (var n in e)
    Ab.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && tc)
    for (var n of tc(e))
      r.indexOf(n) < 0 && kb.call(e, n) && (t[n] = e[n]);
  return t;
};
const yZ = {
  size: "sm"
}, Mb = ue((e, r) => {
  const t = Oe("CheckboxGroup", yZ, e), { children: n, value: o, defaultValue: a, onChange: i, size: l, wrapperProps: s } = t, u = bZ(t, ["children", "value", "defaultValue", "onChange", "size", "wrapperProps"]), [d, f] = Hr({
    value: o,
    defaultValue: a,
    finalValue: [],
    onChange: i
  }), p = (g) => {
    const h = g.currentTarget.value;
    f(d.includes(h) ? d.filter((v) => v !== h) : [...d, h]);
  };
  return /* @__PURE__ */ E.createElement(vZ, {
    value: { value: d, onChange: p, size: l }
  }, /* @__PURE__ */ E.createElement(jr.Wrapper, V3(V3({
    labelElement: "div",
    size: l,
    __staticSelector: "CheckboxGroup",
    ref: r
  }, s), u), n));
});
Mb.displayName = "@mantine/core/CheckboxGroup";
var CZ = Object.defineProperty, nc = Object.getOwnPropertySymbols, Nb = Object.prototype.hasOwnProperty, Tb = Object.prototype.propertyIsEnumerable, F3 = (e, r, t) => r in e ? CZ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, oc = (e, r) => {
  for (var t in r || (r = {}))
    Nb.call(r, t) && F3(e, t, r[t]);
  if (nc)
    for (var t of nc(r))
      Tb.call(r, t) && F3(e, t, r[t]);
  return e;
}, Db = (e, r) => {
  var t = {};
  for (var n in e)
    Nb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && nc)
    for (var n of nc(e))
      r.indexOf(n) < 0 && Tb.call(e, n) && (t[n] = e[n]);
  return t;
};
function wZ(e) {
  const r = e, { width: t, height: n, style: o } = r, a = Db(r, ["width", "height", "style"]);
  return /* @__PURE__ */ E.createElement("svg", oc({
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: oc({ width: t, height: n }, o)
  }, a), /* @__PURE__ */ E.createElement("path", {
    d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
function _Z(e) {
  var r = e, { indeterminate: t } = r, n = Db(r, ["indeterminate"]);
  return t ? /* @__PURE__ */ E.createElement("svg", oc({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 6"
  }, n), /* @__PURE__ */ E.createElement("rect", {
    width: "32",
    height: "6",
    fill: "currentColor",
    rx: "3"
  })) : /* @__PURE__ */ E.createElement(wZ, oc({}, n));
}
var xZ = Object.defineProperty, $Z = Object.defineProperties, OZ = Object.getOwnPropertyDescriptors, Z3 = Object.getOwnPropertySymbols, PZ = Object.prototype.hasOwnProperty, SZ = Object.prototype.propertyIsEnumerable, W3 = (e, r, t) => r in e ? xZ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, B3 = (e, r) => {
  for (var t in r || (r = {}))
    PZ.call(r, t) && W3(e, t, r[t]);
  if (Z3)
    for (var t of Z3(r))
      SZ.call(r, t) && W3(e, t, r[t]);
  return e;
}, H3 = (e, r) => $Z(e, OZ(r));
const IZ = {
  xs: B(16),
  sm: B(20),
  md: B(24),
  lg: B(30),
  xl: B(36)
};
var EZ = Ae((e, {
  radius: r,
  color: t,
  transitionDuration: n,
  labelPosition: o,
  error: a,
  indeterminate: i
}, { size: l }) => {
  const s = ve({ size: l, sizes: IZ }), u = e.fn.variant({ variant: "filled", color: t });
  return {
    icon: H3(B3({}, e.fn.cover()), {
      ref: Yt("icon"),
      color: i ? "inherit" : e.white,
      transform: i ? "none" : `translateY(${B(5)}) scale(0.5)`,
      opacity: i ? 1 : 0,
      transitionProperty: "opacity, transform",
      transitionTimingFunction: "ease",
      transitionDuration: `${n}ms`,
      pointerEvents: "none",
      width: "60%",
      position: "absolute",
      zIndex: 1,
      margin: "auto",
      "@media (prefers-reduced-motion)": {
        transitionDuration: e.respectReducedMotion ? "0ms" : void 0
      }
    }),
    inner: {
      position: "relative",
      width: s,
      height: s,
      order: o === "left" ? 2 : 1
    },
    input: H3(B3({}, e.fn.focusStyles()), {
      appearance: "none",
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
      border: `${B(1)} solid ${a ? e.fn.variant({ variant: "filled", color: "red" }).background : e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4]}`,
      width: s,
      height: s,
      borderRadius: e.fn.radius(r),
      padding: 0,
      display: "block",
      margin: 0,
      transition: `border-color ${n}ms ease, background-color ${n}ms ease`,
      cursor: e.cursorType,
      "&:checked": {
        backgroundColor: u.background,
        borderColor: u.background,
        [`& + .${Yt("icon")}`]: {
          opacity: 1,
          color: e.white,
          transform: "translateY(0) scale(1)"
        }
      },
      "&:disabled": {
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2],
        borderColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[3],
        cursor: "not-allowed",
        pointerEvents: "none",
        [`& + .${Yt("icon")}`]: {
          color: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[5]
        }
      }
    })
  };
});
const RZ = EZ;
var AZ = Object.defineProperty, kZ = Object.defineProperties, MZ = Object.getOwnPropertyDescriptors, G3 = Object.getOwnPropertySymbols, NZ = Object.prototype.hasOwnProperty, TZ = Object.prototype.propertyIsEnumerable, X3 = (e, r, t) => r in e ? AZ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, DZ = (e, r) => {
  for (var t in r || (r = {}))
    NZ.call(r, t) && X3(e, t, r[t]);
  if (G3)
    for (var t of G3(r))
      TZ.call(r, t) && X3(e, t, r[t]);
  return e;
}, jZ = (e, r) => kZ(e, MZ(r));
const bd = {
  xs: B(16),
  sm: B(20),
  md: B(24),
  lg: B(30),
  xl: B(36)
};
var LZ = Ae((e, { labelPosition: r }, { size: t }) => ({
  root: {},
  body: {
    display: "flex",
    "&:has(input:disabled) label": {
      color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[5]
    }
  },
  labelWrapper: jZ(DZ({}, e.fn.fontStyles()), {
    display: "inline-flex",
    flexDirection: "column",
    WebkitTapHighlightColor: "transparent",
    fontSize: t in bd ? ve({ size: t, sizes: e.fontSizes }) : void 0,
    lineHeight: t in bd ? ve({ size: t, sizes: bd }) : void 0,
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    cursor: e.cursorType,
    order: r === "left" ? 1 : 2
  }),
  description: {
    marginTop: `calc(${e.spacing.xs} / 2)`,
    [r === "left" ? "paddingRight" : "paddingLeft"]: e.spacing.sm
  },
  error: {
    marginTop: `calc(${e.spacing.xs} / 2)`,
    [r === "left" ? "paddingRight" : "paddingLeft"]: e.spacing.sm
  },
  label: {
    cursor: e.cursorType,
    [r === "left" ? "paddingRight" : "paddingLeft"]: e.spacing.sm,
    "&:disabled, &[data-disabled]": {
      color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[5]
    }
  }
})), zZ = Object.defineProperty, ac = Object.getOwnPropertySymbols, jb = Object.prototype.hasOwnProperty, Lb = Object.prototype.propertyIsEnumerable, Y3 = (e, r, t) => r in e ? zZ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, VZ = (e, r) => {
  for (var t in r || (r = {}))
    jb.call(r, t) && Y3(e, t, r[t]);
  if (ac)
    for (var t of ac(r))
      Lb.call(r, t) && Y3(e, t, r[t]);
  return e;
}, FZ = (e, r) => {
  var t = {};
  for (var n in e)
    jb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ac)
    for (var n of ac(e))
      r.indexOf(n) < 0 && Lb.call(e, n) && (t[n] = e[n]);
  return t;
};
const C1 = ue((e, r) => {
  var t = e, {
    __staticSelector: n,
    className: o,
    classNames: a,
    styles: i,
    unstyled: l,
    children: s,
    label: u,
    description: d,
    id: f,
    disabled: p,
    error: g,
    size: h,
    labelPosition: v,
    variant: y
  } = t, w = FZ(t, [
    "__staticSelector",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "children",
    "label",
    "description",
    "id",
    "disabled",
    "error",
    "size",
    "labelPosition",
    "variant"
  ]);
  const { classes: $, cx: C } = LZ({ labelPosition: v }, { name: n, styles: i, classNames: a, unstyled: l, variant: y, size: h });
  return /* @__PURE__ */ E.createElement(We, VZ({
    className: C($.root, o),
    ref: r
  }, w), /* @__PURE__ */ E.createElement("div", {
    className: C($.body)
  }, s, /* @__PURE__ */ E.createElement("div", {
    className: $.labelWrapper
  }, u != null && /* @__PURE__ */ E.createElement("label", {
    className: $.label,
    "data-disabled": p || void 0,
    htmlFor: f
  }, u), d && /* @__PURE__ */ E.createElement(jr.Description, {
    className: $.description
  }, d), g && g !== "boolean" && /* @__PURE__ */ E.createElement(jr.Error, {
    className: $.error
  }, g))));
});
C1.displayName = "@mantine/core/InlineInput";
var ZZ = Object.defineProperty, ic = Object.getOwnPropertySymbols, zb = Object.prototype.hasOwnProperty, Vb = Object.prototype.propertyIsEnumerable, U3 = (e, r, t) => r in e ? ZZ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ml = (e, r) => {
  for (var t in r || (r = {}))
    zb.call(r, t) && U3(e, t, r[t]);
  if (ic)
    for (var t of ic(r))
      Vb.call(r, t) && U3(e, t, r[t]);
  return e;
}, WZ = (e, r) => {
  var t = {};
  for (var n in e)
    zb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ic)
    for (var n of ic(e))
      r.indexOf(n) < 0 && Vb.call(e, n) && (t[n] = e[n]);
  return t;
};
const BZ = {
  size: "sm",
  transitionDuration: 100,
  icon: _Z,
  labelPosition: "right"
}, w1 = ue((e, r) => {
  const t = Oe("Checkbox", BZ, e), {
    className: n,
    style: o,
    sx: a,
    checked: i,
    disabled: l,
    color: s,
    label: u,
    indeterminate: d,
    id: f,
    size: p,
    radius: g,
    wrapperProps: h,
    children: v,
    classNames: y,
    styles: w,
    transitionDuration: $,
    icon: C,
    unstyled: x,
    labelPosition: b,
    description: O,
    error: _,
    variant: P
  } = t, S = WZ(t, [
    "className",
    "style",
    "sx",
    "checked",
    "disabled",
    "color",
    "label",
    "indeterminate",
    "id",
    "size",
    "radius",
    "wrapperProps",
    "children",
    "classNames",
    "styles",
    "transitionDuration",
    "icon",
    "unstyled",
    "labelPosition",
    "description",
    "error",
    "variant"
  ]), I = mZ(), N = ke(f), { systemStyles: k, rest: j } = En(S), { classes: R } = RZ({
    radius: g,
    color: s,
    transitionDuration: $,
    labelPosition: b,
    error: !!_,
    indeterminate: d
  }, { name: "Checkbox", classNames: y, styles: w, unstyled: x, variant: P, size: (I == null ? void 0 : I.size) || p }), D = I ? {
    checked: I.value.includes(j.value),
    onChange: I.onChange
  } : {};
  return /* @__PURE__ */ E.createElement(C1, ml(ml({
    className: n,
    sx: a,
    style: o,
    id: N,
    size: (I == null ? void 0 : I.size) || p,
    labelPosition: b,
    label: u,
    description: O,
    error: _,
    disabled: l,
    __staticSelector: "Checkbox",
    classNames: y,
    styles: w,
    unstyled: x,
    "data-checked": D.checked || void 0,
    variant: P
  }, k), h), /* @__PURE__ */ E.createElement("div", {
    className: R.inner
  }, /* @__PURE__ */ E.createElement("input", ml(ml({
    id: N,
    ref: r,
    type: "checkbox",
    className: R.input,
    checked: i,
    disabled: l
  }, j), D)), /* @__PURE__ */ E.createElement(C, {
    indeterminate: d,
    className: R.icon
  })));
});
w1.displayName = "@mantine/core/Checkbox";
w1.Group = Mb;
const [HZ, GZ] = no("Drawer component was not found in tree"), J3 = {
  xs: B(320),
  sm: B(380),
  md: B(440),
  lg: B(620),
  xl: B(780)
};
var XZ = Ae((e, { position: r }, { size: t }) => ({
  header: {
    zIndex: 1e3
  },
  content: {
    flex: r === "right" || r === "left" ? `0 0 ${ve({ size: t, sizes: J3 })}` : "0 0 100%",
    maxWidth: "100%",
    maxHeight: "100%",
    height: r === "right" || r === "left" ? "100%" : ve({ size: t, sizes: J3 }),
    borderRadius: 0,
    overflowY: "auto"
  },
  inner: {
    display: "flex",
    justifyContent: r === "right" ? "flex-end" : "flex-start",
    alignItems: r === "bottom" ? "flex-end" : "flex-start"
  }
}));
const [YZ, Aa] = no("ModalBase component was not found in tree");
var UZ = Ae(() => ({
  close: {
    marginLeft: "auto",
    marginRight: 0
  }
}));
const JZ = UZ;
var qZ = Object.defineProperty, lc = Object.getOwnPropertySymbols, Fb = Object.prototype.hasOwnProperty, Zb = Object.prototype.propertyIsEnumerable, q3 = (e, r, t) => r in e ? qZ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, KZ = (e, r) => {
  for (var t in r || (r = {}))
    Fb.call(r, t) && q3(e, t, r[t]);
  if (lc)
    for (var t of lc(r))
      Zb.call(r, t) && q3(e, t, r[t]);
  return e;
}, QZ = (e, r) => {
  var t = {};
  for (var n in e)
    Fb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && lc)
    for (var n of lc(e))
      r.indexOf(n) < 0 && Zb.call(e, n) && (t[n] = e[n]);
  return t;
};
const eW = {
  size: "sm"
}, rW = ue((e, r) => {
  const t = Aa(), n = Oe(`${t.__staticSelector}CloseButton`, eW, e), { className: o } = n, a = QZ(n, ["className"]), { classes: i, cx: l } = JZ(null, t.stylesApi);
  return /* @__PURE__ */ E.createElement(Ai, KZ({
    className: l(i.close, o),
    ref: r,
    onClick: t.onClose
  }, a));
});
var tW = Ae(() => ({
  overlay: {}
}));
const nW = tW;
var oW = Object.defineProperty, aW = Object.defineProperties, iW = Object.getOwnPropertyDescriptors, K3 = Object.getOwnPropertySymbols, lW = Object.prototype.hasOwnProperty, sW = Object.prototype.propertyIsEnumerable, Q3 = (e, r, t) => r in e ? oW(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, cW = (e, r) => {
  for (var t in r || (r = {}))
    lW.call(r, t) && Q3(e, t, r[t]);
  if (K3)
    for (var t of K3(r))
      sW.call(r, t) && Q3(e, t, r[t]);
  return e;
}, uW = (e, r) => aW(e, iW(r)), dW = Ae((e, { color: r, opacity: t, blur: n, radius: o, gradient: a, fixed: i, zIndex: l }) => ({
  root: uW(cW({}, e.fn.cover(0)), {
    position: i ? "fixed" : "absolute",
    backgroundColor: a ? void 0 : e.fn.rgba(r, t),
    backgroundImage: a,
    backdropFilter: n ? `blur(${B(n)})` : void 0,
    borderRadius: e.fn.radius(o),
    zIndex: l,
    "&[data-center]": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  })
})), fW = Object.defineProperty, sc = Object.getOwnPropertySymbols, Wb = Object.prototype.hasOwnProperty, Bb = Object.prototype.propertyIsEnumerable, e4 = (e, r, t) => r in e ? fW(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, pW = (e, r) => {
  for (var t in r || (r = {}))
    Wb.call(r, t) && e4(e, t, r[t]);
  if (sc)
    for (var t of sc(r))
      Bb.call(r, t) && e4(e, t, r[t]);
  return e;
}, gW = (e, r) => {
  var t = {};
  for (var n in e)
    Wb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && sc)
    for (var n of sc(e))
      r.indexOf(n) < 0 && Bb.call(e, n) && (t[n] = e[n]);
  return t;
};
const vW = {
  opacity: 0.6,
  color: "#000",
  zIndex: In("modal"),
  radius: 0
}, Hb = ue((e, r) => {
  const t = Oe("Overlay", vW, e), {
    variant: n,
    opacity: o,
    color: a,
    blur: i,
    gradient: l,
    zIndex: s,
    radius: u,
    children: d,
    className: f,
    classNames: p,
    styles: g,
    unstyled: h,
    center: v,
    fixed: y
  } = t, w = gW(t, [
    "variant",
    "opacity",
    "color",
    "blur",
    "gradient",
    "zIndex",
    "radius",
    "children",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "center",
    "fixed"
  ]), { classes: $, cx: C } = dW({ color: a, opacity: o, blur: i, radius: u, gradient: l, fixed: y, zIndex: s }, { name: "Overlay", classNames: p, styles: g, unstyled: h, variant: n });
  return /* @__PURE__ */ E.createElement(We, pW({
    ref: r,
    className: C($.root, f),
    "data-center": v || void 0
  }, w), d);
});
Hb.displayName = "@mantine/core/Overlay";
const Gb = Hb;
var mW = Object.defineProperty, hW = Object.defineProperties, bW = Object.getOwnPropertyDescriptors, cc = Object.getOwnPropertySymbols, Xb = Object.prototype.hasOwnProperty, Yb = Object.prototype.propertyIsEnumerable, r4 = (e, r, t) => r in e ? mW(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Ga = (e, r) => {
  for (var t in r || (r = {}))
    Xb.call(r, t) && r4(e, t, r[t]);
  if (cc)
    for (var t of cc(r))
      Yb.call(r, t) && r4(e, t, r[t]);
  return e;
}, yW = (e, r) => hW(e, bW(r)), CW = (e, r) => {
  var t = {};
  for (var n in e)
    Xb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && cc)
    for (var n of cc(e))
      r.indexOf(n) < 0 && Yb.call(e, n) && (t[n] = e[n]);
  return t;
};
const wW = {}, _W = ue((e, r) => {
  const t = Aa(), n = Oe(`${t.__staticSelector}Overlay`, wW, e), { onClick: o, transitionProps: a, style: i, className: l } = n, s = CW(n, ["onClick", "transitionProps", "style", "className"]), { classes: u, cx: d } = nW(null, t.stylesApi), f = (p) => {
    o == null || o(p), t.closeOnClickOutside && t.onClose();
  };
  return /* @__PURE__ */ E.createElement(Ra, yW(Ga(Ga({
    mounted: t.opened
  }, t.transitionProps), a), {
    transition: "fade"
  }), (p) => /* @__PURE__ */ E.createElement(Gb, Ga({
    ref: r,
    onClick: f,
    fixed: !0,
    style: Ga(Ga({}, i), p),
    className: d(u.overlay, l),
    zIndex: t.zIndex
  }, s)));
});
var xW = Ae((e, { zIndex: r }) => ({
  inner: {
    position: "fixed",
    width: "100%",
    top: 0,
    bottom: 0,
    maxHeight: "100%",
    zIndex: r,
    pointerEvents: "none"
  },
  content: {
    pointerEvents: "all"
  }
}));
const $W = xW;
var OW = Object.defineProperty, uc = Object.getOwnPropertySymbols, Ub = Object.prototype.hasOwnProperty, Jb = Object.prototype.propertyIsEnumerable, t4 = (e, r, t) => r in e ? OW(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Xa = (e, r) => {
  for (var t in r || (r = {}))
    Ub.call(r, t) && t4(e, t, r[t]);
  if (uc)
    for (var t of uc(r))
      Jb.call(r, t) && t4(e, t, r[t]);
  return e;
}, PW = (e, r) => {
  var t = {};
  for (var n in e)
    Ub.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && uc)
    for (var n of uc(e))
      r.indexOf(n) < 0 && Jb.call(e, n) && (t[n] = e[n]);
  return t;
};
const SW = {}, IW = ue((e, r) => {
  const t = Aa(), n = Oe(`${t.__staticSelector}Content`, SW, e), { className: o, transitionProps: a, style: i, onKeyDown: l } = n, s = PW(n, ["className", "transitionProps", "style", "onKeyDown"]), { classes: u, cx: d } = $W({ zIndex: t.zIndex }, t.stylesApi), f = (p) => {
    var g;
    ((g = p.target) == null ? void 0 : g.getAttribute("data-mantine-stop-propagation")) !== "true" && p.key === "Escape" && t.closeOnEscape && t.onClose(), l == null || l(p);
  };
  return /* @__PURE__ */ E.createElement(Ra, Xa(Xa({
    mounted: t.opened,
    transition: "pop"
  }, t.transitionProps), a), (p) => /* @__PURE__ */ E.createElement("div", {
    className: d(u.inner)
  }, /* @__PURE__ */ E.createElement(Lf, {
    active: t.opened && t.trapFocus
  }, /* @__PURE__ */ E.createElement(uZ, Xa({
    component: "section",
    role: "dialog",
    tabIndex: -1,
    "aria-modal": !0,
    "aria-describedby": t.bodyMounted ? t.getBodyId() : void 0,
    "aria-labelledby": t.titleMounted ? t.getTitleId() : void 0,
    onKeyDown: f,
    ref: r,
    className: d(u.content, o),
    style: Xa(Xa({}, i), p),
    shadow: t.shadow
  }, s), s.children))));
});
var EW = Ae((e, { padding: r }) => {
  const t = ve({ size: r, sizes: e.spacing });
  return {
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: t,
      paddingRight: `calc(${t} - ${B(5)})`,
      position: "sticky",
      top: 0,
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white,
      zIndex: 1e3
    }
  };
});
const RW = EW;
var AW = Object.defineProperty, dc = Object.getOwnPropertySymbols, qb = Object.prototype.hasOwnProperty, Kb = Object.prototype.propertyIsEnumerable, n4 = (e, r, t) => r in e ? AW(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, kW = (e, r) => {
  for (var t in r || (r = {}))
    qb.call(r, t) && n4(e, t, r[t]);
  if (dc)
    for (var t of dc(r))
      Kb.call(r, t) && n4(e, t, r[t]);
  return e;
}, MW = (e, r) => {
  var t = {};
  for (var n in e)
    qb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && dc)
    for (var n of dc(e))
      r.indexOf(n) < 0 && Kb.call(e, n) && (t[n] = e[n]);
  return t;
};
const NW = {}, TW = ue((e, r) => {
  const t = Aa(), n = Oe(`${t.__staticSelector}Header`, NW, e), { className: o } = n, a = MW(n, ["className"]), { classes: i, cx: l } = RW({ padding: t.padding }, t.stylesApi);
  return /* @__PURE__ */ E.createElement(We, kW({
    ref: r,
    className: l(i.header, o)
  }, a));
});
var DW = Ae((e) => ({
  title: {
    lineHeight: 1,
    padding: 0,
    margin: 0,
    fontWeight: 400,
    fontSize: e.fontSizes.md
  }
}));
const jW = DW;
var LW = Object.defineProperty, fc = Object.getOwnPropertySymbols, Qb = Object.prototype.hasOwnProperty, ey = Object.prototype.propertyIsEnumerable, o4 = (e, r, t) => r in e ? LW(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, zW = (e, r) => {
  for (var t in r || (r = {}))
    Qb.call(r, t) && o4(e, t, r[t]);
  if (fc)
    for (var t of fc(r))
      ey.call(r, t) && o4(e, t, r[t]);
  return e;
}, VW = (e, r) => {
  var t = {};
  for (var n in e)
    Qb.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && fc)
    for (var n of fc(e))
      r.indexOf(n) < 0 && ey.call(e, n) && (t[n] = e[n]);
  return t;
};
const FW = {}, ZW = ue((e, r) => {
  const t = Aa(), n = Oe(`${t.__staticSelector}Title`, FW, e), { className: o } = n, a = VW(n, ["className"]), { classes: i, cx: l } = jW(null, t.stylesApi);
  return Fe(() => (t.setTitleMounted(!0), () => t.setTitleMounted(!1)), []), /* @__PURE__ */ E.createElement(We, zW({
    component: "h2",
    id: t.getTitleId(),
    className: l(i.title, o),
    ref: r
  }, a));
});
var WW = Ae((e, { padding: r }) => ({
  body: {
    padding: ve({ size: r, sizes: e.spacing }),
    "&:not(:only-child)": {
      paddingTop: 0
    }
  }
}));
const BW = WW;
var HW = Object.defineProperty, pc = Object.getOwnPropertySymbols, ry = Object.prototype.hasOwnProperty, ty = Object.prototype.propertyIsEnumerable, a4 = (e, r, t) => r in e ? HW(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, GW = (e, r) => {
  for (var t in r || (r = {}))
    ry.call(r, t) && a4(e, t, r[t]);
  if (pc)
    for (var t of pc(r))
      ty.call(r, t) && a4(e, t, r[t]);
  return e;
}, XW = (e, r) => {
  var t = {};
  for (var n in e)
    ry.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && pc)
    for (var n of pc(e))
      r.indexOf(n) < 0 && ty.call(e, n) && (t[n] = e[n]);
  return t;
};
const YW = {}, UW = ue((e, r) => {
  const t = Aa(), n = Oe(`${t.__staticSelector}Body`, YW, e), { className: o } = n, a = XW(n, ["className"]), { classes: i, cx: l } = BW({ padding: t.padding }, t.stylesApi);
  return Fe(() => (t.setBodyMounted(!0), () => t.setBodyMounted(!1)), []), /* @__PURE__ */ E.createElement(We, GW({
    id: t.getBodyId(),
    className: l(i.body, o),
    ref: r
  }, a));
});
function JW({ children: e }) {
  return /* @__PURE__ */ E.createElement(E.Fragment, null, e);
}
function qW({ opened: e, transitionDuration: r }) {
  const [t, n] = Se(e), o = Ve(), i = Fu() ? 0 : r;
  return Fe(() => (e ? (n(!0), window.clearTimeout(o.current)) : i === 0 ? n(!1) : o.current = window.setTimeout(() => n(!1), i), () => window.clearTimeout(o.current)), [e, i]), t;
}
var KW = Ae(() => ({
  root: {}
})), QW = Object.defineProperty, eB = Object.defineProperties, rB = Object.getOwnPropertyDescriptors, gc = Object.getOwnPropertySymbols, ny = Object.prototype.hasOwnProperty, oy = Object.prototype.propertyIsEnumerable, i4 = (e, r, t) => r in e ? QW(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, yd = (e, r) => {
  for (var t in r || (r = {}))
    ny.call(r, t) && i4(e, t, r[t]);
  if (gc)
    for (var t of gc(r))
      oy.call(r, t) && i4(e, t, r[t]);
  return e;
}, l4 = (e, r) => eB(e, rB(r)), tB = (e, r) => {
  var t = {};
  for (var n in e)
    ny.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && gc)
    for (var n of gc(e))
      r.indexOf(n) < 0 && oy.call(e, n) && (t[n] = e[n]);
  return t;
};
const Di = {
  closeOnClickOutside: !0,
  withinPortal: !0,
  lockScroll: !0,
  trapFocus: !0,
  returnFocus: !0,
  closeOnEscape: !0,
  keepMounted: !1,
  zIndex: In("modal"),
  padding: "md",
  size: "md",
  shadow: "xl"
};
function ir(e) {
  const r = Oe("ModalBase", Di, e), {
    opened: t,
    onClose: n,
    children: o,
    closeOnClickOutside: a,
    __staticSelector: i,
    transitionProps: l,
    withinPortal: s,
    portalProps: u,
    keepMounted: d,
    target: f,
    zIndex: p,
    lockScroll: g,
    trapFocus: h,
    closeOnEscape: v,
    returnFocus: y,
    padding: w,
    shadow: $,
    id: C,
    size: x,
    variant: b,
    classNames: O,
    unstyled: _,
    styles: P,
    className: S
  } = r, I = tB(r, [
    "opened",
    "onClose",
    "children",
    "closeOnClickOutside",
    "__staticSelector",
    "transitionProps",
    "withinPortal",
    "portalProps",
    "keepMounted",
    "target",
    "zIndex",
    "lockScroll",
    "trapFocus",
    "closeOnEscape",
    "returnFocus",
    "padding",
    "shadow",
    "id",
    "size",
    "variant",
    "classNames",
    "unstyled",
    "styles",
    "className"
  ]), { classes: N, cx: k } = KW(null, {
    name: i,
    classNames: O,
    styles: P,
    unstyled: _,
    variant: b,
    size: x
  }), j = ke(C), [R, D] = Se(!1), [T, V] = Se(!1), L = typeof (l == null ? void 0 : l.duration) == "number" ? l == null ? void 0 : l.duration : 200, Z = qW({ opened: t, transitionDuration: L });
  return Cn("keydown", (z) => {
    !h && z.key === "Escape" && v && n();
  }), n8({ opened: t, shouldReturnFocus: h && y }), /* @__PURE__ */ E.createElement(Sa, l4(yd({}, u), {
    withinPortal: s,
    target: f
  }), /* @__PURE__ */ E.createElement(YZ, {
    value: {
      __staticSelector: i,
      opened: t,
      onClose: n,
      closeOnClickOutside: a,
      transitionProps: l4(yd({}, l), { duration: L, keepMounted: d }),
      zIndex: p,
      padding: w,
      id: j,
      getTitleId: () => `${j}-title`,
      getBodyId: () => `${j}-body`,
      titleMounted: R,
      bodyMounted: T,
      setTitleMounted: D,
      setBodyMounted: V,
      trapFocus: h,
      closeOnEscape: v,
      shadow: $,
      stylesApi: {
        name: i,
        size: x,
        variant: b,
        classNames: O,
        styles: P,
        unstyled: _
      }
    }
  }, /* @__PURE__ */ E.createElement(Wk, {
    enabled: Z && g
  }, /* @__PURE__ */ E.createElement(We, yd({
    className: k(N.root, S)
  }, I), o))));
}
ir.CloseButton = rW;
ir.Overlay = _W;
ir.Content = IW;
ir.Header = TW;
ir.Title = ZW;
ir.Body = UW;
ir.NativeScrollArea = JW;
var nB = Object.defineProperty, oB = Object.defineProperties, aB = Object.getOwnPropertyDescriptors, vc = Object.getOwnPropertySymbols, ay = Object.prototype.hasOwnProperty, iy = Object.prototype.propertyIsEnumerable, s4 = (e, r, t) => r in e ? nB(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ql = (e, r) => {
  for (var t in r || (r = {}))
    ay.call(r, t) && s4(e, t, r[t]);
  if (vc)
    for (var t of vc(r))
      iy.call(r, t) && s4(e, t, r[t]);
  return e;
}, ly = (e, r) => oB(e, aB(r)), iB = (e, r) => {
  var t = {};
  for (var n in e)
    ay.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && vc)
    for (var n of vc(e))
      r.indexOf(n) < 0 && iy.call(e, n) && (t[n] = e[n]);
  return t;
};
const lB = {
  top: "slide-down",
  bottom: "slide-up",
  left: "slide-right",
  right: "slide-left"
}, sB = {
  top: "slide-down",
  bottom: "slide-up",
  right: "slide-right",
  left: "slide-left"
}, cB = ly(ql({}, Di), {
  position: "left"
});
function sy(e) {
  const r = Oe("DrawerRoot", cB, e), { classNames: t, variant: n, size: o, scrollAreaComponent: a, position: i, transitionProps: l } = r, s = iB(r, ["classNames", "variant", "size", "scrollAreaComponent", "position", "transitionProps"]), { classes: u, cx: d, theme: f } = XZ({ position: i }, { name: "Drawer", variant: n, size: o }), p = (f.dir === "rtl" ? sB : lB)[i];
  return /* @__PURE__ */ E.createElement(HZ, {
    value: { scrollAreaComponent: a }
  }, /* @__PURE__ */ E.createElement(ir, ql({
    __staticSelector: "Drawer",
    size: o,
    variant: n,
    transitionProps: ql({ transition: p, duration: 200 }, l),
    classNames: ly(ql({}, t), {
      content: d(u.content, t == null ? void 0 : t.content),
      inner: d(u.inner, t == null ? void 0 : t.inner)
    })
  }, s)));
}
var uB = Object.defineProperty, mc = Object.getOwnPropertySymbols, cy = Object.prototype.hasOwnProperty, uy = Object.prototype.propertyIsEnumerable, c4 = (e, r, t) => r in e ? uB(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, dB = (e, r) => {
  for (var t in r || (r = {}))
    cy.call(r, t) && c4(e, t, r[t]);
  if (mc)
    for (var t of mc(r))
      uy.call(r, t) && c4(e, t, r[t]);
  return e;
}, fB = (e, r) => {
  var t = {};
  for (var n in e)
    cy.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && mc)
    for (var n of mc(e))
      r.indexOf(n) < 0 && uy.call(e, n) && (t[n] = e[n]);
  return t;
};
const pB = {
  shadow: "xl"
}, dy = ue((e, r) => {
  const t = Oe("ModalContent", pB, e), { children: n, scrollAreaComponent: o } = t, a = fB(t, ["children", "scrollAreaComponent"]), i = GZ(), l = o || i.scrollAreaComponent || ir.NativeScrollArea;
  return /* @__PURE__ */ E.createElement(ir.Content, dB({
    ref: r,
    radius: 0
  }, a), /* @__PURE__ */ E.createElement(l, {
    style: { height: "100vh" }
  }, n));
});
var gB = Object.defineProperty, vB = Object.defineProperties, mB = Object.getOwnPropertyDescriptors, hc = Object.getOwnPropertySymbols, fy = Object.prototype.hasOwnProperty, py = Object.prototype.propertyIsEnumerable, u4 = (e, r, t) => r in e ? gB(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Kl = (e, r) => {
  for (var t in r || (r = {}))
    fy.call(r, t) && u4(e, t, r[t]);
  if (hc)
    for (var t of hc(r))
      py.call(r, t) && u4(e, t, r[t]);
  return e;
}, hB = (e, r) => vB(e, mB(r)), bB = (e, r) => {
  var t = {};
  for (var n in e)
    fy.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && hc)
    for (var n of hc(e))
      r.indexOf(n) < 0 && py.call(e, n) && (t[n] = e[n]);
  return t;
};
const yB = hB(Kl({}, Di), {
  withOverlay: !0,
  withCloseButton: !0
});
function kn(e) {
  const r = Oe("Drawer", yB, e), {
    title: t,
    withOverlay: n,
    overlayProps: o,
    withCloseButton: a,
    closeButtonProps: i,
    children: l
  } = r, s = bB(r, [
    "title",
    "withOverlay",
    "overlayProps",
    "withCloseButton",
    "closeButtonProps",
    "children"
  ]), u = !!t || a;
  return /* @__PURE__ */ E.createElement(sy, Kl({}, s), n && /* @__PURE__ */ E.createElement(ir.Overlay, Kl({}, o)), /* @__PURE__ */ E.createElement(dy, null, u && /* @__PURE__ */ E.createElement(ir.Header, null, t && /* @__PURE__ */ E.createElement(ir.Title, null, t), a && /* @__PURE__ */ E.createElement(ir.CloseButton, Kl({}, i))), /* @__PURE__ */ E.createElement(ir.Body, null, l)));
}
kn.Root = sy;
kn.CloseButton = ir.CloseButton;
kn.Overlay = ir.Overlay;
kn.Content = dy;
kn.Header = ir.Header;
kn.Title = ir.Title;
kn.Body = ir.Body;
kn.NativeScrollArea = ir.NativeScrollArea;
const CB = {
  gap: { type: "spacing", property: "gap" },
  rowGap: { type: "spacing", property: "rowGap" },
  columnGap: { type: "spacing", property: "columnGap" },
  align: { type: "identity", property: "alignItems" },
  justify: { type: "identity", property: "justifyContent" },
  wrap: { type: "identity", property: "flexWrap" },
  direction: { type: "identity", property: "flexDirection" }
};
var wB = Object.defineProperty, _B = Object.defineProperties, xB = Object.getOwnPropertyDescriptors, bc = Object.getOwnPropertySymbols, gy = Object.prototype.hasOwnProperty, vy = Object.prototype.propertyIsEnumerable, d4 = (e, r, t) => r in e ? wB(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, $B = (e, r) => {
  for (var t in r || (r = {}))
    gy.call(r, t) && d4(e, t, r[t]);
  if (bc)
    for (var t of bc(r))
      vy.call(r, t) && d4(e, t, r[t]);
  return e;
}, OB = (e, r) => _B(e, xB(r)), PB = (e, r) => {
  var t = {};
  for (var n in e)
    gy.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && bc)
    for (var n of bc(e))
      r.indexOf(n) < 0 && vy.call(e, n) && (t[n] = e[n]);
  return t;
};
const SB = {}, IB = ue((e, r) => {
  const t = Oe("Flex", SB, e), { gap: n, rowGap: o, columnGap: a, align: i, justify: l, wrap: s, direction: u, sx: d } = t, f = PB(t, ["gap", "rowGap", "columnGap", "align", "justify", "wrap", "direction", "sx"]);
  return /* @__PURE__ */ E.createElement(We, OB($B({}, f), {
    sx: [
      { display: "flex" },
      (p) => h0({ gap: n, rowGap: o, columnGap: a, align: i, justify: l, wrap: s, direction: u }, p, CB),
      ...f1(d)
    ],
    ref: r
  }));
});
IB.displayName = "@mantine/core/Flex";
const [EB, RB] = no("Grid component was not found in tree");
var AB = Object.defineProperty, f4 = Object.getOwnPropertySymbols, kB = Object.prototype.hasOwnProperty, MB = Object.prototype.propertyIsEnumerable, p4 = (e, r, t) => r in e ? AB(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, NB = (e, r) => {
  for (var t in r || (r = {}))
    kB.call(r, t) && p4(e, t, r[t]);
  if (f4)
    for (var t of f4(r))
      MB.call(r, t) && p4(e, t, r[t]);
  return e;
};
const Bf = (e, r) => e === "content" ? "auto" : e === "auto" ? "0rem" : e ? `${100 / (r / e)}%` : void 0, my = (e, r, t) => t || e === "auto" || e === "content" ? "unset" : Bf(e, r), hy = (e, r) => {
  if (e)
    return e === "auto" || r ? 1 : 0;
}, by = (e, r) => e === 0 ? 0 : e ? `${100 / (r / e)}%` : void 0, yy = (e, r) => typeof e != "undefined" ? `calc(${ve({ size: e, sizes: r.spacing })} / 2)` : void 0;
function TB({
  sizes: e,
  offsets: r,
  orders: t,
  theme: n,
  columns: o,
  gutters: a,
  grow: i
}) {
  return X6.reduce((l, s) => (l[`@media (min-width: ${Nt(n.breakpoints[s])})`] = {
    order: t[s],
    flexBasis: Bf(e[s], o),
    padding: yy(a[s], n),
    flexShrink: 0,
    width: e[s] === "content" ? "auto" : void 0,
    maxWidth: my(e[s], o, i),
    marginLeft: by(r[s], o),
    flexGrow: hy(e[s], i)
  }, l), {});
}
var DB = Ae((e, {
  gutter: r,
  gutterXs: t,
  gutterSm: n,
  gutterMd: o,
  gutterLg: a,
  gutterXl: i,
  grow: l,
  offset: s,
  offsetXs: u,
  offsetSm: d,
  offsetMd: f,
  offsetLg: p,
  offsetXl: g,
  columns: h,
  span: v,
  xs: y,
  sm: w,
  md: $,
  lg: C,
  xl: x,
  order: b,
  orderXs: O,
  orderSm: _,
  orderMd: P,
  orderLg: S,
  orderXl: I
}) => ({
  col: NB({
    boxSizing: "border-box",
    flexGrow: hy(v, l),
    order: b,
    padding: yy(r, e),
    marginLeft: by(s, h),
    flexBasis: Bf(v, h),
    flexShrink: 0,
    width: v === "content" ? "auto" : void 0,
    maxWidth: my(v, h, l)
  }, TB({
    sizes: { xs: y, sm: w, md: $, lg: C, xl: x },
    offsets: { xs: u, sm: d, md: f, lg: p, xl: g },
    orders: { xs: O, sm: _, md: P, lg: S, xl: I },
    gutters: { xs: t, sm: n, md: o, lg: a, xl: i },
    theme: e,
    columns: h,
    grow: l
  }))
}));
const jB = DB;
var LB = Object.defineProperty, yc = Object.getOwnPropertySymbols, Cy = Object.prototype.hasOwnProperty, wy = Object.prototype.propertyIsEnumerable, g4 = (e, r, t) => r in e ? LB(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, zB = (e, r) => {
  for (var t in r || (r = {}))
    Cy.call(r, t) && g4(e, t, r[t]);
  if (yc)
    for (var t of yc(r))
      wy.call(r, t) && g4(e, t, r[t]);
  return e;
}, VB = (e, r) => {
  var t = {};
  for (var n in e)
    Cy.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && yc)
    for (var n of yc(e))
      r.indexOf(n) < 0 && wy.call(e, n) && (t[n] = e[n]);
  return t;
};
const FB = {};
function ZB(e) {
  return e === "auto" || e === "content" ? !0 : typeof e == "number" && e > 0 && e % 1 === 0;
}
const _y = ue((e, r) => {
  const t = Oe("GridCol", FB, e), {
    children: n,
    span: o,
    offset: a,
    offsetXs: i,
    offsetSm: l,
    offsetMd: s,
    offsetLg: u,
    offsetXl: d,
    xs: f,
    sm: p,
    md: g,
    lg: h,
    xl: v,
    order: y,
    orderXs: w,
    orderSm: $,
    orderMd: C,
    orderLg: x,
    orderXl: b,
    className: O,
    unstyled: _,
    variant: P
  } = t, S = VB(t, [
    "children",
    "span",
    "offset",
    "offsetXs",
    "offsetSm",
    "offsetMd",
    "offsetLg",
    "offsetXl",
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "order",
    "orderXs",
    "orderSm",
    "orderMd",
    "orderLg",
    "orderXl",
    "className",
    "unstyled",
    "variant"
  ]), I = RB(), N = o || I.columns, { classes: k, cx: j } = jB({
    gutter: I.gutter,
    gutterXs: I.gutterXs,
    gutterSm: I.gutterSm,
    gutterMd: I.gutterMd,
    gutterLg: I.gutterLg,
    gutterXl: I.gutterXl,
    offset: a,
    offsetXs: i,
    offsetSm: l,
    offsetMd: s,
    offsetLg: u,
    offsetXl: d,
    xs: f,
    sm: p,
    md: g,
    lg: h,
    xl: v,
    order: y,
    orderXs: w,
    orderSm: $,
    orderMd: C,
    orderLg: x,
    orderXl: b,
    grow: I.grow,
    columns: I.columns,
    span: N
  }, { unstyled: _, name: "Grid", variant: P });
  return !ZB(N) || N > I.columns ? null : /* @__PURE__ */ E.createElement(We, zB({
    className: j(k.col, O),
    ref: r
  }, S), n);
});
_y.displayName = "@mantine/core/Col";
var WB = Object.defineProperty, v4 = Object.getOwnPropertySymbols, BB = Object.prototype.hasOwnProperty, HB = Object.prototype.propertyIsEnumerable, m4 = (e, r, t) => r in e ? WB(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, GB = (e, r) => {
  for (var t in r || (r = {}))
    BB.call(r, t) && m4(e, t, r[t]);
  if (v4)
    for (var t of v4(r))
      HB.call(r, t) && m4(e, t, r[t]);
  return e;
};
function XB(e, r) {
  return X6.reduce((t, n) => (typeof e[n] != "undefined" && (t[`@media (min-width: ${r.breakpoints[n]})`] = {
    margin: `calc(-${ve({ size: e[n], sizes: r.spacing })} / 2)`
  }), t), {});
}
var YB = Ae((e, { justify: r, align: t, gutter: n, gutterXs: o, gutterSm: a, gutterMd: i, gutterLg: l, gutterXl: s }) => ({
  root: GB({
    margin: `calc(-${ve({ size: n, sizes: e.spacing })} / 2)`,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: r,
    alignItems: t
  }, XB({ xs: o, sm: a, md: i, lg: l, xl: s }, e))
})), UB = Object.defineProperty, Cc = Object.getOwnPropertySymbols, xy = Object.prototype.hasOwnProperty, $y = Object.prototype.propertyIsEnumerable, h4 = (e, r, t) => r in e ? UB(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, JB = (e, r) => {
  for (var t in r || (r = {}))
    xy.call(r, t) && h4(e, t, r[t]);
  if (Cc)
    for (var t of Cc(r))
      $y.call(r, t) && h4(e, t, r[t]);
  return e;
}, qB = (e, r) => {
  var t = {};
  for (var n in e)
    xy.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Cc)
    for (var n of Cc(e))
      r.indexOf(n) < 0 && $y.call(e, n) && (t[n] = e[n]);
  return t;
};
const KB = {
  gutter: "md",
  justify: "flex-start",
  align: "stretch",
  columns: 12
}, Oy = ue((e, r) => {
  const t = Oe("Grid", KB, e), {
    gutter: n,
    gutterXs: o,
    gutterSm: a,
    gutterMd: i,
    gutterLg: l,
    gutterXl: s,
    children: u,
    grow: d,
    justify: f,
    align: p,
    columns: g,
    className: h,
    unstyled: v,
    variant: y
  } = t, w = qB(t, [
    "gutter",
    "gutterXs",
    "gutterSm",
    "gutterMd",
    "gutterLg",
    "gutterXl",
    "children",
    "grow",
    "justify",
    "align",
    "columns",
    "className",
    "unstyled",
    "variant"
  ]), { classes: $, cx: C } = YB({ gutter: n, justify: f, align: p, gutterXs: o, gutterSm: a, gutterMd: i, gutterLg: l, gutterXl: s }, { unstyled: v, name: "Grid", variant: y });
  return /* @__PURE__ */ E.createElement(EB, {
    value: { gutter: n, gutterXs: o, gutterSm: a, gutterMd: i, gutterLg: l, gutterXl: s, grow: d, columns: g }
  }, /* @__PURE__ */ E.createElement(We, JB({
    className: C($.root, h),
    ref: r
  }, w), u));
});
Oy.Col = _y;
Oy.displayName = "@mantine/core/Grid";
function QB(e) {
  return Gr.toArray(e).filter(Boolean);
}
const Py = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
  apart: "space-between"
};
var eH = Ae((e, { spacing: r, position: t, noWrap: n, grow: o, align: a, count: i }) => ({
  root: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: a || "center",
    flexWrap: n ? "nowrap" : "wrap",
    justifyContent: Py[t],
    gap: ve({ size: r, sizes: e.spacing }),
    "& > *": {
      boxSizing: "border-box",
      maxWidth: o ? `calc(${100 / i}% - (${B(ve({ size: r, sizes: e.spacing }))} - ${ve({ size: r, sizes: e.spacing })} / ${i}))` : void 0,
      flexGrow: o ? 1 : 0
    }
  }
}));
const rH = eH;
var tH = Object.defineProperty, wc = Object.getOwnPropertySymbols, Sy = Object.prototype.hasOwnProperty, Iy = Object.prototype.propertyIsEnumerable, b4 = (e, r, t) => r in e ? tH(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, nH = (e, r) => {
  for (var t in r || (r = {}))
    Sy.call(r, t) && b4(e, t, r[t]);
  if (wc)
    for (var t of wc(r))
      Iy.call(r, t) && b4(e, t, r[t]);
  return e;
}, oH = (e, r) => {
  var t = {};
  for (var n in e)
    Sy.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && wc)
    for (var n of wc(e))
      r.indexOf(n) < 0 && Iy.call(e, n) && (t[n] = e[n]);
  return t;
};
const aH = {
  position: "left",
  spacing: "md"
}, Ey = ue((e, r) => {
  const t = Oe("Group", aH, e), {
    className: n,
    position: o,
    align: a,
    children: i,
    noWrap: l,
    grow: s,
    spacing: u,
    unstyled: d,
    variant: f
  } = t, p = oH(t, [
    "className",
    "position",
    "align",
    "children",
    "noWrap",
    "grow",
    "spacing",
    "unstyled",
    "variant"
  ]), g = QB(i), { classes: h, cx: v } = rH({
    align: a,
    grow: s,
    noWrap: l,
    spacing: u,
    position: o,
    count: g.length
  }, { unstyled: d, name: "Group", variant: f });
  return /* @__PURE__ */ E.createElement(We, nH({
    className: v(h.root, n),
    ref: r
  }, p), g);
});
Ey.displayName = "@mantine/core/Group";
function iH({ open: e, close: r, openDelay: t, closeDelay: n }) {
  const o = Ve(-1), a = Ve(-1), i = () => {
    window.clearTimeout(o.current), window.clearTimeout(a.current);
  }, l = () => {
    i(), t === 0 ? e() : o.current = window.setTimeout(e, t);
  }, s = () => {
    i(), n === 0 ? r() : a.current = window.setTimeout(r, n);
  };
  return Fe(() => i, []), { openDropdown: l, closeDropdown: s };
}
var lH = qn, sH = function(r) {
  var t = A.useRef(r);
  return lH(function() {
    t.current = r;
  }), t;
}, y4 = function(r, t) {
  if (typeof r == "function") {
    r(t);
    return;
  }
  r.current = t;
}, cH = function(r, t) {
  var n = Ve();
  return $e(function(o) {
    r.current = o, n.current && y4(n.current, null), n.current = t, t && y4(t, o);
  }, [t]);
}, C4 = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0"
}, w4 = function(r) {
  Object.keys(C4).forEach(function(t) {
    r.style.setProperty(t, C4[t], "important");
  });
}, gt = null, uH = function(r, t) {
  var n = r.scrollHeight;
  return t.sizingStyle.boxSizing === "border-box" ? n + t.borderSize : n - t.paddingSize;
};
function dH(e, r, t, n) {
  t === void 0 && (t = 1), n === void 0 && (n = 1 / 0), gt || (gt = document.createElement("textarea"), gt.setAttribute("tabindex", "-1"), gt.setAttribute("aria-hidden", "true"), w4(gt)), gt.parentNode === null && document.body.appendChild(gt);
  var o = e.paddingSize, a = e.borderSize, i = e.sizingStyle, l = i.boxSizing;
  Object.keys(i).forEach(function(p) {
    var g = p;
    gt.style[g] = i[g];
  }), w4(gt), gt.value = r;
  var s = uH(gt, e);
  gt.value = "x";
  var u = gt.scrollHeight - o, d = u * t;
  l === "border-box" && (d = d + o + a), s = Math.max(d, s);
  var f = u * n;
  return l === "border-box" && (f = f + o + a), s = Math.min(f, s), [s, u];
}
var _4 = function() {
}, fH = function(r, t) {
  return r.reduce(function(n, o) {
    return n[o] = t[o], n;
  }, {});
}, pH = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak"
], gH = !!document.documentElement.currentStyle, vH = function(r) {
  var t = window.getComputedStyle(r);
  if (t === null)
    return null;
  var n = fH(pH, t), o = n.boxSizing;
  if (o === "")
    return null;
  gH && o === "border-box" && (n.width = parseFloat(n.width) + parseFloat(n.borderRightWidth) + parseFloat(n.borderLeftWidth) + parseFloat(n.paddingRight) + parseFloat(n.paddingLeft) + "px");
  var a = parseFloat(n.paddingBottom) + parseFloat(n.paddingTop), i = parseFloat(n.borderBottomWidth) + parseFloat(n.borderTopWidth);
  return {
    sizingStyle: n,
    paddingSize: a,
    borderSize: i
  };
}, mH = function(r) {
  var t = sH(r);
  qn(function() {
    var n = function(a) {
      t.current(a);
    };
    return window.addEventListener("resize", n), function() {
      window.removeEventListener("resize", n);
    };
  }, []);
}, hH = function(r, t) {
  var n = r.cacheMeasurements, o = r.maxRows, a = r.minRows, i = r.onChange, l = i === void 0 ? _4 : i, s = r.onHeightChange, u = s === void 0 ? _4 : s, d = Xe(r, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);
  if (process.env.NODE_ENV !== "production" && d.style) {
    if ("maxHeight" in d.style)
      throw new Error("Using `style.maxHeight` for <TextareaAutosize/> is not supported. Please use `maxRows`.");
    if ("minHeight" in d.style)
      throw new Error("Using `style.minHeight` for <TextareaAutosize/> is not supported. Please use `minRows`.");
  }
  var f = d.value !== void 0, p = Ve(null), g = cH(p, t), h = Ve(0), v = Ve(), y = function() {
    var C = p.current, x = n && v.current ? v.current : vH(C);
    if (x) {
      v.current = x;
      var b = dH(x, C.value || C.placeholder || "x", a, o), O = b[0], _ = b[1];
      h.current !== O && (h.current = O, C.style.setProperty("height", O + "px", "important"), u(O, {
        rowHeight: _
      }));
    }
  }, w = function(C) {
    f || y(), l(C);
  };
  return qn(y), mH(y), /* @__PURE__ */ sr("textarea", F({}, d, {
    onChange: w,
    ref: g
  }));
}, bH = /* @__PURE__ */ ue(hH);
const yH = bH;
var CH = Ae((e) => ({
  input: {
    paddingTop: e.spacing.xs,
    paddingBottom: e.spacing.xs
  }
})), wH = Object.defineProperty, _H = Object.defineProperties, xH = Object.getOwnPropertyDescriptors, _c = Object.getOwnPropertySymbols, Ry = Object.prototype.hasOwnProperty, Ay = Object.prototype.propertyIsEnumerable, x4 = (e, r, t) => r in e ? wH(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, qo = (e, r) => {
  for (var t in r || (r = {}))
    Ry.call(r, t) && x4(e, t, r[t]);
  if (_c)
    for (var t of _c(r))
      Ay.call(r, t) && x4(e, t, r[t]);
  return e;
}, Cd = (e, r) => _H(e, xH(r)), $H = (e, r) => {
  var t = {};
  for (var n in e)
    Ry.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && _c)
    for (var n of _c(e))
      r.indexOf(n) < 0 && Ay.call(e, n) && (t[n] = e[n]);
  return t;
};
const OH = {
  autosize: !1,
  size: "sm",
  __staticSelector: "Textarea"
}, ky = ue((e, r) => {
  const t = Oe("Textarea", OH, e), {
    autosize: n,
    maxRows: o,
    minRows: a,
    label: i,
    error: l,
    description: s,
    id: u,
    className: d,
    required: f,
    style: p,
    wrapperProps: g,
    classNames: h,
    styles: v,
    size: y,
    __staticSelector: w,
    sx: $,
    errorProps: C,
    descriptionProps: x,
    labelProps: b,
    inputWrapperOrder: O,
    inputContainer: _,
    unstyled: P,
    withAsterisk: S,
    variant: I
  } = t, N = $H(t, [
    "autosize",
    "maxRows",
    "minRows",
    "label",
    "error",
    "description",
    "id",
    "className",
    "required",
    "style",
    "wrapperProps",
    "classNames",
    "styles",
    "size",
    "__staticSelector",
    "sx",
    "errorProps",
    "descriptionProps",
    "labelProps",
    "inputWrapperOrder",
    "inputContainer",
    "unstyled",
    "withAsterisk",
    "variant"
  ]), k = ke(u), { classes: j, cx: R } = CH(), { systemStyles: D, rest: T } = En(N), V = qo({
    required: f,
    ref: r,
    error: l,
    id: k,
    classNames: Cd(qo({}, h), { input: R(j.input, h == null ? void 0 : h.input) }),
    styles: v,
    __staticSelector: w,
    size: y,
    multiline: !0,
    unstyled: P,
    variant: I
  }, T);
  return /* @__PURE__ */ E.createElement(jr.Wrapper, qo(qo({
    label: i,
    error: l,
    id: k,
    description: s,
    required: f,
    style: p,
    className: d,
    classNames: h,
    styles: v,
    size: y,
    __staticSelector: w,
    sx: $,
    errorProps: C,
    labelProps: b,
    descriptionProps: x,
    inputContainer: _,
    inputWrapperOrder: O,
    unstyled: P,
    withAsterisk: S,
    variant: I
  }, D), g), n ? /* @__PURE__ */ E.createElement(jr, Cd(qo({}, V), {
    component: yH,
    maxRows: o,
    minRows: a
  })) : /* @__PURE__ */ E.createElement(jr, Cd(qo({}, V), {
    component: "textarea",
    rows: a
  })));
});
ky.displayName = "@mantine/core/Textarea";
var PH = Object.defineProperty, SH = Object.defineProperties, IH = Object.getOwnPropertyDescriptors, $4 = Object.getOwnPropertySymbols, EH = Object.prototype.hasOwnProperty, RH = Object.prototype.propertyIsEnumerable, O4 = (e, r, t) => r in e ? PH(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, AH = (e, r) => {
  for (var t in r || (r = {}))
    EH.call(r, t) && O4(e, t, r[t]);
  if ($4)
    for (var t of $4(r))
      RH.call(r, t) && O4(e, t, r[t]);
  return e;
}, kH = (e, r) => SH(e, IH(r)), MH = Ae((e) => ({
  root: kH(AH({}, e.fn.cover()), {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden"
  })
})), NH = Object.defineProperty, TH = Object.defineProperties, DH = Object.getOwnPropertyDescriptors, xc = Object.getOwnPropertySymbols, My = Object.prototype.hasOwnProperty, Ny = Object.prototype.propertyIsEnumerable, P4 = (e, r, t) => r in e ? NH(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, hl = (e, r) => {
  for (var t in r || (r = {}))
    My.call(r, t) && P4(e, t, r[t]);
  if (xc)
    for (var t of xc(r))
      Ny.call(r, t) && P4(e, t, r[t]);
  return e;
}, jH = (e, r) => TH(e, DH(r)), LH = (e, r) => {
  var t = {};
  for (var n in e)
    My.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && xc)
    for (var n of xc(e))
      r.indexOf(n) < 0 && Ny.call(e, n) && (t[n] = e[n]);
  return t;
};
const zH = {
  overlayOpacity: 0.75,
  transitionDuration: 0,
  radius: 0,
  zIndex: In("overlay")
}, Ty = ue((e, r) => {
  const t = Oe("LoadingOverlay", zH, e), {
    className: n,
    visible: o,
    loaderProps: a,
    overlayOpacity: i,
    overlayColor: l,
    transitionDuration: s,
    exitTransitionDuration: u,
    zIndex: d,
    style: f,
    loader: p,
    radius: g,
    overlayBlur: h,
    unstyled: v,
    variant: y,
    keepMounted: w
  } = t, $ = LH(t, [
    "className",
    "visible",
    "loaderProps",
    "overlayOpacity",
    "overlayColor",
    "transitionDuration",
    "exitTransitionDuration",
    "zIndex",
    "style",
    "loader",
    "radius",
    "overlayBlur",
    "unstyled",
    "variant",
    "keepMounted"
  ]), { classes: C, cx: x, theme: b } = MH(null, { name: "LoadingOverlay", unstyled: v, variant: y }), O = `calc(${d} + 1)`;
  return /* @__PURE__ */ E.createElement(Ra, {
    keepMounted: w,
    duration: s,
    exitDuration: u,
    mounted: o,
    transition: "fade"
  }, (_) => /* @__PURE__ */ E.createElement(We, hl({
    className: x(C.root, n),
    style: jH(hl(hl({}, _), f), { zIndex: d }),
    ref: r
  }, $), p ? /* @__PURE__ */ E.createElement("div", {
    style: { zIndex: O }
  }, p) : /* @__PURE__ */ E.createElement(wf, hl({
    style: { zIndex: O }
  }, a)), /* @__PURE__ */ E.createElement(Gb, {
    opacity: i,
    zIndex: d,
    radius: g,
    blur: h,
    unstyled: v,
    color: l || (b.colorScheme === "dark" ? b.colors.dark[5] : b.white)
  })));
});
Ty.displayName = "@mantine/core/LoadingOverlay";
var VH = Ae((e, { smallerThan: r, largerThan: t, query: n, styles: o }) => {
  const a = {}, i = ve({ size: t, sizes: e.breakpoints }), l = ve({ size: r, sizes: e.breakpoints }), s = typeof o == "function" ? o(e) : o;
  return t !== void 0 && r !== void 0 ? a[`@media (min-width: ${Nt(i)}) and (max-width: ${Nt($t(l) - 1)})`] = s : (t !== void 0 && (a[`@media (min-width: ${ve({ size: t, sizes: e.breakpoints })})`] = s), r !== void 0 && (a[`@media (max-width: ${Nt($t(ve({ size: r, sizes: e.breakpoints })) - 1)})`] = s)), n && (a[`@media ${n}`] = s), { media: a };
});
function FH(e) {
  var r;
  const { children: t, smallerThan: n, largerThan: o, query: a, styles: i, className: l } = Oe("MediaQuery", {}, e), { classes: s, cx: u } = VH({ smallerThan: n, largerThan: o, query: a, styles: i }, { name: "MediaQuery" }), d = Gr.only(t);
  return typeof d == "object" && d !== null && "props" in d ? E.cloneElement(d, {
    className: u(s.media, (r = d.props) == null ? void 0 : r.className, l)
  }) : d;
}
FH.displayName = "@mantine/core/MediaQuery";
const Dy = {
  context: "Menu component was not found in the tree",
  children: "Menu.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
}, [ZH, ji] = no(Dy.context);
var WH = Ae((e) => ({
  divider: {
    marginTop: B(4),
    marginBottom: B(4),
    borderTop: `${B(1)} solid ${e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2]}`
  }
})), BH = Object.defineProperty, $c = Object.getOwnPropertySymbols, jy = Object.prototype.hasOwnProperty, Ly = Object.prototype.propertyIsEnumerable, S4 = (e, r, t) => r in e ? BH(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, HH = (e, r) => {
  for (var t in r || (r = {}))
    jy.call(r, t) && S4(e, t, r[t]);
  if ($c)
    for (var t of $c(r))
      Ly.call(r, t) && S4(e, t, r[t]);
  return e;
}, GH = (e, r) => {
  var t = {};
  for (var n in e)
    jy.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && $c)
    for (var n of $c(e))
      r.indexOf(n) < 0 && Ly.call(e, n) && (t[n] = e[n]);
  return t;
};
const XH = {}, zy = ue((e, r) => {
  const t = Oe("MenuDivider", XH, e), { children: n, className: o } = t, a = GH(t, ["children", "className"]), { classNames: i, styles: l, unstyled: s, variant: u } = ji(), { classes: d, cx: f } = WH(null, { name: "Menu", classNames: i, styles: l, unstyled: s, variant: u });
  return /* @__PURE__ */ E.createElement(We, HH({
    className: f(d.divider, o),
    ref: r
  }, a));
});
zy.displayName = "@mantine/core/MenuDivider";
var YH = Object.defineProperty, Oc = Object.getOwnPropertySymbols, Vy = Object.prototype.hasOwnProperty, Fy = Object.prototype.propertyIsEnumerable, I4 = (e, r, t) => r in e ? YH(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, UH = (e, r) => {
  for (var t in r || (r = {}))
    Vy.call(r, t) && I4(e, t, r[t]);
  if (Oc)
    for (var t of Oc(r))
      Fy.call(r, t) && I4(e, t, r[t]);
  return e;
}, JH = (e, r) => {
  var t = {};
  for (var n in e)
    Vy.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Oc)
    for (var n of Oc(e))
      r.indexOf(n) < 0 && Fy.call(e, n) && (t[n] = e[n]);
  return t;
};
const qH = {};
function Zy(e) {
  const r = Oe("MenuDropdown", qH, e), { children: t, onMouseEnter: n, onMouseLeave: o } = r, a = JH(r, ["children", "onMouseEnter", "onMouseLeave"]), i = Ve(), l = ji(), s = (f) => {
    var p;
    (f.key === "ArrowUp" || f.key === "ArrowDown") && (f.preventDefault(), (p = i.current.querySelectorAll("[data-menu-item]:not(:disabled)")[0]) == null || p.focus());
  }, u = bn(n, () => l.trigger === "hover" && l.openDropdown()), d = bn(o, () => l.trigger === "hover" && l.closeDropdown());
  return /* @__PURE__ */ E.createElement(nt.Dropdown, UH({
    onMouseEnter: u,
    onMouseLeave: d,
    role: "menu",
    "aria-orientation": "vertical"
  }, a), /* @__PURE__ */ E.createElement("div", {
    tabIndex: -1,
    "data-menu-dropdown": !0,
    "data-autofocus": !0,
    onKeyDown: s,
    ref: i,
    style: { outline: 0 }
  }, t));
}
Zy.displayName = "@mantine/core/MenuDropdown";
var KH = Object.defineProperty, QH = Object.defineProperties, eG = Object.getOwnPropertyDescriptors, E4 = Object.getOwnPropertySymbols, rG = Object.prototype.hasOwnProperty, tG = Object.prototype.propertyIsEnumerable, R4 = (e, r, t) => r in e ? KH(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, nG = (e, r) => {
  for (var t in r || (r = {}))
    rG.call(r, t) && R4(e, t, r[t]);
  if (E4)
    for (var t of E4(r))
      tG.call(r, t) && R4(e, t, r[t]);
  return e;
}, oG = (e, r) => QH(e, eG(r)), aG = Ae((e, { color: r, radius: t }) => ({
  item: oG(nG({}, e.fn.fontStyles()), {
    WebkitTapHighlightColor: "transparent",
    fontSize: e.fontSizes.sm,
    border: 0,
    backgroundColor: "transparent",
    outline: 0,
    width: "100%",
    textAlign: "left",
    textDecoration: "none",
    boxSizing: "border-box",
    padding: `${e.spacing.xs} ${e.spacing.sm}`,
    cursor: "pointer",
    borderRadius: e.fn.radius(t),
    color: r ? e.fn.variant({ variant: "filled", primaryFallback: !1, color: r }).background : e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    display: "flex",
    alignItems: "center",
    "&:disabled": {
      color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[5],
      pointerEvents: "none",
      userSelect: "none"
    },
    "&[data-hovered]": {
      backgroundColor: r ? e.fn.variant({ variant: "light", color: r }).background : e.colorScheme === "dark" ? e.fn.rgba(e.colors.dark[3], 0.35) : e.colors.gray[1]
    }
  }),
  itemLabel: {
    flex: 1
  },
  itemIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: e.spacing.xs
  },
  itemRightSection: {}
}));
const iG = aG;
var lG = Object.defineProperty, sG = Object.defineProperties, cG = Object.getOwnPropertyDescriptors, Pc = Object.getOwnPropertySymbols, Wy = Object.prototype.hasOwnProperty, By = Object.prototype.propertyIsEnumerable, A4 = (e, r, t) => r in e ? lG(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, uG = (e, r) => {
  for (var t in r || (r = {}))
    Wy.call(r, t) && A4(e, t, r[t]);
  if (Pc)
    for (var t of Pc(r))
      By.call(r, t) && A4(e, t, r[t]);
  return e;
}, dG = (e, r) => sG(e, cG(r)), fG = (e, r) => {
  var t = {};
  for (var n in e)
    Wy.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Pc)
    for (var n of Pc(e))
      r.indexOf(n) < 0 && By.call(e, n) && (t[n] = e[n]);
  return t;
};
const pG = {}, Hy = ue((e, r) => {
  const t = Oe("MenuItem", pG, e), { children: n, className: o, color: a, closeMenuOnClick: i, icon: l, rightSection: s } = t, u = fG(t, ["children", "className", "color", "closeMenuOnClick", "icon", "rightSection"]), d = ji(), { classes: f, cx: p, theme: g } = iG({ radius: d.radius, color: a }, {
    name: "Menu",
    classNames: d.classNames,
    styles: d.styles,
    unstyled: d.unstyled,
    variant: d.variant
  }), h = Ve(), v = d.getItemIndex(h.current), y = u, w = bn(y.onMouseLeave, () => d.setHovered(-1)), $ = bn(y.onMouseEnter, () => d.setHovered(d.getItemIndex(h.current))), C = bn(y.onClick, () => {
    typeof i == "boolean" ? i && d.closeDropdownImmediately() : d.closeOnItemClick && d.closeDropdownImmediately();
  }), x = bn(y.onFocus, () => d.setHovered(d.getItemIndex(h.current)));
  return /* @__PURE__ */ E.createElement(We, dG(uG({
    component: "button",
    type: "button"
  }, u), {
    tabIndex: -1,
    onFocus: x,
    className: p(f.item, o),
    ref: Kn(h, r),
    role: "menuitem",
    "data-menu-item": !0,
    "data-hovered": d.hovered === v ? !0 : void 0,
    onMouseEnter: $,
    onMouseLeave: w,
    onClick: C,
    onKeyDown: z6({
      siblingSelector: "[data-menu-item]",
      parentSelector: "[data-menu-dropdown]",
      activateOnFocus: !1,
      loop: d.loop,
      dir: g.dir,
      orientation: "vertical",
      onKeyDown: y.onKeydown
    })
  }), l && /* @__PURE__ */ E.createElement("div", {
    className: f.itemIcon
  }, l), n && /* @__PURE__ */ E.createElement("div", {
    className: f.itemLabel
  }, n), s && /* @__PURE__ */ E.createElement("div", {
    className: f.itemRightSection
  }, s));
});
Hy.displayName = "@mantine/core/MenuItem";
const gG = Hy;
var vG = Ae((e) => ({
  label: {
    color: e.colorScheme === "dark" ? e.colors.dark[2] : e.colors.gray[6],
    fontWeight: 500,
    fontSize: e.fontSizes.xs,
    padding: `calc(${e.spacing.xs} / 2) ${e.spacing.sm}`,
    cursor: "default"
  }
})), mG = Object.defineProperty, Sc = Object.getOwnPropertySymbols, Gy = Object.prototype.hasOwnProperty, Xy = Object.prototype.propertyIsEnumerable, k4 = (e, r, t) => r in e ? mG(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, hG = (e, r) => {
  for (var t in r || (r = {}))
    Gy.call(r, t) && k4(e, t, r[t]);
  if (Sc)
    for (var t of Sc(r))
      Xy.call(r, t) && k4(e, t, r[t]);
  return e;
}, bG = (e, r) => {
  var t = {};
  for (var n in e)
    Gy.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Sc)
    for (var n of Sc(e))
      r.indexOf(n) < 0 && Xy.call(e, n) && (t[n] = e[n]);
  return t;
};
const yG = {}, Yy = ue((e, r) => {
  const t = Oe("MenuLabel", yG, e), { children: n, className: o } = t, a = bG(t, ["children", "className"]), { classNames: i, styles: l, unstyled: s, variant: u } = ji(), { classes: d, cx: f } = vG(null, { name: "Menu", classNames: i, styles: l, unstyled: s, variant: u });
  return /* @__PURE__ */ E.createElement(Ia, hG({
    className: f(d.label, o),
    ref: r
  }, a), n);
});
Yy.displayName = "@mantine/core/MenuLabel";
var CG = Object.defineProperty, Ic = Object.getOwnPropertySymbols, Uy = Object.prototype.hasOwnProperty, Jy = Object.prototype.propertyIsEnumerable, M4 = (e, r, t) => r in e ? CG(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, wG = (e, r) => {
  for (var t in r || (r = {}))
    Uy.call(r, t) && M4(e, t, r[t]);
  if (Ic)
    for (var t of Ic(r))
      Jy.call(r, t) && M4(e, t, r[t]);
  return e;
}, _G = (e, r) => {
  var t = {};
  for (var n in e)
    Uy.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ic)
    for (var n of Ic(e))
      r.indexOf(n) < 0 && Jy.call(e, n) && (t[n] = e[n]);
  return t;
};
const xG = {
  refProp: "ref"
}, qy = ue((e, r) => {
  const t = Oe("MenuTarget", xG, e), { children: n, refProp: o } = t, a = _G(t, ["children", "refProp"]);
  if (!Pa(n))
    throw new Error(Dy.children);
  const i = ji(), l = bn(n.props.onClick, () => i.trigger === "click" && i.toggleDropdown()), s = bn(n.props.onMouseEnter, () => i.trigger === "hover" && i.openDropdown()), u = bn(n.props.onMouseLeave, () => i.trigger === "hover" && i.closeDropdown());
  return /* @__PURE__ */ E.createElement(nt.Target, wG({
    refProp: o,
    popupType: "menu",
    ref: r
  }, a), Wr(n, {
    onClick: l,
    onMouseEnter: s,
    onMouseLeave: u,
    "data-expanded": i.opened ? !0 : void 0
  }));
});
qy.displayName = "@mantine/core/MenuTarget";
var $G = Ae({
  dropdown: { padding: B(4) }
}), OG = Object.defineProperty, PG = Object.defineProperties, SG = Object.getOwnPropertyDescriptors, Ec = Object.getOwnPropertySymbols, Ky = Object.prototype.hasOwnProperty, Qy = Object.prototype.propertyIsEnumerable, N4 = (e, r, t) => r in e ? OG(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, T4 = (e, r) => {
  for (var t in r || (r = {}))
    Ky.call(r, t) && N4(e, t, r[t]);
  if (Ec)
    for (var t of Ec(r))
      Qy.call(r, t) && N4(e, t, r[t]);
  return e;
}, D4 = (e, r) => PG(e, SG(r)), IG = (e, r) => {
  var t = {};
  for (var n in e)
    Ky.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ec)
    for (var n of Ec(e))
      r.indexOf(n) < 0 && Qy.call(e, n) && (t[n] = e[n]);
  return t;
};
const EG = {
  closeOnItemClick: !0,
  loop: !0,
  trigger: "click",
  openDelay: 0,
  closeDelay: 100
};
function pn(e) {
  const r = Oe("Menu", EG, e), {
    children: t,
    onOpen: n,
    onClose: o,
    opened: a,
    defaultOpened: i,
    onChange: l,
    closeOnItemClick: s,
    loop: u,
    closeOnEscape: d,
    trigger: f,
    openDelay: p,
    closeDelay: g,
    classNames: h,
    styles: v,
    unstyled: y,
    radius: w,
    variant: $
  } = r, C = IG(r, [
    "children",
    "onOpen",
    "onClose",
    "opened",
    "defaultOpened",
    "onChange",
    "closeOnItemClick",
    "loop",
    "closeOnEscape",
    "trigger",
    "openDelay",
    "closeDelay",
    "classNames",
    "styles",
    "unstyled",
    "radius",
    "variant"
  ]), { classes: x, cx: b } = $G(), [O, { setHovered: _, resetHovered: P }] = Jk(), [S, I] = Hr({
    value: a,
    defaultValue: i,
    finalValue: !1,
    onChange: l
  }), N = () => {
    I(!1), S && (o == null || o());
  }, k = () => {
    I(!0), !S && (n == null || n());
  }, j = () => S ? N() : k(), { openDropdown: R, closeDropdown: D } = iH({ open: k, close: N, closeDelay: g, openDelay: p }), T = (V) => Xk("[data-menu-item]", "[data-menu-dropdown]", V);
  return ct(() => {
    P();
  }, [S]), /* @__PURE__ */ E.createElement(ZH, {
    value: {
      opened: S,
      toggleDropdown: j,
      getItemIndex: T,
      hovered: O,
      setHovered: _,
      closeOnItemClick: s,
      closeDropdown: f === "click" ? N : D,
      openDropdown: f === "click" ? k : R,
      closeDropdownImmediately: N,
      loop: u,
      trigger: f,
      radius: w,
      classNames: h,
      styles: v,
      unstyled: y,
      variant: $
    }
  }, /* @__PURE__ */ E.createElement(nt, D4(T4({}, C), {
    radius: w,
    opened: S,
    onChange: j,
    defaultOpened: i,
    trapFocus: f === "click",
    closeOnEscape: d && f === "click",
    __staticSelector: "Menu",
    classNames: D4(T4({}, h), { dropdown: b(x.dropdown, h == null ? void 0 : h.dropdown) }),
    styles: v,
    unstyled: y,
    variant: $
  }), t));
}
pn.displayName = "@mantine/core/Menu";
pn.Item = gG;
pn.Label = Yy;
pn.Dropdown = Zy;
pn.Target = qy;
pn.Divider = zy;
const [RG, AG] = no("Modal component was not found in tree"), kG = {
  xs: B(320),
  sm: B(380),
  md: B(440),
  lg: B(620),
  xl: B(780)
};
var MG = Ae((e, { yOffset: r, xOffset: t, centered: n, fullScreen: o }, { size: a }) => ({
  content: {
    flex: o ? "0 0 100%" : `0 0 ${ve({ size: a, sizes: kG })}`,
    maxWidth: "100%",
    maxHeight: o ? void 0 : `calc(100dvh - (${B(r)} * 2))`,
    height: o ? "100vh" : void 0,
    borderRadius: o ? 0 : void 0,
    overflowY: "auto"
  },
  inner: {
    paddingTop: o ? 0 : r,
    paddingBottom: o ? 0 : r,
    paddingLeft: o ? 0 : t,
    paddingRight: o ? 0 : t,
    display: "flex",
    justifyContent: "center",
    alignItems: n ? "center" : "flex-start"
  }
})), NG = Object.defineProperty, TG = Object.defineProperties, DG = Object.getOwnPropertyDescriptors, Rc = Object.getOwnPropertySymbols, eC = Object.prototype.hasOwnProperty, rC = Object.prototype.propertyIsEnumerable, j4 = (e, r, t) => r in e ? NG(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, S0 = (e, r) => {
  for (var t in r || (r = {}))
    eC.call(r, t) && j4(e, t, r[t]);
  if (Rc)
    for (var t of Rc(r))
      rC.call(r, t) && j4(e, t, r[t]);
  return e;
}, tC = (e, r) => TG(e, DG(r)), jG = (e, r) => {
  var t = {};
  for (var n in e)
    eC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Rc)
    for (var n of Rc(e))
      r.indexOf(n) < 0 && rC.call(e, n) && (t[n] = e[n]);
  return t;
};
const LG = tC(S0({}, Di), {
  yOffset: "5dvh",
  xOffset: "5vw"
});
function nC(e) {
  const r = Oe("ModalRoot", LG, e), {
    classNames: t,
    variant: n,
    size: o,
    yOffset: a,
    xOffset: i,
    scrollAreaComponent: l,
    radius: s,
    centered: u,
    fullScreen: d
  } = r, f = jG(r, [
    "classNames",
    "variant",
    "size",
    "yOffset",
    "xOffset",
    "scrollAreaComponent",
    "radius",
    "centered",
    "fullScreen"
  ]), { classes: p, cx: g } = MG({ yOffset: a, xOffset: i, centered: u, fullScreen: d }, { name: "Modal", variant: n, size: o });
  return /* @__PURE__ */ E.createElement(RG, {
    value: { yOffset: a, scrollAreaComponent: l, radius: s }
  }, /* @__PURE__ */ E.createElement(ir, S0({
    __staticSelector: "Modal",
    size: o,
    variant: n,
    classNames: tC(S0({}, t), {
      content: g(p.content, t == null ? void 0 : t.content),
      inner: g(p.inner, t == null ? void 0 : t.inner)
    })
  }, f)));
}
var zG = Object.defineProperty, Ac = Object.getOwnPropertySymbols, oC = Object.prototype.hasOwnProperty, aC = Object.prototype.propertyIsEnumerable, L4 = (e, r, t) => r in e ? zG(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, VG = (e, r) => {
  for (var t in r || (r = {}))
    oC.call(r, t) && L4(e, t, r[t]);
  if (Ac)
    for (var t of Ac(r))
      aC.call(r, t) && L4(e, t, r[t]);
  return e;
}, FG = (e, r) => {
  var t = {};
  for (var n in e)
    oC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ac)
    for (var n of Ac(e))
      r.indexOf(n) < 0 && aC.call(e, n) && (t[n] = e[n]);
  return t;
};
const ZG = {
  shadow: "xl"
}, iC = ue((e, r) => {
  const t = Oe("ModalContent", ZG, e), { children: n, scrollAreaComponent: o } = t, a = FG(t, ["children", "scrollAreaComponent"]), i = AG(), l = o || i.scrollAreaComponent || ir.NativeScrollArea;
  return /* @__PURE__ */ E.createElement(ir.Content, VG({
    ref: r,
    radius: i.radius
  }, a), /* @__PURE__ */ E.createElement(l, {
    style: { maxHeight: `calc(100dvh - (${B(i.yOffset)} * 2))` }
  }, n));
});
var WG = Object.defineProperty, BG = Object.defineProperties, HG = Object.getOwnPropertyDescriptors, kc = Object.getOwnPropertySymbols, lC = Object.prototype.hasOwnProperty, sC = Object.prototype.propertyIsEnumerable, z4 = (e, r, t) => r in e ? WG(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Ql = (e, r) => {
  for (var t in r || (r = {}))
    lC.call(r, t) && z4(e, t, r[t]);
  if (kc)
    for (var t of kc(r))
      sC.call(r, t) && z4(e, t, r[t]);
  return e;
}, GG = (e, r) => BG(e, HG(r)), XG = (e, r) => {
  var t = {};
  for (var n in e)
    lC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && kc)
    for (var n of kc(e))
      r.indexOf(n) < 0 && sC.call(e, n) && (t[n] = e[n]);
  return t;
};
const YG = GG(Ql({}, Di), {
  transitionProps: { duration: 200, transition: "pop" },
  withOverlay: !0,
  withCloseButton: !0
});
function gn(e) {
  const r = Oe("Modal", YG, e), {
    title: t,
    withOverlay: n,
    overlayProps: o,
    withCloseButton: a,
    closeButtonProps: i,
    children: l
  } = r, s = XG(r, [
    "title",
    "withOverlay",
    "overlayProps",
    "withCloseButton",
    "closeButtonProps",
    "children"
  ]), u = !!t || a;
  return /* @__PURE__ */ E.createElement(nC, Ql({}, s), n && /* @__PURE__ */ E.createElement(ir.Overlay, Ql({}, o)), /* @__PURE__ */ E.createElement(iC, null, u && /* @__PURE__ */ E.createElement(ir.Header, null, t && /* @__PURE__ */ E.createElement(ir.Title, null, t), a && /* @__PURE__ */ E.createElement(ir.CloseButton, Ql({}, i))), /* @__PURE__ */ E.createElement(ir.Body, null, l)));
}
gn.Root = nC;
gn.CloseButton = ir.CloseButton;
gn.Overlay = ir.Overlay;
gn.Content = iC;
gn.Header = ir.Header;
gn.Title = ir.Title;
gn.Body = ir.Body;
gn.NativeScrollArea = ir.NativeScrollArea;
var UG = Object.defineProperty, Mc = Object.getOwnPropertySymbols, cC = Object.prototype.hasOwnProperty, uC = Object.prototype.propertyIsEnumerable, V4 = (e, r, t) => r in e ? UG(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, F4 = (e, r) => {
  for (var t in r || (r = {}))
    cC.call(r, t) && V4(e, t, r[t]);
  if (Mc)
    for (var t of Mc(r))
      uC.call(r, t) && V4(e, t, r[t]);
  return e;
}, JG = (e, r) => {
  var t = {};
  for (var n in e)
    cC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Mc)
    for (var n of Mc(e))
      r.indexOf(n) < 0 && uC.call(e, n) && (t[n] = e[n]);
  return t;
};
const qG = {
  xs: B(14),
  sm: B(18),
  md: B(20),
  lg: B(24),
  xl: B(28)
};
function KG(e) {
  var r = e, { size: t, error: n, style: o } = r, a = JG(r, ["size", "error", "style"]);
  const i = ft(), l = ve({ size: t, sizes: qG });
  return /* @__PURE__ */ E.createElement("svg", F4({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: F4({
      color: n ? i.colors.red[6] : i.colors.gray[6],
      width: l,
      height: l
    }, o),
    "data-chevron": !0
  }, a), /* @__PURE__ */ E.createElement("path", {
    d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}
var QG = Object.defineProperty, eX = Object.defineProperties, rX = Object.getOwnPropertyDescriptors, Z4 = Object.getOwnPropertySymbols, tX = Object.prototype.hasOwnProperty, nX = Object.prototype.propertyIsEnumerable, W4 = (e, r, t) => r in e ? QG(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, oX = (e, r) => {
  for (var t in r || (r = {}))
    tX.call(r, t) && W4(e, t, r[t]);
  if (Z4)
    for (var t of Z4(r))
      nX.call(r, t) && W4(e, t, r[t]);
  return e;
}, aX = (e, r) => eX(e, rX(r));
function dC({
  shouldClear: e,
  clearButtonProps: r,
  onClear: t,
  size: n,
  error: o
}) {
  return e ? /* @__PURE__ */ E.createElement(Ai, aX(oX({}, r), {
    variant: "transparent",
    onClick: t,
    size: n,
    onMouseDown: (a) => a.preventDefault()
  })) : /* @__PURE__ */ E.createElement(KG, {
    error: o,
    size: n
  });
}
dC.displayName = "@mantine/core/SelectRightSection";
var iX = Object.defineProperty, lX = Object.defineProperties, sX = Object.getOwnPropertyDescriptors, Nc = Object.getOwnPropertySymbols, fC = Object.prototype.hasOwnProperty, pC = Object.prototype.propertyIsEnumerable, B4 = (e, r, t) => r in e ? iX(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, wd = (e, r) => {
  for (var t in r || (r = {}))
    fC.call(r, t) && B4(e, t, r[t]);
  if (Nc)
    for (var t of Nc(r))
      pC.call(r, t) && B4(e, t, r[t]);
  return e;
}, H4 = (e, r) => lX(e, sX(r)), cX = (e, r) => {
  var t = {};
  for (var n in e)
    fC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Nc)
    for (var n of Nc(e))
      r.indexOf(n) < 0 && pC.call(e, n) && (t[n] = e[n]);
  return t;
};
function uX(e) {
  var r = e, {
    styles: t,
    rightSection: n,
    rightSectionWidth: o,
    theme: a
  } = r, i = cX(r, [
    "styles",
    "rightSection",
    "rightSectionWidth",
    "theme"
  ]);
  if (n)
    return { rightSection: n, rightSectionWidth: o, styles: t };
  const l = typeof t == "function" ? t(a) : t;
  return {
    rightSection: !i.readOnly && !(i.disabled && i.shouldClear) && /* @__PURE__ */ E.createElement(dC, wd({}, i)),
    styles: H4(wd({}, l), {
      rightSection: H4(wd({}, l == null ? void 0 : l.rightSection), {
        pointerEvents: i.shouldClear ? void 0 : "none"
      })
    })
  };
}
var dX = Object.defineProperty, fX = Object.defineProperties, pX = Object.getOwnPropertyDescriptors, Tc = Object.getOwnPropertySymbols, gC = Object.prototype.hasOwnProperty, vC = Object.prototype.propertyIsEnumerable, G4 = (e, r, t) => r in e ? dX(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, _d = (e, r) => {
  for (var t in r || (r = {}))
    gC.call(r, t) && G4(e, t, r[t]);
  if (Tc)
    for (var t of Tc(r))
      vC.call(r, t) && G4(e, t, r[t]);
  return e;
}, gX = (e, r) => fX(e, pX(r)), vX = (e, r) => {
  var t = {};
  for (var n in e)
    gC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Tc)
    for (var n of Tc(e))
      r.indexOf(n) < 0 && vC.call(e, n) && (t[n] = e[n]);
  return t;
};
const mX = {
  type: "text",
  size: "sm",
  __staticSelector: "TextInput"
}, mC = ue((e, r) => {
  const t = Ti("TextInput", mX, e), { inputProps: n, wrapperProps: o } = t, a = vX(t, ["inputProps", "wrapperProps"]);
  return /* @__PURE__ */ E.createElement(jr.Wrapper, _d({}, o), /* @__PURE__ */ E.createElement(jr, gX(_d(_d({}, n), a), {
    ref: r
  })));
});
mC.displayName = "@mantine/core/TextInput";
const hX = ({
  reveal: e,
  size: r
}) => /* @__PURE__ */ E.createElement("svg", {
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: { width: r, height: r }
}, /* @__PURE__ */ E.createElement("path", {
  d: e ? "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z" : "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd"
}));
var bX = Object.defineProperty, yX = Object.defineProperties, CX = Object.getOwnPropertyDescriptors, X4 = Object.getOwnPropertySymbols, wX = Object.prototype.hasOwnProperty, _X = Object.prototype.propertyIsEnumerable, Y4 = (e, r, t) => r in e ? bX(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, xd = (e, r) => {
  for (var t in r || (r = {}))
    wX.call(r, t) && Y4(e, t, r[t]);
  if (X4)
    for (var t of X4(r))
      _X.call(r, t) && Y4(e, t, r[t]);
  return e;
}, U4 = (e, r) => yX(e, CX(r)), xX = Ae((e, { rightSectionWidth: r }, { size: t }) => ({
  visibilityToggle: {},
  input: {
    position: "relative",
    overflow: "hidden"
  },
  innerInput: U4(xd(xd({}, e.fn.fontStyles()), e.fn.cover(0)), {
    backgroundColor: "transparent",
    border: `${B(1)} solid transparent`,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    boxSizing: "border-box",
    display: "block",
    width: `calc(100% - ${B(r)})`,
    paddingLeft: `calc(${ve({ size: t, sizes: ot })}  / 3)`,
    fontSize: ve({ size: t, sizes: e.fontSizes }),
    height: `calc(${ve({ size: t, sizes: ot })} - ${B(2)})`,
    lineHeight: `calc(${ve({ size: t, sizes: ot })} - ${B(4)})`,
    color: e.colorScheme === "dark" ? e.colors.dark[0] : e.black,
    "&::-ms-reveal, &::-ms-clear": {
      display: "none"
    },
    "&:focus": {
      outline: 0
    },
    "&:disabled": {
      cursor: "not-allowed",
      pointerEvents: "none",
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[1],
      color: e.colors.dark[2],
      opacity: 0.6,
      "&::placeholder": {
        color: e.colors.dark[2]
      }
    },
    "&::placeholder": U4(xd({}, e.fn.placeholderStyles()), {
      opacity: 1
    }),
    "&[data-invalid]": {
      color: e.fn.variant({ variant: "filled", color: "red" }).background,
      "&::placeholder": {
        opacity: 1,
        color: e.fn.variant({ variant: "filled", color: "red" }).background
      }
    },
    "&[data-with-icon]": {
      paddingLeft: ve({ size: t, sizes: ot })
    }
  })
})), $X = Object.defineProperty, OX = Object.defineProperties, PX = Object.getOwnPropertyDescriptors, Dc = Object.getOwnPropertySymbols, hC = Object.prototype.hasOwnProperty, bC = Object.prototype.propertyIsEnumerable, J4 = (e, r, t) => r in e ? $X(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, bl = (e, r) => {
  for (var t in r || (r = {}))
    hC.call(r, t) && J4(e, t, r[t]);
  if (Dc)
    for (var t of Dc(r))
      bC.call(r, t) && J4(e, t, r[t]);
  return e;
}, SX = (e, r) => OX(e, PX(r)), IX = (e, r) => {
  var t = {};
  for (var n in e)
    hC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Dc)
    for (var n of Dc(e))
      r.indexOf(n) < 0 && bC.call(e, n) && (t[n] = e[n]);
  return t;
};
const EX = {
  xs: B(22),
  sm: B(26),
  md: B(28),
  lg: B(32),
  xl: B(40)
}, RX = {
  xs: B(12),
  sm: B(15),
  md: B(17),
  lg: B(19),
  xl: B(21)
}, AX = {
  xs: B(28),
  sm: B(32),
  md: B(34),
  lg: B(44),
  xl: B(54)
}, kX = {
  size: "sm",
  toggleTabIndex: -1,
  visibilityToggleIcon: hX,
  __staticSelector: "PasswordInput"
}, yC = ue((e, r) => {
  const t = Oe("PasswordInput", kX, e), {
    radius: n,
    disabled: o,
    size: a,
    toggleTabIndex: i,
    className: l,
    id: s,
    label: u,
    error: d,
    required: f,
    style: p,
    icon: g,
    description: h,
    wrapperProps: v,
    classNames: y,
    styles: w,
    variant: $,
    visibilityToggleIcon: C,
    __staticSelector: x,
    sx: b,
    labelProps: O,
    descriptionProps: _,
    errorProps: P,
    unstyled: S,
    visibilityToggleLabel: I,
    withAsterisk: N,
    inputContainer: k,
    iconWidth: j,
    inputWrapperOrder: R,
    visible: D,
    defaultVisible: T,
    onVisibilityChange: V
  } = t, L = IX(t, [
    "radius",
    "disabled",
    "size",
    "toggleTabIndex",
    "className",
    "id",
    "label",
    "error",
    "required",
    "style",
    "icon",
    "description",
    "wrapperProps",
    "classNames",
    "styles",
    "variant",
    "visibilityToggleIcon",
    "__staticSelector",
    "sx",
    "labelProps",
    "descriptionProps",
    "errorProps",
    "unstyled",
    "visibilityToggleLabel",
    "withAsterisk",
    "inputContainer",
    "iconWidth",
    "inputWrapperOrder",
    "visible",
    "defaultVisible",
    "onVisibilityChange"
  ]), Z = ve({ size: a, sizes: AX }), { classes: z } = xX({ rightSectionWidth: Z }, { name: "PasswordInput", classNames: y, styles: w, unstyled: S, size: a, variant: $ }), W = ke(s), { systemStyles: U, rest: re } = En(L), [X, J] = Hr({
    value: D,
    defaultValue: T,
    finalValue: !1,
    onChange: V
  }), Q = () => J(!X), se = /* @__PURE__ */ E.createElement(p1, {
    className: z.visibilityToggle,
    tabIndex: i,
    radius: n,
    size: ve({ size: a, sizes: EX }),
    "aria-hidden": !I,
    "aria-label": I,
    unstyled: S,
    onMouseDown: (q) => {
      q.preventDefault(), Q();
    },
    onKeyDown: (q) => {
      q.key === " " && (q.preventDefault(), Q());
    }
  }, /* @__PURE__ */ E.createElement(C, {
    reveal: X,
    size: ve({ size: a, sizes: RX })
  }));
  return /* @__PURE__ */ E.createElement(jr.Wrapper, bl(bl({
    required: f,
    id: W,
    label: u,
    error: d,
    description: h,
    size: a,
    className: l,
    style: p,
    classNames: y,
    styles: w,
    __staticSelector: x,
    sx: b,
    errorProps: P,
    descriptionProps: _,
    labelProps: O,
    unstyled: S,
    withAsterisk: N,
    inputWrapperOrder: R,
    inputContainer: k,
    variant: $
  }, U), v), /* @__PURE__ */ E.createElement(jr, {
    component: "div",
    error: d,
    icon: g,
    size: a,
    classNames: SX(bl({}, y), { input: z.input }),
    styles: w,
    radius: n,
    disabled: o,
    __staticSelector: x,
    rightSectionWidth: Z,
    rightSection: !o && se,
    variant: $,
    unstyled: S,
    iconWidth: j
  }, /* @__PURE__ */ E.createElement("input", bl({
    type: X ? "text" : "password",
    required: f,
    "data-invalid": !!d || void 0,
    "data-with-icon": !!g || void 0,
    className: z.innerInput,
    disabled: o,
    id: W,
    ref: r,
    autoComplete: "off"
  }, re))));
});
yC.displayName = "@mantine/core/PasswordInput";
function q4(e, r) {
  if (e < 1)
    return [];
  const t = new Array(e).fill("");
  if (r) {
    const n = r.trim().split("");
    for (let o = 0; o < Math.min(e, n.length); o += 1)
      t[o] = n[o];
  }
  return t;
}
const $d = {
  xs: B(28),
  sm: B(32),
  md: B(36),
  lg: B(40),
  xl: B(48)
};
var MX = Ae((e, r, { size: t }) => ({
  root: {},
  input: {
    width: ve({ size: t, sizes: $d }),
    height: ve({ size: t, sizes: $d }),
    textAlign: "center",
    minHeight: "auto",
    padding: 0,
    lineHeight: ve({ size: t, sizes: $d }),
    "&::selection": {
      background: "transparent"
    }
  }
})), NX = Object.defineProperty, TX = Object.defineProperties, DX = Object.getOwnPropertyDescriptors, jc = Object.getOwnPropertySymbols, CC = Object.prototype.hasOwnProperty, wC = Object.prototype.propertyIsEnumerable, K4 = (e, r, t) => r in e ? NX(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Q4 = (e, r) => {
  for (var t in r || (r = {}))
    CC.call(r, t) && K4(e, t, r[t]);
  if (jc)
    for (var t of jc(r))
      wC.call(r, t) && K4(e, t, r[t]);
  return e;
}, jX = (e, r) => TX(e, DX(r)), LX = (e, r) => {
  var t = {};
  for (var n in e)
    CC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && jc)
    for (var n of jc(e))
      r.indexOf(n) < 0 && wC.call(e, n) && (t[n] = e[n]);
  return t;
};
const eg = {
  number: /^[0-9]+$/,
  alphanumeric: /^[a-zA-Z0-9]+$/i
}, zX = {
  spacing: "sm",
  size: "sm",
  length: 4,
  manageFocus: !0,
  placeholder: "○",
  type: "alphanumeric"
}, _C = ue((e, r) => {
  const t = Oe("PinInput", zX, e), {
    name: n,
    form: o,
    className: a,
    value: i,
    defaultValue: l,
    variant: s,
    spacing: u,
    size: d,
    classNames: f,
    styles: p,
    unstyled: g,
    sx: h,
    length: v,
    onChange: y,
    onComplete: w,
    manageFocus: $,
    autoFocus: C,
    error: x,
    radius: b,
    disabled: O,
    oneTimeCode: _,
    placeholder: P,
    type: S,
    mask: I,
    "aria-label": N,
    readOnly: k,
    inputType: j,
    inputMode: R
  } = t, D = LX(t, [
    "name",
    "form",
    "className",
    "value",
    "defaultValue",
    "variant",
    "spacing",
    "size",
    "classNames",
    "styles",
    "unstyled",
    "sx",
    "length",
    "onChange",
    "onComplete",
    "manageFocus",
    "autoFocus",
    "error",
    "radius",
    "disabled",
    "oneTimeCode",
    "placeholder",
    "type",
    "mask",
    "aria-label",
    "readOnly",
    "inputType",
    "inputMode"
  ]), T = ke(n), { classes: V, cx: L } = MX(null, {
    name: "PinInput",
    classNames: f,
    styles: p,
    unstyled: g,
    variant: s,
    size: d
  }), [Z, z] = Se(-1), [W, U] = Hr({
    value: i,
    defaultValue: l,
    finalValue: "",
    onChange: y
  }), re = Ve([]), X = (G) => {
    const oe = S instanceof RegExp ? S : S in eg ? eg[S] : null;
    return oe == null ? void 0 : oe.test(G);
  }, J = (G, oe) => {
    if ($) {
      if (G === "next") {
        const ne = oe + 1;
        re.current[ne < v ? ne : oe].focus();
      }
      if (G === "prev") {
        const ne = oe - 1;
        re.current[ne > -1 ? ne : oe].focus();
      }
    }
  }, Q = (G, oe) => {
    const ne = [...q4(v, W)];
    ne[oe] = G, U(ne.join(""));
  }, se = (G, oe) => {
    const ne = G.target.value, _e = ne.length === 2 ? ne.split("")[ne.length - 1] : ne, ye = X(_e);
    _e.length < 2 ? ye ? (Q(_e, oe), J("next", oe)) : Q("", oe) : ye && U(ne);
  }, q = (G, oe) => {
    G.key === "ArrowLeft" ? (G.preventDefault(), J("prev", oe)) : G.key === "ArrowRight" ? (G.preventDefault(), J("next", oe)) : G.key === "Delete" ? (G.preventDefault(), Q("", oe)) : G.key === "Backspace" && (G.preventDefault(), Q("", oe), v === oe + 1 ? G.target.value === "" && J("prev", oe) : J("prev", oe));
  }, te = (G, oe) => {
    G.target.select(), z(oe);
  }, ae = () => {
    z(-1);
  }, ge = (G) => {
    G.preventDefault();
    const oe = G.clipboardData.getData("Text");
    X(oe) && U(oe);
  };
  return Fe(() => {
    W.length === v && (w == null || w(W));
  }, [W]), /* @__PURE__ */ E.createElement(E.Fragment, null, /* @__PURE__ */ E.createElement(Ey, Q4({
    role: "group",
    spacing: u,
    ref: r,
    className: L(V.root, a),
    sx: h,
    unstyled: g,
    id: T,
    noWrap: !0
  }, D), q4(v, W).map((G, oe) => /* @__PURE__ */ E.createElement(jr, {
    __staticSelector: "PinInput",
    id: `${T}-${oe + 1}`,
    key: `${T}-${oe}`,
    inputMode: R || (S === "number" ? "numeric" : "text"),
    onChange: (ne) => se(ne, oe),
    onKeyDown: (ne) => q(ne, oe),
    onFocus: (ne) => te(ne, oe),
    onBlur: ae,
    onPaste: ge,
    type: j || (I ? "password" : S === "number" ? "tel" : "text"),
    radius: b,
    error: x,
    variant: s,
    size: d,
    disabled: O,
    ref: (ne) => {
      re.current[oe] = ne;
    },
    autoComplete: _ ? "one-time-code" : "off",
    placeholder: Z === oe ? "" : P,
    value: G,
    autoFocus: C && oe === 0,
    classNames: jX(Q4({}, f), {
      input: L(V.input, f == null ? void 0 : f.input)
    }),
    styles: p,
    unstyled: g,
    "aria-label": N,
    readOnly: k
  }))), /* @__PURE__ */ E.createElement("input", {
    type: "hidden",
    name: n,
    form: o,
    value: W
  }));
});
_C.displayName = "@mantine/core/PinInput";
const xC = xt(!1), VX = xC.Provider, FX = () => dt(xC);
function $C({ children: e, openDelay: r = 0, closeDelay: t = 0 }) {
  return /* @__PURE__ */ E.createElement(VX, {
    value: !0
  }, /* @__PURE__ */ E.createElement(rz, {
    delay: { open: r, close: t }
  }, e));
}
$C.displayName = "@mantine/core/TooltipGroup";
var ZX = Object.defineProperty, WX = Object.defineProperties, BX = Object.getOwnPropertyDescriptors, rg = Object.getOwnPropertySymbols, HX = Object.prototype.hasOwnProperty, GX = Object.prototype.propertyIsEnumerable, tg = (e, r, t) => r in e ? ZX(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ng = (e, r) => {
  for (var t in r || (r = {}))
    HX.call(r, t) && tg(e, t, r[t]);
  if (rg)
    for (var t of rg(r))
      GX.call(r, t) && tg(e, t, r[t]);
  return e;
}, XX = (e, r) => WX(e, BX(r));
function YX(e, r) {
  if (!r)
    return {
      backgroundColor: e.colorScheme === "dark" ? e.colors.gray[2] : e.colors.gray[9],
      color: e.colorScheme === "dark" ? e.black : e.white
    };
  const t = e.fn.variant({ variant: "filled", color: r, primaryFallback: !1 });
  return {
    backgroundColor: t.background,
    color: t.color
  };
}
var OC = Ae((e, { color: r, radius: t, width: n, multiline: o }) => ({
  tooltip: XX(ng(ng({}, e.fn.fontStyles()), YX(e, r)), {
    lineHeight: e.lineHeight,
    fontSize: e.fontSizes.sm,
    borderRadius: e.fn.radius(t),
    padding: `calc(${e.spacing.xs} / 2) ${e.spacing.xs}`,
    position: "absolute",
    whiteSpace: o ? "unset" : "nowrap",
    pointerEvents: "none",
    width: n
  }),
  arrow: {
    backgroundColor: "inherit",
    border: 0,
    zIndex: 1
  }
}));
const PC = {
  children: "Tooltip component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
};
function UX({
  offset: e,
  position: r
}) {
  const [t, n] = Se(!1), o = Ve(), { x: a, y: i, reference: l, floating: s, refs: u, update: d, placement: f } = jf({
    placement: r,
    middleware: [
      Nf({
        crossAxis: !0,
        padding: 5,
        rootBoundary: "document"
      })
    ]
  }), p = f.includes("right") ? e : r.includes("left") ? e * -1 : 0, g = f.includes("bottom") ? e : r.includes("top") ? e * -1 : 0, h = $e(({ clientX: v, clientY: y }) => {
    l({
      getBoundingClientRect() {
        return {
          width: 0,
          height: 0,
          x: v,
          y,
          left: v + p,
          top: y + g,
          right: v,
          bottom: y
        };
      }
    });
  }, [l]);
  return Fe(() => {
    if (u.floating.current) {
      const v = o.current;
      v.addEventListener("mousemove", h);
      const y = yn(u.floating.current);
      return y.forEach((w) => {
        w.addEventListener("scroll", d);
      }), () => {
        v.removeEventListener("mousemove", h), y.forEach((w) => {
          w.removeEventListener("scroll", d);
        });
      };
    }
  }, [l, u.floating.current, d, h, t]), { handleMouseMove: h, x: a, y: i, opened: t, setOpened: n, boundaryRef: o, floating: s };
}
var JX = Object.defineProperty, qX = Object.defineProperties, KX = Object.getOwnPropertyDescriptors, Lc = Object.getOwnPropertySymbols, SC = Object.prototype.hasOwnProperty, IC = Object.prototype.propertyIsEnumerable, og = (e, r, t) => r in e ? JX(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, yl = (e, r) => {
  for (var t in r || (r = {}))
    SC.call(r, t) && og(e, t, r[t]);
  if (Lc)
    for (var t of Lc(r))
      IC.call(r, t) && og(e, t, r[t]);
  return e;
}, Cl = (e, r) => qX(e, KX(r)), QX = (e, r) => {
  var t = {};
  for (var n in e)
    SC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Lc)
    for (var n of Lc(e))
      r.indexOf(n) < 0 && IC.call(e, n) && (t[n] = e[n]);
  return t;
};
const eY = {
  refProp: "ref",
  withinPortal: !0,
  offset: 10,
  position: "right",
  zIndex: In("popover")
};
function EC(e) {
  var r;
  const t = Oe("TooltipFloating", eY, e), {
    children: n,
    refProp: o,
    withinPortal: a,
    portalProps: i,
    style: l,
    className: s,
    classNames: u,
    styles: d,
    unstyled: f,
    radius: p,
    color: g,
    label: h,
    offset: v,
    position: y,
    multiline: w,
    width: $,
    zIndex: C,
    disabled: x,
    variant: b
  } = t, O = QX(t, [
    "children",
    "refProp",
    "withinPortal",
    "portalProps",
    "style",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "radius",
    "color",
    "label",
    "offset",
    "position",
    "multiline",
    "width",
    "zIndex",
    "disabled",
    "variant"
  ]), { handleMouseMove: _, x: P, y: S, opened: I, boundaryRef: N, floating: k, setOpened: j } = UX({
    offset: v,
    position: y
  }), { classes: R, cx: D } = OC({ radius: p, color: g, multiline: w, width: $ }, { name: "TooltipFloating", classNames: u, styles: d, unstyled: f, variant: b });
  if (!Pa(n))
    throw new Error(PC.children);
  const T = Kn(N, n.ref), V = (Z) => {
    var z, W;
    (W = (z = n.props).onMouseEnter) == null || W.call(z, Z), _(Z), j(!0);
  }, L = (Z) => {
    var z, W;
    (W = (z = n.props).onMouseLeave) == null || W.call(z, Z), j(!1);
  };
  return /* @__PURE__ */ E.createElement(E.Fragment, null, /* @__PURE__ */ E.createElement(Sa, Cl(yl({}, i), {
    withinPortal: a
  }), /* @__PURE__ */ E.createElement(We, Cl(yl({}, O), {
    ref: k,
    className: D(R.tooltip, s),
    style: Cl(yl({}, l), {
      zIndex: C,
      display: !x && I ? "block" : "none",
      top: S != null ? S : "",
      left: (r = Math.round(P)) != null ? r : ""
    })
  }), h)), Wr(n, Cl(yl({}, n.props), {
    [o]: T,
    onMouseEnter: V,
    onMouseLeave: L
  })));
}
EC.displayName = "@mantine/core/TooltipFloating";
function rY(e) {
  const [r, t] = Se(!1), o = typeof e.opened == "boolean" ? e.opened : r, a = FX(), i = ke(), { delay: l, currentId: s, setCurrentId: u } = Ah(), d = $e((P) => {
    t(P), P && u(i);
  }, [u, i]), {
    x: f,
    y: p,
    reference: g,
    floating: h,
    context: v,
    refs: y,
    update: w,
    placement: $,
    middlewareData: { arrow: { x: C, y: x } = {} }
  } = jf({
    placement: e.position,
    open: o,
    onOpenChange: d,
    middleware: [
      vh(e.offset),
      Nf({ padding: 8 }),
      $h(),
      Ph({ element: e.arrowRef, padding: e.arrowOffset }),
      ...e.inline ? [Oh()] : []
    ]
  }), { getReferenceProps: b, getFloatingProps: O } = pz([
    ez(v, {
      enabled: e.events.hover,
      delay: a ? l : { open: e.openDelay, close: e.closeDelay },
      mouseOnly: !e.events.touch
    }),
    dz(v, { enabled: e.events.focus, keyboardOnly: !0 }),
    fz(v, { role: "tooltip" }),
    uz(v, { enabled: typeof e.opened === void 0 }),
    tz(v, { id: i })
  ]);
  return Mh({
    opened: o,
    position: e.position,
    positionDependencies: e.positionDependencies,
    floating: { refs: y, update: w }
  }), ct(() => {
    var P;
    (P = e.onPositionChange) == null || P.call(e, $);
  }, [$]), {
    x: f,
    y: p,
    arrowX: C,
    arrowY: x,
    reference: g,
    floating: h,
    getFloatingProps: O,
    getReferenceProps: b,
    isGroupPhase: o && s && s !== i,
    opened: o,
    placement: $
  };
}
var tY = Object.defineProperty, nY = Object.defineProperties, oY = Object.getOwnPropertyDescriptors, zc = Object.getOwnPropertySymbols, RC = Object.prototype.hasOwnProperty, AC = Object.prototype.propertyIsEnumerable, ag = (e, r, t) => r in e ? tY(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, fo = (e, r) => {
  for (var t in r || (r = {}))
    RC.call(r, t) && ag(e, t, r[t]);
  if (zc)
    for (var t of zc(r))
      AC.call(r, t) && ag(e, t, r[t]);
  return e;
}, Od = (e, r) => nY(e, oY(r)), aY = (e, r) => {
  var t = {};
  for (var n in e)
    RC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && zc)
    for (var n of zc(e))
      r.indexOf(n) < 0 && AC.call(e, n) && (t[n] = e[n]);
  return t;
};
const iY = {
  position: "top",
  refProp: "ref",
  withinPortal: !1,
  inline: !1,
  arrowSize: 4,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  offset: 5,
  transitionProps: { duration: 100, transition: "fade" },
  width: "auto",
  events: { hover: !0, focus: !1, touch: !1 },
  zIndex: In("popover"),
  positionDependencies: []
}, _1 = ue((e, r) => {
  var t;
  const n = Ve(null), o = Oe("Tooltip", iY, e), {
    children: a,
    position: i,
    refProp: l,
    label: s,
    openDelay: u,
    closeDelay: d,
    onPositionChange: f,
    opened: p,
    withinPortal: g,
    portalProps: h,
    radius: v,
    color: y,
    classNames: w,
    styles: $,
    unstyled: C,
    style: x,
    className: b,
    withArrow: O,
    arrowSize: _,
    arrowOffset: P,
    arrowRadius: S,
    arrowPosition: I,
    offset: N,
    transitionProps: k,
    multiline: j,
    width: R,
    events: D,
    zIndex: T,
    disabled: V,
    positionDependencies: L,
    onClick: Z,
    onMouseEnter: z,
    onMouseLeave: W,
    inline: U,
    variant: re,
    keepMounted: X
  } = o, J = aY(o, [
    "children",
    "position",
    "refProp",
    "label",
    "openDelay",
    "closeDelay",
    "onPositionChange",
    "opened",
    "withinPortal",
    "portalProps",
    "radius",
    "color",
    "classNames",
    "styles",
    "unstyled",
    "style",
    "className",
    "withArrow",
    "arrowSize",
    "arrowOffset",
    "arrowRadius",
    "arrowPosition",
    "offset",
    "transitionProps",
    "multiline",
    "width",
    "events",
    "zIndex",
    "disabled",
    "positionDependencies",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "inline",
    "variant",
    "keepMounted"
  ]), { classes: Q, cx: se, theme: q } = OC({ radius: v, color: y, width: R, multiline: j }, { name: "Tooltip", classNames: w, styles: $, unstyled: C, variant: re }), te = rY({
    position: Bh(q.dir, i),
    closeDelay: d,
    openDelay: u,
    onPositionChange: f,
    opened: p,
    events: D,
    arrowRef: n,
    arrowOffset: P,
    offset: N + (O ? _ / 2 : 0),
    positionDependencies: [...L, a],
    inline: U
  });
  if (!Pa(a))
    throw new Error(PC.children);
  const ae = Kn(te.reference, a.ref, r);
  return /* @__PURE__ */ E.createElement(E.Fragment, null, /* @__PURE__ */ E.createElement(Sa, Od(fo({}, h), {
    withinPortal: g
  }), /* @__PURE__ */ E.createElement(Ra, Od(fo({
    keepMounted: X,
    mounted: !V && te.opened
  }, k), {
    transition: k.transition || "fade",
    duration: te.isGroupPhase ? 10 : (t = k.duration) != null ? t : 100
  }), (ge) => {
    var G, oe;
    return /* @__PURE__ */ E.createElement(We, fo(fo({}, J), te.getFloatingProps({
      ref: te.floating,
      className: Q.tooltip,
      style: Od(fo(fo({}, x), ge), {
        zIndex: T,
        top: (G = te.y) != null ? G : 0,
        left: (oe = te.x) != null ? oe : 0
      })
    })), s, /* @__PURE__ */ E.createElement(zf, {
      ref: n,
      arrowX: te.arrowX,
      arrowY: te.arrowY,
      visible: O,
      position: te.placement,
      arrowSize: _,
      arrowOffset: P,
      arrowRadius: S,
      arrowPosition: I,
      className: Q.arrow
    }));
  })), Wr(a, te.getReferenceProps(fo({
    onClick: Z,
    onMouseEnter: z,
    onMouseLeave: W,
    onMouseMove: e.onMouseMove,
    onPointerDown: e.onPointerDown,
    onPointerEnter: e.onPointerEnter,
    [l]: ae,
    className: se(b, a.props.className)
  }, a.props))));
});
_1.Group = $C;
_1.Floating = EC;
_1.displayName = "@mantine/core/Tooltip";
const kC = _1;
var lY = Object.defineProperty, Vc = Object.getOwnPropertySymbols, MC = Object.prototype.hasOwnProperty, NC = Object.prototype.propertyIsEnumerable, ig = (e, r, t) => r in e ? lY(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, lg = (e, r) => {
  for (var t in r || (r = {}))
    MC.call(r, t) && ig(e, t, r[t]);
  if (Vc)
    for (var t of Vc(r))
      NC.call(r, t) && ig(e, t, r[t]);
  return e;
}, sY = (e, r) => {
  var t = {};
  for (var n in e)
    MC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Vc)
    for (var n of Vc(e))
      r.indexOf(n) < 0 && NC.call(e, n) && (t[n] = e[n]);
  return t;
};
function cY(e) {
  const r = e, { width: t, height: n, style: o } = r, a = sY(r, ["width", "height", "style"]);
  return /* @__PURE__ */ E.createElement("svg", lg({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 5 5",
    style: lg({ width: t, height: n }, o)
  }, a), /* @__PURE__ */ E.createElement("path", {
    fill: "currentColor",
    d: "M0 2.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z"
  }));
}
const TC = xt(null), uY = TC.Provider, dY = () => dt(TC);
var fY = Object.defineProperty, Fc = Object.getOwnPropertySymbols, DC = Object.prototype.hasOwnProperty, jC = Object.prototype.propertyIsEnumerable, sg = (e, r, t) => r in e ? fY(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, cg = (e, r) => {
  for (var t in r || (r = {}))
    DC.call(r, t) && sg(e, t, r[t]);
  if (Fc)
    for (var t of Fc(r))
      jC.call(r, t) && sg(e, t, r[t]);
  return e;
}, pY = (e, r) => {
  var t = {};
  for (var n in e)
    DC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Fc)
    for (var n of Fc(e))
      r.indexOf(n) < 0 && jC.call(e, n) && (t[n] = e[n]);
  return t;
};
const gY = {
  size: "sm"
}, LC = ue((e, r) => {
  const t = Oe("RadioGroup", gY, e), {
    children: n,
    value: o,
    defaultValue: a,
    onChange: i,
    size: l,
    wrapperProps: s,
    unstyled: u,
    name: d
  } = t, f = pY(t, [
    "children",
    "value",
    "defaultValue",
    "onChange",
    "size",
    "wrapperProps",
    "unstyled",
    "name"
  ]), p = ke(d), [g, h] = Hr({
    value: o,
    defaultValue: a,
    finalValue: "",
    onChange: i
  }), v = (y) => h(y.currentTarget.value);
  return /* @__PURE__ */ E.createElement(uY, {
    value: { value: g, onChange: v, size: l, name: p }
  }, /* @__PURE__ */ E.createElement(jr.Wrapper, cg(cg({
    labelElement: "div",
    size: l,
    __staticSelector: "RadioGroup",
    ref: r,
    unstyled: u
  }, s), f), n));
});
LC.displayName = "@mantine/core/RadioGroup";
var vY = Object.defineProperty, mY = Object.defineProperties, hY = Object.getOwnPropertyDescriptors, ug = Object.getOwnPropertySymbols, bY = Object.prototype.hasOwnProperty, yY = Object.prototype.propertyIsEnumerable, dg = (e, r, t) => r in e ? vY(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, CY = (e, r) => {
  for (var t in r || (r = {}))
    bY.call(r, t) && dg(e, t, r[t]);
  if (ug)
    for (var t of ug(r))
      yY.call(r, t) && dg(e, t, r[t]);
  return e;
}, wY = (e, r) => mY(e, hY(r));
const Pd = {
  xs: B(16),
  sm: B(20),
  md: B(24),
  lg: B(30),
  xl: B(36)
}, wl = {
  xs: B(6),
  sm: B(8),
  md: B(10),
  lg: B(14),
  xl: B(16)
};
var _Y = Ae((e, { color: r, transitionDuration: t, labelPosition: n, error: o }, { size: a }) => {
  const i = e.fn.variant({ variant: "filled", color: r }), l = e.fn.variant({ variant: "filled", color: "red" }).background;
  return {
    inner: {
      order: n === "left" ? 2 : 1,
      position: "relative",
      alignSelf: "flex-start"
    },
    icon: {
      ref: Yt("icon"),
      color: e.white,
      opacity: 0,
      transform: `scale(0.75) translateY(${B(2)})`,
      transition: `opacity ${t}ms ${e.transitionTimingFunction}`,
      pointerEvents: "none",
      width: ve({ sizes: wl, size: a }),
      height: ve({ sizes: wl, size: a }),
      position: "absolute",
      top: `calc(50% - ${ve({ sizes: wl, size: a })} / 2)`,
      left: `calc(50% - ${ve({ sizes: wl, size: a })} / 2)`
    },
    radio: wY(CY({}, e.fn.focusStyles()), {
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
      border: `${B(1)} solid ${o ? l : e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4]}`,
      position: "relative",
      appearance: "none",
      width: ve({ sizes: Pd, size: a }),
      height: ve({ sizes: Pd, size: a }),
      borderRadius: ve({ sizes: Pd, size: a }),
      margin: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transitionProperty: "background-color, border-color",
      transitionTimingFunction: e.transitionTimingFunction,
      transitionDuration: `${t}ms`,
      cursor: e.cursorType,
      "&:checked": {
        background: i.background,
        borderColor: i.background,
        [`& + .${Yt("icon")}`]: {
          opacity: 1,
          transform: "scale(1)"
        }
      },
      "&:disabled": {
        borderColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[4],
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[1],
        [`& + .${Yt("icon")}`]: {
          color: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[4]
        }
      }
    })
  };
}), xY = Object.defineProperty, Zc = Object.getOwnPropertySymbols, zC = Object.prototype.hasOwnProperty, VC = Object.prototype.propertyIsEnumerable, fg = (e, r, t) => r in e ? xY(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, _l = (e, r) => {
  for (var t in r || (r = {}))
    zC.call(r, t) && fg(e, t, r[t]);
  if (Zc)
    for (var t of Zc(r))
      VC.call(r, t) && fg(e, t, r[t]);
  return e;
}, $Y = (e, r) => {
  var t = {};
  for (var n in e)
    zC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Zc)
    for (var n of Zc(e))
      r.indexOf(n) < 0 && VC.call(e, n) && (t[n] = e[n]);
  return t;
};
const OY = {
  icon: cY,
  transitionDuration: 100,
  size: "sm",
  labelPosition: "right"
}, x1 = ue((e, r) => {
  var t, n;
  const o = Oe("Radio", OY, e), {
    className: a,
    style: i,
    id: l,
    label: s,
    size: u,
    title: d,
    disabled: f,
    color: p,
    classNames: g,
    styles: h,
    sx: v,
    icon: y,
    transitionDuration: w,
    wrapperProps: $,
    unstyled: C,
    labelPosition: x,
    description: b,
    error: O,
    variant: _
  } = o, P = $Y(o, [
    "className",
    "style",
    "id",
    "label",
    "size",
    "title",
    "disabled",
    "color",
    "classNames",
    "styles",
    "sx",
    "icon",
    "transitionDuration",
    "wrapperProps",
    "unstyled",
    "labelPosition",
    "description",
    "error",
    "variant"
  ]), S = dY(), I = (t = S == null ? void 0 : S.size) != null ? t : u, N = e.size ? u : I, { classes: k } = _Y({ color: p, transitionDuration: w, labelPosition: x, error: !!O }, { name: "Radio", classNames: g, styles: h, unstyled: C, variant: _, size: N }), { systemStyles: j, rest: R } = En(P), D = ke(l), T = S ? {
    checked: S.value === R.value,
    name: (n = R.name) != null ? n : S.name,
    onChange: S.onChange
  } : {};
  return /* @__PURE__ */ E.createElement(C1, _l(_l({
    className: a,
    sx: v,
    style: i,
    id: D,
    size: N,
    labelPosition: x,
    label: s,
    description: b,
    error: O,
    disabled: f,
    __staticSelector: "Radio",
    classNames: g,
    styles: h,
    unstyled: C,
    "data-checked": T.checked || void 0,
    variant: _
  }, j), $), /* @__PURE__ */ E.createElement("div", {
    className: k.inner
  }, /* @__PURE__ */ E.createElement("input", _l(_l({
    ref: r,
    className: k.radio,
    type: "radio",
    id: D,
    disabled: f
  }, R), T)), /* @__PURE__ */ E.createElement(y, {
    className: k.icon,
    "aria-hidden": !0
  })));
});
x1.displayName = "@mantine/core/Radio";
x1.Group = LC;
var PY = Object.defineProperty, Wc = Object.getOwnPropertySymbols, FC = Object.prototype.hasOwnProperty, ZC = Object.prototype.propertyIsEnumerable, pg = (e, r, t) => r in e ? PY(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, gg = (e, r) => {
  for (var t in r || (r = {}))
    FC.call(r, t) && pg(e, t, r[t]);
  if (Wc)
    for (var t of Wc(r))
      ZC.call(r, t) && pg(e, t, r[t]);
  return e;
}, SY = (e, r) => {
  var t = {};
  for (var n in e)
    FC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Wc)
    for (var n of Wc(e))
      r.indexOf(n) < 0 && ZC.call(e, n) && (t[n] = e[n]);
  return t;
};
function WC(e) {
  const r = e, { width: t, height: n, style: o } = r, a = SY(r, ["width", "height", "style"]);
  return /* @__PURE__ */ E.createElement("svg", gg({
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: gg({ width: t, height: n }, o)
  }, a), /* @__PURE__ */ E.createElement("path", {
    d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
  }));
}
WC.displayName = "@mantine/core/StarIcon";
const vg = {
  xs: B(14),
  sm: B(18),
  md: B(20),
  lg: B(28),
  xl: B(32)
};
var IY = Ae((e, { type: r, color: t }, { size: n }) => {
  const o = e.colorScheme === "light" ? e.colors.gray[3] : e.colors.gray[8], a = e.fn.variant({
    variant: "filled",
    color: t,
    primaryFallback: !1
  }).background;
  return {
    icon: {
      stroke: r === "empty" ? o : a,
      fill: r === "empty" ? o : a,
      width: ve({ size: n, sizes: vg }),
      height: ve({ size: n, sizes: vg })
    }
  };
});
function I0({ size: e, type: r, color: t }) {
  const { classes: n } = IY({ type: r, color: t }, { name: "Rating", size: e });
  return /* @__PURE__ */ E.createElement(WC, {
    className: n.icon
  });
}
I0.displayName = "@mantine/core/StarSymbol";
var EY = Ae((e) => ({
  input: {
    height: 0,
    width: 0,
    position: "absolute",
    overflow: "hidden",
    whiteSpace: "nowrap",
    opacity: 0,
    "&:focus": {
      [`& + .${Yt("label")}`]: {
        outline: e.focusRing === "always" || e.focusRing === "auto" ? `${B(1)} solid ${e.colors[e.primaryColor][e.colorScheme === "dark" ? 7 : 5]}` : void 0
      },
      "&:focus:not(:focus-visible)": {
        [`& + .${Yt("label")}`]: {
          outline: e.focusRing === "auto" || e.focusRing === "never" ? "none" : void 0
        }
      }
    }
  },
  label: {
    ref: Yt("label"),
    display: "block",
    boxSizing: "border-box",
    margin: B(1),
    top: 0,
    left: 0,
    cursor: "pointer",
    position: "absolute",
    zIndex: 0,
    "&[data-read-only]": {
      cursor: "default"
    },
    "&:last-of-type": {
      position: "relative",
      zIndex: 0
    }
  },
  symbolBody: {
    display: "grid",
    placeContent: "center",
    placeItems: "center"
  }
})), RY = Object.defineProperty, Bc = Object.getOwnPropertySymbols, BC = Object.prototype.hasOwnProperty, HC = Object.prototype.propertyIsEnumerable, mg = (e, r, t) => r in e ? RY(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, AY = (e, r) => {
  for (var t in r || (r = {}))
    BC.call(r, t) && mg(e, t, r[t]);
  if (Bc)
    for (var t of Bc(r))
      HC.call(r, t) && mg(e, t, r[t]);
  return e;
}, kY = (e, r) => {
  var t = {};
  for (var n in e)
    BC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Bc)
    for (var n of Bc(e))
      r.indexOf(n) < 0 && HC.call(e, n) && (t[n] = e[n]);
  return t;
};
function GC(e) {
  var r = e, {
    size: t,
    getSymbolLabel: n,
    emptyIcon: o,
    fullIcon: a,
    full: i,
    active: l,
    value: s,
    readOnly: u,
    fractionValue: d,
    classNames: f,
    styles: p,
    unstyled: g,
    color: h,
    id: v,
    variant: y,
    onChange: w
  } = r, $ = kY(r, [
    "size",
    "getSymbolLabel",
    "emptyIcon",
    "fullIcon",
    "full",
    "active",
    "value",
    "readOnly",
    "fractionValue",
    "classNames",
    "styles",
    "unstyled",
    "color",
    "id",
    "variant",
    "onChange"
  ]);
  const { classes: C } = EY(null, {
    name: "Rating",
    classNames: f,
    styles: p,
    unstyled: g,
    size: t,
    variant: y
  }), x = typeof a == "function" ? a(s) : a, b = typeof o == "function" ? o(s) : o;
  return /* @__PURE__ */ E.createElement(E.Fragment, null, !u && /* @__PURE__ */ E.createElement("input", AY({
    onKeyDown: (O) => O.key === " " && w(s),
    className: C.input,
    id: v,
    type: "radio",
    "data-active": l,
    "aria-label": n(s),
    value: s,
    onChange: w
  }, $)), /* @__PURE__ */ E.createElement(We, {
    component: u ? "div" : "label",
    className: C.label,
    "data-read-only": u || void 0,
    htmlFor: v,
    sx: d === 1 ? void 0 : { zIndex: l ? 2 : 0 },
    onClick: () => w(s)
  }, /* @__PURE__ */ E.createElement(We, {
    className: C.symbolBody,
    sx: d === 1 ? void 0 : { clipPath: `inset(0 ${l ? 100 - d * 100 : 100}% 0 0)` }
  }, i ? x || /* @__PURE__ */ E.createElement(I0, {
    color: h,
    size: t,
    type: "full"
  }) : b || /* @__PURE__ */ E.createElement(I0, {
    color: h,
    size: t,
    type: "empty"
  }))));
}
GC.displayName = "@mantine/core/RatingItem";
var MY = Ae(() => ({
  root: {
    display: "flex",
    width: "max-content",
    "&:has(input:disabled)": {
      pointerEvents: "none",
      cursor: "not-allowed"
    }
  },
  symbolGroup: {
    position: "relative",
    transition: "transform 100ms ease",
    '&[data-active="true"]': {
      zIndex: 1,
      transform: "scale(1.2)"
    }
  }
})), NY = Object.defineProperty, Hc = Object.getOwnPropertySymbols, XC = Object.prototype.hasOwnProperty, YC = Object.prototype.propertyIsEnumerable, hg = (e, r, t) => r in e ? NY(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, TY = (e, r) => {
  for (var t in r || (r = {}))
    XC.call(r, t) && hg(e, t, r[t]);
  if (Hc)
    for (var t of Hc(r))
      YC.call(r, t) && hg(e, t, r[t]);
  return e;
}, DY = (e, r) => {
  var t = {};
  for (var n in e)
    XC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Hc)
    for (var n of Hc(e))
      r.indexOf(n) < 0 && YC.call(e, n) && (t[n] = e[n]);
  return t;
};
function Sd(e, r) {
  var t;
  const n = Math.round(e / r) * r, o = ((t = `${r}`.split(".")[1]) == null ? void 0 : t.length) || 0;
  return Number(n.toFixed(o));
}
const jY = {
  size: "sm",
  getSymbolLabel: (e) => `${e}`,
  count: 5,
  fractions: 1,
  color: "yellow"
}, UC = ue((e, r) => {
  const t = Oe("Rating", jY, e), {
    defaultValue: n,
    value: o,
    emptySymbol: a,
    fullSymbol: i,
    size: l,
    count: s,
    fractions: u,
    onChange: d,
    onHover: f,
    getSymbolLabel: p,
    name: g,
    readOnly: h,
    className: v,
    classNames: y,
    styles: w,
    unstyled: $,
    onMouseEnter: C,
    onMouseMove: x,
    onMouseLeave: b,
    highlightSelectedOnly: O,
    color: _,
    id: P,
    variant: S
  } = t, I = DY(t, [
    "defaultValue",
    "value",
    "emptySymbol",
    "fullSymbol",
    "size",
    "count",
    "fractions",
    "onChange",
    "onHover",
    "getSymbolLabel",
    "name",
    "readOnly",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "onMouseEnter",
    "onMouseMove",
    "onMouseLeave",
    "highlightSelectedOnly",
    "color",
    "id",
    "variant"
  ]), { classes: N, cx: k, theme: j } = MY(null, {
    name: "Rating",
    classNames: y,
    styles: w,
    unstyled: $,
    variant: S,
    size: l
  }), R = ke(g), D = ke(P), T = Ve(null), [V, L] = Hr({
    value: o,
    defaultValue: n,
    finalValue: 0,
    onChange: d
  }), [Z, z] = Se(-1), [W, U] = Se(!0), re = Math.floor(u), X = Math.floor(s), J = 1 / re, Q = Sd(V, J), se = Z !== -1 ? Z : Q, q = (ne) => {
    C == null || C(ne), !h && U(!1);
  }, te = (ne) => {
    if (x == null || x(ne), h)
      return;
    const { left: _e, right: ye, width: Te } = T.current.getBoundingClientRect(), we = Te / X, he = (j.dir === "rtl" ? ye - ne.clientX : ne.clientX - _e) / we, xe = Co(Sd(he + J / 2, J), J, X);
    z(xe), xe !== Z && (f == null || f(xe));
  }, ae = (ne) => {
    b == null || b(ne), !h && (z(-1), U(!0), Z !== -1 && (f == null || f(-1)));
  }, ge = () => W && z(-1), G = (ne) => {
    h || L(typeof ne == "number" ? ne : parseFloat(ne.target.value));
  }, oe = Array(X).fill(0).map((ne, _e) => {
    const ye = _e + 1, Te = Array.from(new Array(_e === 0 ? re + 1 : re)), we = !h && Math.ceil(Z) === ye;
    return /* @__PURE__ */ E.createElement("div", {
      key: ye,
      "data-active": we,
      className: N.symbolGroup
    }, Te.map((He, he) => {
      const xe = J * (_e === 0 ? he : he + 1), Le = Sd(ye - 1 + xe, J);
      return /* @__PURE__ */ E.createElement(GC, {
        key: `${ye}-${Le}`,
        size: l,
        variant: S,
        getSymbolLabel: p,
        emptyIcon: a,
        fullIcon: i,
        full: O ? Le === se : Le <= se,
        active: Le === se,
        checked: Le === Q,
        readOnly: h,
        fractionValue: xe,
        value: Le,
        name: R,
        onChange: G,
        onBlur: ge,
        classNames: y,
        styles: w,
        unstyled: $,
        color: _,
        id: `${D}-${_e}-${he}`
      });
    }));
  });
  return /* @__PURE__ */ E.createElement(We, TY({
    ref: Kn(T, r),
    className: k(N.root, v),
    onMouseMove: te,
    onMouseEnter: q,
    onMouseLeave: ae
  }, I), oe);
});
UC.displayName = "@mantine/core/Rating";
function LY({ size: e, thickness: r, sum: t, value: n, root: o, offset: a }) {
  const i = (e * 0.9 - r * 2) / 2, l = Math.PI * i * 2 / 100, s = o ? `${(100 - t) * l}, ${t * l}` : `${n * l}, ${(100 - n) * l}`;
  return {
    strokeWidth: r,
    cx: e / 2,
    cy: e / 2,
    r: i,
    transform: o ? `scale(1, -1) translate(0, -${e})` : null,
    strokeDasharray: s,
    strokeDashoffset: o ? 0 : a
  };
}
var zY = Object.defineProperty, VY = Object.defineProperties, FY = Object.getOwnPropertyDescriptors, Gc = Object.getOwnPropertySymbols, JC = Object.prototype.hasOwnProperty, qC = Object.prototype.propertyIsEnumerable, bg = (e, r, t) => r in e ? zY(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, yg = (e, r) => {
  for (var t in r || (r = {}))
    JC.call(r, t) && bg(e, t, r[t]);
  if (Gc)
    for (var t of Gc(r))
      qC.call(r, t) && bg(e, t, r[t]);
  return e;
}, ZY = (e, r) => VY(e, FY(r)), WY = (e, r) => {
  var t = {};
  for (var n in e)
    JC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Gc)
    for (var n of Gc(e))
      r.indexOf(n) < 0 && qC.call(e, n) && (t[n] = e[n]);
  return t;
};
function KC(e) {
  var r = e, {
    size: t,
    value: n,
    offset: o,
    sum: a,
    thickness: i,
    root: l,
    color: s,
    lineRoundCaps: u,
    tooltip: d
  } = r, f = WY(r, [
    "size",
    "value",
    "offset",
    "sum",
    "thickness",
    "root",
    "color",
    "lineRoundCaps",
    "tooltip"
  ]);
  const p = ft(), g = p.fn.themeColor(s || (p.colorScheme === "dark" ? "dark" : "gray"), s ? p.fn.primaryShade() : p.colorScheme === "dark" ? 4 : 1, !1);
  return /* @__PURE__ */ E.createElement(kC.Floating, {
    disabled: !d,
    label: d
  }, /* @__PURE__ */ E.createElement("circle", yg(ZY(yg({}, f), {
    fill: "none",
    strokeLinecap: u ? "round" : "butt",
    stroke: g
  }), LY({ sum: a, size: t, thickness: i, value: n, offset: o, root: l }))));
}
KC.displayName = "@mantine/core/Curve";
var BY = Object.defineProperty, HY = Object.defineProperties, GY = Object.getOwnPropertyDescriptors, Cg = Object.getOwnPropertySymbols, XY = Object.prototype.hasOwnProperty, YY = Object.prototype.propertyIsEnumerable, wg = (e, r, t) => r in e ? BY(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Ya = (e, r) => {
  for (var t in r || (r = {}))
    XY.call(r, t) && wg(e, t, r[t]);
  if (Cg)
    for (var t of Cg(r))
      YY.call(r, t) && wg(e, t, r[t]);
  return e;
}, Ua = (e, r) => HY(e, GY(r));
function UY({
  size: e,
  thickness: r,
  sections: t,
  renderRoundedLineCaps: n,
  rootColor: o
}) {
  const a = t.reduce((d, f) => d + f.value, 0), i = Math.PI * ((e * 0.9 - r * 2) / 2) * 2;
  let l = i;
  const s = [], u = [];
  for (let d = 0; d < t.length; d += 1)
    s.push({ sum: a, offset: l, data: t[d], root: !1 }), l -= t[d].value / 100 * i;
  if (s.push({ sum: a, offset: l, data: { color: o }, root: !0 }), u.push(Ua(Ya({}, s[s.length - 1]), { lineRoundCaps: !1 })), s.length > 2) {
    u.push(Ua(Ya({}, s[0]), { lineRoundCaps: n })), u.push(Ua(Ya({}, s[s.length - 2]), { lineRoundCaps: n }));
    for (let d = 1; d <= s.length - 3; d += 1)
      u.push(Ua(Ya({}, s[d]), { lineRoundCaps: !1 }));
  } else
    u.push(Ua(Ya({}, s[0]), { lineRoundCaps: n }));
  return u;
}
var JY = Ae({
  root: {
    position: "relative"
  },
  label: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)"
  }
}), qY = Object.defineProperty, KY = Object.defineProperties, QY = Object.getOwnPropertyDescriptors, Xc = Object.getOwnPropertySymbols, QC = Object.prototype.hasOwnProperty, ew = Object.prototype.propertyIsEnumerable, _g = (e, r, t) => r in e ? qY(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Id = (e, r) => {
  for (var t in r || (r = {}))
    QC.call(r, t) && _g(e, t, r[t]);
  if (Xc)
    for (var t of Xc(r))
      ew.call(r, t) && _g(e, t, r[t]);
  return e;
}, eU = (e, r) => KY(e, QY(r)), rU = (e, r) => {
  var t = {};
  for (var n in e)
    QC.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Xc)
    for (var n of Xc(e))
      r.indexOf(n) < 0 && ew.call(e, n) && (t[n] = e[n]);
  return t;
};
const tU = {
  size: 120,
  thickness: 12
}, rw = ue((e, r) => {
  const t = Oe("RingProgress", tU, e), {
    className: n,
    style: o,
    label: a,
    sections: i,
    size: l,
    thickness: s,
    classNames: u,
    styles: d,
    roundCaps: f,
    rootColor: p,
    unstyled: g,
    variant: h
  } = t, v = rU(t, [
    "className",
    "style",
    "label",
    "sections",
    "size",
    "thickness",
    "classNames",
    "styles",
    "roundCaps",
    "rootColor",
    "unstyled",
    "variant"
  ]), { classes: y, cx: w } = JY(null, {
    name: "RingProgress",
    classNames: u,
    styles: d,
    unstyled: g,
    variant: h
  }), $ = UY({
    size: l,
    thickness: s,
    sections: i,
    renderRoundedLineCaps: f,
    rootColor: p
  }).map(({ data: C, sum: x, root: b, lineRoundCaps: O, offset: _ }, P) => /* @__PURE__ */ E.createElement(KC, eU(Id({}, C), {
    key: P,
    size: l,
    thickness: s,
    sum: x,
    offset: _,
    color: C == null ? void 0 : C.color,
    root: b,
    lineRoundCaps: O
  })));
  return /* @__PURE__ */ E.createElement(We, Id({
    style: Id({ width: l, height: l }, o),
    className: w(y.root, n),
    ref: r
  }, v), /* @__PURE__ */ E.createElement("svg", {
    style: { width: l, height: l, transform: "rotate(-90deg)" }
  }, $), a && /* @__PURE__ */ E.createElement("div", {
    className: y.label,
    style: { right: s * 2, left: s * 2 }
  }, a));
});
rw.displayName = "@mantine/core/RingProgress";
function nU({
  data: e,
  searchable: r,
  limit: t,
  searchValue: n,
  filter: o,
  value: a,
  filterDataOnExactSearchMatch: i
}) {
  if (!r)
    return e;
  const l = a != null && e.find((u) => u.value === a) || null;
  if (l && !i && (l == null ? void 0 : l.label) === n) {
    if (t) {
      if (t >= e.length)
        return e;
      const u = e.indexOf(l), d = u + t, f = d - e.length;
      return f > 0 ? e.slice(u - f) : e.slice(u, d);
    }
    return e;
  }
  const s = [];
  for (let u = 0; u < e.length && (o(n, e[u]) && s.push(e[u]), !(s.length >= t)); u += 1)
    ;
  return s;
}
var oU = Ae(() => ({
  input: {
    "&:not(:disabled)": {
      cursor: "pointer",
      "&::selection": {
        backgroundColor: "transparent"
      }
    }
  }
})), aU = Object.defineProperty, iU = Object.defineProperties, lU = Object.getOwnPropertyDescriptors, Yc = Object.getOwnPropertySymbols, tw = Object.prototype.hasOwnProperty, nw = Object.prototype.propertyIsEnumerable, xg = (e, r, t) => r in e ? aU(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Ja = (e, r) => {
  for (var t in r || (r = {}))
    tw.call(r, t) && xg(e, t, r[t]);
  if (Yc)
    for (var t of Yc(r))
      nw.call(r, t) && xg(e, t, r[t]);
  return e;
}, Ed = (e, r) => iU(e, lU(r)), sU = (e, r) => {
  var t = {};
  for (var n in e)
    tw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Yc)
    for (var n of Yc(e))
      r.indexOf(n) < 0 && nw.call(e, n) && (t[n] = e[n]);
  return t;
};
function cU(e, r) {
  return r.label.toLowerCase().trim().includes(e.toLowerCase().trim());
}
function uU(e, r) {
  return !!e && !r.some((t) => t.label.toLowerCase() === e.toLowerCase());
}
const dU = {
  required: !1,
  size: "sm",
  shadow: "sm",
  itemComponent: $f,
  transitionProps: { transition: "fade", duration: 0 },
  initiallyOpened: !1,
  filter: cU,
  maxDropdownHeight: 220,
  searchable: !1,
  clearable: !1,
  limit: 1 / 0,
  disabled: !1,
  creatable: !1,
  shouldCreate: uU,
  selectOnBlur: !1,
  switchDirectionOnFlip: !1,
  filterDataOnExactSearchMatch: !1,
  zIndex: In("popover"),
  positionDependencies: [],
  dropdownPosition: "flip"
}, ow = ue((e, r) => {
  const t = Ti("Select", dU, e), {
    inputProps: n,
    wrapperProps: o,
    shadow: a,
    data: i,
    value: l,
    defaultValue: s,
    onChange: u,
    itemComponent: d,
    onKeyDown: f,
    onBlur: p,
    onFocus: g,
    transitionProps: h,
    initiallyOpened: v,
    unstyled: y,
    classNames: w,
    styles: $,
    filter: C,
    maxDropdownHeight: x,
    searchable: b,
    clearable: O,
    nothingFound: _,
    limit: P,
    disabled: S,
    onSearchChange: I,
    searchValue: N,
    rightSection: k,
    rightSectionWidth: j,
    creatable: R,
    getCreateLabel: D,
    shouldCreate: T,
    selectOnBlur: V,
    onCreate: L,
    dropdownComponent: Z,
    onDropdownClose: z,
    onDropdownOpen: W,
    withinPortal: U,
    portalProps: re,
    switchDirectionOnFlip: X,
    zIndex: J,
    name: Q,
    dropdownPosition: se,
    allowDeselect: q,
    placeholder: te,
    filterDataOnExactSearchMatch: ae,
    form: ge,
    positionDependencies: G,
    readOnly: oe,
    clearButtonProps: ne,
    hoverOnSearchChange: _e
  } = t, ye = sU(t, [
    "inputProps",
    "wrapperProps",
    "shadow",
    "data",
    "value",
    "defaultValue",
    "onChange",
    "itemComponent",
    "onKeyDown",
    "onBlur",
    "onFocus",
    "transitionProps",
    "initiallyOpened",
    "unstyled",
    "classNames",
    "styles",
    "filter",
    "maxDropdownHeight",
    "searchable",
    "clearable",
    "nothingFound",
    "limit",
    "disabled",
    "onSearchChange",
    "searchValue",
    "rightSection",
    "rightSectionWidth",
    "creatable",
    "getCreateLabel",
    "shouldCreate",
    "selectOnBlur",
    "onCreate",
    "dropdownComponent",
    "onDropdownClose",
    "onDropdownOpen",
    "withinPortal",
    "portalProps",
    "switchDirectionOnFlip",
    "zIndex",
    "name",
    "dropdownPosition",
    "allowDeselect",
    "placeholder",
    "filterDataOnExactSearchMatch",
    "form",
    "positionDependencies",
    "readOnly",
    "clearButtonProps",
    "hoverOnSearchChange"
  ]), { classes: Te, cx: we, theme: He } = oU(), [he, xe] = Se(v), [Le, Ue] = Se(-1), me = Ve(), Ie = Ve({}), [er, Ke] = Se("column"), Me = er === "column", { scrollIntoView: Pe, targetRef: Qe, scrollableRef: Sr } = sP({
    duration: 0,
    offset: 5,
    cancelable: !1,
    isList: !0
  }), Cr = q === void 0 ? O : q, nr = (ie) => {
    if (he !== ie) {
      xe(ie);
      const Re = ie ? W : z;
      typeof Re == "function" && Re();
    }
  }, De = R && typeof D == "function";
  let Ge = null;
  const lr = i.map((ie) => typeof ie == "string" ? { label: ie, value: ie } : ie), Ir = V6({ data: lr }), [Or, $r, ar] = Hr({
    value: l,
    defaultValue: s,
    finalValue: null,
    onChange: u
  }), cr = Ir.find((ie) => ie.value === Or), [Vr, pt] = Hr({
    value: N,
    defaultValue: (cr == null ? void 0 : cr.label) || "",
    finalValue: void 0,
    onChange: I
  }), et = (ie) => {
    pt(ie), b && typeof I == "function" && I(ie);
  }, jn = () => {
    var ie;
    oe || ($r(null), ar || et(""), (ie = me.current) == null || ie.focus());
  };
  Fe(() => {
    const ie = Ir.find((Re) => Re.value === Or);
    ie ? et(ie.label) : (!De || !Or) && et("");
  }, [Or]), Fe(() => {
    cr && (!b || !he) && et(cr.label);
  }, [cr == null ? void 0 : cr.label]);
  const St = (ie) => {
    if (!oe)
      if (Cr && (cr == null ? void 0 : cr.value) === ie.value)
        $r(null), nr(!1);
      else {
        if (ie.creatable && typeof L == "function") {
          const Re = L(ie.value);
          typeof Re != "undefined" && Re !== null && $r(typeof Re == "string" ? Re : Re.value);
        } else
          $r(ie.value);
        ar || et(ie.label), Ue(-1), nr(!1), me.current.focus();
      }
  }, Er = nU({
    data: Ir,
    searchable: b,
    limit: P,
    searchValue: Vr,
    filter: C,
    filterDataOnExactSearchMatch: ae,
    value: Or
  });
  De && T(Vr, Er) && (Ge = D(Vr), Er.push({ label: Vr, value: Vr, creatable: !0 }));
  const Ln = (ie, Re, ee) => {
    let K = ie;
    for (; ee(K); )
      if (K = Re(K), !Er[K].disabled)
        return K;
    return ie;
  };
  ct(() => {
    Ue(_e && Vr ? 0 : -1);
  }, [Vr, _e]);
  const rt = Or ? Er.findIndex((ie) => ie.value === Or) : 0, gr = !oe && (Er.length > 0 ? he : he && !!_), Ar = () => {
    Ue((ie) => {
      var Re;
      const ee = Ln(ie, (K) => K - 1, (K) => K > 0);
      return Qe.current = Ie.current[(Re = Er[ee]) == null ? void 0 : Re.value], gr && Pe({ alignment: Me ? "start" : "end" }), ee;
    });
  }, Yr = () => {
    Ue((ie) => {
      var Re;
      const ee = Ln(ie, (K) => K + 1, (K) => K < Er.length - 1);
      return Qe.current = Ie.current[(Re = Er[ee]) == null ? void 0 : Re.value], gr && Pe({ alignment: Me ? "end" : "start" }), ee;
    });
  }, vn = () => window.setTimeout(() => {
    var ie;
    Qe.current = Ie.current[(ie = Er[rt]) == null ? void 0 : ie.value], Pe({ alignment: Me ? "end" : "start" });
  }, 50);
  ct(() => {
    gr && vn();
  }, [gr]);
  const lo = (ie) => {
    switch (typeof f == "function" && f(ie), ie.key) {
      case "ArrowUp": {
        ie.preventDefault(), he ? Me ? Ar() : Yr() : (Ue(rt), nr(!0), vn());
        break;
      }
      case "ArrowDown": {
        ie.preventDefault(), he ? Me ? Yr() : Ar() : (Ue(rt), nr(!0), vn());
        break;
      }
      case "Home": {
        if (!b) {
          ie.preventDefault(), he || nr(!0);
          const Re = Er.findIndex((ee) => !ee.disabled);
          Ue(Re), gr && Pe({ alignment: Me ? "end" : "start" });
        }
        break;
      }
      case "End": {
        if (!b) {
          ie.preventDefault(), he || nr(!0);
          const Re = Er.map((ee) => !!ee.disabled).lastIndexOf(!1);
          Ue(Re), gr && Pe({ alignment: Me ? "end" : "start" });
        }
        break;
      }
      case "Escape": {
        ie.preventDefault(), nr(!1), Ue(-1);
        break;
      }
      case " ": {
        b || (ie.preventDefault(), Er[Le] && he ? St(Er[Le]) : (nr(!0), Ue(rt), vn()));
        break;
      }
      case "Enter":
        b || ie.preventDefault(), Er[Le] && he && (ie.preventDefault(), St(Er[Le]));
    }
  }, so = (ie) => {
    typeof p == "function" && p(ie);
    const Re = Ir.find((ee) => ee.value === Or);
    V && Er[Le] && he && St(Er[Le]), et((Re == null ? void 0 : Re.label) || ""), nr(!1);
  }, co = (ie) => {
    typeof g == "function" && g(ie), b && nr(!0);
  }, H = (ie) => {
    oe || (et(ie.currentTarget.value), O && ie.currentTarget.value === "" && $r(null), Ue(-1), nr(!0));
  }, Ce = () => {
    oe || (nr(!he), Or && !he && Ue(rt));
  };
  return /* @__PURE__ */ E.createElement(jr.Wrapper, Ed(Ja({}, o), {
    __staticSelector: "Select"
  }), /* @__PURE__ */ E.createElement(Yn, {
    opened: gr,
    transitionProps: h,
    shadow: a,
    withinPortal: U,
    portalProps: re,
    __staticSelector: "Select",
    onDirectionChange: Ke,
    switchDirectionOnFlip: X,
    zIndex: J,
    dropdownPosition: se,
    positionDependencies: [...G, Vr],
    classNames: w,
    styles: $,
    unstyled: y,
    variant: n.variant
  }, /* @__PURE__ */ E.createElement(Yn.Target, null, /* @__PURE__ */ E.createElement("div", {
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-owns": gr ? `${n.id}-items` : null,
    "aria-controls": n.id,
    "aria-expanded": gr,
    onMouseLeave: () => Ue(-1),
    tabIndex: -1
  }, /* @__PURE__ */ E.createElement("input", {
    type: "hidden",
    name: Q,
    value: Or || "",
    form: ge,
    disabled: S
  }), /* @__PURE__ */ E.createElement(jr, Ja(Ed(Ja(Ja({
    autoComplete: "off",
    type: "search"
  }, n), ye), {
    ref: Kn(r, me),
    onKeyDown: lo,
    __staticSelector: "Select",
    value: Vr,
    placeholder: te,
    onChange: H,
    "aria-autocomplete": "list",
    "aria-controls": gr ? `${n.id}-items` : null,
    "aria-activedescendant": Le >= 0 ? `${n.id}-${Le}` : null,
    onMouseDown: Ce,
    onBlur: so,
    onFocus: co,
    readOnly: !b || oe,
    disabled: S,
    "data-mantine-stop-propagation": gr,
    name: null,
    classNames: Ed(Ja({}, w), {
      input: we({ [Te.input]: !b }, w == null ? void 0 : w.input)
    })
  }), uX({
    theme: He,
    rightSection: k,
    rightSectionWidth: j,
    styles: $,
    size: n.size,
    shouldClear: O && !!cr,
    onClear: jn,
    error: o.error,
    clearButtonProps: ne,
    disabled: S,
    readOnly: oe
  }))))), /* @__PURE__ */ E.createElement(Yn.Dropdown, {
    component: Z || h1,
    maxHeight: x,
    direction: er,
    id: n.id,
    innerRef: Sr,
    __staticSelector: "Select",
    classNames: w,
    styles: $
  }, /* @__PURE__ */ E.createElement(xf, {
    data: Er,
    hovered: Le,
    classNames: w,
    styles: $,
    isItemSelected: (ie) => ie === Or,
    uuid: n.id,
    __staticSelector: "Select",
    onItemHover: Ue,
    onItemSelect: St,
    itemsRefs: Ie,
    itemComponent: d,
    size: n.size,
    nothingFound: _,
    creatable: De && !!Ge,
    createLabel: Ge,
    "aria-label": o.label,
    unstyled: y,
    variant: n.variant
  }))));
});
ow.displayName = "@mantine/core/Select";
function fU(e, r) {
  if (r.length === 0)
    return r;
  const t = "maxWidth" in r[0] ? "maxWidth" : "minWidth", n = [...r].sort((o, a) => $t(ve({ size: a[t], sizes: e.breakpoints })) - $t(ve({ size: o[t], sizes: e.breakpoints })));
  return t === "minWidth" ? n.reverse() : n;
}
var pU = Object.defineProperty, $g = Object.getOwnPropertySymbols, gU = Object.prototype.hasOwnProperty, vU = Object.prototype.propertyIsEnumerable, Og = (e, r, t) => r in e ? pU(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, mU = (e, r) => {
  for (var t in r || (r = {}))
    gU.call(r, t) && Og(e, t, r[t]);
  if ($g)
    for (var t of $g(r))
      vU.call(r, t) && Og(e, t, r[t]);
  return e;
}, hU = Ae((e, { spacing: r, breakpoints: t, cols: n, verticalSpacing: o }) => {
  const a = o != null, i = fU(e, t).reduce((l, s) => {
    var u, d;
    const f = "maxWidth" in s ? "max-width" : "min-width", p = ve({
      size: f === "max-width" ? s.maxWidth : s.minWidth,
      sizes: e.breakpoints,
      units: "em"
    }), g = $t(p) - (f === "max-width" ? 1 : 0);
    return l[`@media (${f}: ${Nt(g)})`] = {
      gridTemplateColumns: `repeat(${s.cols}, minmax(0, 1fr))`,
      gap: `${ve({
        size: (u = s.verticalSpacing) != null ? u : a ? o : r,
        sizes: e.spacing
      })} ${ve({
        size: (d = s.spacing) != null ? d : r,
        sizes: e.spacing
      })}`
    }, l;
  }, {});
  return {
    root: mU({
      boxSizing: "border-box",
      display: "grid",
      gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))`,
      gap: `${ve({
        size: a ? o : r,
        sizes: e.spacing
      })} ${ve({ size: r, sizes: e.spacing })}`
    }, i)
  };
}), bU = Object.defineProperty, Uc = Object.getOwnPropertySymbols, aw = Object.prototype.hasOwnProperty, iw = Object.prototype.propertyIsEnumerable, Pg = (e, r, t) => r in e ? bU(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, yU = (e, r) => {
  for (var t in r || (r = {}))
    aw.call(r, t) && Pg(e, t, r[t]);
  if (Uc)
    for (var t of Uc(r))
      iw.call(r, t) && Pg(e, t, r[t]);
  return e;
}, CU = (e, r) => {
  var t = {};
  for (var n in e)
    aw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Uc)
    for (var n of Uc(e))
      r.indexOf(n) < 0 && iw.call(e, n) && (t[n] = e[n]);
  return t;
};
const wU = {
  breakpoints: [],
  cols: 1,
  spacing: "md"
}, _U = ue((e, r) => {
  const t = Oe("SimpleGrid", wU, e), {
    className: n,
    breakpoints: o,
    cols: a,
    spacing: i,
    verticalSpacing: l,
    children: s,
    unstyled: u,
    variant: d
  } = t, f = CU(t, [
    "className",
    "breakpoints",
    "cols",
    "spacing",
    "verticalSpacing",
    "children",
    "unstyled",
    "variant"
  ]), { classes: p, cx: g } = hU({ breakpoints: o, cols: a, spacing: i, verticalSpacing: l }, { name: "SimpleGrid", unstyled: u, variant: d });
  return /* @__PURE__ */ E.createElement(We, yU({
    className: g(p.root, n),
    ref: r
  }, f), s);
});
_U.displayName = "@mantine/core/SimpleGrid";
var xU = Object.defineProperty, Jc = Object.getOwnPropertySymbols, lw = Object.prototype.hasOwnProperty, sw = Object.prototype.propertyIsEnumerable, Sg = (e, r, t) => r in e ? xU(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, $U = (e, r) => {
  for (var t in r || (r = {}))
    lw.call(r, t) && Sg(e, t, r[t]);
  if (Jc)
    for (var t of Jc(r))
      sw.call(r, t) && Sg(e, t, r[t]);
  return e;
}, OU = (e, r) => {
  var t = {};
  for (var n in e)
    lw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Jc)
    for (var n of Jc(e))
      r.indexOf(n) < 0 && sw.call(e, n) && (t[n] = e[n]);
  return t;
};
const PU = {
  w: 0,
  h: 0
}, SU = ue((e, r) => {
  const t = Oe("Space", PU, e), { w: n, h: o } = t, a = OU(t, ["w", "h"]);
  return /* @__PURE__ */ E.createElement(We, $U({
    ref: r,
    w: n,
    miw: n,
    h: o,
    mih: o
  }, a));
});
SU.displayName = "@mantine/core/Space";
var IU = Ae((e, { transitionDuration: r }) => ({
  control: {},
  root: {
    position: "relative"
  },
  content: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    transitionProperty: "max-height",
    transitionTimingFunction: e.transitionTimingFunction,
    transitionDuration: `${r}ms`,
    "@media (prefers-reduced-motion)": {
      transitionDuration: e.respectReducedMotion ? "0ms" : void 0
    }
  }
})), EU = Object.defineProperty, qc = Object.getOwnPropertySymbols, cw = Object.prototype.hasOwnProperty, uw = Object.prototype.propertyIsEnumerable, Ig = (e, r, t) => r in e ? EU(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, RU = (e, r) => {
  for (var t in r || (r = {}))
    cw.call(r, t) && Ig(e, t, r[t]);
  if (qc)
    for (var t of qc(r))
      uw.call(r, t) && Ig(e, t, r[t]);
  return e;
}, AU = (e, r) => {
  var t = {};
  for (var n in e)
    cw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && qc)
    for (var n of qc(e))
      r.indexOf(n) < 0 && uw.call(e, n) && (t[n] = e[n]);
  return t;
};
const kU = {
  maxHeight: 100,
  transitionDuration: 200,
  initialState: !1
}, dw = ue((e, r) => {
  const t = Oe("Spoiler", kU, e), {
    className: n,
    children: o,
    maxHeight: a,
    hideLabel: i,
    showLabel: l,
    transitionDuration: s,
    controlRef: u,
    initialState: d,
    classNames: f,
    styles: p,
    unstyled: g,
    variant: h
  } = t, v = AU(t, [
    "className",
    "children",
    "maxHeight",
    "hideLabel",
    "showLabel",
    "transitionDuration",
    "controlRef",
    "initialState",
    "classNames",
    "styles",
    "unstyled",
    "variant"
  ]), { classes: y, cx: w } = IU({ transitionDuration: s }, { name: "Spoiler", classNames: f, styles: p, unstyled: g, variant: h }), [$, C] = Se(d), { ref: x, height: b } = dP(), O = a < b, _ = $ ? i : l;
  return /* @__PURE__ */ E.createElement(We, RU({
    className: w(y.root, n),
    ref: r
  }, v), /* @__PURE__ */ E.createElement("div", {
    className: y.content,
    style: {
      maxHeight: $ ? b ? B(b) : void 0 : B(a)
    }
  }, /* @__PURE__ */ E.createElement("div", {
    ref: x
  }, o)), O && /* @__PURE__ */ E.createElement($D, {
    component: "button",
    ref: u,
    onClick: () => C((P) => !P),
    className: y.control
  }, _));
});
dw.displayName = "@mantine/core/Spoiler";
var MU = Ae((e, { spacing: r, align: t, justify: n }) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: t,
    justifyContent: n,
    gap: ve({ size: r, sizes: e.spacing })
  }
})), NU = Object.defineProperty, Kc = Object.getOwnPropertySymbols, fw = Object.prototype.hasOwnProperty, pw = Object.prototype.propertyIsEnumerable, Eg = (e, r, t) => r in e ? NU(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, TU = (e, r) => {
  for (var t in r || (r = {}))
    fw.call(r, t) && Eg(e, t, r[t]);
  if (Kc)
    for (var t of Kc(r))
      pw.call(r, t) && Eg(e, t, r[t]);
  return e;
}, DU = (e, r) => {
  var t = {};
  for (var n in e)
    fw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Kc)
    for (var n of Kc(e))
      r.indexOf(n) < 0 && pw.call(e, n) && (t[n] = e[n]);
  return t;
};
const jU = {
  spacing: "md",
  align: "stretch",
  justify: "flex-start"
}, LU = ue((e, r) => {
  const t = Oe("Stack", jU, e), { spacing: n, className: o, align: a, justify: i, unstyled: l, variant: s } = t, u = DU(t, ["spacing", "className", "align", "justify", "unstyled", "variant"]), { classes: d, cx: f } = MU({ spacing: n, align: a, justify: i }, { name: "Stack", unstyled: l, variant: s });
  return /* @__PURE__ */ E.createElement(We, TU({
    className: f(d.root, o),
    ref: r
  }, u));
});
LU.displayName = "@mantine/core/Stack";
const gw = xt(null), zU = gw.Provider, VU = () => dt(gw);
var FU = Object.defineProperty, Qc = Object.getOwnPropertySymbols, vw = Object.prototype.hasOwnProperty, mw = Object.prototype.propertyIsEnumerable, Rg = (e, r, t) => r in e ? FU(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Ag = (e, r) => {
  for (var t in r || (r = {}))
    vw.call(r, t) && Rg(e, t, r[t]);
  if (Qc)
    for (var t of Qc(r))
      mw.call(r, t) && Rg(e, t, r[t]);
  return e;
}, ZU = (e, r) => {
  var t = {};
  for (var n in e)
    vw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Qc)
    for (var n of Qc(e))
      r.indexOf(n) < 0 && mw.call(e, n) && (t[n] = e[n]);
  return t;
};
const WU = {
  size: "sm"
}, hw = ue((e, r) => {
  const t = Oe("SwitchGroup", WU, e), { children: n, value: o, defaultValue: a, onChange: i, size: l, wrapperProps: s } = t, u = ZU(t, ["children", "value", "defaultValue", "onChange", "size", "wrapperProps"]), [d, f] = Hr({
    value: o,
    defaultValue: a,
    finalValue: [],
    onChange: i
  }), p = (g) => {
    const h = g.currentTarget.value;
    f(d.includes(h) ? d.filter((v) => v !== h) : [...d, h]);
  };
  return /* @__PURE__ */ E.createElement(zU, {
    value: { value: d, onChange: p, size: l }
  }, /* @__PURE__ */ E.createElement(jr.Wrapper, Ag(Ag({
    labelElement: "div",
    size: l,
    __staticSelector: "SwitchGroup",
    ref: r
  }, s), u), n));
});
hw.displayName = "@mantine/core/SwitchGroup";
var BU = Object.defineProperty, HU = Object.defineProperties, GU = Object.getOwnPropertyDescriptors, kg = Object.getOwnPropertySymbols, XU = Object.prototype.hasOwnProperty, YU = Object.prototype.propertyIsEnumerable, Mg = (e, r, t) => r in e ? BU(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, UU = (e, r) => {
  for (var t in r || (r = {}))
    XU.call(r, t) && Mg(e, t, r[t]);
  if (kg)
    for (var t of kg(r))
      YU.call(r, t) && Mg(e, t, r[t]);
  return e;
}, JU = (e, r) => HU(e, GU(r));
const qU = {
  xs: B(16),
  sm: B(20),
  md: B(24),
  lg: B(30),
  xl: B(36)
}, KU = {
  xs: B(32),
  sm: B(38),
  md: B(46),
  lg: B(56),
  xl: B(72)
}, QU = {
  xs: B(12),
  sm: B(14),
  md: B(18),
  lg: B(22),
  xl: B(28)
}, eJ = {
  xs: B(5),
  sm: B(6),
  md: B(7),
  lg: B(9),
  xl: B(11)
}, rJ = {
  xs: B(4),
  sm: B(5),
  md: B(6),
  lg: B(8),
  xl: B(10)
};
var tJ = Ae((e, { radius: r, color: t, labelPosition: n, error: o }, { size: a }) => {
  const i = ve({ size: a, sizes: QU }), l = ve({ size: r, sizes: e.radius }), s = e.fn.variant({ variant: "filled", color: t }), u = ve({ size: a, sizes: KU }), d = B(a === "xs" ? 1 : 2), f = e.fn.variant({ variant: "filled", color: "red" }).background;
  return {
    root: {
      position: "relative"
    },
    input: {
      height: 0,
      width: 0,
      overflow: "hidden",
      whiteSpace: "nowrap",
      padding: 0,
      WebkitClipPath: "inset(50%)",
      clipPath: "inset(50%)",
      position: "absolute"
    },
    track: JU(UU({}, e.fn.focusStyles("input:focus + &")), {
      cursor: e.cursorType,
      overflow: "hidden",
      WebkitTapHighlightColor: "transparent",
      position: "relative",
      borderRadius: l,
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[2],
      border: `${B(1)} solid ${o ? f : e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3]}`,
      height: ve({ size: a, sizes: qU }),
      minWidth: u,
      margin: 0,
      transitionProperty: "background-color, border-color",
      transitionTimingFunction: e.transitionTimingFunction,
      transitionDuration: "150ms",
      boxSizing: "border-box",
      appearance: "none",
      display: "flex",
      alignItems: "center",
      fontSize: ve({ size: a, sizes: eJ }),
      fontWeight: 600,
      order: n === "left" ? 2 : 1,
      userSelect: "none",
      zIndex: 0,
      lineHeight: 0,
      color: e.colorScheme === "dark" ? e.colors.dark[1] : e.colors.gray[6],
      transition: `color 150ms ${e.transitionTimingFunction}`,
      "input:checked + &": {
        backgroundColor: s.background,
        borderColor: s.background,
        color: e.white,
        transition: `color 150ms ${e.transitionTimingFunction}`
      },
      "input:disabled + &": {
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2],
        borderColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2],
        cursor: "not-allowed",
        pointerEvents: "none"
      }
    }),
    thumb: {
      position: "absolute",
      zIndex: 1,
      borderRadius: l,
      boxSizing: "border-box",
      display: "flex",
      backgroundColor: e.white,
      height: i,
      width: i,
      border: `${B(1)} solid ${e.colorScheme === "dark" ? e.white : e.colors.gray[3]}`,
      left: d,
      transition: `left 150ms ${e.transitionTimingFunction}`,
      "& > *": {
        margin: "auto"
      },
      "@media (prefers-reduced-motion)": {
        transitionDuration: e.respectReducedMotion ? "0ms" : ""
      },
      "input:checked + * > &": {
        left: `calc(100% - ${i} - ${d})`,
        borderColor: e.white
      },
      "input:disabled + * > &": {
        borderColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[2],
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[0]
      }
    },
    trackLabel: {
      height: "100%",
      display: "grid",
      placeContent: "center",
      minWidth: `calc(${u} - ${i})`,
      paddingInline: ve({ size: a, sizes: rJ }),
      marginLeft: `calc(${i} + ${d})`,
      transition: `margin 150ms ${e.transitionTimingFunction}`,
      "input:checked + * > &": {
        marginLeft: 0,
        marginRight: `calc(${i} + ${d})`
      }
    }
  };
}), nJ = Object.defineProperty, oJ = Object.defineProperties, aJ = Object.getOwnPropertyDescriptors, eu = Object.getOwnPropertySymbols, bw = Object.prototype.hasOwnProperty, yw = Object.prototype.propertyIsEnumerable, Ng = (e, r, t) => r in e ? nJ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Rd = (e, r) => {
  for (var t in r || (r = {}))
    bw.call(r, t) && Ng(e, t, r[t]);
  if (eu)
    for (var t of eu(r))
      yw.call(r, t) && Ng(e, t, r[t]);
  return e;
}, iJ = (e, r) => oJ(e, aJ(r)), lJ = (e, r) => {
  var t = {};
  for (var n in e)
    bw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && eu)
    for (var n of eu(e))
      r.indexOf(n) < 0 && yw.call(e, n) && (t[n] = e[n]);
  return t;
};
const sJ = {
  offLabel: "",
  onLabel: "",
  size: "sm",
  radius: "xl",
  error: !1
}, Hf = ue((e, r) => {
  var t;
  const n = Oe("Switch", sJ, e), {
    className: o,
    color: a,
    label: i,
    offLabel: l,
    onLabel: s,
    id: u,
    style: d,
    size: f,
    radius: p,
    wrapperProps: g,
    children: h,
    unstyled: v,
    styles: y,
    classNames: w,
    thumbIcon: $,
    sx: C,
    checked: x,
    defaultChecked: b,
    onChange: O,
    labelPosition: _,
    description: P,
    error: S,
    disabled: I,
    variant: N
  } = n, k = lJ(n, [
    "className",
    "color",
    "label",
    "offLabel",
    "onLabel",
    "id",
    "style",
    "size",
    "radius",
    "wrapperProps",
    "children",
    "unstyled",
    "styles",
    "classNames",
    "thumbIcon",
    "sx",
    "checked",
    "defaultChecked",
    "onChange",
    "labelPosition",
    "description",
    "error",
    "disabled",
    "variant"
  ]), j = VU(), R = (j == null ? void 0 : j.size) || f, { classes: D, cx: T } = tJ({ color: a, radius: p, labelPosition: _, error: !!S }, { name: "Switch", classNames: w, styles: y, unstyled: v, size: R, variant: N }), { systemStyles: V, rest: L } = En(k), Z = ke(u), z = j ? {
    checked: j.value.includes(L.value),
    onChange: j.onChange
  } : {}, [W, U] = Hr({
    value: (t = z.checked) != null ? t : x,
    defaultValue: b,
    finalValue: !1
  });
  return /* @__PURE__ */ E.createElement(C1, Rd(Rd({
    className: T(o, D.root),
    sx: C,
    style: d,
    id: Z,
    size: (j == null ? void 0 : j.size) || f,
    labelPosition: _,
    label: i,
    description: P,
    error: S,
    disabled: I,
    __staticSelector: "Switch",
    classNames: w,
    styles: y,
    unstyled: v,
    "data-checked": z.checked || void 0,
    variant: N
  }, V), g), /* @__PURE__ */ E.createElement("input", iJ(Rd({}, L), {
    disabled: I,
    checked: W,
    onChange: (re) => {
      j ? z.onChange(re) : O == null || O(re), U(re.currentTarget.checked);
    },
    id: Z,
    ref: r,
    type: "checkbox",
    className: D.input
  })), /* @__PURE__ */ E.createElement("label", {
    htmlFor: Z,
    className: D.track
  }, /* @__PURE__ */ E.createElement("div", {
    className: D.thumb
  }, $), /* @__PURE__ */ E.createElement("div", {
    className: D.trackLabel
  }, W ? s : l)));
});
Hf.displayName = "@mantine/core/Switch";
Hf.Group = hw;
const E0 = {
  context: "Tabs component was not found in the tree",
  value: "Tabs.Tab or Tabs.Panel component was rendered with invalid value or without value"
}, [cJ, Gf] = no(E0.context);
var uJ = Object.defineProperty, Tg = Object.getOwnPropertySymbols, dJ = Object.prototype.hasOwnProperty, fJ = Object.prototype.propertyIsEnumerable, Dg = (e, r, t) => r in e ? uJ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, pJ = (e, r) => {
  for (var t in r || (r = {}))
    dJ.call(r, t) && Dg(e, t, r[t]);
  if (Tg)
    for (var t of Tg(r))
      fJ.call(r, t) && Dg(e, t, r[t]);
  return e;
};
function gJ({ orientation: e, inverted: r, placement: t }, n, o) {
  const a = e === "vertical";
  return o === "default" ? {
    [a ? t === "left" ? "borderRight" : "borderLeft" : r ? "borderTop" : "borderBottom"]: `${B(2)} solid ${n.colorScheme === "dark" ? n.colors.dark[4] : n.colors.gray[3]}`
  } : o === "outline" ? {
    [a ? t === "left" ? "borderRight" : "borderLeft" : r ? "borderTop" : "borderBottom"]: `${B(1)} solid ${n.colorScheme === "dark" ? n.colors.dark[4] : n.colors.gray[3]}`
  } : o === "pills" ? {
    gap: `calc(${n.spacing.sm} / 2)`
  } : {};
}
var vJ = Ae((e, r, { variant: t }) => {
  const n = r.orientation === "vertical";
  return {
    tabsList: pJ({
      display: "flex",
      flexWrap: "wrap",
      flexDirection: n ? "column" : "row",
      justifyContent: Py[r.position],
      '& [role="tab"]': {
        flex: r.grow ? 1 : void 0
      }
    }, gJ(r, e, t))
  };
}), mJ = Object.defineProperty, hJ = Object.defineProperties, bJ = Object.getOwnPropertyDescriptors, ru = Object.getOwnPropertySymbols, Cw = Object.prototype.hasOwnProperty, ww = Object.prototype.propertyIsEnumerable, jg = (e, r, t) => r in e ? mJ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, yJ = (e, r) => {
  for (var t in r || (r = {}))
    Cw.call(r, t) && jg(e, t, r[t]);
  if (ru)
    for (var t of ru(r))
      ww.call(r, t) && jg(e, t, r[t]);
  return e;
}, CJ = (e, r) => hJ(e, bJ(r)), wJ = (e, r) => {
  var t = {};
  for (var n in e)
    Cw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ru)
    for (var n of ru(e))
      r.indexOf(n) < 0 && ww.call(e, n) && (t[n] = e[n]);
  return t;
};
const _J = {
  grow: !1,
  position: "left"
}, _w = ue((e, r) => {
  const t = Oe("TabsList", _J, e), { children: n, className: o, grow: a, position: i } = t, l = wJ(t, ["children", "className", "grow", "position"]), { orientation: s, variant: u, color: d, radius: f, inverted: p, placement: g, classNames: h, styles: v, unstyled: y } = Gf(), { classes: w, cx: $ } = vJ({ orientation: s, grow: a, color: d, position: i, radius: f, inverted: p, placement: g }, { name: "Tabs", unstyled: y, classNames: h, styles: v, variant: u });
  return /* @__PURE__ */ E.createElement(We, CJ(yJ({}, l), {
    className: $(w.tabsList, o),
    ref: r,
    role: "tablist",
    "aria-orientation": s
  }), n);
});
_w.displayName = "@mantine/core/TabsList";
var xJ = Ae((e, { orientation: r }) => ({
  panel: {
    flex: r === "vertical" ? 1 : void 0
  }
}));
const $J = xJ;
var OJ = Object.defineProperty, PJ = Object.defineProperties, SJ = Object.getOwnPropertyDescriptors, tu = Object.getOwnPropertySymbols, xw = Object.prototype.hasOwnProperty, $w = Object.prototype.propertyIsEnumerable, Lg = (e, r, t) => r in e ? OJ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, IJ = (e, r) => {
  for (var t in r || (r = {}))
    xw.call(r, t) && Lg(e, t, r[t]);
  if (tu)
    for (var t of tu(r))
      $w.call(r, t) && Lg(e, t, r[t]);
  return e;
}, EJ = (e, r) => PJ(e, SJ(r)), RJ = (e, r) => {
  var t = {};
  for (var n in e)
    xw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && tu)
    for (var n of tu(e))
      r.indexOf(n) < 0 && $w.call(e, n) && (t[n] = e[n]);
  return t;
};
const AJ = {}, Ow = ue((e, r) => {
  const t = Oe("TabsPanel", AJ, e), { value: n, children: o, sx: a, className: i } = t, l = RJ(t, ["value", "children", "sx", "className"]), s = Gf(), { classes: u, cx: d } = $J({
    orientation: s.orientation,
    color: s.color,
    radius: s.radius,
    inverted: s.inverted,
    placement: s.placement
  }, {
    name: "Tabs",
    unstyled: s.unstyled,
    classNames: s.classNames,
    styles: s.styles,
    variant: s.variant
  }), f = s.getPanelId(n), p = s.value === n, g = s.keepMounted || p ? o : null;
  return Fe(() => (s.setMountedPanelIds((h) => [...h, f]), s.setMountedPanelIds((h) => h.filter((v) => v !== f))), [f]), /* @__PURE__ */ E.createElement(We, EJ(IJ({}, l), {
    ref: r,
    sx: [{ display: p ? void 0 : "none" }, ...f1(a)],
    className: d(u.panel, i),
    role: "tabpanel",
    id: f,
    "aria-labelledby": s.getTabId(n)
  }), g);
});
Ow.displayName = "@mantine/core/TabsPanel";
var kJ = Object.defineProperty, MJ = Object.defineProperties, NJ = Object.getOwnPropertyDescriptors, zg = Object.getOwnPropertySymbols, TJ = Object.prototype.hasOwnProperty, DJ = Object.prototype.propertyIsEnumerable, Vg = (e, r, t) => r in e ? kJ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, na = (e, r) => {
  for (var t in r || (r = {}))
    TJ.call(r, t) && Vg(e, t, r[t]);
  if (zg)
    for (var t of zg(r))
      DJ.call(r, t) && Vg(e, t, r[t]);
  return e;
}, Fg = (e, r) => MJ(e, NJ(r));
function jJ(e, { orientation: r, color: t, radius: n, inverted: o, placement: a }, i) {
  const l = r === "vertical", s = e.fn.variant({ color: t, variant: "filled" }), u = B(e.fn.radius(n)), d = r === "vertical" ? a === "left" ? `${u} 0 0 ${u}` : ` 0 ${u} ${u} 0` : o ? `0 0 ${u} ${u}` : `${u} ${u} 0 0`;
  return i === "default" ? Fg(na({
    [l ? a === "left" ? "borderRight" : "borderLeft" : o ? "borderTop" : "borderBottom"]: `${B(2)} solid transparent`,
    [l ? a === "left" ? "marginRight" : "marginLeft" : o ? "marginTop" : "marginBottom"]: B(-2),
    borderRadius: d
  }, e.fn.hover({
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0],
    borderColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3]
  })), {
    "&[data-active]": na({
      borderColor: s.background,
      color: e.colorScheme === "dark" ? e.white : e.black
    }, e.fn.hover({ borderColor: s.background }))
  }) : i === "outline" ? {
    borderRadius: d,
    border: `${B(1)} solid transparent`,
    [l ? a === "left" ? "borderRight" : "borderLeft" : o ? "borderTop" : "borderBottom"]: "none",
    "&[data-active]": {
      borderColor: e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[3],
      "&::before": {
        content: '""',
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white,
        position: "absolute",
        bottom: l ? 0 : o ? "unset" : B(-1),
        top: l ? 0 : o ? B(-1) : "unset",
        [l ? "width" : "height"]: B(1),
        right: l ? a === "left" ? B(-1) : "unset" : 0,
        left: l ? a === "left" ? "unset" : B(-1) : 0
      }
    }
  } : i === "pills" ? Fg(na({
    borderRadius: e.fn.radius(n)
  }, e.fn.hover({
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.colors.gray[0]
  })), {
    "&[data-active]": na({
      backgroundColor: s.background,
      color: e.white
    }, e.fn.hover({ backgroundColor: s.background }))
  }) : {};
}
var LJ = Ae((e, r, { variant: t }) => ({
  tabLabel: {},
  tab: na({
    position: "relative",
    padding: `${e.spacing.xs} ${e.spacing.md}`,
    paddingLeft: r.withIcon ? e.spacing.xs : void 0,
    paddingRight: r.withRightSection ? e.spacing.xs : void 0,
    fontSize: e.fontSizes.sm,
    whiteSpace: "nowrap",
    zIndex: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: r.orientation === "horizontal" ? "center" : void 0,
    lineHeight: 1,
    "&:disabled": na({
      opacity: 0.5,
      cursor: "not-allowed"
    }, e.fn.hover({ backgroundColor: "transparent" })),
    "&:focus": {
      zIndex: 1
    }
  }, jJ(e, r, t)),
  tabRightSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:not(:only-child)": {
      marginLeft: B(7)
    }
  },
  tabIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:not(:only-child)": {
      marginRight: B(7)
    }
  }
}));
const zJ = LJ;
var VJ = Object.defineProperty, FJ = Object.defineProperties, ZJ = Object.getOwnPropertyDescriptors, nu = Object.getOwnPropertySymbols, Pw = Object.prototype.hasOwnProperty, Sw = Object.prototype.propertyIsEnumerable, Zg = (e, r, t) => r in e ? VJ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, WJ = (e, r) => {
  for (var t in r || (r = {}))
    Pw.call(r, t) && Zg(e, t, r[t]);
  if (nu)
    for (var t of nu(r))
      Sw.call(r, t) && Zg(e, t, r[t]);
  return e;
}, BJ = (e, r) => FJ(e, ZJ(r)), HJ = (e, r) => {
  var t = {};
  for (var n in e)
    Pw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && nu)
    for (var n of nu(e))
      r.indexOf(n) < 0 && Sw.call(e, n) && (t[n] = e[n]);
  return t;
};
const GJ = {}, Iw = ue((e, r) => {
  const t = Oe("TabsTab", GJ, e), { value: n, children: o, onKeyDown: a, onClick: i, className: l, icon: s, rightSection: u, color: d } = t, f = HJ(t, ["value", "children", "onKeyDown", "onClick", "className", "icon", "rightSection", "color"]), p = Gf(), g = !!s, h = !!u, { theme: v, classes: y, cx: w } = zJ({
    withIcon: g || h && !o,
    withRightSection: h || g && !o,
    orientation: p.orientation,
    color: d || p.color,
    radius: p.radius,
    inverted: p.inverted,
    placement: p.placement
  }, {
    name: "Tabs",
    unstyled: p.unstyled,
    classNames: p.classNames,
    styles: p.styles,
    variant: p.variant
  }), $ = n === p.value, C = p.getPanelId(n), x = p.mountedPanelIds.includes(n) ? C : void 0, b = (O) => {
    p.onTabChange(p.allowTabDeactivation && n === p.value ? null : n), i == null || i(O);
  };
  return /* @__PURE__ */ E.createElement($o, BJ(WJ({}, f), {
    unstyled: p.unstyled,
    className: w(y.tab, l),
    "data-active": $ || void 0,
    ref: r,
    type: "button",
    role: "tab",
    id: p.getTabId(n),
    "aria-selected": $,
    tabIndex: $ || p.value === null ? 0 : -1,
    "aria-controls": x,
    onClick: b,
    onKeyDown: z6({
      siblingSelector: '[role="tab"]',
      parentSelector: '[role="tablist"]',
      activateOnFocus: p.activateTabWithKeyboard,
      loop: p.loop,
      dir: v.dir,
      orientation: p.orientation,
      onKeyDown: a
    })
  }), s && /* @__PURE__ */ E.createElement("span", {
    className: y.tabIcon
  }, s), o && /* @__PURE__ */ E.createElement("span", {
    className: y.tabLabel
  }, o), u && /* @__PURE__ */ E.createElement("span", {
    className: y.tabRightSection
  }, u));
});
Iw.displayName = "@mantine/core/Tab";
function Ew({
  defaultValue: e,
  value: r,
  onTabChange: t,
  orientation: n,
  children: o,
  loop: a,
  id: i,
  activateTabWithKeyboard: l,
  allowTabDeactivation: s,
  variant: u,
  color: d,
  radius: f,
  inverted: p,
  placement: g,
  keepMounted: h = !0,
  classNames: v,
  styles: y,
  unstyled: w
}) {
  const $ = ke(i), [C, x] = Se([]), [b, O] = Hr({
    value: r,
    defaultValue: e,
    finalValue: null,
    onChange: t
  });
  return /* @__PURE__ */ E.createElement(cJ, {
    value: {
      placement: g,
      value: b,
      orientation: n,
      id: $,
      loop: a,
      activateTabWithKeyboard: l,
      getTabId: d5(`${$}-tab`, E0.value),
      getPanelId: d5(`${$}-panel`, E0.value),
      onTabChange: O,
      setMountedPanelIds: x,
      mountedPanelIds: C,
      allowTabDeactivation: s,
      variant: u,
      color: d,
      radius: f,
      inverted: p,
      keepMounted: h,
      classNames: v,
      styles: y,
      unstyled: w
    }
  }, o);
}
Ew.displayName = "@mantine/core/TabsProvider";
var XJ = Ae((e, { orientation: r, placement: t }) => ({
  root: {
    display: r === "vertical" ? "flex" : void 0,
    flexDirection: t === "right" ? "row-reverse" : "row"
  }
})), YJ = Object.defineProperty, UJ = Object.defineProperties, JJ = Object.getOwnPropertyDescriptors, ou = Object.getOwnPropertySymbols, Rw = Object.prototype.hasOwnProperty, Aw = Object.prototype.propertyIsEnumerable, Wg = (e, r, t) => r in e ? YJ(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, qJ = (e, r) => {
  for (var t in r || (r = {}))
    Rw.call(r, t) && Wg(e, t, r[t]);
  if (ou)
    for (var t of ou(r))
      Aw.call(r, t) && Wg(e, t, r[t]);
  return e;
}, KJ = (e, r) => UJ(e, JJ(r)), QJ = (e, r) => {
  var t = {};
  for (var n in e)
    Rw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ou)
    for (var n of ou(e))
      r.indexOf(n) < 0 && Aw.call(e, n) && (t[n] = e[n]);
  return t;
};
const eq = {
  orientation: "horizontal",
  loop: !0,
  activateTabWithKeyboard: !0,
  allowTabDeactivation: !1,
  unstyled: !1,
  inverted: !1,
  variant: "default",
  placement: "left"
}, oo = ue((e, r) => {
  const t = Oe("Tabs", eq, e), {
    defaultValue: n,
    value: o,
    orientation: a,
    loop: i,
    activateTabWithKeyboard: l,
    allowTabDeactivation: s,
    children: u,
    id: d,
    onTabChange: f,
    variant: p,
    color: g,
    className: h,
    unstyled: v,
    classNames: y,
    styles: w,
    radius: $,
    inverted: C,
    keepMounted: x,
    placement: b
  } = t, O = QJ(t, [
    "defaultValue",
    "value",
    "orientation",
    "loop",
    "activateTabWithKeyboard",
    "allowTabDeactivation",
    "children",
    "id",
    "onTabChange",
    "variant",
    "color",
    "className",
    "unstyled",
    "classNames",
    "styles",
    "radius",
    "inverted",
    "keepMounted",
    "placement"
  ]), { classes: _, cx: P } = XJ({ orientation: a, color: g, radius: $, inverted: C, placement: b }, { unstyled: v, name: "Tabs", classNames: y, styles: w, variant: p });
  return /* @__PURE__ */ E.createElement(Ew, {
    activateTabWithKeyboard: l,
    defaultValue: n,
    orientation: a,
    onTabChange: f,
    value: o,
    id: d,
    loop: i,
    allowTabDeactivation: s,
    color: g,
    variant: p,
    radius: $,
    inverted: C,
    keepMounted: x,
    placement: b,
    classNames: y,
    styles: w,
    unstyled: v
  }, /* @__PURE__ */ E.createElement(We, KJ(qJ({}, O), {
    className: P(_.root, h),
    id: d,
    ref: r
  }), u));
});
oo.List = _w;
oo.Tab = Iw;
oo.Panel = Ow;
oo.displayName = "@mantine/core/Tabs";
var rq = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Li(e, r) {
  var t = tq(e);
  if (typeof t.path != "string") {
    var n = e.webkitRelativePath;
    Object.defineProperty(t, "path", {
      value: typeof r == "string" ? r : typeof n == "string" && n.length > 0 ? n : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return t;
}
function tq(e) {
  var r = e.name, t = r && r.lastIndexOf(".") !== -1;
  if (t && !e.type) {
    var n = r.split(".").pop().toLowerCase(), o = rq.get(n);
    o && Object.defineProperty(e, "type", {
      value: o,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var nq = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function oq(e) {
  return $a(this, void 0, void 0, function() {
    return Oa(this, function(r) {
      return au(e) && aq(e.dataTransfer) ? [2, cq(e.dataTransfer, e.type)] : iq(e) ? [2, lq(e)] : Array.isArray(e) && e.every(function(t) {
        return "getFile" in t && typeof t.getFile == "function";
      }) ? [2, sq(e)] : [2, []];
    });
  });
}
function aq(e) {
  return au(e);
}
function iq(e) {
  return au(e) && au(e.target);
}
function au(e) {
  return typeof e == "object" && e !== null;
}
function lq(e) {
  return R0(e.target.files).map(function(r) {
    return Li(r);
  });
}
function sq(e) {
  return $a(this, void 0, void 0, function() {
    var r;
    return Oa(this, function(t) {
      switch (t.label) {
        case 0:
          return [4, Promise.all(e.map(function(n) {
            return n.getFile();
          }))];
        case 1:
          return r = t.sent(), [2, r.map(function(n) {
            return Li(n);
          })];
      }
    });
  });
}
function cq(e, r) {
  return $a(this, void 0, void 0, function() {
    var t, n;
    return Oa(this, function(o) {
      switch (o.label) {
        case 0:
          return e.items ? (t = R0(e.items).filter(function(a) {
            return a.kind === "file";
          }), r !== "drop" ? [2, t] : [4, Promise.all(t.map(uq))]) : [3, 2];
        case 1:
          return n = o.sent(), [2, Bg(kw(n))];
        case 2:
          return [2, Bg(R0(e.files).map(function(a) {
            return Li(a);
          }))];
      }
    });
  });
}
function Bg(e) {
  return e.filter(function(r) {
    return nq.indexOf(r.name) === -1;
  });
}
function R0(e) {
  if (e === null)
    return [];
  for (var r = [], t = 0; t < e.length; t++) {
    var n = e[t];
    r.push(n);
  }
  return r;
}
function uq(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return Hg(e);
  var r = e.webkitGetAsEntry();
  return r && r.isDirectory ? Mw(r) : Hg(e);
}
function kw(e) {
  return e.reduce(function(r, t) {
    return g0(g0([], a5(r), !1), a5(Array.isArray(t) ? kw(t) : [t]), !1);
  }, []);
}
function Hg(e) {
  var r = e.getAsFile();
  if (!r)
    return Promise.reject("".concat(e, " is not a File"));
  var t = Li(r);
  return Promise.resolve(t);
}
function dq(e) {
  return $a(this, void 0, void 0, function() {
    return Oa(this, function(r) {
      return [2, e.isDirectory ? Mw(e) : fq(e)];
    });
  });
}
function Mw(e) {
  var r = e.createReader();
  return new Promise(function(t, n) {
    var o = [];
    function a() {
      var i = this;
      r.readEntries(function(l) {
        return $a(i, void 0, void 0, function() {
          var s, u, d;
          return Oa(this, function(f) {
            switch (f.label) {
              case 0:
                if (l.length)
                  return [3, 5];
                f.label = 1;
              case 1:
                return f.trys.push([1, 3, , 4]), [4, Promise.all(o)];
              case 2:
                return s = f.sent(), t(s), [3, 4];
              case 3:
                return u = f.sent(), n(u), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                d = Promise.all(l.map(dq)), o.push(d), a(), f.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(l) {
        n(l);
      });
    }
    a();
  });
}
function fq(e) {
  return $a(this, void 0, void 0, function() {
    return Oa(this, function(r) {
      return [2, new Promise(function(t, n) {
        e.file(function(o) {
          var a = Li(o, e.fullPath);
          t(a);
        }, function(o) {
          n(o);
        });
      })];
    });
  });
}
var pq = function(e, r) {
  if (e && r) {
    var t = Array.isArray(r) ? r : r.split(","), n = e.name || "", o = (e.type || "").toLowerCase(), a = o.replace(/\/.*$/, "");
    return t.some(function(i) {
      var l = i.trim().toLowerCase();
      return l.charAt(0) === "." ? n.toLowerCase().endsWith(l) : l.endsWith("/*") ? a === l.replace(/\/.*$/, "") : o === l;
    });
  }
  return !0;
};
function Gg(e) {
  return mq(e) || vq(e) || Tw(e) || gq();
}
function gq() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vq(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function mq(e) {
  if (Array.isArray(e))
    return A0(e);
}
function Xg(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Yg(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Xg(Object(t), !0).forEach(function(n) {
      Nw(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Xg(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Nw(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function hi(e, r) {
  return yq(e) || bq(e, r) || Tw(e, r) || hq();
}
function hq() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tw(e, r) {
  if (e) {
    if (typeof e == "string")
      return A0(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return A0(e, r);
  }
}
function A0(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function bq(e, r) {
  var t = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], o = !0, a = !1, i, l;
    try {
      for (t = t.call(e); !(o = (i = t.next()).done) && (n.push(i.value), !(r && n.length === r)); o = !0)
        ;
    } catch (s) {
      a = !0, l = s;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (a)
          throw l;
      }
    }
    return n;
  }
}
function yq(e) {
  if (Array.isArray(e))
    return e;
}
var Cq = "file-invalid-type", wq = "file-too-large", _q = "file-too-small", xq = "too-many-files", $q = function(r) {
  r = Array.isArray(r) && r.length === 1 ? r[0] : r;
  var t = Array.isArray(r) ? "one of ".concat(r.join(", ")) : r;
  return {
    code: Cq,
    message: "File type must be ".concat(t)
  };
}, Ug = function(r) {
  return {
    code: wq,
    message: "File is larger than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, Jg = function(r) {
  return {
    code: _q,
    message: "File is smaller than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, Oq = {
  code: xq,
  message: "Too many files"
};
function Dw(e, r) {
  var t = e.type === "application/x-moz-file" || pq(e, r);
  return [t, t ? null : $q(r)];
}
function jw(e, r, t) {
  if (_o(e.size))
    if (_o(r) && _o(t)) {
      if (e.size > t)
        return [!1, Ug(t)];
      if (e.size < r)
        return [!1, Jg(r)];
    } else {
      if (_o(r) && e.size < r)
        return [!1, Jg(r)];
      if (_o(t) && e.size > t)
        return [!1, Ug(t)];
    }
  return [!0, null];
}
function _o(e) {
  return e != null;
}
function Pq(e) {
  var r = e.files, t = e.accept, n = e.minSize, o = e.maxSize, a = e.multiple, i = e.maxFiles, l = e.validator;
  return !a && r.length > 1 || a && i >= 1 && r.length > i ? !1 : r.every(function(s) {
    var u = Dw(s, t), d = hi(u, 1), f = d[0], p = jw(s, n, o), g = hi(p, 1), h = g[0], v = l ? l(s) : null;
    return f && h && !v;
  });
}
function iu(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble != "undefined" ? e.cancelBubble : !1;
}
function xl(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(r) {
    return r === "Files" || r === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function qg(e) {
  e.preventDefault();
}
function Sq(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function Iq(e) {
  return e.indexOf("Edge/") !== -1;
}
function Eq() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return Sq(e) || Iq(e);
}
function Qt() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(n) {
    for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      a[i - 1] = arguments[i];
    return r.some(function(l) {
      return !iu(n) && l && l.apply(void 0, [n].concat(a)), iu(n);
    });
  };
}
function Rq() {
  return "showOpenFilePicker" in window;
}
function Aq(e) {
  if (_o(e)) {
    var r = Object.entries(e).filter(function(t) {
      var n = hi(t, 2), o = n[0], a = n[1], i = !0;
      return Lw(o) || (console.warn('Skipped "'.concat(o, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), i = !1), (!Array.isArray(a) || !a.every(zw)) && (console.warn('Skipped "'.concat(o, '" because an invalid file extension was provided.')), i = !1), i;
    }).reduce(function(t, n) {
      var o = hi(n, 2), a = o[0], i = o[1];
      return Yg(Yg({}, t), {}, Nw({}, a, i));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: r
    }];
  }
  return e;
}
function kq(e) {
  if (_o(e))
    return Object.entries(e).reduce(function(r, t) {
      var n = hi(t, 2), o = n[0], a = n[1];
      return [].concat(Gg(r), [o], Gg(a));
    }, []).filter(function(r) {
      return Lw(r) || zw(r);
    }).join(",");
}
function Mq(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function Nq(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function Lw(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function zw(e) {
  return /^.*\.[\w]+$/.test(e);
}
var Tq = ["children"], Dq = ["open"], jq = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], Lq = ["refKey", "onChange", "onClick"];
function zq(e) {
  return Zq(e) || Fq(e) || Vw(e) || Vq();
}
function Vq() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fq(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Zq(e) {
  if (Array.isArray(e))
    return k0(e);
}
function Ad(e, r) {
  return Hq(e) || Bq(e, r) || Vw(e, r) || Wq();
}
function Wq() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vw(e, r) {
  if (e) {
    if (typeof e == "string")
      return k0(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return k0(e, r);
  }
}
function k0(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function Bq(e, r) {
  var t = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], o = !0, a = !1, i, l;
    try {
      for (t = t.call(e); !(o = (i = t.next()).done) && (n.push(i.value), !(r && n.length === r)); o = !0)
        ;
    } catch (s) {
      a = !0, l = s;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (a)
          throw l;
      }
    }
    return n;
  }
}
function Hq(e) {
  if (Array.isArray(e))
    return e;
}
function Kg(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function kr(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Kg(Object(t), !0).forEach(function(n) {
      M0(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Kg(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function M0(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function lu(e, r) {
  if (e == null)
    return {};
  var t = Gq(e, r), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(r.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (t[n] = e[n]);
  }
  return t;
}
function Gq(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), o, a;
  for (a = 0; a < n.length; a++)
    o = n[a], !(r.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
var Xf = /* @__PURE__ */ ue(function(e, r) {
  var t = e.children, n = lu(e, Tq), o = Zw(n), a = o.open, i = lu(o, Dq);
  return Kv(r, function() {
    return {
      open: a
    };
  }, [a]), /* @__PURE__ */ E.createElement(ca, null, t(kr(kr({}, i), {}, {
    open: a
  })));
});
Xf.displayName = "Dropzone";
var Fw = {
  disabled: !1,
  getFilesFromEvent: oq,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
Xf.defaultProps = Fw;
Xf.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: c.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: c.objectOf(c.arrayOf(c.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: c.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: c.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: c.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: c.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: c.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: c.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: c.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: c.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: c.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: c.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: c.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: c.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: c.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: c.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: c.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: c.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: c.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: c.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: c.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: c.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: c.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: c.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: c.func
};
var N0 = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function Zw() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = kr(kr({}, Fw), e), t = r.accept, n = r.disabled, o = r.getFilesFromEvent, a = r.maxSize, i = r.minSize, l = r.multiple, s = r.maxFiles, u = r.onDragEnter, d = r.onDragLeave, f = r.onDragOver, p = r.onDrop, g = r.onDropAccepted, h = r.onDropRejected, v = r.onFileDialogCancel, y = r.onFileDialogOpen, w = r.useFsAccessApi, $ = r.autoFocus, C = r.preventDropOnDocument, x = r.noClick, b = r.noKeyboard, O = r.noDrag, _ = r.noDragEventsBubbling, P = r.onError, S = r.validator, I = Je(function() {
    return kq(t);
  }, [t]), N = Je(function() {
    return Aq(t);
  }, [t]), k = Je(function() {
    return typeof y == "function" ? y : Qg;
  }, [y]), j = Je(function() {
    return typeof v == "function" ? v : Qg;
  }, [v]), R = Ve(null), D = Ve(null), T = _i(Xq, N0), V = Ad(T, 2), L = V[0], Z = V[1], z = L.isFocused, W = L.isFileDialogActive, U = Ve(typeof window != "undefined" && window.isSecureContext && w && Rq()), re = function() {
    !U.current && W && setTimeout(function() {
      if (D.current) {
        var Ie = D.current.files;
        Ie.length || (Z({
          type: "closeDialog"
        }), j());
      }
    }, 300);
  };
  Fe(function() {
    return window.addEventListener("focus", re, !1), function() {
      window.removeEventListener("focus", re, !1);
    };
  }, [D, W, j, U]);
  var X = Ve([]), J = function(Ie) {
    R.current && R.current.contains(Ie.target) || (Ie.preventDefault(), X.current = []);
  };
  Fe(function() {
    return C && (document.addEventListener("dragover", qg, !1), document.addEventListener("drop", J, !1)), function() {
      C && (document.removeEventListener("dragover", qg), document.removeEventListener("drop", J));
    };
  }, [R, C]), Fe(function() {
    return !n && $ && R.current && R.current.focus(), function() {
    };
  }, [R, $, n]);
  var Q = $e(function(me) {
    P ? P(me) : console.error(me);
  }, [P]), se = $e(function(me) {
    me.preventDefault(), me.persist(), he(me), X.current = [].concat(zq(X.current), [me.target]), xl(me) && Promise.resolve(o(me)).then(function(Ie) {
      if (!(iu(me) && !_)) {
        var er = Ie.length, Ke = er > 0 && Pq({
          files: Ie,
          accept: I,
          minSize: i,
          maxSize: a,
          multiple: l,
          maxFiles: s,
          validator: S
        }), Me = er > 0 && !Ke;
        Z({
          isDragAccept: Ke,
          isDragReject: Me,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), u && u(me);
      }
    }).catch(function(Ie) {
      return Q(Ie);
    });
  }, [o, u, Q, _, I, i, a, l, s, S]), q = $e(function(me) {
    me.preventDefault(), me.persist(), he(me);
    var Ie = xl(me);
    if (Ie && me.dataTransfer)
      try {
        me.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return Ie && f && f(me), !1;
  }, [f, _]), te = $e(function(me) {
    me.preventDefault(), me.persist(), he(me);
    var Ie = X.current.filter(function(Ke) {
      return R.current && R.current.contains(Ke);
    }), er = Ie.indexOf(me.target);
    er !== -1 && Ie.splice(er, 1), X.current = Ie, !(Ie.length > 0) && (Z({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), xl(me) && d && d(me));
  }, [R, d, _]), ae = $e(function(me, Ie) {
    var er = [], Ke = [];
    me.forEach(function(Me) {
      var Pe = Dw(Me, I), Qe = Ad(Pe, 2), Sr = Qe[0], Cr = Qe[1], nr = jw(Me, i, a), De = Ad(nr, 2), Ge = De[0], lr = De[1], Ir = S ? S(Me) : null;
      if (Sr && Ge && !Ir)
        er.push(Me);
      else {
        var Or = [Cr, lr];
        Ir && (Or = Or.concat(Ir)), Ke.push({
          file: Me,
          errors: Or.filter(function($r) {
            return $r;
          })
        });
      }
    }), (!l && er.length > 1 || l && s >= 1 && er.length > s) && (er.forEach(function(Me) {
      Ke.push({
        file: Me,
        errors: [Oq]
      });
    }), er.splice(0)), Z({
      acceptedFiles: er,
      fileRejections: Ke,
      type: "setFiles"
    }), p && p(er, Ke, Ie), Ke.length > 0 && h && h(Ke, Ie), er.length > 0 && g && g(er, Ie);
  }, [Z, l, I, i, a, s, p, g, h, S]), ge = $e(function(me) {
    me.preventDefault(), me.persist(), he(me), X.current = [], xl(me) && Promise.resolve(o(me)).then(function(Ie) {
      iu(me) && !_ || ae(Ie, me);
    }).catch(function(Ie) {
      return Q(Ie);
    }), Z({
      type: "reset"
    });
  }, [o, ae, Q, _]), G = $e(function() {
    if (U.current) {
      Z({
        type: "openDialog"
      }), k();
      var me = {
        multiple: l,
        types: N
      };
      window.showOpenFilePicker(me).then(function(Ie) {
        return o(Ie);
      }).then(function(Ie) {
        ae(Ie, null), Z({
          type: "closeDialog"
        });
      }).catch(function(Ie) {
        Mq(Ie) ? (j(Ie), Z({
          type: "closeDialog"
        })) : Nq(Ie) ? (U.current = !1, D.current ? (D.current.value = null, D.current.click()) : Q(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : Q(Ie);
      });
      return;
    }
    D.current && (Z({
      type: "openDialog"
    }), k(), D.current.value = null, D.current.click());
  }, [Z, k, j, w, ae, Q, N, l]), oe = $e(function(me) {
    !R.current || !R.current.isEqualNode(me.target) || (me.key === " " || me.key === "Enter" || me.keyCode === 32 || me.keyCode === 13) && (me.preventDefault(), G());
  }, [R, G]), ne = $e(function() {
    Z({
      type: "focus"
    });
  }, []), _e = $e(function() {
    Z({
      type: "blur"
    });
  }, []), ye = $e(function() {
    x || (Eq() ? setTimeout(G, 0) : G());
  }, [x, G]), Te = function(Ie) {
    return n ? null : Ie;
  }, we = function(Ie) {
    return b ? null : Te(Ie);
  }, He = function(Ie) {
    return O ? null : Te(Ie);
  }, he = function(Ie) {
    _ && Ie.stopPropagation();
  }, xe = Je(function() {
    return function() {
      var me = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ie = me.refKey, er = Ie === void 0 ? "ref" : Ie, Ke = me.role, Me = me.onKeyDown, Pe = me.onFocus, Qe = me.onBlur, Sr = me.onClick, Cr = me.onDragEnter, nr = me.onDragOver, De = me.onDragLeave, Ge = me.onDrop, lr = lu(me, jq);
      return kr(kr(M0({
        onKeyDown: we(Qt(Me, oe)),
        onFocus: we(Qt(Pe, ne)),
        onBlur: we(Qt(Qe, _e)),
        onClick: Te(Qt(Sr, ye)),
        onDragEnter: He(Qt(Cr, se)),
        onDragOver: He(Qt(nr, q)),
        onDragLeave: He(Qt(De, te)),
        onDrop: He(Qt(Ge, ge)),
        role: typeof Ke == "string" && Ke !== "" ? Ke : "presentation"
      }, er, R), !n && !b ? {
        tabIndex: 0
      } : {}), lr);
    };
  }, [R, oe, ne, _e, ye, se, q, te, ge, b, O, n]), Le = $e(function(me) {
    me.stopPropagation();
  }, []), Ue = Je(function() {
    return function() {
      var me = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ie = me.refKey, er = Ie === void 0 ? "ref" : Ie, Ke = me.onChange, Me = me.onClick, Pe = lu(me, Lq), Qe = M0({
        accept: I,
        multiple: l,
        type: "file",
        style: {
          display: "none"
        },
        onChange: Te(Qt(Ke, ge)),
        onClick: Te(Qt(Me, Le)),
        tabIndex: -1
      }, er, D);
      return kr(kr({}, Qe), Pe);
    };
  }, [D, t, l, ge, n]);
  return kr(kr({}, L), {}, {
    isFocused: z && !n,
    getRootProps: xe,
    getInputProps: Ue,
    rootRef: R,
    inputRef: D,
    open: Te(G)
  });
}
function Xq(e, r) {
  switch (r.type) {
    case "focus":
      return kr(kr({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return kr(kr({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return kr(kr({}, N0), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return kr(kr({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return kr(kr({}, e), {}, {
        isDragActive: r.isDragActive,
        isDragAccept: r.isDragAccept,
        isDragReject: r.isDragReject
      });
    case "setFiles":
      return kr(kr({}, e), {}, {
        acceptedFiles: r.acceptedFiles,
        fileRejections: r.fileRejections
      });
    case "reset":
      return kr({}, N0);
    default:
      return e;
  }
}
function Qg() {
}
const [Yq, Uq] = no("Dropzone component was not found in tree");
var e9 = Object.getOwnPropertySymbols, Jq = Object.prototype.hasOwnProperty, qq = Object.prototype.propertyIsEnumerable, Kq = (e, r) => {
  var t = {};
  for (var n in e)
    Jq.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && e9)
    for (var n of e9(e))
      r.indexOf(n) < 0 && qq.call(e, n) && (t[n] = e[n]);
  return t;
};
function Yf(e) {
  const r = (t) => {
    const n = Oe(`Dropzone${W2(e)}`, {}, t), { children: o } = n, a = Kq(n, ["children"]), i = Uq(), l = Pa(o) ? o : /* @__PURE__ */ E.createElement("span", null, o);
    return i[e] ? Wr(l, a) : null;
  };
  return r.displayName = `@mantine/dropzone/${W2(e)}`, r;
}
const Qq = Yf("accept"), eK = Yf("reject"), rK = Yf("idle");
var tK = Object.defineProperty, nK = Object.defineProperties, oK = Object.getOwnPropertyDescriptors, r9 = Object.getOwnPropertySymbols, aK = Object.prototype.hasOwnProperty, iK = Object.prototype.propertyIsEnumerable, t9 = (e, r, t) => r in e ? tK(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, n9 = (e, r) => {
  for (var t in r || (r = {}))
    aK.call(r, t) && t9(e, t, r[t]);
  if (r9)
    for (var t of r9(r))
      iK.call(r, t) && t9(e, t, r[t]);
  return e;
}, lK = (e, r) => nK(e, oK(r)), sK = Ae((e, { padding: r, radius: t }) => {
  const n = e.fn.variant({ color: "red", variant: "light" }), o = e.fn.variant({ color: e.primaryColor, variant: "light" });
  return {
    root: lK(n9(n9({}, e.fn.fontStyles()), e.fn.focusStyles()), {
      boxSizing: "border-box",
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.white,
      border: `${B(2)} dashed ${e.colorScheme === "dark" ? e.colors.dark[4] : e.colors.gray[4]}`,
      padding: ve({ size: r, sizes: e.spacing }),
      borderRadius: e.fn.radius(t),
      cursor: "pointer",
      userSelect: "none",
      transition: "background-color 150ms ease",
      position: "relative",
      "&:hover": {
        backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[0]
      },
      "&[data-loading]": {
        cursor: "default",
        "&:hover": {
          backgroundColor: e.colorScheme === "dark" ? e.colors.dark[6] : e.white
        }
      },
      "&[data-accept]": {
        backgroundColor: e.colorScheme === "dark" ? o.background : e.colors[e.primaryColor][0],
        borderColor: e.colorScheme === "dark" ? o.border : e.colors[e.primaryColor][4],
        "&:hover": {
          backgroundColor: e.colorScheme === "dark" ? o.background : e.colors[e.primaryColor][0]
        }
      },
      "&[data-reject]": {
        backgroundColor: e.colorScheme === "dark" ? n.background : e.colors.red[0],
        borderColor: e.colorScheme === "dark" ? n.border : e.colors.red[4],
        "&:hover": {
          backgroundColor: e.colorScheme === "dark" ? n.background : e.colors.red[0]
        }
      }
    }),
    inner: {
      pointerEvents: "none",
      userSelect: "none"
    }
  };
}), cK = Object.defineProperty, uK = Object.defineProperties, dK = Object.getOwnPropertyDescriptors, su = Object.getOwnPropertySymbols, Ww = Object.prototype.hasOwnProperty, Bw = Object.prototype.propertyIsEnumerable, o9 = (e, r, t) => r in e ? cK(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, qa = (e, r) => {
  for (var t in r || (r = {}))
    Ww.call(r, t) && o9(e, t, r[t]);
  if (su)
    for (var t of su(r))
      Bw.call(r, t) && o9(e, t, r[t]);
  return e;
}, kd = (e, r) => uK(e, dK(r)), fK = (e, r) => {
  var t = {};
  for (var n in e)
    Ww.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && su)
    for (var n of su(e))
      r.indexOf(n) < 0 && Bw.call(e, n) && (t[n] = e[n]);
  return t;
};
const pK = {
  padding: "md",
  loading: !1,
  multiple: !0,
  maxSize: 1 / 0,
  autoFocus: !1,
  activateOnClick: !0,
  activateOnDrag: !0,
  dragEventsBubbling: !0,
  activateOnKeyboard: !0,
  useFsAccessApi: !0
};
function ka(e) {
  const r = Oe("Dropzone", pK, e), {
    className: t,
    padding: n,
    radius: o,
    disabled: a,
    classNames: i,
    styles: l,
    loading: s,
    multiple: u,
    maxSize: d,
    accept: f,
    children: p,
    onDropAny: g,
    onDrop: h,
    onReject: v,
    openRef: y,
    name: w,
    unstyled: $,
    maxFiles: C,
    autoFocus: x,
    activateOnClick: b,
    activateOnDrag: O,
    dragEventsBubbling: _,
    activateOnKeyboard: P,
    onDragEnter: S,
    onDragLeave: I,
    onDragOver: N,
    onFileDialogCancel: k,
    onFileDialogOpen: j,
    preventDropOnDocument: R,
    useFsAccessApi: D,
    getFilesFromEvent: T,
    validator: V,
    variant: L
  } = r, Z = fK(r, [
    "className",
    "padding",
    "radius",
    "disabled",
    "classNames",
    "styles",
    "loading",
    "multiple",
    "maxSize",
    "accept",
    "children",
    "onDropAny",
    "onDrop",
    "onReject",
    "openRef",
    "name",
    "unstyled",
    "maxFiles",
    "autoFocus",
    "activateOnClick",
    "activateOnDrag",
    "dragEventsBubbling",
    "activateOnKeyboard",
    "onDragEnter",
    "onDragLeave",
    "onDragOver",
    "onFileDialogCancel",
    "onFileDialogOpen",
    "preventDropOnDocument",
    "useFsAccessApi",
    "getFilesFromEvent",
    "validator",
    "variant"
  ]), { classes: z, cx: W } = sK({ radius: o, padding: n }, { name: "Dropzone", classNames: i, styles: l, unstyled: $, variant: L }), { getRootProps: U, getInputProps: re, isDragAccept: X, isDragReject: J, open: Q } = Zw(qa({
    onDrop: g,
    onDropAccepted: h,
    onDropRejected: v,
    disabled: a || s,
    accept: Array.isArray(f) ? f.reduce((q, te) => kd(qa({}, q), { [te]: [] }), {}) : f,
    multiple: u,
    maxSize: d,
    maxFiles: C,
    autoFocus: x,
    noClick: !b,
    noDrag: !O,
    noDragEventsBubbling: !_,
    noKeyboard: !P,
    onDragEnter: S,
    onDragLeave: I,
    onDragOver: N,
    onFileDialogCancel: k,
    onFileDialogOpen: j,
    preventDropOnDocument: R,
    useFsAccessApi: D,
    validator: V
  }, T ? { getFilesFromEvent: T } : null));
  l8(y, Q);
  const se = !X && !J;
  return /* @__PURE__ */ E.createElement(Yq, {
    value: { accept: X, reject: J, idle: se }
  }, /* @__PURE__ */ E.createElement(We, kd(qa(qa({}, Z), U()), {
    "data-accept": X || void 0,
    "data-reject": J || void 0,
    "data-idle": se || void 0,
    "data-loading": s || void 0,
    className: W(z.root, t)
  }), /* @__PURE__ */ E.createElement(Ty, {
    visible: s,
    radius: o,
    unstyled: $
  }), /* @__PURE__ */ E.createElement("input", kd(qa({}, re()), {
    name: w
  })), /* @__PURE__ */ E.createElement("div", {
    className: z.inner
  }, p)));
}
ka.displayName = "@mantine/dropzone/Dropzone";
ka.Accept = Qq;
ka.Reject = eK;
ka.Idle = rK;
const Hw = ka;
var gK = Object.defineProperty, vK = Object.defineProperties, mK = Object.getOwnPropertyDescriptors, a9 = Object.getOwnPropertySymbols, hK = Object.prototype.hasOwnProperty, bK = Object.prototype.propertyIsEnumerable, i9 = (e, r, t) => r in e ? gK(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, yK = (e, r) => {
  for (var t in r || (r = {}))
    hK.call(r, t) && i9(e, t, r[t]);
  if (a9)
    for (var t of a9(r))
      bK.call(r, t) && i9(e, t, r[t]);
  return e;
}, CK = (e, r) => vK(e, mK(r)), wK = Ae((e) => ({
  wrapper: CK(yK({}, e.fn.cover(0)), {
    position: "fixed",
    backgroundColor: e.colorScheme === "dark" ? e.colors.dark[7] : e.white,
    display: "flex",
    padding: e.spacing.xs,
    transition: "opacity 100ms ease"
  }),
  dropzone: {
    flex: 1
  }
})), _K = Object.defineProperty, xK = Object.defineProperties, $K = Object.getOwnPropertyDescriptors, cu = Object.getOwnPropertySymbols, Gw = Object.prototype.hasOwnProperty, Xw = Object.prototype.propertyIsEnumerable, l9 = (e, r, t) => r in e ? _K(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Md = (e, r) => {
  for (var t in r || (r = {}))
    Gw.call(r, t) && l9(e, t, r[t]);
  if (cu)
    for (var t of cu(r))
      Xw.call(r, t) && l9(e, t, r[t]);
  return e;
}, Nd = (e, r) => xK(e, $K(r)), OK = (e, r) => {
  var t = {};
  for (var n in e)
    Gw.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && cu)
    for (var n of cu(e))
      r.indexOf(n) < 0 && Xw.call(e, n) && (t[n] = e[n]);
  return t;
};
const PK = {
  padding: "md",
  loading: !1,
  multiple: !0,
  maxSize: 1 / 0,
  autoFocus: !1,
  activateOnClick: !0,
  activateOnDrag: !0,
  dragEventsBubbling: !0,
  activateOnKeyboard: !0,
  active: !0,
  zIndex: In("max"),
  withinPortal: !0
};
function Yw(e) {
  const r = Oe("DropzoneFullScreen", PK, e), {
    classNames: t,
    styles: n,
    sx: o,
    className: a,
    style: i,
    unstyled: l,
    active: s,
    onDrop: u,
    onReject: d,
    zIndex: f,
    withinPortal: p,
    portalProps: g
  } = r, h = OK(r, [
    "classNames",
    "styles",
    "sx",
    "className",
    "style",
    "unstyled",
    "active",
    "onDrop",
    "onReject",
    "zIndex",
    "withinPortal",
    "portalProps"
  ]), [v, y] = E.useState(0), [w, { open: $, close: C }] = H0(!1), { classes: x, cx: b } = wK(null, {
    name: "DropzoneFullScreen",
    classNames: t,
    styles: n,
    unstyled: l
  }), O = (P) => {
    P.dataTransfer.types.includes("Files") && (y((S) => S + 1), $());
  }, _ = () => {
    y((P) => P - 1);
  };
  return Fe(() => {
    v === 0 && C();
  }, [v]), Fe(() => {
    if (s)
      return document.addEventListener("dragenter", O, !1), document.addEventListener("dragleave", _, !1), () => {
        document.removeEventListener("dragenter", O, !1), document.removeEventListener("dragleave", _, !1);
      };
  }, [s]), /* @__PURE__ */ E.createElement(Sa, Nd(Md({}, g), {
    withinPortal: p
  }), /* @__PURE__ */ E.createElement(We, {
    className: b(x.wrapper, a),
    sx: o,
    style: Nd(Md({}, i), {
      opacity: w ? 1 : 0,
      pointerEvents: w ? "all" : "none",
      zIndex: f
    })
  }, /* @__PURE__ */ E.createElement(ka, Nd(Md({}, h), {
    classNames: t,
    styles: n,
    unstyled: l,
    className: x.dropzone,
    onDrop: (P) => {
      u == null || u(P), C();
    },
    onReject: (P) => {
      d == null || d(P), C();
    }
  }))));
}
Yw.displayName = "@mantine/dropzone/DropzoneFullScreen";
const at = {
  png: "image/png",
  gif: "image/gif",
  jpeg: "image/jpeg",
  svg: "image/svg+xml",
  webp: "image/webp",
  avif: "image/avif",
  mp4: "video/mp4",
  zip: "application/zip",
  csv: "text/csv",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  exe: "application/vnd.microsoft.portable-executable"
}, b5e = [
  at.png,
  at.gif,
  at.jpeg,
  at.svg,
  at.webp,
  at.avif
], y5e = [at.pdf], C5e = [at.doc, at.docx], w5e = [at.xls, at.xlsx], _5e = [at.ppt, at.pptx];
at.exe;
Hw.FullScreen = Yw;
const SK = Hw;
function IK(e) {
  return yr("MuiSvgIcon", e);
}
wr("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const EK = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], RK = (e) => {
  const {
    color: r,
    fontSize: t,
    classes: n
  } = e, o = {
    root: ["root", r !== "inherit" && `color${ze(r)}`, `fontSize${ze(t)}`]
  };
  return _r(o, IK, n);
}, AK = Be("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, t.color !== "inherit" && r[`color${ze(t.color)}`], r[`fontSize${ze(t.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: r
}) => {
  var t, n, o, a, i, l, s, u, d, f, p, g, h;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: r.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (t = e.transitions) == null || (n = t.create) == null ? void 0 : n.call(t, "fill", {
      duration: (o = e.transitions) == null || (o = o.duration) == null ? void 0 : o.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((a = e.typography) == null || (i = a.pxToRem) == null ? void 0 : i.call(a, 20)) || "1.25rem",
      medium: ((l = e.typography) == null || (s = l.pxToRem) == null ? void 0 : s.call(l, 24)) || "1.5rem",
      large: ((u = e.typography) == null || (d = u.pxToRem) == null ? void 0 : d.call(u, 35)) || "2.1875rem"
    }[r.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (f = (p = (e.vars || e).palette) == null || (p = p[r.color]) == null ? void 0 : p.main) != null ? f : {
      action: (g = (e.vars || e).palette) == null || (g = g.action) == null ? void 0 : g.active,
      disabled: (h = (e.vars || e).palette) == null || (h = h.action) == null ? void 0 : h.disabled,
      inherit: void 0
    }[r.color]
  };
}), uu = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: a,
    color: i = "inherit",
    component: l = "svg",
    fontSize: s = "medium",
    htmlColor: u,
    inheritViewBox: d = !1,
    titleAccess: f,
    viewBox: p = "0 0 24 24"
  } = n, g = Xe(n, EK), h = /* @__PURE__ */ A.isValidElement(o) && o.type === "svg", v = F({}, n, {
    color: i,
    component: l,
    fontSize: s,
    instanceFontSize: r.fontSize,
    inheritViewBox: d,
    viewBox: p,
    hasSvgAsChild: h
  }), y = {};
  d || (y.viewBox = p);
  const w = RK(v);
  return /* @__PURE__ */ le.jsxs(AK, F({
    as: l,
    className: qe(w.root, a),
    focusable: "false",
    color: u,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: t
  }, y, g, h && o.props, {
    ownerState: v,
    children: [h ? o.props.children : o, f ? /* @__PURE__ */ le.jsx("title", {
      children: f
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (uu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: c.oneOfType([c.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: c.oneOfType([c.oneOf(["inherit", "large", "medium", "small"]), c.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: c.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: c.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: c.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: c.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: c.string
});
uu.muiName = "SvgIcon";
function zo(e, r) {
  function t(n, o) {
    return /* @__PURE__ */ le.jsx(uu, F({
      "data-testid": `${r}Icon`,
      ref: o
    }, n, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (t.displayName = `${r}Icon`), t.muiName = uu.muiName, /* @__PURE__ */ A.memo(/* @__PURE__ */ A.forwardRef(t));
}
function kK(e) {
  return xr;
}
function T0(e, r) {
  return T0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, T0(e, r);
}
function Uw(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, T0(e, r);
}
const s9 = {
  disabled: !1
};
var MK = process.env.NODE_ENV !== "production" ? c.oneOfType([c.number, c.shape({
  enter: c.number,
  exit: c.number,
  appear: c.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && c.oneOfType([c.string, c.shape({
  enter: c.string,
  exit: c.string,
  active: c.string
}), c.shape({
  enter: c.string,
  enterDone: c.string,
  enterActive: c.string,
  exit: c.string,
  exitDone: c.string,
  exitActive: c.string
})]);
const du = E.createContext(null);
var NK = function(r) {
  return r.scrollTop;
}, oi = "unmounted", bo = "exited", yo = "entering", ta = "entered", D0 = "exiting", Mn = /* @__PURE__ */ function(e) {
  Uw(r, e);
  function r(n, o) {
    var a;
    a = e.call(this, n, o) || this;
    var i = o, l = i && !i.isMounting ? n.enter : n.appear, s;
    return a.appearStatus = null, n.in ? l ? (s = bo, a.appearStatus = yo) : s = ta : n.unmountOnExit || n.mountOnEnter ? s = oi : s = bo, a.state = {
      status: s
    }, a.nextCallback = null, a;
  }
  r.getDerivedStateFromProps = function(o, a) {
    var i = o.in;
    return i && a.status === oi ? {
      status: bo
    } : null;
  };
  var t = r.prototype;
  return t.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, t.componentDidUpdate = function(o) {
    var a = null;
    if (o !== this.props) {
      var i = this.state.status;
      this.props.in ? i !== yo && i !== ta && (a = yo) : (i === yo || i === ta) && (a = D0);
    }
    this.updateStatus(!1, a);
  }, t.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, t.getTimeouts = function() {
    var o = this.props.timeout, a, i, l;
    return a = i = l = o, o != null && typeof o != "number" && (a = o.exit, i = o.enter, l = o.appear !== void 0 ? o.appear : i), {
      exit: a,
      enter: i,
      appear: l
    };
  }, t.updateStatus = function(o, a) {
    if (o === void 0 && (o = !1), a !== null)
      if (this.cancelNextCallback(), a === yo) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var i = this.props.nodeRef ? this.props.nodeRef.current : ni.findDOMNode(this);
          i && NK(i);
        }
        this.performEnter(o);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === bo && this.setState({
        status: oi
      });
  }, t.performEnter = function(o) {
    var a = this, i = this.props.enter, l = this.context ? this.context.isMounting : o, s = this.props.nodeRef ? [l] : [ni.findDOMNode(this), l], u = s[0], d = s[1], f = this.getTimeouts(), p = l ? f.appear : f.enter;
    if (!o && !i || s9.disabled) {
      this.safeSetState({
        status: ta
      }, function() {
        a.props.onEntered(u);
      });
      return;
    }
    this.props.onEnter(u, d), this.safeSetState({
      status: yo
    }, function() {
      a.props.onEntering(u, d), a.onTransitionEnd(p, function() {
        a.safeSetState({
          status: ta
        }, function() {
          a.props.onEntered(u, d);
        });
      });
    });
  }, t.performExit = function() {
    var o = this, a = this.props.exit, i = this.getTimeouts(), l = this.props.nodeRef ? void 0 : ni.findDOMNode(this);
    if (!a || s9.disabled) {
      this.safeSetState({
        status: bo
      }, function() {
        o.props.onExited(l);
      });
      return;
    }
    this.props.onExit(l), this.safeSetState({
      status: D0
    }, function() {
      o.props.onExiting(l), o.onTransitionEnd(i.exit, function() {
        o.safeSetState({
          status: bo
        }, function() {
          o.props.onExited(l);
        });
      });
    });
  }, t.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, t.safeSetState = function(o, a) {
    a = this.setNextCallback(a), this.setState(o, a);
  }, t.setNextCallback = function(o) {
    var a = this, i = !0;
    return this.nextCallback = function(l) {
      i && (i = !1, a.nextCallback = null, o(l));
    }, this.nextCallback.cancel = function() {
      i = !1;
    }, this.nextCallback;
  }, t.onTransitionEnd = function(o, a) {
    this.setNextCallback(a);
    var i = this.props.nodeRef ? this.props.nodeRef.current : ni.findDOMNode(this), l = o == null && !this.props.addEndListener;
    if (!i || l) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var s = this.props.nodeRef ? [this.nextCallback] : [i, this.nextCallback], u = s[0], d = s[1];
      this.props.addEndListener(u, d);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, t.render = function() {
    var o = this.state.status;
    if (o === oi)
      return null;
    var a = this.props, i = a.children;
    a.in, a.mountOnEnter, a.unmountOnExit, a.appear, a.enter, a.exit, a.timeout, a.addEndListener, a.onEnter, a.onEntering, a.onEntered, a.onExit, a.onExiting, a.onExited, a.nodeRef;
    var l = Xe(a, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ E.createElement(du.Provider, {
        value: null
      }, typeof i == "function" ? i(o, l) : E.cloneElement(E.Children.only(i), l))
    );
  }, r;
}(E.Component);
Mn.contextType = du;
Mn.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: c.shape({
    current: typeof Element == "undefined" ? c.any : function(e, r, t, n, o, a) {
      var i = e[r];
      return c.instanceOf(i && "ownerDocument" in i ? i.ownerDocument.defaultView.Element : Element)(e, r, t, n, o, a);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: c.oneOfType([c.func.isRequired, c.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: c.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: c.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: c.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: c.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: c.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: c.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(r) {
    var t = MK;
    r.addEndListener || (t = t.isRequired);
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      o[a - 1] = arguments[a];
    return t.apply(void 0, [r].concat(o));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: c.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: c.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: c.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: c.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: c.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: c.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: c.func
} : {};
function Ko() {
}
Mn.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Ko,
  onEntering: Ko,
  onEntered: Ko,
  onExit: Ko,
  onExiting: Ko,
  onExited: Ko
};
Mn.UNMOUNTED = oi;
Mn.EXITED = bo;
Mn.ENTERING = yo;
Mn.ENTERED = ta;
Mn.EXITING = D0;
const Jw = Mn;
function TK(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Uf(e, r) {
  var t = function(a) {
    return r && Xn(a) ? r(a) : a;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && Gr.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    n[o.key] = t(o);
  }), n;
}
function DK(e, r) {
  e = e || {}, r = r || {};
  function t(d) {
    return d in r ? r[d] : e[d];
  }
  var n = /* @__PURE__ */ Object.create(null), o = [];
  for (var a in e)
    a in r ? o.length && (n[a] = o, o = []) : o.push(a);
  var i, l = {};
  for (var s in r) {
    if (n[s])
      for (i = 0; i < n[s].length; i++) {
        var u = n[s][i];
        l[n[s][i]] = t(u);
      }
    l[s] = t(s);
  }
  for (i = 0; i < o.length; i++)
    l[o[i]] = t(o[i]);
  return l;
}
function xo(e, r, t) {
  return t[r] != null ? t[r] : e.props[r];
}
function jK(e, r) {
  return Uf(e.children, function(t) {
    return Wr(t, {
      onExited: r.bind(null, t),
      in: !0,
      appear: xo(t, "appear", e),
      enter: xo(t, "enter", e),
      exit: xo(t, "exit", e)
    });
  });
}
function LK(e, r, t) {
  var n = Uf(e.children), o = DK(r, n);
  return Object.keys(o).forEach(function(a) {
    var i = o[a];
    if (Xn(i)) {
      var l = a in r, s = a in n, u = r[a], d = Xn(u) && !u.props.in;
      s && (!l || d) ? o[a] = Wr(i, {
        onExited: t.bind(null, i),
        in: !0,
        exit: xo(i, "exit", e),
        enter: xo(i, "enter", e)
      }) : !s && l && !d ? o[a] = Wr(i, {
        in: !1
      }) : s && l && Xn(u) && (o[a] = Wr(i, {
        onExited: t.bind(null, i),
        in: u.props.in,
        exit: xo(i, "exit", e),
        enter: xo(i, "enter", e)
      }));
    }
  }), o;
}
var zK = Object.values || function(e) {
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}, VK = {
  component: "div",
  childFactory: function(r) {
    return r;
  }
}, Jf = /* @__PURE__ */ function(e) {
  Uw(r, e);
  function r(n, o) {
    var a;
    a = e.call(this, n, o) || this;
    var i = a.handleExited.bind(TK(a));
    return a.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: i,
      firstRender: !0
    }, a;
  }
  var t = r.prototype;
  return t.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, t.componentWillUnmount = function() {
    this.mounted = !1;
  }, r.getDerivedStateFromProps = function(o, a) {
    var i = a.children, l = a.handleExited, s = a.firstRender;
    return {
      children: s ? jK(o, l) : LK(o, i, l),
      firstRender: !1
    };
  }, t.handleExited = function(o, a) {
    var i = Uf(this.props.children);
    o.key in i || (o.props.onExited && o.props.onExited(a), this.mounted && this.setState(function(l) {
      var s = F({}, l.children);
      return delete s[o.key], {
        children: s
      };
    }));
  }, t.render = function() {
    var o = this.props, a = o.component, i = o.childFactory, l = Xe(o, ["component", "childFactory"]), s = this.state.contextValue, u = zK(this.state.children).map(i);
    return delete l.appear, delete l.enter, delete l.exit, a === null ? /* @__PURE__ */ E.createElement(du.Provider, {
      value: s
    }, u) : /* @__PURE__ */ E.createElement(du.Provider, {
      value: s
    }, /* @__PURE__ */ E.createElement(a, l, u));
  }, r;
}(E.Component);
Jf.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: c.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: c.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: c.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: c.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: c.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: c.func
} : {};
Jf.defaultProps = VK;
const FK = Jf, qw = (e) => e.scrollTop;
function fu(e, r) {
  var t, n;
  const {
    timeout: o,
    easing: a,
    style: i = {}
  } = e;
  return {
    duration: (t = i.transitionDuration) != null ? t : typeof o == "number" ? o : o[r.mode] || 0,
    easing: (n = i.transitionTimingFunction) != null ? n : typeof a == "object" ? a[r.mode] : a,
    delay: i.transitionDelay
  };
}
function ZK(e) {
  return yr("MuiPaper", e);
}
wr("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const WK = ["className", "component", "elevation", "square", "variant"], BK = (e) => {
  const {
    square: r,
    elevation: t,
    variant: n,
    classes: o
  } = e, a = {
    root: ["root", n, !r && "rounded", n === "elevation" && `elevation${t}`]
  };
  return _r(a, ZK, o);
}, HK = Be("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, r[t.variant], !t.square && r.rounded, t.variant === "elevation" && r[`elevation${t.elevation}`]];
  }
})(({
  theme: e,
  ownerState: r
}) => {
  var t;
  return F({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !r.square && {
    borderRadius: e.shape.borderRadius
  }, r.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, r.variant === "elevation" && F({
    boxShadow: (e.vars || e).shadows[r.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${Mr("#fff", Jp(r.elevation))}, ${Mr("#fff", Jp(r.elevation))})`
  }, e.vars && {
    backgroundImage: (t = e.vars.overlays) == null ? void 0 : t[r.elevation]
  }));
}), Kw = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiPaper"
  }), {
    className: o,
    component: a = "div",
    elevation: i = 1,
    square: l = !1,
    variant: s = "elevation"
  } = n, u = Xe(n, WK), d = F({}, n, {
    component: a,
    elevation: i,
    square: l,
    variant: s
  }), f = BK(d);
  return process.env.NODE_ENV !== "production" && vf().shadows[i] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${i}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${i}]\` is defined.`].join(`
`)), /* @__PURE__ */ le.jsx(HK, F({
    as: a,
    ownerState: d,
    className: qe(f.root, o),
    ref: t
  }, u));
});
process.env.NODE_ENV !== "production" && (Kw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: xn(Wn, (e) => {
    const {
      elevation: r,
      variant: t
    } = e;
    return r > 0 && t === "outlined" ? new Error(`MUI: Combining \`elevation={${r}}\` with \`variant="${t}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: c.oneOfType([c.oneOf(["elevation", "outlined"]), c.string])
});
const qf = Kw;
function pu(e) {
  return typeof e == "string";
}
function GK(e, r, t) {
  return e === void 0 || pu(e) ? r : F({}, r, {
    ownerState: F({}, r.ownerState, t)
  });
}
const XK = {
  disableDefaultClasses: !1
}, Qw = /* @__PURE__ */ A.createContext(XK);
process.env.NODE_ENV !== "production" && (Qw.displayName = "ClassNameConfiguratorContext");
function YK(e) {
  const {
    disableDefaultClasses: r
  } = A.useContext(Qw);
  return (t) => r ? "" : e(t);
}
function e_(e, r = []) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => n.match(/^on[A-Z]/) && typeof e[n] == "function" && !r.includes(n)).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function UK(e, r, t) {
  return typeof e == "function" ? e(r, t) : e;
}
function c9(e) {
  if (e === void 0)
    return {};
  const r = {};
  return Object.keys(e).filter((t) => !(t.match(/^on[A-Z]/) && typeof e[t] == "function")).forEach((t) => {
    r[t] = e[t];
  }), r;
}
function JK(e) {
  const {
    getSlotProps: r,
    additionalProps: t,
    externalSlotProps: n,
    externalForwardedProps: o,
    className: a
  } = e;
  if (!r) {
    const g = qe(t == null ? void 0 : t.className, a, o == null ? void 0 : o.className, n == null ? void 0 : n.className), h = F({}, t == null ? void 0 : t.style, o == null ? void 0 : o.style, n == null ? void 0 : n.style), v = F({}, t, o, n);
    return g.length > 0 && (v.className = g), Object.keys(h).length > 0 && (v.style = h), {
      props: v,
      internalRef: void 0
    };
  }
  const i = e_(F({}, o, n)), l = c9(n), s = c9(o), u = r(i), d = qe(u == null ? void 0 : u.className, t == null ? void 0 : t.className, a, o == null ? void 0 : o.className, n == null ? void 0 : n.className), f = F({}, u == null ? void 0 : u.style, t == null ? void 0 : t.style, o == null ? void 0 : o.style, n == null ? void 0 : n.style), p = F({}, u, t, s, l);
  return d.length > 0 && (p.className = d), Object.keys(f).length > 0 && (p.style = f), {
    props: p,
    internalRef: u.ref
  };
}
const qK = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Ao(e) {
  var r;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: o,
    skipResolvingSlotProps: a = !1
  } = e, i = Xe(e, qK), l = a ? {} : UK(n, o), {
    props: s,
    internalRef: u
  } = JK(F({}, i, {
    externalSlotProps: l
  })), d = Xr(u, l == null ? void 0 : l.ref, (r = e.additionalProps) == null ? void 0 : r.ref);
  return GK(t, F({}, s, {
    ref: d
  }), o);
}
function r_(e) {
  const {
    className: r,
    classes: t,
    pulsate: n = !1,
    rippleX: o,
    rippleY: a,
    rippleSize: i,
    in: l,
    onExited: s,
    timeout: u
  } = e, [d, f] = A.useState(!1), p = qe(r, t.ripple, t.rippleVisible, n && t.ripplePulsate), g = {
    width: i,
    height: i,
    top: -(i / 2) + a,
    left: -(i / 2) + o
  }, h = qe(t.child, d && t.childLeaving, n && t.childPulsate);
  return !l && !d && f(!0), A.useEffect(() => {
    if (!l && s != null) {
      const v = setTimeout(s, u);
      return () => {
        clearTimeout(v);
      };
    }
  }, [s, l, u]), /* @__PURE__ */ le.jsx("span", {
    className: p,
    style: g,
    children: /* @__PURE__ */ le.jsx("span", {
      className: h
    })
  });
}
process.env.NODE_ENV !== "production" && (r_.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object.isRequired,
  className: c.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: c.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: c.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: c.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: c.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: c.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: c.number,
  /**
   * exit delay
   */
  timeout: c.number.isRequired
});
const At = wr("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), KK = ["center", "classes", "className"];
let $1 = (e) => e, u9, d9, f9, p9;
const j0 = 550, QK = 80, eQ = ro(u9 || (u9 = $1`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), rQ = ro(d9 || (d9 = $1`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), tQ = ro(f9 || (f9 = $1`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), nQ = Be("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), oQ = Be(r_, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(p9 || (p9 = $1`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), At.rippleVisible, eQ, j0, ({
  theme: e
}) => e.transitions.easing.easeInOut, At.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, At.child, At.childLeaving, rQ, j0, ({
  theme: e
}) => e.transitions.easing.easeInOut, At.childPulsate, tQ, ({
  theme: e
}) => e.transitions.easing.easeInOut), t_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: a = {},
    className: i
  } = n, l = Xe(n, KK), [s, u] = A.useState([]), d = A.useRef(0), f = A.useRef(null);
  A.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [s]);
  const p = A.useRef(!1), g = o6(), h = A.useRef(null), v = A.useRef(null), y = A.useCallback((x) => {
    const {
      pulsate: b,
      rippleX: O,
      rippleY: _,
      rippleSize: P,
      cb: S
    } = x;
    u((I) => [...I, /* @__PURE__ */ le.jsx(oQ, {
      classes: {
        ripple: qe(a.ripple, At.ripple),
        rippleVisible: qe(a.rippleVisible, At.rippleVisible),
        ripplePulsate: qe(a.ripplePulsate, At.ripplePulsate),
        child: qe(a.child, At.child),
        childLeaving: qe(a.childLeaving, At.childLeaving),
        childPulsate: qe(a.childPulsate, At.childPulsate)
      },
      timeout: j0,
      pulsate: b,
      rippleX: O,
      rippleY: _,
      rippleSize: P
    }, d.current)]), d.current += 1, f.current = S;
  }, [a]), w = A.useCallback((x = {}, b = {}, O = () => {
  }) => {
    const {
      pulsate: _ = !1,
      center: P = o || b.pulsate,
      fakeElement: S = !1
      // For test purposes
    } = b;
    if ((x == null ? void 0 : x.type) === "mousedown" && p.current) {
      p.current = !1;
      return;
    }
    (x == null ? void 0 : x.type) === "touchstart" && (p.current = !0);
    const I = S ? null : v.current, N = I ? I.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let k, j, R;
    if (P || x === void 0 || x.clientX === 0 && x.clientY === 0 || !x.clientX && !x.touches)
      k = Math.round(N.width / 2), j = Math.round(N.height / 2);
    else {
      const {
        clientX: D,
        clientY: T
      } = x.touches && x.touches.length > 0 ? x.touches[0] : x;
      k = Math.round(D - N.left), j = Math.round(T - N.top);
    }
    if (P)
      R = Math.sqrt((2 * N.width ** 2 + N.height ** 2) / 3), R % 2 === 0 && (R += 1);
    else {
      const D = Math.max(Math.abs((I ? I.clientWidth : 0) - k), k) * 2 + 2, T = Math.max(Math.abs((I ? I.clientHeight : 0) - j), j) * 2 + 2;
      R = Math.sqrt(D ** 2 + T ** 2);
    }
    x != null && x.touches ? h.current === null && (h.current = () => {
      y({
        pulsate: _,
        rippleX: k,
        rippleY: j,
        rippleSize: R,
        cb: O
      });
    }, g.start(QK, () => {
      h.current && (h.current(), h.current = null);
    })) : y({
      pulsate: _,
      rippleX: k,
      rippleY: j,
      rippleSize: R,
      cb: O
    });
  }, [o, y, g]), $ = A.useCallback(() => {
    w({}, {
      pulsate: !0
    });
  }, [w]), C = A.useCallback((x, b) => {
    if (g.clear(), (x == null ? void 0 : x.type) === "touchend" && h.current) {
      h.current(), h.current = null, g.start(0, () => {
        C(x, b);
      });
      return;
    }
    h.current = null, u((O) => O.length > 0 ? O.slice(1) : O), f.current = b;
  }, [g]);
  return A.useImperativeHandle(t, () => ({
    pulsate: $,
    start: w,
    stop: C
  }), [$, w, C]), /* @__PURE__ */ le.jsx(nQ, F({
    className: qe(At.root, a.root, i),
    ref: v
  }, l, {
    children: /* @__PURE__ */ le.jsx(FK, {
      component: null,
      exit: !0,
      children: s
    })
  }));
});
process.env.NODE_ENV !== "production" && (t_.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string
});
const aQ = t_;
function iQ(e) {
  return yr("MuiButtonBase", e);
}
const lQ = wr("MuiButtonBase", ["root", "disabled", "focusVisible"]), sQ = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], cQ = (e) => {
  const {
    disabled: r,
    focusVisible: t,
    focusVisibleClassName: n,
    classes: o
  } = e, i = _r({
    root: ["root", r && "disabled", t && "focusVisible"]
  }, iQ, o);
  return t && n && (i.root += ` ${n}`), i;
}, uQ = Be("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, r) => r.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${lQ.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), n_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: a = !1,
    children: i,
    className: l,
    component: s = "button",
    disabled: u = !1,
    disableRipple: d = !1,
    disableTouchRipple: f = !1,
    focusRipple: p = !1,
    LinkComponent: g = "a",
    onBlur: h,
    onClick: v,
    onContextMenu: y,
    onDragLeave: w,
    onFocus: $,
    onFocusVisible: C,
    onKeyDown: x,
    onKeyUp: b,
    onMouseDown: O,
    onMouseLeave: _,
    onMouseUp: P,
    onTouchEnd: S,
    onTouchMove: I,
    onTouchStart: N,
    tabIndex: k = 0,
    TouchRippleProps: j,
    touchRippleRef: R,
    type: D
  } = n, T = Xe(n, sQ), V = A.useRef(null), L = A.useRef(null), Z = Xr(L, R), {
    isFocusVisibleRef: z,
    onFocus: W,
    onBlur: U,
    ref: re
  } = XE(), [X, J] = A.useState(!1);
  u && X && J(!1), A.useImperativeHandle(o, () => ({
    focusVisible: () => {
      J(!0), V.current.focus();
    }
  }), []);
  const [Q, se] = A.useState(!1);
  A.useEffect(() => {
    se(!0);
  }, []);
  const q = Q && !d && !u;
  A.useEffect(() => {
    X && p && !d && Q && L.current.pulsate();
  }, [d, p, X, Q]);
  function te(Pe, Qe, Sr = f) {
    return on((Cr) => (Qe && Qe(Cr), !Sr && L.current && L.current[Pe](Cr), !0));
  }
  const ae = te("start", O), ge = te("stop", y), G = te("stop", w), oe = te("stop", P), ne = te("stop", (Pe) => {
    X && Pe.preventDefault(), _ && _(Pe);
  }), _e = te("start", N), ye = te("stop", S), Te = te("stop", I), we = te("stop", (Pe) => {
    U(Pe), z.current === !1 && J(!1), h && h(Pe);
  }, !1), He = on((Pe) => {
    V.current || (V.current = Pe.currentTarget), W(Pe), z.current === !0 && (J(!0), C && C(Pe)), $ && $(Pe);
  }), he = () => {
    const Pe = V.current;
    return s && s !== "button" && !(Pe.tagName === "A" && Pe.href);
  }, xe = A.useRef(!1), Le = on((Pe) => {
    p && !xe.current && X && L.current && Pe.key === " " && (xe.current = !0, L.current.stop(Pe, () => {
      L.current.start(Pe);
    })), Pe.target === Pe.currentTarget && he() && Pe.key === " " && Pe.preventDefault(), x && x(Pe), Pe.target === Pe.currentTarget && he() && Pe.key === "Enter" && !u && (Pe.preventDefault(), v && v(Pe));
  }), Ue = on((Pe) => {
    p && Pe.key === " " && L.current && X && !Pe.defaultPrevented && (xe.current = !1, L.current.stop(Pe, () => {
      L.current.pulsate(Pe);
    })), b && b(Pe), v && Pe.target === Pe.currentTarget && he() && Pe.key === " " && !Pe.defaultPrevented && v(Pe);
  });
  let me = s;
  me === "button" && (T.href || T.to) && (me = g);
  const Ie = {};
  me === "button" ? (Ie.type = D === void 0 ? "button" : D, Ie.disabled = u) : (!T.href && !T.to && (Ie.role = "button"), u && (Ie["aria-disabled"] = u));
  const er = Xr(t, re, V);
  process.env.NODE_ENV !== "production" && A.useEffect(() => {
    q && !L.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [q]);
  const Ke = F({}, n, {
    centerRipple: a,
    component: s,
    disabled: u,
    disableRipple: d,
    disableTouchRipple: f,
    focusRipple: p,
    tabIndex: k,
    focusVisible: X
  }), Me = cQ(Ke);
  return /* @__PURE__ */ le.jsxs(uQ, F({
    as: me,
    className: qe(Me.root, l),
    ownerState: Ke,
    onBlur: we,
    onClick: v,
    onContextMenu: ge,
    onFocus: He,
    onKeyDown: Le,
    onKeyUp: Ue,
    onMouseDown: ae,
    onMouseLeave: ne,
    onMouseUp: oe,
    onDragLeave: G,
    onTouchEnd: ye,
    onTouchMove: Te,
    onTouchStart: _e,
    ref: er,
    tabIndex: u ? -1 : k,
    type: D
  }, Ie, T, {
    children: [i, q ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ le.jsx(aQ, F({
        ref: Z,
        center: a
      }, j))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (n_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: qt,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: c.bool,
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: uf,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: c.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: c.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: c.string,
  /**
   * @ignore
   */
  href: c.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: c.elementType,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * @ignore
   */
  onContextMenu: c.func,
  /**
   * @ignore
   */
  onDragLeave: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * @ignore
   */
  onKeyUp: c.func,
  /**
   * @ignore
   */
  onMouseDown: c.func,
  /**
   * @ignore
   */
  onMouseLeave: c.func,
  /**
   * @ignore
   */
  onMouseUp: c.func,
  /**
   * @ignore
   */
  onTouchEnd: c.func,
  /**
   * @ignore
   */
  onTouchMove: c.func,
  /**
   * @ignore
   */
  onTouchStart: c.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * @default 0
   */
  tabIndex: c.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: c.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: c.oneOfType([c.func, c.shape({
    current: c.shape({
      pulsate: c.func.isRequired,
      start: c.func.isRequired,
      stop: c.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: c.oneOfType([c.oneOf(["button", "reset", "submit"]), c.string])
});
const gu = n_;
function dQ(e) {
  return yr("MuiIconButton", e);
}
const fQ = wr("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), pQ = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], gQ = (e) => {
  const {
    classes: r,
    disabled: t,
    color: n,
    edge: o,
    size: a
  } = e, i = {
    root: ["root", t && "disabled", n !== "default" && `color${ze(n)}`, o && `edge${ze(o)}`, `size${ze(a)}`]
  };
  return _r(i, dQ, r);
}, vQ = Be(gu, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, t.color !== "default" && r[`color${ze(t.color)}`], t.edge && r[`edge${ze(t.edge)}`], r[`size${ze(t.size)}`]];
  }
})(({
  theme: e,
  ownerState: r
}) => F({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !r.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Mr(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, r.edge === "start" && {
  marginLeft: r.size === "small" ? -3 : -12
}, r.edge === "end" && {
  marginRight: r.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: r
}) => {
  var t;
  const n = (t = (e.vars || e).palette) == null ? void 0 : t[r.color];
  return F({}, r.color === "inherit" && {
    color: "inherit"
  }, r.color !== "inherit" && r.color !== "default" && F({
    color: n == null ? void 0 : n.main
  }, !r.disableRipple && {
    "&:hover": F({}, n && {
      backgroundColor: e.vars ? `rgba(${n.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mr(n.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), r.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, r.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${fQ.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), o_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiIconButton"
  }), {
    edge: o = !1,
    children: a,
    className: i,
    color: l = "default",
    disabled: s = !1,
    disableFocusRipple: u = !1,
    size: d = "medium"
  } = n, f = Xe(n, pQ), p = F({}, n, {
    edge: o,
    color: l,
    disabled: s,
    disableFocusRipple: u,
    size: d
  }), g = gQ(p);
  return /* @__PURE__ */ le.jsx(vQ, F({
    className: qe(g.root, i),
    centerRipple: !0,
    focusRipple: !u,
    disabled: s,
    ref: t
  }, f, {
    ownerState: p,
    children: a
  }));
});
process.env.NODE_ENV !== "production" && (o_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: xn(c.node, (e) => A.Children.toArray(e.children).some((t) => /* @__PURE__ */ A.isValidElement(t) && t.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: c.oneOfType([c.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: c.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: c.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: c.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium", "large"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const a_ = o_, mQ = zo(/* @__PURE__ */ le.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
function hQ(e) {
  return yr("MuiTypography", e);
}
wr("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const bQ = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], yQ = (e) => {
  const {
    align: r,
    gutterBottom: t,
    noWrap: n,
    paragraph: o,
    variant: a,
    classes: i
  } = e, l = {
    root: ["root", a, e.align !== "inherit" && `align${ze(r)}`, t && "gutterBottom", n && "noWrap", o && "paragraph"]
  };
  return _r(l, hQ, i);
}, CQ = Be("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, t.variant && r[t.variant], t.align !== "inherit" && r[`align${ze(t.align)}`], t.noWrap && r.noWrap, t.gutterBottom && r.gutterBottom, t.paragraph && r.paragraph];
  }
})(({
  theme: e,
  ownerState: r
}) => F({
  margin: 0
}, r.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, r.variant !== "inherit" && e.typography[r.variant], r.align !== "inherit" && {
  textAlign: r.align
}, r.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, r.gutterBottom && {
  marginBottom: "0.35em"
}, r.paragraph && {
  marginBottom: 16
})), g9 = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, wQ = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, _Q = (e) => wQ[e] || e, i_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiTypography"
  }), o = _Q(n.color), a = U8(F({}, n, {
    color: o
  })), {
    align: i = "inherit",
    className: l,
    component: s,
    gutterBottom: u = !1,
    noWrap: d = !1,
    paragraph: f = !1,
    variant: p = "body1",
    variantMapping: g = g9
  } = a, h = Xe(a, bQ), v = F({}, a, {
    align: i,
    color: o,
    className: l,
    component: s,
    gutterBottom: u,
    noWrap: d,
    paragraph: f,
    variant: p,
    variantMapping: g
  }), y = s || (f ? "p" : g[p] || g9[p]) || "span", w = yQ(v);
  return /* @__PURE__ */ le.jsx(CQ, F({
    as: y,
    ref: t,
    ownerState: v,
    className: qe(w.root, l)
  }, h));
});
process.env.NODE_ENV !== "production" && (i_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: c.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: c.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: c.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: c.oneOfType([c.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), c.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: c.object
});
const xQ = i_, l_ = "base";
function $Q(e) {
  return `${l_}--${e}`;
}
function OQ(e, r) {
  return `${l_}-${e}-${r}`;
}
function s_(e, r) {
  const t = q8[r];
  return t ? $Q(t) : OQ(e, r);
}
function PQ(e, r) {
  const t = {};
  return r.forEach((n) => {
    t[n] = s_(e, n);
  }), t;
}
const SQ = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function IQ(e) {
  const r = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(r) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : r;
}
function EQ(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const r = (n) => e.ownerDocument.querySelector(`input[type="radio"]${n}`);
  let t = r(`[name="${e.name}"]:checked`);
  return t || (t = r(`[name="${e.name}"]`)), t !== e;
}
function RQ(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || EQ(e));
}
function AQ(e) {
  const r = [], t = [];
  return Array.from(e.querySelectorAll(SQ)).forEach((n, o) => {
    const a = IQ(n);
    a === -1 || !RQ(n) || (a === 0 ? r.push(n) : t.push({
      documentOrder: o,
      tabIndex: a,
      node: n
    }));
  }), t.sort((n, o) => n.tabIndex === o.tabIndex ? n.documentOrder - o.documentOrder : n.tabIndex - o.tabIndex).map((n) => n.node).concat(r);
}
function kQ() {
  return !0;
}
function vu(e) {
  const {
    children: r,
    disableAutoFocus: t = !1,
    disableEnforceFocus: n = !1,
    disableRestoreFocus: o = !1,
    getTabbable: a = AQ,
    isEnabled: i = kQ,
    open: l
  } = e, s = A.useRef(!1), u = A.useRef(null), d = A.useRef(null), f = A.useRef(null), p = A.useRef(null), g = A.useRef(!1), h = A.useRef(null), v = Xr(r.ref, h), y = A.useRef(null);
  A.useEffect(() => {
    !l || !h.current || (g.current = !t);
  }, [t, l]), A.useEffect(() => {
    if (!l || !h.current)
      return;
    const C = tt(h.current);
    return h.current.contains(C.activeElement) || (h.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), h.current.setAttribute("tabIndex", "-1")), g.current && h.current.focus()), () => {
      o || (f.current && f.current.focus && (s.current = !0, f.current.focus()), f.current = null);
    };
  }, [l]), A.useEffect(() => {
    if (!l || !h.current)
      return;
    const C = tt(h.current), x = (_) => {
      y.current = _, !(n || !i() || _.key !== "Tab") && C.activeElement === h.current && _.shiftKey && (s.current = !0, d.current && d.current.focus());
    }, b = () => {
      const _ = h.current;
      if (_ === null)
        return;
      if (!C.hasFocus() || !i() || s.current) {
        s.current = !1;
        return;
      }
      if (_.contains(C.activeElement) || n && C.activeElement !== u.current && C.activeElement !== d.current)
        return;
      if (C.activeElement !== p.current)
        p.current = null;
      else if (p.current !== null)
        return;
      if (!g.current)
        return;
      let P = [];
      if ((C.activeElement === u.current || C.activeElement === d.current) && (P = a(h.current)), P.length > 0) {
        var S, I;
        const N = !!((S = y.current) != null && S.shiftKey && ((I = y.current) == null ? void 0 : I.key) === "Tab"), k = P[0], j = P[P.length - 1];
        typeof k != "string" && typeof j != "string" && (N ? j.focus() : k.focus());
      } else
        _.focus();
    };
    C.addEventListener("focusin", b), C.addEventListener("keydown", x, !0);
    const O = setInterval(() => {
      C.activeElement && C.activeElement.tagName === "BODY" && b();
    }, 50);
    return () => {
      clearInterval(O), C.removeEventListener("focusin", b), C.removeEventListener("keydown", x, !0);
    };
  }, [t, n, o, i, l, a]);
  const w = (C) => {
    f.current === null && (f.current = C.relatedTarget), g.current = !0, p.current = C.target;
    const x = r.props.onFocus;
    x && x(C);
  }, $ = (C) => {
    f.current === null && (f.current = C.relatedTarget), g.current = !0;
  };
  return /* @__PURE__ */ le.jsxs(A.Fragment, {
    children: [/* @__PURE__ */ le.jsx("div", {
      tabIndex: l ? 0 : -1,
      onFocus: $,
      ref: u,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ A.cloneElement(r, {
      ref: v,
      onFocus: w
    }), /* @__PURE__ */ le.jsx("div", {
      tabIndex: l ? 0 : -1,
      onFocus: $,
      ref: d,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (vu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: a1,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: c.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: c.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: c.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: c.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: c.func,
  /**
   * If `true`, focus is locked.
   */
  open: c.bool.isRequired
});
process.env.NODE_ENV !== "production" && (vu.propTypes = i1(vu.propTypes));
function MQ(e) {
  return typeof e == "function" ? e() : e;
}
const bi = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const {
    children: n,
    container: o,
    disablePortal: a = !1
  } = r, [i, l] = A.useState(null), s = Xr(/* @__PURE__ */ A.isValidElement(n) ? n.ref : null, t);
  if (_n(() => {
    a || l(MQ(o) || document.body);
  }, [o, a]), _n(() => {
    if (i && !a)
      return as(t, i), () => {
        as(t, null);
      };
  }, [t, i, a]), a) {
    if (/* @__PURE__ */ A.isValidElement(n)) {
      const u = {
        ref: s
      };
      return /* @__PURE__ */ A.cloneElement(n, u);
    }
    return /* @__PURE__ */ le.jsx(A.Fragment, {
      children: n
    });
  }
  return /* @__PURE__ */ le.jsx(A.Fragment, {
    children: i && /* @__PURE__ */ Qv.createPortal(n, i)
  });
});
process.env.NODE_ENV !== "production" && (bi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: c.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([$n, c.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool
});
process.env.NODE_ENV !== "production" && (bi.propTypes = i1(bi.propTypes));
function NQ(e) {
  const r = tt(e);
  return r.body === e ? Eo(e).innerWidth > r.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function li(e, r) {
  r ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function v9(e) {
  return parseInt(Eo(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function TQ(e) {
  const t = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, n = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return t || n;
}
function m9(e, r, t, n, o) {
  const a = [r, t, ...n];
  [].forEach.call(e.children, (i) => {
    const l = a.indexOf(i) === -1, s = !TQ(i);
    l && s && li(i, o);
  });
}
function Td(e, r) {
  let t = -1;
  return e.some((n, o) => r(n) ? (t = o, !0) : !1), t;
}
function DQ(e, r) {
  const t = [], n = e.container;
  if (!r.disableScrollLock) {
    if (NQ(n)) {
      const i = a6(tt(n));
      t.push({
        value: n.style.paddingRight,
        property: "padding-right",
        el: n
      }), n.style.paddingRight = `${v9(n) + i}px`;
      const l = tt(n).querySelectorAll(".mui-fixed");
      [].forEach.call(l, (s) => {
        t.push({
          value: s.style.paddingRight,
          property: "padding-right",
          el: s
        }), s.style.paddingRight = `${v9(s) + i}px`;
      });
    }
    let a;
    if (n.parentNode instanceof DocumentFragment)
      a = tt(n).body;
    else {
      const i = n.parentElement, l = Eo(n);
      a = (i == null ? void 0 : i.nodeName) === "HTML" && l.getComputedStyle(i).overflowY === "scroll" ? i : n;
    }
    t.push({
      value: a.style.overflow,
      property: "overflow",
      el: a
    }, {
      value: a.style.overflowX,
      property: "overflow-x",
      el: a
    }, {
      value: a.style.overflowY,
      property: "overflow-y",
      el: a
    }), a.style.overflow = "hidden";
  }
  return () => {
    t.forEach(({
      value: a,
      el: i,
      property: l
    }) => {
      a ? i.style.setProperty(l, a) : i.style.removeProperty(l);
    });
  };
}
function jQ(e) {
  const r = [];
  return [].forEach.call(e.children, (t) => {
    t.getAttribute("aria-hidden") === "true" && r.push(t);
  }), r;
}
class LQ {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(r, t) {
    let n = this.modals.indexOf(r);
    if (n !== -1)
      return n;
    n = this.modals.length, this.modals.push(r), r.modalRef && li(r.modalRef, !1);
    const o = jQ(t);
    m9(t, r.mount, r.modalRef, o, !0);
    const a = Td(this.containers, (i) => i.container === t);
    return a !== -1 ? (this.containers[a].modals.push(r), n) : (this.containers.push({
      modals: [r],
      container: t,
      restore: null,
      hiddenSiblings: o
    }), n);
  }
  mount(r, t) {
    const n = Td(this.containers, (a) => a.modals.indexOf(r) !== -1), o = this.containers[n];
    o.restore || (o.restore = DQ(o, t));
  }
  remove(r, t = !0) {
    const n = this.modals.indexOf(r);
    if (n === -1)
      return n;
    const o = Td(this.containers, (i) => i.modals.indexOf(r) !== -1), a = this.containers[o];
    if (a.modals.splice(a.modals.indexOf(r), 1), this.modals.splice(n, 1), a.modals.length === 0)
      a.restore && a.restore(), r.modalRef && li(r.modalRef, t), m9(a.container, r.mount, r.modalRef, a.hiddenSiblings, !1), this.containers.splice(o, 1);
    else {
      const i = a.modals[a.modals.length - 1];
      i.modalRef && li(i.modalRef, !1);
    }
    return n;
  }
  isTopModal(r) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === r;
  }
}
function zQ(e) {
  return typeof e == "function" ? e() : e;
}
function VQ(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const FQ = new LQ();
function ZQ(e) {
  const {
    container: r,
    disableEscapeKeyDown: t = !1,
    disableScrollLock: n = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: o = FQ,
    closeAfterTransition: a = !1,
    onTransitionEnter: i,
    onTransitionExited: l,
    children: s,
    onClose: u,
    open: d,
    rootRef: f
  } = e, p = A.useRef({}), g = A.useRef(null), h = A.useRef(null), v = Xr(h, f), [y, w] = A.useState(!d), $ = VQ(s);
  let C = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (C = !1);
  const x = () => tt(g.current), b = () => (p.current.modalRef = h.current, p.current.mount = g.current, p.current), O = () => {
    o.mount(b(), {
      disableScrollLock: n
    }), h.current && (h.current.scrollTop = 0);
  }, _ = on(() => {
    const T = zQ(r) || x().body;
    o.add(b(), T), h.current && O();
  }), P = A.useCallback(() => o.isTopModal(b()), [o]), S = on((T) => {
    g.current = T, T && (d && P() ? O() : h.current && li(h.current, C));
  }), I = A.useCallback(() => {
    o.remove(b(), C);
  }, [C, o]);
  A.useEffect(() => () => {
    I();
  }, [I]), A.useEffect(() => {
    d ? _() : (!$ || !a) && I();
  }, [d, I, $, a, _]);
  const N = (T) => (V) => {
    var L;
    (L = T.onKeyDown) == null || L.call(T, V), !(V.key !== "Escape" || V.which === 229 || // Wait until IME is settled.
    !P()) && (t || (V.stopPropagation(), u && u(V, "escapeKeyDown")));
  }, k = (T) => (V) => {
    var L;
    (L = T.onClick) == null || L.call(T, V), V.target === V.currentTarget && u && u(V, "backdropClick");
  };
  return {
    getRootProps: (T = {}) => {
      const V = e_(e);
      delete V.onTransitionEnter, delete V.onTransitionExited;
      const L = F({}, V, T);
      return F({
        role: "presentation"
      }, L, {
        onKeyDown: N(L),
        ref: v
      });
    },
    getBackdropProps: (T = {}) => {
      const V = T;
      return F({
        "aria-hidden": !0
      }, V, {
        onClick: k(V),
        open: d
      });
    },
    getTransitionProps: () => {
      const T = () => {
        w(!1), i && i();
      }, V = () => {
        w(!0), l && l(), a && I();
      };
      return {
        onEnter: Mp(T, s == null ? void 0 : s.props.onEnter),
        onExited: Mp(V, s == null ? void 0 : s.props.onExited)
      };
    },
    rootRef: v,
    portalRef: S,
    isTopModal: P,
    exited: y,
    hasTransition: $
  };
}
var it = "top", Lt = "bottom", zt = "right", lt = "left", Kf = "auto", zi = [it, Lt, zt, lt], ma = "start", yi = "end", WQ = "clippingParents", c_ = "viewport", Ka = "popper", BQ = "reference", h9 = /* @__PURE__ */ zi.reduce(function(e, r) {
  return e.concat([r + "-" + ma, r + "-" + yi]);
}, []), u_ = /* @__PURE__ */ [].concat(zi, [Kf]).reduce(function(e, r) {
  return e.concat([r, r + "-" + ma, r + "-" + yi]);
}, []), HQ = "beforeRead", GQ = "read", XQ = "afterRead", YQ = "beforeMain", UQ = "main", JQ = "afterMain", qQ = "beforeWrite", KQ = "write", QQ = "afterWrite", eee = [HQ, GQ, XQ, YQ, UQ, JQ, qQ, KQ, QQ];
function dn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Ot(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var r = e.ownerDocument;
    return r && r.defaultView || window;
  }
  return e;
}
function ko(e) {
  var r = Ot(e).Element;
  return e instanceof r || e instanceof Element;
}
function Tt(e) {
  var r = Ot(e).HTMLElement;
  return e instanceof r || e instanceof HTMLElement;
}
function Qf(e) {
  if (typeof ShadowRoot == "undefined")
    return !1;
  var r = Ot(e).ShadowRoot;
  return e instanceof r || e instanceof ShadowRoot;
}
function ree(e) {
  var r = e.state;
  Object.keys(r.elements).forEach(function(t) {
    var n = r.styles[t] || {}, o = r.attributes[t] || {}, a = r.elements[t];
    !Tt(a) || !dn(a) || (Object.assign(a.style, n), Object.keys(o).forEach(function(i) {
      var l = o[i];
      l === !1 ? a.removeAttribute(i) : a.setAttribute(i, l === !0 ? "" : l);
    }));
  });
}
function tee(e) {
  var r = e.state, t = {
    popper: {
      position: r.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(r.elements.popper.style, t.popper), r.styles = t, r.elements.arrow && Object.assign(r.elements.arrow.style, t.arrow), function() {
    Object.keys(r.elements).forEach(function(n) {
      var o = r.elements[n], a = r.attributes[n] || {}, i = Object.keys(r.styles.hasOwnProperty(n) ? r.styles[n] : t[n]), l = i.reduce(function(s, u) {
        return s[u] = "", s;
      }, {});
      !Tt(o) || !dn(o) || (Object.assign(o.style, l), Object.keys(a).forEach(function(s) {
        o.removeAttribute(s);
      }));
    });
  };
}
const nee = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: ree,
  effect: tee,
  requires: ["computeStyles"]
};
function sn(e) {
  return e.split("-")[0];
}
var Po = Math.max, mu = Math.min, ha = Math.round;
function L0() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(r) {
    return r.brand + "/" + r.version;
  }).join(" ") : navigator.userAgent;
}
function d_() {
  return !/^((?!chrome|android).)*safari/i.test(L0());
}
function ba(e, r, t) {
  r === void 0 && (r = !1), t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), o = 1, a = 1;
  r && Tt(e) && (o = e.offsetWidth > 0 && ha(n.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && ha(n.height) / e.offsetHeight || 1);
  var i = ko(e) ? Ot(e) : window, l = i.visualViewport, s = !d_() && t, u = (n.left + (s && l ? l.offsetLeft : 0)) / o, d = (n.top + (s && l ? l.offsetTop : 0)) / a, f = n.width / o, p = n.height / a;
  return {
    width: f,
    height: p,
    top: d,
    right: u + f,
    bottom: d + p,
    left: u,
    x: u,
    y: d
  };
}
function e2(e) {
  var r = ba(e), t = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(r.width - t) <= 1 && (t = r.width), Math.abs(r.height - n) <= 1 && (n = r.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: n
  };
}
function f_(e, r) {
  var t = r.getRootNode && r.getRootNode();
  if (e.contains(r))
    return !0;
  if (t && Qf(t)) {
    var n = r;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Sn(e) {
  return Ot(e).getComputedStyle(e);
}
function oee(e) {
  return ["table", "td", "th"].indexOf(dn(e)) >= 0;
}
function ao(e) {
  return ((ko(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function O1(e) {
  return dn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Qf(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ao(e)
  );
}
function b9(e) {
  return !Tt(e) || // https://github.com/popperjs/popper-core/issues/837
  Sn(e).position === "fixed" ? null : e.offsetParent;
}
function aee(e) {
  var r = /firefox/i.test(L0()), t = /Trident/i.test(L0());
  if (t && Tt(e)) {
    var n = Sn(e);
    if (n.position === "fixed")
      return null;
  }
  var o = O1(e);
  for (Qf(o) && (o = o.host); Tt(o) && ["html", "body"].indexOf(dn(o)) < 0; ) {
    var a = Sn(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || r && a.willChange === "filter" || r && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Vi(e) {
  for (var r = Ot(e), t = b9(e); t && oee(t) && Sn(t).position === "static"; )
    t = b9(t);
  return t && (dn(t) === "html" || dn(t) === "body" && Sn(t).position === "static") ? r : t || aee(e) || r;
}
function r2(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function si(e, r, t) {
  return Po(e, mu(r, t));
}
function iee(e, r, t) {
  var n = si(e, r, t);
  return n > t ? t : n;
}
function p_() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function g_(e) {
  return Object.assign({}, p_(), e);
}
function v_(e, r) {
  return r.reduce(function(t, n) {
    return t[n] = e, t;
  }, {});
}
var lee = function(r, t) {
  return r = typeof r == "function" ? r(Object.assign({}, t.rects, {
    placement: t.placement
  })) : r, g_(typeof r != "number" ? r : v_(r, zi));
};
function see(e) {
  var r, t = e.state, n = e.name, o = e.options, a = t.elements.arrow, i = t.modifiersData.popperOffsets, l = sn(t.placement), s = r2(l), u = [lt, zt].indexOf(l) >= 0, d = u ? "height" : "width";
  if (!(!a || !i)) {
    var f = lee(o.padding, t), p = e2(a), g = s === "y" ? it : lt, h = s === "y" ? Lt : zt, v = t.rects.reference[d] + t.rects.reference[s] - i[s] - t.rects.popper[d], y = i[s] - t.rects.reference[s], w = Vi(a), $ = w ? s === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, C = v / 2 - y / 2, x = f[g], b = $ - p[d] - f[h], O = $ / 2 - p[d] / 2 + C, _ = si(x, O, b), P = s;
    t.modifiersData[n] = (r = {}, r[P] = _, r.centerOffset = _ - O, r);
  }
}
function cee(e) {
  var r = e.state, t = e.options, n = t.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  o != null && (typeof o == "string" && (o = r.elements.popper.querySelector(o), !o) || f_(r.elements.popper, o) && (r.elements.arrow = o));
}
const uee = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: see,
  effect: cee,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ya(e) {
  return e.split("-")[1];
}
var dee = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function fee(e, r) {
  var t = e.x, n = e.y, o = r.devicePixelRatio || 1;
  return {
    x: ha(t * o) / o || 0,
    y: ha(n * o) / o || 0
  };
}
function y9(e) {
  var r, t = e.popper, n = e.popperRect, o = e.placement, a = e.variation, i = e.offsets, l = e.position, s = e.gpuAcceleration, u = e.adaptive, d = e.roundOffsets, f = e.isFixed, p = i.x, g = p === void 0 ? 0 : p, h = i.y, v = h === void 0 ? 0 : h, y = typeof d == "function" ? d({
    x: g,
    y: v
  }) : {
    x: g,
    y: v
  };
  g = y.x, v = y.y;
  var w = i.hasOwnProperty("x"), $ = i.hasOwnProperty("y"), C = lt, x = it, b = window;
  if (u) {
    var O = Vi(t), _ = "clientHeight", P = "clientWidth";
    if (O === Ot(t) && (O = ao(t), Sn(O).position !== "static" && l === "absolute" && (_ = "scrollHeight", P = "scrollWidth")), O = O, o === it || (o === lt || o === zt) && a === yi) {
      x = Lt;
      var S = f && O === b && b.visualViewport ? b.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        O[_]
      );
      v -= S - n.height, v *= s ? 1 : -1;
    }
    if (o === lt || (o === it || o === Lt) && a === yi) {
      C = zt;
      var I = f && O === b && b.visualViewport ? b.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        O[P]
      );
      g -= I - n.width, g *= s ? 1 : -1;
    }
  }
  var N = Object.assign({
    position: l
  }, u && dee), k = d === !0 ? fee({
    x: g,
    y: v
  }, Ot(t)) : {
    x: g,
    y: v
  };
  if (g = k.x, v = k.y, s) {
    var j;
    return Object.assign({}, N, (j = {}, j[x] = $ ? "0" : "", j[C] = w ? "0" : "", j.transform = (b.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + v + "px)" : "translate3d(" + g + "px, " + v + "px, 0)", j));
  }
  return Object.assign({}, N, (r = {}, r[x] = $ ? v + "px" : "", r[C] = w ? g + "px" : "", r.transform = "", r));
}
function pee(e) {
  var r = e.state, t = e.options, n = t.gpuAcceleration, o = n === void 0 ? !0 : n, a = t.adaptive, i = a === void 0 ? !0 : a, l = t.roundOffsets, s = l === void 0 ? !0 : l, u = {
    placement: sn(r.placement),
    variation: ya(r.placement),
    popper: r.elements.popper,
    popperRect: r.rects.popper,
    gpuAcceleration: o,
    isFixed: r.options.strategy === "fixed"
  };
  r.modifiersData.popperOffsets != null && (r.styles.popper = Object.assign({}, r.styles.popper, y9(Object.assign({}, u, {
    offsets: r.modifiersData.popperOffsets,
    position: r.options.strategy,
    adaptive: i,
    roundOffsets: s
  })))), r.modifiersData.arrow != null && (r.styles.arrow = Object.assign({}, r.styles.arrow, y9(Object.assign({}, u, {
    offsets: r.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-placement": r.placement
  });
}
const gee = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: pee,
  data: {}
};
var $l = {
  passive: !0
};
function vee(e) {
  var r = e.state, t = e.instance, n = e.options, o = n.scroll, a = o === void 0 ? !0 : o, i = n.resize, l = i === void 0 ? !0 : i, s = Ot(r.elements.popper), u = [].concat(r.scrollParents.reference, r.scrollParents.popper);
  return a && u.forEach(function(d) {
    d.addEventListener("scroll", t.update, $l);
  }), l && s.addEventListener("resize", t.update, $l), function() {
    a && u.forEach(function(d) {
      d.removeEventListener("scroll", t.update, $l);
    }), l && s.removeEventListener("resize", t.update, $l);
  };
}
const mee = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: vee,
  data: {}
};
var hee = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function es(e) {
  return e.replace(/left|right|bottom|top/g, function(r) {
    return hee[r];
  });
}
var bee = {
  start: "end",
  end: "start"
};
function C9(e) {
  return e.replace(/start|end/g, function(r) {
    return bee[r];
  });
}
function t2(e) {
  var r = Ot(e), t = r.pageXOffset, n = r.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: n
  };
}
function n2(e) {
  return ba(ao(e)).left + t2(e).scrollLeft;
}
function yee(e, r) {
  var t = Ot(e), n = ao(e), o = t.visualViewport, a = n.clientWidth, i = n.clientHeight, l = 0, s = 0;
  if (o) {
    a = o.width, i = o.height;
    var u = d_();
    (u || !u && r === "fixed") && (l = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: l + n2(e),
    y: s
  };
}
function Cee(e) {
  var r, t = ao(e), n = t2(e), o = (r = e.ownerDocument) == null ? void 0 : r.body, a = Po(t.scrollWidth, t.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), i = Po(t.scrollHeight, t.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -n.scrollLeft + n2(e), s = -n.scrollTop;
  return Sn(o || t).direction === "rtl" && (l += Po(t.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: i,
    x: l,
    y: s
  };
}
function o2(e) {
  var r = Sn(e), t = r.overflow, n = r.overflowX, o = r.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + o + n);
}
function m_(e) {
  return ["html", "body", "#document"].indexOf(dn(e)) >= 0 ? e.ownerDocument.body : Tt(e) && o2(e) ? e : m_(O1(e));
}
function ci(e, r) {
  var t;
  r === void 0 && (r = []);
  var n = m_(e), o = n === ((t = e.ownerDocument) == null ? void 0 : t.body), a = Ot(n), i = o ? [a].concat(a.visualViewport || [], o2(n) ? n : []) : n, l = r.concat(i);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(ci(O1(i)))
  );
}
function z0(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function wee(e, r) {
  var t = ba(e, !1, r === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function w9(e, r, t) {
  return r === c_ ? z0(yee(e, t)) : ko(r) ? wee(r, t) : z0(Cee(ao(e)));
}
function _ee(e) {
  var r = ci(O1(e)), t = ["absolute", "fixed"].indexOf(Sn(e).position) >= 0, n = t && Tt(e) ? Vi(e) : e;
  return ko(n) ? r.filter(function(o) {
    return ko(o) && f_(o, n) && dn(o) !== "body";
  }) : [];
}
function xee(e, r, t, n) {
  var o = r === "clippingParents" ? _ee(e) : [].concat(r), a = [].concat(o, [t]), i = a[0], l = a.reduce(function(s, u) {
    var d = w9(e, u, n);
    return s.top = Po(d.top, s.top), s.right = mu(d.right, s.right), s.bottom = mu(d.bottom, s.bottom), s.left = Po(d.left, s.left), s;
  }, w9(e, i, n));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function h_(e) {
  var r = e.reference, t = e.element, n = e.placement, o = n ? sn(n) : null, a = n ? ya(n) : null, i = r.x + r.width / 2 - t.width / 2, l = r.y + r.height / 2 - t.height / 2, s;
  switch (o) {
    case it:
      s = {
        x: i,
        y: r.y - t.height
      };
      break;
    case Lt:
      s = {
        x: i,
        y: r.y + r.height
      };
      break;
    case zt:
      s = {
        x: r.x + r.width,
        y: l
      };
      break;
    case lt:
      s = {
        x: r.x - t.width,
        y: l
      };
      break;
    default:
      s = {
        x: r.x,
        y: r.y
      };
  }
  var u = o ? r2(o) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (a) {
      case ma:
        s[u] = s[u] - (r[d] / 2 - t[d] / 2);
        break;
      case yi:
        s[u] = s[u] + (r[d] / 2 - t[d] / 2);
        break;
    }
  }
  return s;
}
function Ci(e, r) {
  r === void 0 && (r = {});
  var t = r, n = t.placement, o = n === void 0 ? e.placement : n, a = t.strategy, i = a === void 0 ? e.strategy : a, l = t.boundary, s = l === void 0 ? WQ : l, u = t.rootBoundary, d = u === void 0 ? c_ : u, f = t.elementContext, p = f === void 0 ? Ka : f, g = t.altBoundary, h = g === void 0 ? !1 : g, v = t.padding, y = v === void 0 ? 0 : v, w = g_(typeof y != "number" ? y : v_(y, zi)), $ = p === Ka ? BQ : Ka, C = e.rects.popper, x = e.elements[h ? $ : p], b = xee(ko(x) ? x : x.contextElement || ao(e.elements.popper), s, d, i), O = ba(e.elements.reference), _ = h_({
    reference: O,
    element: C,
    strategy: "absolute",
    placement: o
  }), P = z0(Object.assign({}, C, _)), S = p === Ka ? P : O, I = {
    top: b.top - S.top + w.top,
    bottom: S.bottom - b.bottom + w.bottom,
    left: b.left - S.left + w.left,
    right: S.right - b.right + w.right
  }, N = e.modifiersData.offset;
  if (p === Ka && N) {
    var k = N[o];
    Object.keys(I).forEach(function(j) {
      var R = [zt, Lt].indexOf(j) >= 0 ? 1 : -1, D = [it, Lt].indexOf(j) >= 0 ? "y" : "x";
      I[j] += k[D] * R;
    });
  }
  return I;
}
function $ee(e, r) {
  r === void 0 && (r = {});
  var t = r, n = t.placement, o = t.boundary, a = t.rootBoundary, i = t.padding, l = t.flipVariations, s = t.allowedAutoPlacements, u = s === void 0 ? u_ : s, d = ya(n), f = d ? l ? h9 : h9.filter(function(h) {
    return ya(h) === d;
  }) : zi, p = f.filter(function(h) {
    return u.indexOf(h) >= 0;
  });
  p.length === 0 && (p = f);
  var g = p.reduce(function(h, v) {
    return h[v] = Ci(e, {
      placement: v,
      boundary: o,
      rootBoundary: a,
      padding: i
    })[sn(v)], h;
  }, {});
  return Object.keys(g).sort(function(h, v) {
    return g[h] - g[v];
  });
}
function Oee(e) {
  if (sn(e) === Kf)
    return [];
  var r = es(e);
  return [C9(e), r, C9(r)];
}
function Pee(e) {
  var r = e.state, t = e.options, n = e.name;
  if (!r.modifiersData[n]._skip) {
    for (var o = t.mainAxis, a = o === void 0 ? !0 : o, i = t.altAxis, l = i === void 0 ? !0 : i, s = t.fallbackPlacements, u = t.padding, d = t.boundary, f = t.rootBoundary, p = t.altBoundary, g = t.flipVariations, h = g === void 0 ? !0 : g, v = t.allowedAutoPlacements, y = r.options.placement, w = sn(y), $ = w === y, C = s || ($ || !h ? [es(y)] : Oee(y)), x = [y].concat(C).reduce(function(X, J) {
      return X.concat(sn(J) === Kf ? $ee(r, {
        placement: J,
        boundary: d,
        rootBoundary: f,
        padding: u,
        flipVariations: h,
        allowedAutoPlacements: v
      }) : J);
    }, []), b = r.rects.reference, O = r.rects.popper, _ = /* @__PURE__ */ new Map(), P = !0, S = x[0], I = 0; I < x.length; I++) {
      var N = x[I], k = sn(N), j = ya(N) === ma, R = [it, Lt].indexOf(k) >= 0, D = R ? "width" : "height", T = Ci(r, {
        placement: N,
        boundary: d,
        rootBoundary: f,
        altBoundary: p,
        padding: u
      }), V = R ? j ? zt : lt : j ? Lt : it;
      b[D] > O[D] && (V = es(V));
      var L = es(V), Z = [];
      if (a && Z.push(T[k] <= 0), l && Z.push(T[V] <= 0, T[L] <= 0), Z.every(function(X) {
        return X;
      })) {
        S = N, P = !1;
        break;
      }
      _.set(N, Z);
    }
    if (P)
      for (var z = h ? 3 : 1, W = function(J) {
        var Q = x.find(function(se) {
          var q = _.get(se);
          if (q)
            return q.slice(0, J).every(function(te) {
              return te;
            });
        });
        if (Q)
          return S = Q, "break";
      }, U = z; U > 0; U--) {
        var re = W(U);
        if (re === "break")
          break;
      }
    r.placement !== S && (r.modifiersData[n]._skip = !0, r.placement = S, r.reset = !0);
  }
}
const See = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Pee,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function _9(e, r, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - r.height - t.y,
    right: e.right - r.width + t.x,
    bottom: e.bottom - r.height + t.y,
    left: e.left - r.width - t.x
  };
}
function x9(e) {
  return [it, zt, Lt, lt].some(function(r) {
    return e[r] >= 0;
  });
}
function Iee(e) {
  var r = e.state, t = e.name, n = r.rects.reference, o = r.rects.popper, a = r.modifiersData.preventOverflow, i = Ci(r, {
    elementContext: "reference"
  }), l = Ci(r, {
    altBoundary: !0
  }), s = _9(i, n), u = _9(l, o, a), d = x9(s), f = x9(u);
  r.modifiersData[t] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: u,
    isReferenceHidden: d,
    hasPopperEscaped: f
  }, r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": f
  });
}
const Eee = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Iee
};
function Ree(e, r, t) {
  var n = sn(e), o = [lt, it].indexOf(n) >= 0 ? -1 : 1, a = typeof t == "function" ? t(Object.assign({}, r, {
    placement: e
  })) : t, i = a[0], l = a[1];
  return i = i || 0, l = (l || 0) * o, [lt, zt].indexOf(n) >= 0 ? {
    x: l,
    y: i
  } : {
    x: i,
    y: l
  };
}
function Aee(e) {
  var r = e.state, t = e.options, n = e.name, o = t.offset, a = o === void 0 ? [0, 0] : o, i = u_.reduce(function(d, f) {
    return d[f] = Ree(f, r.rects, a), d;
  }, {}), l = i[r.placement], s = l.x, u = l.y;
  r.modifiersData.popperOffsets != null && (r.modifiersData.popperOffsets.x += s, r.modifiersData.popperOffsets.y += u), r.modifiersData[n] = i;
}
const kee = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Aee
};
function Mee(e) {
  var r = e.state, t = e.name;
  r.modifiersData[t] = h_({
    reference: r.rects.reference,
    element: r.rects.popper,
    strategy: "absolute",
    placement: r.placement
  });
}
const Nee = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Mee,
  data: {}
};
function Tee(e) {
  return e === "x" ? "y" : "x";
}
function Dee(e) {
  var r = e.state, t = e.options, n = e.name, o = t.mainAxis, a = o === void 0 ? !0 : o, i = t.altAxis, l = i === void 0 ? !1 : i, s = t.boundary, u = t.rootBoundary, d = t.altBoundary, f = t.padding, p = t.tether, g = p === void 0 ? !0 : p, h = t.tetherOffset, v = h === void 0 ? 0 : h, y = Ci(r, {
    boundary: s,
    rootBoundary: u,
    padding: f,
    altBoundary: d
  }), w = sn(r.placement), $ = ya(r.placement), C = !$, x = r2(w), b = Tee(x), O = r.modifiersData.popperOffsets, _ = r.rects.reference, P = r.rects.popper, S = typeof v == "function" ? v(Object.assign({}, r.rects, {
    placement: r.placement
  })) : v, I = typeof S == "number" ? {
    mainAxis: S,
    altAxis: S
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, S), N = r.modifiersData.offset ? r.modifiersData.offset[r.placement] : null, k = {
    x: 0,
    y: 0
  };
  if (O) {
    if (a) {
      var j, R = x === "y" ? it : lt, D = x === "y" ? Lt : zt, T = x === "y" ? "height" : "width", V = O[x], L = V + y[R], Z = V - y[D], z = g ? -P[T] / 2 : 0, W = $ === ma ? _[T] : P[T], U = $ === ma ? -P[T] : -_[T], re = r.elements.arrow, X = g && re ? e2(re) : {
        width: 0,
        height: 0
      }, J = r.modifiersData["arrow#persistent"] ? r.modifiersData["arrow#persistent"].padding : p_(), Q = J[R], se = J[D], q = si(0, _[T], X[T]), te = C ? _[T] / 2 - z - q - Q - I.mainAxis : W - q - Q - I.mainAxis, ae = C ? -_[T] / 2 + z + q + se + I.mainAxis : U + q + se + I.mainAxis, ge = r.elements.arrow && Vi(r.elements.arrow), G = ge ? x === "y" ? ge.clientTop || 0 : ge.clientLeft || 0 : 0, oe = (j = N == null ? void 0 : N[x]) != null ? j : 0, ne = V + te - oe - G, _e = V + ae - oe, ye = si(g ? mu(L, ne) : L, V, g ? Po(Z, _e) : Z);
      O[x] = ye, k[x] = ye - V;
    }
    if (l) {
      var Te, we = x === "x" ? it : lt, He = x === "x" ? Lt : zt, he = O[b], xe = b === "y" ? "height" : "width", Le = he + y[we], Ue = he - y[He], me = [it, lt].indexOf(w) !== -1, Ie = (Te = N == null ? void 0 : N[b]) != null ? Te : 0, er = me ? Le : he - _[xe] - P[xe] - Ie + I.altAxis, Ke = me ? he + _[xe] + P[xe] - Ie - I.altAxis : Ue, Me = g && me ? iee(er, he, Ke) : si(g ? er : Le, he, g ? Ke : Ue);
      O[b] = Me, k[b] = Me - he;
    }
    r.modifiersData[n] = k;
  }
}
const jee = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Dee,
  requiresIfExists: ["offset"]
};
function Lee(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function zee(e) {
  return e === Ot(e) || !Tt(e) ? t2(e) : Lee(e);
}
function Vee(e) {
  var r = e.getBoundingClientRect(), t = ha(r.width) / e.offsetWidth || 1, n = ha(r.height) / e.offsetHeight || 1;
  return t !== 1 || n !== 1;
}
function Fee(e, r, t) {
  t === void 0 && (t = !1);
  var n = Tt(r), o = Tt(r) && Vee(r), a = ao(r), i = ba(e, o, t), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !t) && ((dn(r) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  o2(a)) && (l = zee(r)), Tt(r) ? (s = ba(r, !0), s.x += r.clientLeft, s.y += r.clientTop) : a && (s.x = n2(a))), {
    x: i.left + l.scrollLeft - s.x,
    y: i.top + l.scrollTop - s.y,
    width: i.width,
    height: i.height
  };
}
function Zee(e) {
  var r = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(a) {
    r.set(a.name, a);
  });
  function o(a) {
    t.add(a.name);
    var i = [].concat(a.requires || [], a.requiresIfExists || []);
    i.forEach(function(l) {
      if (!t.has(l)) {
        var s = r.get(l);
        s && o(s);
      }
    }), n.push(a);
  }
  return e.forEach(function(a) {
    t.has(a.name) || o(a);
  }), n;
}
function Wee(e) {
  var r = Zee(e);
  return eee.reduce(function(t, n) {
    return t.concat(r.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function Bee(e) {
  var r;
  return function() {
    return r || (r = new Promise(function(t) {
      Promise.resolve().then(function() {
        r = void 0, t(e());
      });
    })), r;
  };
}
function Hee(e) {
  var r = e.reduce(function(t, n) {
    var o = t[n.name];
    return t[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, t;
  }, {});
  return Object.keys(r).map(function(t) {
    return r[t];
  });
}
var $9 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function O9() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return !r.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Gee(e) {
  e === void 0 && (e = {});
  var r = e, t = r.defaultModifiers, n = t === void 0 ? [] : t, o = r.defaultOptions, a = o === void 0 ? $9 : o;
  return function(l, s, u) {
    u === void 0 && (u = a);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, $9, a),
      modifiersData: {},
      elements: {
        reference: l,
        popper: s
      },
      attributes: {},
      styles: {}
    }, f = [], p = !1, g = {
      state: d,
      setOptions: function(w) {
        var $ = typeof w == "function" ? w(d.options) : w;
        v(), d.options = Object.assign({}, a, d.options, $), d.scrollParents = {
          reference: ko(l) ? ci(l) : l.contextElement ? ci(l.contextElement) : [],
          popper: ci(s)
        };
        var C = Wee(Hee([].concat(n, d.options.modifiers)));
        return d.orderedModifiers = C.filter(function(x) {
          return x.enabled;
        }), h(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var w = d.elements, $ = w.reference, C = w.popper;
          if (O9($, C)) {
            d.rects = {
              reference: Fee($, Vi(C), d.options.strategy === "fixed"),
              popper: e2(C)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(I) {
              return d.modifiersData[I.name] = Object.assign({}, I.data);
            });
            for (var x = 0; x < d.orderedModifiers.length; x++) {
              if (d.reset === !0) {
                d.reset = !1, x = -1;
                continue;
              }
              var b = d.orderedModifiers[x], O = b.fn, _ = b.options, P = _ === void 0 ? {} : _, S = b.name;
              typeof O == "function" && (d = O({
                state: d,
                options: P,
                name: S,
                instance: g
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Bee(function() {
        return new Promise(function(y) {
          g.forceUpdate(), y(d);
        });
      }),
      destroy: function() {
        v(), p = !0;
      }
    };
    if (!O9(l, s))
      return g;
    g.setOptions(u).then(function(y) {
      !p && u.onFirstUpdate && u.onFirstUpdate(y);
    });
    function h() {
      d.orderedModifiers.forEach(function(y) {
        var w = y.name, $ = y.options, C = $ === void 0 ? {} : $, x = y.effect;
        if (typeof x == "function") {
          var b = x({
            state: d,
            name: w,
            instance: g,
            options: C
          }), O = function() {
          };
          f.push(b || O);
        }
      });
    }
    function v() {
      f.forEach(function(y) {
        return y();
      }), f = [];
    }
    return g;
  };
}
var Xee = [mee, Nee, gee, nee, kee, See, jee, uee, Eee], Yee = /* @__PURE__ */ Gee({
  defaultModifiers: Xee
});
const b_ = "Popper";
function Uee(e) {
  return s_(b_, e);
}
PQ(b_, ["root"]);
const Jee = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], qee = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function Kee(e, r) {
  if (r === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function hu(e) {
  return typeof e == "function" ? e() : e;
}
function P1(e) {
  return e.nodeType !== void 0;
}
function Qee(e) {
  return !P1(e);
}
const ere = () => _r({
  root: ["root"]
}, YK(Uee)), rre = {}, tre = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n;
  const {
    anchorEl: o,
    children: a,
    direction: i,
    disablePortal: l,
    modifiers: s,
    open: u,
    placement: d,
    popperOptions: f,
    popperRef: p,
    slotProps: g = {},
    slots: h = {},
    TransitionProps: v
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = r, y = Xe(r, Jee), w = A.useRef(null), $ = Xr(w, t), C = A.useRef(null), x = Xr(C, p), b = A.useRef(x);
  _n(() => {
    b.current = x;
  }, [x]), A.useImperativeHandle(p, () => C.current, []);
  const O = Kee(d, i), [_, P] = A.useState(O), [S, I] = A.useState(hu(o));
  A.useEffect(() => {
    C.current && C.current.forceUpdate();
  }), A.useEffect(() => {
    o && I(hu(o));
  }, [o]), _n(() => {
    if (!S || !u)
      return;
    const D = (L) => {
      P(L.placement);
    };
    if (process.env.NODE_ENV !== "production" && S && P1(S) && S.nodeType === 1) {
      const L = S.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && L.top === 0 && L.left === 0 && L.right === 0 && L.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let T = [{
      name: "preventOverflow",
      options: {
        altBoundary: l
      }
    }, {
      name: "flip",
      options: {
        altBoundary: l
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: L
      }) => {
        D(L);
      }
    }];
    s != null && (T = T.concat(s)), f && f.modifiers != null && (T = T.concat(f.modifiers));
    const V = Yee(S, w.current, F({
      placement: O
    }, f, {
      modifiers: T
    }));
    return b.current(V), () => {
      V.destroy(), b.current(null);
    };
  }, [S, l, s, u, f, O]);
  const N = {
    placement: _
  };
  v !== null && (N.TransitionProps = v);
  const k = ere(), j = (n = h.root) != null ? n : "div", R = Ao({
    elementType: j,
    externalSlotProps: g.root,
    externalForwardedProps: y,
    additionalProps: {
      role: "tooltip",
      ref: $
    },
    ownerState: r,
    className: k.root
  });
  return /* @__PURE__ */ le.jsx(j, F({}, R, {
    children: typeof a == "function" ? a(N) : a
  }));
}), y_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const {
    anchorEl: n,
    children: o,
    container: a,
    direction: i = "ltr",
    disablePortal: l = !1,
    keepMounted: s = !1,
    modifiers: u,
    open: d,
    placement: f = "bottom",
    popperOptions: p = rre,
    popperRef: g,
    style: h,
    transition: v = !1,
    slotProps: y = {},
    slots: w = {}
  } = r, $ = Xe(r, qee), [C, x] = A.useState(!0), b = () => {
    x(!1);
  }, O = () => {
    x(!0);
  };
  if (!s && !d && (!v || C))
    return null;
  let _;
  if (a)
    _ = a;
  else if (n) {
    const I = hu(n);
    _ = I && P1(I) ? tt(I).body : tt(null).body;
  }
  const P = !d && s && (!v || C) ? "none" : void 0, S = v ? {
    in: d,
    onEnter: b,
    onExited: O
  } : void 0;
  return /* @__PURE__ */ le.jsx(bi, {
    disablePortal: l,
    container: _,
    children: /* @__PURE__ */ le.jsx(tre, F({
      anchorEl: n,
      direction: i,
      disablePortal: l,
      modifiers: u,
      ref: t,
      open: v ? !C : d,
      placement: f,
      popperOptions: p,
      popperRef: g,
      slotProps: y,
      slots: w
    }, $, {
      style: F({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: P
      }, h),
      TransitionProps: S,
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (y_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: xn(c.oneOfType([$n, c.object, c.func]), (e) => {
    if (e.open) {
      const r = hu(e.anchorEl);
      if (r && P1(r) && r.nodeType === 1) {
        const t = r.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && t.top === 0 && t.left === 0 && t.right === 0 && t.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!r || typeof r.getBoundingClientRect != "function" || Qee(r) && r.contextElement != null && r.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: c.oneOfType([c.node, c.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([$n, c.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: c.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: c.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: c.arrayOf(c.shape({
    data: c.object,
    effect: c.func,
    enabled: c.bool,
    fn: c.func,
    name: c.any,
    options: c.object,
    phase: c.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: c.arrayOf(c.string),
    requiresIfExists: c.arrayOf(c.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: c.shape({
    modifiers: c.array,
    onFirstUpdate: c.func,
    placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: c.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: qt,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    root: c.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: c.bool
});
const nre = ["onChange", "maxRows", "minRows", "style", "value"];
function Ol(e) {
  return parseInt(e, 10) || 0;
}
const ore = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function are(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflowing;
}
const C_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const {
    onChange: n,
    maxRows: o,
    minRows: a = 1,
    style: i,
    value: l
  } = r, s = Xe(r, nre), {
    current: u
  } = A.useRef(l != null), d = A.useRef(null), f = Xr(t, d), p = A.useRef(null), g = A.useCallback(() => {
    const y = d.current, $ = Eo(y).getComputedStyle(y);
    if ($.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const C = p.current;
    C.style.width = $.width, C.value = y.value || r.placeholder || "x", C.value.slice(-1) === `
` && (C.value += " ");
    const x = $.boxSizing, b = Ol($.paddingBottom) + Ol($.paddingTop), O = Ol($.borderBottomWidth) + Ol($.borderTopWidth), _ = C.scrollHeight;
    C.value = "x";
    const P = C.scrollHeight;
    let S = _;
    a && (S = Math.max(Number(a) * P, S)), o && (S = Math.min(Number(o) * P, S)), S = Math.max(S, P);
    const I = S + (x === "border-box" ? b + O : 0), N = Math.abs(S - _) <= 1;
    return {
      outerHeightStyle: I,
      overflowing: N
    };
  }, [o, a, r.placeholder]), h = A.useCallback(() => {
    const y = g();
    if (are(y))
      return;
    const w = d.current;
    w.style.height = `${y.outerHeightStyle}px`, w.style.overflow = y.overflowing ? "hidden" : "";
  }, [g]);
  _n(() => {
    const y = () => {
      h();
    };
    let w;
    const $ = () => {
      cancelAnimationFrame(w), w = requestAnimationFrame(() => {
        y();
      });
    }, C = n6(y), x = d.current, b = Eo(x);
    b.addEventListener("resize", C);
    let O;
    return typeof ResizeObserver != "undefined" && (O = new ResizeObserver(process.env.NODE_ENV === "test" ? $ : y), O.observe(x)), () => {
      C.clear(), cancelAnimationFrame(w), b.removeEventListener("resize", C), O && O.disconnect();
    };
  }, [g, h]), _n(() => {
    h();
  });
  const v = (y) => {
    u || h(), n && n(y);
  };
  return /* @__PURE__ */ le.jsxs(A.Fragment, {
    children: [/* @__PURE__ */ le.jsx("textarea", F({
      value: l,
      onChange: v,
      ref: f,
      rows: a,
      style: i
    }, s)), /* @__PURE__ */ le.jsx("textarea", {
      "aria-hidden": !0,
      className: r.className,
      readOnly: !0,
      ref: p,
      tabIndex: -1,
      style: F({}, ore.shadow, i, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (C_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: c.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * @ignore
   */
  onChange: c.func,
  /**
   * @ignore
   */
  placeholder: c.string,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * @ignore
   */
  value: c.oneOfType([c.arrayOf(c.string), c.number, c.string])
});
function P9(e) {
  return typeof e.normalize != "undefined" ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : e;
}
function w_(e = {}) {
  const {
    ignoreAccents: r = !0,
    ignoreCase: t = !0,
    limit: n,
    matchFrom: o = "any",
    stringify: a,
    trim: i = !1
  } = e;
  return (l, {
    inputValue: s,
    getOptionLabel: u
  }) => {
    let d = i ? s.trim() : s;
    t && (d = d.toLowerCase()), r && (d = P9(d));
    const f = d ? l.filter((p) => {
      let g = (a || u)(p);
      return t && (g = g.toLowerCase()), r && (g = P9(g)), o === "start" ? g.indexOf(d) === 0 : g.indexOf(d) > -1;
    }) : l;
    return typeof n == "number" ? f.slice(0, n) : f;
  };
}
function Pl(e, r) {
  for (let t = 0; t < e.length; t += 1)
    if (r(e[t]))
      return t;
  return -1;
}
const ire = w_(), S9 = 5, lre = (e) => {
  var r;
  return e.current !== null && ((r = e.current.parentElement) == null ? void 0 : r.contains(document.activeElement));
};
function sre(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: r = lre,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: t = "Mui",
    autoComplete: n = !1,
    autoHighlight: o = !1,
    autoSelect: a = !1,
    blurOnSelect: i = !1,
    clearOnBlur: l = !e.freeSolo,
    clearOnEscape: s = !1,
    componentName: u = "useAutocomplete",
    defaultValue: d = e.multiple ? [] : null,
    disableClearable: f = !1,
    disableCloseOnSelect: p = !1,
    disabled: g,
    disabledItemsFocusable: h = !1,
    disableListWrap: v = !1,
    filterOptions: y = ire,
    filterSelectedOptions: w = !1,
    freeSolo: $ = !1,
    getOptionDisabled: C,
    getOptionKey: x,
    getOptionLabel: b = (ee) => {
      var K;
      return (K = ee.label) != null ? K : ee;
    },
    groupBy: O,
    handleHomeEndKeys: _ = !e.freeSolo,
    id: P,
    includeInputInList: S = !1,
    inputValue: I,
    isOptionEqualToValue: N = (ee, K) => ee === K,
    multiple: k = !1,
    onChange: j,
    onClose: R,
    onHighlightChange: D,
    onInputChange: T,
    onOpen: V,
    open: L,
    openOnFocus: Z = !1,
    options: z,
    readOnly: W = !1,
    selectOnFocus: U = !e.freeSolo,
    value: re
  } = e, X = df(P);
  let J = b;
  J = (ee) => {
    const K = b(ee);
    if (typeof K != "string") {
      if (process.env.NODE_ENV !== "production") {
        const be = K === void 0 ? "undefined" : `${typeof K} (${K})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${u} returned ${be} instead of a string for ${JSON.stringify(ee)}.`);
      }
      return String(K);
    }
    return K;
  };
  const Q = A.useRef(!1), se = A.useRef(!0), q = A.useRef(null), te = A.useRef(null), [ae, ge] = A.useState(null), [G, oe] = A.useState(-1), ne = o ? 0 : -1, _e = A.useRef(ne), [ye, Te] = ia({
    controlled: re,
    default: d,
    name: u
  }), [we, He] = ia({
    controlled: I,
    default: "",
    name: u,
    state: "inputValue"
  }), [he, xe] = A.useState(!1), Le = A.useCallback((ee, K) => {
    if (!(k ? ye.length < K.length : K !== null) && !l)
      return;
    let pe;
    if (k)
      pe = "";
    else if (K == null)
      pe = "";
    else {
      const Ze = J(K);
      pe = typeof Ze == "string" ? Ze : "";
    }
    we !== pe && (He(pe), T && T(ee, pe, "reset"));
  }, [J, we, k, T, He, l, ye]), [Ue, me] = ia({
    controlled: L,
    default: !1,
    name: u,
    state: "open"
  }), [Ie, er] = A.useState(!0), Ke = !k && ye != null && we === J(ye), Me = Ue && !W, Pe = Me ? y(
    z.filter((ee) => !(w && (k ? ye : [ye]).some((K) => K !== null && N(ee, K)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Ke && Ie ? "" : we,
      getOptionLabel: J
    }
  ) : [], Qe = YE({
    filteredOptions: Pe,
    value: ye,
    inputValue: we
  });
  A.useEffect(() => {
    const ee = ye !== Qe.value;
    he && !ee || $ && !ee || Le(null, ye);
  }, [ye, Le, he, Qe.value, $]);
  const Sr = Ue && Pe.length > 0 && !W;
  if (process.env.NODE_ENV !== "production" && ye !== null && !$ && z.length > 0) {
    const ee = (k ? ye : [ye]).filter((K) => !z.some((be) => N(be, K)));
    ee.length > 0 && console.warn([`MUI: The value provided to ${u} is invalid.`, `None of the options match with \`${ee.length > 1 ? JSON.stringify(ee) : JSON.stringify(ee[0])}\`.`, "You can use the `isOptionEqualToValue` prop to customize the equality test."].join(`
`));
  }
  const Cr = on((ee) => {
    ee === -1 ? q.current.focus() : ae.querySelector(`[data-tag-index="${ee}"]`).focus();
  });
  A.useEffect(() => {
    k && G > ye.length - 1 && (oe(-1), Cr(-1));
  }, [ye, k, G, Cr]);
  function nr(ee, K) {
    if (!te.current || ee < 0 || ee >= Pe.length)
      return -1;
    let be = ee;
    for (; ; ) {
      const pe = te.current.querySelector(`[data-option-index="${be}"]`), Ze = h ? !1 : !pe || pe.disabled || pe.getAttribute("aria-disabled") === "true";
      if (pe && pe.hasAttribute("tabindex") && !Ze)
        return be;
      if (K === "next" ? be = (be + 1) % Pe.length : be = (be - 1 + Pe.length) % Pe.length, be === ee)
        return -1;
    }
  }
  const De = on(({
    event: ee,
    index: K,
    reason: be = "auto"
  }) => {
    if (_e.current = K, K === -1 ? q.current.removeAttribute("aria-activedescendant") : q.current.setAttribute("aria-activedescendant", `${X}-option-${K}`), D && D(ee, K === -1 ? null : Pe[K], be), !te.current)
      return;
    const pe = te.current.querySelector(`[role="option"].${t}-focused`);
    pe && (pe.classList.remove(`${t}-focused`), pe.classList.remove(`${t}-focusVisible`));
    let Ze = te.current;
    if (te.current.getAttribute("role") !== "listbox" && (Ze = te.current.parentElement.querySelector('[role="listbox"]')), !Ze)
      return;
    if (K === -1) {
      Ze.scrollTop = 0;
      return;
    }
    const Ye = te.current.querySelector(`[data-option-index="${K}"]`);
    if (Ye && (Ye.classList.add(`${t}-focused`), be === "keyboard" && Ye.classList.add(`${t}-focusVisible`), Ze.scrollHeight > Ze.clientHeight && be !== "mouse" && be !== "touch")) {
      const rr = Ye, Pr = Ze.clientHeight + Ze.scrollTop, Wt = rr.offsetTop + rr.offsetHeight;
      Wt > Pr ? Ze.scrollTop = Wt - Ze.clientHeight : rr.offsetTop - rr.offsetHeight * (O ? 1.3 : 0) < Ze.scrollTop && (Ze.scrollTop = rr.offsetTop - rr.offsetHeight * (O ? 1.3 : 0));
    }
  }), Ge = on(({
    event: ee,
    diff: K,
    direction: be = "next",
    reason: pe = "auto"
  }) => {
    if (!Me)
      return;
    const Ye = nr((() => {
      const rr = Pe.length - 1;
      if (K === "reset")
        return ne;
      if (K === "start")
        return 0;
      if (K === "end")
        return rr;
      const Pr = _e.current + K;
      return Pr < 0 ? Pr === -1 && S ? -1 : v && _e.current !== -1 || Math.abs(K) > 1 ? 0 : rr : Pr > rr ? Pr === rr + 1 && S ? -1 : v || Math.abs(K) > 1 ? rr : 0 : Pr;
    })(), be);
    if (De({
      index: Ye,
      reason: pe,
      event: ee
    }), n && K !== "reset")
      if (Ye === -1)
        q.current.value = we;
      else {
        const rr = J(Pe[Ye]);
        q.current.value = rr, rr.toLowerCase().indexOf(we.toLowerCase()) === 0 && we.length > 0 && q.current.setSelectionRange(we.length, rr.length);
      }
  }), lr = () => {
    const ee = (K, be) => {
      const pe = K ? J(K) : "", Ze = be ? J(be) : "";
      return pe === Ze;
    };
    if (_e.current !== -1 && Qe.filteredOptions && Qe.filteredOptions.length !== Pe.length && Qe.inputValue === we && (k ? ye.length === Qe.value.length && Qe.value.every((K, be) => J(ye[be]) === J(K)) : ee(Qe.value, ye))) {
      const K = Qe.filteredOptions[_e.current];
      if (K)
        return Pl(Pe, (be) => J(be) === J(K));
    }
    return -1;
  }, Ir = A.useCallback(() => {
    if (!Me)
      return;
    const ee = lr();
    if (ee !== -1) {
      _e.current = ee;
      return;
    }
    const K = k ? ye[0] : ye;
    if (Pe.length === 0 || K == null) {
      Ge({
        diff: "reset"
      });
      return;
    }
    if (te.current) {
      if (K != null) {
        const be = Pe[_e.current];
        if (k && be && Pl(ye, (Ze) => N(be, Ze)) !== -1)
          return;
        const pe = Pl(Pe, (Ze) => N(Ze, K));
        pe === -1 ? Ge({
          diff: "reset"
        }) : De({
          index: pe
        });
        return;
      }
      if (_e.current >= Pe.length - 1) {
        De({
          index: Pe.length - 1
        });
        return;
      }
      De({
        index: _e.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    Pe.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    k ? !1 : ye,
    w,
    Ge,
    De,
    Me,
    we,
    k
  ]), Or = on((ee) => {
    as(te, ee), ee && Ir();
  });
  process.env.NODE_ENV !== "production" && A.useEffect(() => {
    (!q.current || q.current.nodeName !== "INPUT") && (q.current && q.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${u} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${q.current} while an HTMLInputElement was expected.`, `Instead, ${u} expects an input element.`, "", u === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [u]), A.useEffect(() => {
    Ir();
  }, [Ir]);
  const $r = (ee) => {
    Ue || (me(!0), er(!0), V && V(ee));
  }, ar = (ee, K) => {
    Ue && (me(!1), R && R(ee, K));
  }, cr = (ee, K, be, pe) => {
    if (k) {
      if (ye.length === K.length && ye.every((Ze, Ye) => Ze === K[Ye]))
        return;
    } else if (ye === K)
      return;
    j && j(ee, K, be, pe), Te(K);
  }, Vr = A.useRef(!1), pt = (ee, K, be = "selectOption", pe = "options") => {
    let Ze = be, Ye = K;
    if (k) {
      if (Ye = Array.isArray(ye) ? ye.slice() : [], process.env.NODE_ENV !== "production") {
        const Pr = Ye.filter((Wt) => N(K, Wt));
        Pr.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${u} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${Pr.length} matches.`].join(`
`));
      }
      const rr = Pl(Ye, (Pr) => N(K, Pr));
      rr === -1 ? Ye.push(K) : pe !== "freeSolo" && (Ye.splice(rr, 1), Ze = "removeOption");
    }
    Le(ee, Ye), cr(ee, Ye, Ze, {
      option: K
    }), !p && (!ee || !ee.ctrlKey && !ee.metaKey) && ar(ee, Ze), (i === !0 || i === "touch" && Vr.current || i === "mouse" && !Vr.current) && q.current.blur();
  };
  function et(ee, K) {
    if (ee === -1)
      return -1;
    let be = ee;
    for (; ; ) {
      if (K === "next" && be === ye.length || K === "previous" && be === -1)
        return -1;
      const pe = ae.querySelector(`[data-tag-index="${be}"]`);
      if (!pe || !pe.hasAttribute("tabindex") || pe.disabled || pe.getAttribute("aria-disabled") === "true")
        be += K === "next" ? 1 : -1;
      else
        return be;
    }
  }
  const jn = (ee, K) => {
    if (!k)
      return;
    we === "" && ar(ee, "toggleInput");
    let be = G;
    G === -1 ? we === "" && K === "previous" && (be = ye.length - 1) : (be += K === "next" ? 1 : -1, be < 0 && (be = 0), be === ye.length && (be = -1)), be = et(be, K), oe(be), Cr(be);
  }, St = (ee) => {
    Q.current = !0, He(""), T && T(ee, "", "clear"), cr(ee, k ? [] : null, "clear");
  }, Er = (ee) => (K) => {
    if (ee.onKeyDown && ee.onKeyDown(K), !K.defaultMuiPrevented && (G !== -1 && ["ArrowLeft", "ArrowRight"].indexOf(K.key) === -1 && (oe(-1), Cr(-1)), K.which !== 229))
      switch (K.key) {
        case "Home":
          Me && _ && (K.preventDefault(), Ge({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: K
          }));
          break;
        case "End":
          Me && _ && (K.preventDefault(), Ge({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: K
          }));
          break;
        case "PageUp":
          K.preventDefault(), Ge({
            diff: -S9,
            direction: "previous",
            reason: "keyboard",
            event: K
          }), $r(K);
          break;
        case "PageDown":
          K.preventDefault(), Ge({
            diff: S9,
            direction: "next",
            reason: "keyboard",
            event: K
          }), $r(K);
          break;
        case "ArrowDown":
          K.preventDefault(), Ge({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: K
          }), $r(K);
          break;
        case "ArrowUp":
          K.preventDefault(), Ge({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: K
          }), $r(K);
          break;
        case "ArrowLeft":
          jn(K, "previous");
          break;
        case "ArrowRight":
          jn(K, "next");
          break;
        case "Enter":
          if (_e.current !== -1 && Me) {
            const be = Pe[_e.current], pe = C ? C(be) : !1;
            if (K.preventDefault(), pe)
              return;
            pt(K, be, "selectOption"), n && q.current.setSelectionRange(q.current.value.length, q.current.value.length);
          } else
            $ && we !== "" && Ke === !1 && (k && K.preventDefault(), pt(K, we, "createOption", "freeSolo"));
          break;
        case "Escape":
          Me ? (K.preventDefault(), K.stopPropagation(), ar(K, "escape")) : s && (we !== "" || k && ye.length > 0) && (K.preventDefault(), K.stopPropagation(), St(K));
          break;
        case "Backspace":
          if (k && !W && we === "" && ye.length > 0) {
            const be = G === -1 ? ye.length - 1 : G, pe = ye.slice();
            pe.splice(be, 1), cr(K, pe, "removeOption", {
              option: ye[be]
            });
          }
          break;
        case "Delete":
          if (k && !W && we === "" && ye.length > 0 && G !== -1) {
            const be = G, pe = ye.slice();
            pe.splice(be, 1), cr(K, pe, "removeOption", {
              option: ye[be]
            });
          }
          break;
      }
  }, Ln = (ee) => {
    xe(!0), Z && !Q.current && $r(ee);
  }, rt = (ee) => {
    if (r(te)) {
      q.current.focus();
      return;
    }
    xe(!1), se.current = !0, Q.current = !1, a && _e.current !== -1 && Me ? pt(ee, Pe[_e.current], "blur") : a && $ && we !== "" ? pt(ee, we, "blur", "freeSolo") : l && Le(ee, ye), ar(ee, "blur");
  }, gr = (ee) => {
    const K = ee.target.value;
    we !== K && (He(K), er(!1), T && T(ee, K, "input")), K === "" ? !f && !k && cr(ee, null, "clear") : $r(ee);
  }, Ar = (ee) => {
    const K = Number(ee.currentTarget.getAttribute("data-option-index"));
    _e.current !== K && De({
      event: ee,
      index: K,
      reason: "mouse"
    });
  }, Yr = (ee) => {
    De({
      event: ee,
      index: Number(ee.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), Vr.current = !0;
  }, vn = (ee) => {
    const K = Number(ee.currentTarget.getAttribute("data-option-index"));
    pt(ee, Pe[K], "selectOption"), Vr.current = !1;
  }, lo = (ee) => (K) => {
    const be = ye.slice();
    be.splice(ee, 1), cr(K, be, "removeOption", {
      option: ye[ee]
    });
  }, so = (ee) => {
    Ue ? ar(ee, "toggleInput") : $r(ee);
  }, co = (ee) => {
    ee.currentTarget.contains(ee.target) && ee.target.getAttribute("id") !== X && ee.preventDefault();
  }, H = (ee) => {
    ee.currentTarget.contains(ee.target) && (q.current.focus(), U && se.current && q.current.selectionEnd - q.current.selectionStart === 0 && q.current.select(), se.current = !1);
  }, Ce = (ee) => {
    !g && (we === "" || !Ue) && so(ee);
  };
  let ie = $ && we.length > 0;
  ie = ie || (k ? ye.length > 0 : ye !== null);
  let Re = Pe;
  if (O) {
    const ee = /* @__PURE__ */ new Map();
    let K = !1;
    Re = Pe.reduce((be, pe, Ze) => {
      const Ye = O(pe);
      return be.length > 0 && be[be.length - 1].group === Ye ? be[be.length - 1].options.push(pe) : (process.env.NODE_ENV !== "production" && (ee.get(Ye) && !K && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${u} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), K = !0), ee.set(Ye, !0)), be.push({
        key: Ze,
        index: Ze,
        group: Ye,
        options: [pe]
      })), be;
    }, []);
  }
  return g && he && rt(), {
    getRootProps: (ee = {}) => F({
      "aria-owns": Sr ? `${X}-listbox` : null
    }, ee, {
      onKeyDown: Er(ee),
      onMouseDown: co,
      onClick: H
    }),
    getInputLabelProps: () => ({
      id: `${X}-label`,
      htmlFor: X
    }),
    getInputProps: () => ({
      id: X,
      value: we,
      onBlur: rt,
      onFocus: Ln,
      onChange: gr,
      onMouseDown: Ce,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": Me ? "" : null,
      "aria-autocomplete": n ? "both" : "list",
      "aria-controls": Sr ? `${X}-listbox` : void 0,
      "aria-expanded": Sr,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: q,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: g
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: St
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: so
    }),
    getTagProps: ({
      index: ee
    }) => F({
      key: ee,
      "data-tag-index": ee,
      tabIndex: -1
    }, !W && {
      onDelete: lo(ee)
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${X}-listbox`,
      "aria-labelledby": `${X}-label`,
      ref: Or,
      onMouseDown: (ee) => {
        ee.preventDefault();
      }
    }),
    getOptionProps: ({
      index: ee,
      option: K
    }) => {
      var be;
      const pe = (k ? ye : [ye]).some((Ye) => Ye != null && N(K, Ye)), Ze = C ? C(K) : !1;
      return {
        key: (be = x == null ? void 0 : x(K)) != null ? be : J(K),
        tabIndex: -1,
        role: "option",
        id: `${X}-option-${ee}`,
        onMouseMove: Ar,
        onClick: vn,
        onTouchStart: Yr,
        "data-option-index": ee,
        "aria-disabled": Ze,
        "aria-selected": pe
      };
    },
    id: X,
    inputValue: we,
    value: ye,
    dirty: ie,
    expanded: Me && ae,
    popupOpen: Me,
    focused: he || G !== -1,
    anchorEl: ae,
    setAnchorEl: ge,
    focusedTag: G,
    groupedOptions: Re
  };
}
var a2 = {};
Object.defineProperty(a2, "__esModule", {
  value: !0
});
var __ = a2.default = void 0, cre = dre(E), ure = x6;
function x_(e) {
  if (typeof WeakMap != "function")
    return null;
  var r = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (x_ = function(n) {
    return n ? t : r;
  })(e);
}
function dre(e, r) {
  if (!r && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var t = x_(r);
  if (t && t.has(e))
    return t.get(e);
  var n = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var a in e)
    if (a !== "default" && Object.prototype.hasOwnProperty.call(e, a)) {
      var i = o ? Object.getOwnPropertyDescriptor(e, a) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, a, i) : n[a] = e[a];
    }
  return n.default = e, t && t.set(e, n), n;
}
function fre(e) {
  return Object.keys(e).length === 0;
}
function pre(e = null) {
  const r = cre.useContext(ure.ThemeContext);
  return !r || fre(r) ? e : r;
}
__ = a2.default = pre;
const gre = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], vre = Be(y_, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, r) => r.root
})({}), $_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n;
  const o = __(), a = xr({
    props: r,
    name: "MuiPopper"
  }), {
    anchorEl: i,
    component: l,
    components: s,
    componentsProps: u,
    container: d,
    disablePortal: f,
    keepMounted: p,
    modifiers: g,
    open: h,
    placement: v,
    popperOptions: y,
    popperRef: w,
    transition: $,
    slots: C,
    slotProps: x
  } = a, b = Xe(a, gre), O = (n = C == null ? void 0 : C.root) != null ? n : s == null ? void 0 : s.Root, _ = F({
    anchorEl: i,
    container: d,
    disablePortal: f,
    keepMounted: p,
    modifiers: g,
    open: h,
    placement: v,
    popperOptions: y,
    popperRef: w,
    transition: $
  }, b);
  return /* @__PURE__ */ le.jsx(vre, F({
    as: l,
    direction: o == null ? void 0 : o.direction,
    slots: {
      root: O
    },
    slotProps: x != null ? x : u
  }, _, {
    ref: t
  }));
});
process.env.NODE_ENV !== "production" && ($_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: c.oneOfType([$n, c.object, c.func]),
  /**
   * Popper render function or node.
   */
  children: c.oneOfType([c.node, c.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: c.shape({
    Root: c.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([$n, c.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: c.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: c.arrayOf(c.shape({
    data: c.object,
    effect: c.func,
    enabled: c.bool,
    fn: c.func,
    name: c.any,
    options: c.object,
    phase: c.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: c.arrayOf(c.string),
    requiresIfExists: c.arrayOf(c.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: c.shape({
    modifiers: c.array,
    onFirstUpdate: c.func,
    placement: c.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: c.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: qt,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: c.shape({
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: c.bool
});
const S1 = $_;
function mre(e) {
  return yr("MuiListSubheader", e);
}
wr("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const hre = ["className", "color", "component", "disableGutters", "disableSticky", "inset"], bre = (e) => {
  const {
    classes: r,
    color: t,
    disableGutters: n,
    inset: o,
    disableSticky: a
  } = e, i = {
    root: ["root", t !== "default" && `color${ze(t)}`, !n && "gutters", o && "inset", !a && "sticky"]
  };
  return _r(i, mre, r);
}, yre = Be("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, t.color !== "default" && r[`color${ze(t.color)}`], !t.disableGutters && r.gutters, t.inset && r.inset, !t.disableSticky && r.sticky];
  }
})(({
  theme: e,
  ownerState: r
}) => F({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14)
}, r.color === "primary" && {
  color: (e.vars || e).palette.primary.main
}, r.color === "inherit" && {
  color: "inherit"
}, !r.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, r.inset && {
  paddingLeft: 72
}, !r.disableSticky && {
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: (e.vars || e).palette.background.paper
})), i2 = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiListSubheader"
  }), {
    className: o,
    color: a = "default",
    component: i = "li",
    disableGutters: l = !1,
    disableSticky: s = !1,
    inset: u = !1
  } = n, d = Xe(n, hre), f = F({}, n, {
    color: a,
    component: i,
    disableGutters: l,
    disableSticky: s,
    inset: u
  }), p = bre(f);
  return /* @__PURE__ */ le.jsx(yre, F({
    as: i,
    className: qe(p.root, o),
    ref: t,
    ownerState: f
  }, d));
});
i2.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (i2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: c.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: c.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: c.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const Cre = i2, wre = zo(/* @__PURE__ */ le.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function _re(e) {
  return yr("MuiChip", e);
}
const xre = wr("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), dr = xre, $re = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], Ore = (e) => {
  const {
    classes: r,
    disabled: t,
    size: n,
    color: o,
    iconColor: a,
    onDelete: i,
    clickable: l,
    variant: s
  } = e, u = {
    root: ["root", s, t && "disabled", `size${ze(n)}`, `color${ze(o)}`, l && "clickable", l && `clickableColor${ze(o)}`, i && "deletable", i && `deletableColor${ze(o)}`, `${s}${ze(o)}`],
    label: ["label", `label${ze(n)}`],
    avatar: ["avatar", `avatar${ze(n)}`, `avatarColor${ze(o)}`],
    icon: ["icon", `icon${ze(n)}`, `iconColor${ze(a)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${ze(n)}`, `deleteIconColor${ze(o)}`, `deleteIcon${ze(s)}Color${ze(o)}`]
  };
  return _r(u, _re, r);
}, Pre = Be("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e, {
      color: n,
      iconColor: o,
      clickable: a,
      onDelete: i,
      size: l,
      variant: s
    } = t;
    return [{
      [`& .${dr.avatar}`]: r.avatar
    }, {
      [`& .${dr.avatar}`]: r[`avatar${ze(l)}`]
    }, {
      [`& .${dr.avatar}`]: r[`avatarColor${ze(n)}`]
    }, {
      [`& .${dr.icon}`]: r.icon
    }, {
      [`& .${dr.icon}`]: r[`icon${ze(l)}`]
    }, {
      [`& .${dr.icon}`]: r[`iconColor${ze(o)}`]
    }, {
      [`& .${dr.deleteIcon}`]: r.deleteIcon
    }, {
      [`& .${dr.deleteIcon}`]: r[`deleteIcon${ze(l)}`]
    }, {
      [`& .${dr.deleteIcon}`]: r[`deleteIconColor${ze(n)}`]
    }, {
      [`& .${dr.deleteIcon}`]: r[`deleteIcon${ze(s)}Color${ze(n)}`]
    }, r.root, r[`size${ze(l)}`], r[`color${ze(n)}`], a && r.clickable, a && n !== "default" && r[`clickableColor${ze(n)})`], i && r.deletable, i && n !== "default" && r[`deletableColor${ze(n)}`], r[s], r[`${s}${ze(n)}`]];
  }
})(({
  theme: e,
  ownerState: r
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return F({
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${dr.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${dr.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${dr.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${dr.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${dr.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${dr.icon}`]: F({
      marginLeft: 5,
      marginRight: -6
    }, r.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, r.iconColor === r.color && F({
      color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
    }, r.color !== "default" && {
      color: "inherit"
    })),
    [`& .${dr.deleteIcon}`]: F({
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : Mr(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Mr(e.palette.text.primary, 0.4)
      }
    }, r.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, r.color !== "default" && {
      color: e.vars ? `rgba(${e.vars.palette[r.color].contrastTextChannel} / 0.7)` : Mr(e.palette[r.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (e.vars || e).palette[r.color].contrastText
      }
    })
  }, r.size === "small" && {
    height: 24
  }, r.color !== "default" && {
    backgroundColor: (e.vars || e).palette[r.color].main,
    color: (e.vars || e).palette[r.color].contrastText
  }, r.onDelete && {
    [`&.${dr.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mr(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }, r.onDelete && r.color !== "default" && {
    [`&.${dr.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[r.color].dark
    }
  });
}, ({
  theme: e,
  ownerState: r
}) => F({}, r.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mr(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
  },
  [`&.${dr.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mr(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (e.vars || e).shadows[1]
  }
}, r.clickable && r.color !== "default" && {
  [`&:hover, &.${dr.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette[r.color].dark
  }
}), ({
  theme: e,
  ownerState: r
}) => F({}, r.variant === "outlined" && {
  backgroundColor: "transparent",
  border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
  [`&.${dr.clickable}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${dr.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`& .${dr.avatar}`]: {
    marginLeft: 4
  },
  [`& .${dr.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${dr.icon}`]: {
    marginLeft: 4
  },
  [`& .${dr.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${dr.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${dr.deleteIconSmall}`]: {
    marginRight: 3
  }
}, r.variant === "outlined" && r.color !== "default" && {
  color: (e.vars || e).palette[r.color].main,
  border: `1px solid ${e.vars ? `rgba(${e.vars.palette[r.color].mainChannel} / 0.7)` : Mr(e.palette[r.color].main, 0.7)}`,
  [`&.${dr.clickable}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[r.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Mr(e.palette[r.color].main, e.palette.action.hoverOpacity)
  },
  [`&.${dr.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[r.color].mainChannel} / ${e.vars.palette.action.focusOpacity})` : Mr(e.palette[r.color].main, e.palette.action.focusOpacity)
  },
  [`& .${dr.deleteIcon}`]: {
    color: e.vars ? `rgba(${e.vars.palette[r.color].mainChannel} / 0.7)` : Mr(e.palette[r.color].main, 0.7),
    "&:hover, &:active": {
      color: (e.vars || e).palette[r.color].main
    }
  }
})), Sre = Be("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e, {
      size: n
    } = t;
    return [r.label, r[`label${ze(n)}`]];
  }
})(({
  ownerState: e
}) => F({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, e.variant === "outlined" && {
  paddingLeft: 11,
  paddingRight: 11
}, e.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.size === "small" && e.variant === "outlined" && {
  paddingLeft: 7,
  paddingRight: 7
}));
function I9(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const O_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiChip"
  }), {
    avatar: o,
    className: a,
    clickable: i,
    color: l = "default",
    component: s,
    deleteIcon: u,
    disabled: d = !1,
    icon: f,
    label: p,
    onClick: g,
    onDelete: h,
    onKeyDown: v,
    onKeyUp: y,
    size: w = "medium",
    variant: $ = "filled",
    tabIndex: C,
    skipFocusWhenDisabled: x = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = n, b = Xe(n, $re), O = A.useRef(null), _ = Xr(O, t), P = (Z) => {
    Z.stopPropagation(), h && h(Z);
  }, S = (Z) => {
    Z.currentTarget === Z.target && I9(Z) && Z.preventDefault(), v && v(Z);
  }, I = (Z) => {
    Z.currentTarget === Z.target && (h && I9(Z) ? h(Z) : Z.key === "Escape" && O.current && O.current.blur()), y && y(Z);
  }, N = i !== !1 && g ? !0 : i, k = N || h ? gu : s || "div", j = F({}, n, {
    component: k,
    disabled: d,
    size: w,
    color: l,
    iconColor: /* @__PURE__ */ A.isValidElement(f) && f.props.color || l,
    onDelete: !!h,
    clickable: N,
    variant: $
  }), R = Ore(j), D = k === gu ? F({
    component: s || "div",
    focusVisibleClassName: R.focusVisible
  }, h && {
    disableRipple: !0
  }) : {};
  let T = null;
  h && (T = u && /* @__PURE__ */ A.isValidElement(u) ? /* @__PURE__ */ A.cloneElement(u, {
    className: qe(u.props.className, R.deleteIcon),
    onClick: P
  }) : /* @__PURE__ */ le.jsx(wre, {
    className: qe(R.deleteIcon),
    onClick: P
  }));
  let V = null;
  o && /* @__PURE__ */ A.isValidElement(o) && (V = /* @__PURE__ */ A.cloneElement(o, {
    className: qe(R.avatar, o.props.className)
  }));
  let L = null;
  return f && /* @__PURE__ */ A.isValidElement(f) && (L = /* @__PURE__ */ A.cloneElement(f, {
    className: qe(R.icon, f.props.className)
  })), process.env.NODE_ENV !== "production" && V && L && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ le.jsxs(Pre, F({
    as: k,
    className: qe(R.root, a),
    disabled: N && d ? !0 : void 0,
    onClick: g,
    onKeyDown: S,
    onKeyUp: I,
    ref: _,
    tabIndex: x && d ? -1 : C,
    ownerState: j
  }, D, b, {
    children: [V || L, /* @__PURE__ */ le.jsx(Sre, {
      className: qe(R.label),
      ownerState: j,
      children: p
    }), T]
  }));
});
process.env.NODE_ENV !== "production" && (O_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: c.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: DE,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: c.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: c.oneOfType([c.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: c.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * Icon element.
   */
  icon: c.element,
  /**
   * The content of the component.
   */
  label: c.node,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * @ignore
   */
  onKeyUp: c.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * @ignore
   */
  tabIndex: c.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: c.oneOfType([c.oneOf(["filled", "outlined"]), c.string])
});
const Ire = O_;
function Ma({
  props: e,
  states: r,
  muiFormControl: t
}) {
  return r.reduce((n, o) => (n[o] = e[o], t && typeof e[o] == "undefined" && (n[o] = t[o]), n), {});
}
const P_ = /* @__PURE__ */ A.createContext(void 0);
process.env.NODE_ENV !== "production" && (P_.displayName = "FormControlContext");
const I1 = P_;
function Vo() {
  return A.useContext(I1);
}
function S_(e) {
  return /* @__PURE__ */ le.jsx(Y8, F({}, e, {
    defaultTheme: c1,
    themeId: da
  }));
}
process.env.NODE_ENV !== "production" && (S_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: c.oneOfType([c.array, c.func, c.number, c.object, c.string, c.bool])
});
function E9(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function bu(e, r = !1) {
  return e && (E9(e.value) && e.value !== "" || r && E9(e.defaultValue) && e.defaultValue !== "");
}
function Ere(e) {
  return e.startAdornment;
}
function Rre(e) {
  return yr("MuiInputBase", e);
}
const Are = wr("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), mt = Are, kre = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], E1 = (e, r) => {
  const {
    ownerState: t
  } = e;
  return [r.root, t.formControl && r.formControl, t.startAdornment && r.adornedStart, t.endAdornment && r.adornedEnd, t.error && r.error, t.size === "small" && r.sizeSmall, t.multiline && r.multiline, t.color && r[`color${ze(t.color)}`], t.fullWidth && r.fullWidth, t.hiddenLabel && r.hiddenLabel];
}, R1 = (e, r) => {
  const {
    ownerState: t
  } = e;
  return [r.input, t.size === "small" && r.inputSizeSmall, t.multiline && r.inputMultiline, t.type === "search" && r.inputTypeSearch, t.startAdornment && r.inputAdornedStart, t.endAdornment && r.inputAdornedEnd, t.hiddenLabel && r.inputHiddenLabel];
}, Mre = (e) => {
  const {
    classes: r,
    color: t,
    disabled: n,
    error: o,
    endAdornment: a,
    focused: i,
    formControl: l,
    fullWidth: s,
    hiddenLabel: u,
    multiline: d,
    readOnly: f,
    size: p,
    startAdornment: g,
    type: h
  } = e, v = {
    root: ["root", `color${ze(t)}`, n && "disabled", o && "error", s && "fullWidth", i && "focused", l && "formControl", p && p !== "medium" && `size${ze(p)}`, d && "multiline", g && "adornedStart", a && "adornedEnd", u && "hiddenLabel", f && "readOnly"],
    input: ["input", n && "disabled", h === "search" && "inputTypeSearch", d && "inputMultiline", p === "small" && "inputSizeSmall", u && "inputHiddenLabel", g && "inputAdornedStart", a && "inputAdornedEnd", f && "readOnly"]
  };
  return _r(v, Rre, r);
}, A1 = Be("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: E1
})(({
  theme: e,
  ownerState: r
}) => F({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${mt.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, r.multiline && F({
  padding: "4px 0 5px"
}, r.size === "small" && {
  paddingTop: 1
}), r.fullWidth && {
  width: "100%"
})), k1 = Be("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: R1
})(({
  theme: e,
  ownerState: r
}) => {
  const t = e.palette.mode === "light", n = F({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), o = {
    opacity: "0 !important"
  }, a = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return F({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&:-ms-input-placeholder": n,
    // IE11
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${mt.formControl} &`]: {
      "&::-webkit-input-placeholder": o,
      "&::-moz-placeholder": o,
      // Firefox 19+
      "&:-ms-input-placeholder": o,
      // IE11
      "&::-ms-input-placeholder": o,
      // Edge
      "&:focus::-webkit-input-placeholder": a,
      "&:focus::-moz-placeholder": a,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": a,
      // IE11
      "&:focus::-ms-input-placeholder": a
      // Edge
    },
    [`&.${mt.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, r.size === "small" && {
    paddingTop: 1
  }, r.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, r.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), Nre = /* @__PURE__ */ le.jsx(S_, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), I_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n;
  const o = xr({
    props: r,
    name: "MuiInputBase"
  }), {
    "aria-describedby": a,
    autoComplete: i,
    autoFocus: l,
    className: s,
    components: u = {},
    componentsProps: d = {},
    defaultValue: f,
    disabled: p,
    disableInjectingGlobalStyles: g,
    endAdornment: h,
    fullWidth: v = !1,
    id: y,
    inputComponent: w = "input",
    inputProps: $ = {},
    inputRef: C,
    maxRows: x,
    minRows: b,
    multiline: O = !1,
    name: _,
    onBlur: P,
    onChange: S,
    onClick: I,
    onFocus: N,
    onKeyDown: k,
    onKeyUp: j,
    placeholder: R,
    readOnly: D,
    renderSuffix: T,
    rows: V,
    slotProps: L = {},
    slots: Z = {},
    startAdornment: z,
    type: W = "text",
    value: U
  } = o, re = Xe(o, kre), X = $.value != null ? $.value : U, {
    current: J
  } = A.useRef(X != null), Q = A.useRef(), se = A.useCallback((Me) => {
    process.env.NODE_ENV !== "production" && Me && Me.nodeName !== "INPUT" && !Me.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), q = Xr(Q, C, $.ref, se), [te, ae] = A.useState(!1), ge = Vo();
  process.env.NODE_ENV !== "production" && A.useEffect(() => {
    if (ge)
      return ge.registerEffect();
  }, [ge]);
  const G = Ma({
    props: o,
    muiFormControl: ge,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  G.focused = ge ? ge.focused : te, A.useEffect(() => {
    !ge && p && te && (ae(!1), P && P());
  }, [ge, p, te, P]);
  const oe = ge && ge.onFilled, ne = ge && ge.onEmpty, _e = A.useCallback((Me) => {
    bu(Me) ? oe && oe() : ne && ne();
  }, [oe, ne]);
  _n(() => {
    J && _e({
      value: X
    });
  }, [X, _e, J]);
  const ye = (Me) => {
    if (G.disabled) {
      Me.stopPropagation();
      return;
    }
    N && N(Me), $.onFocus && $.onFocus(Me), ge && ge.onFocus ? ge.onFocus(Me) : ae(!0);
  }, Te = (Me) => {
    P && P(Me), $.onBlur && $.onBlur(Me), ge && ge.onBlur ? ge.onBlur(Me) : ae(!1);
  }, we = (Me, ...Pe) => {
    if (!J) {
      const Qe = Me.target || Q.current;
      if (Qe == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : Io(1));
      _e({
        value: Qe.value
      });
    }
    $.onChange && $.onChange(Me, ...Pe), S && S(Me, ...Pe);
  };
  A.useEffect(() => {
    _e(Q.current);
  }, []);
  const He = (Me) => {
    Q.current && Me.currentTarget === Me.target && Q.current.focus(), I && I(Me);
  };
  let he = w, xe = $;
  O && he === "input" && (V ? (process.env.NODE_ENV !== "production" && (b || x) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), xe = F({
    type: void 0,
    minRows: V,
    maxRows: V
  }, xe)) : xe = F({
    type: void 0,
    maxRows: x,
    minRows: b
  }, xe), he = C_);
  const Le = (Me) => {
    _e(Me.animationName === "mui-auto-fill-cancel" ? Q.current : {
      value: "x"
    });
  };
  A.useEffect(() => {
    ge && ge.setAdornedStart(!!z);
  }, [ge, z]);
  const Ue = F({}, o, {
    color: G.color || "primary",
    disabled: G.disabled,
    endAdornment: h,
    error: G.error,
    focused: G.focused,
    formControl: ge,
    fullWidth: v,
    hiddenLabel: G.hiddenLabel,
    multiline: O,
    size: G.size,
    startAdornment: z,
    type: W
  }), me = Mre(Ue), Ie = Z.root || u.Root || A1, er = L.root || d.root || {}, Ke = Z.input || u.Input || k1;
  return xe = F({}, xe, (n = L.input) != null ? n : d.input), /* @__PURE__ */ le.jsxs(A.Fragment, {
    children: [!g && Nre, /* @__PURE__ */ le.jsxs(Ie, F({}, er, !pu(Ie) && {
      ownerState: F({}, Ue, er.ownerState)
    }, {
      ref: t,
      onClick: He
    }, re, {
      className: qe(me.root, er.className, s, D && "MuiInputBase-readOnly"),
      children: [z, /* @__PURE__ */ le.jsx(I1.Provider, {
        value: null,
        children: /* @__PURE__ */ le.jsx(Ke, F({
          ownerState: Ue,
          "aria-invalid": G.error,
          "aria-describedby": a,
          autoComplete: i,
          autoFocus: l,
          defaultValue: f,
          disabled: G.disabled,
          id: y,
          onAnimationStart: Le,
          name: _,
          placeholder: R,
          readOnly: D,
          required: G.required,
          rows: V,
          value: X,
          onKeyDown: k,
          onKeyUp: j,
          type: W
        }, xe, !pu(Ke) && {
          as: he,
          ownerState: F({}, Ue, xe.ownerState)
        }, {
          ref: q,
          className: qe(me.input, xe.className, D && "MuiInputBase-readOnly"),
          onBlur: Te,
          onChange: we,
          onFocus: ye
        }))
      }), h, T ? T(F({}, G, {
        startAdornment: z
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" && (I_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": c.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: uf,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: qt,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: c.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * @ignore
   */
  onClick: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * @ignore
   */
  onKeyUp: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * @ignore
   */
  renderSuffix: c.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The size of the component.
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
const l2 = I_;
function Tre(e) {
  return yr("MuiInput", e);
}
const Bn = F({}, mt, wr("MuiInput", ["root", "underline", "input"]));
function Dre(e) {
  return yr("MuiOutlinedInput", e);
}
const jre = F({}, mt, wr("MuiOutlinedInput", ["root", "notchedOutline", "input"])), rn = jre;
function Lre(e) {
  return yr("MuiFilledInput", e);
}
const zre = F({}, mt, wr("MuiFilledInput", ["root", "underline", "input"])), ht = zre, E_ = zo(/* @__PURE__ */ le.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function Vre(e) {
  return yr("MuiAutocomplete", e);
}
const or = wr("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var R9, A9;
const Fre = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionKey", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "readOnly", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "slotProps", "value"], Zre = ["ref"], Wre = kK(), Bre = (e) => {
  const {
    classes: r,
    disablePortal: t,
    expanded: n,
    focused: o,
    fullWidth: a,
    hasClearIcon: i,
    hasPopupIcon: l,
    inputFocused: s,
    popupOpen: u,
    size: d
  } = e, f = {
    root: ["root", n && "expanded", o && "focused", a && "fullWidth", i && "hasClearIcon", l && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", s && "inputFocused"],
    tag: ["tag", `tagSize${ze(d)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", u && "popupIndicatorOpen"],
    popper: ["popper", t && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return _r(f, Vre, r);
}, Hre = Be("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e, {
      fullWidth: n,
      hasClearIcon: o,
      hasPopupIcon: a,
      inputFocused: i,
      size: l
    } = t;
    return [{
      [`& .${or.tag}`]: r.tag
    }, {
      [`& .${or.tag}`]: r[`tagSize${ze(l)}`]
    }, {
      [`& .${or.inputRoot}`]: r.inputRoot
    }, {
      [`& .${or.input}`]: r.input
    }, {
      [`& .${or.input}`]: i && r.inputFocused
    }, r.root, n && r.fullWidth, a && r.hasPopupIcon, o && r.hasClearIcon];
  }
})({
  [`&.${or.focused} .${or.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${or.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${or.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${or.inputRoot}`]: {
    flexWrap: "wrap",
    [`.${or.hasPopupIcon}&, .${or.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${or.hasPopupIcon}.${or.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${or.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${Bn.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${Bn.root}.${mt.sizeSmall}`]: {
    [`& .${Bn.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${rn.root}`]: {
    padding: 9,
    [`.${or.hasPopupIcon}&, .${or.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${or.hasPopupIcon}.${or.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${or.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${or.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${rn.root}.${mt.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${or.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${ht.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${or.hasPopupIcon}&, .${or.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${or.hasPopupIcon}.${or.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${ht.input}`]: {
      padding: "7px 4px"
    },
    [`& .${or.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${ht.root}.${mt.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${ht.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${mt.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${ht.root}.${mt.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${or.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${ht.root}.${mt.hiddenLabel}.${mt.sizeSmall}`]: {
    [`& .${or.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${or.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${or.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${or.input}`]: {
        opacity: 1
      }
    }
  }]
}), Gre = Be("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, r) => r.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), Xre = Be(a_, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, r) => r.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), Yre = Be(a_, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: ({
    ownerState: e
  }, r) => F({}, r.popupIndicator, e.popupOpen && r.popupIndicatorOpen)
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), Ure = Be(S1, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [{
      [`& .${or.option}`]: r.option
    }, r.popper, t.disablePortal && r.popperDisablePortal];
  }
})(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
})), Jre = Be(qf, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, r) => r.paper
})(({
  theme: e
}) => F({}, e.typography.body1, {
  overflow: "auto"
})), qre = Be("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, r) => r.loading
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), Kre = Be("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, r) => r.noOptions
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), Qre = Be("div", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, r) => r.listbox
})(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${or.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${or.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${or.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Mr(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${or.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mr(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${or.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mr(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
})), ete = Be(Cre, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, r) => r.groupLabel
})(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
})), rte = Be("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, r) => r.groupUl
})({
  padding: 0,
  [`& .${or.option}`]: {
    paddingLeft: 24
  }
}), R_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n, o, a, i;
  const l = Wre({
    props: r,
    name: "MuiAutocomplete"
  }), {
    autoComplete: s = !1,
    autoHighlight: u = !1,
    autoSelect: d = !1,
    blurOnSelect: f = !1,
    ChipProps: p,
    className: g,
    clearIcon: h = R9 || (R9 = /* @__PURE__ */ le.jsx(mQ, {
      fontSize: "small"
    })),
    clearOnBlur: v = !l.freeSolo,
    clearOnEscape: y = !1,
    clearText: w = "Clear",
    closeText: $ = "Close",
    componentsProps: C = {},
    defaultValue: x = l.multiple ? [] : null,
    disableClearable: b = !1,
    disableCloseOnSelect: O = !1,
    disabled: _ = !1,
    disabledItemsFocusable: P = !1,
    disableListWrap: S = !1,
    disablePortal: I = !1,
    filterSelectedOptions: N = !1,
    forcePopupIcon: k = "auto",
    freeSolo: j = !1,
    fullWidth: R = !1,
    getLimitTagsText: D = (pe) => `+${pe}`,
    getOptionLabel: T,
    groupBy: V,
    handleHomeEndKeys: L = !l.freeSolo,
    includeInputInList: Z = !1,
    limitTags: z = -1,
    ListboxComponent: W = "ul",
    ListboxProps: U,
    loading: re = !1,
    loadingText: X = "Loading…",
    multiple: J = !1,
    noOptionsText: Q = "No options",
    openOnFocus: se = !1,
    openText: q = "Open",
    PaperComponent: te = qf,
    PopperComponent: ae = S1,
    popupIcon: ge = A9 || (A9 = /* @__PURE__ */ le.jsx(E_, {})),
    readOnly: G = !1,
    renderGroup: oe,
    renderInput: ne,
    renderOption: _e,
    renderTags: ye,
    selectOnFocus: Te = !l.freeSolo,
    size: we = "medium",
    slotProps: He = {}
  } = l, he = Xe(l, Fre), {
    getRootProps: xe,
    getInputProps: Le,
    getInputLabelProps: Ue,
    getPopupIndicatorProps: me,
    getClearProps: Ie,
    getTagProps: er,
    getListboxProps: Ke,
    getOptionProps: Me,
    value: Pe,
    dirty: Qe,
    expanded: Sr,
    id: Cr,
    popupOpen: nr,
    focused: De,
    focusedTag: Ge,
    anchorEl: lr,
    setAnchorEl: Ir,
    inputValue: Or,
    groupedOptions: $r
  } = sre(F({}, l, {
    componentName: "Autocomplete"
  })), ar = !b && !_ && Qe && !G, cr = (!j || k === !0) && k !== !1, {
    onMouseDown: Vr
  } = Le(), {
    ref: pt
  } = U != null ? U : {}, et = Ke(), {
    ref: jn
  } = et, St = Xe(et, Zre), Er = Xr(jn, pt), rt = T || ((pe) => {
    var Ze;
    return (Ze = pe.label) != null ? Ze : pe;
  }), gr = F({}, l, {
    disablePortal: I,
    expanded: Sr,
    focused: De,
    fullWidth: R,
    getOptionLabel: rt,
    hasClearIcon: ar,
    hasPopupIcon: cr,
    inputFocused: Ge === -1,
    popupOpen: nr,
    size: we
  }), Ar = Bre(gr);
  let Yr;
  if (J && Pe.length > 0) {
    const pe = (Ze) => F({
      className: Ar.tag,
      disabled: _
    }, er(Ze));
    ye ? Yr = ye(Pe, pe, gr) : Yr = Pe.map((Ze, Ye) => /* @__PURE__ */ le.jsx(Ire, F({
      label: rt(Ze),
      size: we
    }, pe({
      index: Ye
    }), p)));
  }
  if (z > -1 && Array.isArray(Yr)) {
    const pe = Yr.length - z;
    !De && pe > 0 && (Yr = Yr.splice(0, z), Yr.push(/* @__PURE__ */ le.jsx("span", {
      className: Ar.tag,
      children: D(pe)
    }, Yr.length)));
  }
  const lo = oe || ((pe) => /* @__PURE__ */ le.jsxs("li", {
    children: [/* @__PURE__ */ le.jsx(ete, {
      className: Ar.groupLabel,
      ownerState: gr,
      component: "div",
      children: pe.group
    }), /* @__PURE__ */ le.jsx(rte, {
      className: Ar.groupUl,
      ownerState: gr,
      children: pe.children
    })]
  }, pe.key)), co = _e || ((pe, Ze) => /* @__PURE__ */ sr("li", F({}, pe, {
    key: pe.key
  }), rt(Ze))), H = (pe, Ze) => {
    const Ye = Me({
      option: pe,
      index: Ze
    });
    return co(F({}, Ye, {
      className: Ar.option
    }), pe, {
      selected: Ye["aria-selected"],
      index: Ze,
      inputValue: Or
    }, gr);
  }, Ce = (n = He.clearIndicator) != null ? n : C.clearIndicator, ie = (o = He.paper) != null ? o : C.paper, Re = (a = He.popper) != null ? a : C.popper, ee = (i = He.popupIndicator) != null ? i : C.popupIndicator, K = (pe) => /* @__PURE__ */ le.jsx(Ure, F({
    as: ae,
    disablePortal: I,
    style: {
      width: lr ? lr.clientWidth : null
    },
    ownerState: gr,
    role: "presentation",
    anchorEl: lr,
    open: nr
  }, Re, {
    className: qe(Ar.popper, Re == null ? void 0 : Re.className),
    children: /* @__PURE__ */ le.jsx(Jre, F({
      ownerState: gr,
      as: te
    }, ie, {
      className: qe(Ar.paper, ie == null ? void 0 : ie.className),
      children: pe
    }))
  }));
  let be = null;
  return !re && $r.length > 0 ? be = K(/* @__PURE__ */ le.jsx(Qre, F({
    as: W,
    className: Ar.listbox,
    ownerState: gr
  }, St, U, {
    ref: Er,
    children: $r.map((pe, Ze) => V ? lo({
      key: pe.key,
      group: pe.group,
      children: pe.options.map((Ye, rr) => H(Ye, pe.index + rr))
    }) : H(pe, Ze))
  }))) : re && $r.length === 0 ? be = K(/* @__PURE__ */ le.jsx(qre, {
    className: Ar.loading,
    ownerState: gr,
    children: X
  })) : $r.length === 0 && !j && !re && (be = K(/* @__PURE__ */ le.jsx(Kre, {
    className: Ar.noOptions,
    ownerState: gr,
    role: "presentation",
    onMouseDown: (pe) => {
      pe.preventDefault();
    },
    children: Q
  }))), /* @__PURE__ */ le.jsxs(A.Fragment, {
    children: [/* @__PURE__ */ le.jsx(Hre, F({
      ref: t,
      className: qe(Ar.root, g),
      ownerState: gr
    }, xe(he), {
      children: ne({
        id: Cr,
        disabled: _,
        fullWidth: !0,
        size: we === "small" ? "small" : void 0,
        InputLabelProps: Ue(),
        InputProps: F({
          ref: Ir,
          className: Ar.inputRoot,
          startAdornment: Yr,
          onClick: (pe) => {
            pe.target === pe.currentTarget && Vr(pe);
          }
        }, (ar || cr) && {
          endAdornment: /* @__PURE__ */ le.jsxs(Gre, {
            className: Ar.endAdornment,
            ownerState: gr,
            children: [ar ? /* @__PURE__ */ le.jsx(Xre, F({}, Ie(), {
              "aria-label": w,
              title: w,
              ownerState: gr
            }, Ce, {
              className: qe(Ar.clearIndicator, Ce == null ? void 0 : Ce.className),
              children: h
            })) : null, cr ? /* @__PURE__ */ le.jsx(Yre, F({}, me(), {
              disabled: _,
              "aria-label": nr ? $ : q,
              title: nr ? $ : q,
              ownerState: gr
            }, ee, {
              className: qe(Ar.popupIndicator, ee == null ? void 0 : ee.className),
              children: ge
            })) : null]
          })
        }),
        inputProps: F({
          className: Ar.input,
          disabled: _,
          readOnly: G
        }, Le())
      })
    })), lr ? be : null]
  });
});
process.env.NODE_ENV !== "production" && (R_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: c.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: c.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: c.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: c.oneOfType([c.oneOf(["mouse", "touch"]), c.bool]),
  /**
   * Props applied to the [`Chip`](/material-ui/api/chip/) element.
   */
  ChipProps: c.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: c.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: c.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: c.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: c.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: c.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: c.shape({
    clearIndicator: c.object,
    paper: c.object,
    popper: c.object,
    popupIndicator: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: xn(c.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: c.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: c.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: c.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: c.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: c.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: c.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: c.oneOfType([c.oneOf(["auto"]), c.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: c.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: c.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: c.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: c.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: c.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */
  groupBy: c.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: c.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: c.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: c.bool,
  /**
   * The input value.
   */
  inputValue: c.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: c.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: Wn,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   */
  ListboxComponent: c.elementType,
  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: c.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: c.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: c.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: c.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: c.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: c.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: c.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: c.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: c.func,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: c.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: c.string,
  /**
   * Array of options.
   */
  options: c.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   */
  PaperComponent: c.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   */
  PopperComponent: c.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: c.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: c.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: c.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: c.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: c.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: c.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: c.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium"]), c.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: c.shape({
    clearIndicator: c.object,
    paper: c.object,
    popper: c.object,
    popupIndicator: c.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: xn(c.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const A_ = R_, tte = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], nte = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, k_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = vf(), o = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: a,
    appear: i = !0,
    children: l,
    easing: s,
    in: u,
    onEnter: d,
    onEntered: f,
    onEntering: p,
    onExit: g,
    onExited: h,
    onExiting: v,
    style: y,
    timeout: w = o,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: $ = Jw
  } = r, C = Xe(r, tte), x = A.useRef(null), b = Xr(x, l.ref, t), O = (R) => (D) => {
    if (R) {
      const T = x.current;
      D === void 0 ? R(T) : R(T, D);
    }
  }, _ = O(p), P = O((R, D) => {
    qw(R);
    const T = fu({
      style: y,
      timeout: w,
      easing: s
    }, {
      mode: "enter"
    });
    R.style.webkitTransition = n.transitions.create("opacity", T), R.style.transition = n.transitions.create("opacity", T), d && d(R, D);
  }), S = O(f), I = O(v), N = O((R) => {
    const D = fu({
      style: y,
      timeout: w,
      easing: s
    }, {
      mode: "exit"
    });
    R.style.webkitTransition = n.transitions.create("opacity", D), R.style.transition = n.transitions.create("opacity", D), g && g(R);
  }), k = O(h), j = (R) => {
    a && a(x.current, R);
  };
  return /* @__PURE__ */ le.jsx($, F({
    appear: i,
    in: u,
    nodeRef: x,
    onEnter: P,
    onEntered: S,
    onEntering: _,
    onExit: N,
    onExited: k,
    onExiting: I,
    addEndListener: j,
    timeout: w
  }, C, {
    children: (R, D) => /* @__PURE__ */ A.cloneElement(l, F({
      style: F({
        opacity: 0,
        visibility: R === "exited" && !u ? "hidden" : void 0
      }, nte[R], y, l.props.style),
      ref: b
    }, D))
  }));
});
process.env.NODE_ENV !== "production" && (k_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: c.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: c.bool,
  /**
   * A single child content element.
   */
  children: a1.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: c.oneOfType([c.shape({
    enter: c.string,
    exit: c.string
  }), c.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: c.bool,
  /**
   * @ignore
   */
  onEnter: c.func,
  /**
   * @ignore
   */
  onEntered: c.func,
  /**
   * @ignore
   */
  onEntering: c.func,
  /**
   * @ignore
   */
  onExit: c.func,
  /**
   * @ignore
   */
  onExited: c.func,
  /**
   * @ignore
   */
  onExiting: c.func,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: c.oneOfType([c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })])
});
const ote = k_;
function ate(e) {
  return yr("MuiBackdrop", e);
}
wr("MuiBackdrop", ["root", "invisible"]);
const ite = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], lte = (e) => {
  const {
    classes: r,
    invisible: t
  } = e;
  return _r({
    root: ["root", t && "invisible"]
  }, ate, r);
}, ste = Be("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, t.invisible && r.invisible];
  }
})(({
  ownerState: e
}) => F({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), M_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n, o, a;
  const i = xr({
    props: r,
    name: "MuiBackdrop"
  }), {
    children: l,
    className: s,
    component: u = "div",
    components: d = {},
    componentsProps: f = {},
    invisible: p = !1,
    open: g,
    slotProps: h = {},
    slots: v = {},
    TransitionComponent: y = ote,
    transitionDuration: w
  } = i, $ = Xe(i, ite), C = F({}, i, {
    component: u,
    invisible: p
  }), x = lte(C), b = (n = h.root) != null ? n : f.root;
  return /* @__PURE__ */ le.jsx(y, F({
    in: g,
    timeout: w
  }, $, {
    children: /* @__PURE__ */ le.jsx(ste, F({
      "aria-hidden": !0
    }, b, {
      as: (o = (a = v.root) != null ? a : d.Root) != null ? o : u,
      className: qe(x.root, s, b == null ? void 0 : b.className),
      ownerState: F({}, C, b == null ? void 0 : b.ownerState),
      classes: x,
      ref: t,
      children: l
    }))
  }));
});
process.env.NODE_ENV !== "production" && (M_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: c.shape({
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: c.shape({
    root: c.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: c.bool,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: c.shape({
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: c.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: c.oneOfType([c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })])
});
const cte = M_;
function ute(e) {
  return yr("MuiModal", e);
}
wr("MuiModal", ["root", "hidden", "backdrop"]);
const dte = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], fte = (e) => {
  const {
    open: r,
    exited: t,
    classes: n
  } = e;
  return _r({
    root: ["root", !r && t && "hidden"],
    backdrop: ["backdrop"]
  }, ute, n);
}, pte = Be("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, !t.open && t.exited && r.hidden];
  }
})(({
  theme: e,
  ownerState: r
}) => F({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !r.open && r.exited && {
  visibility: "hidden"
})), gte = Be(cte, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, r) => r.backdrop
})({
  zIndex: -1
}), N_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n, o, a, i, l, s;
  const u = xr({
    name: "MuiModal",
    props: r
  }), {
    BackdropComponent: d = gte,
    BackdropProps: f,
    className: p,
    closeAfterTransition: g = !1,
    children: h,
    container: v,
    component: y,
    components: w = {},
    componentsProps: $ = {},
    disableAutoFocus: C = !1,
    disableEnforceFocus: x = !1,
    disableEscapeKeyDown: b = !1,
    disablePortal: O = !1,
    disableRestoreFocus: _ = !1,
    disableScrollLock: P = !1,
    hideBackdrop: S = !1,
    keepMounted: I = !1,
    onBackdropClick: N,
    open: k,
    slotProps: j,
    slots: R
    // eslint-disable-next-line react/prop-types
  } = u, D = Xe(u, dte), T = F({}, u, {
    closeAfterTransition: g,
    disableAutoFocus: C,
    disableEnforceFocus: x,
    disableEscapeKeyDown: b,
    disablePortal: O,
    disableRestoreFocus: _,
    disableScrollLock: P,
    hideBackdrop: S,
    keepMounted: I
  }), {
    getRootProps: V,
    getBackdropProps: L,
    getTransitionProps: Z,
    portalRef: z,
    isTopModal: W,
    exited: U,
    hasTransition: re
  } = ZQ(F({}, T, {
    rootRef: t
  })), X = F({}, T, {
    exited: U
  }), J = fte(X), Q = {};
  if (h.props.tabIndex === void 0 && (Q.tabIndex = "-1"), re) {
    const {
      onEnter: oe,
      onExited: ne
    } = Z();
    Q.onEnter = oe, Q.onExited = ne;
  }
  const se = (n = (o = R == null ? void 0 : R.root) != null ? o : w.Root) != null ? n : pte, q = (a = (i = R == null ? void 0 : R.backdrop) != null ? i : w.Backdrop) != null ? a : d, te = (l = j == null ? void 0 : j.root) != null ? l : $.root, ae = (s = j == null ? void 0 : j.backdrop) != null ? s : $.backdrop, ge = Ao({
    elementType: se,
    externalSlotProps: te,
    externalForwardedProps: D,
    getSlotProps: V,
    additionalProps: {
      ref: t,
      as: y
    },
    ownerState: X,
    className: qe(p, te == null ? void 0 : te.className, J == null ? void 0 : J.root, !X.open && X.exited && (J == null ? void 0 : J.hidden))
  }), G = Ao({
    elementType: q,
    externalSlotProps: ae,
    additionalProps: f,
    getSlotProps: (oe) => L(F({}, oe, {
      onClick: (ne) => {
        N && N(ne), oe != null && oe.onClick && oe.onClick(ne);
      }
    })),
    className: qe(ae == null ? void 0 : ae.className, f == null ? void 0 : f.className, J == null ? void 0 : J.backdrop),
    ownerState: X
  });
  return !I && !k && (!re || U) ? null : /* @__PURE__ */ le.jsx(bi, {
    ref: z,
    container: v,
    disablePortal: O,
    children: /* @__PURE__ */ le.jsxs(se, F({}, ge, {
      children: [!S && d ? /* @__PURE__ */ le.jsx(q, F({}, G)) : null, /* @__PURE__ */ le.jsx(vu, {
        disableEnforceFocus: x,
        disableAutoFocus: C,
        disableRestoreFocus: _,
        isEnabled: W,
        open: k,
        children: /* @__PURE__ */ A.cloneElement(h, Q)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (N_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: c.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: c.object,
  /**
   * A single child content element.
   */
  children: a1.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: c.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: c.shape({
    Backdrop: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([$n, c.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: c.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: c.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: c.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: c.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: c.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: c.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: c.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: c.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: c.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: c.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: c.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: c.shape({
    backdrop: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: c.shape({
    backdrop: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const vte = N_, mte = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], hte = (e) => {
  const {
    classes: r,
    disableUnderline: t
  } = e, o = _r({
    root: ["root", !t && "underline"],
    input: ["input"]
  }, Lre, r);
  return F({}, r, o);
}, bte = Be(A1, {
  shouldForwardProp: (e) => fn(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [...E1(e, r), !t.disableUnderline && r.underline];
  }
})(({
  theme: e,
  ownerState: r
}) => {
  var t;
  const n = e.palette.mode === "light", o = n ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", a = n ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", i = n ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", l = n ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return F({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : a,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : i,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : a
      }
    },
    [`&.${ht.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : a
    },
    [`&.${ht.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : l
    }
  }, !r.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(t = (e.vars || e).palette[r.color || "primary"]) == null ? void 0 : t.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${ht.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${ht.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : o}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${ht.disabled}, .${ht.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${ht.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, r.startAdornment && {
    paddingLeft: 12
  }, r.endAdornment && {
    paddingRight: 12
  }, r.multiline && F({
    padding: "25px 12px 8px"
  }, r.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, r.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, r.hiddenLabel && r.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), yte = Be(k1, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: R1
})(({
  theme: e,
  ownerState: r
}) => F({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, r.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, r.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, r.startAdornment && {
  paddingLeft: 0
}, r.endAdornment && {
  paddingRight: 0
}, r.hiddenLabel && r.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, r.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), s2 = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n, o, a, i;
  const l = xr({
    props: r,
    name: "MuiFilledInput"
  }), {
    components: s = {},
    componentsProps: u,
    fullWidth: d = !1,
    // declare here to prevent spreading to DOM
    inputComponent: f = "input",
    multiline: p = !1,
    slotProps: g,
    slots: h = {},
    type: v = "text"
  } = l, y = Xe(l, mte), w = F({}, l, {
    fullWidth: d,
    inputComponent: f,
    multiline: p,
    type: v
  }), $ = hte(l), C = {
    root: {
      ownerState: w
    },
    input: {
      ownerState: w
    }
  }, x = (g != null ? g : u) ? wt(C, g != null ? g : u) : C, b = (n = (o = h.root) != null ? o : s.Root) != null ? n : bte, O = (a = (i = h.input) != null ? i : s.Input) != null ? a : yte;
  return /* @__PURE__ */ le.jsx(l2, F({
    slots: {
      root: b,
      input: O
    },
    componentsProps: x,
    fullWidth: d,
    inputComponent: f,
    multiline: p,
    ref: t,
    type: v
  }, y, {
    classes: $
  }));
});
process.env.NODE_ENV !== "production" && (s2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: c.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: qt,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
s2.muiName = "Input";
const T_ = s2;
function Cte(e) {
  return yr("MuiFormControl", e);
}
wr("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const wte = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], _te = (e) => {
  const {
    classes: r,
    margin: t,
    fullWidth: n
  } = e, o = {
    root: ["root", t !== "none" && `margin${ze(t)}`, n && "fullWidth"]
  };
  return _r(o, Cte, r);
}, xte = Be("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, r) => F({}, r.root, r[`margin${ze(e.margin)}`], e.fullWidth && r.fullWidth)
})(({
  ownerState: e
}) => F({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, e.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, e.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, e.fullWidth && {
  width: "100%"
})), D_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiFormControl"
  }), {
    children: o,
    className: a,
    color: i = "primary",
    component: l = "div",
    disabled: s = !1,
    error: u = !1,
    focused: d,
    fullWidth: f = !1,
    hiddenLabel: p = !1,
    margin: g = "none",
    required: h = !1,
    size: v = "medium",
    variant: y = "outlined"
  } = n, w = Xe(n, wte), $ = F({}, n, {
    color: i,
    component: l,
    disabled: s,
    error: u,
    fullWidth: f,
    hiddenLabel: p,
    margin: g,
    required: h,
    size: v,
    variant: y
  }), C = _te($), [x, b] = A.useState(() => {
    let j = !1;
    return o && A.Children.forEach(o, (R) => {
      if (!J1(R, ["Input", "Select"]))
        return;
      const D = J1(R, ["Select"]) ? R.props.input : R;
      D && Ere(D.props) && (j = !0);
    }), j;
  }), [O, _] = A.useState(() => {
    let j = !1;
    return o && A.Children.forEach(o, (R) => {
      J1(R, ["Input", "Select"]) && (bu(R.props, !0) || bu(R.props.inputProps, !0)) && (j = !0);
    }), j;
  }), [P, S] = A.useState(!1);
  s && P && S(!1);
  const I = d !== void 0 && !s ? d : P;
  let N;
  if (process.env.NODE_ENV !== "production") {
    const j = A.useRef(!1);
    N = () => (j.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), j.current = !0, () => {
      j.current = !1;
    });
  }
  const k = A.useMemo(() => ({
    adornedStart: x,
    setAdornedStart: b,
    color: i,
    disabled: s,
    error: u,
    filled: O,
    focused: I,
    fullWidth: f,
    hiddenLabel: p,
    size: v,
    onBlur: () => {
      S(!1);
    },
    onEmpty: () => {
      _(!1);
    },
    onFilled: () => {
      _(!0);
    },
    onFocus: () => {
      S(!0);
    },
    registerEffect: N,
    required: h,
    variant: y
  }), [x, i, s, u, O, I, f, p, N, h, v, y]);
  return /* @__PURE__ */ le.jsx(I1.Provider, {
    value: k,
    children: /* @__PURE__ */ le.jsx(xte, F({
      as: l,
      ownerState: $,
      className: qe(C.root, a),
      ref: t
    }, w, {
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (D_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: c.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: c.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: c.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: c.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: c.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: c.oneOf(["filled", "outlined", "standard"])
});
const $te = D_;
function Ote(e) {
  return yr("MuiFormHelperText", e);
}
const Pte = wr("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]), k9 = Pte;
var M9;
const Ste = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], Ite = (e) => {
  const {
    classes: r,
    contained: t,
    size: n,
    disabled: o,
    error: a,
    filled: i,
    focused: l,
    required: s
  } = e, u = {
    root: ["root", o && "disabled", a && "error", n && `size${ze(n)}`, t && "contained", l && "focused", i && "filled", s && "required"]
  };
  return _r(u, Ote, r);
}, Ete = Be("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, t.size && r[`size${ze(t.size)}`], t.contained && r.contained, t.filled && r.filled];
  }
})(({
  theme: e,
  ownerState: r
}) => F({
  color: (e.vars || e).palette.text.secondary
}, e.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${k9.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${k9.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}, r.size === "small" && {
  marginTop: 4
}, r.contained && {
  marginLeft: 14,
  marginRight: 14
})), j_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiFormHelperText"
  }), {
    children: o,
    className: a,
    component: i = "p"
  } = n, l = Xe(n, Ste), s = Vo(), u = Ma({
    props: n,
    muiFormControl: s,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), d = F({}, n, {
    component: i,
    contained: u.variant === "filled" || u.variant === "outlined",
    variant: u.variant,
    size: u.size,
    disabled: u.disabled,
    error: u.error,
    filled: u.filled,
    focused: u.focused,
    required: u.required
  }), f = Ite(d);
  return /* @__PURE__ */ le.jsx(Ete, F({
    as: i,
    ownerState: d,
    className: qe(f.root, a),
    ref: t
  }, l, {
    children: o === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      M9 || (M9 = /* @__PURE__ */ le.jsx("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : o
  }));
});
process.env.NODE_ENV !== "production" && (j_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: c.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: c.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: c.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: c.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: c.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   */
  variant: c.oneOfType([c.oneOf(["filled", "outlined", "standard"]), c.string])
});
const Rte = j_;
function Ate(e) {
  return yr("MuiFormLabel", e);
}
const kte = wr("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), ui = kte, Mte = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], Nte = (e) => {
  const {
    classes: r,
    color: t,
    focused: n,
    disabled: o,
    error: a,
    filled: i,
    required: l
  } = e, s = {
    root: ["root", `color${ze(t)}`, o && "disabled", a && "error", i && "filled", n && "focused", l && "required"],
    asterisk: ["asterisk", a && "error"]
  };
  return _r(s, Ate, r);
}, Tte = Be("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, r) => F({}, r.root, e.color === "secondary" && r.colorSecondary, e.filled && r.filled)
})(({
  theme: e,
  ownerState: r
}) => F({
  color: (e.vars || e).palette.text.secondary
}, e.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${ui.focused}`]: {
    color: (e.vars || e).palette[r.color].main
  },
  [`&.${ui.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${ui.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), Dte = Be("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, r) => r.asterisk
})(({
  theme: e
}) => ({
  [`&.${ui.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), L_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiFormLabel"
  }), {
    children: o,
    className: a,
    component: i = "label"
  } = n, l = Xe(n, Mte), s = Vo(), u = Ma({
    props: n,
    muiFormControl: s,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), d = F({}, n, {
    color: u.color || "primary",
    component: i,
    disabled: u.disabled,
    error: u.error,
    filled: u.filled,
    focused: u.focused,
    required: u.required
  }), f = Nte(d);
  return /* @__PURE__ */ le.jsxs(Tte, F({
    as: i,
    ownerState: d,
    className: qe(f.root, a),
    ref: t
  }, l, {
    children: [o, u.required && /* @__PURE__ */ le.jsxs(Dte, {
      ownerState: d,
      "aria-hidden": !0,
      className: f.asterisk,
      children: [" ", "*"]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (L_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: c.oneOfType([c.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: c.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: c.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: c.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: c.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: c.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const jte = L_, Lte = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function V0(e) {
  return `scale(${e}, ${e ** 2})`;
}
const zte = {
  entering: {
    opacity: 1,
    transform: V0(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Dd = typeof navigator != "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), c2 = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const {
    addEndListener: n,
    appear: o = !0,
    children: a,
    easing: i,
    in: l,
    onEnter: s,
    onEntered: u,
    onEntering: d,
    onExit: f,
    onExited: p,
    onExiting: g,
    style: h,
    timeout: v = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: y = Jw
  } = r, w = Xe(r, Lte), $ = o6(), C = A.useRef(), x = vf(), b = A.useRef(null), O = Xr(b, a.ref, t), _ = (D) => (T) => {
    if (D) {
      const V = b.current;
      T === void 0 ? D(V) : D(V, T);
    }
  }, P = _(d), S = _((D, T) => {
    qw(D);
    const {
      duration: V,
      delay: L,
      easing: Z
    } = fu({
      style: h,
      timeout: v,
      easing: i
    }, {
      mode: "enter"
    });
    let z;
    v === "auto" ? (z = x.transitions.getAutoHeightDuration(D.clientHeight), C.current = z) : z = V, D.style.transition = [x.transitions.create("opacity", {
      duration: z,
      delay: L
    }), x.transitions.create("transform", {
      duration: Dd ? z : z * 0.666,
      delay: L,
      easing: Z
    })].join(","), s && s(D, T);
  }), I = _(u), N = _(g), k = _((D) => {
    const {
      duration: T,
      delay: V,
      easing: L
    } = fu({
      style: h,
      timeout: v,
      easing: i
    }, {
      mode: "exit"
    });
    let Z;
    v === "auto" ? (Z = x.transitions.getAutoHeightDuration(D.clientHeight), C.current = Z) : Z = T, D.style.transition = [x.transitions.create("opacity", {
      duration: Z,
      delay: V
    }), x.transitions.create("transform", {
      duration: Dd ? Z : Z * 0.666,
      delay: Dd ? V : V || Z * 0.333,
      easing: L
    })].join(","), D.style.opacity = 0, D.style.transform = V0(0.75), f && f(D);
  }), j = _(p), R = (D) => {
    v === "auto" && $.start(C.current || 0, D), n && n(b.current, D);
  };
  return /* @__PURE__ */ le.jsx(y, F({
    appear: o,
    in: l,
    nodeRef: b,
    onEnter: S,
    onEntered: I,
    onEntering: P,
    onExit: k,
    onExited: j,
    onExiting: N,
    addEndListener: R,
    timeout: v === "auto" ? null : v
  }, w, {
    children: (D, T) => /* @__PURE__ */ A.cloneElement(a, F({
      style: F({
        opacity: 0,
        transform: V0(0.75),
        visibility: D === "exited" && !l ? "hidden" : void 0
      }, zte[D], h, a.props.style),
      ref: O
    }, T))
  }));
});
process.env.NODE_ENV !== "production" && (c2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: c.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: c.bool,
  /**
   * A single child content element.
   */
  children: a1.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: c.oneOfType([c.shape({
    enter: c.string,
    exit: c.string
  }), c.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: c.bool,
  /**
   * @ignore
   */
  onEnter: c.func,
  /**
   * @ignore
   */
  onEntered: c.func,
  /**
   * @ignore
   */
  onEntering: c.func,
  /**
   * @ignore
   */
  onExit: c.func,
  /**
   * @ignore
   */
  onExited: c.func,
  /**
   * @ignore
   */
  onExiting: c.func,
  /**
   * @ignore
   */
  style: c.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: c.oneOfType([c.oneOf(["auto"]), c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })])
});
c2.muiSupportAuto = !0;
const Vte = c2, Fte = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], Zte = (e) => {
  const {
    classes: r,
    disableUnderline: t
  } = e, o = _r({
    root: ["root", !t && "underline"],
    input: ["input"]
  }, Tre, r);
  return F({}, r, o);
}, Wte = Be(A1, {
  shouldForwardProp: (e) => fn(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [...E1(e, r), !t.disableUnderline && r.underline];
  }
})(({
  theme: e,
  ownerState: r
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), F({
    position: "relative"
  }, r.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !r.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(e.vars || e).palette[r.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${Bn.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${Bn.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${n}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${Bn.disabled}, .${Bn.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${n}`
      }
    },
    [`&.${Bn.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), Bte = Be(k1, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: R1
})({}), u2 = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n, o, a, i;
  const l = xr({
    props: r,
    name: "MuiInput"
  }), {
    disableUnderline: s,
    components: u = {},
    componentsProps: d,
    fullWidth: f = !1,
    inputComponent: p = "input",
    multiline: g = !1,
    slotProps: h,
    slots: v = {},
    type: y = "text"
  } = l, w = Xe(l, Fte), $ = Zte(l), x = {
    root: {
      ownerState: {
        disableUnderline: s
      }
    }
  }, b = (h != null ? h : d) ? wt(h != null ? h : d, x) : x, O = (n = (o = v.root) != null ? o : u.Root) != null ? n : Wte, _ = (a = (i = v.input) != null ? i : u.Input) != null ? a : Bte;
  return /* @__PURE__ */ le.jsx(l2, F({
    slots: {
      root: O,
      input: _
    },
    slotProps: b,
    fullWidth: f,
    inputComponent: p,
    multiline: g,
    ref: t,
    type: y
  }, w, {
    classes: $
  }));
});
process.env.NODE_ENV !== "production" && (u2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: c.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: qt,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: c.shape({
    input: c.object,
    root: c.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
u2.muiName = "Input";
const z_ = u2;
function Hte(e) {
  return yr("MuiInputAdornment", e);
}
const Gte = wr("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]), N9 = Gte;
var T9;
const Xte = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], Yte = (e, r) => {
  const {
    ownerState: t
  } = e;
  return [r.root, r[`position${ze(t.position)}`], t.disablePointerEvents === !0 && r.disablePointerEvents, r[t.variant]];
}, Ute = (e) => {
  const {
    classes: r,
    disablePointerEvents: t,
    hiddenLabel: n,
    position: o,
    size: a,
    variant: i
  } = e, l = {
    root: ["root", t && "disablePointerEvents", o && `position${ze(o)}`, i, n && "hiddenLabel", a && `size${ze(a)}`]
  };
  return _r(l, Hte, r);
}, Jte = Be("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: Yte
})(({
  theme: e,
  ownerState: r
}) => F({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active
}, r.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${N9.positionStart}&:not(.${N9.hiddenLabel})`]: {
    marginTop: 16
  }
}, r.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, r.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, r.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), V_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiInputAdornment"
  }), {
    children: o,
    className: a,
    component: i = "div",
    disablePointerEvents: l = !1,
    disableTypography: s = !1,
    position: u,
    variant: d
  } = n, f = Xe(n, Xte), p = Vo() || {};
  let g = d;
  d && p.variant && process.env.NODE_ENV !== "production" && d === p.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), p && !g && (g = p.variant);
  const h = F({}, n, {
    hiddenLabel: p.hiddenLabel,
    size: p.size,
    disablePointerEvents: l,
    position: u,
    variant: g
  }), v = Ute(h);
  return /* @__PURE__ */ le.jsx(I1.Provider, {
    value: null,
    children: /* @__PURE__ */ le.jsx(Jte, F({
      as: i,
      ownerState: h,
      className: qe(v.root, a),
      ref: t
    }, f, {
      children: typeof o == "string" && !s ? /* @__PURE__ */ le.jsx(xQ, {
        color: "text.secondary",
        children: o
      }) : /* @__PURE__ */ le.jsxs(A.Fragment, {
        children: [u === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          T9 || (T9 = /* @__PURE__ */ le.jsx("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, o]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" && (V_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: c.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: c.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: c.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: c.oneOf(["filled", "outlined", "standard"])
});
const qte = V_;
function Kte(e) {
  return yr("MuiInputLabel", e);
}
wr("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const Qte = ["disableAnimation", "margin", "shrink", "variant", "className"], ene = (e) => {
  const {
    classes: r,
    formControl: t,
    size: n,
    shrink: o,
    disableAnimation: a,
    variant: i,
    required: l
  } = e, s = {
    root: ["root", t && "formControl", !a && "animated", o && "shrink", n && n !== "normal" && `size${ze(n)}`, i],
    asterisk: [l && "asterisk"]
  }, u = _r(s, Kte, r);
  return F({}, r, u);
}, rne = Be(jte, {
  shouldForwardProp: (e) => fn(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [{
      [`& .${ui.asterisk}`]: r.asterisk
    }, r.root, t.formControl && r.formControl, t.size === "small" && r.sizeSmall, t.shrink && r.shrink, !t.disableAnimation && r.animated, t.focused && r.focused, r[t.variant]];
  }
})(({
  theme: e,
  ownerState: r
}) => F({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, r.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, r.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, r.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !r.disableAnimation && {
  transition: e.transitions.create(["color", "transform", "max-width"], {
    duration: e.transitions.duration.shorter,
    easing: e.transitions.easing.easeOut
  })
}, r.variant === "filled" && F({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, r.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, r.shrink && F({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, r.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), r.variant === "outlined" && F({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, r.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, r.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), F_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    name: "MuiInputLabel",
    props: r
  }), {
    disableAnimation: o = !1,
    shrink: a,
    className: i
  } = n, l = Xe(n, Qte), s = Vo();
  let u = a;
  typeof u == "undefined" && s && (u = s.filled || s.focused || s.adornedStart);
  const d = Ma({
    props: n,
    muiFormControl: s,
    states: ["size", "variant", "required", "focused"]
  }), f = F({}, n, {
    disableAnimation: o,
    formControl: s,
    shrink: u,
    size: d.size,
    variant: d.variant,
    required: d.required,
    focused: d.focused
  }), p = ene(f);
  return /* @__PURE__ */ le.jsx(rne, F({
    "data-shrink": u,
    ownerState: f,
    ref: t,
    className: qe(p.root, i)
  }, l, {
    classes: p
  }));
});
process.env.NODE_ENV !== "production" && (F_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: c.oneOfType([c.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), c.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: c.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: c.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: c.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: c.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: c.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: c.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: c.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: c.oneOfType([c.oneOf(["normal", "small"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   */
  variant: c.oneOf(["filled", "outlined", "standard"])
});
const tne = F_, Z_ = /* @__PURE__ */ A.createContext({});
process.env.NODE_ENV !== "production" && (Z_.displayName = "ListContext");
const nne = Z_;
function one(e) {
  return yr("MuiList", e);
}
wr("MuiList", ["root", "padding", "dense", "subheader"]);
const ane = ["children", "className", "component", "dense", "disablePadding", "subheader"], ine = (e) => {
  const {
    classes: r,
    disablePadding: t,
    dense: n,
    subheader: o
  } = e;
  return _r({
    root: ["root", !t && "padding", n && "dense", o && "subheader"]
  }, one, r);
}, lne = Be("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, !t.disablePadding && r.padding, t.dense && r.dense, t.subheader && r.subheader];
  }
})(({
  ownerState: e
}) => F({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), W_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiList"
  }), {
    children: o,
    className: a,
    component: i = "ul",
    dense: l = !1,
    disablePadding: s = !1,
    subheader: u
  } = n, d = Xe(n, ane), f = A.useMemo(() => ({
    dense: l
  }), [l]), p = F({}, n, {
    component: i,
    dense: l,
    disablePadding: s
  }), g = ine(p);
  return /* @__PURE__ */ le.jsx(nne.Provider, {
    value: f,
    children: /* @__PURE__ */ le.jsxs(lne, F({
      as: i,
      className: qe(g.root, a),
      ref: t,
      ownerState: p
    }, d, {
      children: [u, o]
    }))
  });
});
process.env.NODE_ENV !== "production" && (W_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: c.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: c.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object])
});
const sne = W_, cne = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function jd(e, r, t) {
  return e === r ? e.firstChild : r && r.nextElementSibling ? r.nextElementSibling : t ? null : e.firstChild;
}
function D9(e, r, t) {
  return e === r ? t ? e.firstChild : e.lastChild : r && r.previousElementSibling ? r.previousElementSibling : t ? null : e.lastChild;
}
function B_(e, r) {
  if (r === void 0)
    return !0;
  let t = e.innerText;
  return t === void 0 && (t = e.textContent), t = t.trim().toLowerCase(), t.length === 0 ? !1 : r.repeating ? t[0] === r.keys[0] : t.indexOf(r.keys.join("")) === 0;
}
function Qa(e, r, t, n, o, a) {
  let i = !1, l = o(e, r, r ? t : !1);
  for (; l; ) {
    if (l === e.firstChild) {
      if (i)
        return !1;
      i = !0;
    }
    const s = n ? !1 : l.disabled || l.getAttribute("aria-disabled") === "true";
    if (!l.hasAttribute("tabindex") || !B_(l, a) || s)
      l = o(e, l, t);
    else
      return l.focus(), !0;
  }
  return !1;
}
const H_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: n,
    autoFocus: o = !1,
    autoFocusItem: a = !1,
    children: i,
    className: l,
    disabledItemsFocusable: s = !1,
    disableListWrap: u = !1,
    onKeyDown: d,
    variant: f = "selectedMenu"
  } = r, p = Xe(r, cne), g = A.useRef(null), h = A.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  _n(() => {
    o && g.current.focus();
  }, [o]), A.useImperativeHandle(n, () => ({
    adjustStyleForScrollbar: (C, {
      direction: x
    }) => {
      const b = !g.current.style.width;
      if (C.clientHeight < g.current.clientHeight && b) {
        const O = `${a6(tt(C))}px`;
        g.current.style[x === "rtl" ? "paddingLeft" : "paddingRight"] = O, g.current.style.width = `calc(100% + ${O})`;
      }
      return g.current;
    }
  }), []);
  const v = (C) => {
    const x = g.current, b = C.key, O = tt(x).activeElement;
    if (b === "ArrowDown")
      C.preventDefault(), Qa(x, O, u, s, jd);
    else if (b === "ArrowUp")
      C.preventDefault(), Qa(x, O, u, s, D9);
    else if (b === "Home")
      C.preventDefault(), Qa(x, null, u, s, jd);
    else if (b === "End")
      C.preventDefault(), Qa(x, null, u, s, D9);
    else if (b.length === 1) {
      const _ = h.current, P = b.toLowerCase(), S = performance.now();
      _.keys.length > 0 && (S - _.lastTime > 500 ? (_.keys = [], _.repeating = !0, _.previousKeyMatched = !0) : _.repeating && P !== _.keys[0] && (_.repeating = !1)), _.lastTime = S, _.keys.push(P);
      const I = O && !_.repeating && B_(O, _);
      _.previousKeyMatched && (I || Qa(x, O, !1, s, jd, _)) ? C.preventDefault() : _.previousKeyMatched = !1;
    }
    d && d(C);
  }, y = Xr(g, t);
  let w = -1;
  A.Children.forEach(i, (C, x) => {
    if (!/* @__PURE__ */ A.isValidElement(C)) {
      w === x && (w += 1, w >= i.length && (w = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && gi.isFragment(C) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), C.props.disabled || (f === "selectedMenu" && C.props.selected || w === -1) && (w = x), w === x && (C.props.disabled || C.props.muiSkipListHighlight || C.type.muiSkipListHighlight) && (w += 1, w >= i.length && (w = -1));
  });
  const $ = A.Children.map(i, (C, x) => {
    if (x === w) {
      const b = {};
      return a && (b.autoFocus = !0), C.props.tabIndex === void 0 && f === "selectedMenu" && (b.tabIndex = 0), /* @__PURE__ */ A.cloneElement(C, b);
    }
    return C;
  });
  return /* @__PURE__ */ le.jsx(sne, F({
    role: "menu",
    ref: y,
    className: l,
    onKeyDown: v,
    tabIndex: o ? 0 : -1
  }, p, {
    children: $
  }));
});
process.env.NODE_ENV !== "production" && (H_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: c.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: c.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: c.node,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: c.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: c.bool,
  /**
   * @ignore
   */
  onKeyDown: c.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: c.oneOf(["menu", "selectedMenu"])
});
const une = H_;
function dne(e) {
  return yr("MuiPopover", e);
}
wr("MuiPopover", ["root", "paper"]);
const fne = ["onEntering"], pne = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], gne = ["slotProps"];
function j9(e, r) {
  let t = 0;
  return typeof r == "number" ? t = r : r === "center" ? t = e.height / 2 : r === "bottom" && (t = e.height), t;
}
function L9(e, r) {
  let t = 0;
  return typeof r == "number" ? t = r : r === "center" ? t = e.width / 2 : r === "right" && (t = e.width), t;
}
function z9(e) {
  return [e.horizontal, e.vertical].map((r) => typeof r == "number" ? `${r}px` : r).join(" ");
}
function rs(e) {
  return typeof e == "function" ? e() : e;
}
const vne = (e) => {
  const {
    classes: r
  } = e;
  return _r({
    root: ["root"],
    paper: ["paper"]
  }, dne, r);
}, mne = Be(vte, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, r) => r.root
})({}), G_ = Be(qf, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, r) => r.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), X_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n, o, a;
  const i = xr({
    props: r,
    name: "MuiPopover"
  }), {
    action: l,
    anchorEl: s,
    anchorOrigin: u = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: d,
    anchorReference: f = "anchorEl",
    children: p,
    className: g,
    container: h,
    elevation: v = 8,
    marginThreshold: y = 16,
    open: w,
    PaperProps: $ = {},
    slots: C,
    slotProps: x,
    transformOrigin: b = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: O = Vte,
    transitionDuration: _ = "auto",
    TransitionProps: {
      onEntering: P
    } = {},
    disableScrollLock: S = !1
  } = i, I = Xe(i.TransitionProps, fne), N = Xe(i, pne), k = (n = x == null ? void 0 : x.paper) != null ? n : $, j = A.useRef(), R = Xr(j, k.ref), D = F({}, i, {
    anchorOrigin: u,
    anchorReference: f,
    elevation: v,
    marginThreshold: y,
    externalPaperSlotProps: k,
    transformOrigin: b,
    TransitionComponent: O,
    transitionDuration: _,
    TransitionProps: I
  }), T = vne(D), V = A.useCallback(() => {
    if (f === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (d || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), d;
    const oe = rs(s), ne = oe && oe.nodeType === 1 ? oe : tt(j.current).body, _e = ne.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const ye = ne.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && ye.top === 0 && ye.left === 0 && ye.right === 0 && ye.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: _e.top + j9(_e, u.vertical),
      left: _e.left + L9(_e, u.horizontal)
    };
  }, [s, u.horizontal, u.vertical, d, f]), L = A.useCallback((oe) => ({
    vertical: j9(oe, b.vertical),
    horizontal: L9(oe, b.horizontal)
  }), [b.horizontal, b.vertical]), Z = A.useCallback((oe) => {
    const ne = {
      width: oe.offsetWidth,
      height: oe.offsetHeight
    }, _e = L(ne);
    if (f === "none")
      return {
        top: null,
        left: null,
        transformOrigin: z9(_e)
      };
    const ye = V();
    let Te = ye.top - _e.vertical, we = ye.left - _e.horizontal;
    const He = Te + ne.height, he = we + ne.width, xe = Eo(rs(s)), Le = xe.innerHeight - y, Ue = xe.innerWidth - y;
    if (y !== null && Te < y) {
      const me = Te - y;
      Te -= me, _e.vertical += me;
    } else if (y !== null && He > Le) {
      const me = He - Le;
      Te -= me, _e.vertical += me;
    }
    if (process.env.NODE_ENV !== "production" && ne.height > Le && ne.height && Le && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${ne.height - Le}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), y !== null && we < y) {
      const me = we - y;
      we -= me, _e.horizontal += me;
    } else if (he > Ue) {
      const me = he - Ue;
      we -= me, _e.horizontal += me;
    }
    return {
      top: `${Math.round(Te)}px`,
      left: `${Math.round(we)}px`,
      transformOrigin: z9(_e)
    };
  }, [s, f, V, L, y]), [z, W] = A.useState(w), U = A.useCallback(() => {
    const oe = j.current;
    if (!oe)
      return;
    const ne = Z(oe);
    ne.top !== null && (oe.style.top = ne.top), ne.left !== null && (oe.style.left = ne.left), oe.style.transformOrigin = ne.transformOrigin, W(!0);
  }, [Z]);
  A.useEffect(() => (S && window.addEventListener("scroll", U), () => window.removeEventListener("scroll", U)), [s, S, U]);
  const re = (oe, ne) => {
    P && P(oe, ne), U();
  }, X = () => {
    W(!1);
  };
  A.useEffect(() => {
    w && U();
  }), A.useImperativeHandle(l, () => w ? {
    updatePosition: () => {
      U();
    }
  } : null, [w, U]), A.useEffect(() => {
    if (!w)
      return;
    const oe = n6(() => {
      U();
    }), ne = Eo(s);
    return ne.addEventListener("resize", oe), () => {
      oe.clear(), ne.removeEventListener("resize", oe);
    };
  }, [s, w, U]);
  let J = _;
  _ === "auto" && !O.muiSupportAuto && (J = void 0);
  const Q = h || (s ? tt(rs(s)).body : void 0), se = (o = C == null ? void 0 : C.root) != null ? o : mne, q = (a = C == null ? void 0 : C.paper) != null ? a : G_, te = Ao({
    elementType: q,
    externalSlotProps: F({}, k, {
      style: z ? k.style : F({}, k.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: v,
      ref: R
    },
    ownerState: D,
    className: qe(T.paper, k == null ? void 0 : k.className)
  }), ae = Ao({
    elementType: se,
    externalSlotProps: (x == null ? void 0 : x.root) || {},
    externalForwardedProps: N,
    additionalProps: {
      ref: t,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: Q,
      open: w
    },
    ownerState: D,
    className: qe(T.root, g)
  }), {
    slotProps: ge
  } = ae, G = Xe(ae, gne);
  return /* @__PURE__ */ le.jsx(se, F({}, G, !pu(se) && {
    slotProps: ge,
    disableScrollLock: S
  }, {
    children: /* @__PURE__ */ le.jsx(O, F({
      appear: !0,
      in: w,
      onEntering: re,
      onExited: X,
      timeout: J
    }, I, {
      children: /* @__PURE__ */ le.jsx(q, F({}, te, {
        children: p
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (X_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: qt,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: xn(c.oneOfType([$n, c.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const r = rs(e.anchorEl);
      if (r && r.nodeType === 1) {
        const t = r.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && t.top === 0 && t.left === 0 && t.right === 0 && t.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${r}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: c.shape({
    horizontal: c.oneOfType([c.oneOf(["center", "left", "right"]), c.number]).isRequired,
    vertical: c.oneOfType([c.oneOf(["bottom", "center", "top"]), c.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: c.shape({
    left: c.number.isRequired,
    top: c.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: c.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: c.oneOfType([$n, c.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: c.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Wn,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: c.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: c.shape({
    component: uf
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: c.shape({
    paper: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: c.shape({
    paper: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: c.shape({
    horizontal: c.oneOfType([c.oneOf(["center", "left", "right"]), c.number]).isRequired,
    vertical: c.oneOfType([c.oneOf(["bottom", "center", "top"]), c.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: c.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: c.oneOfType([c.oneOf(["auto"]), c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: c.object
});
const hne = X_;
function bne(e) {
  return yr("MuiMenu", e);
}
wr("MuiMenu", ["root", "paper", "list"]);
const yne = ["onEntering"], Cne = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], wne = {
  vertical: "top",
  horizontal: "right"
}, _ne = {
  vertical: "top",
  horizontal: "left"
}, xne = (e) => {
  const {
    classes: r
  } = e;
  return _r({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, bne, r);
}, $ne = Be(hne, {
  shouldForwardProp: (e) => fn(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, r) => r.root
})({}), One = Be(G_, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, r) => r.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), Pne = Be(une, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, r) => r.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Y_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n, o;
  const a = xr({
    props: r,
    name: "MuiMenu"
  }), {
    autoFocus: i = !0,
    children: l,
    className: s,
    disableAutoFocusItem: u = !1,
    MenuListProps: d = {},
    onClose: f,
    open: p,
    PaperProps: g = {},
    PopoverClasses: h,
    transitionDuration: v = "auto",
    TransitionProps: {
      onEntering: y
    } = {},
    variant: w = "selectedMenu",
    slots: $ = {},
    slotProps: C = {}
  } = a, x = Xe(a.TransitionProps, yne), b = Xe(a, Cne), O = p6(), _ = F({}, a, {
    autoFocus: i,
    disableAutoFocusItem: u,
    MenuListProps: d,
    onEntering: y,
    PaperProps: g,
    transitionDuration: v,
    TransitionProps: x,
    variant: w
  }), P = xne(_), S = i && !u && p, I = A.useRef(null), N = (L, Z) => {
    I.current && I.current.adjustStyleForScrollbar(L, {
      direction: O ? "rtl" : "ltr"
    }), y && y(L, Z);
  }, k = (L) => {
    L.key === "Tab" && (L.preventDefault(), f && f(L, "tabKeyDown"));
  };
  let j = -1;
  A.Children.map(l, (L, Z) => {
    /* @__PURE__ */ A.isValidElement(L) && (process.env.NODE_ENV !== "production" && gi.isFragment(L) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), L.props.disabled || (w === "selectedMenu" && L.props.selected || j === -1) && (j = Z));
  });
  const R = (n = $.paper) != null ? n : One, D = (o = C.paper) != null ? o : g, T = Ao({
    elementType: $.root,
    externalSlotProps: C.root,
    ownerState: _,
    className: [P.root, s]
  }), V = Ao({
    elementType: R,
    externalSlotProps: D,
    ownerState: _,
    className: P.paper
  });
  return /* @__PURE__ */ le.jsx($ne, F({
    onClose: f,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: O ? "right" : "left"
    },
    transformOrigin: O ? wne : _ne,
    slots: {
      paper: R,
      root: $.root
    },
    slotProps: {
      root: T,
      paper: V
    },
    open: p,
    ref: t,
    transitionDuration: v,
    TransitionProps: F({
      onEntering: N
    }, x),
    ownerState: _
  }, b, {
    classes: h,
    children: /* @__PURE__ */ le.jsx(Pne, F({
      onKeyDown: k,
      actions: I,
      autoFocus: i && (j === -1 || u),
      autoFocusItem: S,
      variant: w
    }, d, {
      className: qe(P.list, d.className),
      children: l
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Y_.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: c.oneOfType([$n, c.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: c.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: c.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: c.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: c.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: c.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: c.shape({
    paper: c.oneOfType([c.func, c.object]),
    root: c.oneOfType([c.func, c.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: c.shape({
    paper: c.elementType,
    root: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: c.oneOfType([c.oneOf(["auto"]), c.number, c.shape({
    appear: c.number,
    enter: c.number,
    exit: c.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: c.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: c.oneOf(["menu", "selectedMenu"])
});
const Sne = Y_;
function Ine(e) {
  return yr("MuiNativeSelect", e);
}
const Ene = wr("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), d2 = Ene, Rne = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], Ane = (e) => {
  const {
    classes: r,
    variant: t,
    disabled: n,
    multiple: o,
    open: a,
    error: i
  } = e, l = {
    select: ["select", t, n && "disabled", o && "multiple", i && "error"],
    icon: ["icon", `icon${ze(t)}`, a && "iconOpen", n && "disabled"]
  };
  return _r(l, Ine, r);
}, U_ = ({
  ownerState: e,
  theme: r
}) => F({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": F({}, r.vars ? {
    backgroundColor: `rgba(${r.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: r.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${d2.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (r.vars || r).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (r.vars || r).shape.borderRadius,
  "&:focus": {
    borderRadius: (r.vars || r).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), kne = Be("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: fn,
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.select, r[t.variant], t.error && r.error, {
      [`&.${d2.multiple}`]: r.multiple
    }];
  }
})(U_), J_ = ({
  ownerState: e,
  theme: r
}) => F({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (r.vars || r).palette.action.active,
  [`&.${d2.disabled}`]: {
    color: (r.vars || r).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), Mne = Be("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.icon, t.variant && r[`icon${ze(t.variant)}`], t.open && r.iconOpen];
  }
})(J_), q_ = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const {
    className: n,
    disabled: o,
    error: a,
    IconComponent: i,
    inputRef: l,
    variant: s = "standard"
  } = r, u = Xe(r, Rne), d = F({}, r, {
    disabled: o,
    variant: s,
    error: a
  }), f = Ane(d);
  return /* @__PURE__ */ le.jsxs(A.Fragment, {
    children: [/* @__PURE__ */ le.jsx(kne, F({
      ownerState: d,
      className: qe(f.select, n),
      disabled: o,
      ref: l || t
    }, u)), r.multiple ? null : /* @__PURE__ */ le.jsx(Mne, {
      as: i,
      ownerState: d,
      className: f.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (q_.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The CSS class name of the select element.
   */
  className: c.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: c.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: c.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: c.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: qt,
  /**
   * @ignore
   */
  multiple: c.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: c.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The input value.
   */
  value: c.any,
  /**
   * The variant to use.
   */
  variant: c.oneOf(["standard", "outlined", "filled"])
});
const Nne = q_;
var V9;
const Tne = ["children", "classes", "className", "label", "notched"], Dne = Be("fieldset", {
  shouldForwardProp: fn
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), jne = Be("legend", {
  shouldForwardProp: fn
})(({
  ownerState: e,
  theme: r
}) => F({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: r.transitions.create("width", {
    duration: 150,
    easing: r.transitions.easing.easeOut
  })
}, e.withLabel && F({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: r.transitions.create("max-width", {
    duration: 50,
    easing: r.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: r.transitions.create("max-width", {
    duration: 100,
    easing: r.transitions.easing.easeOut,
    delay: 50
  })
})));
function K_(e) {
  const {
    className: r,
    label: t,
    notched: n
  } = e, o = Xe(e, Tne), a = t != null && t !== "", i = F({}, e, {
    notched: n,
    withLabel: a
  });
  return /* @__PURE__ */ le.jsx(Dne, F({
    "aria-hidden": !0,
    className: r,
    ownerState: i
  }, o, {
    children: /* @__PURE__ */ le.jsx(jne, {
      ownerState: i,
      children: a ? /* @__PURE__ */ le.jsx("span", {
        children: t
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        V9 || (V9 = /* @__PURE__ */ le.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (K_.propTypes = {
  /**
   * The content of the component.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The label.
   */
  label: c.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: c.bool.isRequired,
  /**
   * @ignore
   */
  style: c.object
});
const Lne = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], zne = (e) => {
  const {
    classes: r
  } = e, n = _r({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, Dre, r);
  return F({}, r, n);
}, Vne = Be(A1, {
  shouldForwardProp: (e) => fn(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: E1
})(({
  theme: e,
  ownerState: r
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return F({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${rn.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${rn.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${rn.focused} .${rn.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[r.color].main,
      borderWidth: 2
    },
    [`&.${rn.error} .${rn.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${rn.disabled} .${rn.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, r.startAdornment && {
    paddingLeft: 14
  }, r.endAdornment && {
    paddingRight: 14
  }, r.multiline && F({
    padding: "16.5px 14px"
  }, r.size === "small" && {
    padding: "8.5px 14px"
  }));
}), Fne = Be(K_, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, r) => r.notchedOutline
})(({
  theme: e
}) => {
  const r = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : r
  };
}), Zne = Be(k1, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: R1
})(({
  theme: e,
  ownerState: r
}) => F({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, r.size === "small" && {
  padding: "8.5px 14px"
}, r.multiline && {
  padding: 0
}, r.startAdornment && {
  paddingLeft: 0
}, r.endAdornment && {
  paddingRight: 0
})), f2 = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n, o, a, i, l;
  const s = xr({
    props: r,
    name: "MuiOutlinedInput"
  }), {
    components: u = {},
    fullWidth: d = !1,
    inputComponent: f = "input",
    label: p,
    multiline: g = !1,
    notched: h,
    slots: v = {},
    type: y = "text"
  } = s, w = Xe(s, Lne), $ = zne(s), C = Vo(), x = Ma({
    props: s,
    muiFormControl: C,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), b = F({}, s, {
    color: x.color || "primary",
    disabled: x.disabled,
    error: x.error,
    focused: x.focused,
    formControl: C,
    fullWidth: d,
    hiddenLabel: x.hiddenLabel,
    multiline: g,
    size: x.size,
    type: y
  }), O = (n = (o = v.root) != null ? o : u.Root) != null ? n : Vne, _ = (a = (i = v.input) != null ? i : u.Input) != null ? a : Zne;
  return /* @__PURE__ */ le.jsx(l2, F({
    slots: {
      root: O,
      input: _
    },
    renderSuffix: (P) => /* @__PURE__ */ le.jsx(Fne, {
      ownerState: b,
      className: $.notchedOutline,
      label: p != null && p !== "" && x.required ? l || (l = /* @__PURE__ */ le.jsxs(A.Fragment, {
        children: [p, " ", "*"]
      })) : p,
      notched: typeof h != "undefined" ? h : !!(P.startAdornment || P.filled || P.focused)
    }),
    fullWidth: d,
    inputComponent: f,
    multiline: g,
    ref: t,
    type: y
  }, w, {
    classes: F({}, $, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" && (f2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: c.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: c.shape({
    Input: c.elementType,
    Root: c.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: c.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: c.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: c.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The id of the `input` element.
   */
  id: c.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: c.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: qt,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: c.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: c.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: c.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: c.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    input: c.elementType,
    root: c.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: c.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any
});
f2.muiName = "Input";
const Q_ = f2;
function Wne(e) {
  return yr("MuiPagination", e);
}
wr("MuiPagination", ["root", "ul", "outlined", "text"]);
const Bne = ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"];
function Hne(e = {}) {
  const {
    boundaryCount: r = 1,
    componentName: t = "usePagination",
    count: n = 1,
    defaultPage: o = 1,
    disabled: a = !1,
    hideNextButton: i = !1,
    hidePrevButton: l = !1,
    onChange: s,
    page: u,
    showFirstButton: d = !1,
    showLastButton: f = !1,
    siblingCount: p = 1
  } = e, g = Xe(e, Bne), [h, v] = ia({
    controlled: u,
    default: o,
    name: t,
    state: "page"
  }), y = (S, I) => {
    u || v(I), s && s(S, I);
  }, w = (S, I) => {
    const N = I - S + 1;
    return Array.from({
      length: N
    }, (k, j) => S + j);
  }, $ = w(1, Math.min(r, n)), C = w(Math.max(n - r + 1, r + 1), n), x = Math.max(
    Math.min(
      // Natural start
      h - p,
      // Lower boundary when page is high
      n - r - p * 2 - 1
    ),
    // Greater than startPages
    r + 2
  ), b = Math.min(
    Math.max(
      // Natural end
      h + p,
      // Upper boundary when page is low
      r + p * 2 + 2
    ),
    // Less than endPages
    C.length > 0 ? C[0] - 2 : n - 1
  ), O = [
    ...d ? ["first"] : [],
    ...l ? [] : ["previous"],
    ...$,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...x > r + 2 ? ["start-ellipsis"] : r + 1 < n - r ? [r + 1] : [],
    // Sibling pages
    ...w(x, b),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...b < n - r - 1 ? ["end-ellipsis"] : n - r > r ? [n - r] : [],
    ...C,
    ...i ? [] : ["next"],
    ...f ? ["last"] : []
  ], _ = (S) => {
    switch (S) {
      case "first":
        return 1;
      case "previous":
        return h - 1;
      case "next":
        return h + 1;
      case "last":
        return n;
      default:
        return null;
    }
  }, P = O.map((S) => typeof S == "number" ? {
    onClick: (I) => {
      y(I, S);
    },
    type: "page",
    page: S,
    selected: S === h,
    disabled: a,
    "aria-current": S === h ? "true" : void 0
  } : {
    onClick: (I) => {
      y(I, _(S));
    },
    type: S,
    page: _(S),
    selected: !1,
    disabled: a || S.indexOf("ellipsis") === -1 && (S === "next" || S === "last" ? h >= n : h <= 1)
  });
  return F({
    items: P
  }, g);
}
function Gne(e) {
  return yr("MuiPaginationItem", e);
}
const Xne = wr("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon", "colorPrimary", "colorSecondary"]), Et = Xne, F9 = zo(/* @__PURE__ */ le.jsx("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), Z9 = zo(/* @__PURE__ */ le.jsx("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), W9 = zo(/* @__PURE__ */ le.jsx("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), B9 = zo(/* @__PURE__ */ le.jsx("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), Yne = ["className", "color", "component", "components", "disabled", "page", "selected", "shape", "size", "slots", "type", "variant"], ex = (e, r) => {
  const {
    ownerState: t
  } = e;
  return [r.root, r[t.variant], r[`size${ze(t.size)}`], t.variant === "text" && r[`text${ze(t.color)}`], t.variant === "outlined" && r[`outlined${ze(t.color)}`], t.shape === "rounded" && r.rounded, t.type === "page" && r.page, (t.type === "start-ellipsis" || t.type === "end-ellipsis") && r.ellipsis, (t.type === "previous" || t.type === "next") && r.previousNext, (t.type === "first" || t.type === "last") && r.firstLast];
}, Une = (e) => {
  const {
    classes: r,
    color: t,
    disabled: n,
    selected: o,
    size: a,
    shape: i,
    type: l,
    variant: s
  } = e, u = {
    root: ["root", `size${ze(a)}`, s, i, t !== "standard" && `color${ze(t)}`, t !== "standard" && `${s}${ze(t)}`, n && "disabled", o && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[l]],
    icon: ["icon"]
  };
  return _r(u, Gne, r);
}, Jne = Be("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: ex
})(({
  theme: e,
  ownerState: r
}) => F({}, e.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  height: "auto",
  [`&.${Et.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, r.size === "small" && {
  minWidth: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, r.size === "large" && {
  minWidth: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: e.typography.pxToRem(15)
})), qne = Be(gu, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: ex
})(({
  theme: e,
  ownerState: r
}) => F({}, e.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (e.vars || e).palette.text.primary,
  [`&.${Et.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Et.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  transition: e.transitions.create(["color", "background-color"], {
    duration: e.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Et.selected}`]: {
    backgroundColor: (e.vars || e).palette.action.selected,
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Mr(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette.action.selected
      }
    },
    [`&.${Et.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mr(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    },
    [`&.${Et.disabled}`]: {
      opacity: 1,
      color: (e.vars || e).palette.action.disabled,
      backgroundColor: (e.vars || e).palette.action.selected
    }
  }
}, r.size === "small" && {
  minWidth: 26,
  height: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, r.size === "large" && {
  minWidth: 40,
  height: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: e.typography.pxToRem(15)
}, r.shape === "rounded" && {
  borderRadius: (e.vars || e).shape.borderRadius
}), ({
  theme: e,
  ownerState: r
}) => F({}, r.variant === "text" && {
  [`&.${Et.selected}`]: F({}, r.color !== "standard" && {
    color: (e.vars || e).palette[r.color].contrastText,
    backgroundColor: (e.vars || e).palette[r.color].main,
    "&:hover": {
      backgroundColor: (e.vars || e).palette[r.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[r.color].main
      }
    },
    [`&.${Et.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[r.color].dark
    }
  }, {
    [`&.${Et.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    }
  })
}, r.variant === "outlined" && {
  border: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
  [`&.${Et.selected}`]: F({}, r.color !== "standard" && {
    color: (e.vars || e).palette[r.color].main,
    border: `1px solid ${e.vars ? `rgba(${e.vars.palette[r.color].mainChannel} / 0.5)` : Mr(e.palette[r.color].main, 0.5)}`,
    backgroundColor: e.vars ? `rgba(${e.vars.palette[r.color].mainChannel} / ${e.vars.palette.action.activatedOpacity})` : Mr(e.palette[r.color].main, e.palette.action.activatedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[r.color].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mr(e.palette[r.color].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${Et.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[r.color].mainChannel} / calc(${e.vars.palette.action.activatedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Mr(e.palette[r.color].main, e.palette.action.activatedOpacity + e.palette.action.focusOpacity)
    }
  }, {
    [`&.${Et.disabled}`]: {
      borderColor: (e.vars || e).palette.action.disabledBackground,
      color: (e.vars || e).palette.action.disabled
    }
  })
})), Kne = Be("div", {
  name: "MuiPaginationItem",
  slot: "Icon",
  overridesResolver: (e, r) => r.icon
})(({
  theme: e,
  ownerState: r
}) => F({
  fontSize: e.typography.pxToRem(20),
  margin: "0 -8px"
}, r.size === "small" && {
  fontSize: e.typography.pxToRem(18)
}, r.size === "large" && {
  fontSize: e.typography.pxToRem(22)
})), rx = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiPaginationItem"
  }), {
    className: o,
    color: a = "standard",
    component: i,
    components: l = {},
    disabled: s = !1,
    page: u,
    selected: d = !1,
    shape: f = "circular",
    size: p = "medium",
    slots: g = {},
    type: h = "page",
    variant: v = "text"
  } = n, y = Xe(n, Yne), w = F({}, n, {
    color: a,
    disabled: s,
    selected: d,
    shape: f,
    size: p,
    type: h,
    variant: v
  }), $ = p6(), C = Une(w), b = ($ ? {
    previous: g.next || l.next || B9,
    next: g.previous || l.previous || W9,
    last: g.first || l.first || F9,
    first: g.last || l.last || Z9
  } : {
    previous: g.previous || l.previous || W9,
    next: g.next || l.next || B9,
    first: g.first || l.first || F9,
    last: g.last || l.last || Z9
  })[h];
  return h === "start-ellipsis" || h === "end-ellipsis" ? /* @__PURE__ */ le.jsx(Jne, {
    ref: t,
    ownerState: w,
    className: qe(C.root, o),
    children: "…"
  }) : /* @__PURE__ */ le.jsxs(qne, F({
    ref: t,
    ownerState: w,
    component: i,
    disabled: s,
    className: qe(C.root, o)
  }, y, {
    children: [h === "page" && u, b ? /* @__PURE__ */ le.jsx(Kne, {
      as: b,
      ownerState: w,
      className: C.icon
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (rx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "standard"]), c.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: c.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: c.shape({
    first: c.elementType,
    last: c.elementType,
    next: c.elementType,
    previous: c.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * The current page number.
   */
  page: c.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: c.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: c.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium", "large"]), c.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: c.shape({
    first: c.elementType,
    last: c.elementType,
    next: c.elementType,
    previous: c.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: c.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: c.oneOfType([c.oneOf(["outlined", "text"]), c.string])
});
const tx = rx, Qne = ["boundaryCount", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"], eoe = (e) => {
  const {
    classes: r,
    variant: t
  } = e;
  return _r({
    root: ["root", t],
    ul: ["ul"]
  }, Wne, r);
}, roe = Be("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.root, r[t.variant]];
  }
})({}), toe = Be("ul", {
  name: "MuiPagination",
  slot: "Ul",
  overridesResolver: (e, r) => r.ul
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function noe(e, r, t) {
  return e === "page" ? `${t ? "" : "Go to "}page ${r}` : `Go to ${e} page`;
}
const nx = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiPagination"
  }), {
    boundaryCount: o = 1,
    className: a,
    color: i = "standard",
    count: l = 1,
    defaultPage: s = 1,
    disabled: u = !1,
    getItemAriaLabel: d = noe,
    hideNextButton: f = !1,
    hidePrevButton: p = !1,
    renderItem: g = (P) => /* @__PURE__ */ le.jsx(tx, F({}, P)),
    shape: h = "circular",
    showFirstButton: v = !1,
    showLastButton: y = !1,
    siblingCount: w = 1,
    size: $ = "medium",
    variant: C = "text"
  } = n, x = Xe(n, Qne), {
    items: b
  } = Hne(F({}, n, {
    componentName: "Pagination"
  })), O = F({}, n, {
    boundaryCount: o,
    color: i,
    count: l,
    defaultPage: s,
    disabled: u,
    getItemAriaLabel: d,
    hideNextButton: f,
    hidePrevButton: p,
    renderItem: g,
    shape: h,
    showFirstButton: v,
    showLastButton: y,
    siblingCount: w,
    size: $,
    variant: C
  }), _ = eoe(O);
  return /* @__PURE__ */ le.jsx(roe, F({
    "aria-label": "pagination navigation",
    className: qe(_.root, a),
    ownerState: O,
    ref: t
  }, x, {
    children: /* @__PURE__ */ le.jsx(toe, {
      className: _.ul,
      ownerState: O,
      children: b.map((P, S) => /* @__PURE__ */ le.jsx("li", {
        children: g(F({}, P, {
          color: i,
          "aria-label": d(P.type, P.page, P.selected),
          shape: h,
          size: $,
          variant: C
        }))
      }, S))
    })
  }));
});
process.env.NODE_ENV !== "production" && (nx.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: Wn,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "standard"]), c.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: Wn,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: Wn,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: c.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: c.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: c.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: c.func,
  /**
   * The current page.
   */
  page: Wn,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: c.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: c.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: c.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: c.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: Wn,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: c.oneOfType([c.oneOf(["small", "medium", "large"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: c.oneOfType([c.oneOf(["outlined", "text"]), c.string])
});
const ooe = nx;
function aoe(e) {
  return yr("MuiSelect", e);
}
const ei = wr("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var H9;
const ioe = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], loe = Be("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${ei.select}`]: r.select
      },
      {
        [`&.${ei.select}`]: r[t.variant]
      },
      {
        [`&.${ei.error}`]: r.error
      },
      {
        [`&.${ei.multiple}`]: r.multiple
      }
    ];
  }
})(U_, {
  // Win specificity over the input base
  [`&.${ei.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), soe = Be("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, r) => {
    const {
      ownerState: t
    } = e;
    return [r.icon, t.variant && r[`icon${ze(t.variant)}`], t.open && r.iconOpen];
  }
})(J_), coe = Be("input", {
  shouldForwardProp: (e) => O6(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, r) => r.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function G9(e, r) {
  return typeof r == "object" && r !== null ? e === r : String(e) === String(r);
}
function uoe(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const doe = (e) => {
  const {
    classes: r,
    variant: t,
    disabled: n,
    multiple: o,
    open: a,
    error: i
  } = e, l = {
    select: ["select", t, n && "disabled", o && "multiple", i && "error"],
    icon: ["icon", `icon${ze(t)}`, a && "iconOpen", n && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return _r(l, aoe, r);
}, ox = /* @__PURE__ */ A.forwardRef(function(r, t) {
  var n;
  const {
    "aria-describedby": o,
    "aria-label": a,
    autoFocus: i,
    autoWidth: l,
    children: s,
    className: u,
    defaultOpen: d,
    defaultValue: f,
    disabled: p,
    displayEmpty: g,
    error: h = !1,
    IconComponent: v,
    inputRef: y,
    labelId: w,
    MenuProps: $ = {},
    multiple: C,
    name: x,
    onBlur: b,
    onChange: O,
    onClose: _,
    onFocus: P,
    onOpen: S,
    open: I,
    readOnly: N,
    renderValue: k,
    SelectDisplayProps: j = {},
    tabIndex: R,
    value: D,
    variant: T = "standard"
  } = r, V = Xe(r, ioe), [L, Z] = ia({
    controlled: D,
    default: f,
    name: "Select"
  }), [z, W] = ia({
    controlled: I,
    default: d,
    name: "Select"
  }), U = A.useRef(null), re = A.useRef(null), [X, J] = A.useState(null), {
    current: Q
  } = A.useRef(I != null), [se, q] = A.useState(), te = Xr(t, y), ae = A.useCallback((De) => {
    re.current = De, De && J(De);
  }, []), ge = X == null ? void 0 : X.parentNode;
  A.useImperativeHandle(te, () => ({
    focus: () => {
      re.current.focus();
    },
    node: U.current,
    value: L
  }), [L]), A.useEffect(() => {
    d && z && X && !Q && (q(l ? null : ge.clientWidth), re.current.focus());
  }, [X, l]), A.useEffect(() => {
    i && re.current.focus();
  }, [i]), A.useEffect(() => {
    if (!w)
      return;
    const De = tt(re.current).getElementById(w);
    if (De) {
      const Ge = () => {
        getSelection().isCollapsed && re.current.focus();
      };
      return De.addEventListener("click", Ge), () => {
        De.removeEventListener("click", Ge);
      };
    }
  }, [w]);
  const G = (De, Ge) => {
    De ? S && S(Ge) : _ && _(Ge), Q || (q(l ? null : ge.clientWidth), W(De));
  }, oe = (De) => {
    De.button === 0 && (De.preventDefault(), re.current.focus(), G(!0, De));
  }, ne = (De) => {
    G(!1, De);
  }, _e = A.Children.toArray(s), ye = (De) => {
    const Ge = _e.find((lr) => lr.props.value === De.target.value);
    Ge !== void 0 && (Z(Ge.props.value), O && O(De, Ge));
  }, Te = (De) => (Ge) => {
    let lr;
    if (Ge.currentTarget.hasAttribute("tabindex")) {
      if (C) {
        lr = Array.isArray(L) ? L.slice() : [];
        const Ir = L.indexOf(De.props.value);
        Ir === -1 ? lr.push(De.props.value) : lr.splice(Ir, 1);
      } else
        lr = De.props.value;
      if (De.props.onClick && De.props.onClick(Ge), L !== lr && (Z(lr), O)) {
        const Ir = Ge.nativeEvent || Ge, Or = new Ir.constructor(Ir.type, Ir);
        Object.defineProperty(Or, "target", {
          writable: !0,
          value: {
            value: lr,
            name: x
          }
        }), O(Or, De);
      }
      C || G(!1, Ge);
    }
  }, we = (De) => {
    N || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(De.key) !== -1 && (De.preventDefault(), G(!0, De));
  }, He = X !== null && z, he = (De) => {
    !He && b && (Object.defineProperty(De, "target", {
      writable: !0,
      value: {
        value: L,
        name: x
      }
    }), b(De));
  };
  delete V["aria-invalid"];
  let xe, Le;
  const Ue = [];
  let me = !1, Ie = !1;
  (bu({
    value: L
  }) || g) && (k ? xe = k(L) : me = !0);
  const er = _e.map((De) => {
    if (!/* @__PURE__ */ A.isValidElement(De))
      return null;
    process.env.NODE_ENV !== "production" && gi.isFragment(De) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Ge;
    if (C) {
      if (!Array.isArray(L))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : Io(2));
      Ge = L.some((lr) => G9(lr, De.props.value)), Ge && me && Ue.push(De.props.children);
    } else
      Ge = G9(L, De.props.value), Ge && me && (Le = De.props.children);
    return Ge && (Ie = !0), /* @__PURE__ */ A.cloneElement(De, {
      "aria-selected": Ge ? "true" : "false",
      onClick: Te(De),
      onKeyUp: (lr) => {
        lr.key === " " && lr.preventDefault(), De.props.onKeyUp && De.props.onKeyUp(lr);
      },
      role: "option",
      selected: Ge,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": De.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && A.useEffect(() => {
    if (!Ie && !C && L !== "") {
      const De = _e.map((Ge) => Ge.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${L}\` for the select ${x ? `(name="${x}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${De.filter((Ge) => Ge != null).map((Ge) => `\`${Ge}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Ie, _e, C, x, L]), me && (C ? Ue.length === 0 ? xe = null : xe = Ue.reduce((De, Ge, lr) => (De.push(Ge), lr < Ue.length - 1 && De.push(", "), De), []) : xe = Le);
  let Ke = se;
  !l && Q && X && (Ke = ge.clientWidth);
  let Me;
  typeof R != "undefined" ? Me = R : Me = p ? null : 0;
  const Pe = j.id || (x ? `mui-component-select-${x}` : void 0), Qe = F({}, r, {
    variant: T,
    value: L,
    open: He,
    error: h
  }), Sr = doe(Qe), Cr = F({}, $.PaperProps, (n = $.slotProps) == null ? void 0 : n.paper), nr = df();
  return /* @__PURE__ */ le.jsxs(A.Fragment, {
    children: [/* @__PURE__ */ le.jsx(loe, F({
      ref: ae,
      tabIndex: Me,
      role: "combobox",
      "aria-controls": nr,
      "aria-disabled": p ? "true" : void 0,
      "aria-expanded": He ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": a,
      "aria-labelledby": [w, Pe].filter(Boolean).join(" ") || void 0,
      "aria-describedby": o,
      onKeyDown: we,
      onMouseDown: p || N ? null : oe,
      onBlur: he,
      onFocus: P
    }, j, {
      ownerState: Qe,
      className: qe(j.className, Sr.select, u),
      id: Pe,
      children: uoe(xe) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        H9 || (H9 = /* @__PURE__ */ le.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : xe
    })), /* @__PURE__ */ le.jsx(coe, F({
      "aria-invalid": h,
      value: Array.isArray(L) ? L.join(",") : L,
      name: x,
      ref: U,
      "aria-hidden": !0,
      onChange: ye,
      tabIndex: -1,
      disabled: p,
      className: Sr.nativeInput,
      autoFocus: i,
      ownerState: Qe
    }, V)), /* @__PURE__ */ le.jsx(soe, {
      as: v,
      className: Sr.icon,
      ownerState: Qe
    }), /* @__PURE__ */ le.jsx(Sne, F({
      id: `menu-${x || ""}`,
      anchorEl: ge,
      open: He,
      onClose: ne,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, $, {
      MenuListProps: F({
        "aria-labelledby": w,
        role: "listbox",
        "aria-multiselectable": C ? "true" : void 0,
        disableListWrap: !0,
        id: nr
      }, $.MenuListProps),
      slotProps: F({}, $.slotProps, {
        paper: F({}, Cr, {
          style: F({
            minWidth: Ke
          }, Cr != null ? Cr.style : null)
        })
      }),
      children: er
    }))]
  });
});
process.env.NODE_ENV !== "production" && (ox.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": c.string,
  /**
   * @ignore
   */
  "aria-label": c.string,
  /**
   * @ignore
   */
  autoFocus: c.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: c.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * The CSS class name of the select element.
   */
  className: c.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: c.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: c.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: c.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: c.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: c.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: qt,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: c.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: c.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: c.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: c.string,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: c.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: c.func,
  /**
   * If `true`, the component is shown.
   */
  open: c.bool,
  /**
   * @ignore
   */
  readOnly: c.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: c.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: c.object,
  /**
   * @ignore
   */
  tabIndex: c.oneOfType([c.number, c.string]),
  /**
   * @ignore
   */
  type: c.any,
  /**
   * The input value.
   */
  value: c.any,
  /**
   * The variant to use.
   */
  variant: c.oneOf(["standard", "outlined", "filled"])
});
const foe = ox, poe = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], goe = ["root"], voe = (e) => {
  const {
    classes: r
  } = e;
  return r;
}, p2 = {
  name: "MuiSelect",
  overridesResolver: (e, r) => r.root,
  shouldForwardProp: (e) => fn(e) && e !== "variant",
  slot: "Root"
}, moe = Be(z_, p2)(""), hoe = Be(Q_, p2)(""), boe = Be(T_, p2)(""), g2 = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    name: "MuiSelect",
    props: r
  }), {
    autoWidth: o = !1,
    children: a,
    classes: i = {},
    className: l,
    defaultOpen: s = !1,
    displayEmpty: u = !1,
    IconComponent: d = E_,
    id: f,
    input: p,
    inputProps: g,
    label: h,
    labelId: v,
    MenuProps: y,
    multiple: w = !1,
    native: $ = !1,
    onClose: C,
    onOpen: x,
    open: b,
    renderValue: O,
    SelectDisplayProps: _,
    variant: P = "outlined"
  } = n, S = Xe(n, poe), I = $ ? Nne : foe, N = Vo(), k = Ma({
    props: n,
    muiFormControl: N,
    states: ["variant", "error"]
  }), j = k.variant || P, R = F({}, n, {
    variant: j,
    classes: i
  }), D = voe(R), T = Xe(D, goe), V = p || {
    standard: /* @__PURE__ */ le.jsx(moe, {
      ownerState: R
    }),
    outlined: /* @__PURE__ */ le.jsx(hoe, {
      label: h,
      ownerState: R
    }),
    filled: /* @__PURE__ */ le.jsx(boe, {
      ownerState: R
    })
  }[j], L = Xr(t, V.ref);
  return /* @__PURE__ */ le.jsx(A.Fragment, {
    children: /* @__PURE__ */ A.cloneElement(V, F({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: I,
      inputProps: F({
        children: a,
        error: k.error,
        IconComponent: d,
        variant: j,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: w
      }, $ ? {
        id: f
      } : {
        autoWidth: o,
        defaultOpen: s,
        displayEmpty: u,
        labelId: v,
        MenuProps: y,
        onClose: C,
        onOpen: x,
        open: b,
        renderValue: O,
        SelectDisplayProps: F({
          id: f
        }, _)
      }, g, {
        classes: g ? wt(T, g.classes) : T
      }, p ? p.props.inputProps : {})
    }, (w && $ || u) && j === "outlined" ? {
      notched: !0
    } : {}, {
      ref: L,
      className: qe(V.props.className, l, D.root)
    }, !p && {
      variant: j
    }, S))
  });
});
process.env.NODE_ENV !== "production" && (g2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: c.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: c.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: c.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: c.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: c.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: c.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: c.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: c.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: c.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: c.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: c.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: c.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: c.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: c.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: c.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: c.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: c.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: c.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: c.oneOfType([c.oneOf([""]), c.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: c.oneOf(["filled", "outlined", "standard"])
});
g2.muiName = "Select";
const yoe = g2;
function Coe(e) {
  return yr("MuiTextField", e);
}
wr("MuiTextField", ["root"]);
const woe = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"], _oe = {
  standard: z_,
  filled: T_,
  outlined: Q_
}, xoe = (e) => {
  const {
    classes: r
  } = e;
  return _r({
    root: ["root"]
  }, Coe, r);
}, $oe = Be($te, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, r) => r.root
})({}), ax = /* @__PURE__ */ A.forwardRef(function(r, t) {
  const n = xr({
    props: r,
    name: "MuiTextField"
  }), {
    autoComplete: o,
    autoFocus: a = !1,
    children: i,
    className: l,
    color: s = "primary",
    defaultValue: u,
    disabled: d = !1,
    error: f = !1,
    FormHelperTextProps: p,
    fullWidth: g = !1,
    helperText: h,
    id: v,
    InputLabelProps: y,
    inputProps: w,
    InputProps: $,
    inputRef: C,
    label: x,
    maxRows: b,
    minRows: O,
    multiline: _ = !1,
    name: P,
    onBlur: S,
    onChange: I,
    onFocus: N,
    placeholder: k,
    required: j = !1,
    rows: R,
    select: D = !1,
    SelectProps: T,
    type: V,
    value: L,
    variant: Z = "outlined"
  } = n, z = Xe(n, woe), W = F({}, n, {
    autoFocus: a,
    color: s,
    disabled: d,
    error: f,
    fullWidth: g,
    multiline: _,
    required: j,
    select: D,
    variant: Z
  }), U = xoe(W);
  process.env.NODE_ENV !== "production" && D && !i && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const re = {};
  Z === "outlined" && (y && typeof y.shrink != "undefined" && (re.notched = y.shrink), re.label = x), D && ((!T || !T.native) && (re.id = void 0), re["aria-describedby"] = void 0);
  const X = df(v), J = h && X ? `${X}-helper-text` : void 0, Q = x && X ? `${X}-label` : void 0, se = _oe[Z], q = /* @__PURE__ */ le.jsx(se, F({
    "aria-describedby": J,
    autoComplete: o,
    autoFocus: a,
    defaultValue: u,
    fullWidth: g,
    multiline: _,
    name: P,
    rows: R,
    maxRows: b,
    minRows: O,
    type: V,
    value: L,
    id: X,
    inputRef: C,
    onBlur: S,
    onChange: I,
    onFocus: N,
    placeholder: k,
    inputProps: w
  }, re, $));
  return /* @__PURE__ */ le.jsxs($oe, F({
    className: qe(U.root, l),
    disabled: d,
    error: f,
    fullWidth: g,
    ref: t,
    required: j,
    color: s,
    variant: Z,
    ownerState: W
  }, z, {
    children: [x != null && x !== "" && /* @__PURE__ */ le.jsx(tne, F({
      htmlFor: X,
      id: Q
    }, y, {
      children: x
    })), D ? /* @__PURE__ */ le.jsx(yoe, F({
      "aria-describedby": J,
      id: X,
      labelId: Q,
      value: L,
      input: q
    }, T, {
      children: i
    })) : q, h && /* @__PURE__ */ le.jsx(Rte, F({
      id: J
    }, p, {
      children: h
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (ax.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: c.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: c.bool,
  /**
   * @ignore
   */
  children: c.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: c.object,
  /**
   * @ignore
   */
  className: c.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: c.oneOfType([c.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), c.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: c.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: c.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: c.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: c.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: c.bool,
  /**
   * The helper text content.
   */
  helperText: c.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: c.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: c.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: c.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: c.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: qt,
  /**
   * The label content.
   */
  label: c.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: c.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: c.oneOfType([c.number, c.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: c.oneOfType([c.number, c.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: c.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: c.string,
  /**
   * @ignore
   */
  onBlur: c.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: c.func,
  /**
   * @ignore
   */
  onFocus: c.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: c.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: c.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: c.oneOfType([c.number, c.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: c.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: c.object,
  /**
   * The size of the component.
   */
  size: c.oneOfType([c.oneOf(["medium", "small"]), c.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: c.oneOfType([c.arrayOf(c.oneOfType([c.func, c.object, c.bool])), c.func, c.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: c.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: c.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: c.oneOf(["filled", "outlined", "standard"])
});
const Ooe = ax;
var ce = function() {
  return ce = Object.assign || function(r) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (r[a] = t[a]);
    }
    return r;
  }, ce.apply(this, arguments);
};
function Poe(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
  return t;
}
var Soe = de(function() {
  return Promise.resolve().then(function() {
    return Yie;
  });
}), Ioe = de(function() {
  return Promise.resolve().then(function() {
    return Uie;
  });
}), Eoe = de(function() {
  return Promise.resolve().then(function() {
    return Jie;
  });
}), Roe = de(function() {
  return Promise.resolve().then(function() {
    return qie;
  });
}), Aoe = de(function() {
  return Promise.resolve().then(function() {
    return Qie;
  });
}), koe = de(function() {
  return Promise.resolve().then(function() {
    return rle;
  });
}), Moe = de(function() {
  return Promise.resolve().then(function() {
    return nle;
  });
}), Noe = de(function() {
  return Promise.resolve().then(function() {
    return ale;
  });
}), Toe = de(function() {
  return Promise.resolve().then(function() {
    return ile;
  });
}), Doe = de(function() {
  return Promise.resolve().then(function() {
    return lle;
  });
}), joe = de(function() {
  return Promise.resolve().then(function() {
    return sle;
  });
}), Loe = de(function() {
  return Promise.resolve().then(function() {
    return ule;
  });
}), zoe = de(function() {
  return Promise.resolve().then(function() {
    return dle;
  });
}), Voe = de(function() {
  return Promise.resolve().then(function() {
    return ple;
  });
}), Foe = de(function() {
  return Promise.resolve().then(function() {
    return gle;
  });
}), Zoe = de(function() {
  return Promise.resolve().then(function() {
    return mle;
  });
}), Woe = de(function() {
  return Promise.resolve().then(function() {
    return ble;
  });
}), Boe = de(function() {
  return Promise.resolve().then(function() {
    return Cle;
  });
}), Hoe = de(function() {
  return Promise.resolve().then(function() {
    return _le;
  });
}), Goe = de(function() {
  return Promise.resolve().then(function() {
    return $le;
  });
}), Xoe = de(function() {
  return Promise.resolve().then(function() {
    return Ole;
  });
}), Yoe = de(function() {
  return Promise.resolve().then(function() {
    return Ple;
  });
}), Uoe = de(function() {
  return Promise.resolve().then(function() {
    return Sle;
  });
}), Joe = de(function() {
  return Promise.resolve().then(function() {
    return Ele;
  });
}), qoe = de(function() {
  return Promise.resolve().then(function() {
    return Ale;
  });
}), Koe = de(function() {
  return Promise.resolve().then(function() {
    return Mle;
  });
}), Qoe = de(function() {
  return Promise.resolve().then(function() {
    return Ase;
  });
}), eae = de(function() {
  return Promise.resolve().then(function() {
    return Tle;
  });
}), rae = de(function() {
  return Promise.resolve().then(function() {
    return jle;
  });
}), tae = de(function() {
  return Promise.resolve().then(function() {
    return Lle;
  });
}), nae = de(function() {
  return Promise.resolve().then(function() {
    return Vle;
  });
}), oae = de(function() {
  return Promise.resolve().then(function() {
    return Zle;
  });
}), aae = de(function() {
  return Promise.resolve().then(function() {
    return Ble;
  });
}), iae = de(function() {
  return Promise.resolve().then(function() {
    return Hle;
  });
}), lae = de(function() {
  return Promise.resolve().then(function() {
    return Gle;
  });
}), sae = de(function() {
  return Promise.resolve().then(function() {
    return Xle;
  });
}), cae = de(function() {
  return Promise.resolve().then(function() {
    return Ule;
  });
}), uae = de(function() {
  return Promise.resolve().then(function() {
    return qle;
  });
}), dae = de(function() {
  return Promise.resolve().then(function() {
    return Qle;
  });
}), fae = de(function() {
  return Promise.resolve().then(function() {
    return rse;
  });
}), pae = de(function() {
  return Promise.resolve().then(function() {
    return nse;
  });
}), gae = de(function() {
  return Promise.resolve().then(function() {
    return ase;
  });
}), vae = de(function() {
  return Promise.resolve().then(function() {
    return ise;
  });
}), mae = de(function() {
  return Promise.resolve().then(function() {
    return sse;
  });
}), hae = de(function() {
  return Promise.resolve().then(function() {
    return use;
  });
}), bae = de(function() {
  return Promise.resolve().then(function() {
    return fse;
  });
}), yae = de(function() {
  return Promise.resolve().then(function() {
    return pse;
  });
}), Cae = de(function() {
  return Promise.resolve().then(function() {
    return vse;
  });
}), wae = de(function() {
  return Promise.resolve().then(function() {
    return hse;
  });
}), _ae = de(function() {
  return Promise.resolve().then(function() {
    return bse;
  });
}), xae = de(function() {
  return Promise.resolve().then(function() {
    return Cse;
  });
}), $ae = de(function() {
  return Promise.resolve().then(function() {
    return _se;
  });
}), Oae = de(function() {
  return Promise.resolve().then(function() {
    return xse;
  });
}), Pae = de(function() {
  return Promise.resolve().then(function() {
    return $se;
  });
}), Sae = de(function() {
  return Promise.resolve().then(function() {
    return Pse;
  });
}), Iae = de(function() {
  return Promise.resolve().then(function() {
    return Sse;
  });
}), Eae = de(function() {
  return Promise.resolve().then(function() {
    return Ese;
  });
}), Rae = de(function() {
  return Promise.resolve().then(function() {
    return $ue;
  });
}), Aae = de(function() {
  return Promise.resolve().then(function() {
    return Pue;
  });
}), kae = de(function() {
  return Promise.resolve().then(function() {
    return Iue;
  });
}), Mae = de(function() {
  return Promise.resolve().then(function() {
    return Rue;
  });
}), Nae = de(function() {
  return Promise.resolve().then(function() {
    return kue;
  });
}), Tae = de(function() {
  return Promise.resolve().then(function() {
    return Nue;
  });
}), Dae = de(function() {
  return Promise.resolve().then(function() {
    return Due;
  });
}), jae = de(function() {
  return Promise.resolve().then(function() {
    return Lue;
  });
}), Lae = de(function() {
  return Promise.resolve().then(function() {
    return Vue;
  });
}), zae = de(function() {
  return Promise.resolve().then(function() {
    return Zue;
  });
}), Vae = de(function() {
  return Promise.resolve().then(function() {
    return Bue;
  });
}), Fae = de(function() {
  return Promise.resolve().then(function() {
    return Gue;
  });
}), Zae = de(function() {
  return Promise.resolve().then(function() {
    return Yue;
  });
}), Wae = de(function() {
  return Promise.resolve().then(function() {
    return Jue;
  });
}), Bae = de(function() {
  return Promise.resolve().then(function() {
    return Kue;
  });
}), Hae = de(function() {
  return Promise.resolve().then(function() {
    return Mse;
  });
}), Gae = de(function() {
  return Promise.resolve().then(function() {
    return Tse;
  });
}), Xae = de(function() {
  return Promise.resolve().then(function() {
    return jse;
  });
}), Yae = de(function() {
  return Promise.resolve().then(function() {
    return zse;
  });
}), Uae = de(function() {
  return Promise.resolve().then(function() {
    return Fse;
  });
}), Jae = de(function() {
  return Promise.resolve().then(function() {
    return Wse;
  });
}), qae = de(function() {
  return Promise.resolve().then(function() {
    return Hse;
  });
}), Kae = de(function() {
  return Promise.resolve().then(function() {
    return Xse;
  });
}), Qae = de(function() {
  return Promise.resolve().then(function() {
    return Use;
  });
}), eie = de(function() {
  return Promise.resolve().then(function() {
    return qse;
  });
}), rie = de(function() {
  return Promise.resolve().then(function() {
    return Qse;
  });
}), tie = de(function() {
  return Promise.resolve().then(function() {
    return rce;
  });
}), nie = de(function() {
  return Promise.resolve().then(function() {
    return nce;
  });
}), oie = de(function() {
  return Promise.resolve().then(function() {
    return ace;
  });
}), aie = de(function() {
  return Promise.resolve().then(function() {
    return lce;
  });
}), iie = de(function() {
  return Promise.resolve().then(function() {
    return cce;
  });
}), lie = de(function() {
  return Promise.resolve().then(function() {
    return dce;
  });
}), sie = de(function() {
  return Promise.resolve().then(function() {
    return pce;
  });
}), cie = de(function() {
  return Promise.resolve().then(function() {
    return vce;
  });
}), uie = de(function() {
  return Promise.resolve().then(function() {
    return hce;
  });
}), die = de(function() {
  return Promise.resolve().then(function() {
    return yce;
  });
}), fie = de(function() {
  return Promise.resolve().then(function() {
    return Cce;
  });
}), pie = de(function() {
  return Promise.resolve().then(function() {
    return wce;
  });
}), gie = de(function() {
  return Promise.resolve().then(function() {
    return xce;
  });
}), vie = de(function() {
  return Promise.resolve().then(function() {
    return $ce;
  });
}), mie = de(function() {
  return Promise.resolve().then(function() {
    return Oce;
  });
}), hie = de(function() {
  return Promise.resolve().then(function() {
    return Pce;
  });
}), bie = de(function() {
  return Promise.resolve().then(function() {
    return Sce;
  });
}), yie = de(function() {
  return Promise.resolve().then(function() {
    return Ice;
  });
}), Cie = de(function() {
  return Promise.resolve().then(function() {
    return Ece;
  });
}), wie = de(function() {
  return Promise.resolve().then(function() {
    return Rce;
  });
}), _ie = de(function() {
  return Promise.resolve().then(function() {
    return Ace;
  });
}), xie = de(function() {
  return Promise.resolve().then(function() {
    return kce;
  });
}), $ie = de(function() {
  return Promise.resolve().then(function() {
    return Nce;
  });
}), Oie = de(function() {
  return Promise.resolve().then(function() {
    return Dce;
  });
}), Pie = de(function() {
  return Promise.resolve().then(function() {
    return Lce;
  });
}), Sie = de(function() {
  return Promise.resolve().then(function() {
    return Vce;
  });
}), Iie = de(function() {
  return Promise.resolve().then(function() {
    return Zce;
  });
}), Eie = de(function() {
  return Promise.resolve().then(function() {
    return Bce;
  });
}), Rie = de(function() {
  return Promise.resolve().then(function() {
    return Gce;
  });
}), Aie = de(function() {
  return Promise.resolve().then(function() {
    return Yce;
  });
}), kie = de(function() {
  return Promise.resolve().then(function() {
    return Jce;
  });
}), Mie = de(function() {
  return Promise.resolve().then(function() {
    return Kce;
  });
}), Nie = de(function() {
  return Promise.resolve().then(function() {
    return eue;
  });
}), Tie = de(function() {
  return Promise.resolve().then(function() {
    return tue;
  });
}), Die = de(function() {
  return Promise.resolve().then(function() {
    return oue;
  });
}), jie = de(function() {
  return Promise.resolve().then(function() {
    return iue;
  });
}), Lie = de(function() {
  return Promise.resolve().then(function() {
    return sue;
  });
}), zie = de(function() {
  return Promise.resolve().then(function() {
    return uue;
  });
}), Vie = de(function() {
  return Promise.resolve().then(function() {
    return fue;
  });
}), Fie = de(function() {
  return Promise.resolve().then(function() {
    return gue;
  });
}), Zie = de(function() {
  return Promise.resolve().then(function() {
    return mue;
  });
}), Wie = de(function() {
  return Promise.resolve().then(function() {
    return bue;
  });
}), Bie = de(function() {
  return Promise.resolve().then(function() {
    return Cue;
  });
}), Hie = de(function() {
  return Promise.resolve().then(function() {
    return _ue;
  });
}), Gie = {
  "arrow-down": Soe,
  "arrow-left": Ioe,
  "arrow-right": Eoe,
  "arrow-up": Roe,
  back: Aoe,
  "left-arrow-circle": koe,
  up: Moe,
  add: Noe,
  bullet: Toe,
  calendar: Doe,
  check: joe,
  clip: Loe,
  clock: zoe,
  "close-circle": Voe,
  close: Foe,
  copy: Zoe,
  download: Woe,
  edit: Boe,
  email: Hoe,
  exit: Goe,
  "eye-off": Xoe,
  "eye-on": Yoe,
  fail: Uoe,
  "filter-close": Joe,
  filter: qoe,
  flag: Koe,
  group: Qoe,
  home: eae,
  image: rae,
  information: tae,
  "item-documents-files": nae,
  key: oae,
  lock: aae,
  menu: iae,
  minus: lae,
  more: sae,
  notification: cae,
  plus: uae,
  print: dae,
  "question-checkmark-circle": fae,
  question: pae,
  refresh: gae,
  search: vae,
  "send-share": mae,
  settings: hae,
  star: bae,
  success: yae,
  support: Cae,
  "time-zone": wae,
  trash: _ae,
  unlock: xae,
  upload: $ae,
  user: Oae,
  warning: Pae,
  wifi: Sae,
  overflow: Iae,
  "plus-circle": Eae,
  brain: Rae,
  "card-edit": Aae,
  "doctor-talk": kae,
  folder: Mae,
  heartbeat: Nae,
  hospital: Tae,
  mask: Dae,
  "medical-certificate": jae,
  "medical-cross": Lae,
  notes: zae,
  pill: Vae,
  "scale-weight": Fae,
  "shield-heart": Zae,
  stethoscope: Wae,
  syringe: Bae,
  audio: Hae,
  "camera-off": Gae,
  "camera-on": Xae,
  fullscreen: Yae,
  "microphone-off": Uae,
  "microphone-on": Jae,
  minimize: qae,
  miniplayer: Kae,
  "phone-on": Qae,
  rotate: eie,
  "share-screen": rie,
  book: tie,
  "browser-video-player": nie,
  chart: oie,
  chat: aie,
  "clipboard-saved": iie,
  clipboard: lie,
  "credit-card": sie,
  dashboard: cie,
  "document-atestado": uie,
  "face-id": die,
  "file-check": fie,
  "file-error": pie,
  "file-exams": gie,
  file: vie,
  "file-image": mie,
  "file-pdf": hie,
  "file-text": bie,
  "file-warning-error": yie,
  "file-crossed": Cie,
  "filter-cross-delete": wie,
  "file-warning": _ie,
  "user-error": xie,
  "font-bold": $ie,
  "font-italic": Oie,
  "font-underline": Pie,
  frame: Sie,
  "icon-share": Iie,
  identity: Eie,
  "justify-center": Rie,
  "justify-left": Aie,
  "medical-cross-fast-help-circle": kie,
  mobile: Mie,
  "paragraph-list": Nie,
  "paragraph-number": Tie,
  receipt: Die,
  "select-all": jie,
  send: Lie,
  "settings-handles": zie,
  "signin-send-share": Vie,
  "receipt-bullet": Fie,
  analytics: Zie,
  "document-calculator": Wie,
  "profile-checkmark": Bie,
  "hand-key": Hie
}, Pt = function(e) {
  var r = e.name, t = e.size, n = e.color, o = e.onClick, a = Poe(e, ["name", "size", "color", "onClick"]), i = Je(function() {
    if (!r)
      throw new Error("Icon name was not provided");
    return r;
  }, [r]), l = Gie[i];
  return m(jO, ce({ fallback: m("span", { className: "icon-on-suspense" }) }, { children: m(l, ce({ color: n, onClick: o, size: t }, a)) }));
}, Xie = {
  "x-small": 14,
  small: 16,
  medium: 24,
  large: 32
}, fe = function(e) {
  return Xie[e || "medium"];
}, Nn = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.231 9.24a.77.77 0 0 1 1.117 0L12 13.025l3.652-3.785a.77.77 0 0 1 1.117 0 .84.84 0 0 1 0 1.157l-4.21 4.363a.77.77 0 0 1-1.117 0l-4.21-4.363a.84.84 0 0 1 0-1.157Z", fill: "currentColor" }) }));
}, Yie = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Nn
}), v2 = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.76 7.231a.77.77 0 0 1 0 1.117L10.975 12l3.785 3.652a.77.77 0 0 1 0 1.117.84.84 0 0 1-1.157 0l-4.363-4.21a.77.77 0 0 1 0-1.117l4.363-4.21a.84.84 0 0 1 1.157 0Z", fill: "currentColor" }) }));
}, Uie = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: v2
}), yu = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.24 7.231a.84.84 0 0 1 1.157 0l4.363 4.21a.77.77 0 0 1 0 1.117l-4.363 4.21a.84.84 0 0 1-1.157 0 .77.77 0 0 1 0-1.116L13.025 12 9.24 8.348a.77.77 0 0 1 0-1.117Z", fill: "currentColor" }) }));
}, Jie = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yu
}), io = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.442 9.24a.77.77 0 0 1 1.116 0l4.21 4.363a.84.84 0 0 1 0 1.157.77.77 0 0 1-1.116 0L12 10.975 8.348 14.76a.77.77 0 0 1-1.117 0 .84.84 0 0 1 0-1.157l4.21-4.363Z", fill: "currentColor" }) }));
}, qie = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: io
}), Kie = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.53 6.47a.75.75 0 0 1 0 1.06l-3.72 3.72H19a.75.75 0 0 1 0 1.5H6.81l3.72 3.72a.75.75 0 1 1-1.06 1.06l-5-5a.75.75 0 0 1 0-1.06l5-5a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }) }));
}, Qie = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Kie
}), ele = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.949A7.05 7.05 0 0 0 2.95 10 7.05 7.05 0 0 0 10 17.051 7.05 7.05 0 0 0 17.052 10 7.05 7.05 0 0 0 10 2.949Zm0 15.384A8.333 8.333 0 0 1 1.667 10 8.333 8.333 0 0 1 10 1.667 8.333 8.333 0 0 1 18.334 10 8.333 8.333 0 0 1 10 18.333Z", fill: e.color }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.94 10c0-.354.287-.641.641-.641h6.838a.641.641 0 0 1 0 1.282H6.581a.641.641 0 0 1-.64-.641Z", fill: e.color }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.599 6.983c.25.25.25.656 0 .906L7.488 10l2.11 2.112a.641.641 0 1 1-.906.906l-2.564-2.564a.641.641 0 0 1 0-.906l2.564-2.564c.25-.25.656-.25.907 0Z", fill: e.color })] }));
}, rle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ele
}), tle = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.48 10.48a.75.75 0 0 1-1.06 0L12.7 6.76v12.19a.75.75 0 0 1-1.5 0V6.76l-3.72 3.72a.75.75 0 1 1-1.06-1.06l5-5a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1 0 1.06Z", fill: "currentColor" }) }));
}, nle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: tle
}), ole = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 15.25a.75.75 0 0 0 1.5 0v-6.5h6.5a.75.75 0 0 0 0-1.5h-6.5V.75a.75.75 0 0 0-1.5 0v6.5H.75a.75.75 0 0 0 0 1.5h6.5v6.5Z", fill: "currentColor" }) }));
}, ale = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ole
}), m2 = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.243 7.757a6 6 0 1 1-8.485 8.486 6 6 0 0 1 8.485-8.486Z", fill: "currentColor" }) }));
}, ile = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: m2
}), h2 = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.999A3.749 3.749 0 0 1 5.999 2.25H18a3.749 3.749 0 0 1 3.749 3.749V18a3.749 3.749 0 0 1-3.749 3.749H6a3.749 3.749 0 0 1-3.749-3.749V6Zm3.749-2.25A2.25 2.25 0 0 0 3.749 6V18A2.25 2.25 0 0 0 6 20.251H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.749H6Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 8A.75.75 0 0 1 3 7.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 8ZM17.805 10.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 11.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM14.304 10.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 11.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM10.803 10.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 11.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM7.303 13.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.246-.555Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 14.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505A.748.748 0 0 1 6 14.45ZM10.803 13.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 14.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM14.304 13.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 14.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM17.805 13.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 14.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM17.805 16.946a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 17.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM14.304 16.946a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 17.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM10.803 16.946a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 17.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM7.303 16.946a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.246-.555Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 17.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505A.748.748 0 0 1 6 17.45Z", fill: "currentColor" })] }));
}, lle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: h2
}), M1 = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.774 5.728a.786.786 0 0 1 0 1.104L9.46 18.272a.765.765 0 0 1-1.091 0l-5.143-5.2a.786.786 0 0 1 0-1.103.765.765 0 0 1 1.09 0l4.598 4.648 10.77-10.889a.765.765 0 0 1 1.09 0Z", fill: "currentColor" }) }));
}, sle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: M1
}), cle = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6 3.605a4.629 4.629 0 1 1 6.547 6.546l-7.232 7.232a2.866 2.866 0 0 1-4.052-4.052l5.486-5.486a.75.75 0 1 1 1.06 1.06l-5.486 5.486a1.366 1.366 0 0 0 1.932 1.932l7.232-7.232a3.13 3.13 0 1 0-4.426-4.426L6.43 11.897a4.892 4.892 0 1 0 6.92 6.92l4.389-4.39a.75.75 0 1 1 1.06 1.061l-4.389 4.39a6.392 6.392 0 0 1-9.04 0 6.392 6.392 0 0 1 0-9.041L12.6 3.605Z", fill: "currentColor" }) }));
}, ule = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: cle
}), ix = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.613 12.618c0-.425.345-.77.77-.77h4.769a.769.769 0 0 1 0 1.539h-4.77a.769.769 0 0 1-.769-.77Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.382 6.103c.425 0 .77.344.77.769v5.746a.769.769 0 1 1-1.539 0V6.872c0-.425.345-.77.77-.77Z", fill: "currentColor" })] }));
}, dle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ix
}), fle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.298 5.702c.2.2.2.525 0 .726l-3.87 3.87a.513.513 0 0 1-.726-.725l3.87-3.87c.2-.2.526-.2.726 0Z", fill: e.color }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.702 5.702c.2-.2.525-.2.726 0l3.87 3.87a.513.513 0 0 1-.725.726l-3.87-3.87c-.2-.2-.2-.525 0-.726Z", fill: e.color }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2.36a5.64 5.64 0 1 0 0 11.28A5.64 5.64 0 0 0 8 2.36ZM1.333 8a6.666 6.666 0 1 1 13.334 0A6.666 6.666 0 1 1 1.334 8Z", fill: e.color })] }));
}, ple = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: fle
}), Fo = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.277 6.277c.37-.37.97-.37 1.34 0l10.105 10.106a.947.947 0 1 1-1.34 1.34L6.278 7.617a.947.947 0 0 1 0-1.34Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.723 6.277c.37.37.37.97 0 1.34L7.617 17.722a.947.947 0 1 1-1.34-1.34L16.383 6.278c.37-.37.97-.37 1.34 0Z", fill: "currentColor" })] }));
}, gle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Fo
}), vle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.103 8.922a2.82 2.82 0 0 1 2.82-2.82H19.18A2.82 2.82 0 0 1 22 8.923v10.259A2.82 2.82 0 0 1 19.18 22H8.923a2.82 2.82 0 0 1-2.82-2.82V8.923Zm2.82-1.281c-.709 0-1.282.573-1.282 1.281v10.259c0 .707.573 1.281 1.281 1.281h10.259c.707 0 1.281-.574 1.281-1.281V8.922c0-.708-.574-1.281-1.281-1.281H8.922Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.82 3.538c-.708 0-1.282.574-1.282 1.282v10.257c0 .708.574 1.282 1.282 1.282h2.052a.769.769 0 0 1 0 1.538H4.82A2.82 2.82 0 0 1 2 15.077V4.82A2.82 2.82 0 0 1 4.82 2h10.257a2.82 2.82 0 0 1 2.82 2.82v2.052a.769.769 0 0 1-1.538 0V4.82c0-.708-.574-1.282-1.282-1.282H4.82Z", fill: "currentColor" })] }));
}, mle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vle
}), hle = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 .25a.75.75 0 0 1 .75.75v12.19l3.72-3.72a.75.75 0 0 1 1.06 1.06l-5 5.001a.75.75 0 0 1-1.061 0l-5-5a.75.75 0 0 1 1.06-1.061L8.25 13.19V1A.75.75 0 0 1 9 .25ZM.25 19a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 19Z", fill: "currentColor" }) }));
}, ble = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hle
}), yle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.834 3.622c-.71 0-1.296.612-1.296 1.381v13.994c0 .768.586 1.381 1.296 1.381h14.332c.71 0 1.296-.613 1.296-1.381v-6.384c0-.448.344-.81.769-.81.425 0 .769.362.769.81v6.384C22 20.65 20.737 22 19.166 22H4.834C3.264 22 2 20.65 2 18.997V5.003C2 3.35 3.263 2 4.834 2H12c.425 0 .77.363.77.81 0 .449-.345.812-.77.812H4.834Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.009 2.871a2.719 2.719 0 0 1 3.988 0l.177.186c1.101 1.16 1.101 3.043 0 4.204l-8.605 9.07-.003.002a1.78 1.78 0 0 1-.832.496l-3.812 1.005a.751.751 0 0 1-.745-.21.835.835 0 0 1-.199-.785l.954-4.018c.079-.333.242-.637.472-.88l8.605-9.07Zm-8.23 13.065 2.582-.68a.26.26 0 0 0 .121-.073l8.604-9.069c.5-.527.5-1.383 0-1.91l-.176-.186a1.236 1.236 0 0 0-1.813 0l-8.605 9.07a.276.276 0 0 0-.068.126l-.646 2.722Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.384 4.583a.742.742 0 0 1 1.088 0l3.077 3.244c.3.316.3.83 0 1.146a.742.742 0 0 1-1.088 0L15.385 5.73a.842.842 0 0 1 0-1.147ZM8.616 12.22c.08-.011.24-.035.387-.035 1.841 0 3.333 1.573 3.333 3.513 0 .161-.022.325-.034.415a2.576 2.576 0 0 0-.005.039c-.056.444-.442.756-.863.697-.421-.058-.718-.466-.662-.91l.012-.094c.01-.08.014-.11.014-.147 0-1.045-.803-1.892-1.795-1.892a.633.633 0 0 0-.103.01l-.133.02c-.421.054-.805-.263-.857-.707-.051-.444.249-.849.67-.903l.036-.006Z", fill: "currentColor" })] }));
}, Cle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yle
}), wle = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 6.8A2.543 2.543 0 0 1 4.8 4.25h14.4a2.543 2.543 0 0 1 2.547 2.68.75.75 0 0 1 .003.07v10A2.756 2.756 0 0 1 19 19.75H5A2.756 2.756 0 0 1 2.25 17V7c0-.024.001-.047.003-.07a2.55 2.55 0 0 1-.003-.13Zm1.5 2.374V17c0 .06.004.119.013.177l4.748-4.75L3.75 9.175Zm6.39 2.55a.77.77 0 0 0-.072-.05l-5.82-3.976c-.357-.293-.498-.589-.498-.898 0-.586.464-1.05 1.05-1.05h14.4c.586 0 1.05.464 1.05 1.05 0 .312-.14.62-.466 1.042l-5.827 3.885a.65.65 0 0 0-.025.017l-.043.028c-1.149.736-2.525.737-3.675.003l-.074-.051Zm-.344 1.54-4.973 4.973c.058.009.117.013.177.013h14c.06 0 .119-.004.177-.013l-4.94-4.939a4.81 4.81 0 0 1-4.44-.034Zm5.741-.787 4.7 4.7c.009-.058.013-.117.013-.177V9.335l-4.713 3.142Z", fill: "currentColor" }) }));
}, _le = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: wle
}), xle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.825 12a.77.77 0 0 1 .77-.77h5.135a.77.77 0 1 1 0 1.538h-5.135a.77.77 0 0 1-.77-.768Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.131 9.405c.301-.3.789-.3 1.09 0l2.053 2.051c.301.3.301.787 0 1.087l-2.054 2.052c-.3.3-.788.3-1.089 0-.3-.3-.3-.788 0-1.088L19.641 12l-1.51-1.508c-.3-.3-.3-.787 0-1.087Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.324 3.538c-.71 0-1.284.574-1.284 1.282v14.36c0 .708.574 1.282 1.284 1.282H17.65c.71 0 1.284-.574 1.284-1.283v-2.051a.77.77 0 0 1 1.54 0v2.051A2.822 2.822 0 0 1 17.649 22H5.324A2.822 2.822 0 0 1 2.5 19.18V4.82A2.822 2.822 0 0 1 5.324 2H17.65a2.822 2.822 0 0 1 2.824 2.82v2.051a.77.77 0 0 1-1.54 0v-2.05c0-.71-.575-1.283-1.284-1.283H5.324Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.405 10.205a.77.77 0 0 1 .77.769v2.051a.77.77 0 0 1-1.54 0v-2.051a.77.77 0 0 1 .77-.769Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.486 2a.77.77 0 0 1 .77.769v14.355c0 1.069-.604 2.044-1.56 2.523l-4.11 2.052c-1.876.937-4.086-.427-4.086-2.523a.77.77 0 0 1 1.54 0 1.284 1.284 0 0 0 1.858 1.147l4.107-2.05c.437-.22.711-.663.711-1.15V2.77a.77.77 0 0 1 .77-.769Z", fill: "currentColor" })] }));
}, $le = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: xle
}), lx = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.714 18.435a.768.768 0 0 1 .995-.442c.766.298 1.536.459 2.291.459.425 0 .77.346.77.774A.772.772 0 0 1 12 20c-.972 0-1.931-.207-2.846-.563a.776.776 0 0 1-.44-1.002Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.476 11.802a.777.777 0 0 1 .31 1.05c-1.016 1.892-2.465 3.664-4.144 4.97C15.967 19.123 14.014 20 12 20a.772.772 0 0 1-.77-.774c0-.428.345-.774.77-.774 1.57 0 3.202-.69 4.701-1.856 1.495-1.162 2.809-2.762 3.732-4.481a.767.767 0 0 1 1.043-.313Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.761 8.233a.766.766 0 0 1 1.085.086 16.398 16.398 0 0 1 1.94 2.83c.285.53.285 1.173 0 1.702a.766.766 0 0 1-1.041.313.777.777 0 0 1-.312-1.05.245.245 0 0 0 0-.228 14.858 14.858 0 0 0-1.757-2.562.778.778 0 0 1 .085-1.091ZM19.724 4.227c.3.302.3.792 0 1.095L5.364 19.773a.766.766 0 0 1-1.088 0 .778.778 0 0 1 0-1.095l14.36-14.451a.766.766 0 0 1 1.088 0Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.741 10.248a2.45 2.45 0 0 0-3.481 0 2.49 2.49 0 0 0 0 3.503c.3.303.3.793 0 1.095a.766.766 0 0 1-1.088 0 4.045 4.045 0 0 1 0-5.693 3.983 3.983 0 0 1 5.657 0c.3.302.3.792 0 1.095a.766.766 0 0 1-1.088 0Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.358 6.179C8.033 4.876 9.986 4 12 4c2.014 0 3.97.877 5.644 2.181a.778.778 0 0 1 .138 1.086.766.766 0 0 1-1.08.139C15.205 6.238 13.573 5.548 12 5.548c-1.57 0-3.202.69-4.701 1.856-1.495 1.163-2.809 2.763-3.732 4.482a.245.245 0 0 0 0 .23c.923 1.718 2.236 3.316 3.73 4.48a.778.778 0 0 1 .138 1.085.766.766 0 0 1-1.08.14c-1.676-1.307-3.125-3.077-4.142-4.97a1.805 1.805 0 0 1 0-1.7C3.23 9.256 4.679 7.483 6.358 6.178Z", fill: "currentColor" })] }));
}, Ole = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: lx
}), sx = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.299 7.404c-1.495 1.162-2.809 2.762-3.732 4.481a.245.245 0 0 0 0 .23c.923 1.719 2.237 3.318 3.732 4.481 1.499 1.166 3.13 1.856 4.701 1.856 1.57 0 3.202-.69 4.701-1.856 1.495-1.162 2.809-2.762 3.732-4.481a.246.246 0 0 0 0-.23c-.923-1.719-2.237-3.318-3.732-4.481-1.5-1.166-3.13-1.856-4.701-1.856-1.571 0-3.202.69-4.701 1.856Zm-.941-1.225C8.033 4.876 9.986 4 12 4c2.014 0 3.967.876 5.642 2.179 1.679 1.305 3.128 3.077 4.145 4.97.284.53.284 1.172 0 1.702-1.017 1.893-2.466 3.665-4.145 4.97C15.967 19.125 14.014 20 12 20c-2.014 0-3.967-.876-5.642-2.179-1.679-1.306-3.128-3.077-4.145-4.97a1.804 1.804 0 0 1 0-1.702C3.23 9.256 4.679 7.484 6.358 6.18Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.658 10.332a2.334 2.334 0 0 0-3.316 0 2.37 2.37 0 0 0 0 3.336c.916.922 2.4.922 3.316 0a2.37 2.37 0 0 0 0-3.336Zm1.036-1.043a3.793 3.793 0 0 0-5.388 0 3.852 3.852 0 0 0 0 5.422 3.793 3.793 0 0 0 5.388 0 3.852 3.852 0 0 0 0-5.422Z", fill: "currentColor" })] }));
}, Ple = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: sx
}), Fi = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.447 8.553c.3.3.3.788 0 1.088L9.64 15.447a.77.77 0 1 1-1.088-1.088l5.806-5.806c.3-.3.787-.3 1.088 0Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.553 8.553c.3-.3.788-.3 1.088 0l5.806 5.806a.77.77 0 0 1-1.088 1.088L8.553 9.64a.77.77 0 0 1 0-1.088Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538A8.461 8.461 0 0 0 3.538 12 8.46 8.46 0 0 0 12 20.462 8.46 8.46 0 0 0 20.462 12 8.46 8.46 0 0 0 12 3.538ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" })] }));
}, Sle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Fi
}), Ile = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 19 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.234 3.473h9.896c.681 0 1.239.553 1.243 1.234v1.034c0 .147-.11.246-.234.258a.253.253 0 0 1-.205-.07l-.541-.517a.26.26 0 0 1-.041-.053.139.139 0 0 1-.025-.05.214.214 0 0 1-.016-.085v-.517a.175.175 0 0 0-.177-.176H4.24a.175.175 0 0 0-.177.176v1.83c0 .044.017.09.05.122l3.682 3.675a.6.6 0 0 1 .086.115l.002.004.002.004.005.008a.144.144 0 0 1 .014.03l.002.007a.29.29 0 0 0 .02.05c.002.003.003.008.004.013l.005.015.001.007c.001.004.003.008.003.013 0 .004 0 .01.002.015a.08.08 0 0 1 .002.014c0 .004 0 .008.002.012a.051.051 0 0 1 .002.013v4.466c0 .23.217.402.439.344l1.767-.443a.356.356 0 0 0 .267-.344v-2.334c0-.147.11-.246.234-.258a.253.253 0 0 1 .205.07l.541.516a.261.261 0 0 1 .041.054l.025.049a.214.214 0 0 1 .016.086V14.673c0 .648-.443 1.214-1.07 1.37l-1.768.442a1.414 1.414 0 0 1-1.755-1.37v-4.19l-3.523-3.52A1.225 1.225 0 0 1 3 6.533V4.707c0-.68.554-1.234 1.234-1.234Zm9.33 3.367a.57.57 0 0 1 .804.804L13.15 8.862l1.218 1.218a.57.57 0 0 1-.804.803l-1.218-1.218-1.218 1.219a.57.57 0 0 1-.803-.804l1.218-1.218-1.218-1.218a.57.57 0 0 1 .803-.804l1.218 1.218 1.218-1.218Z", fill: "currentColor" }) }));
}, Ele = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Ile
}), Rle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 4.797C3 3.805 3.806 3 4.8 3h14.4c.994 0 1.8.805 1.8 1.797v2.656c0 .477-.19.933-.527 1.27l-5.356 5.349c-.301.3-.79.3-1.091 0a.77.77 0 0 1 0-1.09l5.356-5.347a.255.255 0 0 0 .075-.182V4.797a.257.257 0 0 0-.257-.256H4.8a.257.257 0 0 0-.257.256v2.656c0 .07.027.134.074.18l.001.002 5.356 5.347a.77.77 0 0 1 0 1.09c-.301.3-.79.3-1.09 0L3.528 8.725h-.001A1.793 1.793 0 0 1 3 7.453V4.797Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.429 12.757a.77.77 0 0 1 .771.77v6.418c0 .334.315.58.64.498l2.57-.642a.514.514 0 0 0 .39-.498v-5.776a.77.77 0 0 1 1.543 0v5.776c0 .943-.643 1.764-1.559 1.993l-2.571.642a2.057 2.057 0 0 1-2.556-1.993v-6.418a.77.77 0 0 1 .772-.77Z", fill: "currentColor" })] }));
}, Ale = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Rle
}), kle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.774 2.954c.428 0 .774.344.774.77V21.23c0 .425-.346.769-.774.769A.772.772 0 0 1 4 21.23V3.724c0-.425.347-.77.774-.77ZM19.226 3.026c.427 0 .774.344.774.769v10.277c0 .425-.347.769-.774.769a.772.772 0 0 1-.774-.77V3.796c0-.425.346-.77.774-.77Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m4.774 14.051-.495-.591a.766.766 0 0 0-.1 1.083.778.778 0 0 0 1.074.113l.002-.002a.97.97 0 0 1 .078-.046c.084-.047.238-.121.476-.2.475-.157 1.295-.333 2.578-.333 1.187 0 2.186.384 3.329.832l.043.017c1.105.433 2.351.922 3.854.922 1.453 0 2.465-.27 3.138-.568.336-.149.582-.303.754-.43a2.532 2.532 0 0 0 .283-.244l.008-.008.003-.004.002-.002v-.001s.002 0-.575-.514l.576.513a.766.766 0 0 0-.06-1.086.778.778 0 0 0-1.08.045l-.004.005a.988.988 0 0 1-.078.062 2.434 2.434 0 0 1-.46.26c-.456.202-1.25.434-2.507.434-1.187 0-2.186-.384-3.329-.832l-.043-.017c-1.105-.434-2.351-.923-3.854-.923-1.426 0-2.413.197-3.067.412-.326.108-.568.22-.737.314a2.536 2.536 0 0 0-.287.184l-.009.008-.004.003-.002.001s-.002.002.493.593ZM5.325 4.266a.778.778 0 0 1-1.08.02.766.766 0 0 1-.035-1.087l.564.526c-.564-.526-.563-.527-.563-.527v-.001l.002-.002.004-.004.008-.008a1.23 1.23 0 0 1 .083-.077 2.51 2.51 0 0 1 .201-.157c.172-.121.418-.268.752-.41C5.931 2.256 6.94 2 8.387 2c1.503 0 2.75.489 3.854.922l.043.017c1.143.449 2.142.832 3.329.832 1.283 0 2.103-.176 2.578-.333.238-.079.392-.153.476-.2a.987.987 0 0 0 .077-.046l.003-.002a.778.778 0 0 1 1.074.113.766.766 0 0 1-.1 1.084l-.495-.592.494.592-.001.001-.002.001-.004.004-.009.007a1.536 1.536 0 0 1-.085.062 2.52 2.52 0 0 1-.202.122 4.38 4.38 0 0 1-.737.314c-.654.215-1.64.412-3.067.412-1.503 0-2.75-.49-3.854-.923-.014-.005-.029-.01-.043-.017-1.143-.448-2.142-.832-3.329-.832-1.261 0-2.06.223-2.519.417-.23.097-.38.19-.462.248a.975.975 0 0 0-.081.063Z", fill: "currentColor" })] }));
}, Mle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: kle
}), Nle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.757 3.27a3.653 3.653 0 0 1 4.487 0l5.845 4.547a3.653 3.653 0 0 1 1.411 2.884v7.145a3.654 3.654 0 0 1-3.654 3.654H6.154A3.654 3.654 0 0 1 2.5 17.846v-7.145c0-1.127.52-2.192 1.41-2.884L9.757 3.27Zm.897 1.154L4.808 8.97a2.191 2.191 0 0 0-.846 1.73v7.145c0 1.211.98 2.192 2.192 2.192h11.692c1.211 0 2.192-.98 2.192-2.192v-7.145a2.19 2.19 0 0 0-.846-1.73l-5.846-4.547a2.192 2.192 0 0 0-2.692 0Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.55 11.912a2.192 2.192 0 1 0-3.1 3.1 2.192 2.192 0 0 0 3.1-3.1Zm1.033-1.034a3.654 3.654 0 1 0-5.167 5.167 3.654 3.654 0 0 0 5.167-5.167Z", fill: "currentColor" })] }));
}, Tle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Nle
}), Dle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.558 4.385c-.642 0-1.162.516-1.162 1.153v12.924c0 .637.52 1.153 1.162 1.153h14.88c.643 0 1.164-.516 1.164-1.153V5.538c0-.637-.52-1.153-1.163-1.153H4.559ZM2 5.538A2.548 2.548 0 0 1 4.558 3h14.88a2.548 2.548 0 0 1 2.56 2.538v12.924A2.549 2.549 0 0 1 19.437 21H4.559A2.548 2.548 0 0 1 2 18.462V5.538Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.1 8.415a1.17 1.17 0 0 0-1.645 0 1.147 1.147 0 0 0 0 1.632c.454.45 1.19.45 1.645 0a1.147 1.147 0 0 0 0-1.632Zm.986-.98c-1-.99-2.62-.99-3.618 0-1 .992-1 2.6 0 3.59 1 .992 2.62.992 3.618 0 1-.99 1-2.598 0-3.59ZM15.524 12.288a1.638 1.638 0 0 1 2.29-.252l3.924 3.116c.301.239.35.674.11.973a.702.702 0 0 1-.982.108l-3.925-3.116a.235.235 0 0 0-.327.036m0 0-3.104 3.85a1.638 1.638 0 0 1-2.288.252l-1.739-1.38a.234.234 0 0 0-.324.032l-4.067 4.844a.701.701 0 0 1-.983.088.689.689 0 0 1-.09-.974l4.068-4.844a1.637 1.637 0 0 1 2.268-.228l1.738 1.38c.1.08.248.064.328-.035l3.103-3.85", fill: "currentColor" })] }));
}, jle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Dle
}), Zi = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 8.253a1 1 0 1 1 2-.005 1 1 0 0 1-2 .005Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75ZM2.25 12A9.75 9.75 0 0 1 12 2.25 9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 11.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] }));
}, Lle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Zi
}), zle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { d: "M7.748 4.663h-1.75a2 2 0 0 0-2.001 2.001V19.67a2 2 0 0 0 2 2h2.001M20.003 7.665v-1a2 2 0 0 0-2-2.002h-1.751", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), m("rect", { x: 10.999, y: 10.541, width: 9.004, height: 11.13, rx: 1.125, stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), m("rect", { x: 7.749, y: 2.663, width: 8.504, height: 4.002, rx: 2, stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Vle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: zle
}), Fle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.673 8.406c.186-.187.476-.357.83-.357s.644.17.83.357c.185.186.355.477.355.833s-.17.647-.355.833a1.183 1.183 0 0 1-.83.357c-.354 0-.644-.17-.83-.357a1.192 1.192 0 0 1-.355-.833c0-.356.17-.647.355-.833Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.01 4.166c-.59-.218-1.073-.12-1.433.241L9.589 7.408a1.48 1.48 0 0 0-.346 1.538l.916 2.044a.778.778 0 0 1-.163.872l-5.95 5.876v2.21H6.25l5.955-5.98a.77.77 0 0 1 .85-.165l2.147.923c.59.218 1.073.12 1.433-.242l2.961-2.973c.341-.426.456-.948.268-1.467l-1.538-3.603-.007-.018a1.27 1.27 0 0 0-.703-.706l-.017-.007-3.589-1.544Zm-2.526-.856c.872-.876 2.034-.987 3.084-.592a.832.832 0 0 1 .033.014L18.2 4.28a2.82 2.82 0 0 1 1.55 1.557l1.543 3.614.013.033c.419 1.121.128 2.238-.542 3.046a.8.8 0 0 1-.047.051l-2.988 3.001c-.873.876-2.034.987-3.084.592a.784.784 0 0 1-.033-.014l-1.683-.724-5.812 5.837a.771.771 0 0 1-.546.227H3.273a.774.774 0 0 1-.773-.776v-3.311c0-.208.083-.407.23-.553l5.799-5.726-.706-1.577a3.037 3.037 0 0 1 .673-3.247l2.988-3Z", fill: "currentColor" })] }));
}, Zle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Fle
}), Wle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.839 10.718c-.713 0-1.29.573-1.29 1.282v7.18c0 .708.577 1.282 1.29 1.282H17.16c.713 0 1.29-.574 1.29-1.282V12c0-.709-.577-1.282-1.29-1.282H6.84ZM4 12a2.83 2.83 0 0 1 2.839-2.82H17.16A2.83 2.83 0 0 1 20 12v7.18A2.83 2.83 0 0 1 17.161 22H6.84A2.83 2.83 0 0 1 4 19.18V12Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538c-1.853 0-3.355 1.493-3.355 3.334v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873C7.097 4.182 9.292 2 12 2c2.708 0 4.903 2.181 4.903 4.872v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873c0-1.841-1.502-3.334-3.355-3.334Z", fill: "currentColor" })] }));
}, Ble = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Wle
}), cx = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.251 6a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001A.75.75 0 0 1 2.25 6ZM2.251 12a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001a.75.75 0 0 1-.75-.75ZM2.251 18a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, Hle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: cx
}), ux = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 16 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 1c0-.552.398-1 .889-1H15.11c.491 0 .889.448.889 1s-.398 1-.889 1H.89C.398 2 0 1.552 0 1Z", fill: "currentColor" }) }));
}, Gle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ux
}), dx = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.75 18.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246Zm.688-.004h-.688v.004M10.75 12.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246Zm.688-.004h-.688v.004M10.75 6.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246ZM11.438 6h-.688v.004", fill: "currentColor" }) }));
}, Xle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: dx
}), Yle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.292 17.593a.75.75 0 0 1 .75.75v.365a3.042 3.042 0 0 1-6.084.001v-.365a.75.75 0 0 1 1.5 0v.365a1.542 1.542 0 0 0 3.084-.001v-.365a.75.75 0 0 1 .75-.75ZM9.417 4.833a2.583 2.583 0 1 1 5.166 0v.918a.75.75 0 0 1-1.5 0v-.918a1.083 1.083 0 1 0-2.166 0v.918a.75.75 0 0 1-1.5 0v-.918Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.094 6.407a3.78 3.78 0 0 0-3.781 3.781v2.797c0 .73-.29 1.429-.806 1.944l-.64.641a1.25 1.25 0 0 0-.367.884c0 .63.51 1.14 1.14 1.14h10.721c.63 0 1.14-.51 1.14-1.14 0-.33-.132-.65-.366-.884l-.641-.64a2.75 2.75 0 0 1-.806-1.945v-2.797a3.78 3.78 0 0 0-3.781-3.781h-1.813Zm-5.281 3.781a5.28 5.28 0 0 1 5.281-5.281h1.813a5.28 5.28 0 0 1 5.281 5.281v2.797c0 .33.132.65.366.884l.641.64a2.75 2.75 0 0 1 .806 1.945 2.64 2.64 0 0 1-2.64 2.64H6.64A2.64 2.64 0 0 1 4 16.454c0-.73.29-1.429.806-1.944l.64-.641a1.25 1.25 0 0 0 .367-.884v-2.797Z", fill: "currentColor" })] }));
}, Ule = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Yle
}), Jle = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 .907c.523 0 .947.424.947.948v14.29a.947.947 0 0 1-1.894 0V1.855c0-.524.424-.948.947-.948Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.093 9a.947.947 0 0 1-.948.947H1.855a.947.947 0 1 1 0-1.894h14.29c.524 0 .948.424.948.947Z", fill: "currentColor" })] }));
}, qle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Jle
}), Kle = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3.75a.25.25 0 0 0-.25.25v3.25h8.5V4a.25.25 0 0 0-.25-.25H8Zm9.75 3.5V4A1.75 1.75 0 0 0 16 2.25H8A1.75 1.75 0 0 0 6.25 4v3.25H5A2.75 2.75 0 0 0 2.25 10v5A2.75 2.75 0 0 0 5 17.75h1.25V20c0 .966.784 1.75 1.75 1.75h8A1.75 1.75 0 0 0 17.75 20v-2.25H19A2.75 2.75 0 0 0 21.75 15v-5A2.75 2.75 0 0 0 19 7.25h-1.25ZM5 8.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h1.25V13.8a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 .75.75v2.45H19c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25H5Zm11.25 5.8h-8.5V20c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-5.45ZM6.25 11a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, Qle = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Kle
}), ese = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { d: "M13 21.608a8.119 8.119 0 0 1-1 .063 9.004 9.004 0 1 1 9.004-9.004c0 .334-.02.668-.062 1M20.004 17.669l-2.501 2.5-1.501-1.5", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "m12 13.378 1.328-.737a2.087 2.087 0 0 0 1.073-1.825 2.298 2.298 0 0 0-2.42-2.15 2.345 2.345 0 0 0-2.382 1.812M12.1 16.569a.1.1 0 1 1-.2 0 .1.1 0 0 1 .2 0", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, rse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ese
}), tse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.436 9.971a1.422 1.422 0 0 0-1.496-1.306.771.771 0 0 1-.074 0 1.467 1.467 0 0 0-1.49 1.135.769.769 0 0 1-1.499-.348 3.005 3.005 0 0 1 3.015-2.324 2.96 2.96 0 0 1 3.082 2.82c0 1.175-.856 1.899-1.386 2.33l-.196.157c-.209.168-.365.294-.492.426a.597.597 0 0 0-.131.173.769.769 0 0 1-1.538-.008c0-.552.301-.96.558-1.229.204-.213.466-.422.686-.598l.143-.115c.56-.455.808-.755.818-1.113ZM12.604 15.242A.767.767 0 0 0 12 14.95a.897.897 0 1 0 .897.897.768.768 0 0 0-.293-.604Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.231 15.718c0-.425.344-.769.769-.769.495 0 .897.402.897.897a.769.769 0 0 1-1.373.476.767.767 0 0 1-.293-.604Z", fill: "currentColor" })] }));
}, nse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: tse
}), ose = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.77 3.538a.77.77 0 0 1 .768.77v3.077h3.077a.77.77 0 1 1 0 1.538H2.77A.77.77 0 0 1 2 8.153V4.309a.77.77 0 0 1 .77-.77Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.917 7.833C4.497 4.396 7.964 2 12 2c5.523 0 10 4.477 10 10a.77.77 0 0 1-1.538 0A8.46 8.46 0 0 0 12 3.538c-3.41 0-6.345 2.023-7.685 4.937a.77.77 0 0 1-1.398-.642ZM16.615 15.846a.77.77 0 0 1 .77-.77h3.846a.77.77 0 0 1 .769.77v3.846a.77.77 0 0 1-1.538 0v-3.077h-3.077a.77.77 0 0 1-.77-.769Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.77 11.23a.77.77 0 0 1 .768.77A8.46 8.46 0 0 0 12 20.462c3.41 0 6.345-2.023 7.685-4.937a.77.77 0 1 1 1.398.642C19.502 19.604 16.035 22 12 22 6.477 22 2 17.523 2 12a.77.77 0 0 1 .77-.77Z", fill: "currentColor" })] }));
}, ase = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ose
}), fx = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.286 7.22a5.704 5.704 0 1 0-8.067 8.066 5.704 5.704 0 0 0 8.067-8.067Zm1.095-1.096A7.253 7.253 0 1 0 6.124 16.381 7.253 7.253 0 0 0 16.381 6.124Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.282 15.282a.774.774 0 0 1 1.095 0l3.396 3.396a.774.774 0 1 1-1.095 1.095l-3.396-3.396a.774.774 0 0 1 0-1.095Z", fill: "currentColor" })] }));
}, ise = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: fx
}), lse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { d: "m12 12 9-9v7-7h-7", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M9 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, sse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: lse
}), cse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { clipRule: "evenodd", d: "M14.121 9.879A3 3 0 1 1 9.88 14.12 3 3 0 0 1 14.12 9.88Z", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { clipRule: "evenodd", d: "M16.18 18.725a1.29 1.29 0 0 0 1.823 0l.722-.722a1.29 1.29 0 0 0 0-1.823 1.324 1.324 0 0 1-.284-1.453 7.63 7.63 0 0 0 .065-.16 1.217 1.217 0 0 1 1.137-.766h.067c.712 0 1.289-.577 1.289-1.289v-1.021c0-.712-.577-1.289-1.289-1.289h-.067c-.5 0-.954-.301-1.137-.766a7.63 7.63 0 0 0-.065-.16 1.324 1.324 0 0 1 .284-1.453 1.29 1.29 0 0 0 0-1.823l-.722-.722a1.29 1.29 0 0 0-1.823 0 1.324 1.324 0 0 1-1.453.284l-.16-.065a1.227 1.227 0 0 1-.767-1.141v-.067C13.8 3.577 13.223 3 12.511 3H11.49a1.29 1.29 0 0 0-1.29 1.289v.067c0 .5-.301.954-.766 1.137-.054.022-.107.043-.16.066a1.324 1.324 0 0 1-1.453-.284 1.29 1.29 0 0 0-1.823 0l-.723.722a1.29 1.29 0 0 0 0 1.823c.382.382.494.955.284 1.453a5.419 5.419 0 0 0-.065.161 1.22 1.22 0 0 1-1.138.766h-.067C3.577 10.2 3 10.777 3 11.489v1.021c0 .713.577 1.29 1.289 1.29h.067c.5 0 .954.301 1.137.766l.065.16c.21.498.098 1.071-.284 1.453a1.29 1.29 0 0 0 0 1.823l.722.722a1.29 1.29 0 0 0 1.823 0 1.324 1.324 0 0 1 1.453-.284l.16.065c.466.183.766.637.766 1.137v.067c0 .712.577 1.289 1.289 1.289h1.021c.712 0 1.289-.577 1.289-1.289v-.067c0-.5.301-.954.766-1.137l.16-.065a1.332 1.332 0 0 1 1.457.285Z", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, use = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: cse
}), dse = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2a.73.73 0 0 1 .657.426l2.694 5.722 6.024.923a.74.74 0 0 1 .589.518.783.783 0 0 1-.183.778L17.42 14.82l1.03 6.291a.775.775 0 0 1-.293.745.708.708 0 0 1-.772.055L12 18.943l-5.385 2.968a.708.708 0 0 1-.772-.055.775.775 0 0 1-.292-.745l1.03-6.291-4.362-4.453a.783.783 0 0 1-.183-.778.74.74 0 0 1 .59-.518l6.022-.923 2.695-5.722A.73.73 0 0 1 12 2Zm0 2.491L9.793 9.178a.735.735 0 0 1-.55.418l-4.948.758 3.583 3.658a.78.78 0 0 1 .21.671l-.845 5.16 4.414-2.434a.707.707 0 0 1 .686 0l4.414 2.434-.844-5.16a.78.78 0 0 1 .209-.67l3.583-3.659-4.948-.758a.734.734 0 0 1-.55-.418L12 4.49Z", fill: "currentColor" }) }));
}, fse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: dse
}), N1 = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.12 8.998c.3.3.3.787 0 1.087l-4.89 4.89a.77.77 0 0 1-1.198.14L7.809 12.89a.769.769 0 1 1 1.087-1.087l1.665 1.665 4.47-4.471c.301-.3.788-.3 1.088 0Z", fill: "currentColor" })] }));
}, pse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: N1
}), gse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10.62a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h1c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-1Zm-1.75.25c0-.966.784-1.75 1.75-1.75h1a2.75 2.75 0 0 1 2.75 2.75v3A2.75 2.75 0 0 1 19 17.62h-1a1.75 1.75 0 0 1-1.75-1.75v-5ZM5 10.62c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25h1a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25H5Zm-2.75 1.25A2.75 2.75 0 0 1 5 9.12h1c.966 0 1.75.784 1.75 1.75v5A1.75 1.75 0 0 1 6 17.62H5a2.75 2.75 0 0 1-2.75-2.75v-3Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.75 9.37a7.25 7.25 0 1 1 14.5 0v.5a.75.75 0 0 1-1.5 0v-.5a5.75 5.75 0 1 0-11.5 0v.5a.75.75 0 0 1-1.5 0v-.5ZM11.375 19.37a.5.5 0 0 0 0 1h1.25a.5.5 0 0 0 0-1h-1.25Zm-2 .5a2 2 0 0 1 2-2h1.25a2 2 0 0 1 0 4h-1.25a2 2 0 0 1-2-2Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 16.12a.75.75 0 0 1 .75.75v1A2.75 2.75 0 0 1 16 20.62h-2.125a.75.75 0 0 1 0-1.5H16c.69 0 1.25-.56 1.25-1.25v-1a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] }));
}, vse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gse
}), mse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.754 3.5a8.254 8.254 0 0 0 0 16.508.75.75 0 1 1 0 1.5C6.367 21.508 2 17.14 2 11.754S6.367 2 11.754 2s9.754 4.367 9.754 9.754a.75.75 0 1 1-1.5 0A8.254 8.254 0 0 0 11.754 3.5Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.513 8.752a.75.75 0 0 1 .75-.75h16.981a.75.75 0 0 1 0 1.5H3.264a.75.75 0 0 1-.75-.75ZM2.514 14.755a.75.75 0 0 1 .75-.75h8.49a.75.75 0 1 1 0 1.5h-8.49a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.273 3.433a2.865 2.865 0 0 1 4.962-.001 16.234 16.234 0 0 1 2.27 8.324.75.75 0 1 1-1.5-.004 14.733 14.733 0 0 0-2.063-7.559l-.005-.008a1.366 1.366 0 0 0-2.366 0l-.004.007a14.885 14.885 0 0 0 0 15.125l.003.005c.245.424.697.685 1.187.687a.75.75 0 0 1-.004 1.5 2.876 2.876 0 0 1-2.48-1.432 16.385 16.385 0 0 1 0-16.644Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.756 14.505a3.252 3.252 0 1 0 0 6.503 3.252 3.252 0 0 0 0-6.503Zm0-1.5a4.752 4.752 0 1 0 0 9.503 4.752 4.752 0 0 0 0-9.503Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.294 15.799c.345 0 .624.279.624.623v1.488h1.129a.624.624 0 1 1 0 1.247h-1.753a.624.624 0 0 1-.623-.623v-2.111c0-.345.279-.624.623-.624Z", fill: "currentColor" })] }));
}, hse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: mse
}), px = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.818 5.077c.427 0 .773.344.773.77v13.076c0 .859.68 1.539 1.526 1.539h7.727c.862 0 1.565-.697 1.565-1.539V5.846c0-.425.346-.77.773-.77a.77.77 0 0 1 .773.77v13.077c0 1.708-1.413 3.077-3.11 3.077H8.116a3.067 3.067 0 0 1-3.072-3.077V5.846c0-.425.346-.77.773-.77Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 5.846c0-.425.346-.77.773-.77h15.454c.427 0 .773.345.773.77 0 .425-.346.77-.773.77H4.273a.771.771 0 0 1-.773-.77ZM9.167 2.77c0-.426.346-.77.772-.77h4.122a.77.77 0 0 1 .772.77.77.77 0 0 1-.772.768H9.939a.771.771 0 0 1-.772-.769ZM14.06 9.18a.77.77 0 0 1 .773.769v7.18a.77.77 0 0 1-.772.768.77.77 0 0 1-.773-.769v-7.18a.77.77 0 0 1 .773-.769ZM9.94 9.18a.77.77 0 0 1 .772.769v7.18a.77.77 0 0 1-.773.768.771.771 0 0 1-.772-.769v-7.18c0-.424.346-.769.772-.769Z", fill: "currentColor" })] }));
}, bse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: px
}), yse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.839 10.718c-.713 0-1.29.573-1.29 1.282v7.18c0 .708.577 1.282 1.29 1.282H17.16c.713 0 1.29-.574 1.29-1.282V12c0-.709-.577-1.282-1.29-1.282H6.84ZM4 12a2.83 2.83 0 0 1 2.839-2.82H17.16A2.83 2.83 0 0 1 20 12v7.18A2.83 2.83 0 0 1 17.161 22H6.84A2.83 2.83 0 0 1 4 19.18V12ZM7.259 5.681A4.89 4.89 0 0 1 12 2c2.708 0 4.903 2.181 4.903 4.872 0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77c0-1.84-1.502-3.333-3.355-3.333a3.343 3.343 0 0 0-3.24 2.52.775.775 0 0 1-1.501-.377Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.129 6.103c.428 0 .774.344.774.769v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873c0-.425.346-.77.774-.77Z", fill: "currentColor" })] }));
}, Cse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yse
}), wse = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.25a.75.75 0 0 1 .75.75v12.19l3.72-3.72a.75.75 0 0 1 1.06 1.06l-5 5.001a.75.75 0 0 1-1.061 0l-5-5a.75.75 0 0 1 1.06-1.061l3.721 3.721V3a.75.75 0 0 1 .75-.75ZM3.25 21a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, _se = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: wse
}), gx = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.348 16.472c-2.082 0-3.806 1.625-3.806 3.765A.767.767 0 0 1 4.77 21 .767.767 0 0 1 4 20.237c0-3.005 2.437-5.29 5.348-5.29h5.304c3.038 0 5.348 2.41 5.348 5.29a.767.767 0 0 1-.771.763.767.767 0 0 1-.77-.763c0-2.06-1.643-3.765-3.807-3.765H9.348ZM14.63 5.56a3.774 3.774 0 0 0-5.164.009c-1.41 1.313-1.378 3.599.034 5.083 1.327 1.396 3.638 1.364 5.138-.033 1.429-1.33 1.456-3.6-.009-5.058Zm1.074-1.118a5.346 5.346 0 0 0-7.307.003c-2.126 1.98-1.95 5.25-.034 7.265 2.001 2.103 5.308 1.93 7.344.033 2.104-1.959 2.08-5.238.02-7.28a.778.778 0 0 0-.011-.01l-.012-.011Z", fill: "currentColor" }) }));
}, xse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gx
}), Wi = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538A8.461 8.461 0 0 0 3.538 12 8.46 8.46 0 0 0 12 20.462 8.46 8.46 0 0 0 20.462 12 8.46 8.46 0 0 0 12 3.538ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6.615a.77.77 0 0 1 .77.77v5.128a.77.77 0 1 1-1.54 0V7.385a.77.77 0 0 1 .77-.77ZM10.974 16.362a1.026 1.026 0 1 1 2.05-.005 1.026 1.026 0 0 1-2.05.005Z", fill: "currentColor" })] }));
}, $se = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Wi
}), Ose = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.876 19.627a1.125 1.125 0 1 1 2.247-.003 1.125 1.125 0 0 1-2.247.003Zm.473-.003-.473-.003v.006M18.901 12.553c-3.805-3.49-9.998-3.49-13.803 0a.75.75 0 1 1-1.014-1.106c4.38-4.016 11.452-4.016 15.831 0a.75.75 0 1 1-1.014 1.106Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.91 8.366c-5.463-4.821-14.356-4.821-19.82 0a.75.75 0 0 1-.992-1.124c6.03-5.323 15.774-5.323 21.805 0a.75.75 0 1 1-.993 1.124ZM15.891 16.353a5.526 5.526 0 0 0-7.783 0 .75.75 0 1 1-1.058-1.064 7.026 7.026 0 0 1 9.9 0 .75.75 0 0 1-1.059 1.064Z", fill: "currentColor" })] }));
}, Pse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Ose
}), vx = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [m("path", { d: "M18.5027 12C18.5027 12.2763 18.2788 12.5002 18.0025 12.5002C17.7263 12.5002 17.5023 12.2763 17.5023 12C17.5023 11.7237 17.7263 11.4998 18.0025 11.4998C18.2788 11.4998 18.5027 11.7237 18.5027 12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M12.5002 12C12.5002 12.2763 12.2762 12.5002 12 12.5002C11.7237 12.5002 11.4998 12.2763 11.4998 12C11.4998 11.7237 11.7237 11.4998 12 11.4998C12.2762 11.4998 12.5002 11.7237 12.5002 12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M6.49773 12C6.49773 12.2763 6.27378 12.5002 5.99752 12.5002C5.72127 12.5002 5.49731 12.2763 5.49731 12C5.49731 11.7237 5.72127 11.4998 5.99752 11.4998C6.27378 11.4998 6.49773 11.7237 6.49773 12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Sse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vx
}), Ise = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { d: "M12 8V16", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M16 12H8", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Ese = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Ise
}), Rse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.2621 10.0539C19.765 9.55675 18.959 9.55675 18.4618 10.0539C17.9647 10.551 17.9647 11.357 18.4618 11.8542C18.959 12.3513 19.765 12.3513 20.2621 11.8542C20.7593 11.357 20.7593 10.551 20.2621 10.0539ZM21.3219 8.99237C20.2389 7.9103 18.4838 7.91059 17.4012 8.99322C16.3183 10.0761 16.3183 11.8319 17.4012 12.9148C18.4841 13.9978 20.2399 13.9978 21.3228 12.9148C22.4057 11.8319 22.4057 10.0761 21.3228 8.99322L21.3219 8.99237Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.949 15.4041C18.949 14.9898 19.2848 14.6541 19.699 14.6541H20.5C22.2952 14.6541 23.75 16.1088 23.75 17.9041V19.0001C23.75 19.4143 23.4142 19.7501 23 19.7501C22.5858 19.7501 22.25 19.4143 22.25 19.0001V17.9041C22.25 16.9373 21.4668 16.1541 20.5 16.1541H19.699C19.2848 16.1541 18.949 15.8183 18.949 15.4041Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.53813 10.0539C5.041 9.55675 4.23498 9.55675 3.73784 10.0539C3.24071 10.551 3.24071 11.357 3.73784 11.8542C4.23498 12.3513 5.041 12.3513 5.53813 11.8542C6.03527 11.357 6.03527 10.551 5.53813 10.0539ZM6.59794 8.99237C5.51494 7.9103 3.75982 7.91059 2.67718 8.99322C1.59426 10.0761 1.59426 11.8319 2.67718 12.9148C3.76011 13.9978 5.51587 13.9978 6.59879 12.9148C7.68172 11.8319 7.68172 10.0761 6.59879 8.99322L6.59794 8.99237Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 16.1541C2.53321 16.1541 1.75 16.9373 1.75 17.9041V19.0001C1.75 19.4143 1.41421 19.7501 1 19.7501C0.585786 19.7501 0.25 19.4143 0.25 19.0001V17.9041C0.25 16.1088 1.70479 14.6541 3.5 14.6541H4.301C4.71521 14.6541 5.051 14.9898 5.051 15.4041C5.051 15.8183 4.71521 16.1541 4.301 16.1541H3.5Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6723 6.44269C12.7487 5.5191 11.2513 5.5191 10.3277 6.44269C9.40411 7.36629 9.40411 8.86372 10.3277 9.78731C11.2513 10.7109 12.7487 10.7109 13.6723 9.78731C14.5959 8.86371 14.5959 7.36628 13.6723 6.44269ZM14.7326 5.38165C13.2232 3.87266 10.7763 3.87278 9.26704 5.38203C7.75767 6.89141 7.75766 9.3386 9.26704 10.848C10.7764 12.3573 13.2236 12.3573 14.733 10.848C16.2423 9.33859 16.242 6.89103 14.7326 5.38165Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.91003 17.399C5.91003 15.0518 7.81282 13.149 10.16 13.149H13.839C16.1862 13.149 18.089 15.0518 18.089 17.399V19C18.089 19.4143 17.7532 19.75 17.339 19.75C16.9248 19.75 16.589 19.4143 16.589 19V17.399C16.589 15.8803 15.3578 14.649 13.839 14.649H10.16C8.64125 14.649 7.41003 15.8803 7.41003 17.399V19C7.41003 19.4143 7.07425 19.75 6.66003 19.75C6.24582 19.75 5.91003 19.4143 5.91003 19V17.399Z", fill: "currentColor" })] }));
}, Ase = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Rse
}), kse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.662 4.338v5.147a2.34 2.34 0 0 0 4.676 0V4.338a2.34 2.34 0 0 0-4.676 0ZM8 .5a3.839 3.839 0 0 0-3.838 3.838v5.147a3.839 3.839 0 0 0 7.676 0V4.338A3.84 3.84 0 0 0 8 .5Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.9a.75.75 0 0 1 .75.75 6.25 6.25 0 1 0 12.5 0 .75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-15.5 0A.75.75 0 0 1 1 8.9Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15.9a.75.75 0 0 1 .75.75v2.1a.75.75 0 1 1-1.5 0v-2.1A.75.75 0 0 1 8 15.9Z", fill: "currentColor" })] }));
}, Mse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: kse
}), Nse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.81 2.886a.75.75 0 0 1 1.044.184l11.9 17a.75.75 0 1 1-1.228.86l-11.9-17a.75.75 0 0 1 .184-1.044Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 7.75a.75.75 0 0 1 .75.75v7a1.5 1.5 0 0 0 1.5 1.5h7.962a.75.75 0 0 1 0 1.5H5.25a3 3 0 0 1-3-3v-7A.75.75 0 0 1 3 7.75ZM4.412 6.25a.75.75 0 0 1 .75-.75h7.963a3 3 0 0 1 3 3v7a.75.75 0 0 1-1.5 0v-7a1.5 1.5 0 0 0-1.5-1.5H5.162a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.7 7.265c1.227-.988 3.05-.114 3.05 1.46v6.55c0 1.575-1.823 2.449-3.05 1.46l-3.795-3.054a.75.75 0 1 1 .94-1.168l3.795 3.054c.245.197.61.024.61-.292v-6.55a.374.374 0 0 0-.61-.292l-3.795 3.054a.75.75 0 0 1-.94-1.168L18.7 7.265Z", fill: "currentColor" })] }));
}, Tse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Nse
}), Dse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 22 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.633 1.625c-.898 0-1.625.727-1.625 1.625v7.583c0 .898.727 1.625 1.625 1.625h8.532c.897 0 1.625-.727 1.625-1.625V3.25c0-.898-.728-1.625-1.625-1.625H3.633ZM.383 3.25A3.25 3.25 0 0 1 3.633 0h8.532a3.25 3.25 0 0 1 3.25 3.25v7.583a3.25 3.25 0 0 1-3.25 3.25H3.633a3.25 3.25 0 0 1-3.25-3.25V3.25Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.204 1.912c1.33-1.07 3.304-.124 3.304 1.582v7.096c0 1.705-1.975 2.652-3.305 1.581l-4.11-3.308a.812.812 0 1 1 1.018-1.266l4.112 3.309c.265.213.66.025.66-.316V3.494a.406.406 0 0 0-.66-.317l-4.112 3.31a.812.812 0 1 1-1.018-1.267l4.11-3.308Z", fill: "currentColor" })] }));
}, jse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Dse
}), Lse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.073 1.375c0-.397.322-.719.719-.719h3.833c.397 0 .719.322.719.72v3.832a.719.719 0 0 1-1.438 0V2.094h-3.114a.719.719 0 0 1-.72-.719Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.133.867c.28.28.28.736 0 1.016l-5.75 5.75a.719.719 0 1 1-1.016-1.016l5.75-5.75a.719.719 0 0 1 1.016 0ZM1.375 14.073c.397 0 .719.322.719.719v3.114h3.114a.719.719 0 1 1 0 1.438H1.375a.719.719 0 0 1-.719-.719v-3.833c0-.397.322-.719.719-.719Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.633 12.367c.28.28.28.736 0 1.016l-5.75 5.75a.719.719 0 1 1-1.016-1.016l5.75-5.75a.719.719 0 0 1 1.016 0ZM4.25 3.052c-.662 0-1.198.536-1.198 1.198v4.792a.719.719 0 1 1-1.437 0V4.25A2.635 2.635 0 0 1 4.25 1.615h4.792a.719.719 0 1 1 0 1.437H4.25ZM17.667 10.24c.397 0 .718.321.718.718v4.792a2.635 2.635 0 0 1-2.635 2.636H10a.719.719 0 0 1 0-1.438h5.75c.662 0 1.198-.536 1.198-1.198v-4.792c0-.397.322-.718.719-.718Z", fill: "currentColor" })] }));
}, zse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Lse
}), Vse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 11.25a.75.75 0 0 1 .75.75A2.751 2.751 0 0 0 12 14.752a.75.75 0 0 1 0 1.5A4.251 4.251 0 0 1 7.75 12a.75.75 0 0 1 .75-.75ZM8.5 8.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 7.75a.75.75 0 0 1 .75.75V12a.75.75 0 1 1-1.5 0V8.5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.498 10.75a.75.75 0 0 1 .749.75 6.744 6.744 0 0 0 11.29 4.99.75.75 0 0 1 1.012 1.107A8.244 8.244 0 0 1 3.747 11.5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 18.253a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM3.466 3.466a.75.75 0 0 1 1.061 0l16.007 16.007a.75.75 0 0 1-1.061 1.06L3.466 4.528a.75.75 0 0 1 0-1.06ZM8.238 4.566A4.236 4.236 0 0 1 16.252 6.5V11a.75.75 0 0 1-1.5 0V6.495a2.736 2.736 0 0 0-5.176-1.25.75.75 0 1 1-1.338-.678ZM19.505 10.75a.75.75 0 0 1 .748.752 8.159 8.159 0 0 1-.835 3.572.75.75 0 1 1-1.346-.661 6.658 6.658 0 0 0 .681-2.915.75.75 0 0 1 .752-.748Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.006 13.945a.75.75 0 0 1 .001 1.061 4.238 4.238 0 0 1-3.006 1.245.75.75 0 0 1 0-1.5c.729.001 1.43-.288 1.944-.804a.75.75 0 0 1 1.061-.002Z", fill: "currentColor" })] }));
}, Fse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Vse
}), Zse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.662 4.338v5.147a2.34 2.34 0 0 0 4.676 0V4.338a2.34 2.34 0 0 0-4.676 0ZM8 .5a3.839 3.839 0 0 0-3.838 3.838v5.147a3.839 3.839 0 0 0 7.676 0V4.338A3.84 3.84 0 0 0 8 .5Z", fill: e.color }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.9a.75.75 0 0 1 .75.75 6.25 6.25 0 1 0 12.5 0 .75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-15.5 0A.75.75 0 0 1 1 8.9Z", fill: e.color }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15.9a.75.75 0 0 1 .75.75v2.1a.75.75 0 1 1-1.5 0v-2.1A.75.75 0 0 1 8 15.9Z", fill: e.color })] }));
}, Wse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Zse
}), Bse = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 2.996a.75.75 0 0 1 .75-.75h4.002a.75.75 0 1 1 0 1.5H3.746v3.252a.75.75 0 0 1-1.5 0V2.996Zm8.004 2A2.75 2.75 0 0 1 13 2.246h6.004a2.75 2.75 0 0 1 2.75 2.75V11a2.75 2.75 0 0 1-2.75 2.75H13A2.75 2.75 0 0 1 10.25 11V4.996ZM13 3.746c-.69 0-1.25.56-1.25 1.25V11c0 .69.56 1.25 1.25 1.25h6.004c.69 0 1.25-.56 1.25-1.25V4.996c0-.69-.56-1.25-1.25-1.25H13ZM8.529 15.471a.75.75 0 0 1 0 1.06l-3.722 3.723h2.191a.75.75 0 0 1 0 1.5H2.996a.75.75 0 0 1-.75-.75v-4.002a.75.75 0 0 1 1.5 0v2.19l3.722-3.72a.75.75 0 0 1 1.06 0Zm12.475.78a.75.75 0 0 1 .75.75v4.003a.75.75 0 0 1-.75.75h-4.002a.75.75 0 0 1 0-1.5h3.252v-3.252a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }) }));
}, Hse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Bse
}), Gse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.283 14c0-.966.783-1.75 1.75-1.75H20c.966 0 1.75.784 1.75 1.75v6A1.75 1.75 0 0 1 20 21.75h-8.969A1.75 1.75 0 0 1 9.283 20v-6Zm1.75-.25a.25.25 0 0 0-.25.25v6c0 .139.111.25.25.25H20a.25.25 0 0 0 .25-.25v-6a.25.25 0 0 0-.25-.25h-8.969ZM5.47 6.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 6.538a.75.75 0 0 1 .75.75V10a.75.75 0 0 1-.75.75H6.29a.75.75 0 1 1 0-1.5H8.25V7.288a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4.75c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h2a.75.75 0 1 1 0 1.5H5A2.75 2.75 0 0 1 2.252 13V6a2.75 2.75 0 0 1 2.75-2.75h11A2.75 2.75 0 0 1 18.75 6v4a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25H5Z", fill: "currentColor" })] }));
}, Xse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Gse
}), Yse = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { clipRule: "evenodd", d: "M11.19 11.192a13.162 13.162 0 0 0 2.749-3.968.78.78 0 0 0-.173-.862l-.853-.852c-.7-.699-.7-1.687-.089-2.298l1.223-1.222a2.083 2.083 0 0 1 2.946 0l.68.679c.771.772 1.093 1.885.885 2.99-.515 2.721-2.096 5.701-4.647 8.253-2.551 2.55-5.532 4.132-8.253 4.646-1.105.209-2.218-.113-2.99-.885l-.678-.678a2.083 2.083 0 0 1 0-2.946l1.222-1.222c.61-.61 1.6-.61 2.209 0l.94.942a.78.78 0 0 0 .862.173c1.385-.612 2.75-1.532 3.968-2.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}, Use = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Yse
}), Jse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.424 4.053a.75.75 0 0 1 .75.75v2.893a.75.75 0 0 1-.75.75h-2.893a.75.75 0 0 1 0-1.5h2.143V4.803a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 12c0-5.384 4.365-9.75 9.75-9.75a9.747 9.747 0 0 1 8.563 5.087.75.75 0 0 1-1.316.718A8.25 8.25 0 1 0 20.25 12a.75.75 0 0 1 1.5 0c0 5.384-4.365 9.75-9.75 9.75S2.25 17.384 2.25 12Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.945 10.055a2.75 2.75 0 1 0-3.89 3.89 2.75 2.75 0 0 0 3.89-3.89Zm1.06-1.06a4.25 4.25 0 1 0-6.01 6.01 4.25 4.25 0 0 0 6.01-6.01Z", fill: "currentColor" })] }));
}, qse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Jse
}), Kse = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.12A2.75 2.75 0 0 1 5 2.37h5a.75.75 0 0 1 0 1.5H5c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-6.125a.75.75 0 1 1 1.5 0v6.125A2.75 2.75 0 0 1 19 21.87H5a2.75 2.75 0 0 1-2.75-2.75v-14Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 8.372a3.751 3.751 0 0 1 3.752-3.75h5.002a.75.75 0 0 1 0 1.5h-5.002a2.251 2.251 0 0 0-2.252 2.25v2.501a.75.75 0 0 1-1.5 0v-2.5Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.972 2.34a.75.75 0 0 1 1.061 0l2.501 2.5a.75.75 0 0 1 0 1.061l-2.501 2.502a.75.75 0 1 1-1.06-1.061l1.97-1.97-1.97-1.972a.75.75 0 0 1 0-1.06Z", fill: "currentColor" })] }));
}, Qse = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Kse
}), ece = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { d: "M17 5.317a20.42 20.42 0 0 1 2.956-.3A1.005 1.005 0 0 1 21 6.016v11.837c0 .542-.433.99-.974.998-3.092.047-5.42.617-8.026 2.149-2.606-1.532-4.934-2.102-8.026-2.148A.996.996 0 0 1 3 17.853V6.016a.995.995 0 0 1 1.017-1c3.071.099 5.389.677 7.983 2.13", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { clipRule: "evenodd", d: "M17 15.238V3.012c0-.729-.766-1.238-1.417-.911-1.756.88-3.236 2.669-3.583 4.511V21c.396-2.099 2.261-4.129 4.331-4.824a.987.987 0 0 0 .669-.938Z", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, rce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ece
}), tce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { d: "M3 8h18M11 5.495l-.005.005.005.005.005-.005L11 5.495M8.5 5.495l-.005.005.005.005.005-.005-.005-.005M6 5.495l-.005.005.005.005.005-.005L6 5.495", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M9 20H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { clipRule: "evenodd", d: "M22 17v0a5 5 0 0 1-5 5v0a5 5 0 0 1-5-5v0a5 5 0 0 1 5-5v0a5 5 0 0 1 5 5v0Z", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { clipRule: "evenodd", d: "M15.586 18.498v-2.995a.496.496 0 0 1 .749-.432l2.507 1.498a.504.504 0 0 1 0 .863l-2.507 1.498a.496.496 0 0 1-.749-.431v0Z", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, nce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: tce
}), oce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.194 15.334a.194.194 0 0 0-.194.194v3.778c0 .107.087.194.194.194h4.723a.75.75 0 0 1 0 1.5H4.194c-.937 0-1.694-.76-1.694-1.694v-3.778c0-.937.76-1.694 1.694-1.694h4.722a.75.75 0 0 1 0 1.5H4.194ZM13.833 4.194c0-.935.759-1.694 1.694-1.694h3.778c.935 0 1.694.757 1.694 1.694v15.112c0 .935-.757 1.694-1.694 1.694h-4.722a.75.75 0 0 1-.75-.75V4.194Zm1.5 0V19.5h3.972a.194.194 0 0 0 .194-.194V4.194A.194.194 0 0 0 19.305 4h-3.778a.194.194 0 0 0-.194.194Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.86 9.667a.194.194 0 0 0-.194.194V19.5h4.917a.75.75 0 0 1 0 1.5H8.917a.75.75 0 0 1-.751-.75V9.861c0-.937.76-1.694 1.694-1.694h4.722a.75.75 0 0 1 0 1.5H9.86Z", fill: "currentColor" })] }));
}, ace = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: oce
}), ice = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h3c.219 0 .416.094.553.243l3.446 3.446 3.47-3.47A.75.75 0 0 1 16 16.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5Zm7.553 17.757a.75.75 0 0 1-1.083.024L7.688 17.75H5A2.75 2.75 0 0 1 2.25 15V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75h-2.69l-3.757 3.757Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM7.25 8A.75.75 0 0 1 8 7.25h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 8Z", fill: "currentColor" })] }));
}, lce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ice
}), sce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.167 12.321c.29.293.29.768 0 1.06l-2.768 2.792a.74.74 0 0 1-1.051.001l-1.665-1.673a.755.755 0 0 1-.002-1.06.74.74 0 0 1 1.052-.002l1.139 1.144 2.243-2.262a.74.74 0 0 1 1.052 0ZM9.946 3.555 8.843 4.939v.72c0 .134.109.243.243.243h5.828c.134 0 .243-.11.243-.244V4.94l-1.102-1.384a.244.244 0 0 0-.19-.092h-3.73a.244.244 0 0 0-.19.092Zm5.94 1.128.569-.457-1.262-1.586A1.698 1.698 0 0 0 13.864 2h-3.73c-.516 0-1.004.235-1.326.64L7.545 4.226a.733.733 0 0 0-.16.46v-.003h.73v.731a.728.728 0 0 1-.73-.728v.972c0 .943.762 1.708 1.7 1.708h5.83c.938 0 1.7-.765 1.7-1.708v-.975h-.73Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 6.634A2.677 2.677 0 0 1 6.171 3.95h1.943a.73.73 0 0 1 .729.732.73.73 0 0 1-.729.731H6.171c-.67 0-1.214.546-1.214 1.22v12.683c0 .674.543 1.22 1.214 1.22H17.83c.67 0 1.214-.546 1.214-1.22V6.634c0-.674-.543-1.22-1.214-1.22h-1.943a.73.73 0 0 1-.729-.731.73.73 0 0 1 .729-.732h1.943c1.475 0 2.671 1.2 2.671 2.683v12.683A2.677 2.677 0 0 1 17.829 22H6.17A2.677 2.677 0 0 1 3.5 19.317V6.634Z", fill: "currentColor" })] }));
}, cce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: sce
}), uce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.946 3.555 8.843 4.94v.719c0 .134.109.243.243.243h5.828c.134 0 .243-.109.243-.243v-.72l-1.102-1.384a.244.244 0 0 0-.19-.092h-3.73a.244.244 0 0 0-.19.092Zm5.94 1.128.569-.457-1.262-1.585V2.64A1.698 1.698 0 0 0 13.864 2h-3.73c-.516 0-1.004.236-1.326.64L7.545 4.226a.733.733 0 0 0-.16.46v-.003h.73v.732a.728.728 0 0 1-.73-.729v.973c0 .942.762 1.707 1.7 1.707h5.83c.938 0 1.7-.765 1.7-1.707v-.976h-.73Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 6.634a2.677 2.677 0 0 1 2.671-2.683h1.943a.73.73 0 0 1 .729.732.73.73 0 0 1-.729.732H6.171c-.67 0-1.214.545-1.214 1.22v12.682c0 .674.543 1.22 1.214 1.22H17.83c.67 0 1.214-.546 1.214-1.22V6.634c0-.674-.543-1.22-1.214-1.22h-1.943a.73.73 0 0 1-.729-.731.73.73 0 0 1 .729-.732h1.943c1.475 0 2.671 1.201 2.671 2.683v12.683A2.677 2.677 0 0 1 17.829 22H6.17A2.677 2.677 0 0 1 3.5 19.317V6.634Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.386 11.512a.73.73 0 0 1 .728-.732h7.772a.73.73 0 0 1 .728.732.73.73 0 0 1-.728.732H8.114a.73.73 0 0 1-.728-.732ZM7.386 16.39a.73.73 0 0 1 .728-.732h7.772a.73.73 0 0 1 .728.732.73.73 0 0 1-.728.732H8.114a.73.73 0 0 1-.728-.732Z", fill: "currentColor" })] }));
}, dce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: uce
}), fce = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { d: "M3 9h18M9.57 13H7m11 6H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}, pce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: fce
}), gce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.128 3.962a3.167 3.167 0 0 0-3.166 3.166v9.744a3.167 3.167 0 0 0 3.166 3.166h9.744a3.167 3.167 0 0 0 3.166-3.166V7.128a3.167 3.167 0 0 0-3.166-3.166H7.128ZM2.5 7.128A4.628 4.628 0 0 1 7.128 2.5h9.744A4.628 4.628 0 0 1 21.5 7.128v9.744a4.628 4.628 0 0 1-4.628 4.628H7.128A4.628 4.628 0 0 1 2.5 16.872V7.128Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m11.124 8.615 2.825 5.648 1.16-2.32a1.219 1.219 0 0 1 1.09-.674h4.57a.73.73 0 0 1 0 1.462h-4.42l-1.31 2.62c-.45.9-1.731.9-2.18.001l-2.833-5.664L8.73 12.09v.002a1.22 1.22 0 0 1-1.072.638H3.231a.73.73 0 0 1 0-1.462h4.282l1.45-2.688a1.218 1.218 0 0 1 2.16.034Zm-.875.66Zm-.432-.007ZM13.73 14.7Z", fill: "currentColor" })] }));
}, vce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gce
}), mce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.783 7.398a3.751 3.751 0 0 1 1.677-.396h1.293a.75.75 0 1 1 0 1.5H6.46c-.35 0-.694.081-1.006.238l-.586.292a2.25 2.25 0 0 0-.924.856l-1.55 2.585a.75.75 0 1 1-1.287-.772l1.551-2.585c.367-.612.901-1.106 1.54-1.425m0 0 .585-.293M17.257 5.001a.75.75 0 0 1 .75.75v3.001a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.006 7.252a.75.75 0 0 1 .75-.75h3.001a.75.75 0 0 1 0 1.5h-3.001a.75.75 0 0 1-.75-.75ZM16.006 12.754a.75.75 0 0 1 .75-.75h2.001a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM14.005 15.755a.75.75 0 0 1 .75-.75h4.002a.75.75 0 0 1 0 1.5h-4.002a.75.75 0 0 1-.75-.75ZM10.414 10.033a2.396 2.396 0 0 1 3.688 3.025l-2.994 4.49A4.751 4.751 0 0 1 8.77 19.38l-5.765 2.083a.75.75 0 0 1-.51-1.41l5.765-2.084a3.252 3.252 0 0 0 1.6-1.254l2.994-4.49a.896.896 0 0 0-1.38-1.131l-2.19 2.19a.75.75 0 0 1-.531.22h-2a.75.75 0 0 1 0-1.5h1.69l1.971-1.97Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.003 4.25A2.25 2.25 0 0 1 9.253 2h11.005a2.25 2.25 0 0 1 2.25 2.25v15.007a2.25 2.25 0 0 1-2.25 2.25H9.253a2.25 2.25 0 0 1-2.25-2.25v-.307a.75.75 0 0 1 1.5 0v.307c0 .414.336.75.75.75h11.005a.75.75 0 0 0 .75-.75V4.25a.75.75 0 0 0-.75-.751H9.253a.75.75 0 0 0-.75.75v8.504a.75.75 0 0 1-1.5 0V4.251Z", fill: "currentColor" })] }));
}, hce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: mce
}), bce = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.385 8.236a.77.77 0 0 1 .769.77v1.538a.77.77 0 0 1-1.539 0V9.005a.77.77 0 0 1 .77-.77ZM16.615 8.236a.77.77 0 0 1 .77.77v1.538a.77.77 0 0 1-1.539 0V9.005a.77.77 0 0 1 .77-.77ZM12.513 8.253a.77.77 0 0 1 .77.77v3.59c0 .99-.805 1.794-1.796 1.794h-.513a.77.77 0 1 1 0-1.538h.513a.257.257 0 0 0 .257-.257v-3.59a.77.77 0 0 1 .769-.769ZM8.132 15.72c.3-.3.787-.3 1.088 0a3.933 3.933 0 0 0 5.561 0 .77.77 0 0 1 1.088 1.088 5.471 5.471 0 0 1-7.737 0 .77.77 0 0 1 0-1.088ZM2 4.82A2.82 2.82 0 0 1 4.82 2h2.655a.77.77 0 1 1 0 1.538H4.82c-.709 0-1.283.574-1.283 1.283v2.654a.77.77 0 1 1-1.538 0V4.82ZM21.23 15.756a.77.77 0 0 1 .77.77v2.654A2.82 2.82 0 0 1 19.18 22h-2.655a.77.77 0 0 1 0-1.538h2.655c.708 0 1.282-.574 1.282-1.282v-2.655a.77.77 0 0 1 .769-.77ZM2.77 15.756a.77.77 0 0 1 .768.77v2.654c0 .708.574 1.282 1.283 1.282h2.654a.77.77 0 0 1 0 1.538H4.82A2.82 2.82 0 0 1 2 19.18v-2.655a.77.77 0 0 1 .77-.77ZM15.756 2.77a.77.77 0 0 1 .77-.77h2.654A2.82 2.82 0 0 1 22 4.82v2.655a.77.77 0 1 1-1.538 0V4.82c0-.709-.574-1.283-1.282-1.283h-2.655a.77.77 0 0 1-.77-.769Z", fill: "currentColor" }) }));
}, yce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: bce
}), mx = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.246 2.25a.75.75 0 0 1 .749.75v3.998c0 .139.112.25.25.25h3.999a.75.75 0 1 1 0 1.5h-3.999a1.75 1.75 0 0 1-1.749-1.75V3a.75.75 0 0 1 .75-.749ZM10.64 11.429a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0l-1.5-1.5a.75.75 0 0 1 1.06-1.06l.97.97 1.97-1.97a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 10.996a3.747 3.747 0 0 1 3.747-3.748h4.001a3.747 3.747 0 0 1 3.748 3.748v4.001a3.747 3.747 0 0 1-3.748 3.747h-4A3.747 3.747 0 0 1 2.5 14.997v-4.001Zm3.747-2.249A2.248 2.248 0 0 0 4 10.996v4.001a2.248 2.248 0 0 0 2.248 2.248h4.001a2.248 2.248 0 0 0 2.249-2.248v-4.001a2.248 2.248 0 0 0-2.249-2.249h-4Z", fill: "currentColor" }), m("path", { d: "M7 5.002c0-.69.56-1.25 1.25-1.25h7.171c.331 0 .649.132.883.366l2.83 2.827c.235.234.367.552.367.884v11.173c0 .69-.56 1.25-1.249 1.25H8.249c-.69 0-1.249-.56-1.249-1.25v-.763H5.501v.763A2.748 2.748 0 0 0 8.25 21.75h10.003A2.748 2.748 0 0 0 21 19.002V7.829c0-.73-.29-1.429-.806-1.944l-2.83-2.828a2.748 2.748 0 0 0-1.943-.803H8.25a2.748 2.748 0 0 0-2.748 2.748v3.244h1.5V5.002Z", fill: "currentColor" })] }));
}, Cce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: mx
}), F0 = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.748 2.003h6.922a.758.758 0 0 1 .15 0h.1c.729 0 1.427.289 1.942.804l2.83 2.827c.517.515.807 1.215.807 1.944v11.173A2.748 2.748 0 0 1 17.75 21.5H7.748A2.748 2.748 0 0 1 5 18.751v-.332A3.749 3.749 0 0 1 2 14.746v-4.001A3.749 3.749 0 0 1 5 7.072V4.75a2.748 2.748 0 0 1 2.748-2.748ZM6.5 18.75v-.257h3.248a3.747 3.747 0 0 0 3.748-3.748v-4.001a3.747 3.747 0 0 0-3.748-3.747H6.5V4.75c0-.69.56-1.25 1.25-1.25h6.246v3.247c0 .966.783 1.749 1.75 1.749H19V18.75c0 .69-.56 1.25-1.249 1.25H7.748c-.69 0-1.249-.56-1.249-1.25Zm9.245-11.753h3.113a1.248 1.248 0 0 0-.223-.304l-2.83-2.827a1.25 1.25 0 0 0-.31-.226v3.107c0 .138.112.25.25.25ZM3.498 10.745a2.248 2.248 0 0 1 2.248-2.248h4.001a2.248 2.248 0 0 1 2.249 2.248v4.001a2.248 2.248 0 0 1-2.249 2.249h-4a2.248 2.248 0 0 1-2.25-2.249v-4.001Zm3.574.268a.75.75 0 1 0-1.152.96l.85 1.019-.85 1.019a.75.75 0 0 0 1.152.96l.673-.809.673.808a.75.75 0 0 0 1.152-.96l-.85-1.018.85-1.02a.75.75 0 0 0-1.152-.96l-.673.809-.673-.808Z", fill: "currentColor" }) }));
}, wce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: F0
}), _ce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 5A2.75 2.75 0 0 1 7 2.25h7.172c.73 0 1.429.29 1.944.806l2.828 2.828a2.75 2.75 0 0 1 .806 1.944V19A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19V5ZM7 3.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V7.828c0-.33-.132-.65-.366-.884l-2.828-2.828a1.25 1.25 0 0 0-.884-.366H7Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2.25a.75.75 0 0 1 .75.75v4c0 .138.112.25.25.25h4a.75.75 0 0 1 0 1.5h-4A1.75 1.75 0 0 1 13.25 7V3a.75.75 0 0 1 .75-.75ZM7.961 16.432A.755.755 0 1 1 9.029 17.5a.755.755 0 0 1-1.068-1.068ZM7.25 10.995a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM7.25 13.995a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM14.961 16.466a.755.755 0 1 1 1.068 1.069.755.755 0 0 1-1.068-1.069ZM11.466 16.456a.755.755 0 1 1 1.068 1.069.755.755 0 0 1-1.068-1.069Z", fill: "currentColor" })] }));
}, xce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: _ce
}), hx = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 5A2.75 2.75 0 0 1 7 2.25h7.172c.73 0 1.429.29 1.944.806l2.828 2.828a2.75 2.75 0 0 1 .806 1.944V19A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19V5ZM7 3.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V7.828c0-.33-.132-.65-.366-.884l-2.828-2.828a1.25 1.25 0 0 0-.884-.366H7Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2.25a.75.75 0 0 1 .75.75v4c0 .138.112.25.25.25h4a.75.75 0 0 1 0 1.5h-4A1.75 1.75 0 0 1 13.25 7V3a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] }));
}, $ce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hx
}), bx = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [m("path", { d: "M20.0033 7.99867H16.0016C15.4491 7.99867 15.0012 7.55076 15.0012 6.99825V2.99658", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M5.99744 7.99867V4.99742C5.99744 3.89239 6.89324 2.99658 7.99827 2.99658H15.1733C15.7039 2.99658 16.2127 3.20757 16.5878 3.58283L19.417 6.412C19.7923 6.78715 20.0033 7.29598 20.0033 7.82659V19.0032C20.0033 20.1083 19.1075 21.0041 18.0024 21.0041H7.99827C6.89324 21.0041 5.99744 20.1083 5.99744 19.0032V18.0028", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M6.38866 10.9994C6.46883 11.0787 6.49318 11.1986 6.45031 11.3029C6.40745 11.4072 6.30584 11.4753 6.19308 11.4753C6.08032 11.4753 5.97871 11.4072 5.93584 11.3029C5.89298 11.1986 5.91733 11.0787 5.9975 10.9994C6.10632 10.8915 6.28184 10.8915 6.39066 10.9994", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M13.0004 11.9502C11.4628 11.7149 9.89938 12.1655 8.72294 13.1831C7.54651 14.2007 6.8754 15.683 6.88686 17.2384C6.88843 17.4943 6.90883 17.7498 6.94789 18.0027", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("rect", { x: "2.99622", y: "7.99841", width: "10.0042", height: "10.0042", rx: "3", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Oce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: bx
}), yx = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.414 6.414L15.586 3.586C15.211 3.211 14.702 3 14.172 3H7C5.895 3 5 3.895 5 5V19C5 20.105 5.895 21 7 21H17C18.105 21 19 20.105 19 19V7.828C19 7.298 18.789 6.789 18.414 6.414V6.414Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M19 8H15C14.448 8 14 7.552 14 7V3", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M10.34 16.5498H13.66", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.833 12.751V11.583C10.833 11.261 11.094 11 11.416 11H12.584C12.906 11 13.167 11.261 13.167 11.583V12.751C13.167 13.073 12.906 13.334 12.584 13.334H11.416C11.094 13.333 10.833 13.072 10.833 12.751Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 17.417V16.249C8 15.927 8.261 15.666 8.583 15.666H9.751C10.073 15.666 10.334 15.927 10.334 16.249V17.417C10.334 17.739 10.073 18 9.751 18H8.583C8.261 18 8 17.739 8 17.417Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.667 17.417V16.249C13.667 15.927 13.928 15.666 14.25 15.666H15.418C15.74 15.666 16.001 15.927 16.001 16.249V17.417C16 17.739 15.739 18 15.417 18H14.249C13.928 18 13.667 17.739 13.667 17.417H13.667Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M14.24 15.6701L12.73 13.3101", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M9.76001 15.6701L11.27 13.3101", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Pce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yx
}), Z0 = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [m("path", { d: "M20.0033 7.99867H16.0016C15.4491 7.99867 15.0012 7.55076 15.0012 6.99825V2.99658", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("rect", { x: "2.99622", y: "7.99841", width: "10.0042", height: "10.0042", rx: "3", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M5.74731 11.2499L6.24752 14.7513H6.57666L7.99825 11.7501L9.41984 14.7513H9.74898L10.2492 11.2499", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M5.99744 7.99867V4.99742C5.99744 3.89239 6.89324 2.99658 7.99827 2.99658H15.1733C15.7039 2.99658 16.2127 3.20757 16.5878 3.58283L19.417 6.412C19.7923 6.78715 20.0033 7.29598 20.0033 7.82659V19.0032C20.0033 20.1083 19.1075 21.0041 18.0024 21.0041H7.99827C6.89324 21.0041 5.99744 20.1083 5.99744 19.0032V18.0028", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Sce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Z0
}), Cx = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [m("path", { d: "M20.0034 7.99867H16.0018C15.4492 7.99867 15.0013 7.55076 15.0013 6.99825V2.99658", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M5.99744 7.99867V4.99742C5.99744 3.89239 6.89324 2.99658 7.99827 2.99658H15.1733C15.7039 2.99658 16.2127 3.20757 16.5878 3.58283L19.417 6.412C19.7923 6.78715 20.0033 7.29598 20.0033 7.82659V19.0032C20.0033 20.1083 19.1075 21.0041 18.0024 21.0041H7.99827C6.89324 21.0041 5.99744 20.1083 5.99744 19.0032V18.0028", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M7.99826 12.8151V10.9794", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M7.99811 14.8403C7.97406 14.8403 7.951 14.8499 7.93409 14.8671C7.91717 14.8842 7.90781 14.9073 7.90807 14.9314C7.90808 14.9683 7.93037 15.0015 7.96451 15.0156C7.99865 15.0296 8.03788 15.0216 8.06384 14.9954C8.0898 14.9691 8.09734 14.9298 8.08293 14.8958C8.06852 14.8618 8.03502 14.8399 7.99811 14.8403", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("rect", { x: "2.99658", y: "7.99841", width: "10.0042", height: "10.0042", rx: "3", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Ice = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Cx
}), wx = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [m("path", { d: "M5.00012 8V19C5.00012 20.105 5.89512 21 7.00012 21H15.0001", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M19.0001 20.75L5.00012 3.25", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M19 16V7.828C19 7.298 18.789 6.789 18.414 6.414L15.586 3.586C15.211 3.211 14.702 3 14.172 3H9", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M19.0001 8H15.0001C14.4481 8 14.0001 7.552 14.0001 7V3", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Ece = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: wx
}), _x = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [m("path", { d: "M14 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V14", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M21 18L18 21", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M18 18L21 21", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.625 12.4996V14.3737C13.625 14.7524 13.411 15.0987 13.0722 15.2681L11.8222 15.8931C11.5123 16.0481 11.1441 16.0315 10.8493 15.8493C10.5545 15.6671 10.375 15.3452 10.375 14.9987V12.4996L8.38921 10.9677C8.14376 10.7784 8 10.4859 8 10.1759V9C8 8.44772 8.44772 8 9 8H15C15.5523 8 16 8.44772 16 9V10.1759C16 10.4859 15.8562 10.7784 15.6108 10.9677L13.625 12.4996Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Rce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: _x
}), xx = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [m("path", { d: "M12.0003 12.6588V10.709", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4167 6.41152L15.5875 3.58234C15.2124 3.20708 14.7036 2.99609 14.173 2.99609H6.99796C5.89293 2.99609 4.99713 3.8919 4.99713 4.99693V19.0028C4.99713 20.1078 5.89293 21.0036 6.99796 21.0036H17.0021C18.1072 21.0036 19.003 20.1078 19.003 19.0028V7.82611C19.003 7.29549 18.792 6.78666 18.4167 6.41152Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M11.9997 14.8084C11.9445 14.8084 11.8997 14.8532 11.8997 14.9084C11.8997 14.9637 11.9445 15.0085 11.9997 15.0085C12.0433 14.9966 12.0735 14.9571 12.0735 14.9119C12.0735 14.8668 12.0433 14.8272 11.9997 14.8154", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Ace = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: xx
}), $x = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [m("circle", { cx: "12.001", cy: "8.24884", r: "4.25177", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M3.99731 20.0038C3.99731 17.5178 6.01315 15.502 8.49919 15.502H11.0833", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M15.7346 19.7718L19.2721 16.2344", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M15.7346 16.2344L19.2721 19.7718", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, kce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: $x
}), Mce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 6A.75.75 0 0 1 7 5.25h5.875a3.75 3.75 0 1 1 0 7.5H7a.75.75 0 0 1-.75-.75V6Zm1.5.75v4.5h5.125a2.25 2.25 0 0 0 0-4.5H7.75Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 12a.75.75 0 0 1 .75-.75h7a3.75 3.75 0 1 1 0 7.5H7a.75.75 0 0 1-.75-.75v-6Zm1.5.75v4.5H14a2.25 2.25 0 0 0 0-4.5H7.75Z", fill: "currentColor" })] }));
}, Nce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Mce
}), Tce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.682 5.273a.75.75 0 0 1 .546.91l-3 12a.75.75 0 0 1-1.456-.365l3-12a.75.75 0 0 1 .91-.545Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 18a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75ZM9.25 6a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7A.75.75 0 0 1 9.25 6Z", fill: "currentColor" })] }));
}, Dce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Tce
}), jce = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 5a.75.75 0 0 1 .75.75v6a3.25 3.25 0 0 0 6.5 0v-6a.75.75 0 0 1 1.5 0v6a4.75 4.75 0 1 1-9.5 0v-6A.75.75 0 0 1 8 5ZM6.25 18.75A.75.75 0 0 1 7 18h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, Lce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: jce
}), zce = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 12.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25h-3ZM13.25 14A2.75 2.75 0 0 1 16 11.25h3A2.75 2.75 0 0 1 21.75 14v5A2.75 2.75 0 0 1 19 21.75h-3A2.75 2.75 0 0 1 13.25 19v-5ZM16 3.75c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25h-3ZM13.25 5A2.75 2.75 0 0 1 16 2.25h3A2.75 2.75 0 0 1 21.75 5v2A2.75 2.75 0 0 1 19 9.75h-3A2.75 2.75 0 0 1 13.25 7V5ZM5 3.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5ZM2.25 5A2.75 2.75 0 0 1 5 2.25h3A2.75 2.75 0 0 1 10.75 5v5A2.75 2.75 0 0 1 8 12.75H5A2.75 2.75 0 0 1 2.25 10V5ZM5 15.75c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25H5ZM2.25 17A2.75 2.75 0 0 1 5 14.25h3A2.75 2.75 0 0 1 10.75 17v2A2.75 2.75 0 0 1 8 21.75H5A2.75 2.75 0 0 1 2.25 19v-2Z", fill: "currentColor" }) }));
}, Vce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: zce
}), Fce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.5A2.75 2.75 0 0 1 5 2.75h5a.75.75 0 0 1 0 1.5H5c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-6.125a.75.75 0 0 1 1.5 0V19.5A2.75 2.75 0 0 1 19 22.25H5a2.75 2.75 0 0 1-2.75-2.75v-14Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 8.752a3.751 3.751 0 0 1 3.752-3.751h5.002a.75.75 0 0 1 0 1.5h-5.002a2.251 2.251 0 0 0-2.252 2.251v2.501a.75.75 0 0 1-1.5 0v-2.5Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.972 2.72a.75.75 0 0 1 1.061 0l2.501 2.5a.75.75 0 0 1 0 1.061l-2.501 2.501a.75.75 0 1 1-1.06-1.06l1.97-1.971-1.97-1.97a.75.75 0 0 1 0-1.061Z", fill: "currentColor" })] }));
}, Zce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Fce
}), Wce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 6.998a.75.75 0 0 1 .75-.75h18.008a.75.75 0 0 1 0 1.5H2.996a.75.75 0 0 1-.75-.75ZM6.248 11a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75ZM6.25 14.5a.75.75 0 0 1 .75-.75h5a.75.75 0 1 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: e.color }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.997 4.747a2.251 2.251 0 0 0-2.25 2.251V15a2.251 2.251 0 0 0 2.25 2.252H10a.75.75 0 0 1 0 1.5H5.997A3.751 3.751 0 0 1 2.247 15V6.998a3.752 3.752 0 0 1 3.75-3.751h12.005a3.752 3.752 0 0 1 3.752 3.751V11a.75.75 0 0 1-1.5 0V6.998a2.251 2.251 0 0 0-2.252-2.251H5.997Z", fill: e.color }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.093 16.253H18.41a2.85 2.85 0 0 1 2.843 2.843V19.504c0 .69-.56 1.25-1.25 1.25H13.5c-.69 0-1.25-.56-1.25-1.25v-.409a2.85 2.85 0 0 1 2.843-2.842Zm.003 1.5a1.35 1.35 0 0 0-1.346 1.346v.155h6.003v-.155a1.35 1.35 0 0 0-1.346-1.346h-3.311ZM14 12.49a2.75 2.75 0 1 1 5.502.022 2.75 2.75 0 0 1-5.501-.022Zm2.751 1.262a1.25 1.25 0 1 0-1.25-1.256m1.25 1.256a1.25 1.25 0 0 1-1.25-1.256", fill: e.color })] }));
}, Bce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Wce
}), Hce = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.251 4.002a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 8.003a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 12.005a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 16.007a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM7.253 20.008a.75.75 0 0 1 .75-.75h8.003a.75.75 0 0 1 0 1.5H8.003a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, Gce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Hce
}), Xce = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.251 4.002a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 8.003a.75.75 0 0 1 .75-.75h13.006a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM3.251 12.005a.75.75 0 0 1 .75-.75h13.006a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM3.251 16.007a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 20.008a.75.75 0 0 1 .75-.75h8.004a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, Yce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Xce
}), Uce = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { clipRule: "evenodd", d: "M15.752 11.25a.75.75 0 0 0-.75-.75H13.5V8.998a.75.75 0 0 0-.75-.75H11.25a.75.75 0 0 0-.75.75v1.5H8.998a.75.75 0 0 0-.75.75v1.501c0 .415.335.75.75.75h1.5v1.501c0 .415.336.75.75.75h1.501a.75.75 0 0 0 .75-.75v-1.5h1.501a.75.75 0 0 0 .75-.75V11.25Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M5.633 5.633a9.004 9.004 0 1 1 0 12.734M4.497 12H1.996M5.997 8.999h-2.5M5.997 15.001h-2.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Jce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Uce
}), qce = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.998 3.746c-.69 0-1.25.56-1.25 1.251v14.006c0 .69.56 1.25 1.25 1.25h8.004c.69 0 1.25-.56 1.25-1.25V4.997c0-.69-.56-1.25-1.25-1.25h-.75v1.026A1.307 1.307 0 0 1 14 6.147H9.999a1.307 1.307 0 0 1-1.25-1.375V3.747h-.75Zm0-1.5a2.75 2.75 0 0 0-2.75 2.751v14.006a2.75 2.75 0 0 0 2.75 2.75h8.004a2.75 2.75 0 0 0 2.75-2.75V4.997a2.75 2.75 0 0 0-2.75-2.75H7.998Zm2.251 1.5v.901h3.502v-.9H10.25Zm-1 14.257a.75.75 0 0 1 .75-.75h4.002a.75.75 0 0 1 0 1.5H9.999a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, Kce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: qce
}), Qce = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.25 5a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM6 3.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 5a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM11.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM11.25 19a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM6 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM6 17.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 19a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Z", fill: "currentColor" }) }));
}, eue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Qce
}), rue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.25 4a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM10.4 9a.75.75 0 0 1 .75-.75H20a.75.75 0 0 1 0 1.5h-8.85A.75.75 0 0 1 10.4 9ZM5.537 3.307A.75.75 0 0 1 6 4v5a.75.75 0 1 1-1.5 0V5.81a.75.75 0 0 1-1.03-1.09l1.25-1.25a.75.75 0 0 1 .817-.163ZM10.25 14a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM10.4 19a.75.75 0 0 1 .75-.75H20a.75.75 0 0 1 0 1.5h-8.85a.75.75 0 0 1-.75-.75ZM5 14.75a.25.25 0 0 0-.25.25.75.75 0 0 1-1.5 0c0-.966.784-1.75 1.75-1.75h.614a1.979 1.979 0 0 1 1.503 3.266L5.63 18.25H7a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.57-1.238l2.548-2.972a.479.479 0 0 0-.364-.79H5Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 9A.75.75 0 0 1 4 8.25h2.5a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 9Z", fill: "currentColor" })] }));
}, tue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: rue
}), nue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.114 7.394c0-.427.346-.773.772-.773h8.228a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773ZM7.114 11.515c0-.427.346-.773.772-.773h8.362a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.8 4.045a.258.258 0 0 0-.257.258v15.235l1.626-.815a.77.77 0 0 1 .69 0l2.398 1.201 2.398-1.2a.77.77 0 0 1 .69-.001l2.398 1.2 2.397-1.2a.77.77 0 0 1 .69 0l1.627.814V4.303a.258.258 0 0 0-.257-.258H4.8ZM3 4.303C3 3.308 3.806 2.5 4.8 2.5h14.4c.994 0 1.8.808 1.8 1.803v15.651c0 .96-1.007 1.578-1.86 1.152h-.001l-1.654-.829-2.167 1.086-.002.001c-.362.18-.785.18-1.146 0h-.002L12 20.277l-2.168 1.086-.002.001c-.36.18-.784.18-1.146 0h-.002l-2.167-1.087-1.654.829-.002.001A1.287 1.287 0 0 1 3 19.954V4.303Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.114 15.636c0-.427.346-.773.772-.773h5.142a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773Z", fill: "currentColor" })] }));
}, oue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: nue
}), aue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5A2.75 2.75 0 0 1 5 2.25a.75.75 0 0 1 0 1.5c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0ZM3 7.58a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2A.75.75 0 0 1 3 7.58ZM7.58 3a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2A.75.75 0 0 1 7.58 3ZM21 18.25a.75.75 0 0 1 .75.75A2.75 2.75 0 0 1 19 21.75a.75.75 0 0 1 0-1.5c.69 0 1.25-.56 1.25-1.25a.75.75 0 0 1 .75-.75ZM18.25 3a.75.75 0 0 1 .75-.75A2.75 2.75 0 0 1 21.75 5a.75.75 0 0 1-1.5 0c0-.69-.56-1.25-1.25-1.25a.75.75 0 0 1-.75-.75ZM21 7.58a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM21 12.92a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM12.92 3a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM12.92 21a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM9.308 15.58a.75.75 0 0 1 0 1.061l-2.222 2.222a.75.75 0 0 1-1.06 0l-1.334-1.332a.75.75 0 1 1 1.06-1.061l.804.803 1.692-1.692a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 13.75c-.69 0-1.25.56-1.25 1.25v4c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-4c0-.69-.56-1.25-1.25-1.25H5ZM2.25 15A2.75 2.75 0 0 1 5 12.25h4A2.75 2.75 0 0 1 11.75 15v4A2.75 2.75 0 0 1 9 21.75H5A2.75 2.75 0 0 1 2.25 19v-4Z", fill: "currentColor" })] }));
}, iue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: aue
}), lue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.874 5.995C2.27 4.308 3.979 2.672 5.639 3.442l14.429 6.697c1.577.731 1.577 2.989 0 3.72l-14.43 6.7c-1.659.769-3.367-.867-2.764-2.554l2.143-6.008-2.143-6.002Zm2.133-1.193a.54.54 0 0 0-.72.689l2.232 6.254a.75.75 0 0 1 0 .504l-2.232 6.26c-.171.478.31.879.72.689l14.43-6.7a.555.555 0 0 0 0-.999L5.006 4.802Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.06 12a.75.75 0 0 1 .75-.75H20.5a.75.75 0 0 1 0 1.5H5.81a.75.75 0 0 1-.75-.75Z", fill: "currentColor" })] }));
}, sue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: lue
}), cue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.385 4.82a.77.77 0 0 1 .769-.769h3.077a.77.77 0 1 1 0 1.539h-3.077a.77.77 0 0 1-.77-.77ZM2 4.82a.77.77 0 0 1 .77-.769H14.05a.77.77 0 0 1 0 1.539H2.77A.77.77 0 0 1 2 4.82ZM9.18 12a.77.77 0 0 1 .769-.77H21.23a.77.77 0 0 1 0 1.54H9.949a.77.77 0 0 1-.77-.77ZM2 12a.77.77 0 0 1 .77-.77h3.076a.77.77 0 1 1 0 1.54H2.77A.77.77 0 0 1 2 12ZM17.385 19.18a.77.77 0 0 1 .769-.77h3.077a.77.77 0 1 1 0 1.539h-3.077a.77.77 0 0 1-.77-.77ZM2 19.18a.77.77 0 0 1 .77-.77H14.05a.77.77 0 0 1 0 1.539H2.77a.77.77 0 0 1-.769-.77Z", fill: e.color }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.01 3.914a1.282 1.282 0 1 0-1.814 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.086-1.089a2.82 2.82 0 1 0-3.988 3.989 2.82 2.82 0 0 0 3.99-3.988h-.002ZM8.804 11.093a1.282 1.282 0 1 0-1.813 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.087-1.088a2.82 2.82 0 1 0-3.989 3.989 2.82 2.82 0 0 0 3.99-3.988v-.001ZM17.01 18.273a1.282 1.282 0 1 0-1.814 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.086-1.089a2.82 2.82 0 1 0-3.988 3.989 2.82 2.82 0 0 0 3.99-3.988h-.002Z", fill: e.color })] }));
}, uue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: cue
}), due = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 8.5A.5.5 0 0 1 2 8h8.253a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5Z", fill: "#4E535C" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.646 5.896a.5.5 0 0 1 .708 0l2.25 2.25a.5.5 0 0 1 0 .708l-2.25 2.249a.5.5 0 1 1-.707-.707L9.543 8.5 7.646 6.604a.5.5 0 0 1 0-.708Z", fill: "#4E535C" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-1.5a.5.5 0 0 1 1 0V13a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1v1.5a.5.5 0 0 1-1 0V4Z", fill: "#4E535C" })] }));
}, fue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: due
}), pue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { d: "M16 7H12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M16 11H12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M16 15H12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 20.191V4C4 3.448 4.448 3 5 3H19C19.552 3 20 3.448 20 4V20.191C20 20.563 19.609 20.804 19.276 20.638L17.333 19.666L14.667 21L12 19.667L9.333 21L6.666 19.667L4.723 20.639C4.391 20.804 4 20.563 4 20.191Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M8 6.99C7.997 6.99 7.995 6.992 7.995 6.995C7.995 6.998 7.997 7 8 7C8.003 7 8.005 6.998 8.005 6.995C8.005 6.992 8.003 6.99 8 6.99", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M8 11C7.997 11 7.995 11.002 7.995 11.005C7.995 11.008 7.997 11.01 8 11.01C8.003 11.01 8.005 11.008 8.005 11.005C8.005 11.002 8.003 11 8 11", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M8 14.99C7.997 14.99 7.995 14.992 7.995 14.995C7.995 14.998 7.997 15 8 15C8.003 15 8.005 14.998 8.005 14.995C8.005 14.992 8.003 14.99 8 14.99", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, gue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: pue
}), vue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { d: "M9 17V8C9 7.448 9.448 7 10 7H15V17", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M15 7V4C15 3.448 15.448 3 16 3H20C20.552 3 21 3.448 21 4V16C21 16.552 20.552 17 20 17H4C3.448 17 3 16.552 3 16V12C3 11.448 3.448 11 4 11H9", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M3 21H21", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, mue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vue
}), hue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.0037 12.4998V21.0033C22.0037 21.5559 21.5558 22.0038 21.0033 22.0038H15.0008C14.4483 22.0038 14.0004 21.5559 14.0004 21.0033V12.4998C14.0004 11.9473 14.4483 11.4994 15.0008 11.4994H21.0033C21.5558 11.4994 22.0037 11.9473 22.0037 12.4998Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M22.0037 15.0008H14.0004", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M7.49771 7.99789H16.0013", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M7.49771 11.4994H9.99875", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M7.49771 15.0008H9.99875", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M10.9992 19.0025H5.99708C4.89205 19.0025 3.99625 18.1067 3.99625 17.0016V5.99705C3.99625 4.89202 4.89205 3.99622 5.99708 3.99622H18.0021C19.1071 3.99622 20.0029 4.89202 20.0029 5.99705V8.9983", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M16.7516 17.2018C16.7239 17.2018 16.7015 17.2242 16.7015 17.2518C16.7015 17.2794 16.7239 17.3018 16.7516 17.3018C16.7792 17.3018 16.8016 17.2794 16.8016 17.2518C16.8016 17.2242 16.7792 17.2018 16.7516 17.2018", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M19.2526 17.2018C19.225 17.2018 19.2026 17.2242 19.2026 17.2518C19.2026 17.2794 19.225 17.3018 19.2526 17.3018C19.2802 17.3018 19.3026 17.2794 19.3026 17.2518C19.3026 17.2242 19.2802 17.2018 19.2526 17.2018", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M16.7516 19.7028C16.7239 19.7028 16.7015 19.7251 16.7015 19.7528C16.7015 19.7804 16.7239 19.8028 16.7516 19.8028C16.7792 19.8028 16.8016 19.7804 16.8016 19.7528C16.8016 19.7251 16.7792 19.7028 16.7516 19.7028", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M19.2526 19.7028C19.225 19.7028 19.2026 19.7251 19.2026 19.7528C19.2026 19.7804 19.225 19.8028 19.2526 19.8028C19.2802 19.8028 19.3026 19.7804 19.3026 19.7528C19.3026 19.7251 19.2802 19.7028 19.2526 19.7028", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, bue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hue
}), yue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { d: "M19.0029 21.0038C20.108 21.0038 21.0038 20.108 21.0038 19.0029", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M21.0037 19.0029V15.0012", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M19.0029 21.0037H14.0008", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M9.99917 2.99622H4.99709C3.89206 2.99622 2.99625 3.89202 2.99625 4.99705V7.9983", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.0029 10.9995H15.0013C13.8962 10.9995 13.0004 10.1037 13.0004 8.99872V4.99705C13.0004 3.89202 13.8962 2.99622 15.0013 2.99622H19.0029C20.1079 2.99622 21.0038 3.89202 21.0038 4.99705V8.99872C21.0038 10.1037 20.1079 10.9995 19.0029 10.9995Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M18.3637 6.14661L16.6629 7.84731L15.6405 6.82789", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99917 21.0037H3.49646C3.2202 21.0037 2.99625 20.7797 2.99625 20.5035V20.0973C2.99955 18.9417 3.93553 18.0057 5.09113 18.0024H8.40451C9.5601 18.0057 10.4961 18.9417 10.4994 20.0973V20.5035C10.4994 20.7797 10.2754 21.0037 9.99917 21.0037Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.74781 15.5014C5.64383 15.5014 4.74846 14.6072 4.747 13.5033C4.74553 12.3993 5.63852 11.5027 6.7425 11.4998C7.84648 11.4968 8.74423 12.3886 8.74866 13.4926C8.75077 14.0246 8.54091 14.5356 8.16545 14.9126C7.78999 15.2895 7.27986 15.5014 6.74781 15.5014Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Cue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yue
}), wue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({ width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.9975 21.0038H3.99667C3.44444 21.0038 2.99625 20.5556 2.99625 20.0034V14.0009C2.99625 13.4487 3.44444 13.0005 3.99667 13.0005H5.9975C6.54973 13.0005 6.99792 13.4487 6.99792 14.0009V20.0034C6.99792 20.5556 6.54973 21.0038 5.9975 21.0038Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M13.0004 17.0021H15.3344C15.7676 17.0021 16.1887 16.862 16.5349 16.6019L18.9519 14.7892C19.5551 14.337 20.3995 14.397 20.9327 14.9302V14.9302C21.525 15.5225 21.525 16.4819 20.9327 17.0731L18.8589 19.147C18.3006 19.7052 17.5883 20.0864 16.814 20.2414L13.8828 20.8277C13.3015 20.9437 12.7023 20.9297 12.1271 20.7857L9.47595 20.1234C9.15882 20.0434 8.83368 20.0033 8.50655 20.0033H6.99792", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M13.0004 17.0022H14.486C15.3234 17.0022 16.0017 16.3239 16.0017 15.4865V15.1834C16.0017 14.4881 15.5285 13.8819 14.8542 13.7138L12.5612 13.1405C12.1881 13.0475 11.8059 13.0005 11.4218 13.0005V13.0005C10.4944 13.0005 9.587 13.2746 8.81567 13.7898L6.99792 15.0013", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M13.4496 4.17076L8.82268 4.17376C8.55757 4.17376 8.30346 4.2798 8.11638 4.46688L7.29104 5.29223C6.89987 5.68339 6.89987 6.31665 7.29104 6.70682L8.11938 7.53516C8.30646 7.72224 8.56157 7.82828 8.82668 7.82728L13.4526 7.82428L13.4636 7.82528C14.1269 9.11282 15.4544 10.0012 17.0041 9.99918C19.213 9.99318 21.0037 8.19744 21.0037 5.98952C21.0047 3.7806 19.216 1.99385 17.0071 1.99585C15.4634 1.99985 14.1389 2.88923 13.4726 4.17176", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), m("path", { d: "M17.0041 6.26168C17.1481 6.26168 17.2642 6.14463 17.2642 6.00057C17.2642 5.85651 17.1461 5.73947 17.0031 5.73947C16.859 5.73947 16.742 5.85651 16.742 6.00057C16.742 6.14463 16.859 6.26168 17.0041 6.26168", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, _ue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: wue
}), xue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.165 2.84a3.849 3.849 0 0 1 6.14 2.1l.004.016a.27.27 0 0 0 .204.206 4.355 4.355 0 0 1 2.757 6.681l-.004.007a.256.256 0 0 0 0 .29l.005.006a4.355 4.355 0 0 1-2.758 6.682.27.27 0 0 0-.204.205l-.003.015a3.845 3.845 0 0 1-6.14 2.112l-.004-.004a.257.257 0 0 0-.323 0l-.004.003a3.849 3.849 0 0 1-6.14-2.099l-.004-.016a.27.27 0 0 0-.204-.206 4.355 4.355 0 0 1-2.758-6.68l.005-.008a.256.256 0 0 0 0-.29l-.006-.008a4.355 4.355 0 0 1 2.759-6.68.27.27 0 0 0 .204-.205l.004-.016a3.845 3.845 0 0 1 6.14-2.105l.004.003c.084.068.2.075.291.022a.715.715 0 0 1 .035-.03Zm1.012 1.162a1.796 1.796 0 0 1-2.304.044 2.31 2.31 0 0 0-3.68 1.258 1.808 1.808 0 0 1-1.386 1.372l-.008.002a2.821 2.821 0 0 0-1.791 4.32 1.793 1.793 0 0 1 0 2.014 2.818 2.818 0 0 0 1.79 4.32l.01.002c.689.148 1.23.684 1.384 1.371a2.308 2.308 0 0 0 3.681 1.255 1.796 1.796 0 0 1 2.254 0 2.31 2.31 0 0 0 3.681-1.264 1.808 1.808 0 0 1 1.385-1.372l.009-.002a2.821 2.821 0 0 0 1.79-4.321 1.793 1.793 0 0 1 0-2.012 2.818 2.818 0 0 0-1.79-4.322l-.009-.001a1.808 1.808 0 0 1-1.385-1.371 2.308 2.308 0 0 0-3.63-1.293Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.904c.425 0 .77.344.77.769v16.653a.769.769 0 0 1-1.539 0V3.673c0-.425.344-.769.77-.769ZM17.13 14.82c-.709 0-1.283.573-1.283 1.281a.769.769 0 0 1-1.538 0 2.82 2.82 0 0 1 2.82-2.82.769.769 0 1 1 0 1.538ZM8.922 7.13c.425 0 .77.345.77.769a2.82 2.82 0 0 1-2.821 2.82.769.769 0 1 1 0-1.538c.708 0 1.282-.574 1.282-1.282 0-.424.345-.769.77-.769ZM6.101 14.05c0-.424.345-.768.77-.768A2.82 2.82 0 0 1 9.69 16.1a.769.769 0 0 1-1.538 0c0-.708-.574-1.282-1.282-1.282a.769.769 0 0 1-.77-.769ZM15.078 7.13c.425 0 .769.345.769.769 0 .708.574 1.282 1.283 1.282a.769.769 0 1 1 0 1.537A2.82 2.82 0 0 1 14.309 7.9c0-.424.344-.769.769-.769Z", fill: "currentColor" })] }));
}, $ue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: xue
}), Oue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4.82A2.82 2.82 0 0 1 4.82 2h12.308a2.82 2.82 0 0 1 2.82 2.82V9.95a.77.77 0 0 1-1.538 0V4.82c0-.709-.573-1.283-1.282-1.283H4.821c-.709 0-1.283.574-1.283 1.283V19.18c0 .707.574 1.282 1.283 1.282h5.128a.77.77 0 1 1 0 1.538H4.82A2.82 2.82 0 0 1 2 19.18V4.82Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.31 13.658c.7-.7 1.837-.7 2.538 0l1.626 1.627c.701.7.701 1.837 0 2.538l-3.65 3.651a1.795 1.795 0 0 1-1.27.526h-2.652a.77.77 0 0 1-.77-.77v-2.652c0-.476.19-.932.526-1.269l3.652-3.65Zm1.087 1.088-3.65 3.651a.257.257 0 0 0-.076.181v1.884h1.883a.256.256 0 0 0 .181-.076l3.652-3.65c.1-.101.1-.263 0-.363m-1.627-1.627Zm-.363 0c.1-.1.263-.1.363 0h-.363ZM10.975 11.23a.77.77 0 0 1 .769.77v3.077a.77.77 0 0 1-1.539 0V12a.77.77 0 0 1 .77-.77Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.667 13.539a.77.77 0 0 1 .769-.77h3.077a.77.77 0 0 1 0 1.539H9.436a.77.77 0 0 1-.77-.77ZM7.128 6.872a.77.77 0 0 1 .77-.77h6.153a.77.77 0 1 1 0 1.54H7.898a.77.77 0 0 1-.77-.77Z", fill: "currentColor" })] }));
}, Pue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Oue
}), Sue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.262 2.75a1.04 1.04 0 0 0-1.04 1.04v1.039h5.659v-1.04a1.04 1.04 0 0 0-1.04-1.039H8.262Zm6.119 1.04a2.54 2.54 0 0 0-2.54-2.54H8.262a2.54 2.54 0 0 0-2.54 2.54v3.578a4.32 4.32 0 0 0 1.6 3.36l-.335 1.342a1.56 1.56 0 0 0-.43.025l-.216.043a.82.82 0 0 0-.032.007l-2.299.46a3.434 3.434 0 0 0-2.761 3.367v.344a.75.75 0 0 0 1.5 0v-.344c0-.922.65-1.716 1.555-1.897l1.419-.283v1.902a2.252 2.252 0 1 0 1.5 0v-1.912c1.133.67 2.386.908 3.724.643a.75.75 0 0 0-.291-1.472 3.628 3.628 0 0 1-2.28-.257l.305-1.22c.431.144.892.221 1.37.221.482 0 .946-.078 1.379-.224l.092.359a.75.75 0 1 0 1.453-.375l-.19-.732a4.32 4.32 0 0 0 1.596-3.357V3.79Zm-1.5 2.539H7.223v1.04a2.827 2.827 0 0 0 2.829 2.828 2.829 2.829 0 0 0 2.829-2.829v-1.04ZM6.473 17.066a.75.75 0 1 0 0 1.501.75.75 0 0 0 0-1.501ZM11.443 16.904a5.654 5.654 0 1 1 5.654 5.654.75.75 0 0 1 0-1.5 4.155 4.155 0 1 0-4.154-4.154.75.75 0 0 1-1.5 0Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.193 16.154a.75.75 0 0 1 .75.75c0 .628.139 1.222.387 1.756a.75.75 0 0 1 .054.47l-.396 1.898 1.893-.403a.75.75 0 0 1 .471.054 4.148 4.148 0 0 0 1.75.384.75.75 0 1 1 0 1.5c-.758 0-1.482-.15-2.144-.42l-2.783.59a.75.75 0 0 1-.89-.886l.582-2.79a5.651 5.651 0 0 1-.424-2.153.75.75 0 0 1 .75-.75ZM14.814 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.213 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132ZM17.064 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.463 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132ZM19.314 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.713 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132Z", fill: "currentColor" })] }));
}, Iue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Sue
}), Eue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.846 5.509a3.004 3.004 0 0 1 3-3.009h5.657c.918 0 1.799.366 2.448 1.017l2.189 2.195a3.477 3.477 0 0 1 1.014 2.455v3.381a.693.693 0 1 1-1.385 0v-3.38c0-.553-.219-1.083-.608-1.474L14.97 4.5c-.389-.39-.917-.61-1.468-.61H7.846c-.892 0-1.615.725-1.615 1.62V8.77a.693.693 0 1 1-1.385 0V5.509Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.846 2.522c.383 0 .693.31.693.694v3.218c0 .384.31.695.692.695h3.209a.693.693 0 0 1 0 1.388h-3.21a2.08 2.08 0 0 1-2.076-2.083V3.216c0-.383.31-.694.692-.694ZM3 10.622a2.542 2.542 0 0 1 2.538-2.546h3.875a2.075 2.075 0 0 1 1.728.928l1.024 1.54c.128.194.344.31.576.31h5.72A2.542 2.542 0 0 1 21 13.4v5.554a2.542 2.542 0 0 1-2.538 2.546H5.538A2.542 2.542 0 0 1 3 18.954v-8.332Zm2.538-1.157c-.637 0-1.153.518-1.153 1.157v8.332c0 .64.516 1.157 1.153 1.157h12.924c.637 0 1.153-.518 1.153-1.157V13.4c0-.64-.516-1.158-1.153-1.158H12.74a2.075 2.075 0 0 1-1.728-.927l-1.024-1.54a.692.692 0 0 0-.576-.31H5.538Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.462 15.02c0-.384.31-.695.692-.695h2.77a.693.693 0 0 1 0 1.389h-2.77a.693.693 0 0 1-.692-.694Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.538 12.937c.383 0 .693.31.693.694v2.777a.693.693 0 1 1-1.385 0v-2.777c0-.383.31-.694.692-.694Z", fill: "currentColor" })] }));
}, Rue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Eue
}), Aue = function(e) {
  var r = fe(e.size);
  return m("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.086 21.23a.77.77 0 0 1 .771-.768h10.286a.77.77 0 1 1 0 1.538H6.857a.77.77 0 0 1-.771-.77ZM5.829 3.538c-.71 0-1.286.574-1.286 1.283v1.025a.77.77 0 0 1-1.543 0V4.821A2.824 2.824 0 0 1 5.829 2H18.17A2.824 2.824 0 0 1 21 4.82V9.95a.77.77 0 0 1-.771.769h-4.115a.772.772 0 0 1-.622-.315l-1.714-2.335-2.73 5.582a.771.771 0 0 1-1.316.117l-2.238-3.05H4.543v4.36c0 .709.575 1.282 1.285 1.282h12.345c.709 0 1.284-.573 1.284-1.282V14.05a.77.77 0 0 1 .772-.769.77.77 0 0 1 .771.77v1.025a2.824 2.824 0 0 1-2.828 2.82H5.829A2.824 2.824 0 0 1 3 15.077V9.949a.77.77 0 0 1 .771-.77h4.115c.246 0 .477.117.622.315l1.714 2.335 2.73-5.582a.771.771 0 0 1 1.316-.117l2.238 3.05h2.951V4.82c0-.708-.575-1.282-1.286-1.282H5.83Z", fill: "currentColor" }) }));
}, kue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Aue
}), Mue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.326 9.432c0-.425.343-.77.767-.77h4.093c.99 0 1.79.805 1.79 1.797V20.73c0 .425-.343.77-.766.77a.769.769 0 0 1-.768-.77V10.46a.257.257 0 0 0-.256-.258h-4.093a.769.769 0 0 1-.767-.77Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.814 4.04a.257.257 0 0 0-.256.257V20.73a.769.769 0 1 1-1.534 0V4.297c0-.992.8-1.797 1.79-1.797H15.07c.989 0 1.79.805 1.79 1.797V20.73c0 .425-.343.77-.767.77a.769.769 0 0 1-.767-.77V4.297a.257.257 0 0 0-.256-.257H3.814Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.023 20.73c0 .425-.343.77-.767.77H6.628a.769.769 0 0 1-.767-.77v-4.108c0-.425.343-.77.767-.77h5.628c.424 0 .767.345.767.77v4.108Zm-1.534-.77v-2.568H7.395v2.568h4.094Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.442 15.852c.423 0 .767.345.767.77v4.108c0 .425-.344.77-.767.77a.769.769 0 0 1-.767-.77v-4.108c0-.425.343-.77.767-.77Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 20.73c0-.425.343-.77.767-.77h20.466c.424 0 .767.345.767.77 0 .425-.343.77-.767.77H1.767A.769.769 0 0 1 1 20.73ZM9.442 7.635c.423 0 .767.345.767.77v3.082c0 .425-.344.77-.767.77a.769.769 0 0 1-.767-.77V8.404c0-.425.343-.77.767-.77Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.14 9.946c0-.425.343-.77.767-.77h3.07c.423 0 .767.345.767.77 0 .425-.344.77-.767.77h-3.07a.769.769 0 0 1-.767-.77Z", fill: "currentColor" })] }));
}, Nue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Mue
}), Tue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.39 13.718a.77.77 0 0 1 .767-.772h5.686a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.773H9.157a.77.77 0 0 1-.767-.773ZM8.39 10.284a.77.77 0 0 1 .767-.773h5.686a.77.77 0 0 1 .767.773.77.77 0 0 1-.767.772H9.157a.77.77 0 0 1-.767-.772Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.998 5.2 6.5 6.641a1.287 1.287 0 0 0-.896 1.227v8.264c0 .562.363 1.058.896 1.227h.002l4.492 1.438a3.29 3.29 0 0 0 2.011 0l4.498-1.437c.532-.17.893-.667.893-1.228V7.87a1.287 1.287 0 0 0-.893-1.224l-4.499-1.442a3.29 3.29 0 0 0-2.006-.005Zm2.474-1.468a4.812 4.812 0 0 0-2.936-.006l-.002.001L6.04 5.168h-.001a2.83 2.83 0 0 0-1.968 2.7v8.265a2.832 2.832 0 0 0 1.968 2.7h.001l4.49 1.437a4.816 4.816 0 0 0 2.942 0l4.497-1.437a2.83 2.83 0 0 0 1.962-2.7V7.867a2.83 2.83 0 0 0-1.962-2.693l-4.496-1.442Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.396 9.139a.77.77 0 0 1 .767-.772h.227C21.384 8.367 23 9.994 23 12c0 2.007-1.616 3.634-3.61 3.634h-.227a.77.77 0 0 1-.767-.772.77.77 0 0 1 .767-.772h.227A2.083 2.083 0 0 0 21.466 12c0-1.154-.93-2.09-2.076-2.09h-.227a.77.77 0 0 1-.767-.772ZM4.61 9.911a2.083 2.083 0 0 0-2.076 2.09c0 1.154.93 2.09 2.076 2.09h.227a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.772H4.61c-1.994 0-3.61-1.627-3.61-3.634 0-2.007 1.616-3.634 3.61-3.634h.227a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.772H4.61ZM8.39 13.718a.77.77 0 0 1 .767-.772h5.686a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.773H9.157a.77.77 0 0 1-.767-.773ZM8.39 10.284a.77.77 0 0 1 .767-.773h5.686a.77.77 0 0 1 .767.773.77.77 0 0 1-.767.772H9.157a.77.77 0 0 1-.767-.772Z", fill: "currentColor" })] }));
}, Due = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Tue
}), jue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.031 7.646a3.75 3.75 0 0 1 1.677-.396H8a.75.75 0 1 1 0 1.5H6.708c-.35 0-.694.08-1.006.237l-.585.293a2.25 2.25 0 0 0-.924.855l-1.55 2.584a.75.75 0 1 1-1.286-.771l1.55-2.585A3.75 3.75 0 0 1 4.447 7.94m0 0 .585-.293M17.5 5.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.25 7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 1 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM16.25 13a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM14.25 16a.75.75 0 0 1 .75-.75h4a.75.75 0 1 1 0 1.5h-4a.75.75 0 0 1-.75-.75ZM10.66 10.28a2.396 2.396 0 0 1 3.687 3.023l-2.993 4.488a4.75 4.75 0 0 1-2.337 1.832l-5.762 2.082a.75.75 0 1 1-.51-1.41l5.762-2.082a3.25 3.25 0 0 0 1.6-1.254l2.993-4.488a.896.896 0 0 0-1.38-1.13l-2.19 2.19a.75.75 0 0 1-.53.219H7a.75.75 0 1 1 0-1.5h1.69l1.97-1.97Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 4.5A2.25 2.25 0 0 1 9.5 2.25h11a2.25 2.25 0 0 1 2.25 2.25v15a2.25 2.25 0 0 1-2.25 2.25h-11a2.25 2.25 0 0 1-2.25-2.25v-.307a.75.75 0 0 1 1.5 0v.307c0 .415.336.75.75.75h11a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75h-11a.75.75 0 0 0-.75.75V13a.75.75 0 1 1-1.5 0V4.5Z", fill: "currentColor" })] }));
}, Lue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: jue
}), zue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.539a8.461 8.461 0 0 0-8.461 8.46v.002A8.462 8.462 0 1 0 12 3.539h-.002Zm10 8.46C22 6.477 17.523 2 12 2S2 6.477 2 12s4.478 10 10 10c5.523 0 10.001-4.478 10-10Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.367 7.911c0-.991.803-1.795 1.794-1.795h1.678c.992 0 1.795.804 1.795 1.795V9.38h1.47c.99 0 1.794.804 1.794 1.795v1.678c0 .99-.804 1.795-1.795 1.795h-1.469v1.469c0 .99-.803 1.794-1.795 1.794h-1.678a1.795 1.795 0 0 1-1.794-1.794v-1.47h-1.47a1.795 1.795 0 0 1-1.794-1.794v-1.678c0-.991.804-1.795 1.795-1.795h1.469V7.91Zm1.794-.256a.257.257 0 0 0-.256.256v2.238a.77.77 0 0 1-.77.77H7.899a.257.257 0 0 0-.257.256v1.678c0 .141.115.256.257.256h2.238a.77.77 0 0 1 .77.77v2.238c0 .14.114.256.255.256h1.678a.257.257 0 0 0 .257-.256v-2.239a.77.77 0 0 1 .77-.769h2.237a.257.257 0 0 0 .257-.256v-1.678a.257.257 0 0 0-.257-.257h-2.238a.77.77 0 0 1-.769-.769V7.911a.257.257 0 0 0-.257-.256h-1.678Z", fill: "currentColor" })] }));
}, Vue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: zue
}), Fue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 16.502a.75.75 0 0 1 .75-.75h4.001a.75.75 0 0 1 0 1.5H6.998a.75.75 0 0 1-.75-.75ZM18.032 15.033a.75.75 0 0 1 0 1.061l-1.876 1.876a.75.75 0 0 1-1.06 0l-1.126-1.126a.75.75 0 1 1 1.061-1.06l.595.595 1.346-1.346a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 6.996a4.75 4.75 0 0 1 4.75-4.75h10.008a4.75 4.75 0 0 1 4.75 4.75v10.008a4.75 4.75 0 0 1-4.75 4.75H6.996a4.75 4.75 0 0 1-4.75-4.75V6.996Zm4.75-3.25a3.25 3.25 0 0 0-3.25 3.25v10.008a3.25 3.25 0 0 0 3.25 3.25h10.008a3.25 3.25 0 0 0 3.25-3.25V6.996a3.25 3.25 0 0 0-3.25-3.25H6.996Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 13a.75.75 0 0 1 .75-.75H15a.75.75 0 1 1 0 1.5H6.998a.75.75 0 0 1-.75-.75ZM8.498 5.748a.75.75 0 0 1 .75.75v3.001a.75.75 0 1 1-1.5 0V6.498a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 7.998a.75.75 0 0 1 .75-.75h3.001a.75.75 0 1 1 0 1.5H6.998a.75.75 0 0 1-.75-.75Z", fill: "currentColor" })] }));
}, Zue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Fue
}), Wue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.824 3.562c-.699-.7-1.833-.7-2.532 0-.7.7-.7 1.835 0 2.535.7.7 1.833.7 2.532 0 .7-.7.7-1.835 0-2.535Zm1.085-1.087a3.323 3.323 0 0 0-4.702 0 3.332 3.332 0 0 0 0 4.708 3.323 3.323 0 0 0 4.703 0 3.332 3.332 0 0 0 0-4.708ZM8.212 8.11a3.323 3.323 0 0 0-4.703 0 3.332 3.332 0 0 0 0 4.708 3.323 3.323 0 0 0 4.703 0 3.332 3.332 0 0 0 0-4.709Zm1.085-1.088a4.857 4.857 0 0 0-6.873 0 4.87 4.87 0 0 0 0 6.882 4.857 4.857 0 0 0 6.873 0 4.87 4.87 0 0 0 0-6.882Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 10.463c0-.424.344-.768.767-.768h8.186a.768.768 0 0 1 0 1.537H1.767A.768.768 0 0 1 1 10.463ZM20.784 11.911a2.321 2.321 0 0 0-3.286 0l-5.075 5.081a2.327 2.327 0 0 0 0 3.29 2.321 2.321 0 0 0 3.286 0l5.075-5.081a2.328 2.328 0 0 0 0-3.29Zm-4.371-1.086a3.855 3.855 0 0 1 5.457 0 3.865 3.865 0 0 1 0 5.463l-5.076 5.08a3.855 3.855 0 0 1-5.456 0 3.865 3.865 0 0 1 0-5.462l5.075-5.081Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.893 13.383c.3-.3.785-.3 1.085 0l4.339 4.343a.769.769 0 0 1-1.086 1.087l-4.338-4.344c-.3-.3-.3-.786 0-1.086Z", fill: "currentColor" })] }));
}, Bue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Wue
}), Hue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7.897A5.898 5.898 0 0 1 7.897 2h8.206A5.898 5.898 0 0 1 22 7.897v8.206A5.898 5.898 0 0 1 16.103 22H7.897A5.898 5.898 0 0 1 2 16.103V7.897Zm5.897-4.359a4.36 4.36 0 0 0-4.359 4.36v8.205a4.36 4.36 0 0 0 4.36 4.358h8.205a4.36 4.36 0 0 0 4.358-4.358V7.897a4.36 4.36 0 0 0-4.358-4.359H7.897Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 7.06a3.334 3.334 0 0 0-3.333 3.334c0 .141.115.256.256.256h6.154a.256.256 0 0 0 .256-.256A3.333 3.333 0 0 0 12 7.06Zm-4.872 3.334a4.872 4.872 0 0 1 9.744 0c0 .992-.805 1.795-1.795 1.795H8.923a1.795 1.795 0 0 1-1.795-1.795Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.37 8.676a.77.77 0 0 1 .344 1.032l-1.026 2.051a.77.77 0 1 1-1.376-.688l1.026-2.05a.77.77 0 0 1 1.032-.345Z", fill: "currentColor" })] }));
}, Gue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Hue
}), Xue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.515 3.836a4.009 4.009 0 0 0-3.03 0L5.342 5.934c-.483.197-.8.666-.8 1.187v4.04c0 4.233 3.169 8.234 7.458 9.28 4.29-1.046 7.457-5.047 7.457-9.28V7.12c0-.52-.315-.989-.8-1.187l-5.142-2.098Zm.584-1.424a5.556 5.556 0 0 0-4.198 0L4.758 4.51A2.82 2.82 0 0 0 3 7.12v4.04c0 5.027 3.77 9.687 8.83 10.821a.776.776 0 0 0 .34 0c5.06-1.134 8.83-5.794 8.83-10.82V7.12a2.82 2.82 0 0 0-1.758-2.61L14.1 2.41Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.522 9.692c-.757 0-1.35.708-1.35 1.444 0 .786.522 1.577 1.268 2.228.36.313.738.563 1.057.73.16.084.295.143.398.179.052.018.086.027.105.031.019-.004.053-.013.105-.031.103-.036.238-.095.398-.178a5.703 5.703 0 0 0 1.056-.731c.747-.65 1.27-1.442 1.27-2.228 0-.735-.595-1.444-1.35-1.444-.449 0-.73.206-.902.4a.772.772 0 0 1-1.154 0 1.158 1.158 0 0 0-.901-.4Zm-2.893 1.444c0-1.4 1.109-2.982 2.893-2.982.614 0 1.104.183 1.478.423.374-.24.864-.423 1.478-.423 1.783 0 2.893 1.582 2.893 2.982 0 1.445-.921 2.624-1.797 3.387-.45.393-.928.71-1.351.932a4.525 4.525 0 0 1-.61.27c-.177.062-.396.121-.613.121-.217 0-.436-.06-.613-.12a4.525 4.525 0 0 1-.61-.27c-.423-.223-.9-.54-1.351-.933-.876-.763-1.797-1.942-1.797-3.387Z", fill: "currentColor" })] }));
}, Yue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Xue
}), Uue = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.94 12.269a1.79 1.79 0 1 0-2.532 2.532 1.79 1.79 0 0 0 2.533-2.532Zm1.085-1.086a3.326 3.326 0 1 0-4.702 4.704 3.326 3.326 0 0 0 4.703-4.704ZM1 4.837a2.813 2.813 0 0 1 2.814-2.814H5.86a.767.767 0 0 1 0 1.535H3.814c-.707 0-1.28.572-1.28 1.28V8.93a5.372 5.372 0 1 0 10.745 0V4.837c0-.707-.572-1.279-1.279-1.279H9.953a.767.767 0 0 1 0-1.535H12a2.813 2.813 0 0 1 2.814 2.814V8.93A6.907 6.907 0 1 1 1 8.93V4.837Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.907 14.302c.424 0 .767.344.767.768v1.279a5.116 5.116 0 1 0 10.233 0v-.256a.767.767 0 1 1 1.535 0v.256a6.65 6.65 0 1 1-13.302 0v-1.28c0-.423.343-.767.767-.767ZM5.86 1c.424 0 .768.344.768.767v2.047a.767.767 0 1 1-1.535 0V1.767c0-.423.344-.767.767-.767ZM9.953 1c.424 0 .768.344.768.767v2.047a.767.767 0 1 1-1.535 0V1.767c0-.423.344-.767.767-.767Z", fill: "currentColor" })] }));
}, Jue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Uue
}), que = function(e) {
  var r = fe(e.size);
  return Y("svg", ce({}, e, { width: r, height: r, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.175 3.288c.3.3.3.785 0 1.085l-4.267 4.253c-.3.3-.787.3-1.088 0-.3-.3-.3-.785 0-1.084l4.267-4.254c.3-.3.787-.3 1.088 0ZM20.759 5.864c.3.3.301.785.001 1.085l-4.256 4.253c-.3.3-.788.3-1.088.002a.765.765 0 0 1-.002-1.085l4.257-4.254c.3-.3.787-.3 1.088 0Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.379 5.108c.3-.3.787-.3 1.088 0l7.487 7.454c.3.299.3.784 0 1.084-.3.3-.787.3-1.087 0l-7.488-7.453c-.3-.3-.3-.785 0-1.085ZM7.057 16.959c.3.3.3.785 0 1.084l-3.744 3.732c-.3.3-.787.3-1.088 0-.3-.3-.3-.785 0-1.084l3.744-3.732c.3-.3.787-.3 1.088 0ZM6.718 11.744c.3-.3.787-.3 1.087 0l1.498 1.493c.3.3.3.785 0 1.085-.3.299-.788.299-1.088 0l-1.497-1.493c-.3-.3-.3-.785 0-1.085ZM8.964 9.505c.3-.3.787-.3 1.088 0l1.497 1.493c.3.3.3.785 0 1.084-.3.3-.787.3-1.088 0L8.964 10.59c-.3-.3-.3-.785 0-1.084ZM16.02 2.225c.3-.3.788-.3 1.088 0l4.667 4.652c.3.3.3.785 0 1.084-.3.3-.788.3-1.088 0L16.02 3.31c-.3-.3-.3-.785 0-1.084Z", fill: "currentColor" }), m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.964 6.596c.3.3.3.785 0 1.084L6.26 14.364a1.275 1.275 0 0 0 0 1.807l1.648 1.641c.5.5 1.312.5 1.813 0l6.704-6.684c.3-.299.788-.299 1.088 0 .3.3.3.786 0 1.085l-6.705 6.684a2.826 2.826 0 0 1-3.987 0l-1.649-1.64a2.806 2.806 0 0 1 0-3.977l6.705-6.684c.3-.3.787-.3 1.087 0Z", fill: "currentColor" })] }));
}, Kue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: que
});
const Na = (e, r, t, n, o) => n ? e.colors.feedback.error[300] : o ? e.colors.neutral[100] : r && !t ? e.colors.neutral[400] : t ? e.colors.feedback.success[300] : e.colors.neutral[200], yt = (e, r, t) => r ? e.colors.neutral[200] : t ? e.colors.feedback.error[300] : e.colors.neutral[300], Que = process.env.NODE_ENV === "production", e1e = ["top-left", "top-center", "top-right", "bottom-left", "bottom-center", "bottom-right"], Ox = 5, Tn = `margin-top: ${Ox}px;`, Ld = 100, Px = 44, r1e = (e, r) => e || r ? "0 42px 0 16px" : "0 16px 0 16px", t1e = Ne({
  wrapper: (e, {
    fullWidth: r
  }) => M`
    display: flex;
    flex-direction: column;
    width: ${r ? "100%" : "232px"};

    :has(input:disabled) .mantine-Input-rightSection {
      display: flex;
    }
  `,
  container: (e, {
    fullWidth: r
  }) => M`
    position: relative;
    padding: 0;
    width: fit-content;
    height: 44px;
    width: ${r ? "100%" : "232px"};

    ${Tn}

    &:focus-within {
      > fieldset {
        border: 1.5px solid ${e.colors.brand.primary[300]};
      }
    }
  `,
  fieldset: (e, {
    dataEntered: r,
    validated: t,
    error: n,
    label: o,
    disabled: a
  }) => M`
    position: absolute;
    margin: 0;
    padding: 0 12px;
    inset: ${o ? "-5px" : "1px"} 0 0;
    border: 1.5px solid
      ${Na(e, r, t, !!n, a)};
    border-radius: ${e.border.radius.lg};
    cursor: ${a ? "not-allowed" : "initial"};
  `,
  label: (e, {
    disabled: r,
    error: t
  }) => M`
    padding: 0 4px;
    z-index: 1;
    font-family: ${e.typography.label.fontFamily};
    color: ${yt(e, r, t)};
    font-weight: ${e.fontWeights.normal};
    font-size: ${e.fontSizes.sm};
  `,
  input: (e, {
    icon: r,
    validated: t,
    disabled: n,
    error: o
  }) => M`
    padding: ${r1e(r, t)};
    font-family: ${e.typography.label.fontFamily};
    color: ${e.colors.neutral[500]};
    border: none;
    box-sizing: border-box;
    position: absolute;
    height: 46px;
    -webkit-background-clip: text;

    &[type='time']::-webkit-calendar-picker-indicator {
      background: none;
    }

    &[data-invalid] {
      color: ${yt(e, n, o)};

      &::placeholder {
        color: ${yt(e, n, o)};
      }
    }

    &::placeholder {
      color: ${e.colors.neutral[200]};
    }

    &[data-disabled] {
      border-color: ${e.colors.neutral[100]};
      background-color: transparent;
      opacity: 1;

      &::placeholder {
        color: ${e.colors.neutral[200]};
      }
    }
  `,
  error: M`
    display: none;
  `,
  messageError: (e) => M`
    color: ${e.colors.feedback.error[300]};
    font-size: ${e.fontSizes.xs};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    margin-top: 4px;
  `,
  invalid: (e) => M`
    color: ${e.colors.feedback.error[300]};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};

    &::placeholder {
      color: ${e.colors.feedback.error[300]};
    }
  `,
  disabled: (e) => M`
    :disabled {
      border-color: ${e.colors.neutral[100]};
      background-color: transparent;
      opacity: 1;

      &::placeholder {
        color: ${e.colors.neutral[200]};
      }
    }
  `,
  rightSection: (e, {
    validated: r,
    disabled: t
  }) => M`
    pointer-events: none;
    color: ${e.colors.neutral[500]};
    margin-right: ${e.spacing.xxs};
    top: 24px;

    path {
      fill: ${r && !t ? e.colors.feedback.success[300] : e.colors.neutral[200]};
    }
  `
}), n1e = (e) => ({
  microCopy: {
    color: e.colors.neutral[400]
  },
  linkUnderline: {
    color: e.colors.brand.primary[300]
  },
  link: {
    color: e.colors.brand.primary[300]
  },
  label: {
    color: e.colors.neutral[400]
  },
  button: {
    color: e.colors.neutral[400]
  },
  paragraphSmall: {
    color: e.colors.neutral[400]
  },
  paragraphLarge: {
    color: e.colors.neutral[400]
  },
  subheading: {
    color: e.colors.neutral[300]
  },
  headingSmall: {
    color: e.colors.neutral[500]
  },
  headingMedium: {
    color: e.colors.neutral[500]
  },
  headingLarge: {
    color: e.colors.neutral[500]
  },
  headingXLarge: {
    color: e.colors.neutral[500]
  },
  headingDisplay: {
    color: e.colors.neutral[500]
  }
}), o1e = Ne({
  root: (e, {
    variant: r,
    color: t,
    textAlign: n
  }) => M`
    ${e.typography[r]}
    text-align: ${n || "initial"};
    text-decoration: ${r === "linkUnderline" ? "underline" : "none"};
    color: ${t || n1e(e)[r].color};
    cursor: ${r === "linkUnderline" || r === "link" ? "pointer" : "inherit"};
  `
}), Ee = (e, r) => r ? `${e}-${r}` : e, tr = ue((e, r) => {
  const {
    variant: t = "paragraphLarge",
    showOnClarity: n = !1,
    renderAs: o,
    children: a,
    color: i,
    textAlign: l,
    cy: s,
    ...u
  } = e, d = o1e({
    variant: t,
    color: i,
    textAlign: l
  });
  return /* @__PURE__ */ m(o || "p", { ref: r, ...u, "data-cy": Ee("text", s), css: d.root, "data-clarity-mask": !n, children: a });
});
tr.displayName = "Text";
function X9(e, r, t) {
  return e.length + 1 === r.length && r.endsWith(t);
}
function Y9(e, r) {
  if (!r)
    return r;
  var t = String(r).replace(/[^\da-zA-Z\n|]/g, ""), n = e.split(/[^\da-zA-Z\n|]/g).filter(Boolean).map(function(u) {
    return u.length;
  }), o = e.split(/[\da-zA-Z\n|]/g).filter(Boolean), a = o[0], i = o[o.length - 1];
  if (e.startsWith(a)) {
    var l = o.reduce(function(u, d, f) {
      var p = n[f], g = u.value.slice(0, p), h = u.value.slice(p);
      return { result: g ? u.result.concat(d, g) : u.result, value: h };
    }, { result: "", value: t }).result.slice(0, e.length);
    return X9(l, e, i) ? l.concat(i) : l;
  }
  var s = n.reduce(function(u, d, f) {
    var p = o[f] || "", g = "$1" + p + "$2", h = d + u.prevSlice + u.prevSeparator.length, v = new RegExp("(.{" + h + "})(.)");
    return { prevSeparator: p, prevSlice: h, value: u.value.replace(v, g) };
  }, { prevSeparator: "", prevSlice: 0, value: t }).value.slice(0, e.length);
  return X9(s, e, i) ? s.concat(i) : s;
}
function U9(e, r) {
  return r === void 0 ? function(t) {
    return Y9(e, t);
  } : Y9(e, r);
}
const Sx = ue((e, r) => {
  const {
    fullWidth: t = !1,
    icon: n,
    validated: o,
    disabled: a = !1,
    onChange: i,
    error: l,
    label: s,
    onBlur: u,
    name: d,
    mask: f,
    cy: p,
    ...g
  } = e, [h, v] = Se(!1), y = Ve(null);
  Kv(r, () => y.current, [y]);
  const w = t1e({
    fullWidth: t,
    validated: o,
    dataEntered: h,
    disabled: a,
    error: l,
    label: s,
    icon: n
  });
  Fe(() => {
    if (f && y.current) {
      const x = y.current.value, b = U9(f, x.replace(/[ˆa-zA-Z]/g, ""));
      setTimeout(() => {
        y != null && y.current && (y.current.value = b);
      }, 50);
    }
  }, [f]);
  const $ = $e((x) => {
    var _;
    const b = (_ = x == null ? void 0 : x.currentTarget) == null ? void 0 : _.value;
    b || typeof b == "string" && (b != null && b.length) ? v(!0) : v(!1);
    const O = String(b).replace(/[ˆa-zA-Z]/g, "");
    x.currentTarget.value = f ? U9(f, O) : b, i && i(x);
  }, [f, i]), C = () => {
    if (o)
      return /* @__PURE__ */ m(M1, {});
    if (n)
      return typeof n == "string" ? /* @__PURE__ */ m(Pt, { name: n }) : n;
  };
  return /* @__PURE__ */ Y("div", { css: w.wrapper, "data-cy": Ee("input-wrapper", p == null ? void 0 : p.wrapper), children: [
    /* @__PURE__ */ Y("div", { css: w.container, children: [
      /* @__PURE__ */ m("fieldset", { css: w.fieldset, children: s && /* @__PURE__ */ m("legend", { css: w.label, children: /* @__PURE__ */ m("label", { children: s }) }) }),
      /* @__PURE__ */ m(mC, { "aria-label": "input", "data-cy": Ee("input-field", p == null ? void 0 : p.field), disabled: a, variant: "unstyled", styles: w, rightSection: C(), onChange: $, ref: y, onBlur: u, name: d, error: l, "data-clarity-mask": !0, ...g })
    ] }),
    l && /* @__PURE__ */ m(tr, { variant: "microCopy", css: w.messageError, showOnClarity: !0, children: l })
  ] });
});
Sx.displayName = "Input";
const a1e = Ne({
  popper: (e) => M`
    padding-top: ${e.spacing.xxs} !important;

    .MuiAutocomplete-listbox {
      ::-webkit-scrollbar {
        width: 4px;
        background: ${e.colors.neutral[100]};
        border-radius: ${e.spacing.xxs};
      }
      ::-webkit-scrollbar-track {
        background-color: ${e.colors.neutral[100]};
      }
      ::-webkit-scrollbar-thumb {
        background: ${e.colors.neutral[200]};
        border-radius: ${e.spacing.xxs};
      }
    }

    .MuiPaper-root {
      font-family: ${e.typography.label.fontFamily};
      font-size: ${e.fontSizes.sm};
      color: ${e.colors.brand.primary[500]};
      border-radius: ${e.border.radius.lg};
      box-shadow: ${e.shadow.level1};

      .MuiAutocomplete-option {
        padding: ${e.spacing.xxs} ${e.spacing.xs};

        &[aria-selected='true'] {
          background: ${e.colors.brand.primary[100]};
          color: ${e.colors.brand.primary[300]};

          &.Mui-focused {
            background: ${e.colors.brand.primary[100]};
            color: ${e.colors.brand.primary[300]};
          }
        }

        :hover {
          background: ${e.colors.brand.primary[100]};
          color: ${e.colors.brand.primary[300]};
        }

        &.Mui-focused {
          background: ${e.colors.brand.primary[100]};
          color: ${e.colors.brand.primary[300]};
        }
      }
    }
  `
}), Ix = ue((e, r) => {
  const {
    label: t,
    placeholder: n,
    error: o,
    fullWidth: a = !0,
    noOptionsText: i,
    optionLabel: l,
    icon: s,
    getOptionDisabled: u,
    filterOptions: d,
    cy: f,
    ...p
  } = e, g = a1e(), h = ($) => $ && l ? $[l] : $, v = $e(($) => {
    const {
      InputProps: C,
      inputProps: x
    } = $, b = s || (x["aria-expanded"] ? /* @__PURE__ */ m(io, { "aria-label": "arrow up", "data-testid": "arrowUp" }) : /* @__PURE__ */ m(Nn, { "aria-label": "arrow down", "data-testid": "arrowDown" }));
    return /* @__PURE__ */ m("div", { ref: C.ref, children: /* @__PURE__ */ m(Sx, { fullWidth: !0, label: t, icon: b, placeholder: n, error: o, cy: {
      field: Ee("autocomplete-input", f == null ? void 0 : f.input)
    }, ...x }) });
  }, [o, s, t, n, f]), y = $e(($) => /* @__PURE__ */ m(S1, { ...$, css: g.popper }), [g]), w = $e(($, C) => l ? ($ == null ? void 0 : $[l]) === (C == null ? void 0 : C[l]) : $ === C, [l]);
  return /* @__PURE__ */ m(A_, { ref: r, "data-cy": Ee("autocomplete-wrapper", f == null ? void 0 : f.wrapper), fullWidth: a, renderInput: v, noOptionsText: i || "Sem resultados", isOptionEqualToValue: w, getOptionLabel: h, PopperComponent: y, getOptionDisabled: u, filterOptions: d, ...p });
});
Ix.displayName = "Autocomplete";
const i1e = ro`
  from {
    transform:  rotate(0deg);
  }
  to {
    transform:  rotate(360deg);
  }
`, l1e = Ne({
  root: M`
    height: fit-content;
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  spin: (e) => M`
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: ${e.spacing.xxs};

    svg {
      animation: ${i1e} 1.1s infinite linear;
    }
  `
}), J9 = {
  large: 32,
  medium: 24
}, Ex = ({
  text: e,
  styles: r,
  size: t = "medium",
  ref: n,
  ringColor: o,
  spinColor: a,
  cy: i
}) => {
  const l = l1e();
  return /* @__PURE__ */ Y("div", { css: [l.root, r == null ? void 0 : r.root, process.env.NODE_ENV === "production" ? "" : ";label:Loader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], ref: n, children: [
    /* @__PURE__ */ m("div", { css: [l.spin, r == null ? void 0 : r.spinner, process.env.NODE_ENV === "production" ? "" : ";label:Loader;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], "data-cy": Ee("loader-wrapper", i == null ? void 0 : i.wrapper), children: /* @__PURE__ */ Y("svg", { width: J9[t], height: J9[t], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-testid": "loader", children: [
      /* @__PURE__ */ m("path", { opacity: "0.2", fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z", fill: o, "data-testid": "loader-ring" }),
      /* @__PURE__ */ m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 1C11 0.447715 11.4477 0 12 0C18.6274 0 24 5.37258 24 12C24 12.5523 23.5523 13 23 13C22.4477 13 22 12.5523 22 12C22 6.47715 17.5228 2 12 2C11.4477 2 11 1.55228 11 1Z", fill: a, "data-testid": "loader-spin" })
    ] }) }),
    /* @__PURE__ */ m(tr, { renderAs: "div", css: r == null ? void 0 : r.text, cy: Ee("loader-text", i == null ? void 0 : i.text), children: e })
  ] });
}, q9 = (e) => ({
  primary: {
    ringColor: e.colors.brand.primary[100],
    spinColor: e.colors.background.white
  },
  secondary: {
    ringColor: e.colors.brand.primary[200],
    spinColor: e.colors.brand.primary[300]
  },
  tertiary: {
    ringColor: e.colors.brand.primary[200],
    spinColor: e.colors.brand.primary[300]
  },
  tertiaryDanger: {
    ringColor: e.colors.feedback.error[200],
    spinColor: e.colors.feedback.error[300]
  },
  link: {
    ringColor: e.colors.brand.primary[200],
    spinColor: e.colors.brand.primary[300]
  },
  success: {
    ringColor: e.colors.feedback.success[200],
    spinColor: e.colors.feedback.success[300]
  }
}), s1e = Ne({
  root: (e, {
    disabled: r,
    fullWidth: t,
    busy: n,
    hasChildren: o
  }) => M`
    ${e.typography.button};
    width: ${t ? "100%" : "fit-content"};
    height: 44px;
    cursor: pointer;
    border-radius: ${e.border.radius.lg};
    padding: 10px ${e.spacing.xs};
    display: flex;
    flex-direction: row;
    justify-items: center;
    align-items: center;
    justify-content: center;
    gap: ${o ? e.spacing.xxs : 0};
    outline: none;
    cursor: ${n ? "not-allowed" : "pointer"};
    position: relative;
    background-color: transparent;

    &:hover .notification {
      background-color: ${e.colors.brand.primary[400]};
    }

    :active {
      ${r || n ? "" : "transform: scale(0.9);"}
    }

    @media only screen and (max-width: ${e.grid.breakpoint.sm}) {
      height: 48px;
    }
  `,
  primary: (e) => M`
    color: ${e.colors.background.white};
    background-color: ${e.colors.brand.primary[300]};
    border: 2px solid;
    border-color: ${e.colors.brand.primary[300]};

    :hover,
    :focus,
    :active {
      background-color: ${e.colors.brand.primary[400]};
      border-color: ${e.colors.brand.primary[400]};
    }

    :disabled {
      background-color: ${e.colors.neutral[100]};
      border-color: ${e.colors.neutral[100]};
      color: ${e.colors.neutral[400]};
      cursor: not-allowed;
    }
  `,
  secondary: (e) => M`
    color: ${e.colors.brand.primary[300]};
    border: 2px solid;
    border-color: ${e.colors.brand.primary[300]};

    :hover,
    :focus,
    :active {
      background-color: ${e.colors.brand.primary[100]};
      border-color: ${e.colors.brand.primary[400]};
      color: ${e.colors.brand.primary[400]};
    }
    :disabled {
      background-color: transparent;
      border-color: ${e.colors.neutral[100]};
      color: ${e.colors.neutral[400]};
      cursor: not-allowed;
    }
  `,
  tertiary: (e) => M`
    color: ${e.colors.brand.primary[300]};
    border: 2px solid;
    border-color: transparent;

    :hover,
    :focus,
    :active {
      background-color: ${e.colors.brand.primary[100]};
      color: ${e.colors.brand.primary[400]};
    }
    :disabled {
      background-color: transparent;
      color: ${e.colors.neutral[400]};
      cursor: not-allowed;
    }
  `,
  tertiaryDanger: (e) => M`
    color: ${e.colors.feedback.error[300]};
    border: 2px solid;
    border-color: transparent;

    :hover,
    :focus,
    :active {
      background-color: ${e.colors.feedback.error[100]};
      color: ${e.colors.feedback.error[400]};
    }
    :disabled {
      background-color: transparent;
      color: ${e.colors.neutral[400]};
      cursor: not-allowed;
    }
  `,
  link: (e) => M`
    ${e.typography.linkUnderline};
    color: ${e.colors.brand.primary[300]};
    border: none;
    padding: 0;
    height: auto;
    text-decoration: underline;

    &:hover {
      color: ${e.colors.brand.primary[400]};
    }

    :disabled {
      background-color: transparent;
      color: ${e.colors.neutral[300]};
      cursor: not-allowed;
    }
  `,
  success: (e) => M`
    color: ${e.colors.feedback.success[300]};
    border: 2px solid;
    border-color: transparent;

    :hover,
    :focus,
    :active {
      background-color: ${e.colors.feedback.success[100]};
      color: ${e.colors.feedback.success[400]};
    }
    :disabled {
      background-color: transparent;
      color: ${e.colors.neutral[400]};
      cursor: not-allowed;
    }
  `,
  active: (e) => M`
    :after {
      content: '';
      top: 22px;
      left: 0;
      position: absolute;
      height: 4px;
      width: 100%;
      border-radius: ${e.border.radius.xs};
      background-color: ${e.colors.brand.secondary[300]};
    }
  `,
  notification: (e) => M`
    position: absolute;
    top: -12px;
    right: -12px;
    min-width: 24px;
    min-height: 24px;
    border-radius: ${e.border.radius.full};
    outline: 2px solid ${e.colors.background.white};
    background-color: ${e.colors.brand.primary[300]};
    padding: 0 ${e.spacing.xxs};
    span {
      color: ${e.colors.background.white};
    }
    display: flex;
    justify-content: center;
    align-items: center;
  `
}), st = ue((e, r) => {
  const {
    disabled: t,
    children: n,
    variant: o = "primary",
    leftIcon: a,
    rightIcon: i,
    busy: l,
    id: s,
    fullWidth: u = !1,
    onClick: d,
    cy: f,
    ...p
  } = e, g = ke(s), h = ur(), v = s1e({
    disabled: t,
    fullWidth: u,
    busy: l,
    hasChildren: !!n
  }), y = (e == null ? void 0 : e.variant) === "secondary" && typeof (e == null ? void 0 : e.notification) == "number" && (e == null ? void 0 : e.notification) > 0;
  return /* @__PURE__ */ Y("button", { disabled: t, css: [v.root, v[o], process.env.NODE_ENV === "production" ? "" : ";label:Button;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], id: g, tabIndex: 0, ref: r, onClick: l ? null : d, "data-cy": Ee("button", f), ...p, children: [
    a && !l && /* @__PURE__ */ m(Pt, { name: a }),
    l && /* @__PURE__ */ m(Ex, { ringColor: q9(h)[o].ringColor, spinColor: q9(h)[o].spinColor }),
    y && /* @__PURE__ */ m("div", { css: v.notification, className: "notification", children: /* @__PURE__ */ m(tr, { variant: "microCopy", renderAs: "span", children: (e == null ? void 0 : e.variant) === "secondary" && (e == null ? void 0 : e.notification) }) }),
    /* @__PURE__ */ m("span", { children: n }),
    i && /* @__PURE__ */ m(Pt, { name: i })
  ] });
});
st.displayName = "Button";
const Rx = (e) => M`
  border: 1px solid ${e.colors.feedback.error[300]};

  :hover {
    border: 1px solid ${e.colors.feedback.error[400]};
  }

  &:checked {
    border: 1px solid ${e.colors.feedback.error[300]};
    background-color: ${e.colors.feedback.error[300]};

    :hover {
      border: 1px solid ${e.colors.feedback.error[400]};
      background-color: ${e.colors.feedback.error[400]};
    }
  }
`, c1e = Ne({
  root: (e, {
    hasError: r
  }) => M`
    & .mantine-Group-root {
      padding-top: 0px;
    }

    & .mantine-Checkbox-input {
      ${r && Rx(e)}
    }
  `,
  wrapperGroup: (e, {
    orientation: r
  }) => M`
    display: flex;
    gap: ${e.spacing.xs};
    flex-direction: ${r === "horizontal" ? "row" : "column"};
  `,
  error: (e) => M`
    ${e.typography.microCopy};
    color: ${e.colors.feedback.error[300]};
    margin-top: ${e.spacing.xxs};
  `
}), Ax = ue(({
  children: e,
  id: r,
  orientation: t = "horizontal",
  error: n,
  cy: o,
  ...a
}, i) => {
  const l = c1e({
    orientation: t,
    hasError: !!n
  }), s = ke(r);
  return /* @__PURE__ */ m(w1.Group, { id: s, styles: l, error: n, ...a, ref: i, "data-cy": Ee("checkbox-group", o), children: /* @__PURE__ */ m("div", { css: l.wrapperGroup, children: e }) });
});
Ax.displayName = "Checkbox.Group";
const u1e = Ne({
  root: (e) => M`
    :has(input:disabled) label {
      color: ${e.colors.neutral[200]};

      svg {
        color: ${e.colors.neutral[100]};
      }
    }
  `,
  inner: M`
    display: flex;
    align-items: center;
  `,
  input: (e, {
    error: r
  }) => M`
    border: 1px solid ${e.colors.brand.primary[300]};
    border-radius: ${e.border.radius.xs};
    height: 18px;
    width: 18px;
    cursor: pointer;

    :hover {
      border: 1px solid ${e.colors.brand.primary[400]};
    }

    :disabled {
      border: 1px solid ${e.colors.neutral[200]};
      background-color: transparent;
    }

    :disabled + .__mantine-ref-icon {
      color: ${e.colors.neutral[100]};
    }

    :checked {
      border: 1px solid ${e.colors.brand.primary[300]};
      background-color: ${e.colors.brand.primary[300]};

      :hover {
        border: 1px solid ${e.colors.brand.primary[400]};
        background-color: ${e.colors.brand.primary[400]};
      }

      :disabled {
        border-color: ${e.colors.neutral[200]};
        background-color: ${e.colors.neutral[200]};
      }
    }

    ${r && Rx(e)}
  `,
  icon: (e, {
    indeterminate: r
  }) => M`
    width: 18px;
    border-radius: ${e.border.radius.xs};
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 12px;
      color: ${e.colors.neutral[100]};
    }

    ${r && M`
      svg {
        width: 8px;
        height: 1px;
        color: ${e.colors.neutral[100]};
      }
    `}
  `,
  label: (e) => M`
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    font-size: ${e.fontSizes.sm};
    color: ${e.colors.neutral[400]};
    cursor: pointer;

    &[data-disabled='true'] {
      color: ${e.colors.neutral[200]};
    }
  `
}), b2 = ue((e, r) => {
  const {
    indeterminate: t,
    disabled: n,
    id: o,
    error: a,
    cy: i,
    ...l
  } = e, s = u1e({
    indeterminate: t,
    disabled: n,
    error: a
  }), u = ke(o), d = $e(({
    indeterminate: f,
    className: p
  }) => /* @__PURE__ */ m("div", { className: p, children: f ? /* @__PURE__ */ m(ux, { size: "small", "data-testid": "minusIcon", "aria-label": "indeterminate icon" }) : /* @__PURE__ */ m(M1, { size: "small", "data-testid": "checkIcon", "aria-label": "checked icon" }) }), []);
  return /* @__PURE__ */ m(w1, { id: u, ref: r, icon: d, styles: s, disabled: n, indeterminate: t, ...l, "data-cy": Ee("checkbox", i), "data-clarity-mask": !0 });
});
b2.displayName = "Checkbox";
b2.Group = Ax;
const d1e = Ne({
  root: (e, {
    disabled: r
  }) => M`
    width: fit-content;
    height: 40px;
    padding: ${e.spacing.xxs} ${e.spacing.xs};
    border-radius: ${e.border.radius.full};
    gap: ${e.border.radius.lg};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: ${r ? "not-allowed" : "pointer"};
    user-select: none;
    background-color: ${e.colors.background.white};
    border: 1px solid ${e.colors.neutral[200]};

    svg path {
      fill: ${e.colors.neutral[200]};
    }
    div {
      color: ${e.colors.brand.primary[500]};
      margin: 0;
    }

    :hover {
      background-color: ${e.colors.background.white};
      border-color: ${e.colors.brand.primary[300]};
      svg path {
        fill: ${e.colors.brand.primary[300]};
      }
      div {
        color: ${e.colors.brand.primary[300]};
      }
    }
  `,
  label: M`
    max-width: fit-content;
  `,
  input: (e) => M`
    visibility: hidden;
    position: absolute;
    top: 0;
    right: 0;
    &:checked {
      & + .hero-chip__body {
        background-color: ${e.colors.brand.primary[100]};
        border-color: ${e.colors.brand.primary[300]};
        svg path {
          fill: ${e.colors.brand.primary[300]};
        }
        div {
          color: ${e.colors.brand.primary[300]};
        }
      }
    }
    &:disabled {
      & + .hero-chip__body {
        background-color: ${e.colors.neutral[100]};
        border-color: ${e.colors.neutral[100]};
        svg path {
          fill: ${e.colors.neutral[200]};
        }
        div {
          color: ${e.colors.neutral[300]};
        }
      }
    }
  `
}), kx = ue((e, r) => {
  const {
    children: t,
    style: n,
    leftIcon: o,
    rightIcon: a,
    disabled: i,
    id: l,
    name: s,
    value: u,
    cy: d,
    ...f
  } = e, p = ke(l), g = d1e({
    disabled: i
  });
  return /* @__PURE__ */ Y("label", { css: g.label, htmlFor: p, tabIndex: 0, children: [
    /* @__PURE__ */ m("input", { ...f, disabled: i, id: p, ref: r, type: "checkbox", css: g.input, "data-testid": "hero-chip", name: s, role: "checkbox", value: u, "data-cy": Ee("chip", d) }),
    /* @__PURE__ */ Y("div", { className: "hero-chip__body", "data-testid": "hero-chip-body", css: g.root, style: n, children: [
      o && /* @__PURE__ */ m(Pt, { size: "small", name: o }),
      /* @__PURE__ */ m(tr, { renderAs: "div", variant: "label", "data-testid": "hero-chip-label", children: t }),
      a && /* @__PURE__ */ m(Pt, { size: "small", name: a })
    ] })
  ] });
});
kx.displayName = "Chip";
var f1e = Object.defineProperty, p1e = Object.defineProperties, g1e = Object.getOwnPropertyDescriptors, Cu = Object.getOwnPropertySymbols, Mx = Object.prototype.hasOwnProperty, Nx = Object.prototype.propertyIsEnumerable, K9 = (e, r, t) => r in e ? f1e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Q9 = (e, r) => {
  for (var t in r || (r = {}))
    Mx.call(r, t) && K9(e, t, r[t]);
  if (Cu)
    for (var t of Cu(r))
      Nx.call(r, t) && K9(e, t, r[t]);
  return e;
}, ev = (e, r) => p1e(e, g1e(r)), v1e = (e, r) => {
  var t = {};
  for (var n in e)
    Mx.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Cu)
    for (var n of Cu(e))
      r.indexOf(n) < 0 && Nx.call(e, n) && (t[n] = e[n]);
  return t;
};
function W0(e) {
  var r = e, { direction: t, style: n } = r, o = v1e(r, ["direction", "style"]);
  const a = ft();
  return /* @__PURE__ */ E.createElement(oT, ev(Q9({}, o), {
    style: ev(Q9({}, n), {
      transform: t === "next" && a.dir === "ltr" || t === "previous" && a.dir === "rtl" ? "rotate(270deg)" : "rotate(90deg)"
    })
  }));
}
W0.displayName = "@mantine/dates/Chevron";
var m1e = Object.defineProperty, h1e = Object.defineProperties, b1e = Object.getOwnPropertyDescriptors, rv = Object.getOwnPropertySymbols, y1e = Object.prototype.hasOwnProperty, C1e = Object.prototype.propertyIsEnumerable, tv = (e, r, t) => r in e ? m1e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Sl = (e, r) => {
  for (var t in r || (r = {}))
    y1e.call(r, t) && tv(e, t, r[t]);
  if (rv)
    for (var t of rv(r))
      C1e.call(r, t) && tv(e, t, r[t]);
  return e;
}, nv = (e, r) => h1e(e, b1e(r));
const wi = {
  xs: B(30),
  sm: B(36),
  md: B(42),
  lg: B(48),
  xl: B(54)
};
var w1e = Ae((e, { radius: r, isStatic: t }, { size: n }) => {
  const o = e.fn.variant({ variant: "filled" }), a = e.fn.variant({ variant: "light" });
  return {
    day: nv(Sl({
      width: ve({ size: n, sizes: wi }),
      height: ve({ size: n, sizes: wi }),
      fontSize: ve({ size: n, sizes: e.fontSizes }),
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      userSelect: t ? void 0 : "none",
      cursor: t ? "default" : "pointer",
      borderRadius: e.fn.radius(r)
    }, t ? null : e.fn.hover({
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[0]
    })), {
      "&:active": t ? void 0 : e.activeStyles,
      "&[data-disabled]": nv(Sl({
        color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[4],
        cursor: "not-allowed"
      }, e.fn.hover({ backgroundColor: "transparent" })), {
        "&:active": {
          transform: "none"
        }
      }),
      "&[data-weekend]": {
        color: e.colors.red[e.fn.primaryShade()]
      },
      "&[data-outside]": {
        color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[4]
      },
      "&[data-in-range]": Sl({
        backgroundColor: a.background,
        borderRadius: 0
      }, t ? null : e.fn.hover({ backgroundColor: a.hover })),
      "&[data-first-in-range]": {
        borderTopLeftRadius: e.radius.sm,
        borderBottomLeftRadius: e.radius.sm
      },
      "&[data-last-in-range]": {
        borderTopRightRadius: e.radius.sm,
        borderBottomRightRadius: e.radius.sm
      },
      "&[data-selected]": Sl({
        color: o.color,
        backgroundColor: o.background
      }, t ? null : e.fn.hover({ backgroundColor: o.hover })),
      "&[data-hidden]": {
        display: "none"
      }
    })
  };
});
const _1e = w1e;
var x1e = Object.defineProperty, $1e = Object.defineProperties, O1e = Object.getOwnPropertyDescriptors, ov = Object.getOwnPropertySymbols, P1e = Object.prototype.hasOwnProperty, S1e = Object.prototype.propertyIsEnumerable, av = (e, r, t) => r in e ? x1e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Il = (e, r) => {
  for (var t in r || (r = {}))
    P1e.call(r, t) && av(e, t, r[t]);
  if (ov)
    for (var t of ov(r))
      S1e.call(r, t) && av(e, t, r[t]);
  return e;
}, El = (e, r) => $1e(e, O1e(r)), I1e = Ae((e, r, { size: t }) => {
  const n = ve({ size: t, sizes: wi });
  return {
    calendarHeaderControlIcon: {},
    calendarHeader: {
      display: "flex",
      maxWidth: `calc(${n} * 7 + ${B(7)})`
    },
    calendarHeaderControl: El(Il({
      width: n,
      height: n,
      borderRadius: e.fn.radius(),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      userSelect: "none"
    }, e.fn.hover({
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[0]
    })), {
      "&:active": e.activeStyles,
      "&[data-disabled]": El(Il({
        opacity: 0.2,
        cursor: "not-allowed"
      }, e.fn.hover({ backgroundColor: "transparent" })), {
        "&:active": {
          transform: "none"
        }
      })
    }),
    calendarHeaderLevel: El(Il({
      height: n,
      borderRadius: e.fn.radius(),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      userSelect: "none",
      flex: 1,
      fontSize: ve({ size: t, sizes: e.fontSizes }),
      fontWeight: 500,
      textTransform: "capitalize"
    }, e.fn.hover({
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[0]
    })), {
      "&:active": e.activeStyles,
      "&[data-static]": El(Il({
        cursor: "default",
        userSelect: "unset"
      }, e.fn.hover({ backgroundColor: "transparent" })), {
        "&:active": {
          transform: "none"
        }
      })
    })
  };
}), E1e = Object.defineProperty, wu = Object.getOwnPropertySymbols, Tx = Object.prototype.hasOwnProperty, Dx = Object.prototype.propertyIsEnumerable, iv = (e, r, t) => r in e ? E1e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, R1e = (e, r) => {
  for (var t in r || (r = {}))
    Tx.call(r, t) && iv(e, t, r[t]);
  if (wu)
    for (var t of wu(r))
      Dx.call(r, t) && iv(e, t, r[t]);
  return e;
}, A1e = (e, r) => {
  var t = {};
  for (var n in e)
    Tx.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && wu)
    for (var n of wu(e))
      r.indexOf(n) < 0 && Dx.call(e, n) && (t[n] = e[n]);
  return t;
};
const k1e = {
  nextDisabled: !1,
  previousDisabled: !1,
  hasNextLevel: !0,
  withNext: !0,
  withPrevious: !0,
  size: "sm"
}, T1 = ue((e, r) => {
  const t = Oe("CalendarHeader", k1e, e), {
    className: n,
    nextIcon: o,
    previousIcon: a,
    nextLabel: i,
    previousLabel: l,
    onNext: s,
    onPrevious: u,
    onLevelClick: d,
    label: f,
    classNames: p,
    styles: g,
    unstyled: h,
    nextDisabled: v,
    previousDisabled: y,
    hasNextLevel: w,
    levelControlAriaLabel: $,
    withNext: C,
    withPrevious: x,
    __staticSelector: b,
    __preventFocus: O,
    __stopPropagation: _,
    size: P,
    variant: S
  } = t, I = A1e(t, [
    "className",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "onLevelClick",
    "label",
    "classNames",
    "styles",
    "unstyled",
    "nextDisabled",
    "previousDisabled",
    "hasNextLevel",
    "levelControlAriaLabel",
    "withNext",
    "withPrevious",
    "__staticSelector",
    "__preventFocus",
    "__stopPropagation",
    "size",
    "variant"
  ]), { classes: N, cx: k } = I1e(null, {
    name: ["CalendarHeader", b],
    classNames: p,
    styles: g,
    unstyled: h,
    size: P,
    variant: S
  }), j = O ? (R) => R.preventDefault() : void 0;
  return /* @__PURE__ */ E.createElement(We, R1e({
    className: k(N.calendarHeader, n),
    ref: r
  }, I), x && /* @__PURE__ */ E.createElement($o, {
    className: N.calendarHeaderControl,
    "data-previous": !0,
    "aria-label": l,
    onClick: u,
    unstyled: h,
    onMouseDown: j,
    disabled: y,
    "data-disabled": y || void 0,
    tabIndex: O ? -1 : 0,
    "data-mantine-stop-propagation": _ || void 0
  }, a || /* @__PURE__ */ E.createElement(W0, {
    className: N.calendarHeaderControlIcon,
    direction: "previous",
    "data-previous": !0
  })), /* @__PURE__ */ E.createElement($o, {
    component: w ? "button" : "div",
    className: N.calendarHeaderLevel,
    onClick: w ? d : void 0,
    unstyled: h,
    onMouseDown: w ? j : void 0,
    disabled: !w,
    "data-static": !w || void 0,
    "aria-label": $,
    tabIndex: O || !w ? -1 : 0,
    "data-mantine-stop-propagation": _ || void 0
  }, f), C && /* @__PURE__ */ E.createElement($o, {
    className: N.calendarHeaderControl,
    "data-next": !0,
    "aria-label": i,
    onClick: s,
    unstyled: h,
    onMouseDown: j,
    disabled: v,
    "data-disabled": v || void 0,
    tabIndex: O ? -1 : 0,
    "data-mantine-stop-propagation": _ || void 0
  }, o || /* @__PURE__ */ E.createElement(W0, {
    className: N.calendarHeaderControlIcon,
    direction: "next",
    "data-next": !0
  })));
});
T1.displayName = "@mantine/dates/CalendarHeader";
var jx = { exports: {} };
(function(e, r) {
  (function(t, n) {
    e.exports = n();
  })(Mo, function() {
    var t = 1e3, n = 6e4, o = 36e5, a = "millisecond", i = "second", l = "minute", s = "hour", u = "day", d = "week", f = "month", p = "quarter", g = "year", h = "date", v = "Invalid Date", y = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, w = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, $ = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(R) {
      var D = ["th", "st", "nd", "rd"], T = R % 100;
      return "[" + R + (D[(T - 20) % 10] || D[T] || D[0]) + "]";
    } }, C = function(R, D, T) {
      var V = String(R);
      return !V || V.length >= D ? R : "" + Array(D + 1 - V.length).join(T) + R;
    }, x = { s: C, z: function(R) {
      var D = -R.utcOffset(), T = Math.abs(D), V = Math.floor(T / 60), L = T % 60;
      return (D <= 0 ? "+" : "-") + C(V, 2, "0") + ":" + C(L, 2, "0");
    }, m: function R(D, T) {
      if (D.date() < T.date())
        return -R(T, D);
      var V = 12 * (T.year() - D.year()) + (T.month() - D.month()), L = D.clone().add(V, f), Z = T - L < 0, z = D.clone().add(V + (Z ? -1 : 1), f);
      return +(-(V + (T - L) / (Z ? L - z : z - L)) || 0);
    }, a: function(R) {
      return R < 0 ? Math.ceil(R) || 0 : Math.floor(R);
    }, p: function(R) {
      return { M: f, y: g, w: d, d: u, D: h, h: s, m: l, s: i, ms: a, Q: p }[R] || String(R || "").toLowerCase().replace(/s$/, "");
    }, u: function(R) {
      return R === void 0;
    } }, b = "en", O = {};
    O[b] = $;
    var _ = "$isDayjsObject", P = function(R) {
      return R instanceof k || !(!R || !R[_]);
    }, S = function R(D, T, V) {
      var L;
      if (!D)
        return b;
      if (typeof D == "string") {
        var Z = D.toLowerCase();
        O[Z] && (L = Z), T && (O[Z] = T, L = Z);
        var z = D.split("-");
        if (!L && z.length > 1)
          return R(z[0]);
      } else {
        var W = D.name;
        O[W] = D, L = W;
      }
      return !V && L && (b = L), L || !V && b;
    }, I = function(R, D) {
      if (P(R))
        return R.clone();
      var T = typeof D == "object" ? D : {};
      return T.date = R, T.args = arguments, new k(T);
    }, N = x;
    N.l = S, N.i = P, N.w = function(R, D) {
      return I(R, { locale: D.$L, utc: D.$u, x: D.$x, $offset: D.$offset });
    };
    var k = function() {
      function R(T) {
        this.$L = S(T.locale, null, !0), this.parse(T), this.$x = this.$x || T.x || {}, this[_] = !0;
      }
      var D = R.prototype;
      return D.parse = function(T) {
        this.$d = function(V) {
          var L = V.date, Z = V.utc;
          if (L === null)
            return /* @__PURE__ */ new Date(NaN);
          if (N.u(L))
            return /* @__PURE__ */ new Date();
          if (L instanceof Date)
            return new Date(L);
          if (typeof L == "string" && !/Z$/i.test(L)) {
            var z = L.match(y);
            if (z) {
              var W = z[2] - 1 || 0, U = (z[7] || "0").substring(0, 3);
              return Z ? new Date(Date.UTC(z[1], W, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, U)) : new Date(z[1], W, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, U);
            }
          }
          return new Date(L);
        }(T), this.init();
      }, D.init = function() {
        var T = this.$d;
        this.$y = T.getFullYear(), this.$M = T.getMonth(), this.$D = T.getDate(), this.$W = T.getDay(), this.$H = T.getHours(), this.$m = T.getMinutes(), this.$s = T.getSeconds(), this.$ms = T.getMilliseconds();
      }, D.$utils = function() {
        return N;
      }, D.isValid = function() {
        return this.$d.toString() !== v;
      }, D.isSame = function(T, V) {
        var L = I(T);
        return this.startOf(V) <= L && L <= this.endOf(V);
      }, D.isAfter = function(T, V) {
        return I(T) < this.startOf(V);
      }, D.isBefore = function(T, V) {
        return this.endOf(V) < I(T);
      }, D.$g = function(T, V, L) {
        return N.u(T) ? this[V] : this.set(L, T);
      }, D.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, D.valueOf = function() {
        return this.$d.getTime();
      }, D.startOf = function(T, V) {
        var L = this, Z = !!N.u(V) || V, z = N.p(T), W = function(te, ae) {
          var ge = N.w(L.$u ? Date.UTC(L.$y, ae, te) : new Date(L.$y, ae, te), L);
          return Z ? ge : ge.endOf(u);
        }, U = function(te, ae) {
          return N.w(L.toDate()[te].apply(L.toDate("s"), (Z ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ae)), L);
        }, re = this.$W, X = this.$M, J = this.$D, Q = "set" + (this.$u ? "UTC" : "");
        switch (z) {
          case g:
            return Z ? W(1, 0) : W(31, 11);
          case f:
            return Z ? W(1, X) : W(0, X + 1);
          case d:
            var se = this.$locale().weekStart || 0, q = (re < se ? re + 7 : re) - se;
            return W(Z ? J - q : J + (6 - q), X);
          case u:
          case h:
            return U(Q + "Hours", 0);
          case s:
            return U(Q + "Minutes", 1);
          case l:
            return U(Q + "Seconds", 2);
          case i:
            return U(Q + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, D.endOf = function(T) {
        return this.startOf(T, !1);
      }, D.$set = function(T, V) {
        var L, Z = N.p(T), z = "set" + (this.$u ? "UTC" : ""), W = (L = {}, L[u] = z + "Date", L[h] = z + "Date", L[f] = z + "Month", L[g] = z + "FullYear", L[s] = z + "Hours", L[l] = z + "Minutes", L[i] = z + "Seconds", L[a] = z + "Milliseconds", L)[Z], U = Z === u ? this.$D + (V - this.$W) : V;
        if (Z === f || Z === g) {
          var re = this.clone().set(h, 1);
          re.$d[W](U), re.init(), this.$d = re.set(h, Math.min(this.$D, re.daysInMonth())).$d;
        } else
          W && this.$d[W](U);
        return this.init(), this;
      }, D.set = function(T, V) {
        return this.clone().$set(T, V);
      }, D.get = function(T) {
        return this[N.p(T)]();
      }, D.add = function(T, V) {
        var L, Z = this;
        T = Number(T);
        var z = N.p(V), W = function(X) {
          var J = I(Z);
          return N.w(J.date(J.date() + Math.round(X * T)), Z);
        };
        if (z === f)
          return this.set(f, this.$M + T);
        if (z === g)
          return this.set(g, this.$y + T);
        if (z === u)
          return W(1);
        if (z === d)
          return W(7);
        var U = (L = {}, L[l] = n, L[s] = o, L[i] = t, L)[z] || 1, re = this.$d.getTime() + T * U;
        return N.w(re, this);
      }, D.subtract = function(T, V) {
        return this.add(-1 * T, V);
      }, D.format = function(T) {
        var V = this, L = this.$locale();
        if (!this.isValid())
          return L.invalidDate || v;
        var Z = T || "YYYY-MM-DDTHH:mm:ssZ", z = N.z(this), W = this.$H, U = this.$m, re = this.$M, X = L.weekdays, J = L.months, Q = L.meridiem, se = function(ae, ge, G, oe) {
          return ae && (ae[ge] || ae(V, Z)) || G[ge].slice(0, oe);
        }, q = function(ae) {
          return N.s(W % 12 || 12, ae, "0");
        }, te = Q || function(ae, ge, G) {
          var oe = ae < 12 ? "AM" : "PM";
          return G ? oe.toLowerCase() : oe;
        };
        return Z.replace(w, function(ae, ge) {
          return ge || function(G) {
            switch (G) {
              case "YY":
                return String(V.$y).slice(-2);
              case "YYYY":
                return N.s(V.$y, 4, "0");
              case "M":
                return re + 1;
              case "MM":
                return N.s(re + 1, 2, "0");
              case "MMM":
                return se(L.monthsShort, re, J, 3);
              case "MMMM":
                return se(J, re);
              case "D":
                return V.$D;
              case "DD":
                return N.s(V.$D, 2, "0");
              case "d":
                return String(V.$W);
              case "dd":
                return se(L.weekdaysMin, V.$W, X, 2);
              case "ddd":
                return se(L.weekdaysShort, V.$W, X, 3);
              case "dddd":
                return X[V.$W];
              case "H":
                return String(W);
              case "HH":
                return N.s(W, 2, "0");
              case "h":
                return q(1);
              case "hh":
                return q(2);
              case "a":
                return te(W, U, !0);
              case "A":
                return te(W, U, !1);
              case "m":
                return String(U);
              case "mm":
                return N.s(U, 2, "0");
              case "s":
                return String(V.$s);
              case "ss":
                return N.s(V.$s, 2, "0");
              case "SSS":
                return N.s(V.$ms, 3, "0");
              case "Z":
                return z;
            }
            return null;
          }(ae) || z.replace(":", "");
        });
      }, D.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, D.diff = function(T, V, L) {
        var Z, z = this, W = N.p(V), U = I(T), re = (U.utcOffset() - this.utcOffset()) * n, X = this - U, J = function() {
          return N.m(z, U);
        };
        switch (W) {
          case g:
            Z = J() / 12;
            break;
          case f:
            Z = J();
            break;
          case p:
            Z = J() / 3;
            break;
          case d:
            Z = (X - re) / 6048e5;
            break;
          case u:
            Z = (X - re) / 864e5;
            break;
          case s:
            Z = X / o;
            break;
          case l:
            Z = X / n;
            break;
          case i:
            Z = X / t;
            break;
          default:
            Z = X;
        }
        return L ? Z : N.a(Z);
      }, D.daysInMonth = function() {
        return this.endOf(f).$D;
      }, D.$locale = function() {
        return O[this.$L];
      }, D.locale = function(T, V) {
        if (!T)
          return this.$L;
        var L = this.clone(), Z = S(T, V, !0);
        return Z && (L.$L = Z), L;
      }, D.clone = function() {
        return N.w(this.$d, this);
      }, D.toDate = function() {
        return new Date(this.valueOf());
      }, D.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, D.toISOString = function() {
        return this.$d.toISOString();
      }, D.toString = function() {
        return this.$d.toUTCString();
      }, R;
    }(), j = k.prototype;
    return I.prototype = j, [["$ms", a], ["$s", i], ["$m", l], ["$H", s], ["$W", u], ["$M", f], ["$y", g], ["$D", h]].forEach(function(R) {
      j[R[1]] = function(D) {
        return this.$g(D, R[0], R[1]);
      };
    }), I.extend = function(R, D) {
      return R.$i || (R(D, k, I), R.$i = !0), I;
    }, I.locale = S, I.isDayjs = P, I.unix = function(R) {
      return I(1e3 * R);
    }, I.en = O[b], I.Ls = O, I.p = {}, I;
  });
})(jx);
var Lx = jx.exports;
const je = /* @__PURE__ */ Qn(Lx);
function zd(e, r) {
  return e ? e === "month" ? 0 : e === "year" ? 1 : 2 : r;
}
function M1e(e) {
  return e === 0 ? "month" : e === 1 ? "year" : "decade";
}
function ri(e, r, t) {
  return M1e(Co(zd(e, 0), zd(r, 0), zd(t, 2)));
}
var N1e = Ae(() => ({
  calendar: {}
})), T1e = Ae((e, r, { size: t }) => ({
  monthLevelGroup: {
    display: "flex",
    "& [data-month-level]:not(:last-of-type)": {
      marginRight: ve({ size: t, sizes: e.spacing })
    }
  }
})), D1e = Ae((e) => ({
  monthLevel: {},
  calendarHeader: {
    marginBottom: e.spacing.xs
  }
}));
const j1e = {
  locale: "en",
  firstDayOfWeek: 1,
  weekendDays: [0, 6],
  labelSeparator: "–"
}, L1e = xt(j1e);
var z1e = Object.defineProperty, V1e = Object.defineProperties, F1e = Object.getOwnPropertyDescriptors, lv = Object.getOwnPropertySymbols, Z1e = Object.prototype.hasOwnProperty, W1e = Object.prototype.propertyIsEnumerable, sv = (e, r, t) => r in e ? z1e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, B1e = (e, r) => {
  for (var t in r || (r = {}))
    Z1e.call(r, t) && sv(e, t, r[t]);
  if (lv)
    for (var t of lv(r))
      W1e.call(r, t) && sv(e, t, r[t]);
  return e;
}, H1e = (e, r) => V1e(e, F1e(r));
function Dn() {
  const e = dt(L1e), r = $e((a) => a || e.locale, [e.locale]), t = $e((a) => typeof a == "number" ? a : e.firstDayOfWeek, [e.firstDayOfWeek]), n = $e((a) => Array.isArray(a) ? a : e.weekendDays, [e.weekendDays]), o = $e((a) => typeof a == "string" ? a : e.labelSeparator, [e.labelSeparator]);
  return H1e(B1e({}, e), {
    getLocale: r,
    getFirstDayOfWeek: t,
    getWeekendDays: n,
    getLabelSeparator: o
  });
}
function G1e(e, r = 1) {
  const t = new Date(e);
  for (; t.getDay() !== r; )
    t.setDate(t.getDate() - 1);
  return t;
}
function X1e(e, r = 1) {
  const t = new Date(e), n = r === 0 ? 6 : r - 1;
  for (; t.getDay() !== n; )
    t.setDate(t.getDate() + 1);
  return t;
}
function Y1e(e, r = 1) {
  const t = e.getMonth(), n = new Date(e.getFullYear(), t, 1), o = new Date(e.getFullYear(), e.getMonth() + 1, 0), a = X1e(o, r), i = G1e(n, r), l = [];
  for (; i <= a; ) {
    const s = [];
    for (let u = 0; u < 7; u += 1)
      s.push(new Date(i)), i.setDate(i.getDate() + 1);
    l.push(s);
  }
  return l;
}
function zx(e, r) {
  return e.getFullYear() === r.getFullYear() && e.getMonth() === r.getMonth();
}
function Vx(e, r) {
  return r instanceof Date ? je(e).isBefore(je(r).add(1, "day"), "day") : !0;
}
function Fx(e, r) {
  return r instanceof Date ? je(e).isAfter(je(r).subtract(1, "day"), "day") : !0;
}
var U1e = Object.defineProperty, J1e = Object.defineProperties, q1e = Object.getOwnPropertyDescriptors, cv = Object.getOwnPropertySymbols, K1e = Object.prototype.hasOwnProperty, Q1e = Object.prototype.propertyIsEnumerable, uv = (e, r, t) => r in e ? U1e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ede = (e, r) => {
  for (var t in r || (r = {}))
    K1e.call(r, t) && uv(e, t, r[t]);
  if (cv)
    for (var t of cv(r))
      Q1e.call(r, t) && uv(e, t, r[t]);
  return e;
}, rde = (e, r) => J1e(e, q1e(r)), tde = Ae((e) => ({
  monthThead: {},
  monthRow: {},
  monthTbody: {},
  monthCell: {
    padding: 0,
    "&[data-with-spacing]": {
      padding: B(0.5)
    }
  },
  month: rde(ede({}, e.fn.fontStyles()), {
    borderCollapse: "collapse",
    tableLayout: "fixed",
    "& *": {
      boxSizing: "border-box"
    }
  })
}));
function nde(e, r, t, n, o, a, i) {
  const l = e.flat().filter((d) => {
    var f;
    return Vx(d, t) && Fx(d, r) && !(o != null && o(d)) && !((f = n == null ? void 0 : n(d)) != null && f.disabled) && (!a || zx(d, i));
  }), s = l.find((d) => {
    var f;
    return (f = n == null ? void 0 : n(d)) == null ? void 0 : f.selected;
  });
  if (s)
    return s;
  const u = l.find((d) => je().isSame(d, "date"));
  return u || l[0];
}
var ode = Object.defineProperty, _u = Object.getOwnPropertySymbols, Zx = Object.prototype.hasOwnProperty, Wx = Object.prototype.propertyIsEnumerable, dv = (e, r, t) => r in e ? ode(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ade = (e, r) => {
  for (var t in r || (r = {}))
    Zx.call(r, t) && dv(e, t, r[t]);
  if (_u)
    for (var t of _u(r))
      Wx.call(r, t) && dv(e, t, r[t]);
  return e;
}, ide = (e, r) => {
  var t = {};
  for (var n in e)
    Zx.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && _u)
    for (var n of _u(e))
      r.indexOf(n) < 0 && Wx.call(e, n) && (t[n] = e[n]);
  return t;
};
const lde = {
  tabIndex: 0,
  size: "sm"
}, Bx = ue((e, r) => {
  const t = Oe("Day", lde, e), {
    className: n,
    date: o,
    radius: a,
    disabled: i,
    styles: l,
    classNames: s,
    unstyled: u,
    __staticSelector: d,
    weekend: f,
    outside: p,
    selected: g,
    renderDay: h,
    inRange: v,
    firstInRange: y,
    lastInRange: w,
    hidden: $,
    static: C,
    variant: x,
    size: b
  } = t, O = ide(t, [
    "className",
    "date",
    "radius",
    "disabled",
    "styles",
    "classNames",
    "unstyled",
    "__staticSelector",
    "weekend",
    "outside",
    "selected",
    "renderDay",
    "inRange",
    "firstInRange",
    "lastInRange",
    "hidden",
    "static",
    "variant",
    "size"
  ]), { classes: _, cx: P } = _1e({ radius: a, isStatic: C }, { name: ["Day", d], classNames: s, styles: l, unstyled: u, variant: x, size: b });
  return /* @__PURE__ */ E.createElement($o, ade({
    component: C ? "div" : "button",
    ref: r,
    className: P(_.day, n),
    disabled: i,
    "data-today": je(o).isSame(/* @__PURE__ */ new Date(), "day") || void 0,
    "data-hidden": $ || void 0,
    "data-disabled": i || void 0,
    "data-weekend": !i && !p && f || void 0,
    "data-outside": !i && p || void 0,
    "data-selected": !i && g || void 0,
    "data-in-range": v && !i || void 0,
    "data-first-in-range": y && !i || void 0,
    "data-last-in-range": w && !i || void 0,
    unstyled: u
  }, O), (h == null ? void 0 : h(o)) || o.getDate());
});
Bx.displayName = "@mantine/dates/Day";
function sde({
  locale: e,
  format: r = "dd",
  firstDayOfWeek: t = 1
}) {
  const n = je().day(t), o = [];
  for (let a = 0; a < 7; a += 1)
    typeof r == "string" ? o.push(je(n).add(a, "days").locale(e).format(r)) : o.push(r(je(n).add(a, "days").toDate()));
  return o;
}
var cde = Ae((e, r, { size: t }) => ({
  weekdaysRow: {},
  weekday: {
    color: e.colorScheme === "dark" ? e.colors.dark[1] : e.colors.gray[5],
    fontWeight: 400,
    fontSize: ve({ size: t, sizes: e.fontSizes }),
    textTransform: "capitalize",
    paddingBottom: `calc(${ve({ size: t, sizes: e.spacing })} / 2)`
  }
})), ude = Object.defineProperty, xu = Object.getOwnPropertySymbols, Hx = Object.prototype.hasOwnProperty, Gx = Object.prototype.propertyIsEnumerable, fv = (e, r, t) => r in e ? ude(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, dde = (e, r) => {
  for (var t in r || (r = {}))
    Hx.call(r, t) && fv(e, t, r[t]);
  if (xu)
    for (var t of xu(r))
      Gx.call(r, t) && fv(e, t, r[t]);
  return e;
}, fde = (e, r) => {
  var t = {};
  for (var n in e)
    Hx.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && xu)
    for (var n of xu(e))
      r.indexOf(n) < 0 && Gx.call(e, n) && (t[n] = e[n]);
  return t;
};
const pde = {
  weekdayFormat: "dd",
  cellComponent: "th",
  size: "sm"
}, Xx = ue((e, r) => {
  const t = Oe("WeekdaysRow", pde, e), {
    className: n,
    locale: o,
    firstDayOfWeek: a,
    weekdayFormat: i,
    cellComponent: l,
    __staticSelector: s,
    classNames: u,
    styles: d,
    unstyled: f,
    variant: p,
    size: g
  } = t, h = fde(t, [
    "className",
    "locale",
    "firstDayOfWeek",
    "weekdayFormat",
    "cellComponent",
    "__staticSelector",
    "classNames",
    "styles",
    "unstyled",
    "variant",
    "size"
  ]), v = Dn(), { classes: y, cx: w } = cde(null, {
    name: ["WeekdaysRow", s],
    classNames: u,
    styles: d,
    unstyled: f,
    variant: p,
    size: g
  }), $ = sde({
    locale: v.getLocale(o),
    format: i,
    firstDayOfWeek: v.getFirstDayOfWeek(a)
  }).map((C, x) => /* @__PURE__ */ E.createElement(l, {
    key: x,
    className: y.weekday
  }, C));
  return /* @__PURE__ */ E.createElement(We, dde({
    component: "tr",
    ref: r,
    className: w(y.weekdaysRow, n)
  }, h), $);
});
Xx.displayName = "@mantine/dates/WeekdaysRow";
var gde = Object.defineProperty, vde = Object.defineProperties, mde = Object.getOwnPropertyDescriptors, $u = Object.getOwnPropertySymbols, Yx = Object.prototype.hasOwnProperty, Ux = Object.prototype.propertyIsEnumerable, pv = (e, r, t) => r in e ? gde(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Rl = (e, r) => {
  for (var t in r || (r = {}))
    Yx.call(r, t) && pv(e, t, r[t]);
  if ($u)
    for (var t of $u(r))
      Ux.call(r, t) && pv(e, t, r[t]);
  return e;
}, Vd = (e, r) => vde(e, mde(r)), hde = (e, r) => {
  var t = {};
  for (var n in e)
    Yx.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && $u)
    for (var n of $u(e))
      r.indexOf(n) < 0 && Ux.call(e, n) && (t[n] = e[n]);
  return t;
};
const bde = {
  size: "sm",
  withCellSpacing: !0
}, Jx = ue((e, r) => {
  const t = Oe("Month", bde, e), {
    className: n,
    classNames: o,
    styles: a,
    unstyled: i,
    __staticSelector: l,
    locale: s,
    firstDayOfWeek: u,
    weekdayFormat: d,
    month: f,
    weekendDays: p,
    getDayProps: g,
    excludeDate: h,
    minDate: v,
    maxDate: y,
    renderDay: w,
    hideOutsideDates: $,
    hideWeekdays: C,
    getDayAriaLabel: x,
    static: b,
    __getDayRef: O,
    __onDayKeyDown: _,
    __onDayClick: P,
    __onDayMouseEnter: S,
    __preventFocus: I,
    __stopPropagation: N,
    withCellSpacing: k,
    size: j,
    variant: R
  } = t, D = hde(t, [
    "className",
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "locale",
    "firstDayOfWeek",
    "weekdayFormat",
    "month",
    "weekendDays",
    "getDayProps",
    "excludeDate",
    "minDate",
    "maxDate",
    "renderDay",
    "hideOutsideDates",
    "hideWeekdays",
    "getDayAriaLabel",
    "static",
    "__getDayRef",
    "__onDayKeyDown",
    "__onDayClick",
    "__onDayMouseEnter",
    "__preventFocus",
    "__stopPropagation",
    "withCellSpacing",
    "size",
    "variant"
  ]), T = Dn(), { classes: V, cx: L } = tde(null, {
    name: ["Month", l],
    classNames: o,
    styles: a,
    unstyled: i,
    variant: R,
    size: j
  }), Z = {
    __staticSelector: l || "Month",
    classNames: o,
    styles: a,
    unstyled: i,
    variant: R,
    size: j
  }, z = Y1e(f, T.getFirstDayOfWeek(u)), W = nde(z, v, y, g, h, $, f), U = z.map((re, X) => {
    const J = re.map((Q, se) => {
      const q = !zx(Q, f), te = (x == null ? void 0 : x(Q)) || je(Q).locale(s || T.locale).format("D MMMM YYYY"), ae = g == null ? void 0 : g(Q), ge = je(Q).isSame(W, "date");
      return /* @__PURE__ */ E.createElement("td", {
        key: Q.toString(),
        className: V.monthCell,
        "data-with-spacing": k || void 0
      }, /* @__PURE__ */ E.createElement(Bx, Vd(Rl(Vd(Rl({}, Z), {
        "data-mantine-stop-propagation": N || void 0,
        renderDay: w,
        date: Q,
        weekend: T.getWeekendDays(p).includes(Q.getDay()),
        outside: q,
        hidden: $ ? q : !1,
        "aria-label": te,
        static: b,
        disabled: (h == null ? void 0 : h(Q)) || !Vx(Q, y) || !Fx(Q, v),
        ref: (G) => O == null ? void 0 : O(X, se, G)
      }), ae), {
        onKeyDown: (G) => {
          var oe;
          (oe = ae == null ? void 0 : ae.onKeyDown) == null || oe.call(ae, G), _ == null || _(G, { rowIndex: X, cellIndex: se, date: Q });
        },
        onMouseEnter: (G) => {
          var oe;
          (oe = ae == null ? void 0 : ae.onMouseEnter) == null || oe.call(ae, G), S == null || S(G, Q);
        },
        onClick: (G) => {
          var oe;
          (oe = ae == null ? void 0 : ae.onClick) == null || oe.call(ae, G), P == null || P(G, Q);
        },
        onMouseDown: (G) => {
          var oe;
          (oe = ae == null ? void 0 : ae.onMouseDown) == null || oe.call(ae, G), I && G.preventDefault();
        },
        tabIndex: I || !ge ? -1 : 0
      })));
    });
    return /* @__PURE__ */ E.createElement("tr", {
      key: X,
      className: V.monthRow
    }, J);
  });
  return /* @__PURE__ */ E.createElement(We, Rl({
    component: "table",
    className: L(V.month, n),
    ref: r
  }, D), !C && /* @__PURE__ */ E.createElement("thead", {
    className: V.monthThead
  }, /* @__PURE__ */ E.createElement(Xx, Vd(Rl({}, Z), {
    locale: s,
    firstDayOfWeek: u,
    weekdayFormat: d
  }))), /* @__PURE__ */ E.createElement("tbody", {
    className: V.monthTbody
  }, U));
});
Jx.displayName = "@mantine/dates/Month";
var yde = Object.defineProperty, Ou = Object.getOwnPropertySymbols, qx = Object.prototype.hasOwnProperty, Kx = Object.prototype.propertyIsEnumerable, gv = (e, r, t) => r in e ? yde(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Fd = (e, r) => {
  for (var t in r || (r = {}))
    qx.call(r, t) && gv(e, t, r[t]);
  if (Ou)
    for (var t of Ou(r))
      Kx.call(r, t) && gv(e, t, r[t]);
  return e;
}, Cde = (e, r) => {
  var t = {};
  for (var n in e)
    qx.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ou)
    for (var n of Ou(e))
      r.indexOf(n) < 0 && Kx.call(e, n) && (t[n] = e[n]);
  return t;
};
const wde = {
  monthLabelFormat: "MMMM YYYY"
}, Qx = ue((e, r) => {
  const t = Oe("MonthLevel", wde, e), {
    month: n,
    locale: o,
    firstDayOfWeek: a,
    weekdayFormat: i,
    weekendDays: l,
    getDayProps: s,
    excludeDate: u,
    minDate: d,
    maxDate: f,
    renderDay: p,
    hideOutsideDates: g,
    hideWeekdays: h,
    getDayAriaLabel: v,
    __getDayRef: y,
    __onDayKeyDown: w,
    __onDayClick: $,
    __onDayMouseEnter: C,
    withCellSpacing: x,
    __preventFocus: b,
    __stopPropagation: O,
    nextIcon: _,
    previousIcon: P,
    nextLabel: S,
    previousLabel: I,
    onNext: N,
    onPrevious: k,
    onLevelClick: j,
    nextDisabled: R,
    previousDisabled: D,
    hasNextLevel: T,
    levelControlAriaLabel: V,
    withNext: L,
    withPrevious: Z,
    className: z,
    monthLabelFormat: W,
    classNames: U,
    styles: re,
    unstyled: X,
    __staticSelector: J,
    size: Q,
    variant: se,
    static: q
  } = t, te = Cde(t, [
    "month",
    "locale",
    "firstDayOfWeek",
    "weekdayFormat",
    "weekendDays",
    "getDayProps",
    "excludeDate",
    "minDate",
    "maxDate",
    "renderDay",
    "hideOutsideDates",
    "hideWeekdays",
    "getDayAriaLabel",
    "__getDayRef",
    "__onDayKeyDown",
    "__onDayClick",
    "__onDayMouseEnter",
    "withCellSpacing",
    "__preventFocus",
    "__stopPropagation",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "onLevelClick",
    "nextDisabled",
    "previousDisabled",
    "hasNextLevel",
    "levelControlAriaLabel",
    "withNext",
    "withPrevious",
    "className",
    "monthLabelFormat",
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "size",
    "variant",
    "static"
  ]), { classes: ae, cx: ge } = D1e(null, {
    name: ["MonthLevel", J],
    classNames: U,
    styles: re,
    unstyled: X,
    variant: se,
    size: Q
  }), G = Dn(), oe = {
    __staticSelector: J || "MonthLevel",
    classNames: U,
    styles: re,
    unstyled: X,
    variant: se,
    size: Q
  }, ne = typeof R == "boolean" ? R : f ? !je(n).endOf("month").isBefore(f) : !1, _e = typeof D == "boolean" ? D : d ? !je(n).startOf("month").isAfter(d) : !1;
  return /* @__PURE__ */ E.createElement(We, Fd({
    className: ge(ae.monthLevel, z),
    "data-month-level": !0,
    ref: r
  }, te), /* @__PURE__ */ E.createElement(T1, Fd({
    label: typeof W == "function" ? W(n) : je(n).locale(o || G.locale).format(W),
    className: ae.calendarHeader,
    __preventFocus: b,
    __stopPropagation: O,
    nextIcon: _,
    previousIcon: P,
    nextLabel: S,
    previousLabel: I,
    onNext: N,
    onPrevious: k,
    onLevelClick: j,
    nextDisabled: ne,
    previousDisabled: _e,
    hasNextLevel: T,
    levelControlAriaLabel: V,
    withNext: L,
    withPrevious: Z
  }, oe)), /* @__PURE__ */ E.createElement(Jx, Fd({
    month: n,
    locale: o,
    firstDayOfWeek: a,
    weekdayFormat: i,
    weekendDays: l,
    getDayProps: s,
    excludeDate: u,
    minDate: d,
    maxDate: f,
    renderDay: p,
    hideOutsideDates: g,
    hideWeekdays: h,
    getDayAriaLabel: v,
    __getDayRef: y,
    __onDayKeyDown: w,
    __onDayClick: $,
    __onDayMouseEnter: C,
    __preventFocus: b,
    __stopPropagation: O,
    static: q,
    withCellSpacing: x
  }, oe)));
});
Qx.displayName = "@mantine/dates/MonthLevel";
function _de({ direction: e, levelIndex: r, rowIndex: t, cellIndex: n, size: o }) {
  switch (e) {
    case "up":
      return r === 0 && t === 0 ? null : t === 0 ? {
        levelIndex: r - 1,
        rowIndex: n <= o[r - 1][o[r - 1].length - 1] - 1 ? o[r - 1].length - 1 : o[r - 1].length - 2,
        cellIndex: n
      } : {
        levelIndex: r,
        rowIndex: t - 1,
        cellIndex: n
      };
    case "down":
      return t === o[r].length - 1 ? {
        levelIndex: r + 1,
        rowIndex: 0,
        cellIndex: n
      } : t === o[r].length - 2 && n >= o[r][o[r].length - 1] ? {
        levelIndex: r + 1,
        rowIndex: 0,
        cellIndex: n
      } : {
        levelIndex: r,
        rowIndex: t + 1,
        cellIndex: n
      };
    case "left":
      return r === 0 && t === 0 && n === 0 ? null : t === 0 && n === 0 ? {
        levelIndex: r - 1,
        rowIndex: o[r - 1].length - 1,
        cellIndex: o[r - 1][o[r - 1].length - 1] - 1
      } : n === 0 ? {
        levelIndex: r,
        rowIndex: t - 1,
        cellIndex: o[r][t - 1] - 1
      } : {
        levelIndex: r,
        rowIndex: t,
        cellIndex: n - 1
      };
    case "right":
      return t === o[r].length - 1 && n === o[r][t] - 1 ? {
        levelIndex: r + 1,
        rowIndex: 0,
        cellIndex: 0
      } : n === o[r][t] - 1 ? {
        levelIndex: r,
        rowIndex: t + 1,
        cellIndex: 0
      } : {
        levelIndex: r,
        rowIndex: t,
        cellIndex: n + 1
      };
    default:
      return { levelIndex: r, rowIndex: t, cellIndex: n };
  }
}
function e$({
  controlsRef: e,
  direction: r,
  levelIndex: t,
  rowIndex: n,
  cellIndex: o,
  size: a
}) {
  var i, l;
  const s = _de({ direction: r, size: a, rowIndex: n, cellIndex: o, levelIndex: t });
  if (!s)
    return;
  const u = (l = (i = e.current[s.levelIndex]) == null ? void 0 : i[s.rowIndex]) == null ? void 0 : l[s.cellIndex];
  u && (u.disabled || u.getAttribute("data-hidden") || u.getAttribute("data-outside") ? e$({
    controlsRef: e,
    direction: r,
    levelIndex: s.levelIndex,
    cellIndex: s.cellIndex,
    rowIndex: s.rowIndex,
    size: a
  }) : u.focus());
}
function xde(e) {
  switch (e) {
    case "ArrowDown":
      return "down";
    case "ArrowUp":
      return "up";
    case "ArrowRight":
      return "right";
    case "ArrowLeft":
      return "left";
    default:
      return null;
  }
}
function $de(e) {
  return e.current.map((r) => r.map((t) => t.length));
}
function y2({
  controlsRef: e,
  levelIndex: r,
  rowIndex: t,
  cellIndex: n,
  event: o
}) {
  const a = xde(o.key);
  if (a) {
    o.preventDefault();
    const i = $de(e);
    e$({
      controlsRef: e,
      direction: a,
      levelIndex: r,
      rowIndex: t,
      cellIndex: n,
      size: i
    });
  }
}
var Ode = Object.defineProperty, Pu = Object.getOwnPropertySymbols, r$ = Object.prototype.hasOwnProperty, t$ = Object.prototype.propertyIsEnumerable, vv = (e, r, t) => r in e ? Ode(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Pde = (e, r) => {
  for (var t in r || (r = {}))
    r$.call(r, t) && vv(e, t, r[t]);
  if (Pu)
    for (var t of Pu(r))
      t$.call(r, t) && vv(e, t, r[t]);
  return e;
}, Sde = (e, r) => {
  var t = {};
  for (var n in e)
    r$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Pu)
    for (var n of Pu(e))
      r.indexOf(n) < 0 && t$.call(e, n) && (t[n] = e[n]);
  return t;
};
const Ide = {
  numberOfColumns: 1
}, n$ = ue((e, r) => {
  const t = Oe("MonthLevelGroup", Ide, e), {
    month: n,
    locale: o,
    firstDayOfWeek: a,
    weekdayFormat: i,
    weekendDays: l,
    getDayProps: s,
    excludeDate: u,
    minDate: d,
    maxDate: f,
    renderDay: p,
    hideOutsideDates: g,
    hideWeekdays: h,
    getDayAriaLabel: v,
    __onDayClick: y,
    __onDayMouseEnter: w,
    withCellSpacing: $,
    __preventFocus: C,
    nextIcon: x,
    previousIcon: b,
    nextLabel: O,
    previousLabel: _,
    onNext: P,
    onPrevious: S,
    onLevelClick: I,
    nextDisabled: N,
    previousDisabled: k,
    hasNextLevel: j,
    className: R,
    classNames: D,
    styles: T,
    unstyled: V,
    numberOfColumns: L,
    levelControlAriaLabel: Z,
    monthLabelFormat: z,
    __staticSelector: W,
    __stopPropagation: U,
    size: re,
    variant: X,
    static: J
  } = t, Q = Sde(t, [
    "month",
    "locale",
    "firstDayOfWeek",
    "weekdayFormat",
    "weekendDays",
    "getDayProps",
    "excludeDate",
    "minDate",
    "maxDate",
    "renderDay",
    "hideOutsideDates",
    "hideWeekdays",
    "getDayAriaLabel",
    "__onDayClick",
    "__onDayMouseEnter",
    "withCellSpacing",
    "__preventFocus",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "onLevelClick",
    "nextDisabled",
    "previousDisabled",
    "hasNextLevel",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "numberOfColumns",
    "levelControlAriaLabel",
    "monthLabelFormat",
    "__staticSelector",
    "__stopPropagation",
    "size",
    "variant",
    "static"
  ]), { classes: se, cx: q } = T1e(null, {
    name: ["MonthLevelGroup", W],
    classNames: D,
    styles: T,
    unstyled: V,
    variant: X,
    size: re
  }), te = Ve([]), ae = Array(L).fill(0).map((ge, G) => {
    const oe = je(n).add(G, "months").toDate();
    return /* @__PURE__ */ E.createElement(Qx, {
      key: G,
      month: oe,
      withNext: G === L - 1,
      withPrevious: G === 0,
      monthLabelFormat: z,
      __stopPropagation: U,
      __onDayClick: y,
      __onDayMouseEnter: w,
      __onDayKeyDown: (ne, _e) => y2({
        levelIndex: G,
        rowIndex: _e.rowIndex,
        cellIndex: _e.cellIndex,
        event: ne,
        controlsRef: te
      }),
      __getDayRef: (ne, _e, ye) => {
        Array.isArray(te.current[G]) || (te.current[G] = []), Array.isArray(te.current[G][ne]) || (te.current[G][ne] = []), te.current[G][ne][_e] = ye;
      },
      levelControlAriaLabel: typeof Z == "function" ? Z(oe) : Z,
      locale: o,
      firstDayOfWeek: a,
      weekdayFormat: i,
      weekendDays: l,
      getDayProps: s,
      excludeDate: u,
      minDate: d,
      maxDate: f,
      renderDay: p,
      hideOutsideDates: g,
      hideWeekdays: h,
      getDayAriaLabel: v,
      __preventFocus: C,
      nextIcon: x,
      previousIcon: b,
      nextLabel: O,
      previousLabel: _,
      onNext: P,
      onPrevious: S,
      onLevelClick: I,
      nextDisabled: N,
      previousDisabled: k,
      hasNextLevel: j,
      classNames: D,
      styles: T,
      unstyled: V,
      __staticSelector: W || "MonthLevelGroup",
      size: re,
      variant: X,
      static: J,
      withCellSpacing: $
    });
  });
  return /* @__PURE__ */ E.createElement(We, Pde({
    className: q(se.monthLevelGroup, R),
    ref: r
  }, Q), ae);
});
n$.displayName = "@mantine/dates/MonthLevelGroup";
var Ede = Ae((e, r, { size: t }) => ({
  yearLevelGroup: {
    display: "flex",
    "& [data-year-level]:not(:last-of-type)": {
      marginRight: ve({ size: t, sizes: e.spacing })
    }
  }
})), Rde = Ae((e) => ({
  yearLevel: {},
  calendarHeader: {
    marginBottom: e.spacing.xs
  }
}));
function Ade(e) {
  const r = je(e).startOf("year").toDate(), t = [[], [], [], []];
  let n = 0;
  for (let o = 0; o < 4; o += 1)
    for (let a = 0; a < 3; a += 1)
      t[o].push(je(r).add(n, "months").toDate()), n += 1;
  return t;
}
function o$(e, r, t) {
  return !r && !t ? !1 : !!(r && je(e).isBefore(r, "month") || t && je(e).isAfter(t, "month"));
}
var kde = Ae(() => ({
  monthsList: {
    borderCollapse: "collapse",
    borderWidth: 0,
    cursor: "pointer"
  },
  monthsListCell: {
    padding: 0,
    "&[data-with-spacing]": {
      padding: B(0.5)
    }
  },
  monthsListRow: {}
}));
function Mde(e, r, t, n) {
  const o = e.flat().filter((l) => {
    var s;
    return !o$(l, r, t) && !((s = n == null ? void 0 : n(l)) != null && s.disabled);
  }), a = o.find((l) => {
    var s;
    return (s = n == null ? void 0 : n(l)) == null ? void 0 : s.selected;
  });
  if (a)
    return a;
  const i = o.find((l) => je().isSame(l, "month"));
  return i || o[0];
}
var Nde = Object.defineProperty, Tde = Object.defineProperties, Dde = Object.getOwnPropertyDescriptors, mv = Object.getOwnPropertySymbols, jde = Object.prototype.hasOwnProperty, Lde = Object.prototype.propertyIsEnumerable, hv = (e, r, t) => r in e ? Nde(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Al = (e, r) => {
  for (var t in r || (r = {}))
    jde.call(r, t) && hv(e, t, r[t]);
  if (mv)
    for (var t of mv(r))
      Lde.call(r, t) && hv(e, t, r[t]);
  return e;
}, bv = (e, r) => Tde(e, Dde(r)), zde = Ae((e, r, { size: t }) => {
  const n = e.fn.variant({ variant: "filled" }), o = e.fn.variant({ variant: "light" });
  return {
    pickerControl: bv(Al({
      fontSize: ve({ size: t, sizes: e.fontSizes }),
      height: ve({ size: t, sizes: wi }),
      width: `calc((${ve({ size: t, sizes: wi })} * 7) / 3 + ${B(1.5)})`,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      userSelect: "none",
      borderRadius: e.fn.radius()
    }, e.fn.hover({
      backgroundColor: e.colorScheme === "dark" ? e.colors.dark[5] : e.colors.gray[0]
    })), {
      "&:active": e.activeStyles,
      "&[data-in-range]": Al({
        backgroundColor: o.background,
        borderRadius: 0
      }, e.fn.hover({ backgroundColor: o.hover })),
      "&[data-first-in-range]": {
        borderRadius: 0,
        borderTopLeftRadius: e.radius.sm,
        borderBottomLeftRadius: e.radius.sm
      },
      "&[data-last-in-range]": {
        borderRadius: 0,
        borderTopRightRadius: e.radius.sm,
        borderBottomRightRadius: e.radius.sm
      },
      "&[data-last-in-range][data-first-in-range]": {
        borderRadius: e.radius.sm
      },
      "&[data-selected]": Al({
        color: n.color,
        backgroundColor: n.background
      }, e.fn.hover({ backgroundColor: n.hover })),
      "&[data-disabled]": bv(Al({
        color: e.colorScheme === "dark" ? e.colors.dark[3] : e.colors.gray[4],
        cursor: "not-allowed"
      }, e.fn.hover({ backgroundColor: "transparent" })), {
        "&:active": {
          transform: "none"
        }
      })
    })
  };
}), Vde = Object.defineProperty, Su = Object.getOwnPropertySymbols, a$ = Object.prototype.hasOwnProperty, i$ = Object.prototype.propertyIsEnumerable, yv = (e, r, t) => r in e ? Vde(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Fde = (e, r) => {
  for (var t in r || (r = {}))
    a$.call(r, t) && yv(e, t, r[t]);
  if (Su)
    for (var t of Su(r))
      i$.call(r, t) && yv(e, t, r[t]);
  return e;
}, Zde = (e, r) => {
  var t = {};
  for (var n in e)
    a$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Su)
    for (var n of Su(e))
      r.indexOf(n) < 0 && i$.call(e, n) && (t[n] = e[n]);
  return t;
};
const Wde = {
  size: "sm"
}, C2 = ue((e, r) => {
  const t = Oe("PickerControl", Wde, e), {
    className: n,
    children: o,
    disabled: a,
    selected: i,
    classNames: l,
    styles: s,
    unstyled: u,
    firstInRange: d,
    lastInRange: f,
    inRange: p,
    __staticSelector: g,
    size: h,
    variant: v
  } = t, y = Zde(t, [
    "className",
    "children",
    "disabled",
    "selected",
    "classNames",
    "styles",
    "unstyled",
    "firstInRange",
    "lastInRange",
    "inRange",
    "__staticSelector",
    "size",
    "variant"
  ]), { classes: w, cx: $ } = zde(null, {
    name: ["PickerControl", g],
    classNames: l,
    styles: s,
    unstyled: u,
    variant: v,
    size: h
  });
  return /* @__PURE__ */ E.createElement($o, Fde({
    className: $(w.pickerControl, n),
    ref: r,
    unstyled: u,
    "data-picker-control": !0,
    "data-selected": i && !a || void 0,
    "data-disabled": a || void 0,
    "data-in-range": p && !a && !i || void 0,
    "data-first-in-range": d && !a || void 0,
    "data-last-in-range": f && !a || void 0,
    disabled: a
  }, y), o);
});
C2.displayName = "@mantine/dates/PickerControl";
var Bde = Object.defineProperty, Hde = Object.defineProperties, Gde = Object.getOwnPropertyDescriptors, Iu = Object.getOwnPropertySymbols, l$ = Object.prototype.hasOwnProperty, s$ = Object.prototype.propertyIsEnumerable, Cv = (e, r, t) => r in e ? Bde(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, wv = (e, r) => {
  for (var t in r || (r = {}))
    l$.call(r, t) && Cv(e, t, r[t]);
  if (Iu)
    for (var t of Iu(r))
      s$.call(r, t) && Cv(e, t, r[t]);
  return e;
}, Xde = (e, r) => Hde(e, Gde(r)), Yde = (e, r) => {
  var t = {};
  for (var n in e)
    l$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Iu)
    for (var n of Iu(e))
      r.indexOf(n) < 0 && s$.call(e, n) && (t[n] = e[n]);
  return t;
};
const Ude = {
  monthsListFormat: "MMM",
  size: "sm",
  withCellSpacing: !0
}, c$ = ue((e, r) => {
  const t = Oe("MonthsList", Ude, e), {
    year: n,
    className: o,
    monthsListFormat: a,
    locale: i,
    minDate: l,
    maxDate: s,
    getMonthControlProps: u,
    classNames: d,
    styles: f,
    unstyled: p,
    __staticSelector: g,
    __getControlRef: h,
    __onControlKeyDown: v,
    __onControlClick: y,
    __onControlMouseEnter: w,
    __preventFocus: $,
    size: C,
    variant: x,
    __stopPropagation: b,
    withCellSpacing: O
  } = t, _ = Yde(t, [
    "year",
    "className",
    "monthsListFormat",
    "locale",
    "minDate",
    "maxDate",
    "getMonthControlProps",
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "__getControlRef",
    "__onControlKeyDown",
    "__onControlClick",
    "__onControlMouseEnter",
    "__preventFocus",
    "size",
    "variant",
    "__stopPropagation",
    "withCellSpacing"
  ]), { classes: P, cx: S } = kde(null, {
    name: ["MonthsList", g],
    classNames: d,
    styles: f,
    unstyled: p,
    variant: x,
    size: C
  }), I = Dn(), N = Ade(n), k = Mde(N, l, s, u), j = N.map((R, D) => {
    const T = R.map((V, L) => {
      const Z = u == null ? void 0 : u(V), z = je(V).isSame(k, "month");
      return /* @__PURE__ */ E.createElement("td", {
        key: L,
        className: P.monthsListCell,
        "data-with-spacing": O || void 0
      }, /* @__PURE__ */ E.createElement(C2, Xde(wv({
        variant: x,
        size: C,
        classNames: d,
        styles: f,
        unstyled: p,
        __staticSelector: g || "MonthsList",
        "data-mantine-stop-propagation": b || void 0,
        disabled: o$(V, l, s),
        ref: (W) => h == null ? void 0 : h(D, L, W)
      }, Z), {
        onKeyDown: (W) => {
          var U;
          (U = Z == null ? void 0 : Z.onKeyDown) == null || U.call(Z, W), v == null || v(W, { rowIndex: D, cellIndex: L, date: V });
        },
        onClick: (W) => {
          var U;
          (U = Z == null ? void 0 : Z.onClick) == null || U.call(Z, W), y == null || y(W, V);
        },
        onMouseEnter: (W) => {
          var U;
          (U = Z == null ? void 0 : Z.onMouseEnter) == null || U.call(Z, W), w == null || w(W, V);
        },
        onMouseDown: (W) => {
          var U;
          (U = Z == null ? void 0 : Z.onMouseDown) == null || U.call(Z, W), $ && W.preventDefault();
        },
        tabIndex: $ || !z ? -1 : 0
      }), je(V).locale(I.getLocale(i)).format(a)));
    });
    return /* @__PURE__ */ E.createElement("tr", {
      key: D,
      className: P.monthsListRow
    }, T);
  });
  return /* @__PURE__ */ E.createElement(We, wv({
    component: "table",
    ref: r,
    className: S(P.monthsList, o)
  }, _), /* @__PURE__ */ E.createElement("tbody", null, j));
});
c$.displayName = "@mantine/dates/MonthsList";
var Jde = Object.defineProperty, Eu = Object.getOwnPropertySymbols, u$ = Object.prototype.hasOwnProperty, d$ = Object.prototype.propertyIsEnumerable, _v = (e, r, t) => r in e ? Jde(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Zd = (e, r) => {
  for (var t in r || (r = {}))
    u$.call(r, t) && _v(e, t, r[t]);
  if (Eu)
    for (var t of Eu(r))
      d$.call(r, t) && _v(e, t, r[t]);
  return e;
}, qde = (e, r) => {
  var t = {};
  for (var n in e)
    u$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Eu)
    for (var n of Eu(e))
      r.indexOf(n) < 0 && d$.call(e, n) && (t[n] = e[n]);
  return t;
};
const Kde = {
  yearLabelFormat: "YYYY",
  size: "sm"
}, f$ = ue((e, r) => {
  const t = Oe("YearLevel", Kde, e), {
    year: n,
    locale: o,
    minDate: a,
    maxDate: i,
    monthsListFormat: l,
    getMonthControlProps: s,
    __getControlRef: u,
    __onControlKeyDown: d,
    __onControlClick: f,
    __onControlMouseEnter: p,
    withCellSpacing: g,
    __preventFocus: h,
    nextIcon: v,
    previousIcon: y,
    nextLabel: w,
    previousLabel: $,
    onNext: C,
    onPrevious: x,
    onLevelClick: b,
    nextDisabled: O,
    previousDisabled: _,
    hasNextLevel: P,
    levelControlAriaLabel: S,
    withNext: I,
    withPrevious: N,
    className: k,
    yearLabelFormat: j,
    classNames: R,
    styles: D,
    unstyled: T,
    __staticSelector: V,
    __stopPropagation: L,
    size: Z,
    variant: z
  } = t, W = qde(t, [
    "year",
    "locale",
    "minDate",
    "maxDate",
    "monthsListFormat",
    "getMonthControlProps",
    "__getControlRef",
    "__onControlKeyDown",
    "__onControlClick",
    "__onControlMouseEnter",
    "withCellSpacing",
    "__preventFocus",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "onLevelClick",
    "nextDisabled",
    "previousDisabled",
    "hasNextLevel",
    "levelControlAriaLabel",
    "withNext",
    "withPrevious",
    "className",
    "yearLabelFormat",
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "__stopPropagation",
    "size",
    "variant"
  ]), { classes: U, cx: re } = Rde(null, {
    name: ["YearLevel", V],
    classNames: R,
    styles: D,
    unstyled: T,
    size: Z,
    variant: z
  }), X = Dn(), J = {
    __staticSelector: V || "YearLevel",
    classNames: R,
    styles: D,
    unstyled: T,
    size: Z,
    variant: z
  }, Q = typeof O == "boolean" ? O : i ? !je(n).endOf("year").isBefore(i) : !1, se = typeof _ == "boolean" ? _ : a ? !je(n).startOf("year").isAfter(a) : !1;
  return /* @__PURE__ */ E.createElement(We, Zd({
    className: re(U.yearLevel, k),
    "data-year-level": !0,
    ref: r
  }, W), /* @__PURE__ */ E.createElement(T1, Zd({
    label: typeof j == "function" ? j(n) : je(n).locale(o || X.locale).format(j),
    className: U.calendarHeader,
    __preventFocus: h,
    __stopPropagation: L,
    nextIcon: v,
    previousIcon: y,
    nextLabel: w,
    previousLabel: $,
    onNext: C,
    onPrevious: x,
    onLevelClick: b,
    nextDisabled: Q,
    previousDisabled: se,
    hasNextLevel: P,
    levelControlAriaLabel: S,
    withNext: I,
    withPrevious: N
  }, J)), /* @__PURE__ */ E.createElement(c$, Zd({
    year: n,
    locale: o,
    minDate: a,
    maxDate: i,
    monthsListFormat: l,
    getMonthControlProps: s,
    __getControlRef: u,
    __onControlKeyDown: d,
    __onControlClick: f,
    __onControlMouseEnter: p,
    __preventFocus: h,
    __stopPropagation: L,
    withCellSpacing: g
  }, J)));
});
f$.displayName = "@mantine/dates/YearLevel";
var Qde = Object.defineProperty, Ru = Object.getOwnPropertySymbols, p$ = Object.prototype.hasOwnProperty, g$ = Object.prototype.propertyIsEnumerable, xv = (e, r, t) => r in e ? Qde(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, e0e = (e, r) => {
  for (var t in r || (r = {}))
    p$.call(r, t) && xv(e, t, r[t]);
  if (Ru)
    for (var t of Ru(r))
      g$.call(r, t) && xv(e, t, r[t]);
  return e;
}, r0e = (e, r) => {
  var t = {};
  for (var n in e)
    p$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ru)
    for (var n of Ru(e))
      r.indexOf(n) < 0 && g$.call(e, n) && (t[n] = e[n]);
  return t;
};
const t0e = {
  numberOfColumns: 1,
  size: "sm"
}, v$ = ue((e, r) => {
  const t = Oe("YearLevelGroup", t0e, e), {
    year: n,
    locale: o,
    minDate: a,
    maxDate: i,
    monthsListFormat: l,
    getMonthControlProps: s,
    __onControlClick: u,
    __onControlMouseEnter: d,
    withCellSpacing: f,
    __preventFocus: p,
    nextIcon: g,
    previousIcon: h,
    nextLabel: v,
    previousLabel: y,
    onNext: w,
    onPrevious: $,
    onLevelClick: C,
    nextDisabled: x,
    previousDisabled: b,
    hasNextLevel: O,
    className: _,
    classNames: P,
    styles: S,
    unstyled: I,
    __staticSelector: N,
    __stopPropagation: k,
    numberOfColumns: j,
    levelControlAriaLabel: R,
    yearLabelFormat: D,
    variant: T,
    size: V
  } = t, L = r0e(t, [
    "year",
    "locale",
    "minDate",
    "maxDate",
    "monthsListFormat",
    "getMonthControlProps",
    "__onControlClick",
    "__onControlMouseEnter",
    "withCellSpacing",
    "__preventFocus",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "onLevelClick",
    "nextDisabled",
    "previousDisabled",
    "hasNextLevel",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "__stopPropagation",
    "numberOfColumns",
    "levelControlAriaLabel",
    "yearLabelFormat",
    "variant",
    "size"
  ]), { classes: Z, cx: z } = Ede(null, {
    name: ["YearLevelGroup", N],
    styles: S,
    classNames: P,
    unstyled: I,
    variant: T,
    size: V
  }), W = Ve([]), U = Array(j).fill(0).map((re, X) => {
    const J = je(n).add(X, "years").toDate();
    return /* @__PURE__ */ E.createElement(f$, {
      key: X,
      variant: T,
      size: V,
      monthsListFormat: l,
      year: J,
      withNext: X === j - 1,
      withPrevious: X === 0,
      yearLabelFormat: D,
      __stopPropagation: k,
      __onControlClick: u,
      __onControlMouseEnter: d,
      __onControlKeyDown: (Q, se) => y2({
        levelIndex: X,
        rowIndex: se.rowIndex,
        cellIndex: se.cellIndex,
        event: Q,
        controlsRef: W
      }),
      __getControlRef: (Q, se, q) => {
        Array.isArray(W.current[X]) || (W.current[X] = []), Array.isArray(W.current[X][Q]) || (W.current[X][Q] = []), W.current[X][Q][se] = q;
      },
      levelControlAriaLabel: typeof R == "function" ? R(J) : R,
      locale: o,
      minDate: a,
      maxDate: i,
      __preventFocus: p,
      nextIcon: g,
      previousIcon: h,
      nextLabel: v,
      previousLabel: y,
      onNext: w,
      onPrevious: $,
      onLevelClick: C,
      nextDisabled: x,
      previousDisabled: b,
      hasNextLevel: O,
      getMonthControlProps: s,
      classNames: P,
      styles: S,
      unstyled: I,
      __staticSelector: N || "YearLevelGroup",
      withCellSpacing: f
    });
  });
  return /* @__PURE__ */ E.createElement(We, e0e({
    className: z(Z.yearLevelGroup, _),
    ref: r
  }, L), U);
});
v$.displayName = "@mantine/dates/YearLevelGroup";
var n0e = Ae((e) => ({
  decadeLevelGroup: {
    display: "flex",
    gap: e.spacing.md
  }
}));
function m$(e) {
  const r = e.getFullYear(), t = r - r % 10;
  let n = 0;
  const o = [[], [], [], []];
  for (let a = 0; a < 4; a += 1) {
    const i = a === 3 ? 1 : 3;
    for (let l = 0; l < i; l += 1)
      o[a].push(new Date(t + n, 0)), n += 1;
  }
  return o;
}
function o0e(e) {
  const r = m$(e);
  return [r[0][0], r[3][0]];
}
var a0e = Ae((e) => ({
  decadeLevel: {},
  calendarHeader: {
    marginBottom: e.spacing.xs
  }
}));
function h$(e, r, t) {
  return !r && !t ? !1 : !!(r && je(e).isBefore(r, "year") || t && je(e).isAfter(t, "year"));
}
var i0e = Ae(() => ({
  yearsList: {
    borderCollapse: "collapse",
    borderWidth: 0
  },
  yearsListCell: {
    padding: 0,
    "&[data-with-spacing]": {
      padding: B(0.5)
    }
  },
  yearsListRow: {}
}));
function l0e(e, r, t, n) {
  const o = e.flat().filter((l) => {
    var s;
    return !h$(l, r, t) && !((s = n == null ? void 0 : n(l)) != null && s.disabled);
  }), a = o.find((l) => {
    var s;
    return (s = n == null ? void 0 : n(l)) == null ? void 0 : s.selected;
  });
  if (a)
    return a;
  const i = o.find((l) => je().isSame(l, "year"));
  return i || o[0];
}
var s0e = Object.defineProperty, c0e = Object.defineProperties, u0e = Object.getOwnPropertyDescriptors, Au = Object.getOwnPropertySymbols, b$ = Object.prototype.hasOwnProperty, y$ = Object.prototype.propertyIsEnumerable, $v = (e, r, t) => r in e ? s0e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Ov = (e, r) => {
  for (var t in r || (r = {}))
    b$.call(r, t) && $v(e, t, r[t]);
  if (Au)
    for (var t of Au(r))
      y$.call(r, t) && $v(e, t, r[t]);
  return e;
}, d0e = (e, r) => c0e(e, u0e(r)), f0e = (e, r) => {
  var t = {};
  for (var n in e)
    b$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Au)
    for (var n of Au(e))
      r.indexOf(n) < 0 && y$.call(e, n) && (t[n] = e[n]);
  return t;
};
const p0e = {
  yearsListFormat: "YYYY",
  size: "sm",
  withCellSpacing: !0
}, C$ = ue((e, r) => {
  const t = Oe("YearsList", p0e, e), {
    decade: n,
    className: o,
    yearsListFormat: a,
    locale: i,
    minDate: l,
    maxDate: s,
    getYearControlProps: u,
    classNames: d,
    styles: f,
    unstyled: p,
    __staticSelector: g,
    __getControlRef: h,
    __onControlKeyDown: v,
    __onControlClick: y,
    __onControlMouseEnter: w,
    __preventFocus: $,
    __stopPropagation: C,
    size: x,
    variant: b,
    withCellSpacing: O
  } = t, _ = f0e(t, [
    "decade",
    "className",
    "yearsListFormat",
    "locale",
    "minDate",
    "maxDate",
    "getYearControlProps",
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "__getControlRef",
    "__onControlKeyDown",
    "__onControlClick",
    "__onControlMouseEnter",
    "__preventFocus",
    "__stopPropagation",
    "size",
    "variant",
    "withCellSpacing"
  ]), { classes: P, cx: S } = i0e(null, {
    name: ["YearsList", g],
    classNames: d,
    styles: f,
    unstyled: p,
    variant: b,
    size: x
  }), I = Dn(), N = m$(n), k = l0e(N, l, s, u), j = N.map((R, D) => {
    const T = R.map((V, L) => {
      const Z = u == null ? void 0 : u(V), z = je(V).isSame(k, "year");
      return /* @__PURE__ */ E.createElement("td", {
        key: L,
        className: P.yearsListCell,
        "data-with-spacing": O || void 0
      }, /* @__PURE__ */ E.createElement(C2, d0e(Ov({
        size: x,
        variant: b,
        classNames: d,
        styles: f,
        unstyled: p,
        __staticSelector: g || "YearsList",
        "data-mantine-stop-propagation": C || void 0,
        disabled: h$(V, l, s),
        ref: (W) => h == null ? void 0 : h(D, L, W)
      }, Z), {
        onKeyDown: (W) => {
          var U;
          (U = Z == null ? void 0 : Z.onKeyDown) == null || U.call(Z, W), v == null || v(W, { rowIndex: D, cellIndex: L, date: V });
        },
        onClick: (W) => {
          var U;
          (U = Z == null ? void 0 : Z.onClick) == null || U.call(Z, W), y == null || y(W, V);
        },
        onMouseEnter: (W) => {
          var U;
          (U = Z == null ? void 0 : Z.onMouseEnter) == null || U.call(Z, W), w == null || w(W, V);
        },
        onMouseDown: (W) => {
          var U;
          (U = Z == null ? void 0 : Z.onMouseDown) == null || U.call(Z, W), $ && W.preventDefault();
        },
        tabIndex: $ || !z ? -1 : 0
      }), je(V).locale(I.getLocale(i)).format(a)));
    });
    return /* @__PURE__ */ E.createElement("tr", {
      key: D,
      className: P.yearsListRow
    }, T);
  });
  return /* @__PURE__ */ E.createElement(We, Ov({
    component: "table",
    ref: r,
    className: S(P.yearsList, o)
  }, _), /* @__PURE__ */ E.createElement("tbody", null, j));
});
C$.displayName = "@mantine/dates/YearsList";
var g0e = Object.defineProperty, ku = Object.getOwnPropertySymbols, w$ = Object.prototype.hasOwnProperty, _$ = Object.prototype.propertyIsEnumerable, Pv = (e, r, t) => r in e ? g0e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Wd = (e, r) => {
  for (var t in r || (r = {}))
    w$.call(r, t) && Pv(e, t, r[t]);
  if (ku)
    for (var t of ku(r))
      _$.call(r, t) && Pv(e, t, r[t]);
  return e;
}, v0e = (e, r) => {
  var t = {};
  for (var n in e)
    w$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ku)
    for (var n of ku(e))
      r.indexOf(n) < 0 && _$.call(e, n) && (t[n] = e[n]);
  return t;
};
const m0e = {
  decadeLabelFormat: "YYYY"
}, x$ = ue((e, r) => {
  const t = Oe("DecadeLevel", m0e, e), {
    decade: n,
    locale: o,
    minDate: a,
    maxDate: i,
    yearsListFormat: l,
    getYearControlProps: s,
    __getControlRef: u,
    __onControlKeyDown: d,
    __onControlClick: f,
    __onControlMouseEnter: p,
    withCellSpacing: g,
    __preventFocus: h,
    nextIcon: v,
    previousIcon: y,
    nextLabel: w,
    previousLabel: $,
    onNext: C,
    onPrevious: x,
    nextDisabled: b,
    previousDisabled: O,
    levelControlAriaLabel: _,
    withNext: P,
    withPrevious: S,
    className: I,
    decadeLabelFormat: N,
    classNames: k,
    styles: j,
    unstyled: R,
    __staticSelector: D,
    __stopPropagation: T,
    variant: V,
    size: L
  } = t, Z = v0e(t, [
    "decade",
    "locale",
    "minDate",
    "maxDate",
    "yearsListFormat",
    "getYearControlProps",
    "__getControlRef",
    "__onControlKeyDown",
    "__onControlClick",
    "__onControlMouseEnter",
    "withCellSpacing",
    "__preventFocus",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "nextDisabled",
    "previousDisabled",
    "levelControlAriaLabel",
    "withNext",
    "withPrevious",
    "className",
    "decadeLabelFormat",
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "__stopPropagation",
    "variant",
    "size"
  ]), { classes: z, cx: W } = a0e(null, {
    name: ["DecadeLevel", D],
    classNames: k,
    styles: j,
    unstyled: R,
    variant: V,
    size: L
  }), U = Dn(), [re, X] = o0e(n), J = {
    __staticSelector: D || "DecadeLevel",
    classNames: k,
    styles: j,
    unstyled: R,
    variant: V,
    size: L
  }, Q = typeof b == "boolean" ? b : i ? !je(X).endOf("year").isBefore(i) : !1, se = typeof O == "boolean" ? O : a ? !je(re).startOf("year").isAfter(a) : !1, q = (te, ae) => je(te).locale(o || U.locale).format(ae);
  return /* @__PURE__ */ E.createElement(We, Wd({
    className: W(z.decadeLevel, I),
    "data-decade-level": !0,
    ref: r
  }, Z), /* @__PURE__ */ E.createElement(T1, Wd({
    label: typeof N == "function" ? N(re, X) : `${q(re, N)} – ${q(X, N)}`,
    className: z.calendarHeader,
    __preventFocus: h,
    __stopPropagation: T,
    nextIcon: v,
    previousIcon: y,
    nextLabel: w,
    previousLabel: $,
    onNext: C,
    onPrevious: x,
    nextDisabled: Q,
    previousDisabled: se,
    hasNextLevel: !1,
    levelControlAriaLabel: _,
    withNext: P,
    withPrevious: S
  }, J)), /* @__PURE__ */ E.createElement(C$, Wd({
    decade: n,
    locale: o,
    minDate: a,
    maxDate: i,
    yearsListFormat: l,
    getYearControlProps: s,
    __getControlRef: u,
    __onControlKeyDown: d,
    __onControlClick: f,
    __onControlMouseEnter: p,
    __preventFocus: h,
    __stopPropagation: T,
    withCellSpacing: g
  }, J)));
});
x$.displayName = "@mantine/dates/DecadeLevel";
var h0e = Object.defineProperty, Mu = Object.getOwnPropertySymbols, $$ = Object.prototype.hasOwnProperty, O$ = Object.prototype.propertyIsEnumerable, Sv = (e, r, t) => r in e ? h0e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, b0e = (e, r) => {
  for (var t in r || (r = {}))
    $$.call(r, t) && Sv(e, t, r[t]);
  if (Mu)
    for (var t of Mu(r))
      O$.call(r, t) && Sv(e, t, r[t]);
  return e;
}, y0e = (e, r) => {
  var t = {};
  for (var n in e)
    $$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Mu)
    for (var n of Mu(e))
      r.indexOf(n) < 0 && O$.call(e, n) && (t[n] = e[n]);
  return t;
};
const C0e = {
  numberOfColumns: 1
}, P$ = ue((e, r) => {
  const t = Oe("DecadeLevelGroup", C0e, e), {
    decade: n,
    locale: o,
    minDate: a,
    maxDate: i,
    yearsListFormat: l,
    getYearControlProps: s,
    __onControlClick: u,
    __onControlMouseEnter: d,
    withCellSpacing: f,
    __preventFocus: p,
    nextIcon: g,
    previousIcon: h,
    nextLabel: v,
    previousLabel: y,
    onNext: w,
    onPrevious: $,
    nextDisabled: C,
    previousDisabled: x,
    className: b,
    classNames: O,
    styles: _,
    unstyled: P,
    __staticSelector: S,
    __stopPropagation: I,
    numberOfColumns: N,
    levelControlAriaLabel: k,
    decadeLabelFormat: j,
    variant: R,
    size: D
  } = t, T = y0e(t, [
    "decade",
    "locale",
    "minDate",
    "maxDate",
    "yearsListFormat",
    "getYearControlProps",
    "__onControlClick",
    "__onControlMouseEnter",
    "withCellSpacing",
    "__preventFocus",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "nextDisabled",
    "previousDisabled",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "__stopPropagation",
    "numberOfColumns",
    "levelControlAriaLabel",
    "decadeLabelFormat",
    "variant",
    "size"
  ]), { classes: V, cx: L } = n0e(null, {
    name: ["DecadeLevelGroup", S],
    styles: _,
    classNames: O,
    unstyled: P,
    variant: R,
    size: D
  }), Z = Ve([]), z = Array(N).fill(0).map((W, U) => {
    const re = je(n).add(U * 10, "years").toDate();
    return /* @__PURE__ */ E.createElement(x$, {
      key: U,
      variant: R,
      size: D,
      yearsListFormat: l,
      decade: re,
      withNext: U === N - 1,
      withPrevious: U === 0,
      decadeLabelFormat: j,
      __onControlClick: u,
      __onControlMouseEnter: d,
      __onControlKeyDown: (X, J) => y2({
        levelIndex: U,
        rowIndex: J.rowIndex,
        cellIndex: J.cellIndex,
        event: X,
        controlsRef: Z
      }),
      __getControlRef: (X, J, Q) => {
        Array.isArray(Z.current[U]) || (Z.current[U] = []), Array.isArray(Z.current[U][X]) || (Z.current[U][X] = []), Z.current[U][X][J] = Q;
      },
      levelControlAriaLabel: typeof k == "function" ? k(re) : k,
      locale: o,
      minDate: a,
      maxDate: i,
      __preventFocus: p,
      __stopPropagation: I,
      nextIcon: g,
      previousIcon: h,
      nextLabel: v,
      previousLabel: y,
      onNext: w,
      onPrevious: $,
      nextDisabled: C,
      previousDisabled: x,
      getYearControlProps: s,
      __staticSelector: S || "DecadeLevelGroup",
      classNames: O,
      styles: _,
      unstyled: P,
      withCellSpacing: f
    });
  });
  return /* @__PURE__ */ E.createElement(We, b0e({
    className: L(V.decadeLevelGroup, b),
    ref: r
  }, T), z);
});
P$.displayName = "@mantine/dates/DecadeLevelGroup";
var w0e = Object.defineProperty, Nu = Object.getOwnPropertySymbols, S$ = Object.prototype.hasOwnProperty, I$ = Object.prototype.propertyIsEnumerable, Iv = (e, r, t) => r in e ? w0e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, kl = (e, r) => {
  for (var t in r || (r = {}))
    S$.call(r, t) && Iv(e, t, r[t]);
  if (Nu)
    for (var t of Nu(r))
      I$.call(r, t) && Iv(e, t, r[t]);
  return e;
}, _0e = (e, r) => {
  var t = {};
  for (var n in e)
    S$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Nu)
    for (var n of Nu(e))
      r.indexOf(n) < 0 && I$.call(e, n) && (t[n] = e[n]);
  return t;
};
const x0e = {
  maxLevel: "decade",
  minLevel: "month",
  __updateDateOnYearSelect: !0,
  __updateDateOnMonthSelect: !0
}, w2 = ue((e, r) => {
  const t = Oe("Calendar", x0e, e), {
    maxLevel: n,
    minLevel: o,
    defaultLevel: a,
    level: i,
    onLevelChange: l,
    date: s,
    defaultDate: u,
    onDateChange: d,
    numberOfColumns: f,
    columnsToScroll: p,
    ariaLabels: g,
    onYearSelect: h,
    onMonthSelect: v,
    onYearMouseEnter: y,
    onMonthMouseEnter: w,
    __updateDateOnYearSelect: $,
    __updateDateOnMonthSelect: C,
    firstDayOfWeek: x,
    weekdayFormat: b,
    weekendDays: O,
    getDayProps: _,
    excludeDate: P,
    renderDay: S,
    hideOutsideDates: I,
    hideWeekdays: N,
    getDayAriaLabel: k,
    monthLabelFormat: j,
    nextIcon: R,
    previousIcon: D,
    __onDayClick: T,
    __onDayMouseEnter: V,
    withCellSpacing: L,
    monthsListFormat: Z,
    getMonthControlProps: z,
    yearLabelFormat: W,
    yearsListFormat: U,
    getYearControlProps: re,
    decadeLabelFormat: X,
    minDate: J,
    maxDate: Q,
    locale: se,
    className: q,
    classNames: te,
    styles: ae,
    __staticSelector: ge,
    unstyled: G,
    variant: oe,
    size: ne,
    __preventFocus: _e,
    __stopPropagation: ye,
    onNextDecade: Te,
    onPreviousDecade: we,
    onNextYear: He,
    onPreviousYear: he,
    onNextMonth: xe,
    onPreviousMonth: Le,
    static: Ue
  } = t, me = _0e(t, [
    "maxLevel",
    "minLevel",
    "defaultLevel",
    "level",
    "onLevelChange",
    "date",
    "defaultDate",
    "onDateChange",
    "numberOfColumns",
    "columnsToScroll",
    "ariaLabels",
    "onYearSelect",
    "onMonthSelect",
    "onYearMouseEnter",
    "onMonthMouseEnter",
    "__updateDateOnYearSelect",
    "__updateDateOnMonthSelect",
    "firstDayOfWeek",
    "weekdayFormat",
    "weekendDays",
    "getDayProps",
    "excludeDate",
    "renderDay",
    "hideOutsideDates",
    "hideWeekdays",
    "getDayAriaLabel",
    "monthLabelFormat",
    "nextIcon",
    "previousIcon",
    "__onDayClick",
    "__onDayMouseEnter",
    "withCellSpacing",
    "monthsListFormat",
    "getMonthControlProps",
    "yearLabelFormat",
    "yearsListFormat",
    "getYearControlProps",
    "decadeLabelFormat",
    "minDate",
    "maxDate",
    "locale",
    "className",
    "classNames",
    "styles",
    "__staticSelector",
    "unstyled",
    "variant",
    "size",
    "__preventFocus",
    "__stopPropagation",
    "onNextDecade",
    "onPreviousDecade",
    "onNextYear",
    "onPreviousYear",
    "onNextMonth",
    "onPreviousMonth",
    "static"
  ]), { classes: Ie, cx: er } = N1e(null, {
    name: ["Calendar", ge],
    classNames: te,
    styles: ae,
    unstyled: G,
    variant: oe,
    size: ne
  }), [Ke, Me] = Hr({
    value: i ? ri(i, o, n) : void 0,
    defaultValue: a ? ri(a, o, n) : void 0,
    finalValue: ri(void 0, o, n),
    onChange: l
  }), [Pe, Qe] = Hr({
    value: s,
    defaultValue: u,
    finalValue: null,
    onChange: d
  }), Sr = {
    __staticSelector: ge || "Calendar",
    styles: ae,
    classNames: te,
    unstyled: G,
    variant: oe,
    size: ne
  }, Cr = p || f || 1, nr = Pe || /* @__PURE__ */ new Date(), De = () => {
    const ar = je(nr).add(Cr, "month").toDate();
    xe == null || xe(ar), Qe(ar);
  }, Ge = () => {
    const ar = je(nr).subtract(Cr, "month").toDate();
    Le == null || Le(ar), Qe(ar);
  }, lr = () => {
    const ar = je(nr).add(Cr, "year").toDate();
    He == null || He(ar), Qe(ar);
  }, Ir = () => {
    const ar = je(nr).subtract(Cr, "year").toDate();
    he == null || he(ar), Qe(ar);
  }, Or = () => {
    const ar = je(nr).add(10 * Cr, "year").toDate();
    Te == null || Te(ar), Qe(ar);
  }, $r = () => {
    const ar = je(nr).subtract(10 * Cr, "year").toDate();
    we == null || we(ar), Qe(ar);
  };
  return /* @__PURE__ */ E.createElement(We, kl({
    className: er(Ie.calendar, q),
    ref: r
  }, me), Ke === "month" && /* @__PURE__ */ E.createElement(n$, kl({
    month: nr,
    minDate: J,
    maxDate: Q,
    firstDayOfWeek: x,
    weekdayFormat: b,
    weekendDays: O,
    getDayProps: _,
    excludeDate: P,
    renderDay: S,
    hideOutsideDates: I,
    hideWeekdays: N,
    getDayAriaLabel: k,
    onNext: De,
    onPrevious: Ge,
    hasNextLevel: n !== "month",
    onLevelClick: () => Me("year"),
    numberOfColumns: f,
    locale: se,
    levelControlAriaLabel: g == null ? void 0 : g.monthLevelControl,
    nextLabel: g == null ? void 0 : g.nextMonth,
    nextIcon: R,
    previousLabel: g == null ? void 0 : g.previousMonth,
    previousIcon: D,
    monthLabelFormat: j,
    __onDayClick: T,
    __onDayMouseEnter: V,
    __preventFocus: _e,
    __stopPropagation: ye,
    static: Ue,
    withCellSpacing: L
  }, Sr)), Ke === "year" && /* @__PURE__ */ E.createElement(v$, kl({
    year: nr,
    numberOfColumns: f,
    minDate: J,
    maxDate: Q,
    monthsListFormat: Z,
    getMonthControlProps: z,
    locale: se,
    onNext: lr,
    onPrevious: Ir,
    hasNextLevel: n !== "month" && n !== "year",
    onLevelClick: () => Me("decade"),
    levelControlAriaLabel: g == null ? void 0 : g.yearLevelControl,
    nextLabel: g == null ? void 0 : g.nextYear,
    nextIcon: R,
    previousLabel: g == null ? void 0 : g.previousYear,
    previousIcon: D,
    yearLabelFormat: W,
    __onControlMouseEnter: w,
    __onControlClick: (ar, cr) => {
      C && Qe(cr), Me(ri("month", o, n)), v == null || v(cr);
    },
    __preventFocus: _e,
    __stopPropagation: ye,
    withCellSpacing: L
  }, Sr)), Ke === "decade" && /* @__PURE__ */ E.createElement(P$, kl({
    decade: nr,
    minDate: J,
    maxDate: Q,
    yearsListFormat: U,
    getYearControlProps: re,
    locale: se,
    onNext: Or,
    onPrevious: $r,
    numberOfColumns: f,
    nextLabel: g == null ? void 0 : g.nextDecade,
    nextIcon: R,
    previousLabel: g == null ? void 0 : g.previousDecade,
    previousIcon: D,
    decadeLabelFormat: X,
    __onControlMouseEnter: y,
    __onControlClick: (ar, cr) => {
      $ && Qe(cr), Me(ri("year", o, n)), h == null || h(cr);
    },
    __preventFocus: _e,
    __stopPropagation: ye,
    withCellSpacing: L
  }, Sr)));
});
w2.displayName = "@mantine/dates/Calendar";
var Ev = Object.getOwnPropertySymbols, $0e = Object.prototype.hasOwnProperty, O0e = Object.prototype.propertyIsEnumerable, P0e = (e, r) => {
  var t = {};
  for (var n in e)
    $0e.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Ev)
    for (var n of Ev(e))
      r.indexOf(n) < 0 && O0e.call(e, n) && (t[n] = e[n]);
  return t;
};
function E$(e) {
  const r = e, {
    maxLevel: t,
    minLevel: n,
    defaultLevel: o,
    level: a,
    onLevelChange: i,
    nextIcon: l,
    previousIcon: s,
    date: u,
    defaultDate: d,
    onDateChange: f,
    numberOfColumns: p,
    columnsToScroll: g,
    ariaLabels: h,
    onYearSelect: v,
    onMonthSelect: y,
    onYearMouseEnter: w,
    onMonthMouseEnter: $,
    onNextMonth: C,
    onPreviousMonth: x,
    onNextYear: b,
    onPreviousYear: O,
    onNextDecade: _,
    onPreviousDecade: P,
    withCellSpacing: S,
    __updateDateOnYearSelect: I,
    __updateDateOnMonthSelect: N,
    firstDayOfWeek: k,
    weekdayFormat: j,
    weekendDays: R,
    getDayProps: D,
    excludeDate: T,
    renderDay: V,
    hideOutsideDates: L,
    hideWeekdays: Z,
    getDayAriaLabel: z,
    monthLabelFormat: W,
    monthsListFormat: U,
    getMonthControlProps: re,
    yearLabelFormat: X,
    yearsListFormat: J,
    getYearControlProps: Q,
    decadeLabelFormat: se,
    allowSingleDateInRange: q,
    allowDeselect: te,
    minDate: ae,
    maxDate: ge,
    locale: G
  } = r, oe = P0e(r, [
    "maxLevel",
    "minLevel",
    "defaultLevel",
    "level",
    "onLevelChange",
    "nextIcon",
    "previousIcon",
    "date",
    "defaultDate",
    "onDateChange",
    "numberOfColumns",
    "columnsToScroll",
    "ariaLabels",
    "onYearSelect",
    "onMonthSelect",
    "onYearMouseEnter",
    "onMonthMouseEnter",
    "onNextMonth",
    "onPreviousMonth",
    "onNextYear",
    "onPreviousYear",
    "onNextDecade",
    "onPreviousDecade",
    "withCellSpacing",
    "__updateDateOnYearSelect",
    "__updateDateOnMonthSelect",
    "firstDayOfWeek",
    "weekdayFormat",
    "weekendDays",
    "getDayProps",
    "excludeDate",
    "renderDay",
    "hideOutsideDates",
    "hideWeekdays",
    "getDayAriaLabel",
    "monthLabelFormat",
    "monthsListFormat",
    "getMonthControlProps",
    "yearLabelFormat",
    "yearsListFormat",
    "getYearControlProps",
    "decadeLabelFormat",
    "allowSingleDateInRange",
    "allowDeselect",
    "minDate",
    "maxDate",
    "locale"
  ]);
  return {
    calendarProps: {
      maxLevel: t,
      minLevel: n,
      defaultLevel: o,
      level: a,
      onLevelChange: i,
      nextIcon: l,
      previousIcon: s,
      date: u,
      defaultDate: d,
      onDateChange: f,
      numberOfColumns: p,
      columnsToScroll: g,
      ariaLabels: h,
      onYearSelect: v,
      onMonthSelect: y,
      onYearMouseEnter: w,
      onMonthMouseEnter: $,
      onNextMonth: C,
      onPreviousMonth: x,
      onNextYear: b,
      onPreviousYear: O,
      onNextDecade: _,
      onPreviousDecade: P,
      withCellSpacing: S,
      __updateDateOnYearSelect: I,
      __updateDateOnMonthSelect: N,
      firstDayOfWeek: k,
      weekdayFormat: j,
      weekendDays: R,
      getDayProps: D,
      excludeDate: T,
      renderDay: V,
      hideOutsideDates: L,
      hideWeekdays: Z,
      getDayAriaLabel: z,
      monthLabelFormat: W,
      monthsListFormat: U,
      getMonthControlProps: re,
      yearLabelFormat: X,
      yearsListFormat: J,
      getYearControlProps: Q,
      decadeLabelFormat: se,
      allowSingleDateInRange: q,
      allowDeselect: te,
      minDate: ae,
      maxDate: ge,
      locale: G
    },
    others: oe
  };
}
function S0e({ date: e, maxDate: r, minDate: t }) {
  return !(e == null || Number.isNaN(e.getTime()) || r && je(e).isAfter(r, "date") || t && je(e).isBefore(t, "date"));
}
function I0e(e) {
  const r = new Date(e);
  return Number.isNaN(r.getTime()) || !e ? null : r;
}
function E0e(e, r) {
  if (r === "range" && Array.isArray(e)) {
    const [t, n] = e;
    return t ? n ? `${t.toISOString()} – ${n.toISOString()}` : `${t.toISOString()} –` : "";
  }
  return r === "multiple" && Array.isArray(e) ? e.map((t) => t.toISOString()).join(", ") : !Array.isArray(e) && e ? e.toISOString() : "";
}
function _2({ value: e, type: r, name: t, form: n }) {
  return /* @__PURE__ */ E.createElement("input", {
    type: "hidden",
    value: E0e(e, r),
    name: t,
    form: n
  });
}
_2.displayName = "@mantine/dates/HiddenDatesInput";
function R0e(e, r) {
  if (!e || !r)
    return r;
  const t = e.getHours(), n = e.getMinutes(), o = e.getSeconds(), a = e.getMilliseconds(), i = new Date(r);
  return i.setHours(t), i.setMinutes(n), i.setSeconds(o), i.setMilliseconds(a), i;
}
var A0e = Object.defineProperty, k0e = Object.defineProperties, M0e = Object.getOwnPropertyDescriptors, Tu = Object.getOwnPropertySymbols, R$ = Object.prototype.hasOwnProperty, A$ = Object.prototype.propertyIsEnumerable, Rv = (e, r, t) => r in e ? A0e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, po = (e, r) => {
  for (var t in r || (r = {}))
    R$.call(r, t) && Rv(e, t, r[t]);
  if (Tu)
    for (var t of Tu(r))
      A$.call(r, t) && Rv(e, t, r[t]);
  return e;
}, Ml = (e, r) => k0e(e, M0e(r)), N0e = (e, r) => {
  var t = {};
  for (var n in e)
    R$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Tu)
    for (var n of Tu(e))
      r.indexOf(n) < 0 && A$.call(e, n) && (t[n] = e[n]);
  return t;
};
const T0e = {
  valueFormat: "MMMM D, YYYY",
  fixOnBlur: !0,
  preserveTime: !0,
  size: "sm"
}, k$ = ue((e, r) => {
  const t = Ti("DateInput", T0e, e), {
    inputProps: n,
    wrapperProps: o,
    value: a,
    defaultValue: i,
    onChange: l,
    clearable: s,
    clearButtonProps: u,
    popoverProps: d,
    getDayProps: f,
    locale: p,
    valueFormat: g,
    dateParser: h,
    minDate: v,
    maxDate: y,
    fixOnBlur: w,
    onFocus: $,
    onBlur: C,
    onClick: x,
    readOnly: b,
    name: O,
    form: _,
    rightSection: P,
    unstyled: S,
    classNames: I,
    styles: N,
    allowDeselect: k,
    preserveTime: j,
    date: R,
    defaultDate: D,
    onDateChange: T
  } = t, V = N0e(t, [
    "inputProps",
    "wrapperProps",
    "value",
    "defaultValue",
    "onChange",
    "clearable",
    "clearButtonProps",
    "popoverProps",
    "getDayProps",
    "locale",
    "valueFormat",
    "dateParser",
    "minDate",
    "maxDate",
    "fixOnBlur",
    "onFocus",
    "onBlur",
    "onClick",
    "readOnly",
    "name",
    "form",
    "rightSection",
    "unstyled",
    "classNames",
    "styles",
    "allowDeselect",
    "preserveTime",
    "date",
    "defaultDate",
    "onDateChange"
  ]), { calendarProps: L, others: Z } = E$(V), z = Dn(), U = h || ((he) => {
    const xe = je(he, g, z.getLocale(p)).toDate();
    return Number.isNaN(xe.getTime()) ? I0e(he) : xe;
  }), re = k !== void 0 ? k : s, X = (he) => he ? je(he).locale(z.getLocale(p)).format(g) : "", [J, Q, se] = Hr({
    value: a,
    defaultValue: i,
    finalValue: null,
    onChange: l
  }), [q, te] = Hr({
    value: R,
    defaultValue: i || D,
    finalValue: null,
    onChange: T
  });
  Fe(() => {
    se && te(a);
  }, [se, a]);
  const [ae, ge] = Se(X(J));
  Fe(() => {
    ge(X(J));
  }, [z.getLocale(p)]);
  const [G, oe] = Se(!1), ne = (he) => {
    const xe = he.currentTarget.value;
    if (ge(xe), xe.trim() === "" && s)
      Q(null);
    else {
      const Le = U(xe);
      S0e({ date: Le, minDate: v, maxDate: y }) && (Q(Le), te(Le));
    }
  }, _e = (he) => {
    C == null || C(he), oe(!1), w && ge(X(J));
  }, ye = (he) => {
    $ == null || $(he), oe(!0);
  }, Te = (he) => {
    x == null || x(he), oe(!0);
  }, we = (he) => Ml(po({}, f == null ? void 0 : f(he)), {
    selected: je(J).isSame(he, "day"),
    onClick: () => {
      const xe = j ? R0e(J, he) : he, Le = s && re && je(J).isSame(he, "day") ? null : xe;
      Q(Le), !se && ge(X(Le)), oe(!1);
    }
  }), He = P || (s && J && !b ? /* @__PURE__ */ E.createElement(Ai, po({
    variant: "transparent",
    onMouseDown: (he) => he.preventDefault(),
    tabIndex: -1,
    onClick: () => {
      Q(null), !se && ge(""), oe(!1);
    },
    unstyled: S
  }, u)) : null);
  return ct(() => {
    a !== void 0 && !G && ge(X(a));
  }, [a]), /* @__PURE__ */ E.createElement(E.Fragment, null, /* @__PURE__ */ E.createElement(jr.Wrapper, Ml(po({}, o), {
    __staticSelector: "DateInput"
  }), /* @__PURE__ */ E.createElement(nt, po({
    opened: G,
    trapFocus: !1,
    position: "bottom-start",
    disabled: b,
    withRoles: !1
  }, d), /* @__PURE__ */ E.createElement(nt.Target, null, /* @__PURE__ */ E.createElement(jr, Ml(po(po({
    "data-dates-input": !0,
    "data-read-only": b || void 0,
    autoComplete: "off",
    ref: r,
    value: ae,
    onChange: ne,
    onBlur: _e,
    onFocus: ye,
    onClick: Te,
    readOnly: b,
    rightSection: He
  }, n), Z), {
    __staticSelector: "DateInput"
  }))), /* @__PURE__ */ E.createElement(nt.Dropdown, {
    onMouseDown: (he) => he.preventDefault(),
    "data-dates-dropdown": !0
  }, /* @__PURE__ */ E.createElement(w2, Ml(po({
    __staticSelector: "DateInput"
  }, L), {
    classNames: I,
    styles: N,
    unstyled: S,
    __preventFocus: !0,
    minDate: v,
    maxDate: y,
    locale: p,
    getDayProps: we,
    size: n.size,
    date: q,
    onDateChange: te
  }))))), /* @__PURE__ */ E.createElement(_2, {
    name: O,
    form: _,
    value: J,
    type: "default"
  }));
});
k$.displayName = "@mantine/dates/DateInput";
const Av = (e) => e === "range" ? [null, null] : e === "multiple" ? [] : null;
function M$({
  type: e,
  value: r,
  defaultValue: t,
  onChange: n
}) {
  const o = Ve(e), [a, i] = Hr({
    value: r,
    defaultValue: t,
    onChange: n,
    finalValue: Av(e)
  });
  let l = a;
  if (o.current !== e) {
    if (o.current = e, r === void 0)
      l = t !== void 0 ? t : Av(e), i(l);
    else if (process.env.NODE_ENV === "development")
      switch (e) {
        case "default":
          r !== null && typeof r != "string" && console.error("[@mantine/dates/use-uncontrolled-dates] Value must be type of `null` or `string`");
          break;
        case "multiple":
          r instanceof Array || console.error("[@mantine/dates/use-uncontrolled-dates] Value must be type of `string[]`");
          break;
        case "range":
          (!(r instanceof Array) || r.length !== 2) && console.error("[@mantine/dates/use-uncontrolled-dates] Value must be type of `[string, string]`");
          break;
      }
  }
  return [l, i];
}
function kv(e, r) {
  const t = [...r].sort((n, o) => n.getTime() - o.getTime());
  return je(t[0]).startOf("day").subtract(1, "ms").isBefore(e) && je(t[1]).endOf("day").add(1, "ms").isAfter(e);
}
function D0e({
  type: e,
  level: r,
  value: t,
  defaultValue: n,
  onChange: o,
  allowSingleDateInRange: a,
  allowDeselect: i,
  onMouseLeave: l
}) {
  const [s, u] = M$({ type: e, value: t, defaultValue: n, onChange: o }), [d, f] = Se(e === "range" && s[0] && !s[1] ? s[0] : null), [p, g] = Se(null), h = (b) => {
    if (e === "range") {
      if (d instanceof Date && !s[1]) {
        if (je(b).isSame(d, r) && !a) {
          f(null), g(null), u([null, null]);
          return;
        }
        const O = [b, d];
        O.sort((_, P) => _.getTime() - P.getTime()), u(O), g(null), f(null);
        return;
      }
      if (s[0] && !s[1] && je(b).isSame(s[0], r) && !a) {
        f(null), g(null), u([null, null]);
        return;
      }
      u([b, null]), g(null), f(b);
      return;
    }
    if (e === "multiple") {
      s.some((O) => je(O).isSame(b, r)) ? u(s.filter((O) => !je(O).isSame(b, r))) : u([...s, b]);
      return;
    }
    s && i && je(b).isSame(s, r) ? u(null) : u(b);
  }, v = (b) => d instanceof Date && p instanceof Date ? kv(b, [p, d]) : s[0] instanceof Date && s[1] instanceof Date ? kv(b, s) : !1, y = e === "range" ? (b) => {
    l == null || l(b), g(null);
  } : l, w = (b) => s[0] instanceof Date && je(b).isSame(s[0], r) ? !(p && je(p).isBefore(s[0])) : !1, $ = (b) => s[1] instanceof Date ? je(b).isSame(s[1], r) : !(s[0] instanceof Date) || !p ? !1 : je(p).isBefore(s[0]) && je(b).isSame(s[0], r);
  return {
    onDateChange: h,
    onRootMouseLeave: y,
    onHoveredDateChange: e === "range" && d ? g : () => {
    },
    getControlProps: (b) => {
      if (e === "range")
        return {
          selected: s.some((_) => _ && je(_).isSame(b, r)),
          inRange: v(b),
          firstInRange: w(b),
          lastInRange: $(b),
          "data-autofocus": !!s[0] && je(s[0]).isSame(b, r) || void 0
        };
      if (e === "multiple")
        return {
          selected: s.some((_) => _ && je(_).isSame(b, r)),
          "data-autofocus": !!s[0] && je(s[0]).isSame(b, r) || void 0
        };
      const O = je(s).isSame(b, r);
      return { selected: O, "data-autofocus": O || void 0 };
    },
    _value: s,
    setValue: u
  };
}
function j0e({
  type: e,
  date: r,
  locale: t,
  format: n,
  labelSeparator: o
}) {
  const a = (i) => je(i).locale(t).format(n);
  return e === "default" ? r === null ? "" : a(r) : e === "multiple" ? r.map(a).join(", ") : e === "range" ? r[0] && r[1] ? `${a(r[0])} ${o} ${a(r[1])}` : r[0] ? `${a(r[0])} ${o} ` : "" : "";
}
function L0e({
  type: e,
  value: r,
  defaultValue: t,
  onChange: n,
  locale: o,
  format: a,
  closeOnChange: i,
  sortDates: l,
  labelSeparator: s
}) {
  const u = Dn(), [d, f] = H0(!1), [p, g] = M$({
    type: e,
    value: r,
    defaultValue: t,
    onChange: n
  }), h = j0e({
    type: e,
    date: p,
    locale: u.getLocale(o),
    format: a,
    labelSeparator: u.getLabelSeparator(s)
  }), v = ($) => {
    i && (e === "default" && f.close(), e === "range" && $[0] && $[1] && f.close()), g(l && e === "multiple" ? [...$].sort((C, x) => C.getTime() - x.getTime()) : $);
  }, y = () => v(e === "range" ? [null, null] : e === "multiple" ? [] : null), w = e === "range" ? !!p[0] : e === "multiple" ? p.length > 0 : p !== null;
  return {
    _value: p,
    setValue: v,
    onClear: y,
    shouldClear: w,
    formattedValue: h,
    dropdownOpened: d,
    dropdownHandlers: f
  };
}
function Mv({ minDate: e, maxDate: r }) {
  const t = /* @__PURE__ */ new Date();
  return !e && !r ? t : je(t).isBefore(e) ? e : je(t).isAfter(r) ? r : t;
}
var z0e = Ae(() => ({
  placeholder: {},
  input: {
    cursor: "pointer",
    lineHeight: "unset",
    "&[data-read-only]": {
      cursor: "default"
    }
  }
}));
const V0e = z0e;
var F0e = Object.defineProperty, Z0e = Object.defineProperties, W0e = Object.getOwnPropertyDescriptors, Du = Object.getOwnPropertySymbols, N$ = Object.prototype.hasOwnProperty, T$ = Object.prototype.propertyIsEnumerable, Nv = (e, r, t) => r in e ? F0e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, go = (e, r) => {
  for (var t in r || (r = {}))
    N$.call(r, t) && Nv(e, t, r[t]);
  if (Du)
    for (var t of Du(r))
      T$.call(r, t) && Nv(e, t, r[t]);
  return e;
}, Tv = (e, r) => Z0e(e, W0e(r)), B0e = (e, r) => {
  var t = {};
  for (var n in e)
    N$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Du)
    for (var n of Du(e))
      r.indexOf(n) < 0 && T$.call(e, n) && (t[n] = e[n]);
  return t;
};
const H0e = {}, D$ = ue((e, r) => {
  const t = Ti("PickerInputBase", H0e, e), {
    inputProps: n,
    wrapperProps: o,
    placeholder: a,
    classNames: i,
    styles: l,
    unstyled: s,
    popoverProps: u,
    modalProps: d,
    dropdownType: f,
    children: p,
    formattedValue: g,
    dropdownHandlers: h,
    dropdownOpened: v,
    onClick: y,
    clearable: w,
    onClear: $,
    clearButtonProps: C,
    rightSection: x,
    shouldClear: b,
    readOnly: O,
    disabled: _,
    value: P,
    name: S,
    form: I,
    type: N
  } = t, k = B0e(t, [
    "inputProps",
    "wrapperProps",
    "placeholder",
    "classNames",
    "styles",
    "unstyled",
    "popoverProps",
    "modalProps",
    "dropdownType",
    "children",
    "formattedValue",
    "dropdownHandlers",
    "dropdownOpened",
    "onClick",
    "clearable",
    "onClear",
    "clearButtonProps",
    "rightSection",
    "shouldClear",
    "readOnly",
    "disabled",
    "value",
    "name",
    "form",
    "type"
  ]), { classes: j, cx: R } = V0e(null, {
    name: n.__staticSelector,
    classNames: i,
    styles: l,
    unstyled: s,
    variant: n.variant,
    size: n.size
  }), D = x || (w && b && !O && !_ ? /* @__PURE__ */ E.createElement(Ai, go({
    variant: "transparent",
    onClick: $,
    unstyled: s,
    size: n.size
  }, C)) : null), T = () => {
    N === "range" && P[0] && !P[1] && $(), h.close();
  }, V = o.label;
  return /* @__PURE__ */ E.createElement(E.Fragment, null, f === "modal" && !O && /* @__PURE__ */ E.createElement(gn, go({
    opened: v,
    onClose: T,
    withCloseButton: !1,
    size: "auto",
    "data-dates-modal": !0,
    unstyled: s
  }, d), p), /* @__PURE__ */ E.createElement(jr.Wrapper, go({}, o), /* @__PURE__ */ E.createElement(nt, go({
    position: "bottom-start",
    opened: v,
    onClose: T,
    disabled: f === "modal" || O,
    trapFocus: !0,
    returnFocus: !0,
    unstyled: s
  }, u), /* @__PURE__ */ E.createElement(nt.Target, {
    shouldOverrideDefaultTargetId: !V
  }, /* @__PURE__ */ E.createElement(jr, go(Tv(go({
    "aria-label": g,
    "data-dates-input": !0,
    "data-read-only": O || void 0,
    disabled: _,
    component: "button",
    type: "button",
    multiline: !0,
    onClick: (L) => {
      y == null || y(L), h.toggle();
    },
    rightSection: D
  }, n), {
    ref: r,
    classNames: Tv(go({}, i), { input: R(j.input, i == null ? void 0 : i.input) })
  }), k), g || /* @__PURE__ */ E.createElement(jr.Placeholder, {
    className: j.placeholder,
    sx: { color: n.error ? "inherit" : void 0 }
  }, a))), /* @__PURE__ */ E.createElement(nt.Dropdown, {
    "data-dates-dropdown": !0
  }, p))), /* @__PURE__ */ E.createElement(_2, {
    value: P,
    name: S,
    form: I,
    type: N
  }));
});
D$.displayName = "@mantine/dates/PickerInputBase";
var G0e = Object.defineProperty, ju = Object.getOwnPropertySymbols, j$ = Object.prototype.hasOwnProperty, L$ = Object.prototype.propertyIsEnumerable, Dv = (e, r, t) => r in e ? G0e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Bd = (e, r) => {
  for (var t in r || (r = {}))
    j$.call(r, t) && Dv(e, t, r[t]);
  if (ju)
    for (var t of ju(r))
      L$.call(r, t) && Dv(e, t, r[t]);
  return e;
}, X0e = (e, r) => {
  var t = {};
  for (var n in e)
    j$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && ju)
    for (var n of ju(e))
      r.indexOf(n) < 0 && L$.call(e, n) && (t[n] = e[n]);
  return t;
};
const Y0e = {
  type: "default"
}, z$ = ue((e, r) => {
  const t = Oe("MonthPicker", Y0e, e), {
    type: n,
    defaultValue: o,
    value: a,
    onChange: i,
    __staticSelector: l,
    getMonthControlProps: s,
    allowSingleDateInRange: u,
    allowDeselect: d,
    onMouseLeave: f,
    onMonthSelect: p
  } = t, g = X0e(t, [
    "type",
    "defaultValue",
    "value",
    "onChange",
    "__staticSelector",
    "getMonthControlProps",
    "allowSingleDateInRange",
    "allowDeselect",
    "onMouseLeave",
    "onMonthSelect"
  ]), { onDateChange: h, onRootMouseLeave: v, onHoveredDateChange: y, getControlProps: w } = D0e({
    type: n,
    level: "month",
    allowDeselect: d,
    allowSingleDateInRange: u,
    value: a,
    defaultValue: o,
    onChange: i,
    onMouseLeave: f
  });
  return /* @__PURE__ */ E.createElement(w2, Bd({
    ref: r,
    minLevel: "year",
    __updateDateOnMonthSelect: !1,
    __staticSelector: l || "MonthPicker",
    onMouseLeave: v,
    onMonthMouseEnter: ($, C) => y(C),
    onMonthSelect: ($) => {
      h($), p == null || p($);
    },
    getMonthControlProps: ($) => Bd(Bd({}, w($)), s == null ? void 0 : s($))
  }, g));
});
z$.displayName = "@mantine/dates/MonthPicker";
var U0e = Object.defineProperty, J0e = Object.defineProperties, q0e = Object.getOwnPropertyDescriptors, Lu = Object.getOwnPropertySymbols, V$ = Object.prototype.hasOwnProperty, F$ = Object.prototype.propertyIsEnumerable, jv = (e, r, t) => r in e ? U0e(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Lv = (e, r) => {
  for (var t in r || (r = {}))
    V$.call(r, t) && jv(e, t, r[t]);
  if (Lu)
    for (var t of Lu(r))
      F$.call(r, t) && jv(e, t, r[t]);
  return e;
}, K0e = (e, r) => J0e(e, q0e(r)), Q0e = (e, r) => {
  var t = {};
  for (var n in e)
    V$.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Lu)
    for (var n of Lu(e))
      r.indexOf(n) < 0 && F$.call(e, n) && (t[n] = e[n]);
  return t;
};
const efe = {
  type: "default",
  valueFormat: "MMMM YYYY",
  closeOnChange: !0,
  sortDates: !0,
  dropdownType: "popover"
}, Z$ = ue((e, r) => {
  const t = Oe("MonthPickerInput", efe, e), {
    type: n,
    value: o,
    defaultValue: a,
    onChange: i,
    valueFormat: l,
    labelSeparator: s,
    locale: u,
    classNames: d,
    styles: f,
    unstyled: p,
    closeOnChange: g,
    variant: h,
    size: v,
    dropdownType: y,
    sortDates: w,
    minDate: $,
    maxDate: C
  } = t, x = Q0e(t, [
    "type",
    "value",
    "defaultValue",
    "onChange",
    "valueFormat",
    "labelSeparator",
    "locale",
    "classNames",
    "styles",
    "unstyled",
    "closeOnChange",
    "variant",
    "size",
    "dropdownType",
    "sortDates",
    "minDate",
    "maxDate"
  ]), { calendarProps: b, others: O } = E$(x), {
    _value: _,
    setValue: P,
    formattedValue: S,
    dropdownHandlers: I,
    dropdownOpened: N,
    onClear: k,
    shouldClear: j
  } = L0e({
    type: n,
    value: o,
    defaultValue: a,
    onChange: i,
    locale: u,
    format: l,
    labelSeparator: s,
    closeOnChange: g,
    sortDates: w
  });
  return /* @__PURE__ */ E.createElement(D$, Lv({
    formattedValue: S,
    dropdownOpened: N,
    dropdownHandlers: I,
    classNames: d,
    styles: f,
    unstyled: p,
    __staticSelector: "MonthPickerInput",
    ref: r,
    onClear: k,
    shouldClear: j,
    value: _,
    type: n,
    variant: h,
    size: v,
    dropdownType: y
  }, O), /* @__PURE__ */ E.createElement(z$, K0e(Lv({}, b), {
    type: n,
    value: _,
    defaultDate: Array.isArray(_) ? _[0] || Mv({ maxDate: C, minDate: $ }) : _ || Mv({ maxDate: C, minDate: $ }),
    onChange: P,
    locale: u,
    classNames: d,
    styles: f,
    unstyled: p,
    __staticSelector: "MonthPickerInput",
    __stopPropagation: y === "popover",
    variant: h,
    size: v,
    minDate: $,
    maxDate: C
  })));
});
Z$.displayName = "@mantine/dates/MonthPickerInput";
var rfe = { exports: {} };
(function(e, r) {
  (function(t, n) {
    e.exports = n(Lx);
  })(Mo, function(t) {
    function n(i) {
      return i && typeof i == "object" && "default" in i ? i : { default: i };
    }
    var o = n(t), a = { name: "pt-br", weekdays: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"), weekdaysShort: "dom_seg_ter_qua_qui_sex_sáb".split("_"), weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"), months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"), monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"), ordinal: function(i) {
      return i + "º";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY [às] HH:mm", LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm" }, relativeTime: { future: "em %s", past: "há %s", s: "poucos segundos", m: "um minuto", mm: "%d minutos", h: "uma hora", hh: "%d horas", d: "um dia", dd: "%d dias", M: "um mês", MM: "%d meses", y: "um ano", yy: "%d anos" } };
    return o.default.locale(a, null, !0), a;
  });
})(rfe);
var W$ = { exports: {} };
(function(e, r) {
  (function(t, n) {
    e.exports = n();
  })(Mo, function() {
    return function(t, n, o) {
      o.updateLocale = function(a, i) {
        var l = o.Ls[a];
        if (l)
          return (i ? Object.keys(i) : []).forEach(function(s) {
            l[s] = i[s];
          }), l;
      };
    };
  });
})(W$);
var tfe = W$.exports;
const B$ = /* @__PURE__ */ Qn(tfe), Hd = (e) => M`
  display: grid;
  grid-template-columns: repeat(3, 78px);
  gap: ${e.spacing.xs};
`, zv = (e) => M`
  color: ${e.colors.neutral[400]};
  font-family: ${e.typography.label.fontFamily};
  border: 1px solid ${e.colors.neutral[200]};
  border-radius: ${e.border.radius.full};
`, Nl = (e) => M`
  background-color: ${e.colors.brand.primary[100]};
  border-color: ${e.colors.brand.primary[300]};
  border-radius: ${e.border.radius.full};
  color: ${e.colors.brand.primary[300]};
`, nfe = Ne({
  container: (e, {
    fullWidth: r
  }) => M`
    position: relative;
    padding: 0;
    width: fit-content;
    height: 44px;
    width: ${r ? "100%" : "232px"};
    ${Tn}

    &:focus-within {
      > fieldset {
        border: 1.5px solid ${e.colors.brand.primary[300]};
      }
    }

    &:has(input:disabled) {
      cursor: not-allowed;
    }

    &:has(input:disabled) .mantine-Input-rightSection {
      display: flex;
    }
  `,
  fieldset: (e, {
    dataEntered: r,
    disabled: t,
    error: n
  }) => M`
    position: absolute;
    margin: 0;
    padding: 0 12px;
    inset: -5px 0 0;
    border-radius: ${e.border.radius.lg};
    border: 1.5px solid
      ${Na(e, r, void 0, !!n, t)};
  `,
  label: (e, {
    disabled: r,
    error: t
  }) => M`
    padding: 0 4px;
    z-index: 1;
    font-family: ${e.typography.label.fontFamily};
    color: ${yt(e, r, t)};
    font-weight: ${e.fontWeights.normal};
    font-size: ${e.fontSizes.sm};
  `,
  input: (e) => M`
    padding: 0 42px 0 16px;
    height: 44px;
    font-family: ${e.typography.label.fontFamily};
    color: ${e.colors.neutral[500]};
    border: none;
    box-sizing: border-box;
    height: 46px;

    &[data-disabled] {
      background-color: transparent;
    }

    &[data-invalid] {
      color: ${e.colors.feedback.error[300]};
    }

    &[data-invalid]::placeholder {
      color: ${e.colors.feedback.error[300]};
    }

    &::placeholder {
      color: ${e.colors.neutral[200]};
    }

    &:focus {
      border-color: ${e.colors.brand.primary[300]};
    }
  `,
  disabled: (e) => M`
    &:disabled {
      cursor: not-allowed;
    }

    &::placeholder {
      color: ${e.colors.neutral[200]};
    }
  `,
  error: (e) => M`
    color: ${e.colors.feedback.error[300]};
    font-size: ${e.fontSizes.xs};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    position: absolute;
    top: 48px;
  `,
  invalid: (e) => M`
    border-color: ${e.colors.feedback.error[300]};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    color: ${e.colors.feedback.error[300]};

    &::placeholder {
      color: ${e.colors.feedback.error[300]};
    }
  `,
  rightSection: (e, {
    disabled: r
  }) => M`
    pointer-events: none;
    color: ${e.colors.neutral[500]};
    margin-right: ${e.spacing.xxs};
    cursor: ${r && "not-allowed"};

    svg {
      width: 22px;
      height: 22px;
    }

    path {
      fill: ${e.colors.neutral[200]};
    }
  `,
  dropdown: (e) => M`
    border-radius: ${e.border.radius.lg};
    box-shadow: ${e.shadow.level3};
    border: none;
    width: 326px !important;
    padding: ${e.spacing.xs} ${e.spacing.sm};
  `,
  calendarBase: M`
    max-width: 280px;
  `,
  weekday: (e) => M`
    font-weight: ${e.fontWeights.normal};
    text-transform: lowercase;
    font-family: ${e.typography.label.fontFamily};
    color: ${e.colors.brand.primary[500]};
  `,
  day: (e) => M`
    color: ${e.colors.neutral[400]};
    font-family: ${e.typography.label.fontFamily};
    width: 40px;
    height: 40px;

    &:hover {
      background-color: ${e.colors.brand.primary[100]};
      color: ${e.colors.brand.primary[300]};
    }

    &[data-selected='true'] {
      background-color: ${e.colors.brand.primary[300]};

      &:hover {
        background-color: ${e.colors.brand.primary[100]};
      }
    }

    &[data-weekend='true'] {
      color: ${e.colors.neutral[400]};

      &:hover {
        color: ${e.colors.brand.primary[300]};
      }
    }

    &[data-outside='true'] {
      color: ${e.colors.neutral[200]};
    }

    &[data-selected='true'] {
      color: ${e.colors.background.white};
    }
  `,
  calendarHeader: (e) => M`
    margin-bottom: ${e.spacing.sm};
  `,
  calendarHeaderLevelIcon: M`
    display: none;
  `,
  calendarHeaderLevel: (e) => M`
    color: ${e.colors.brand.primary[300]};
    text-decoration: underline;
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.bold};

    &:hover {
      background-color: transparent;
    }
  `,
  monthPickerControls: (e) => M`
    ${Hd(e)};
  `,
  monthsListRow: (e) => M`
    ${Hd(e)}
  `,
  monthsList: (e) => M`
    tbody {
      display: grid;
      gap: ${e.spacing.xs};
    }
  `,
  pickerControl: (e) => M`
    ${zv(e)};

    &:hover {
      ${Nl(e)};
    }
  `,
  monthPickerControlActive: (e) => M`
    ${Nl(e)};

    &:hover {
      background-color: ${e.colors.brand.primary[100]};
      color: ${e.colors.brand.primary[300]};
    }
  `,
  yearsListRow: (e) => M`
    ${Hd(e)}
  `,
  yearsList: (e) => M`
    tbody {
      display: grid;
      gap: ${e.spacing.xs};
    }
  `,
  yearPickerControl: (e) => M`
    ${zv(e)};

    &:hover {
      ${Nl(e)};
    }
  `,
  yearPickerControlActive: (e) => M`
    ${Nl(e)};

    &:hover {
      background-color: ${e.colors.brand.primary[100]};
      color: ${e.colors.brand.primary[300]};
    }
  `
}), ofe = ue((e, r) => {
  const {
    id: t,
    onChange: n,
    disabled: o,
    fullWidth: a,
    error: i,
    label: l,
    withinPortal: s = !0,
    excludeDate: u,
    cy: d,
    placeholder: f,
    ...p
  } = e, g = ke(t), [h, v] = Se(!1), y = nfe({
    dataEntered: h,
    disabled: o,
    fullWidth: a,
    error: i
  });
  je.extend(B$), je.updateLocale("pt-br", {
    weekdaysMin: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"]
  });
  const w = $e((C) => {
    const x = C.replace(/\D/g, "").replace(/\//g, ""), b = x.substring(0, 2), O = x.substring(2, 4), _ = x.substring(4, 8);
    return /* @__PURE__ */ new Date(`${_}/${O}/${b}`);
  }, []), $ = (C) => {
    v(!!C), n && n(C);
  };
  return /* @__PURE__ */ Y("div", { css: y.container, "data-cy": Ee("datepicker-wrapper", d == null ? void 0 : d.wrapper), children: [
    /* @__PURE__ */ m("fieldset", { css: y.fieldset, children: /* @__PURE__ */ m("legend", { css: y.label, children: /* @__PURE__ */ m("label", { children: l }) }) }),
    /* @__PURE__ */ m(k$, { "aria-label": "datepicker", "data-cy": Ee("datepicker-input", d == null ? void 0 : d.input), id: g, variant: "unstyled", styles: y, disabled: o, onChange: $, maxLength: 10, placeholder: f, rightSection: /* @__PURE__ */ m(h2, { "aria-label": "calendar" }), valueFormat: "DD/MM/YYYY", locale: "pt-br", firstDayOfWeek: 0, error: i, dateParser: w, ref: r, popoverProps: {
      withinPortal: s
    }, excludeDate: u, ...p })
  ] });
});
ofe.displayName = "DatePicker";
const afe = (e, r, t, n) => n ? e.colors.feedback.error[300] : t ? e.colors.neutral[100] : r ? e.colors.brand.primary[300] : e.colors.neutral[200], ife = {
  small: M`
    height: 32px;
    padding: 1px 15px 0 8px;
  `,
  medium: M`
    height: 46px;
    padding: 0px 42px 0 14px;
  `
}, lfe = Ne({
  container: (e, {
    fullWidth: r,
    size: t,
    disabled: n
  }) => M`
    position: relative;
    padding: 0;
    width: ${r ? "100%" : "232px"};
    height: ${t === "medium" ? "44px" : "32px"};
    cursor: ${n ? "not-allowed" : "initial"};

    ${Tn}

    &:focus-within {
      > fieldset {
        border: 1.5px solid ${e.colors.brand.primary[300]};
      }
    }
  `,
  fieldset: (e, {
    label: r,
    hasData: t,
    disabled: n,
    error: o
  }) => M`
    position: absolute;
    margin: 0;
    padding: 0 12px;
    inset: ${r ? "-5px" : "1px"} 0 0;
    border-radius: ${e.border.radius.lg};
    border: 1.5px solid
      ${afe(e, t, n, o)};
  `,
  label: (e, {
    disabled: r,
    error: t
  }) => M`
    padding: 0 4px;
    z-index: 1;
    font-family: ${e.typography.label.fontFamily};
    font-size: ${e.fontSizes.sm};
    font-weight: ${e.fontWeights.normal};
    color: ${yt(e, r, t)};
  `,
  input: (e, {
    size: r,
    error: t,
    disabled: n
  }) => M`
    border-radius: ${e.border.radius.lg};
    font-family: ${e.typography.label.fontFamily};
    color: ${e.colors.neutral[400]};
    font-size: ${e.fontSizes.sm};
    font-weight: ${e.fontWeights.normal};

    ${ife[r]}

    &::placeholder {
      color: ${e.colors.neutral[200]};
    }

    &[data-disabled] {
      background-color: transparent;
      cursor: not-allowed;
    }

    &[data-invalid] {
      &::placeholder {
        font-family: ${e.typography.label.fontFamily};
        color: ${yt(e, n, t)};
      }
    }

    &:disabled {
      color: ${e.colors.neutral[200]};
      &::placeholder {
        color: ${e.colors.neutral[200]};
      }
    }

    &:focus {
      border-color: ${e.colors.brand.primary[500]};
    }
  `,
  dropdown: ({
    border: e,
    shadow: r
  }) => M`
    padding: 0;
    border-radius: ${e.radius.lg};
    box-shadow: ${r.level4};
  `,
  itemsWrapper: (e) => M`
    padding: ${e.spacing.xxs} 0;
  `,
  item: (e) => M`
    height: 38px;
    border-radius: ${e.border.radius.none};
    font-family: ${e.typography.label.fontFamily};
    color: ${e.colors.neutral[400]};

    &:hover {
      background-color: ${e.colors.brand.primary[100]};
      color: ${e.colors.brand.primary[300]};
    }

    &[data-selected='true'] {
      color: ${e.colors.brand.primary[300]};
      background-color: ${e.colors.brand.primary[100]};

      &:hover {
        background-color: ${e.colors.brand.primary[100]};
        color: ${e.colors.brand.primary[300]};
      }
    }
  `,
  rightSection: ({
    colors: e,
    border: r,
    spacing: t
  }, {
    disabled: n,
    size: o
  }) => M`
    border-radius: 0 ${r.radius.lg} ${r.radius.lg} 0;
    width: 42px;
    pointer-events: none;
    color: ${e.neutral[500]};
    margin-right: ${o === "medium" && t.xxs};
    padding-left: ${o === "small" && "10px"};

    path {
      fill: ${n ? e.neutral[200] : e.neutral[500]};
    }
  `,
  invalid: (e) => M`
    border-color: ${e.colors.feedback.error[300]};
    font-weight: ${e.fontWeights.normal};
    color: ${e.colors.feedback.error[300]};

    &::placeholder {
      color: ${e.colors.feedback.error[300]};
    }
  `,
  error: ({
    typography: e,
    colors: r,
    fontSizes: t
  }) => M`
    font-family: ${e.label.fontFamily};
    font-size: ${t.xs};
    color: ${r.feedback.error[300]};
  `,
  hovered: ({
    colors: e
  }) => M`
    background: ${e.brand.primary[100]};
    color: ${e.brand.primary[500]};
  `,
  disabled: ({
    colors: e
  }) => M`
    color: ${e.neutral[100]};
    border-color: ${e.neutral[100]};
  `
}), H$ = ue((e, r) => {
  const {
    fullWidth: t,
    disabled: n,
    label: o,
    error: a,
    onChange: i,
    size: l = "medium",
    cy: s,
    ...u
  } = e, [d, f] = Se(!1), p = lfe({
    fullWidth: t,
    hasData: d,
    disabled: n,
    label: o,
    error: a,
    size: l
  }), g = $e((h) => {
    h.length && f(!0), i && i(h);
  }, [i]);
  return /* @__PURE__ */ Y("div", { css: p.container, "data-cy": Ee("dropdown-wrapper", s == null ? void 0 : s.wrapper), children: [
    /* @__PURE__ */ m("fieldset", { css: p.fieldset, children: o && /* @__PURE__ */ m("legend", { css: p.label, children: /* @__PURE__ */ m("label", { children: o }) }) }),
    /* @__PURE__ */ m(ow, { "aria-label": "dropdown", "data-cy": Ee("dropdown-input", s == null ? void 0 : s.input), styles: p, error: a, disabled: n, rightSection: /* @__PURE__ */ m(Nn, { size: "medium", "aria-label": "arrow down" }), onChange: g, "data-testid": "hero-input-dropdown", variant: "unstyled", withinPortal: !0, ref: r, "data-clarity-mask": !0, ...u })
  ] });
});
H$.displayName = "Dropdown";
const sfe = (e, r) => r === "weak" ? e.colors.feedback.error[200] : r === "medium" ? e.colors.feedback.warning[200] : r === "strong" ? e.colors.feedback.success[200] : e.colors.neutral[100], cfe = (e, r) => r === "weak" ? e.colors.feedback.error[300] : r === "medium" ? e.colors.feedback.warning[300] : r === "strong" ? e.colors.feedback.success[300] : e.colors.neutral[100], ufe = (e) => {
  const r = {
    weak: "Fraca",
    medium: "Regular",
    strong: "Forte"
  };
  return r == null ? void 0 : r[e];
}, dfe = Ne({
  container: M`
    width: 100%;
  `,
  wrapper: (e, {
    fullWidth: r
  }) => M`
    display: flex;
    gap: ${e.spacing.xxs};
    width: ${r ? "100%" : "232px"};
  `,
  progressWrapper: (e) => M`
    margin-top: ${e.spacing.xxs};
    width: 100%;
    transition: all 0.3s ease-in-out;

    .weak {
      background-color: ${e.colors.feedback.error[300]};
    }

    .medium {
      background-color: ${e.colors.feedback.warning[300]};
    }

    .strong {
      background-color: ${e.colors.feedback.success[300]};
    }
  `,
  progress: (e, {
    strength: r
  }) => M`
    height: 4px;
    border-radius: 20px;
    background-color: ${sfe(e, r)};
  `,
  strengthMessage: (e, {
    strength: r
  }) => M`
    font-family: ${e.typography.label.fontFamily};
    display: inline-flex;
    font-size: ${e.fontSizes.xs};
    margin-top: ${e.spacing.xxs};
    color: ${cfe(e, r)};
  `
}), ffe = ({
  id: e,
  strength: r,
  fullWidth: t = !1
}) => {
  const n = dfe({
    strength: r,
    fullWidth: t
  }), o = ke(e), a = () => r === "weak" ? "weak" : "", i = () => r === "medium" ? "medium" : "", l = () => r === "strong" ? "strong" : "";
  return /* @__PURE__ */ Y("div", { id: o, css: n.container, children: [
    /* @__PURE__ */ Y("div", { css: n.wrapper, children: [
      /* @__PURE__ */ m("div", { css: n.progressWrapper, children: /* @__PURE__ */ m("div", { css: n.progress, className: `${a()}${i()}${l()}` }) }),
      /* @__PURE__ */ m("div", { css: n.progressWrapper, children: /* @__PURE__ */ m("div", { css: n.progress, className: `${i()}${l()}` }) }),
      /* @__PURE__ */ m("div", { css: n.progressWrapper, children: /* @__PURE__ */ m("div", { css: n.progress, className: `${l()}` }) })
    ] }),
    r && /* @__PURE__ */ m("span", { css: n.strengthMessage, children: ufe(r) })
  ] });
}, pfe = Ne({
  container: (e, {
    fullWidth: r
  }) => M`
    position: relative;
    padding: 0;
    width: fit-content;
    height: 44px;
    width: ${r ? "100%" : "232px"};

    ${Tn}

    &:focus-within {
      > fieldset {
        border: 1.5px solid ${e.colors.brand.primary[300]};
      }
    }
  `,
  fieldset: (e, {
    dataEntered: r,
    error: t,
    disabled: n
  }) => M`
    position: absolute;
    margin: 0;
    padding: 0 12px;
    inset: -5px 0 0;
    border-radius: ${e.border.radius.lg};
    border: 1.5px solid
      ${Na(e, r, !1, !!t, n)};
    cursor: ${n ? "not-allowed" : "initial"};
  `,
  label: (e, {
    disabled: r,
    error: t
  }) => M`
    padding: 0 4px;
    z-index: 1;
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    color: ${yt(e, r, t)};
    font-size: ${e.fontSizes.sm};
  `,
  input: (e, {
    disabled: r,
    error: t
  }) => M`
    font-family: ${e.typography.label.fontFamily};
    color: ${e.colors.neutral[500]};
    border: none;
    box-sizing: border-box;
    position: absolute;
    height: 46px;

    &[data-disabled] {
      background-color: transparent;
    }

    &[data-invalid] {
      color: ${yt(e, r, t)};
    }
  `,
  innerInput: (e, {
    disabled: r,
    error: t
  }) => M`
    padding: 12px 42px 0 16px;
    font-family: ${e.typography.label.fontFamily};

    &[data-invalid] {
      color: ${yt(e, r, t)};

      &::placeholder {
        color: ${yt(e, r, t)};
      }
    }

    &:disabled {
      background-color: transparent;
    }
    &::placeholder {
      color: ${e.colors.neutral[200]};
    }
  `,
  disabled: (e) => M`
    border-color: ${e.colors.neutral[100]};
    background-color: transparent;
    opacity: 1;

    &::placeholder {
      color: ${e.colors.neutral[200]};
    }
  `,
  error: (e) => M`
    color: ${e.colors.feedback.error[300]};
    font-size: ${e.fontSizes.xs};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    position: absolute;
    top: 48px;
  `,
  invalid: (e) => M`
    color: ${e.colors.feedback.error[300]};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};

    &::placeholder {
      color: ${e.colors.feedback.error[300]};
    }
  `,
  rightSection: (e, {
    error: r
  }) => M`
    color: ${e.colors.neutral[500]};
    cursor: pointer;
    margin-right: ${e.spacing.xxs};
    top: 24px;

    button {
      &:hover {
        background: transparent;
        border: none;
      }
    }

    path {
      fill: ${r ? e.colors.feedback.error[300] : e.colors.neutral[200]};
    }
  `
}), gfe = ue((e, r) => {
  const {
    fullWidth: t = !1,
    disabled: n = !1,
    onChange: o,
    strength: a,
    id: i,
    label: l,
    error: s,
    cy: u,
    ...d
  } = e, [f, p] = Se(!1), g = pfe({
    fullWidth: t,
    dataEntered: f,
    disabled: n,
    error: s
  }), h = ke(i), v = $e((w) => {
    var C;
    const $ = (C = w == null ? void 0 : w.currentTarget) == null ? void 0 : C.value;
    $ || typeof $ == "string" && ($ != null && $.length) ? p(!0) : p(!1), o && o(w);
  }, [o]);
  function y({
    reveal: w
  }) {
    return w ? /* @__PURE__ */ m(sx, { "data-testid": "eye-on" }) : /* @__PURE__ */ m(lx, { "data-testid": "eye-off" });
  }
  return /* @__PURE__ */ Y(Br, { children: [
    /* @__PURE__ */ Y("div", { css: g.container, "data-cy": Ee("inputPassword-wrapper", u == null ? void 0 : u.wrapper), children: [
      /* @__PURE__ */ m("fieldset", { css: g.fieldset, children: /* @__PURE__ */ m("legend", { css: g.label, children: /* @__PURE__ */ m("label", { children: l }) }) }),
      /* @__PURE__ */ m(yC, { "aria-label": "password-input", id: h, variant: "unstyled", styles: g, disabled: n, onChange: v, visibilityToggleIcon: y, "data-testid": "password-input", error: s, ref: r, "data-cy": Ee("inputPassword-input", u == null ? void 0 : u.input), "data-clarity-mask": !0, ...d })
    ] }),
    a && !n && /* @__PURE__ */ m(ffe, { id: `${h}-PasswordStrengthBar`, fullWidth: t, strength: a })
  ] });
});
gfe.displayName = "InputPassword";
const G$ = (e) => M`
  border-color: ${e.colors.feedback.error[300]};

  :hover {
    border-color: ${e.colors.feedback.error[400]};
  }

  &:checked {
    border-color: ${e.colors.feedback.error[300]};

    :hover {
      border-color: ${e.colors.feedback.error[400]};
    }
  }
`, vfe = Ne({
  root: (e, {
    hasError: r
  }) => M`
    & .mantine-RadioGroup-root {
      padding-top: 0px;
    }
    & .mantine-Stack-root {
      gap: ${e.spacing.xs};
    }
    & .mantine-Radio-radio {
      ${r && G$(e)};
    }
    & .mantine-Radio-icon {
      color: ${r ? e.colors.feedback.error[300] : e.colors.brand.primary[300]};
    }
  `,
  wrapperGroup: (e, {
    orientation: r
  }) => M`
    display: flex;
    flex-direction: ${r === "horizontal" ? "row" : "column"};
    flex-wrap: wrap;
    gap: ${e.spacing.xs};
  `,
  error: (e) => M`
    ${e.typography.microCopy};
    color: ${e.colors.feedback.error[300]};
    margin-top: ${e.spacing.xxs};
  `
}), X$ = ue((e, r) => {
  const {
    id: t,
    children: n,
    orientation: o = "horizontal",
    error: a,
    cy: i,
    ...l
  } = e, s = vfe({
    orientation: o,
    hasError: !!a
  }), u = ke(t);
  return /* @__PURE__ */ m(x1.Group, { id: u, styles: s, error: a, ref: r, ...l, "data-cy": Ee("radio-group", i), "data-clarity-mask": !0, children: /* @__PURE__ */ m("div", { css: s.wrapperGroup, children: n }) });
});
X$.displayName = "Radio.Group";
const Vv = (e, r) => r ? e.colors.neutral[200] : e.colors.brand.primary[400], mfe = Ne({
  root: (e) => M`
    display: flex;
    align-items: center;
    gap: ${e.spacing.xs};
  `,
  label: (e, {
    disabled: r,
    labelColor: t
  }) => M`
    font-family: ${e.typography.label.fontFamily};
    color: ${t || e.colors.neutral[400]};
    padding-left: 10px;
    cursor: ${r && "not-allowed"};

    [class^='mantine-']:has(input:disabled) & {
      color: ${t || e.colors.neutral[200]};
      opacity: ${t && 0.8};
    }
  `,
  description: (e, {
    disabled: r
  }) => M`
    ${e.typography.paragraphSmall};
    color: ${e.colors.neutral[300]};
    margin-top: 0;
    cursor: ${r && "not-allowed"};

    [class^='mantine-']:has(input:disabled) & {
      color: ${e.colors.neutral[200]};
    }
  `,
  radio: (e, {
    disabled: r,
    error: t
  }) => M`
    height: 20px;
    width: 20px;
    cursor: ${r ? "not-allowed" : "pointer"};
    border-color: ${e.colors.brand.primary[300]};

    &:checked {
      background-color: ${e.colors.background.white};
      border-color: ${e.colors.brand.primary[300]};
    }

    &:disabled {
      background-color: transparent;
      border-color: ${e.colors.neutral[200]};

      + .___ref-icon {
        color: ${e.colors.neutral[200]};
      }
    }

    &:hover {
      border-color: ${Vv(e, r)};

      + .__mantine-ref-icon {
        color: ${Vv(e, r)};
      }
    }

    ${t && G$(e)}
  `,
  icon: (e, {
    error: r
  }) => M`
    color: ${r ? e.colors.feedback.error[300] : e.colors.brand.primary[300]};
    width: 10px;
    height: 10px;
    top: calc(50% - 5px);
    left: calc(50% - 5px);
  `
}), Y$ = ue(
  (e, r) => {
    const {
      id: t,
      disabled: n,
      error: o,
      cy: a,
      labelColor: i,
      ...l
    } = e, s = mfe({
      disabled: n,
      error: o,
      labelColor: i
    }), u = ke(t);
    return /* @__PURE__ */ m(x1, { id: u, disabled: n, styles: s, ref: r, ...l, "data-cy": Ee("radio", a), "data-clarity-mask": !0 });
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
);
Y$.displayName = "Radio";
Y$.Group = X$;
const hfe = Ne({
  track: M`
    height: 22px;
    width: 40px;
    cursor: pointer;
  `,
  body: M`
    display: flex;
    align-items: center;
  `,
  input: ({
    colors: e
  }) => M`
    &:checked + .mantine-Switch-track {
      background-color: ${e.feedback.success[300]};
      border-color: ${e.feedback.success[300]};
    }

    &:disabled + .mantine-Switch-track {
      background-color: ${e.neutral[100]};
      border-color: ${e.neutral[100]};
    }
  `,
  label: (e) => M`
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    padding-left: ${e.spacing.xxs};
    color: ${e.colors.neutral[500]};

    &[data-disabled='true'] {
      color: ${e.colors.neutral[100]};
    }
  `
}), bfe = ue(({
  cy: e,
  ...r
}, t) => {
  const n = hfe();
  return /* @__PURE__ */ m(Hf, { styles: n, ref: t, ...r, "data-cy": Ee("switch", e), "data-clarity-mask": !0 });
});
bfe.displayName = "Switch";
const yfe = (e, r, t) => t ? e.colors.neutral[100] : r ? e.colors.brand.primary[300] : e.colors.neutral[200], Cfe = Ne({
  container: (e, {
    fullWidth: r,
    disabled: t
  }) => M`
    position: relative;
    padding: 0;
    width: fit-content;
    height: 48px;
    width: ${r ? "100%" : "232px"};

    ${Tn}

    &:focus-within {
      > fieldset {
        border: 1.5px solid
          ${t ? "none" : e.colors.brand.primary[300]};
      }
    }
  `,
  fieldset: (e, {
    dataEntered: r,
    label: t,
    disabled: n
  }) => M`
    position: absolute;
    margin: 0;
    padding: 0 12px;
    inset: ${t ? "-5px" : "1px"} 0 0;
    border: 1.5px solid ${yfe(e, r, n)};
    border-radius: ${e.border.radius.lg};
  `,
  label: (e, {
    disabled: r
  }) => M`
    padding: 0 4px;
    z-index: 1;
    background: ${e.colors.background.white};
    font-family: ${e.typography.label.fontFamily};
    color: ${r ? e.colors.neutral[200] : e.colors.neutral[300]};
    font-weight: ${e.fontWeights.normal};
    font-size: ${e.fontSizes.sm};
  `,
  wrapper: M`
    :has(input:disabled) .mantine-Input-rightSection {
      display: flex;
    }
  `,
  input: (e) => M`
    padding: 0 42px 0 16px;
    height: 48px;
    font-family: ${e.typography.label.fontFamily};
    color: ${e.colors.neutral[400]};
    font-size: ${e.fontSizes.sm};
    font-weight: ${e.fontWeights.normal};
    box-sizing: border-box;
    border: none;

    &::placeholder {
      color: ${e.colors.neutral[200]};
    }

    &:focus {
      border-color: ${e.colors.brand.primary[500]};
    }

    &[data-disabled='true'] {
      pointer-events: visible;
      background-color: transparent;
      color: ${e.colors.neutral[200]};
      opacity: 1;

      &::placeholder {
        color: ${e.colors.neutral[200]};
      }
    }
  `,
  dropdown: ({
    border: e,
    shadow: r,
    colors: t,
    typography: n
  }) => M`
    padding: 0;
    border-radius: ${e.radius.lg};
    box-shadow: ${r.level1};
    font-family: ${n.label.fontFamily};
    border-color: ${t.neutral[100]};
  `,
  itemsWrapper: (e) => M`
    padding: ${e.spacing.xxs} 0;
  `,
  item: (e) => M`
    font-family: ${e.typography.label.fontFamily};
    font-size: ${e.fontSizes.sm};
    height: 38px;
    border-radius: ${e.border.radius.none};

    &:hover {
      color: ${e.colors.brand.primary[300]};
      background-color: ${e.colors.brand.primary[100]};
    }
  `,
  hovered: ({
    colors: e
  }) => M`
    background: ${e.brand.primary[100]};
    color: ${e.brand.primary[500]};
  `,
  rightSection: ({
    colors: e,
    border: r
  }, {
    disabled: t
  }) => M`
    cursor: pointer;
    background: ${t ? e.neutral[100] : e.brand.primary[300]};
    border-radius: 0 ${r.radius.lg} ${r.radius.lg} 0;
    width: 42px;
    top: 2px;

    path {
      fill: ${t ? e.neutral[200] : e.neutral[100]};
    }

    button {
      cursor: ${t && "not-allowed"};
    }
  `
}), wfe = ue((e, r) => {
  const {
    fullWidth: t,
    label: n,
    disabled: o,
    onChange: a,
    onSearch: i,
    cy: l,
    ...s
  } = e, [u, d] = Se(), f = Cfe({
    fullWidth: t,
    dataEntered: u,
    label: n,
    disabled: o
  }), p = (v) => {
    v.length ? d(!0) : d(!1), a && a(v);
  }, g = () => {
    i && !o && i(s.value);
  }, h = $e(({
    handleSearch: v
  }) => /* @__PURE__ */ m(p1, { onClick: v, title: "search", size: "xl", variant: "transparent", "data-testid": "searchButton", children: /* @__PURE__ */ m(fx, { "aria-label": "icon-search" }) }), []);
  return /* @__PURE__ */ Y("div", { css: f.container, "data-cy": Ee("searchbox-wrapper", l == null ? void 0 : l.wrapper), children: [
    /* @__PURE__ */ m("fieldset", { css: f.fieldset, children: n && /* @__PURE__ */ m("legend", { css: f.label, children: /* @__PURE__ */ m("label", { children: n }) }) }),
    /* @__PURE__ */ m(fb, { "aria-label": "searchbox", styles: f, "data-testid": "hero-SearchBox", type: "search", variant: "unstyled", size: "md", withinPortal: !0, rightSection: /* @__PURE__ */ m(h, { handleSearch: g }), onChange: p, ref: r, disabled: o, ...s, "data-cy": Ee("searchbox-input", l == null ? void 0 : l.input), "data-clarity-mask": !0 })
  ] });
});
wfe.displayName = "SearchBox";
const _fe = Ne({
  container: (e, {
    fullWidth: r,
    disabled: t
  }) => M`
    position: relative;
    padding: 0;
    width: fit-content;
    width: ${r ? "100%" : "232px"};
    cursor: ${t ? "not-allowed" : "initial"};

    ${Tn}

    &:focus-within {
      > fieldset {
        border: 1.5px solid ${e.colors.brand.primary[300]};
      }
    }
  `,
  fieldset: (e, {
    dataEntered: r,
    error: t,
    disabled: n
  }) => M`
    position: absolute;
    margin: 0;
    padding: 0 12px;
    inset: -5px 0 0;
    border: 1.5px solid
      ${Na(e, r, null, !!t, n)};
    border-radius: ${e.border.radius.lg};
  `,
  wrapper: M`
    margin-bottom: 2px;
    padding-right: 2px;
    padding-bottom: 4px;
  `,
  root: (e) => M`
    padding-top: ${e.spacing.xxs};

    textarea {
      &[data-disabled] {
        color: ${e.colors.neutral[200]};
        border-color: ${e.colors.neutral[100]};
        background-color: transparent;
        opacity: 1;

        &::placeholder {
          font-family: ${e.typography.label.fontFamily};
          color: ${e.colors.neutral[200]};
        }
      }

      &[data-invalid] {
        &::placeholder {
          font-family: ${e.typography.label.fontFamily};
          color: ${e.colors.neutral[200]};
        }
      }

      &::placeholder {
        font-family: ${e.typography.label.fontFamily};
        color: ${e.colors.neutral[200]};
      }
    }
  `,
  label: (e, {
    disabled: r,
    error: t
  }) => M`
    font-size: ${e.fontSizes.sm};
    padding: 0 4px;
    z-index: 1;
    font-family: ${e.typography.label.fontFamily};
    color: ${yt(e, r, t)};
    font-weight: ${e.fontWeights.normal};
  `,
  input: (e, {
    hasRightSection: r
  }) => M`
    color: ${e.colors.neutral[500]};
    font-family: ${e.typography.label.fontFamily};
    padding: ${r ? `0 44px 0 ${e.spacing.xs}` : e.spacing.xs};
    border: none;
    box-sizing: border-box;

    ::-webkit-scrollbar {
      width: 4px;
      background: ${e.colors.neutral[100]};
      border-radius: ${e.spacing.lg};
    }
    ::-webkit-scrollbar-track {
      background-color: ${e.colors.neutral[100]};
    }
    ::-webkit-scrollbar-thumb {
      background: ${e.colors.neutral[200]};
      border-radius: ${e.spacing.lg};
    }

    &[data-invalid] {
      color: ${e.colors.feedback.error[300]};
    }
  `,
  disabled: (e) => M`
    :disabled {
      border-color: ${e.colors.neutral[100]};
      color: ${e.colors.neutral[200]};
      background-color: transparent;
      opacity: 1;
    }
  `,
  invalid: (e) => M`
    border-color: ${e.colors.feedback.error[300]};
    font-weight: ${e.fontWeights.normal};
    color: ${e.colors.feedback.error[300]};
  `,
  rightSection: ({
    spacing: e
  }) => M`
    margin: 0 ${e.xxs} 12px 0;
    display: flex;
    align-items: end;
    width: auto;
  `,
  error: (e) => M`
    color: ${e.colors.feedback.error[300]};
    font-size: ${e.fontSizes.xs};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    position: absolute;
    margin-top: 4px;
  `,
  counter: (e) => M`
    font-size: ${e.fontSizes.xs};
    color: ${e.colors.neutral[200]};
    font-family: ${e.typography.label.fontFamily};
  `
}), xfe = 100, $fe = ue((e, r) => {
  const {
    maxLength: t,
    onChange: n,
    fullWidth: o = !1,
    error: a,
    disabled: i,
    label: l,
    value: s,
    cy: u,
    ...d
  } = e, [f, p] = Se(!1), [g, h] = Se(0), v = _fe({
    fullWidth: o,
    dataEntered: f,
    error: a,
    disabled: i,
    hasRightSection: !!t,
    maxLengthLarge: t >= xfe
  }), y = $e(() => t ? /* @__PURE__ */ m("div", { css: v.counter, children: `${g}/${t}` }) : null, [g, t, v.counter]), w = $e(($) => {
    var x;
    const C = (x = $ == null ? void 0 : $.currentTarget) == null ? void 0 : x.value;
    C || typeof C == "string" && (C != null && C.length) ? p(!0) : p(!1), t && h(C.length), n && n($);
  }, [t, n]);
  return Fe(() => {
    typeof s == "string" && h(String(s).length);
  }, [s]), /* @__PURE__ */ Y("div", { css: v.container, "data-cy": Ee("textarea-wrapper", u == null ? void 0 : u.wrapper), children: [
    /* @__PURE__ */ m("fieldset", { css: v.fieldset, children: /* @__PURE__ */ m("legend", { css: v.label, children: /* @__PURE__ */ m("label", { children: l }) }) }),
    /* @__PURE__ */ m(ky, { "aria-label": "textarea", variant: "unstyled", rightSection: y(), error: a, onChange: w, disabled: i, maxLength: t, styles: v, ref: r, value: s, ...d, "data-cy": Ee("textarea-input", u == null ? void 0 : u.input), "data-clarity-mask": !0 })
  ] });
});
$fe.displayName = "Textarea";
const Ofe = ["00:00", "00:30", "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30", "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30"], Pfe = ue((e, r) => {
  const {
    id: t,
    placeholder: n,
    options: o,
    ...a
  } = e, i = ke(t);
  return /* @__PURE__ */ m(Ix, { id: i, placeholder: n || "hh:mm", options: o || Ofe, ref: r, icon: /* @__PURE__ */ m(ix, { "aria-label": "clock", "data-testid": "icon-clock" }), ...a });
});
Pfe.displayName = "TimeInput";
const Sfe = (e, r, t) => r ? e.colors.neutral[200] : t ? e.colors.feedback.error[300] : e.colors.neutral[300], Ife = Ne({
  container: (e, {
    fullWidth: r
  }) => M`
    position: relative;
    padding: 0;
    width: fit-content;
    height: 44px;
    width: ${r ? "100%" : "232px"};

    ${Tn}

    &:focus-within {
      > fieldset {
        border: 1.5px solid ${e.colors.brand.primary[300]};
      }
    }

    &:has(button:disabled) {
      cursor: not-allowed;
    }

    &:has(button:disabled) .mantine-Input-rightSection {
      display: flex;
    }
  `,
  fieldset: (e, {
    dataEntered: r,
    disabled: t,
    error: n
  }) => M`
    position: absolute;
    margin: 0;
    padding: 0 12px;
    inset: -5px 0 0;
    border-radius: ${e.border.radius.lg};
    border: 1.5px solid
      ${Na(e, r, !1, !!n, t)};
  `,
  label: (e, {
    disabled: r,
    error: t
  }) => M`
    padding: 0 4px;
    z-index: 1;
    font-family: ${e.typography.label.fontFamily};
    color: ${Sfe(e, r, t)};
    font-weight: ${e.fontWeights.normal};
    font-size: ${e.fontSizes.sm};
  `,
  input: (e) => M`
    padding: 0 42px 0 16px;
    font-family: ${e.typography.label.fontFamily};
    color: ${e.colors.neutral[500]};
    border: none;
    box-sizing: border-box;
    height: 46px;

    &[data-disabled] {
      background-color: transparent;
    }

    &[data-invalid] {
      color: ${e.colors.feedback.error[300]};
    }

    &[data-invalid]::placeholder {
      color: ${e.colors.feedback.error[300]};
    }

    &::placeholder {
      color: ${e.colors.neutral[200]};
    }
    &:focus {
      border-color: ${e.colors.brand.primary[300]};
    }
  `,
  invalid: (e) => M`
    border-color: ${e.colors.feedback.error[300]};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    color: ${e.colors.feedback.error[300]};

    &::placeholder {
      color: ${e.colors.feedback.error[300]};
    }
  `,
  error: (e) => M`
    color: ${e.colors.feedback.error[300]};
    font-size: ${e.fontSizes.xs};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    position: absolute;
    top: 48px;
  `,
  disabled: (e) => M`
    &:disabled {
      cursor: not-allowed;
    }
    &::placeholder {
      color: ${e.colors.neutral[200]};
    }
  `,
  dropdown: (e) => M`
    border-radius: ${e.border.radius.lg};
    box-shadow: ${e.shadow.level3};
    border: none;
    width: 326px !important;
    padding: ${e.spacing.xs} ${e.spacing.sm};
  `,
  pickerControl: (e) => M`
    color: ${e.colors.neutral[400]};
    font-family: ${e.typography.label.fontFamily};

    border-radius: ${e.border.radius.full};
    border: 1px solid ${e.colors.neutral[200]};
    height: 40px;

    &:hover {
      background-color: ${e.colors.brand.primary[100]};
      color: ${e.colors.brand.primary[300]};
    }

    &[data-selected='true'] {
      background-color: ${e.colors.brand.primary[100]};
      border-color: ${e.colors.brand.primary[300]};
      border-radius: ${e.border.radius.full};
      color: ${e.colors.brand.primary[300]};

      &:hover {
        background-color: ${e.colors.brand.primary[100]};
        color: ${e.colors.brand.primary[300]};
      }
    }
  `,
  calendarHeader: (e) => M`
    margin-bottom: ${e.spacing.sm};
  `,
  calendarHeaderLevelIcon: M`
    display: none;
  `,
  calendarHeaderLevel: (e) => M`
    color: ${e.colors.brand.primary[300]};
    text-decoration: underline;
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.bold};
    &:hover {
      background-color: transparent;
    }
  `,
  rightSection: (e, {
    disabled: r
  }) => M`
    pointer-events: none;
    color: ${e.colors.neutral[500]};
    margin-right: ${e.spacing.xxs};
    cursor: ${r && "not-allowed"};

    svg {
      width: 22px;
      height: 22px;
    }

    path {
      fill: ${e.colors.neutral[200]};
    }
  `,
  monthsListRow: (e) => M`
    display: grid;
    grid-template-columns: repeat(3, 78px);
    gap: ${e.spacing.xs};
  `,
  monthsListCell: (e) => M`
    margin-bottom: ${e.spacing.xs};
  `,
  yearsListRow: (e) => M`
    display: grid;
    grid-template-columns: repeat(3, 78px);
    gap: ${e.spacing.xs};
  `,
  yearsListCell: (e) => M`
    margin-bottom: ${e.spacing.xs};
  `
}), vt = {
  jan: "Janeiro",
  feb: "Fevereiro",
  mar: "Março",
  apr: "Abril",
  may: "Maio",
  jun: "Junho",
  jul: "Julho",
  aug: "Agosto",
  sep: "Setembro",
  oct: "Outubro",
  nov: "Novembro",
  dec: "Dezembro"
}, It = (e) => e == null ? void 0 : e.slice(0, 3), Efe = [...Object.values(vt)], Rfe = [It(vt.jan), It(vt.feb), It(vt.mar), It(vt.apr), It(vt.may), It(vt.jun), It(vt.jul), It(vt.aug), It(vt.sep), It(vt.oct), It(vt.nov), It(vt.dec)], Afe = ue((e, r) => {
  const {
    id: t,
    label: n,
    fullWidth: o,
    onChange: a,
    error: i,
    disabled: l,
    cy: s,
    ...u
  } = e, [d, f] = Se(!1), p = Ife({
    dataEntered: d,
    fullWidth: o,
    disabled: l,
    error: i
  }), g = ke(t);
  je.extend(B$), je.updateLocale("pt-br", {
    months: Efe,
    monthsShort: Rfe
  });
  const h = (v) => {
    f(!!v), a && a(v);
  };
  return /* @__PURE__ */ Y("div", { css: p.container, "data-cy": Ee("monthPicker-wrapper", s == null ? void 0 : s.wrapper), children: [
    /* @__PURE__ */ m("fieldset", { css: p.fieldset, children: /* @__PURE__ */ m("legend", { css: p.label, children: /* @__PURE__ */ m("label", { children: n }) }) }),
    /* @__PURE__ */ m(Z$, { id: g, "aria-label": "monthpicker", variant: "unstyled", onChange: h, rightSection: /* @__PURE__ */ m(h2, { "aria-label": "calendar" }), locale: "pt-br", valueFormat: "MMMM [de] YYYY", styles: p, disabled: l, error: i, ref: r, "data-cy": Ee("monthPicker-input", s == null ? void 0 : s.input), ...u })
  ] });
});
Afe.displayName = "MonthPicker";
const kfe = (e, r, t) => r ? e.colors.feedback.error[300] : t ? e.colors.neutral[200] : e.colors.neutral[300], Mfe = (e, r, t) => r ? e.colors.feedback.error[300] : t ? e.colors.neutral[100] : e.colors.neutral[200], Nfe = Ne({
  inputIcon: M`
    & .MuiSvgIcon-root {
      font-size: 1.2rem;
    }
  `,
  inputBase: (e, {
    error: r,
    disabled: t,
    fullWidth: n,
    hasMultipleLines: o
  }) => M`
    & .MuiInputLabel-root {
      ${e.typography.label}
      color: ${kfe(e, r, t)} !important;
      transform: translate(16px, -12px) scale(1);
      transition: all 0.15s ease-in;
      line-height: ${o ? e.typography.label.lineHeight : `calc(${e.typography.label.lineHeight} + ${Ox}px)`};
    }

    ${Tn}

    & .Mui-focused {
      color: ${e.colors.neutral[500]};
      border: ${e.colors.brand.primary[300]};
    }

    & .MuiOutlinedInput-root {
      padding: ${e.spacing.xxs} ${e.spacing.xxs} !important;
      border-radius: ${e.border.radius.lg};
      min-height: ${Px + "px"};
      height: auto;
      gap: ${e.spacing.xxs};
      color: ${e.colors.neutral[400]};
      cursor: ${t ? "not-allowed" : "initial"};
      width: ${n ? "100%" : "232px"};
    }

    & .MuiInputBase-input {
      font-size: ${e.fontSizes.sm};
      line-height: 24px;
      font-family: ${e.typography.label.fontFamily};
      font-weight: ${e.fontWeights.normal};
      color: ${e.colors.neutral[400]};
      min-width: 2px !important;

      ::placeholder {
        color: ${e.colors.neutral[200]};
        font-size: ${e.fontSizes.sm};
        opacity: 1;
      }
    }

    & .MuiOutlinedInput-notchedOutline {
      padding: 0 12px;
      border-width: 1px !important;
      border-color: ${Mfe(e, r, t)} !important;

      span {
        padding: 0 2px;
      }

      legend {
        font-family: ${e.typography.label.fontFamily};
        font-size: ${e.fontSizes.sm};
        height: ${e.fontSizes.sm};
        padding-right: 2px;
      }
    }

    & .Mui-focused .MuiOutlinedInput-notchedOutline {
      border-width: 1px !important;
      border-color: ${r ? e.colors.feedback.error[300] : e.colors.brand.primary[300]} !important;
    }

    & .MuiInputAdornment-positionEnd {
      pointer-events: none;
      position: absolute;
      right: 12px;
    }

    & .MuiAutocomplete-tag {
      ${e.typography.label};
      color: ${e.colors.neutral[400]};
    }
  `,
  popper: (e) => M`
    padding-top: ${e.spacing.xxs} !important;

    .MuiAutocomplete-listbox {
      ::-webkit-scrollbar {
        width: 4px;
        background: ${e.colors.neutral[100]};
        border-radius: ${e.spacing.xxs};
      }
      ::-webkit-scrollbar-track {
        background-color: ${e.colors.neutral[100]};
      }
      ::-webkit-scrollbar-thumb {
        background: ${e.colors.neutral[200]};
        border-radius: ${e.spacing.xxs};
      }
    }

    .MuiPaper-root {
      font-family: ${e.typography.label.fontFamily};
      font-size: ${e.fontSizes.sm};
      color: ${e.colors.brand.primary[500]};
      border-radius: ${e.border.radius.lg};
      box-shadow: ${e.shadow.level1};

      .MuiAutocomplete-option {
        padding: ${e.spacing.xxs} ${e.spacing.xs};

        &[aria-selected='true'] {
          background: ${e.colors.brand.primary[100]};
          color: ${e.colors.brand.primary[300]};

          &.Mui-focused {
            background: ${e.colors.brand.primary[100]};
            color: ${e.colors.brand.primary[300]};
          }
        }

        :hover {
          background: ${e.colors.brand.primary[100]};
          color: ${e.colors.brand.primary[300]};
        }

        &.Mui-focused {
          background: ${e.colors.brand.primary[100]};
          color: ${e.colors.brand.primary[300]};
        }
      }
    }
  `,
  checkboxWrapper: M`
    pointer-events: none;
  `,
  errorMessage: (e) => M`
    color: ${e.colors.feedback.error[300]};
    margin-top: 4px;
  `
}), U$ = (e, r) => ({
  primary: {
    color: r ? e.colors.background.white : e.colors.brand.primary[300],
    background: e.colors.brand.primary[r ? 300 : 200]
  },
  information: {
    color: r ? e.colors.background.white : e.colors.feedback.information[400],
    background: e.colors.feedback.information[r ? 400 : 200]
  },
  success: {
    color: r ? e.colors.background.white : e.colors.feedback.success[500],
    background: e.colors.feedback.success[r ? 300 : 200]
  },
  warning: {
    color: r ? e.colors.background.white : e.colors.feedback.warning[500],
    background: e.colors.feedback.warning[r ? 300 : 200]
  },
  error: {
    color: r ? e.colors.background.white : e.colors.feedback.error[500],
    background: e.colors.feedback.error[r ? 300 : 200]
  },
  neutral: {
    color: r ? e.colors.background.white : e.colors.neutral[300],
    background: e.colors.neutral[r ? 300 : 100]
  }
}), Tfe = (e, r, t) => U$(e, t)[r], Fv = (e) => {
  const r = {
    small: "16px",
    medium: "24px"
  };
  return r[e] || (r == null ? void 0 : r.medium);
}, Gd = {
  small: M`
    padding: 0 8px;
  `,
  medium: M`
    padding: 0 16px;
  `,
  action: M`
    padding: 8px 8px 8px 16px;
  `
}, Dfe = Ne({
  root: (e, {
    variant: r,
    size: t,
    solid: n
  }) => M`
    font-family: ${e.typography.label.fontFamily};
    text-transform: none;
    font-size: ${t === "small" ? e.fontSizes.xs : e.fontSizes.sm};
    font-weight: ${e.fontWeights.normal};
    padding: 0;
    height: ${Fv(t)};
    min-height: ${Fv(t)};
    margin: 0;
    border-radius: ${e.border.radius.xs};

    ${Tfe(e, r, n)}
  `,
  inner: (e, {
    onClick: r,
    size: t
  }) => M`
    ${!!Gd && Gd[t]}
    ${!!r && Gd.action}
  `,
  rightSection: M`
    margin: 0;
  `,
  closeIcon: (e, {
    variant: r,
    solid: t
  }) => M`
    color: ${U$(e, t)[r].color};
    padding: 0 8px 0 0;
    margin: 0;
    background: transparent;
    border: none;
    display: flex;
    cursor: pointer;
  `
}), Bi = ({
  id: e,
  children: r,
  variant: t = "primary",
  size: n = "medium",
  solid: o = !1,
  onClick: a
}) => {
  const i = Dfe({
    variant: t,
    size: n,
    solid: o,
    onClick: a
  }), l = ke(e), s = /* @__PURE__ */ m("button", { css: i.closeIcon, onClick: a, type: "button", children: /* @__PURE__ */ m(Fo, { "aria-label": "close icon", size: "small" }) });
  return /* @__PURE__ */ m(oZ, { id: l, "data-testid": "hero-tag", styles: i, rightSection: a && s, "data-clarity-mask": !0, children: r });
}, jfe = ue((e, r) => {
  var se;
  const {
    optionLabel: t,
    label: n,
    value: o,
    placeholder: a,
    options: i,
    error: l,
    onChange: s,
    noOptionsText: u,
    disableCloseOnSelect: d = !0,
    disableClearable: f = !1,
    renderOptionLabel: p,
    fullWidth: g,
    disabled: h,
    id: v,
    cy: y,
    ...w
  } = e, $ = Ve(null), C = Je(
    () => {
      var q;
      return ((q = $ == null ? void 0 : $.current) == null ? void 0 : q.offsetHeight) > Px;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [(se = $ == null ? void 0 : $.current) == null ? void 0 : se.offsetHeight]
  ), x = Nfe({
    disabled: h,
    error: l,
    fullWidth: g,
    hasMultipleLines: C
  }), b = ur(), O = ke(v), _ = ke(v), P = Je(() => ({
    value: "0",
    [p != null ? p : t]: "Selecionar todas"
  }), [t, p]), [S, I] = Se([]);
  function N(q) {
    const te = {
      ...q.InputProps,
      endAdornment: /* @__PURE__ */ m(qte, { position: "end", children: q.inputProps["aria-expanded"] ? /* @__PURE__ */ m(io, { "aria-label": "arrow up", "data-testid": "arrowUp" }) : /* @__PURE__ */ m(Nn, { "aria-label": "arrow down", "data-testid": "arrowDown", color: b.colors.neutral[200] }) })
    };
    return /* @__PURE__ */ m(Ooe, { ...q, ref: $, id: _, size: "small", label: n, placeholder: (S == null ? void 0 : S.length) === 0 ? a : "", InputLabelProps: {
      shrink: !0
    }, InputProps: te, variant: "outlined", css: x.inputBase });
  }
  const k = Je(() => (i == null ? void 0 : i.length) === (S == null ? void 0 : S.length), [i == null ? void 0 : i.length, S == null ? void 0 : S.length]), j = $e((q) => {
    I(q);
  }, []), R = $e(() => I([]), []), D = $e((q) => {
    q ? I(i) : R();
  }, [R, i]), T = $e(() => {
    D(!k);
  }, [k, D]), V = (q, te, ae) => {
    if (ae === "selectOption" || ae === "removeOption") {
      const ge = te.find((G) => G[t] === P[t]);
      if (ge) {
        if (k)
          return s(q, [], ae);
        const G = i.filter((oe) => oe[t] !== P[t]);
        return T(), s(q, G, ae);
      } else
        return j(te.filter((G) => G !== ge)), s(q, te, ae);
    } else if (ae === "clear")
      return R(), s(q, [], ae);
  }, L = (q, te, ae) => (j(te), s(q, te, ae)), Z = $e((q) => `${q[t]}`, [t]), z = $e((q, te, {
    selected: ae
  }) => {
    const G = P && te[p != null ? p : t] === P[p != null ? p : t] ? {
      indeterminate: k,
      checked: k
    } : {
      checked: ae
    };
    return /* @__PURE__ */ m("li", { ...q, "data-testid": te[p != null ? p : t], children: /* @__PURE__ */ m("div", { css: x.checkboxWrapper, children: /* @__PURE__ */ m(b2, { label: te[p != null ? p : t], readOnly: !0, ...G }) }) });
  }, [k, t, p, P, x]), W = w_(), U = $e((q, te) => {
    const ae = W(q, te);
    return (ae == null ? void 0 : ae.length) === 0 ? [] : P ? [P, ...ae] : ae;
  }, [W, P]), re = $e((q, te) => q.map((ae, ge) => {
    const G = {
      id: String(ge),
      ...h ? {} : {
        onClick: te({
          index: ge
        }).onDelete
      }
    };
    return /* @__PURE__ */ m(Bi, { variant: "neutral", ...G, children: ae[p != null ? p : t] }, String(ge));
  }), [h, t, p]), X = $e((q) => /* @__PURE__ */ m(S1, { ...q, css: x.popper }), [x]), J = $e((q) => q === 1 ? `e mais ${q} opção` : `e mais ${q} opções`, []);
  Fe(() => {
    o && I(o);
  }, [o]);
  const Q = $e((q, te) => te === void 0 || te === "" || q[t] === te[t], [t]);
  return /* @__PURE__ */ Y(Br, { children: [
    /* @__PURE__ */ m(A_, { ...w, ref: r, multiple: !0, id: O, options: i, value: S, noOptionsText: u || "Sem resultados", renderOption: z, getOptionLabel: Z, filterOptions: U, renderInput: N, renderTags: re, PopperComponent: X, disableCloseOnSelect: d, isOptionEqualToValue: Q, disableClearable: f, disabled: h, onChange: P ? V : L, getLimitTagsText: J, "data-cy": Ee("multiSelect-input", y == null ? void 0 : y.input) }),
    l && /* @__PURE__ */ m(tr, { renderAs: "p", variant: "microCopy", css: x.errorMessage, showOnClarity: !0, children: l })
  ] });
});
jfe.displayName = "MultiSelect";
const Lfe = Ne({
  wrapper: (e, {
    fullWidth: r
  }) => M`
    display: flex;
    flex-direction: column;
    width: ${r ? "100%" : "232px"};
  `,
  container: (e, {
    fullWidth: r
  }) => M`
    position: relative;
    padding: 0;
    height: 48px;
    width: ${r ? "100%" : "232px"};
    ${Tn}

    &:focus-within {
      > fieldset {
        border: 1.5px solid ${e.colors.brand.primary[300]};
      }
    }
  `,
  fieldset: (e, {
    dataEntered: r,
    error: t,
    label: n,
    disabled: o
  }) => M`
    position: absolute;
    margin: 0;
    padding: 0 12px;
    inset: ${n ? "-5px" : "1px"} 0 0;
    top: -5px;
    height: 49px;
    border: 1.5px solid
      ${Na(e, r, !1, !!t, o)};
    border-radius: ${e.border.radius.lg};
    cursor: ${o ? "not-allowed" : "initial"};
  `,
  label: (e, {
    error: r,
    disabled: t
  }) => M`
    padding: 0 4px;
    z-index: 1;
    font-family: ${e.typography.label.fontFamily};
    color: ${yt(e, t, r)};
    font-weight: ${e.fontWeights.normal};
    font-size: ${e.fontSizes.sm};
  `,
  input: (e, {
    disabled: r,
    error: t
  }) => M`
    padding: 0 ${e.spacing.xs};
    font-family: ${e.typography.label.fontFamily};
    font-size: ${e.fontSizes.sm};
    color: ${yt(e, r, t)};
    box-sizing: border-box;
    position: absolute;
    height: 46px;
    border: none;
    outline: none;
    font-weight: normal;
    background-color: transparent;
    width: 100%;
    cursor: ${r ? "not-allowed" : "initial"};

    &:focus {
      border: none;
    }

    &:disabled {
      border-color: ${e.colors.neutral[100]};
      background-color: transparent;
      opacity: 1;
      color: ${e.colors.neutral[200]};
    }

    ::placeholder {
      color: ${e.colors.neutral[100]};
    }
  `,
  error: (e) => M`
    color: ${e.colors.feedback.error[300]};
    font-size: ${e.fontSizes.xs};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
  `
});
var J$ = {}, q$ = {}, K$ = { exports: {} };
(function(e) {
  (function(r) {
    var t, n = 20, o = 1, a = 1e6, i = 1e6, l = -7, s = 21, u = "[big.js] ", d = u + "Invalid ", f = d + "decimal places", p = d + "rounding mode", g = u + "Division by zero", h = {}, v = void 0, y = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
    function w() {
      function b(O) {
        var _ = this;
        if (!(_ instanceof b))
          return O === v ? w() : new b(O);
        O instanceof b ? (_.s = O.s, _.e = O.e, _.c = O.c.slice()) : $(_, O), _.constructor = b;
      }
      return b.prototype = h, b.DP = n, b.RM = o, b.NE = l, b.PE = s, b.version = "5.2.2", b;
    }
    function $(b, O) {
      var _, P, S;
      if (O === 0 && 1 / O < 0)
        O = "-0";
      else if (!y.test(O += ""))
        throw Error(d + "number");
      for (b.s = O.charAt(0) == "-" ? (O = O.slice(1), -1) : 1, (_ = O.indexOf(".")) > -1 && (O = O.replace(".", "")), (P = O.search(/e/i)) > 0 ? (_ < 0 && (_ = P), _ += +O.slice(P + 1), O = O.substring(0, P)) : _ < 0 && (_ = O.length), S = O.length, P = 0; P < S && O.charAt(P) == "0"; )
        ++P;
      if (P == S)
        b.c = [b.e = 0];
      else {
        for (; S > 0 && O.charAt(--S) == "0"; )
          ;
        for (b.e = _ - P - 1, b.c = [], _ = 0; P <= S; )
          b.c[_++] = +O.charAt(P++);
      }
      return b;
    }
    function C(b, O, _, P) {
      var S = b.c, I = b.e + O + 1;
      if (I < S.length) {
        if (_ === 1)
          P = S[I] >= 5;
        else if (_ === 2)
          P = S[I] > 5 || S[I] == 5 && (P || I < 0 || S[I + 1] !== v || S[I - 1] & 1);
        else if (_ === 3)
          P = P || !!S[0];
        else if (P = !1, _ !== 0)
          throw Error(p);
        if (I < 1)
          S.length = 1, P ? (b.e = -O, S[0] = 1) : S[0] = b.e = 0;
        else {
          if (S.length = I--, P)
            for (; ++S[I] > 9; )
              S[I] = 0, I-- || (++b.e, S.unshift(1));
          for (I = S.length; !S[--I]; )
            S.pop();
        }
      } else if (_ < 0 || _ > 3 || _ !== ~~_)
        throw Error(p);
      return b;
    }
    function x(b, O, _, P) {
      var S, I, N = b.constructor, k = !b.c[0];
      if (_ !== v) {
        if (_ !== ~~_ || _ < (O == 3) || _ > a)
          throw Error(O == 3 ? d + "precision" : f);
        for (b = new N(b), _ = P - b.e, b.c.length > ++P && C(b, _, N.RM), O == 2 && (P = b.e + _ + 1); b.c.length < P; )
          b.c.push(0);
      }
      if (S = b.e, I = b.c.join(""), _ = I.length, O != 2 && (O == 1 || O == 3 && P <= S || S <= N.NE || S >= N.PE))
        I = I.charAt(0) + (_ > 1 ? "." + I.slice(1) : "") + (S < 0 ? "e" : "e+") + S;
      else if (S < 0) {
        for (; ++S; )
          I = "0" + I;
        I = "0." + I;
      } else if (S > 0)
        if (++S > _)
          for (S -= _; S--; )
            I += "0";
        else
          S < _ && (I = I.slice(0, S) + "." + I.slice(S));
      else
        _ > 1 && (I = I.charAt(0) + "." + I.slice(1));
      return b.s < 0 && (!k || O == 4) ? "-" + I : I;
    }
    h.abs = function() {
      var b = new this.constructor(this);
      return b.s = 1, b;
    }, h.cmp = function(b) {
      var O, _ = this, P = _.c, S = (b = new _.constructor(b)).c, I = _.s, N = b.s, k = _.e, j = b.e;
      if (!P[0] || !S[0])
        return P[0] ? I : S[0] ? -N : 0;
      if (I != N)
        return I;
      if (O = I < 0, k != j)
        return k > j ^ O ? 1 : -1;
      for (N = (k = P.length) < (j = S.length) ? k : j, I = -1; ++I < N; )
        if (P[I] != S[I])
          return P[I] > S[I] ^ O ? 1 : -1;
      return k == j ? 0 : k > j ^ O ? 1 : -1;
    }, h.div = function(b) {
      var O = this, _ = O.constructor, P = O.c, S = (b = new _(b)).c, I = O.s == b.s ? 1 : -1, N = _.DP;
      if (N !== ~~N || N < 0 || N > a)
        throw Error(f);
      if (!S[0])
        throw Error(g);
      if (!P[0])
        return new _(I * 0);
      var k, j, R, D, T, V = S.slice(), L = k = S.length, Z = P.length, z = P.slice(0, k), W = z.length, U = b, re = U.c = [], X = 0, J = N + (U.e = O.e - b.e) + 1;
      for (U.s = I, I = J < 0 ? 0 : J, V.unshift(0); W++ < k; )
        z.push(0);
      do {
        for (R = 0; R < 10; R++) {
          if (k != (W = z.length))
            D = k > W ? 1 : -1;
          else
            for (T = -1, D = 0; ++T < k; )
              if (S[T] != z[T]) {
                D = S[T] > z[T] ? 1 : -1;
                break;
              }
          if (D < 0) {
            for (j = W == k ? S : V; W; ) {
              if (z[--W] < j[W]) {
                for (T = W; T && !z[--T]; )
                  z[T] = 9;
                --z[T], z[W] += 10;
              }
              z[W] -= j[W];
            }
            for (; !z[0]; )
              z.shift();
          } else
            break;
        }
        re[X++] = D ? R : ++R, z[0] && D ? z[W] = P[L] || 0 : z = [P[L]];
      } while ((L++ < Z || z[0] !== v) && I--);
      return !re[0] && X != 1 && (re.shift(), U.e--), X > J && C(U, N, _.RM, z[0] !== v), U;
    }, h.eq = function(b) {
      return !this.cmp(b);
    }, h.gt = function(b) {
      return this.cmp(b) > 0;
    }, h.gte = function(b) {
      return this.cmp(b) > -1;
    }, h.lt = function(b) {
      return this.cmp(b) < 0;
    }, h.lte = function(b) {
      return this.cmp(b) < 1;
    }, h.minus = h.sub = function(b) {
      var O, _, P, S, I = this, N = I.constructor, k = I.s, j = (b = new N(b)).s;
      if (k != j)
        return b.s = -j, I.plus(b);
      var R = I.c.slice(), D = I.e, T = b.c, V = b.e;
      if (!R[0] || !T[0])
        return T[0] ? (b.s = -j, b) : new N(R[0] ? I : 0);
      if (k = D - V) {
        for ((S = k < 0) ? (k = -k, P = R) : (V = D, P = T), P.reverse(), j = k; j--; )
          P.push(0);
        P.reverse();
      } else
        for (_ = ((S = R.length < T.length) ? R : T).length, k = j = 0; j < _; j++)
          if (R[j] != T[j]) {
            S = R[j] < T[j];
            break;
          }
      if (S && (P = R, R = T, T = P, b.s = -b.s), (j = (_ = T.length) - (O = R.length)) > 0)
        for (; j--; )
          R[O++] = 0;
      for (j = O; _ > k; ) {
        if (R[--_] < T[_]) {
          for (O = _; O && !R[--O]; )
            R[O] = 9;
          --R[O], R[_] += 10;
        }
        R[_] -= T[_];
      }
      for (; R[--j] === 0; )
        R.pop();
      for (; R[0] === 0; )
        R.shift(), --V;
      return R[0] || (b.s = 1, R = [V = 0]), b.c = R, b.e = V, b;
    }, h.mod = function(b) {
      var O, _ = this, P = _.constructor, S = _.s, I = (b = new P(b)).s;
      if (!b.c[0])
        throw Error(g);
      return _.s = b.s = 1, O = b.cmp(_) == 1, _.s = S, b.s = I, O ? new P(_) : (S = P.DP, I = P.RM, P.DP = P.RM = 0, _ = _.div(b), P.DP = S, P.RM = I, this.minus(_.times(b)));
    }, h.plus = h.add = function(b) {
      var O, _ = this, P = _.constructor, S = _.s, I = (b = new P(b)).s;
      if (S != I)
        return b.s = -I, _.minus(b);
      var N = _.e, k = _.c, j = b.e, R = b.c;
      if (!k[0] || !R[0])
        return R[0] ? b : new P(k[0] ? _ : S * 0);
      if (k = k.slice(), S = N - j) {
        for (S > 0 ? (j = N, O = R) : (S = -S, O = k), O.reverse(); S--; )
          O.push(0);
        O.reverse();
      }
      for (k.length - R.length < 0 && (O = R, R = k, k = O), S = R.length, I = 0; S; k[S] %= 10)
        I = (k[--S] = k[S] + R[S] + I) / 10 | 0;
      for (I && (k.unshift(I), ++j), S = k.length; k[--S] === 0; )
        k.pop();
      return b.c = k, b.e = j, b;
    }, h.pow = function(b) {
      var O = this, _ = new O.constructor(1), P = _, S = b < 0;
      if (b !== ~~b || b < -i || b > i)
        throw Error(d + "exponent");
      for (S && (b = -b); b & 1 && (P = P.times(O)), b >>= 1, !!b; )
        O = O.times(O);
      return S ? _.div(P) : P;
    }, h.round = function(b, O) {
      var _ = this.constructor;
      if (b === v)
        b = 0;
      else if (b !== ~~b || b < -a || b > a)
        throw Error(f);
      return C(new _(this), b, O === v ? _.RM : O);
    }, h.sqrt = function() {
      var b, O, _, P = this, S = P.constructor, I = P.s, N = P.e, k = new S(0.5);
      if (!P.c[0])
        return new S(P);
      if (I < 0)
        throw Error(u + "No square root");
      I = Math.sqrt(P + ""), I === 0 || I === 1 / 0 ? (O = P.c.join(""), O.length + N & 1 || (O += "0"), I = Math.sqrt(O), N = ((N + 1) / 2 | 0) - (N < 0 || N & 1), b = new S((I == 1 / 0 ? "1e" : (I = I.toExponential()).slice(0, I.indexOf("e") + 1)) + N)) : b = new S(I), N = b.e + (S.DP += 4);
      do
        _ = b, b = k.times(_.plus(P.div(_)));
      while (_.c.slice(0, N).join("") !== b.c.slice(0, N).join(""));
      return C(b, S.DP -= 4, S.RM);
    }, h.times = h.mul = function(b) {
      var O, _ = this, P = _.constructor, S = _.c, I = (b = new P(b)).c, N = S.length, k = I.length, j = _.e, R = b.e;
      if (b.s = _.s == b.s ? 1 : -1, !S[0] || !I[0])
        return new P(b.s * 0);
      for (b.e = j + R, N < k && (O = S, S = I, I = O, R = N, N = k, k = R), O = new Array(R = N + k); R--; )
        O[R] = 0;
      for (j = k; j--; ) {
        for (k = 0, R = N + j; R > j; )
          k = O[R] + I[j] * S[R - j - 1] + k, O[R--] = k % 10, k = k / 10 | 0;
        O[R] = (O[R] + k) % 10;
      }
      for (k ? ++b.e : O.shift(), j = O.length; !O[--j]; )
        O.pop();
      return b.c = O, b;
    }, h.toExponential = function(b) {
      return x(this, 1, b, b);
    }, h.toFixed = function(b) {
      return x(this, 2, b, this.e + b);
    }, h.toPrecision = function(b) {
      return x(this, 3, b, b - 1);
    }, h.toString = function() {
      return x(this);
    }, h.valueOf = h.toJSON = function() {
      return x(this, 4);
    }, t = w(), t.default = t.Big = t, e.exports ? e.exports = t : r.Big = t;
  })(Mo);
})(K$);
var zfe = K$.exports;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  var r = t(zfe);
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function n(o, a, i) {
    var l = a.formats.number[i], s = new Mo.Intl.NumberFormat(a.locale, l);
    return s.format((0, r.default)(o));
  }
})(q$);
(function(e) {
  function r(_) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(S) {
      return typeof S;
    } : r = function(S) {
      return S && typeof Symbol == "function" && S.constructor === Symbol && S !== Symbol.prototype ? "symbol" : typeof S;
    }, r(_);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = l(E), n = V8, o = a(q$);
  function a(_) {
    return _ && _.__esModule ? _ : { default: _ };
  }
  function i() {
    if (typeof WeakMap != "function")
      return null;
    var _ = /* @__PURE__ */ new WeakMap();
    return i = function() {
      return _;
    }, _;
  }
  function l(_) {
    if (_ && _.__esModule)
      return _;
    if (_ === null || r(_) !== "object" && typeof _ != "function")
      return { default: _ };
    var P = i();
    if (P && P.has(_))
      return P.get(_);
    var S = {}, I = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var N in _)
      if (Object.prototype.hasOwnProperty.call(_, N)) {
        var k = I ? Object.getOwnPropertyDescriptor(_, N) : null;
        k && (k.get || k.set) ? Object.defineProperty(S, N, k) : S[N] = _[N];
      }
    return S.default = _, P && P.set(_, S), S;
  }
  function s() {
    return s = Object.assign || function(_) {
      for (var P = 1; P < arguments.length; P++) {
        var S = arguments[P];
        for (var I in S)
          Object.prototype.hasOwnProperty.call(S, I) && (_[I] = S[I]);
      }
      return _;
    }, s.apply(this, arguments);
  }
  function u(_, P) {
    var S = Object.keys(_);
    if (Object.getOwnPropertySymbols) {
      var I = Object.getOwnPropertySymbols(_);
      P && (I = I.filter(function(N) {
        return Object.getOwnPropertyDescriptor(_, N).enumerable;
      })), S.push.apply(S, I);
    }
    return S;
  }
  function d(_) {
    for (var P = 1; P < arguments.length; P++) {
      var S = arguments[P] != null ? arguments[P] : {};
      P % 2 ? u(Object(S), !0).forEach(function(I) {
        f(_, I, S[I]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(_, Object.getOwnPropertyDescriptors(S)) : u(Object(S)).forEach(function(I) {
        Object.defineProperty(_, I, Object.getOwnPropertyDescriptor(S, I));
      });
    }
    return _;
  }
  function f(_, P, S) {
    return P in _ ? Object.defineProperty(_, P, { value: S, enumerable: !0, configurable: !0, writable: !0 }) : _[P] = S, _;
  }
  function p(_, P) {
    return w(_) || y(_, P) || h(_, P) || g();
  }
  function g() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function h(_, P) {
    if (_) {
      if (typeof _ == "string")
        return v(_, P);
      var S = Object.prototype.toString.call(_).slice(8, -1);
      if (S === "Object" && _.constructor && (S = _.constructor.name), S === "Map" || S === "Set")
        return Array.from(_);
      if (S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S))
        return v(_, P);
    }
  }
  function v(_, P) {
    (P == null || P > _.length) && (P = _.length);
    for (var S = 0, I = new Array(P); S < P; S++)
      I[S] = _[S];
    return I;
  }
  function y(_, P) {
    if (!(typeof Symbol == "undefined" || !(Symbol.iterator in Object(_)))) {
      var S = [], I = !0, N = !1, k = void 0;
      try {
        for (var j = _[Symbol.iterator](), R; !(I = (R = j.next()).done) && (S.push(R.value), !(P && S.length === P)); I = !0)
          ;
      } catch (D) {
        N = !0, k = D;
      } finally {
        try {
          !I && j.return != null && j.return();
        } finally {
          if (N)
            throw k;
        }
      }
      return S;
    }
  }
  function w(_) {
    if (Array.isArray(_))
      return _;
  }
  function $(_, P) {
    if (_ == null)
      return {};
    var S = C(_, P), I, N;
    if (Object.getOwnPropertySymbols) {
      var k = Object.getOwnPropertySymbols(_);
      for (N = 0; N < k.length; N++)
        I = k[N], !(P.indexOf(I) >= 0) && Object.prototype.propertyIsEnumerable.call(_, I) && (S[I] = _[I]);
    }
    return S;
  }
  function C(_, P) {
    if (_ == null)
      return {};
    var S = {}, I = Object.keys(_), N, k;
    for (k = 0; k < I.length; k++)
      N = I[k], !(P.indexOf(N) >= 0) && (S[N] = _[N]);
    return S;
  }
  var x = {
    locale: "en-US",
    formats: {
      number: {
        USD: {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      }
    }
  }, b = function(P) {
    var S = P.component, I = P.value, N = P.defaultValue, k = P.config, j = P.currency, R = P.max, D = P.autoFocus, T = P.autoSelect, V = P.autoReset, L = P.onChange, Z = P.onBlur, z = P.onFocus, W = P.onKeyPress, U = $(P, ["component", "value", "defaultValue", "config", "currency", "max", "autoFocus", "autoSelect", "autoReset", "onChange", "onBlur", "onFocus", "onKeyPress"]), re = (0, t.useCallback)(function(Te) {
      var we = Te === document.activeElement;
      Te && D && !we && Te.focus();
    }, [D]), X = (0, t.useState)("0"), J = p(X, 2), Q = J[0], se = J[1], q = (0, t.useMemo)(function() {
      return function() {
        var Te = k.formats.number[j].maximumFractionDigits, we = d(d({}, x), k);
        return we.formats.number[j].minimumFractionDigits = Te, we;
      };
    }, [x, k]), te = function(we) {
      return typeof we == "number" ? we : Number(we.toString().replace(/[^0-9-]/g, ""));
    }, ae = function(we) {
      var He = q(), he = He.formats.number[j].maximumFractionDigits, xe = we;
      return typeof we == "string" ? (xe = te(we), xe % 1 !== 0 && (xe = xe.toFixed(he))) : xe = Number.isInteger(we) ? Number(we) * Math.pow(10, he) : we.toFixed(he), te(xe) / Math.pow(10, he);
    }, ge = function(we) {
      var He = ae(we), he = (0, o.default)(He, q(), j);
      return [He, he];
    }, G = function(we) {
      var He = ge(we), he = p(He, 2), xe = he[0], Le = he[1];
      return !R || xe <= R ? (se(Le), [xe, Le]) : [ae(Q), Q];
    }, oe = function(we) {
      we.preventDefault();
      var He = G(we.target.value), he = p(He, 2), xe = he[0], Le = he[1];
      Le && L(we, xe, Le);
    }, ne = function(we) {
      var He = G(we.target.value), he = p(He, 2), xe = he[0], Le = he[1];
      V && ge(0), Le && Z(we, xe, Le);
    }, _e = function(we) {
      T && we.target.select();
      var He = G(we.target.value), he = p(He, 2), xe = he[0], Le = he[1];
      Le && z(we, xe, Le);
    }, ye = function(we) {
      return W(we, we.key, we.keyCode);
    };
    return (0, t.useEffect)(function() {
      var Te = I || N || 0, we = ge(Te), He = p(we, 2), he = He[1];
      se(he);
    }, [j, I, N, k]), /* @__PURE__ */ t.default.createElement(S, s({}, U, {
      ref: re,
      value: Q,
      onChange: oe,
      onBlur: ne,
      onFocus: _e,
      onKeyUp: ye
    }));
  };
  b.propTypes = {
    defaultValue: n.number,
    value: n.number,
    max: n.number,
    component: n.node.isRequired,
    currency: n.string.isRequired,
    config: (0, n.shape)().isRequired,
    autoFocus: n.bool.isRequired,
    autoSelect: n.bool.isRequired,
    autoReset: n.bool.isRequired,
    onChange: n.func.isRequired,
    onBlur: n.func.isRequired,
    onFocus: n.func.isRequired,
    onKeyPress: n.func.isRequired
  }, b.defaultProps = {
    component: "input",
    currency: "USD",
    value: 0,
    config: x,
    autoFocus: !1,
    autoSelect: !1,
    autoReset: !1,
    onChange: function(P) {
      return P;
    },
    onBlur: function(P) {
      return P;
    },
    onFocus: function(P) {
      return P;
    },
    onKeyPress: function(P) {
      return P;
    }
  };
  var O = b;
  e.default = O;
})(J$);
const Vfe = /* @__PURE__ */ Qn(J$), Ffe = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    }
  }
}, Zfe = 999999.99, Wfe = ue((e, r) => {
  const {
    label: t,
    error: n,
    onChange: o,
    disabled: a,
    fullWidth: i,
    max: l = Zfe,
    cy: s,
    ...u
  } = e, [d, f] = Se(!1), p = Lfe({
    error: n,
    disabled: a,
    dataEntered: d,
    fullWidth: i
  }), g = $e((h, v, y) => {
    var $;
    const w = ($ = h == null ? void 0 : h.currentTarget) == null ? void 0 : $.value;
    w || typeof w == "string" && (w != null && w.length) ? f(!0) : f(!1), o && o(h, v, y);
  }, [o]);
  return /* @__PURE__ */ Y("div", { css: p.wrapper, "data-cy": Ee("currencyInput-wrapper", s == null ? void 0 : s.wrapper), children: [
    /* @__PURE__ */ Y("div", { css: p.container, children: [
      /* @__PURE__ */ m("fieldset", { css: p.fieldset, children: t && /* @__PURE__ */ m("legend", { css: p.label, children: /* @__PURE__ */ m("label", { children: t }) }) }),
      /* @__PURE__ */ m(Vfe, { id: "conexaCurrency", "aria-label": "currencyInput", currency: "BRL", css: p.input, config: Ffe, max: l, inputRef: r, onChange: g, disabled: a, "data-cy": Ee("currencyInput-input", s == null ? void 0 : s.input), ...u })
    ] }),
    n && /* @__PURE__ */ m(tr, { variant: "microCopy", css: p.error, children: n })
  ] });
});
Wfe.displayName = "CurrencyInput";
const Bfe = Ne({
  root: ({
    spacing: e,
    colors: r
  }) => M`
    gap: ${e.xxs};

    &[data-validated='true'] {
      input {
        border: 1px solid ${r.feedback.success[300]};
        color: ${r.neutral[400]};
      }
    }
  `,
  input: ({
    colors: e,
    typography: r,
    border: t
  }) => M`
    width: 44px;
    height: 44px;
    border: 1px solid ${e.neutral[300]};
    color: ${e.neutral[400]};
    ${r.label};
    border-radius: ${t.radius.lg};

    &:focus {
      border: 1px solid ${e.brand.primary[300]};
    }

    &[data-invalid='true'] {
      border: 1px solid ${e.feedback.error[300]};
      color: ${e.neutral[400]};
    }
  `,
  wrapperErrorMessage: ({
    colors: e
  }) => M`
    margin-top: 4px;

    span {
      color: ${e.feedback.error[300]};
    }
  `
}), Hfe = ue((e, r) => {
  const {
    placeholder: t = "",
    validated: n,
    error: o,
    id: a,
    ...i
  } = e, l = Bfe(), s = ke(a);
  return /* @__PURE__ */ Y("div", { children: [
    /* @__PURE__ */ m(_C, { styles: l, ref: r, placeholder: t, "data-validated": n, error: !!o, id: s, ...i }),
    o ? /* @__PURE__ */ m("div", { css: l.wrapperErrorMessage, children: /* @__PURE__ */ m(tr, { variant: "microCopy", renderAs: "span", showOnClarity: !0, children: o }) }) : null
  ] });
});
Hfe.displayName = "PinInput";
const Q$ = {
  "x-large": 120,
  large: 56,
  medium: 40,
  small: 32,
  "x-small": 24
}, Tl = {
  "x-large": 80,
  large: 32,
  medium: 24,
  small: 18,
  "x-small": 14
}, Gfe = {
  "x-large": {
    bottom: "60px",
    left: "54px"
  },
  large: {
    bottom: "28px",
    left: "30px"
  },
  medium: {
    bottom: "19px",
    left: "20px"
  },
  small: {
    bottom: "15px",
    left: "19px"
  },
  "x-small": {
    bottom: "10px",
    left: "13px"
  }
};
function eO(e) {
  return typeof e == "string" ? e.toLowerCase().replace(/\w\S*/g, (t) => t.replace(/^\w/, (n) => n.toUpperCase())) : e;
}
const Xfe = Ne({
  dropdown: (e) => M`
    padding: 8px 0px !important;
    border-radius: ${e.border.radius.lg};
    box-shadow: ${e.shadow.level1};
  `,
  item: (e) => M`
    z-index: 1;
    height: 38px;
    color: ${e.colors.neutral[500]};
    background: ${e.colors.background.white};
    font-family: ${e.typography.label.fontFamily};
    color: ${e.colors.neutral[300]};
    font-weight: ${e.fontWeights.normal};
    font-size: ${e.fontSizes.sm};
    border-radius: 0;

    &:hover {
      color: ${e.colors.brand.primary[300]};
      background-color: ${e.colors.brand.primary[100]};
    }

    &:disabled {
      color: ${e.colors.neutral[200]};
    }
  `,
  itemLabel: (e) => M`
    font-family: ${e.typography.label.fontFamily};
    font-size: ${e.fontSizes.sm};
    border-radius: ${e.border.radius.none};
  `
}), rO = ({
  children: e,
  id: r,
  cy: t,
  ...n
}) => {
  const o = ke(r);
  return /* @__PURE__ */ m(pn.Item, { id: o, "data-cy": Ee("action-list-item", t), ...n, children: e });
};
rO.displayName = "ActionList.Item";
const Nr = ({
  children: e,
  withinPortal: r = !0,
  width: t = 200,
  offset: n = 8,
  ...o
}) => {
  const a = Xfe();
  return /* @__PURE__ */ m(pn, { styles: a, withinPortal: r, width: t, ...o, offset: n, children: e });
};
Nr.displayName = "ActionList";
Nr.Target = pn.Target;
Nr.Target.displayName = "ActionList.Target";
Nr.Dropdown = pn.Dropdown;
Nr.Dropdown.displayName = "ActionList.Dropdown";
Nr.Item = rO;
const Yfe = Ne({
  root: (e, {
    size: r
  }) => M`
    display: flex;
    border-radius: ${e.border.radius.full};

    svg {
      width: ${Tl[r]}px;
      height: ${Tl[r]}px;
    }
  `,
  label: (e, {
    size: r
  }) => M`
    span {
      font-family: ${e.typography.label.fontFamily};
      font-size: ${r === "large" ? e.fontSizes.xl : e.fontSizes.xs};
      color: ${e.colors.neutral[400]};
      margin-right: ${e.spacing.xxs};
    }
  `,
  container: (e, {
    menu: r
  }) => M`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    gap: ${e.spacing.xxs};
    cursor: ${r ? "pointer" : "default"};
  `,
  avatarWrapper: M`
    display: inline-block;
    position: relative;
  `,
  status: (e, {
    size: r
  }) => M`
    position: absolute;
    z-index: 1;
    stroke: ${e.colors.background.white};
    stroke-width: 2px;
    svg {
      width: ${Tl[r]}px;
      height: ${Tl[r]}px;
    }

    ${Gfe[r]}
  `,
  menuButton: M`
    padding: 0;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    border: none;
    text-decoration: none;
  `
}), Ufe = (e, r) => {
  const t = e || "", n = r && (e == null ? void 0 : e.length) > r ? "..." : "";
  return r ? t.slice(0, r) + n : t;
}, Jfe = (e) => e == null ? void 0 : e.replace(/\s+/g, " ").trim().split(" ")[0], qfe = ({
  label: e,
  maxLabelLength: r,
  firstName: t
}) => {
  let n = e;
  return t && (n = Jfe(n)), r && (n = Ufe(n, r)), eO(n);
}, Kfe = (e, r) => ({
  light: M`
      background-color: ${e.colors.background.white};
      color: ${e.colors.neutral[400]};
    `,
  dark: M`
      background-color: ${e.colors.neutral[400]};
      color: ${e.colors.background.white};
    `
})[r], Qfe = Ne({
  tooltip: (e, {
    variant: r
  }) => M`
    box-shadow: ${e.shadow.level1};
    ${Kfe(e, r)};
    padding: 12px;
    border-radius: ${e.border.radius.xs};
    font-size: ${e.fontSizes.xs};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
  `
}), e2e = ({
  children: e,
  variant: r = "dark",
  position: t = "top",
  withinPortal: n = !0,
  ...o
}) => {
  const a = Qfe({
    variant: r
  });
  return /* @__PURE__ */ m(kC, { styles: a, position: t, withinPortal: n, arrowSize: 9, arrowOffset: 7, ...o, children: e });
}, r2e = Ne({
  root: (e) => M`
    border-radius: ${e.border.radius.full};
  `
}), t2e = {
  xl: "headingSmall",
  lg: "subheading",
  md: "paragraphLarge",
  sm: "paragraphSmall",
  xs: "microCopy"
}, n2e = {
  xl: "xs",
  lg: "sm",
  md: "md",
  sm: "lg",
  xs: "xl"
}, Zv = {
  xl: "x-large",
  lg: "large",
  md: "medium",
  sm: "small",
  xs: "x-small"
}, tO = ({
  id: e,
  children: r,
  limit: t = 3,
  size: n = "lg",
  spacing: o = "md",
  hideAccumulator: a,
  accumulatorAltText: i,
  ...l
}) => {
  const s = ke(e), u = ke(e), d = ke(e), f = r2e(), p = ur(), g = Je(() => Gr.count(r), [r]), h = Je(() => g - Math.abs(t), [t, g]), v = Je(() => !!t && g > Math.abs(t), [t, g]), y = Je(() => {
    const w = Math.abs(t);
    return t && Array.isArray(r) ? Gr.map(r.slice(0, w), ($) => A.isValidElement($) ? Wr($, {
      ...$.props,
      size: Zv[n]
    }) : $) : r;
  }, [r, t, n]);
  return /* @__PURE__ */ Y(P0.Group, { id: s, spacing: n2e[o], ...l, children: [
    y,
    !a && v && /* @__PURE__ */ m(P0, { id: u, alt: i, styles: f, size: Q$[Zv[n]], children: /* @__PURE__ */ m(tr, { id: d, "data-testid": "accumulator-count", color: p.colors.neutral[300], variant: t2e[n], children: "+" + h }) })
  ] });
};
tO.displayName = "Avatar.Group";
const ti = ur(), Ta = ({
  id: e,
  size: r = "large",
  label: t,
  menu: n,
  status: o,
  children: a,
  actionListItem: i,
  maxLabelLength: l,
  firstName: s = !1,
  hasTooltipOnLabel: u,
  ...d
}) => {
  const f = Yfe({
    size: r,
    menu: n
  }), [p, g] = Se(!1), h = r8(() => g(!1)), v = Je(() => qfe({
    firstName: s,
    label: t,
    maxLabelLength: l
  }), [s, t, l]), y = ke(e), w = ke(e), $ = ke(e), C = () => n ? g((b) => !b) : null, x = o === "online" ? ti.colors.feedback.success[300] : ti.colors.feedback.error[300];
  return /* @__PURE__ */ m("div", { css: f.root, children: /* @__PURE__ */ Y("div", { css: f.container, ref: h, onClick: C, children: [
    /* @__PURE__ */ Y("div", { css: f.avatarWrapper, children: [
      /* @__PURE__ */ m(P0, { id: y, alt: t || "image", size: Q$[r], styles: f, ...d, children: /* @__PURE__ */ m(gx, { "data-testid": "avatar", "aria-label": "user icon", color: ti.colors.neutral[300] }) }),
      o && /* @__PURE__ */ m("div", { css: f.status, children: /* @__PURE__ */ m(m2, { "data-testid": "bullet", "aria-label": "bullet icon", color: x }) })
    ] }),
    t && /* @__PURE__ */ m("div", { css: f.label, "data-clarity-mask": !0, children: u ? /* @__PURE__ */ m(e2e, { label: eO(t), position: "bottom", children: /* @__PURE__ */ m("span", { "data-testid": "label", children: v }) }) : /* @__PURE__ */ m("span", { "data-testid": "label", children: v }) }),
    n && /* @__PURE__ */ Y(Nr, { id: $, opened: p, children: [
      /* @__PURE__ */ m(Nr.Target, { children: /* @__PURE__ */ m("button", { css: f.menuButton, children: p ? /* @__PURE__ */ m(io, { "data-testid": "arrow-up", "aria-label": "arrow up icon", color: ti.colors.neutral[200] }) : /* @__PURE__ */ m(Nn, { "data-testid": "arrow-down", "aria-label": "arrow down icon", color: ti.colors.neutral[200] }) }) }),
      /* @__PURE__ */ m(Nr.Dropdown, { id: w, children: i == null ? void 0 : i.map((b) => /* @__PURE__ */ m(Nr.Item, { onClick: b.onClick, disabled: b.disabled, "data-clarity-mask": !0, children: b.label }, b.id)) })
    ] }),
    a
  ] }) });
};
Ta.displayName = "Avatar";
Ta.Group = tO;
const o2e = Ne({
  content: ({
    typography: e,
    colors: r
  }) => M`
    ${e.paragraphLarge};
    color: ${r.neutral[400]};
  `,
  control: ({
    colors: e,
    spacing: r
  }, {
    position: t
  }) => M`
    display: flex;
    margin: ${t === "center" && "0 auto"};
    gap: ${r.xxs};
    margin-top: ${r.xxs};

    p,
    svg {
      color: ${e.brand.primary[500]};
    }

    :hover {
      text-decoration: none;
    }
  `
}), x5e = ({
  position: e = "left",
  maxHeight: r = 48,
  transitionDuration: t = 500,
  children: n,
  ...o
}) => {
  const a = o2e({
    position: e
  }), i = Je(() => ({
    showLabel: /* @__PURE__ */ Y(Br, { children: [
      /* @__PURE__ */ m(tr, { variant: "subheading", children: "Ver mais" }),
      /* @__PURE__ */ m(Nn, { "aria-label": "arrow-down", "data-testid": "arrow-down" })
    ] }),
    hideLabel: /* @__PURE__ */ Y(Br, { children: [
      /* @__PURE__ */ m(tr, { variant: "subheading", children: "Ver menos" }),
      /* @__PURE__ */ m(io, { "aria-label": "arrow-up", "data-testid": "arrow-up" })
    ] })
  }), []);
  return /* @__PURE__ */ m(dw, { maxHeight: r, showLabel: i == null ? void 0 : i.showLabel, hideLabel: i == null ? void 0 : i.hideLabel, transitionDuration: t, styles: a, ...o, children: n });
}, Dl = (e, r) => ({
  border: `1px solid ${e.colors.feedback[r][300]}`,
  background: e.colors.feedback[r][100],
  color: e.colors.feedback[r][400],
  titleColor: e.colors.feedback[r][500]
}), a2e = Ne({
  root: (e, {
    variant: r
  }) => M`
    border-radius: ${e.border.radius.lg};
    padding: ${e.spacing.xs};
    background: ${Dl(e, r).background};
    color: ${Dl(e, r).titleColor};
    border: ${Dl(e, r).border};
  `,
  lowerAction: (e) => M`
    margin-top: ${e.spacing.xxs};
  `,
  message: (e, {
    variant: r
  }) => M`
    font-family: ${e.typography.label.fontFamily};
    font-size: ${e.fontSizes.md};
    color: ${Dl(e, r).color};

    & a {
      text-decoration: none;
      font-weight: ${e.fontWeights.bold};
      color: ${e.colors.brand.primary[300]};
    }
  `,
  title: (e) => M`
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.bold};
    font-size: ${e.fontSizes.md};
  `
}), $5e = ({
  id: e,
  title: r,
  text: t,
  action: n,
  actionLabel: o,
  actionIsLoading: a,
  hideIcon: i,
  withCloseButton: l,
  variant: s = "information",
  cy: u,
  ...d
}) => {
  const f = a2e({
    variant: s
  }), p = ke(e), g = {
    information: /* @__PURE__ */ m(Zi, { "data-testid": "information", "aria-label": "information icon" }),
    success: /* @__PURE__ */ m(N1, { "data-testid": "success", "aria-label": "success icon" }),
    warning: /* @__PURE__ */ m(Wi, { "data-testid": "warning", "aria-label": "warning icon" }),
    error: /* @__PURE__ */ m(Fi, { "data-testid": "error", "aria-label": "error icon" })
  }, h = Je(() => /* @__PURE__ */ m("div", { "data-cy": Ee("alert-title", u == null ? void 0 : u.title), children: r }), [r, u == null ? void 0 : u.title]);
  return /* @__PURE__ */ m(Br, { children: /* @__PURE__ */ Y(km, { "data-testid": "hero-alert", id: p, styles: f, icon: !i && g[s], title: h, withCloseButton: l, ...d, children: [
    /* @__PURE__ */ m("div", { "data-cy": Ee("alert-text", u == null ? void 0 : u.text), dangerouslySetInnerHTML: {
      __html: t
    } }),
    n && o && /* @__PURE__ */ m("div", { css: f.lowerAction, children: /* @__PURE__ */ m(st, { onClick: n, "aria-label": "action button", busy: a, variant: "link", cy: Ee("alert-action", u == null ? void 0 : u.action), children: o }) })
  ] }) });
}, i2e = (e) => e > 100 ? 100 : e < 0 ? 0 : e, l2e = {
  small: M`
    height: 4px;
  `,
  medium: M`
    height: 8px;
  `
}, s2e = {
  primary: (e) => M`
    background-color: ${e.colors.brand.primary[300]};
  `,
  tertiary: (e) => M`
    background-color: ${e.colors.brand.tertiary[300]};
  `,
  error: (e) => M`
    background-color: ${e.colors.feedback.error[300]};
  `,
  success: (e) => M`
    background-color: ${e.colors.feedback.success[300]};
  `
}, c2e = Ne({
  container: (e, {
    size: r
  }) => M`
    width: 100%;
    background-color: ${e.colors.neutral[100]};
    border-radius: ${e.border.radius.full};

    ${!!r && l2e[r]}
  `,
  progress: (e, {
    value: r,
    variant: t
  }) => M`
    height: 100%;
    width: ${i2e(r)}%;
    border-radius: ${e.border.radius.lg};
    transition: width 0.4s ease-in-out;

    ${!!t && s2e[t](e)}
  `
}), nO = ({
  value: e,
  id: r,
  size: t = "small",
  variant: n = "primary",
  ...o
}) => {
  const a = c2e({
    value: e,
    size: t,
    variant: n
  }), i = ke(r);
  return /* @__PURE__ */ m("div", { css: a.container, tabIndex: -1, id: i, children: /* @__PURE__ */ m("div", { css: a.progress, ...o, "data-testid": "progress" }) });
}, {
  colors: Xd
} = ur(), Gn = (e) => ({
  backgroundColor: Xd.feedback[e][200],
  color: Xd.feedback[e][500],
  border: Xd.feedback[e][300]
}), oO = {
  "top-right": "animate__fadeInRight",
  "top-center": "animate__fadeInDown",
  "top-left": "animate__fadeInLeft",
  "bottom-right": "animate__fadeInRight",
  "bottom-center": "animate__fadeInUp",
  "bottom-left": "animate__fadeInLeft"
}, u2e = {
  "top-right": "animate__fadeOutRight",
  "top-center": "animate__fadeOutUp",
  "top-left": "animate__fadeOutLeft",
  "bottom-right": "animate__fadeOutRight",
  "bottom-center": "animate__fadeOutDown",
  "bottom-left": "animate__fadeOutLeft"
}, x2 = 300, jl = {
  body: {
    isMobile: M`
      grid-template-areas:
        'leftIcon text text closeButton'
        'leftIcon button . .';
    `,
    hasAction: M`
      grid-template-columns: 24px auto 1fr 24px;
      grid-template-areas: 'leftIcon text button closeButton';
    `,
    notAction: M`
      grid-template-columns: 24px auto 24px;
      grid-template-areas: 'leftIcon text closeButton';
    `
  },
  action: {
    isMobile: (e) => M`
      margin: ${e.spacing.xs} 12px 0 12px;
    `
  }
}, d2e = Ne({
  body: (e, {
    variant: r,
    hasAction: t
  }) => M`
    max-width: 578px;
    min-width: 266px;
    width: fit-content;
    background-color: ${Gn(r).backgroundColor};
    padding: ${e.spacing.xs};
    border-radius: ${e.border.radius.lg};
    border: 1px solid ${Gn(r).border};
    display: grid;
    align-items: flex-start;
    animation-duration: ${x2}ms;

    ${t && jl.body.hasAction};
    ${!t && jl.body.notAction};

    @media only screen and (max-width: ${e.grid.breakpoint.sm}) {
      ${t && jl.body.isMobile};
    }
  `,
  text: (e, {
    variant: r
  }) => M`
    ${e.typography.paragraphSmall};
    grid-area: text;
    margin: 0px 12px;
    display: inline-flex;
    align-items: center;
    color: ${Gn(r).color};
    flex-grow: 1;
  `,
  action: (e, {
    variant: r,
    hasAction: t
  }) => M`
    grid-area: button;
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.bold};
    font-size: ${e.fontSizes.md};
    color: ${Gn(r).color};
    margin: 4px ${e.spacing.xs} 0 ${e.spacing.xxs};
    cursor: pointer;

    @media only screen and (max-width: ${e.grid.breakpoint.sm}) {
      ${t && jl.action.isMobile(e)};
    }
  `,
  icon: M`
    grid-area: leftIcon;
    width: 24px;
    height: 24px;
  `,
  close: M`
    grid-area: closeButton;
    height: 24px;

    button {
      border: none;
      padding: 0;
      background: none;
      cursor: pointer;
      width: fit-content;
      height: 24px;
    }
  `
}), f2e = ({
  id: e,
  message: r,
  variant: t = "success",
  onClose: n,
  actionLabel: o,
  action: a,
  position: i
}) => {
  const l = d2e({
    variant: t,
    hasAction: !!o
  }), {
    containerPosition: s
  } = Vt(To), u = ur(), d = {
    success: /* @__PURE__ */ m(N1, { "aria-label": "success", "data-testid": "successIcon", size: "medium", color: u.colors.feedback.success[500] }),
    error: /* @__PURE__ */ m(Fi, { "aria-label": "error", "data-testid": "errorIcon", size: "medium", color: u.colors.feedback.error[500] }),
    warning: /* @__PURE__ */ m(Wi, { "aria-label": "warning", "data-testid": "warningIcon", size: "medium", color: u.colors.feedback.warning[500] }),
    information: /* @__PURE__ */ m(Zi, { "aria-label": "information", "data-testid": "informationIcon", size: "medium", color: u.colors.feedback.information[500] })
  };
  return /* @__PURE__ */ Y("div", { css: l.body, id: e, className: `${oO[i != null ? i : s]}`, "data-testid": "toast-container", children: [
    /* @__PURE__ */ m("span", { css: l.icon, children: d[t] }),
    /* @__PURE__ */ m("span", { css: l.text, children: r }),
    o && /* @__PURE__ */ m("span", { css: l.action, className: "action", onClick: a, children: o }),
    /* @__PURE__ */ m("div", { css: l.close, children: /* @__PURE__ */ m("button", { name: "close-button", "aria-label": "close", type: "button", onClick: () => n(e), id: "closeButton", children: /* @__PURE__ */ m(Fo, { "aria-label": "close", color: u.colors.feedback[t][500] }) }) })
  ] });
}, p2e = Ne({
  body: (e, {
    variant: r
  }) => M`
    width: 450px;
    max-width: 100%;
    background-color: ${Gn(r).backgroundColor};
    padding: ${e.spacing.xs};
    border-radius: ${e.border.radius.lg};
    border: 0.5px solid ${Gn(r).border};
    display: flex;
    align-items: center;
    flex-direction: column;
    animation-duration: ${x2}ms;
  `,
  topSection: M`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: start;
  `,
  avatarSection: (e) => M`
    display: flex;
    align-items: flex-start;
    gap: ${e.spacing.xxs};
  `,
  footer: (e) => M`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: ${e.spacing.xs};
    gap: ${e.spacing.xxs};
    width: 100%;
  `,
  close: M`
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 22px;
      height: 22px;
    }
  `
}), g2e = ({
  id: e,
  variant: r = "success",
  onClose: t,
  avatarProps: n,
  position: o,
  primaryAction: a,
  primaryActionLabel: i,
  secondaryAction: l,
  secondaryActionLabel: s
}) => {
  const u = p2e({
    variant: r
  }), {
    containerPosition: d
  } = Vt(To), f = ur(), p = ke(e);
  return /* @__PURE__ */ Y("div", { css: u.body, id: p, className: `${oO[o != null ? o : d]}`, "data-testid": "toast-container", children: [
    /* @__PURE__ */ Y("div", { css: u.topSection, children: [
      /* @__PURE__ */ Y("div", { css: u.avatarSection, children: [
        /* @__PURE__ */ m(Ta, { id: "toast-avatar", size: "large", src: n.src }),
        /* @__PURE__ */ Y("div", { children: [
          /* @__PURE__ */ m(tr, { variant: "subheading", color: Gn(r).color, children: n.username }),
          /* @__PURE__ */ m(tr, { variant: "paragraphSmall", color: Gn(r).color, children: n.description })
        ] })
      ] }),
      /* @__PURE__ */ m("span", { css: u.close, children: /* @__PURE__ */ m(p1, { "aria-label": "action-close", variant: "transparent", onClick: () => t(e), children: /* @__PURE__ */ m(Fo, { "aria-label": "close", color: f.colors.feedback[r][500] }) }) })
    ] }),
    /* @__PURE__ */ Y("div", { css: u.footer, children: [
      l && /* @__PURE__ */ m(st, { id: "secondary-action", variant: "secondary", onClick: l, fullWidth: !0, children: s }),
      a && /* @__PURE__ */ m(st, { id: "primary-action", onClick: a, fullWidth: !0, children: i })
    ] })
  ] });
}, v2e = 3e3, m2e = {
  "top-right": "position: fixed; top: 0; right: 0; padding: 8px; z-index: 9999;",
  "top-center": "position: fixed; top: 0; left: 50%; transform: translateX(-50%); padding: 8px; z-index: 9999;",
  "top-left": "position: fixed; top: 0; left: 0; padding: 8px; z-index: 9999;",
  "bottom-left": "position: fixed; bottom: 0; left: 0; padding: 8px; z-index: 9999;",
  "bottom-center": "position: fixed; bottom: 0; left: 50%; transform: translateX(-50%); padding: 8px; z-index: 9999;",
  "bottom-right": "position: fixed; bottom: 0; right: 0; padding: 8px; z-index: 9999;"
}, h2e = () => {
  const e = ke(), [r, t] = Se(!1), [n] = Se(`toast-container-${e}`), {
    containerPosition: o
  } = To.getState(), a = $e((i) => i.map((l) => {
    const s = document.createElement("div");
    return s.setAttribute("id", n + l), s.setAttribute("style", m2e[l]), document.getElementsByTagName("body")[0].prepend(s), s;
  }), [n]);
  return Fe(() => {
    a(e1e), t(!0);
  }, [n, o, a]), {
    toastContainerId: n,
    loaded: r
  };
}, aO = () => {
  const {
    removeToast: e,
    containerPosition: r
  } = To.getState();
  function t(o) {
    e(o);
  }
  function n(o, a) {
    const i = document.getElementById(o);
    i && (i.classList.add(u2e[a != null ? a : r]), setTimeout(() => {
      t(o);
    }, x2));
  }
  return {
    toastRemoval: n
  };
}, b2e = (e) => {
  const {
    toasts: r
  } = e, {
    toastRemoval: t
  } = aO(), [n, o] = Se();
  Fe(() => {
    n != null && n.id && t(n.id, n == null ? void 0 : n.position);
  }, [n]), Fe(() => {
    if (!r.length)
      return;
    const a = r[r.length - 1];
    a.autoClose && setTimeout(() => o(a), a.autoCloseDuration || v2e);
  }, [r]);
}, y2e = Ne({
  wrapper: (e) => M`
    display: flex;
    gap: ${e.spacing.xxs};
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `
}), C2e = ({
  toasts: e,
  position: r,
  toastContainerId: t
}) => {
  const {
    toastRemoval: n
  } = aO(), o = y2e(), a = Je(() => `#${t + r}`, [r, t]), i = $e((l) => {
    l != null && l.onClose && l.onClose(l.id), n(l.id, l == null ? void 0 : l.position);
  }, [n]);
  return /* @__PURE__ */ m(_f, { target: a, children: /* @__PURE__ */ m("div", { css: o.wrapper, children: e.map((l) => l.type === "Expanded" ? /* @__PURE__ */ m(g2e, { ...l, onClose: () => i(l) }, l.id) : /* @__PURE__ */ m(f2e, { ...l, onClose: () => i(l) }, l.id)) }) });
}, O5e = ({
  position: e = "top-right"
}) => {
  const {
    toasts: r,
    setContainerPosition: t
  } = Vt(To), {
    toastContainerId: n,
    loaded: o
  } = h2e();
  Fe(() => {
    e && t(e);
  }, [e]), b2e({
    toasts: r
  });
  const a = r.reduce((i, l) => (i[l.position || e] = [...i[l.position || e] || [], l], i), {});
  return o ? /* @__PURE__ */ m(Br, { children: Object.entries(a).map(([i, l]) => /* @__PURE__ */ m(C2e, { position: i, toasts: l, toastContainerId: n }, i)) }) : /* @__PURE__ */ m(Br, {});
}, Ll = (e, r) => ({
  border: `1px solid ${e.colors.feedback[r][300]}`,
  background: e.colors.feedback[r][100],
  color: e.colors.feedback[r][400],
  titleColor: e.colors.feedback[r][500]
}), w2e = Ne({
  root: (e, {
    variant: r
  }) => M`
    padding: ${e.spacing.xs} ${e.spacing.sm};
    background: ${Ll(e, r).background};
    border-bottom: ${Ll(e, r).border};
    min-height: 76px;
    width: 100%;
    box-sizing: border-box;
  `,
  leftIcon: (e, {
    variant: r
  }) => M`
    grid-area: leftIcon;
    margin-top: ${e.spacing.xxs};

    svg {
      color: ${Ll(e, r).titleColor};
      min-height: 24px;
      min-width: 24px;
    }

    div {
      word-wrap: break-word;
    }
  `,
  wrapper: (e, {
    withCloseButton: r
  }) => M`
    display: grid;
    align-items: flex-start;
    height: 100%;
    grid-template-areas: 'leftIcon text button closeButton';
    grid-template-columns: ${r ? "24px 10fr 1fr 24px" : "24px 10fr 1fr"};
    justify-content: space-between;
    gap: ${e.spacing.xxs};

    @media only screen and (max-width: ${e.grid.breakpoint.sm}) {
      grid-template-areas:
        'leftIcon text text closeButton'
        'button button button button';
    }
  `,
  text: (e, {
    variant: r
  }) => M`
    grid-area: text;
    margin-top: ${e.spacing.xxs};

    div {
      color: ${Ll(e, r).titleColor};
    }
  `,
  rightSection: (e, {
    hasButtonLabel: r
  }) => M`
    white-space: nowrap;
    grid-area: button;

    @media only screen and (max-width: ${e.grid.breakpoint.sm}) {
      margin-top: ${r ? e.spacing.xxs : 0};
    }
  `,
  iconButton: (e) => M`
    grid-area: closeButton;

    button {
      border: none;
      padding: 0;
      background: none;
      cursor: pointer;
      width: fit-content;
      height: 44px;

      svg {
        color: ${e.colors.neutral[200]};
      }
    }
  `
}), P5e = ({
  variant: e = "success",
  action: r,
  actionLabel: t,
  actionIsLoading: n,
  onClose: o,
  withCloseButton: a,
  text: i,
  cy: l
}) => {
  const s = w2e({
    variant: e,
    hasButtonLabel: !!t,
    withCloseButton: a
  }), u = {
    information: /* @__PURE__ */ m(Zi, { "data-testid": "information", "aria-label": "information icon" }),
    success: /* @__PURE__ */ m(N1, { "data-testid": "success", "aria-label": "success icon" }),
    warning: /* @__PURE__ */ m(Wi, { "data-testid": "warning", "aria-label": "warning icon" }),
    error: /* @__PURE__ */ m(Fi, { "data-testid": "error", "aria-label": "error icon" })
  };
  return /* @__PURE__ */ m("div", { css: s.root, children: /* @__PURE__ */ Y("div", { css: s.wrapper, children: [
    /* @__PURE__ */ m("div", { css: s.leftIcon, children: u[e] }),
    /* @__PURE__ */ m("div", { css: s.text, children: /* @__PURE__ */ m(tr, { renderAs: "div", id: "text", cy: Ee("banner-text", l == null ? void 0 : l.text), showOnClarity: !0, children: i }) }),
    t && /* @__PURE__ */ m("div", { css: s.rightSection, children: /* @__PURE__ */ m(st, { name: t, variant: "tertiary", onClick: r, type: "button", id: "actionButton", busy: n, cy: Ee("banner-action", l == null ? void 0 : l.action), children: t }) }),
    a && /* @__PURE__ */ m("div", { css: s.iconButton, children: /* @__PURE__ */ m("button", { name: "close-button", type: "button", onClick: o, id: "closeButton", "data-cy": Ee("button-banner-close-action", l == null ? void 0 : l.closeAction), children: /* @__PURE__ */ m(Fo, { "data-testid": "close-button", "aria-label": "icon close" }) }) })
  ] }) });
}, _2e = Ne({
  root: ({
    colors: e,
    spacing: r
  }) => M`
    background-color: ${e.feedback.warning[200]};
    border-bottom: 1px solid ${e.feedback.warning[300]};
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${r.xxs};
    height: 32px;

    h1 {
      color: ${e.feedback.warning[500]};
    }
  `
}), x2e = () => /* @__PURE__ */ Y("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ m("path", { d: "M9.18665 2.66666L6.81332 13.3333", stroke: "#3D3300", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ m("path", { d: "M12 5.33334L14.6667 8.00001L12 10.6667", stroke: "#3D3300", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ m("path", { d: "M4 10.6667L1.33334 8.00001L4 5.33334", stroke: "#3D3300", strokeLinecap: "round", strokeLinejoin: "round" })
] }), S5e = ({
  disabled: e = Que
}) => {
  const r = _2e();
  return e ? null : /* @__PURE__ */ Y("div", { css: r.root, children: [
    /* @__PURE__ */ m(x2e, {}),
    /* @__PURE__ */ m(tr, { variant: "microCopy", renderAs: "h1", children: "Ambiente de homologação" })
  ] });
}, $2e = {
  small: 16,
  medium: 24,
  large: 32
}, O2e = (e) => $2e[e || "large"], P2e = (e, r, t) => r === "star" && e === "inline" ? {
  flexDirection: "row"
} : {
  flexDirection: "column",
  padding: t.spacing.xs
}, S2e = Ne({
  root: (e, {
    layoutMode: r,
    type: t
  }) => M`
    display: flex;
    gap: ${e.spacing.xxs};
    align-items: center;
    width: fit-content;
    color: ${e.colors.brand.primary[300]};

    ${P2e(r, t, e)}
  `,
  numbersWrapper: (e) => M`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: ${e.spacing.xxs};
  `,
  feedbackTextLeft: M`
    align-self: flex-start;
  `,
  feedbackTextRight: M`
    align-self: flex-end;
  `
}), I2e = Ne({
  root: (e) => M`
    display: flex;
    gap: ${e.spacing.xxs};
  `
}), E2e = {
  width: 40,
  height: 40
}, {
  colors: zu
} = ur(), Wv = ({
  filled: e,
  ratingItemClassName: r = "",
  size: t,
  position: n
}) => {
  const o = O2e(t);
  return /* @__PURE__ */ m("svg", { "data-cy": Ee("rating-star", n == null ? void 0 : n.toString()), width: o, height: o, viewBox: "0 0 28 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: r, children: /* @__PURE__ */ m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 1.5L18.0163 9.39938L27 10.674L20.5 16.819L22.034 25.5L14 21.3994L5.966 25.5L7.5 16.819L1 10.674L9.98232 9.39938L14 1.5Z", stroke: zu.feedback.warning[300], fill: e ? zu.feedback.warning[300] : "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) });
}, I5e = (e) => {
  const {
    defaultValue: r = null,
    count: t = 5,
    type: n = "star",
    showText: o = !0,
    readOnly: a = !1,
    fractions: i = 1,
    ratingItemClassName: l = "",
    onChange: s,
    layoutMode: u = "block",
    cy: d
  } = e, [f, p] = Se(r), g = S2e({
    layoutMode: u,
    type: n
  }), h = I2e(), v = $e((C) => {
    p(C), s == null || s(C);
  }, [s]), y = Je(() => n === "star", [n]), w = Je(() => e.type === "star" ? e.size : void 0, [e]), $ = $e((C) => ({
    emptySymbol: /* @__PURE__ */ m(Wv, { ratingItemClassName: l, size: w, position: C }),
    fullSymbol: /* @__PURE__ */ m(Wv, { filled: !0, ratingItemClassName: l, size: w, position: C })
  }), [l, w]);
  return /* @__PURE__ */ Y("div", { css: g.root, "data-cy": Ee("rating-wrapper", d == null ? void 0 : d.wrapper), children: [
    y && /* @__PURE__ */ Y(ca, { children: [
      o && /* @__PURE__ */ Y(tr, { cy: Ee("rating-title", d == null ? void 0 : d.title), color: zu.neutral[500], showOnClarity: !0, children: [
        "Escolha de ",
        t ? 1 : 0,
        " a ",
        t,
        " estrelas para classificar"
      ] }),
      /* @__PURE__ */ m(UC, { size: "xl", value: f, onChange: v, readOnly: a, fractions: i, count: t, color: zu.feedback.warning[300], emptySymbol: (C) => {
        var x;
        return (x = $(C)) == null ? void 0 : x.emptySymbol;
      }, fullSymbol: (C) => {
        var x;
        return (x = $(C)) == null ? void 0 : x.fullSymbol;
      }, styles: h })
    ] }),
    !y && /* @__PURE__ */ Y(ca, { children: [
      o && /* @__PURE__ */ m(tr, { color: "inherit", variant: "paragraphSmall", css: g.feedbackTextLeft, cy: Ee("rating-text-left", d == null ? void 0 : d.textLeft), children: "Nem um pouco provável" }),
      /* @__PURE__ */ m("div", { css: g.numbersWrapper, children: Array.from({
        length: t + 1
      }, (C, x) => /* @__PURE__ */ m(kx, { onClick: () => v(x), checked: f === x, style: E2e, disabled: a, className: l, cy: Ee("rating-number", x == null ? void 0 : x.toString()), children: x }, x == null ? void 0 : x.toString())) }),
      o && /* @__PURE__ */ m(tr, { color: "inherit", variant: "paragraphSmall", css: g.feedbackTextRight, cy: Ee("rating-text-right", d == null ? void 0 : d.textRight), children: "Extremamente provável" })
    ] })
  ] });
}, R2e = ({
  minutes: e,
  seconds: r,
  onFinished: t
}) => {
  const n = ur(), o = Math.max(0, Math.min(59, e)), a = Math.max(0, Math.min(59, r)), [i, l] = Se({
    minutes: o,
    seconds: a
  }), [s, u] = Se({
    primarySection: 0,
    secondarySection: 100
  });
  Fe(() => {
    let f;
    return i.minutes >= 0 && i.seconds >= 0 && (f = setInterval(() => {
      if (i.seconds === 0 && i.minutes === 0) {
        clearInterval(f);
        return;
      }
      if (i.seconds === 0) {
        l((p) => ({
          minutes: Math.max(0, p.minutes - 1),
          seconds: 59
        }));
        return;
      }
      l((p) => ({
        ...p,
        seconds: Math.max(0, p.seconds - 1)
      }));
    }, 1e3)), () => clearInterval(f);
  }, [i.minutes, i.seconds]), Fe(() => {
    const f = i.minutes * 60 + i.seconds, p = e * 60 + r, g = f / p * Ld, h = Math.min(Ld, g);
    u({
      primarySection: Ld - h,
      secondarySection: h
    });
  }, [i, e, r]), Fe(() => {
    i.minutes === 0 && i.seconds === 0 && t && t();
  }, [t, r, i]);
  const d = Je(() => {
    const f = [{
      value: s.primarySection,
      color: n.colors.brand.primary[100]
    }, {
      value: s.secondarySection,
      color: n.colors.brand.secondary[300]
    }];
    return s.secondarySection === 0 ? f.slice(0, 1) : f;
  }, [s.secondarySection, s.primarySection, n.colors.brand.primary, n.colors.brand.secondary]);
  return {
    time: i,
    progress: s,
    handleShowSections: d
  };
}, A2e = Ne({
  text: M`
    margin-top: 4px;
  `
}), E5e = ({
  minutes: e = 10,
  seconds: r = 0,
  onFinished: t
}) => {
  const n = ur(), o = A2e(), {
    time: a,
    handleShowSections: i
  } = R2e({
    minutes: e,
    seconds: r,
    onFinished: t
  });
  return /* @__PURE__ */ m(rw, { roundCaps: !0, thickness: 8, sections: i, label: /* @__PURE__ */ Y(tr, { css: o.text, textAlign: "center", variant: "headingMedium", color: n.colors.neutral[400], children: [
    a.minutes,
    ":",
    a.seconds.toString().padStart(2, "0")
  ] }) });
}, k2e = Ne({
  container: (e) => M`
    border-bottom: 1px solid ${e.colors.neutral[100]};
    width: 100%;
    margin-inline: auto;
    height: 80px;
    padding: ${e.spacing.sm} ${e.spacing.xs};
    font-family: ${e.typography.label.fontFamily};
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${e.colors.background.white};
  `,
  buttonLabel: (e) => M`
    font-weight: ${e.fontWeights.bold};
  `,
  leftIcon: (e) => M`
    display: flex;
    align-items: center;
    gap: ${e.spacing.xxs};

    > svg {
      cursor: pointer;
    }
  `,
  rightIcon: (e) => M`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${e.spacing.sm};
  `
});
function Hi() {
  const [e, r] = Se({
    width: void 0,
    height: void 0
  }), [t, n] = Se(), [o, a] = Se();
  return Fe(() => {
    function i() {
      r({
        width: window.innerWidth,
        height: window.innerHeight
      }), n(window.innerWidth <= 639), a(window.innerWidth >= 639);
    }
    return window.addEventListener("resize", i), i(), () => window.removeEventListener("resize", i);
  }, []), {
    windowSize: e,
    isMobile: t,
    isDesktop: o
  };
}
const Bv = ur(), R5e = ({
  id: e,
  title: r,
  buttonLabel: t,
  avatar: n = !1,
  avatarSrc: o,
  username: a,
  rightIcon: i,
  leftIcon: l,
  labelAction: s,
  leftIconAction: u,
  actionListItemAvatar: d,
  ...f
}) => {
  const p = k2e(), g = ke(e), h = ke(e), v = ke(e), {
    isMobile: y
  } = Hi(), w = Je(() => y ? "headingSmall" : "headingMedium", [y]), $ = $e(() => {
    if (l || y)
      return /* @__PURE__ */ m(Pt, { name: y ? "arrow-left" : l, color: Bv.colors.neutral[200], onClick: u });
  }, [y, l, u]), C = $e(() => i && /* @__PURE__ */ m(Pt, { name: i, color: Bv.colors.neutral[200] }), [i]), x = $e(() => y && t && n && i || y && t && i ? null : /* @__PURE__ */ m(st, { id: v, onClick: s, variant: "tertiary", css: p.buttonLabel, children: t }), [y, t, n, i, v, s, p.buttonLabel]);
  return /* @__PURE__ */ Y("header", { css: p.container, id: g, ...f, children: [
    /* @__PURE__ */ Y("section", { css: p.leftIcon, children: [
      l && $(),
      /* @__PURE__ */ m(tr, { variant: w, showOnClarity: !0, children: r })
    ] }),
    /* @__PURE__ */ Y("section", { css: p.rightIcon, children: [
      t && x(),
      i && C(),
      n && /* @__PURE__ */ m(Ta, { src: o, id: h, menu: !0, label: !y && a, size: "medium", actionListItem: d })
    ] })
  ] });
}, M2e = (e) => M`
  color: ${e.colors.brand.primary[300]};

  span::after {
    content: '';
    display: block;
    width: 100%;
    height: 4px;
    margin-top: 4px;

    background-color: ${e.colors.brand.tertiary[300]};
    border-radius: ${e.border.radius.lg};
  }
`, N2e = (e, r) => M`
  width: 100%;
  height: 48px;
  border-bottom: 1px solid ${e.colors.neutral[100]};
  border-radius: ${e.border.radius.none};
  padding: 0;
  color: ${r ? e.colors.brand.primary[300] : e.colors.neutral[300]};

  svg {
    display: none;
  }
`, T2e = Ne({
  root: (e, {
    isActive: r,
    isLargeScreen: t,
    subItem: n
  }) => M`
    width: fit-content;
    padding: 10px 16px;
    border-radius: ${e.border.radius.lg};
    cursor: pointer;
    user-select: none;
    outline: none;
    background: none;
    border: none;
    white-space: nowrap;

    display: flex;
    align-items: center;
    gap: ${e.spacing.xxs};

    font-family: ${n ? e.typography.label.fontFamily : e.typography.subheading.fontFamily};
    font-size: ${n ? e.typography.label.fontSize : e.typography.subheading.fontSize};
    font-weight: ${n ? e.typography.label.fontWeight : e.typography.subheading.fontWeight};
    color: ${e.colors.neutral[300]};

    &:hover {
      color: ${e.colors.brand.primary[300]};
    }

    ${r && t && M2e(e)}
    ${!t && N2e(e, r)}
  `
}), iO = ({
  id: e,
  children: r,
  leftIcon: t,
  rightIcon: n,
  isActive: o,
  onClick: a,
  subItem: i,
  ...l
}) => {
  const s = u1("lg"), u = T2e({
    isActive: o,
    isLargeScreen: s,
    subItem: i
  }), d = ke(e);
  return /* @__PURE__ */ Y("button", { id: d, css: u.root, onClick: a, ...l, children: [
    t && /* @__PURE__ */ m(Pt, { name: t, "aria-label": "left-icon" }),
    /* @__PURE__ */ m("span", { children: r }),
    n && /* @__PURE__ */ m(Pt, { name: n, "aria-label": "right-icon" })
  ] });
};
iO.displayName = "Menu.Trigger";
const $2 = "80px", Ca = "56px", D2e = Ne({
  root: (e) => M`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${e.spacing.xxs};
    height: ${Ca};

    @media only screen and (min-width: ${e.grid.breakpoint.lg}) {
      height: 48px;
      border-bottom: 1px solid ${e.colors.neutral[100]};
      border-radius: ${e.border.radius.none};
      position: relative;
    }
  `,
  logoutButton: (e) => M`
    padding: 10px 0;
    border-radius: ${e.border.radius.lg};
    cursor: pointer;
    user-select: none;
    outline: none;
    background: none;
    border: none;

    font-family: ${e.typography.label.fontFamily};
    font-size: ${e.fontSizes.sm};
    font-weight: ${e.fontWeights.normal};
    color: ${e.colors.neutral[300]};

    &:hover,
    &:active {
      color: ${e.colors.brand.primary[300]};
    }
  `,
  timeCounter: (e) => M`
    color: ${e.colors.neutral[200]};
  `
});
var lO = { exports: {} };
(function(e, r) {
  (function(t, n) {
    e.exports = n();
  })(Mo, function() {
    var t = "minute", n = /[+-]\d\d(?::?\d\d)?/g, o = /([+-]|\d\d)/g;
    return function(a, i, l) {
      var s = i.prototype;
      l.utc = function(v) {
        var y = { date: v, utc: !0, args: arguments };
        return new i(y);
      }, s.utc = function(v) {
        var y = l(this.toDate(), { locale: this.$L, utc: !0 });
        return v ? y.add(this.utcOffset(), t) : y;
      }, s.local = function() {
        return l(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var u = s.parse;
      s.parse = function(v) {
        v.utc && (this.$u = !0), this.$utils().u(v.$offset) || (this.$offset = v.$offset), u.call(this, v);
      };
      var d = s.init;
      s.init = function() {
        if (this.$u) {
          var v = this.$d;
          this.$y = v.getUTCFullYear(), this.$M = v.getUTCMonth(), this.$D = v.getUTCDate(), this.$W = v.getUTCDay(), this.$H = v.getUTCHours(), this.$m = v.getUTCMinutes(), this.$s = v.getUTCSeconds(), this.$ms = v.getUTCMilliseconds();
        } else
          d.call(this);
      };
      var f = s.utcOffset;
      s.utcOffset = function(v, y) {
        var w = this.$utils().u;
        if (w(v))
          return this.$u ? 0 : w(this.$offset) ? f.call(this) : this.$offset;
        if (typeof v == "string" && (v = function(b) {
          b === void 0 && (b = "");
          var O = b.match(n);
          if (!O)
            return null;
          var _ = ("" + O[0]).match(o) || ["-", 0, 0], P = _[0], S = 60 * +_[1] + +_[2];
          return S === 0 ? 0 : P === "+" ? S : -S;
        }(v), v === null))
          return this;
        var $ = Math.abs(v) <= 16 ? 60 * v : v, C = this;
        if (y)
          return C.$offset = $, C.$u = v === 0, C;
        if (v !== 0) {
          var x = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (C = this.local().add($ + x, t)).$offset = $, C.$x.$localOffset = x;
        } else
          C = this.utc();
        return C;
      };
      var p = s.format;
      s.format = function(v) {
        var y = v || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return p.call(this, y);
      }, s.valueOf = function() {
        var v = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * v;
      }, s.isUTC = function() {
        return !!this.$u;
      }, s.toISOString = function() {
        return this.toDate().toISOString();
      }, s.toString = function() {
        return this.toDate().toUTCString();
      };
      var g = s.toDate;
      s.toDate = function(v) {
        return v === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : g.call(this);
      };
      var h = s.diff;
      s.diff = function(v, y, w) {
        if (v && this.$u === v.$u)
          return h.call(this, v, y, w);
        var $ = this.local(), C = l(v).local();
        return h.call($, C, y, w);
      };
    };
  });
})(lO);
var j2e = lO.exports;
const L2e = /* @__PURE__ */ Qn(j2e);
var sO = { exports: {} };
(function(e, r) {
  (function(t, n) {
    e.exports = n();
  })(Mo, function() {
    var t = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, n = {};
    return function(o, a, i) {
      var l, s = function(p, g, h) {
        h === void 0 && (h = {});
        var v = new Date(p), y = function(w, $) {
          $ === void 0 && ($ = {});
          var C = $.timeZoneName || "short", x = w + "|" + C, b = n[x];
          return b || (b = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: w, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: C }), n[x] = b), b;
        }(g, h);
        return y.formatToParts(v);
      }, u = function(p, g) {
        for (var h = s(p, g), v = [], y = 0; y < h.length; y += 1) {
          var w = h[y], $ = w.type, C = w.value, x = t[$];
          x >= 0 && (v[x] = parseInt(C, 10));
        }
        var b = v[3], O = b === 24 ? 0 : b, _ = v[0] + "-" + v[1] + "-" + v[2] + " " + O + ":" + v[4] + ":" + v[5] + ":000", P = +p;
        return (i.utc(_).valueOf() - (P -= P % 1e3)) / 6e4;
      }, d = a.prototype;
      d.tz = function(p, g) {
        p === void 0 && (p = l);
        var h = this.utcOffset(), v = this.toDate(), y = v.toLocaleString("en-US", { timeZone: p }), w = Math.round((v - new Date(y)) / 1e3 / 60), $ = i(y, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(v.getTimezoneOffset() / 15) - w, !0);
        if (g) {
          var C = $.utcOffset();
          $ = $.add(h - C, "minute");
        }
        return $.$x.$timezone = p, $;
      }, d.offsetName = function(p) {
        var g = this.$x.$timezone || i.tz.guess(), h = s(this.valueOf(), g, { timeZoneName: p }).find(function(v) {
          return v.type.toLowerCase() === "timezonename";
        });
        return h && h.value;
      };
      var f = d.startOf;
      d.startOf = function(p, g) {
        if (!this.$x || !this.$x.$timezone)
          return f.call(this, p, g);
        var h = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return f.call(h, p, g).tz(this.$x.$timezone, !0);
      }, i.tz = function(p, g, h) {
        var v = h && g, y = h || g || l, w = u(+i(), y);
        if (typeof p != "string")
          return i(p).tz(y);
        var $ = function(O, _, P) {
          var S = O - 60 * _ * 1e3, I = u(S, P);
          if (_ === I)
            return [S, _];
          var N = u(S -= 60 * (I - _) * 1e3, P);
          return I === N ? [S, I] : [O - 60 * Math.min(I, N) * 1e3, Math.max(I, N)];
        }(i.utc(p, v).valueOf(), w, y), C = $[0], x = $[1], b = i(C).utcOffset(x);
        return b.$x.$timezone = y, b;
      }, i.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, i.tz.setDefault = function(p) {
        l = p;
      };
    };
  });
})(sO);
var z2e = sO.exports;
const V2e = /* @__PURE__ */ Qn(z2e);
je.locale("pt-br");
je.extend(L2e);
je.extend(V2e);
const cO = ({
  id: e,
  onClick: r
}) => {
  const t = D2e(), n = ke(e), [o, a] = Se("00:00");
  return Fe(() => {
    const i = setInterval(() => {
      const l = je();
      l.tz("America/Sao_Paulo"), a(l.format("HH:mm"));
    }, 1e3);
    return () => clearInterval(i);
  }, []), /* @__PURE__ */ Y("div", { css: t.root, children: [
    /* @__PURE__ */ m("button", { id: n, css: t.logoutButton, onClick: r, children: /* @__PURE__ */ m("span", { children: "Sair" }) }),
    /* @__PURE__ */ Y(tr, { css: t.timeCounter, renderAs: "span", variant: "microCopy", showOnClarity: !0, children: [
      "Horário: ",
      o
    ] })
  ] });
};
cO.displayName = "Menu.TriggerLogout";
const uO = ro`
    from {
      opacity: 0;
      transform: translateY(-15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
`, F2e = Ne({
  root: (e, {
    maxWidth: r
  }) => M`
    width: 100%;
    max-width: ${r ? e.grid.breakpoint[r] : "100%"};
    height: ${$2};
    margin-inline: auto;
    padding: ${e.spacing.xxs} ${e.spacing.sm};
    border-bottom: 1px solid ${e.colors.neutral[100]};

    align-items: center;
    display: flex;
    gap: ${e.spacing.lg};

    svg {
      min-width: ${e.spacing.sm};
    }

    @media only screen and (max-width: ${e.grid.breakpoint.lg}) {
      position: absolute;
      top: 0;
      align-items: flex-start;
      display: flex;
      justify-content: space-between;
      padding: ${e.spacing.xs};
      background: ${e.colors.background.white};
      height: ${Ca};
      gap: ${e.spacing.xs};
    }
  `
}), Z2e = (e, r) => M`
  flex-direction: column;
  width: calc(100% - ${e.spacing.md});
  padding: 0;
  animation: ${uO} 0.4s forwards;
  background: ${e.colors.background.white};
  align-self: start;
  justify-self: start;

  position: absolute;
  top: ${r ? $2 : Ca};
  z-index: 1;
  height: calc(100vh - ${Ca});
`, W2e = Ne({
  root: (e, {
    isLargeScreen: r
  }) => M`
    display: flex;
    align-items: center;
    align-self: center;

    ${!r && Z2e(e, r)}
  `
}), D1 = Zu((e, r) => ({
  expanded: !1,
  opened: [],
  toggle: () => e((t) => ({
    expanded: !t.expanded
  })),
  setOpened: (t) => e((n) => ({
    opened: r().isCollapseActive(t) ? [...n.opened.filter((o) => o !== t)] : [...n.opened, t]
  })),
  isCollapseActive: (t) => !!r().opened.find((n) => n === t)
})), dO = ({
  children: e,
  ...r
}) => {
  const t = u1("lg"), {
    expanded: n
  } = Vt(D1), o = W2e({
    isLargeScreen: t
  });
  return Je(() => n || t, [n, t]) ? /* @__PURE__ */ m("div", { css: o.root, ...r, children: e }) : null;
};
dO.displayName = "Menu.List";
const B2e = Ne({
  root: (e) => M`
    display: flex;
    align-self: center;
    align-items: center;
    max-width: 160px;
    min-height: ${e.spacing.md};

    @media only screen and (max-width: ${e.grid.breakpoint.lg}) {
      gap: ${e.spacing.xs};
      padding: 0;

      max-height: ${$2};
    }

    @media only screen and (max-width: ${e.grid.breakpoint.sm}) {
      max-height: ${Ca};
    }
  `
}), fO = ({
  children: e,
  ...r
}) => {
  const t = B2e();
  return /* @__PURE__ */ m("div", { css: t.root, ...r, children: e });
};
fO.displayName = "Menu.Brand";
const H2e = Ne({
  root: (e) => M`
    width: fit-content;
    height: 24px;
    background: none;
    border: none;
    padding: 0;
    display: block;
    color: ${e.colors.neutral[200]};
    cursor: pointer;

    @media only screen and (min-width: ${e.grid.breakpoint.lg}) {
      display: none;
    }
  `
}), pO = () => {
  const {
    expanded: e,
    toggle: r
  } = Vt(D1), t = H2e(), n = Je(() => e ? /* @__PURE__ */ m(Fo, { "aria-label": "close" }) : /* @__PURE__ */ m(cx, { "aria-label": "menu" }), [e]);
  return /* @__PURE__ */ m("button", { name: "menu-toggle", css: t.root, onClick: r, children: n });
};
pO.displayName = "Menu.Toggle";
const G2e = Ne({
  root: (e) => M`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
    gap: ${e.spacing.sm};
    align-self: center;

    @media only screen and (min-width: ${e.grid.breakpoint.lg}) {
      gap: ${e.spacing.xs};
      max-height: ${Ca};
    }
  `
}), gO = ({
  children: e,
  ...r
}) => {
  const t = G2e();
  return /* @__PURE__ */ m("div", { css: t.root, ...r, children: e });
};
gO.displayName = "Menu.Tools";
const X2e = (e) => M`
  color: ${e.colors.brand.primary[300]};

  span::after {
    content: '';
    display: block;
    width: 100%;
    height: 4px;
    margin-top: 4px;

    background-color: ${e.colors.brand.tertiary[300]};
    border-radius: ${e.border.radius.lg};
  }
`, Y2e = (e) => M`
  color: ${e.colors.brand.primary[300]};
`, U2e = (e) => M`
  width: 100%;
  height: 48px;
  border-bottom: 1px solid ${e.colors.neutral[100]};
  padding: 0;
  border-radius: ${e.border.radius.none};
  position: relative;

  svg {
    position: absolute;
    right: 8px;
  }
`, J2e = Ne({
  root: (e, {
    isLargeScreen: r
  }) => M`
    width: ${r ? "fit-content" : "100%"};
  `,
  actionWrapper: (e, {
    isActive: r,
    isLargeScreen: t
  }) => M`
    width: fit-content;
    padding: 10px 16px;
    border-radius: ${e.border.radius.lg};
    cursor: pointer;
    user-select: none;
    outline: none;
    background: none;
    border: none;
    white-space: nowrap;

    display: flex;
    align-items: center;
    gap: ${e.spacing.xxs};

    font-family: ${e.typography.subheading.fontFamily};
    font-size: ${e.fontSizes.md};
    font-weight: ${e.fontWeights.bold};
    color: ${e.colors.neutral[300]};

    &:hover {
      color: ${e.colors.brand.primary[300]};
    }

    svg {
      fill: currentColor;
    }

    ${r && Y2e(e)}
    ${r && t && X2e(e)}
    ${!t && U2e(e)}
  `,
  contentWrapper: M`
    button {
      padding: 10px 16px;
    }
  `
}), vO = ({
  id: e,
  label: r,
  children: t,
  isActive: n,
  ...o
}) => {
  const a = u1("lg"), {
    isCollapseActive: i,
    setOpened: l
  } = Vt(D1), s = ke(e), u = J2e({
    isActive: n,
    isLargeScreen: a
  }), d = () => i(s) ? /* @__PURE__ */ m(io, { "aria-label": "arrow-up", "data-testid": "arrow-up" }) : /* @__PURE__ */ m(Nn, { "aria-label": "arrow-down", "data-testid": "arrow-down" }), f = () => a ? /* @__PURE__ */ m(Nr.Dropdown, { children: Gr.map(t, (g) => {
    if (E.isValidElement(g))
      return /* @__PURE__ */ m(Nr.Item, { onClick: () => {
        l(s);
        const h = g.props;
        h.onClick && h.onClick();
      }, children: g });
  }) }) : /* @__PURE__ */ m("div", { css: u.contentWrapper, children: t });
  function p() {
    i(s) && l(s);
  }
  return /* @__PURE__ */ m("div", { css: u.root, children: /* @__PURE__ */ Y(Nr, { opened: i(s), onClose: p, children: [
    /* @__PURE__ */ m(Nr.Target, { children: /* @__PURE__ */ Y("button", { id: s, css: u.actionWrapper, onClick: () => l(s), ...o, children: [
      /* @__PURE__ */ m("span", { children: r }),
      d()
    ] }) }),
    i(s) && f()
  ] }) });
};
vO.displayName = "Menu.Collapse";
const q2e = ({
  breakpoint: e = "lg",
  children: r
}) => u1(e) ? /* @__PURE__ */ m(Br, { children: r }) : null, K2e = Ne({
  root: (e) => M`
    display: block;
    width: 100%;
    align-self: start;
    margin-top: auto;
    animation: ${uO} 0.4s forwards;
    border-top: 1px solid ${e.colors.neutral[100]};

    @media only screen and (min-width: ${e.grid.breakpoint.lg}) {
      display: none;
    }
  `
}), Q2e = ({
  children: e,
  ...r
}) => {
  const {
    expanded: t
  } = Vt(D1), n = K2e();
  return t && /* @__PURE__ */ m("div", { css: n.root, ...r, children: e });
}, mO = ({
  children: e,
  maxWidth: r,
  ...t
}) => {
  const n = F2e({
    maxWidth: r
  });
  return /* @__PURE__ */ m("div", { css: n.root, ...t, children: e });
};
mO.displayName = "Menu.Root";
const A5e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Brand: fO,
  Collapse: vO,
  Footer: Q2e,
  List: dO,
  MediaMatch: q2e,
  Root: mO,
  Toggle: pO,
  Tools: gO,
  Trigger: iO,
  TriggerLogout: cO
}, Symbol.toStringTag, { value: "Module" })), epe = Ne({
  container: (e) => M`
    border-bottom: 1px solid ${e.colors.neutral[100]};
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    padding: 28px;

    svg {
      color: ${e.colors.neutral[200]};
      cursor: pointer;
    }
  `
}), hO = ({
  id: e,
  children: r,
  cy: t
}) => {
  const n = epe(), o = ke(e);
  return /* @__PURE__ */ m("header", { id: o, css: n.container, "data-cy": Ee("sidebar-brand", t), children: r });
};
hO.displayName = "Sidebar.Brand";
const j1 = Zu((e, r) => ({
  expanded: !0,
  opened: [],
  setExpanded: (t) => e(() => ({
    expanded: t
  })),
  setOpened: (t) => e((n) => ({
    opened: r().isCollapseActive(t) ? [...n.opened.filter((o) => o !== t)] : [...n.opened, t]
  })),
  isCollapseActive: (t) => !!r().opened.find((n) => n === t)
})), Hv = (e, r) => M`
  svg *,
  div > svg * {
    &[stroke-width] {
      stroke: ${r ? e.colors.brand.primary[300] : e.colors.neutral[200]};
    }

    &[fill] {
      fill: ${r ? e.colors.brand.primary[300] : e.colors.neutral[200]};
    }
  }
`, rpe = (e) => M`
  :hover > div > div > svg *,
  :focus > div > div > svg * {
    &[stroke-width] {
      stroke: ${e.colors.brand.primary[300]};
    }

    &[fill] {
      fill: ${e.colors.brand.primary[300]};
    }
  }
`, tpe = Ne({
  container: (e, {
    isActive: r,
    expanded: t,
    tagLabel: n
  }) => M`
    display: flex;
    align-items: center;
    justify-content: space-between;
    user-select: none;
    font-family: ${e.typography.label.fontFamily};
    max-width: ${t ? "240px" : "64px"};
    height: 48px;
    border-radius: ${e.border.radius.lg};
    padding: 12px 14px 12px 20px;
    border: 2px solid transparent;
    cursor: pointer;
    width: 100%;
    color: ${e.colors.brand.primary[r ? 300 : 500]};
    background-color: ${r ? e.colors.brand.primary[100] : e.colors.background.white};
    transition: 0.4s ease;

    ${Hv(e, r)};

    :hover,
    :focus {
      background-color: ${e.colors.brand.primary[100]};
      color: ${e.colors.brand.primary[300]};
    }

    :hover > div > svg *,
    :focus > div > svg * {
      &[stroke-width] {
        stroke: ${e.colors.brand.primary[300]};
      }

      &[fill] {
        fill: ${e.colors.brand.primary[300]};
      }
    }

    ${!n && rpe(e)}
  `,
  menuItems: (e, {
    isActive: r
  }) => M`
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    white-space: nowrap;
    width: 100%;

    > svg {
      min-height: 24px;
      min-width: 24px;
    }

    ${Hv(e, r)};
  `,
  notification: (e) => M`
    position: absolute;
    z-index: 1;
    stroke: ${e.colors.background.white};
    stroke-width: 2px;
    left: 12px;
    bottom: 9px;

    svg {
      path {
        fill: ${e.colors.brand.tertiary[300]} !important;
      }
    }
  `
}), O2 = ({
  id: e,
  children: r,
  isActive: t = !1,
  icon: n,
  tagLabel: o,
  onClick: a,
  cy: i,
  ...l
}) => {
  const s = ke(e), u = ke(e), {
    expanded: d
  } = Vt(j1), f = tpe({
    expanded: d,
    isActive: t,
    tagLabel: o
  });
  return /* @__PURE__ */ m("button", { id: s, onClick: a, css: f.container, "data-cy": Ee("sidebar-trigger", i), ...l, children: /* @__PURE__ */ Y("div", { css: f.menuItems, children: [
    n && /* @__PURE__ */ m(Pt, { name: n, "aria-label": n }),
    !d && o && /* @__PURE__ */ m("div", { css: f.notification, children: /* @__PURE__ */ m(m2, { size: "small", "aria-label": "bullet icon" }) }),
    d && r,
    !d || o && /* @__PURE__ */ m(Bi, { id: u, variant: "primary", size: "small", children: o })
  ] }) });
};
O2.displayName = "Sidebar.Trigger";
const npe = Ne({
  content: M`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  `
}), bO = ({
  children: e,
  id: r,
  icon: t,
  isActive: n = !1,
  label: o,
  value: a,
  cy: i,
  ...l
}) => {
  const s = npe(), u = ke(r), d = ke(r), {
    setOpened: f,
    isCollapseActive: p
  } = Vt(j1);
  function g() {
    return p(a) ? /* @__PURE__ */ m(io, { "aria-label": "arrow-up", "data-testid": "arrow-up" }) : /* @__PURE__ */ m(Nn, { "aria-label": "arrow-down", "data-testid": "arrow-down" });
  }
  const h = $e(() => {
    f && f(a);
  }, [f, a]);
  return /* @__PURE__ */ Y("div", { id: u, ...l, "data-cy": Ee("sidebar-collapse", i), children: [
    /* @__PURE__ */ m(O2, { id: d, icon: t, isActive: n, onClick: h, children: /* @__PURE__ */ Y("div", { css: s.content, children: [
      o,
      g()
    ] }) }),
    Gr.map(e, (v) => Wr(v, {
      value: a
    }))
  ] });
};
bO.displayName = "Sidebar.Collapse";
const ope = Ne({
  footer: (e) => M`
    border-top: 1px solid ${e.colors.neutral[100]};
    padding: ${e.spacing.xxs};
  `
}), yO = ({
  id: e,
  children: r,
  cy: t,
  ...n
}) => {
  const o = ope(), a = ke(e);
  return /* @__PURE__ */ m("footer", { id: a, css: o.footer, ...n, "data-cy": Ee("sidebar-footer", t), children: r });
};
yO.displayName = "Sidebar.Footer";
const ape = ro`
    from {
      opacity: 0;
      transform: translateY(-15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
`, ipe = Ne({
  menuSubItems: (e) => M`
    padding-left: 34px;
    color: ${e.colors.neutral[100]};
    position: relative;
    bottom: 8px;
    animation: ${ape} 0.4s forwards;

    &:before {
      content: '__';
      display: block;
      width: 1px;
      padding-top: 12px;
      height: 44px;
      background-color: ${e.colors.brand.primary[100]};
    }
  `,
  subItemWrapper: (e, {
    subItemActive: r
  }) => M`
    cursor: pointer;
    position: absolute;
    top: 20px;
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.bold};
    color: ${r ? e.colors.brand.primary[300] : e.colors.neutral[300]};
    margin-left: ${e.spacing.md};

    :hover {
      color: ${e.colors.brand.primary[300]};
    }
  `
}), CO = ({
  id: e,
  onClick: r,
  children: t,
  subItemActive: n = !1,
  value: o,
  cy: a
}) => {
  const i = ke(e), l = ipe({
    subItemActive: n
  }), {
    expanded: s,
    isCollapseActive: u
  } = Vt(j1);
  return /* @__PURE__ */ m(Br, { children: s && /* @__PURE__ */ m(Cf, { in: u(o), css: l.menuSubItems, id: i, "data-cy": Ee("sidebar-collapse-trigger", a), children: /* @__PURE__ */ m("div", { onClick: r, children: /* @__PURE__ */ m("span", { css: l.subItemWrapper, children: t }) }) }) });
};
CO.displayName = "Sidebar.CollapseTrigger";
const lpe = Ne({
  container: (e) => M`
    margin: ${e.spacing.xxs};
    display: flex;
    gap: ${e.spacing.xxs};
    flex-direction: column;
  `
}), wO = ({
  id: e,
  children: r,
  cy: t,
  ...n
}) => {
  const o = lpe(), a = ke(e);
  return /* @__PURE__ */ m("div", { id: a, css: o.container, ...n, "data-cy": Ee("sidebar-list", t), children: r });
};
wO.displayName = "Sidebar.List";
const spe = ro`
    from {
      opacity: 0;
      transform: translateX(-15px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
`, cpe = Ne({
  sidebar: (e, {
    expanded: r
  }) => /* @__PURE__ */ M("width:", r ? "256px" : "80px", ";clip-path:inset(0px -15px 0px 0px);overflow:hidden;transition:0.4s;display:grid;grid-template-rows:80px auto 56px;flex-direction:column;background:", e.colors.background.white, ";animation:", spe, " 0.5s ease forwards;height:100vh;" + (process.env.NODE_ENV === "production" ? "" : ";label:sidebar;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2NvbmV4YS1oZXJvL2NvbmV4YS1oZXJvL3NyYy9jb21wb25lbnRzL2xheW91dC9TaWRlYmFyL1NpZGViYXIuc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdCdUMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvY29uZXhhLWhlcm8vY29uZXhhLWhlcm8vc3JjL2NvbXBvbmVudHMvbGF5b3V0L1NpZGViYXIvU2lkZWJhci5zdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBrZXlmcmFtZXMsIGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0J1xuaW1wb3J0IHsgbWFrZVN0eWxlcyB9IGZyb20gJ0AvdXRpbHMvbWFrZVN0eWxlcydcbmltcG9ydCB7IFNpZGViYXJTdHlsZXNQcm9wcyB9IGZyb20gJy4vU2lkZWJhci50eXBlcydcblxuY29uc3QgcHJlc2VudGF0aW9uQW5pbWF0ZSA9IGtleWZyYW1lc2BcbiAgICBmcm9tIHtcbiAgICAgIG9wYWNpdHk6IDA7XG4gICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTE1cHgpO1xuICAgIH1cbiAgICB0byB7XG4gICAgICBvcGFjaXR5OiAxO1xuICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKDApO1xuICAgIH1cbmBcblxuY29uc3QgdXNlU3R5bGVzID0gbWFrZVN0eWxlczxTaWRlYmFyU3R5bGVzUHJvcHM+KHtcbiAgc2lkZWJhcjogKHRoZW1lLCB7IGV4cGFuZGVkIH0pID0+IGNzc2BcbiAgICB3aWR0aDogJHtleHBhbmRlZCA/ICcyNTZweCcgOiAnODBweCd9O1xuICAgIGNsaXAtcGF0aDogaW5zZXQoMHB4IC0xNXB4IDBweCAwcHgpO1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgdHJhbnNpdGlvbjogMC40cztcbiAgICBkaXNwbGF5OiBncmlkO1xuICAgIGdyaWQtdGVtcGxhdGUtcm93czogODBweCBhdXRvIDU2cHg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBiYWNrZ3JvdW5kOiAke3RoZW1lLmNvbG9ycy5iYWNrZ3JvdW5kLndoaXRlfTtcbiAgICBhbmltYXRpb246ICR7cHJlc2VudGF0aW9uQW5pbWF0ZX0gMC41cyBlYXNlIGZvcndhcmRzO1xuICAgIGhlaWdodDogMTAwdmg7XG4gIGAsXG59KVxuXG5leHBvcnQgZGVmYXVsdCB1c2VTdHlsZXNcbiJdfQ== */")
}), _O = ({
  children: e,
  id: r,
  isExpanded: t,
  cy: n,
  ...o
}) => {
  const a = ke(r), {
    expanded: i,
    setExpanded: l
  } = Vt(j1), s = cpe({
    expanded: i
  });
  return Fe(() => {
    l(t);
  }, [t, l]), /* @__PURE__ */ m("div", { "data-testid": "sidebar", id: a, css: s.sidebar, ...o, "data-cy": Ee("siderbar-wrapper", n), children: e });
};
_O.displayName = "Sidebar.Root";
const k5e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Brand: hO,
  Collapse: bO,
  CollapseTrigger: CO,
  Footer: yO,
  List: wO,
  Root: _O,
  Trigger: O2
}, Symbol.toStringTag, { value: "Module" })), upe = Ne({
  root: (e) => M`
    border-radius: ${e.border.radius.lg};
  `,
  scrollbar: (e) => M`
    border-radius: ${e.border.radius.lg};
  `
}), M5e = ({
  children: e,
  ...r
}) => {
  const t = upe();
  return /* @__PURE__ */ m(dh, { styles: t, ...r, children: e });
}, dpe = Ne({
  header: (e) => M`
    background-color: ${e.colors.background.gray};
  `
}), xO = ({
  children: e,
  cy: r,
  ...t
}) => {
  const n = dpe();
  return /* @__PURE__ */ m("thead", { css: n.header, ...t, "data-cy": Ee("table-heading", r), children: e });
};
xO.displayName = "Table.Heading";
const fpe = Ne({
  head: (e) => M`
    color: ${e.colors.brand.primary[500]};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    font-size: ${e.fontSizes.md};
    padding: ${e.spacing.xxs} ${e.spacing.xs};
    vertical-align: middle;
    height: 48px;

    &:first-of-type {
      border-top-left-radius: ${e.border.radius.lg};
    }

    &:last-child {
      border-top-right-radius: ${e.border.radius.lg};
    }
  `
}), $O = ({
  children: e,
  cy: r,
  ...t
}) => {
  const n = fpe();
  return /* @__PURE__ */ m("th", { css: n.head, ...t, "data-cy": Ee("table-head", r), children: e });
};
$O.displayName = "Table.Head";
const OO = ({
  children: e,
  cy: r,
  ...t
}) => /* @__PURE__ */ m("tbody", { ...t, "data-cy": Ee("table-body", r), children: e });
OO.displayName = "Table.Body";
const P2 = ({
  children: e,
  cy: r,
  ...t
}) => /* @__PURE__ */ m("tr", { ...t, "data-cy": Ee("table-row", r), children: e });
P2.displayName = "Table.Row";
const ppe = (e) => e && parseInt(e) > 80 ? "80px" : e || "56px", gpe = Ne({
  container: (e, {
    width: r,
    height: t,
    subtitle: n
  }) => M`
    color: ${e.colors.neutral[400]};
    font-family: ${e.typography.label.fontFamily};
    font-weight: ${e.fontWeights.normal};
    font-size: ${e.fontSizes.sm};
    padding: ${e.spacing.xxs} ${e.spacing.xs};
    vertical-align: middle;
    height: ${ppe(t)};
    border-top: 1px solid ${e.colors.neutral[100]};
    width: ${r || "auto"};
    background-color: ${n && e.colors.background.gray};
  `
}), S2 = ({
  align: e = "left",
  colSpan: r,
  children: t,
  width: n,
  height: o,
  subtitle: a,
  cy: i,
  ...l
}) => {
  const s = gpe({
    width: n,
    height: o,
    subtitle: a
  });
  return /* @__PURE__ */ m("td", { css: s.container, colSpan: r, align: e, ...l, "data-cy": Ee("table-cell", i), children: t });
};
S2.displayName = "Table.Cell";
const vpe = Ne({
  container: (e, {
    variant: r
  }) => M`
    display: grid;
    grid-template-columns: repeat(2, auto);
    gap: ${e.spacing.xs};
    text-align: center;
    justify-content: center;
    width: 100%;
    color: ${e.colors.neutral[300]};
    margin: ${r === "large" ? "80px 0" : "26px 0"};

    svg {
      height: 92px;
      width: 92px;
    }
  `,
  wrapper: M`
    display: flex;
    flex-direction: column;
    justify-content: center;
  `
}), vo = ur(), PO = ({
  id: e,
  columns: r,
  variant: t,
  isShow: n,
  label: o,
  description: a,
  icon: i,
  cy: l,
  ...s
}) => {
  const u = vpe({
    variant: t
  }), d = ke(e), f = Je(() => t === "large", [t]), p = $e((g) => ({
    userError: /* @__PURE__ */ m($x, { color: vo.colors.neutral[200] }),
    fileWarning: /* @__PURE__ */ m(xx, { color: vo.colors.neutral[200] }),
    filterDelete: /* @__PURE__ */ m(_x, { color: vo.colors.neutral[200] }),
    fileCrossed: /* @__PURE__ */ m(wx, { color: vo.colors.neutral[200] })
  })[g], []);
  return n ? /* @__PURE__ */ m(P2, { children: /* @__PURE__ */ m(S2, { colSpan: r, children: /* @__PURE__ */ Y("div", { id: d, css: u.container, ...s, "data-cy": Ee("table-notfound", l), children: [
    f && p(i),
    /* @__PURE__ */ Y("div", { css: u.wrapper, children: [
      /* @__PURE__ */ m(tr, { variant: f ? "headingMedium" : "paragraphLarge", color: f ? vo.colors.neutral[300] : vo.colors.neutral[200], children: o }),
      f && /* @__PURE__ */ m(tr, { variant: "paragraphLarge", color: vo.colors.neutral[200], children: a })
    ] })
  ] }) }) }) : null;
};
PO.displayName = "Table.NotFound";
const mpe = Ne({
  table: (e) => M`
    width: 100%;
    text-align: left;
    font-family: ${e.typography.label.fontFamily};
    border-collapse: separate;
    border: 1px solid ${e.colors.neutral[100]};
    border-radius: ${e.border.radius.lg};
    background: ${e.colors.background.white};
  `
}), SO = ({
  id: e,
  children: r,
  cy: t,
  ...n
}) => {
  const o = mpe(), a = ke(e);
  return /* @__PURE__ */ m("table", { id: a, css: o.table, ...n, "data-cy": Ee("table-wrapper", t), children: r });
};
SO.displayName = "Table.Root";
const N5e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Body: OO,
  Cell: S2,
  Head: $O,
  Heading: xO,
  NotFound: PO,
  Root: SO,
  Row: P2
}, Symbol.toStringTag, { value: "Module" })), hpe = (e, r) => ({
  white: e.colors.background.white,
  primary: e.colors.brand.primary[100],
  secondary: e.colors.brand.secondary[100]
})[r], bpe = Ne({
  root: (e, {
    background: r,
    hasAction: t,
    width: n,
    height: o
  }) => M`
    padding: ${e.spacing.sm} ${e.spacing.xs};
    background-color: ${hpe(e, r)};
    border: ${r === "white" ? `0.5px solid ${e.colors.neutral[100]}` : "none"};
    border-radius: ${e.border.radius.lg};
    cursor: ${t ? "pointer" : "auto"};
    max-width: ${n || "auto"};
    height: ${o || "auto"};
  `
}), T5e = ({
  children: e,
  background: r = "white",
  onClick: t,
  height: n,
  width: o
}) => {
  const a = bpe({
    background: r,
    hasAction: !!t,
    width: o,
    height: n
  });
  return /* @__PURE__ */ m("div", { css: a.root, onClick: t, children: e });
}, ype = (e, r) => ({
  transparent: "transparent",
  primary: e.colors.neutral[100],
  secondary: "transparent",
  tertiary: e.colors.neutral[100]
})[r], Cpe = (e, r) => {
  const t = {
    DEFAULT: e.colors.neutral[300],
    tertiary: e.colors.brand.tertiary[400]
  };
  return t[r] || t.DEFAULT;
}, wpe = (e, r) => {
  const t = {
    DEFAULT: e.colors.brand.primary[300],
    tertiary: e.colors.brand.tertiary[500]
  };
  return t[r] || t.DEFAULT;
}, _pe = (e, r) => ({
  transparent: "transparent",
  primary: e.colors.background.white,
  secondary: e.colors.brand.primary[100],
  tertiary: e.colors.background.white
})[r], xpe = (e, r, t) => r === "transparent" ? `${e.spacing.xs} 0` : t === "medium" ? `${e.spacing.xs} ${e.spacing.xs}` : `${e.spacing.xxs}`, Yd = {
  withBorder: {
    root: (e, r) => M`
      border: 0.5px solid ${ype(e, r)};
    `
  },
  tertiary: {
    iconWrapper: (e) => M`
      background-color: ${e.colors.brand.tertiary[100]};
    `
  },
  opened: {
    trigger: (e) => M`
      margin-bottom: ${e.spacing.xs};
    `
  }
}, $pe = Ne({
  root: (e, {
    variant: r,
    spacing: t,
    withBorder: n
  }) => M`
    border: none;
    border-radius: ${e.border.radius.lg};
    padding: ${xpe(e, r, t)};
    background-color: ${_pe(e, r)};

    ${n && Yd.withBorder.root(e, r)}
  `,
  trigger: (e, {
    opened: r
  }) => M`
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    background-color: transparent;
    border: none;
    margin-bottom: 0;
    transition: all 0.2s ease-in-out;
    ${r && Yd.opened.trigger(e)}
  `,
  headerLeftSection: ({
    spacing: e
  }) => M`
    display: flex;
    align-items: flex-start;
    gap: ${e.xxs};
  `,
  iconWrapper: (e, {
    variant: r
  }) => M`
    background-color: ${e.colors.brand.primary[200]};
    border-radius: ${e.border.radius.lg};
    display: flex;
    align-items: center;
    padding: 6px;

    svg {
      width: 19px;
      height: 19px;
    }

    ${r === "tertiary" && Yd.tertiary.iconWrapper(e)}
  `,
  wrapperTexts: M`
    display: flex;
    flex-direction: column;
  `,
  headerRightSection: ({
    spacing: e
  }) => M`
    display: flex;
    align-items: center;
    gap: ${e.xxs};
  `
}), D5e = ({
  children: e,
  title: r,
  description: t,
  avatarSrc: n,
  icon: o,
  tagProps: a,
  variant: i = "primary",
  spacing: l = "medium",
  withBorder: s = !0,
  onClick: u
}) => {
  const d = ur(), [f, {
    toggle: p
  }] = H0(!1), g = $pe({
    opened: f,
    variant: i,
    spacing: l,
    withBorder: s
  }), h = (v) => {
    p(), u && u(v);
  };
  return /* @__PURE__ */ Y("div", { css: g.root, children: [
    /* @__PURE__ */ Y("button", { onClick: h, css: g.trigger, children: [
      /* @__PURE__ */ Y("div", { css: g.headerLeftSection, children: [
        n && /* @__PURE__ */ m(Ta, { size: "medium", src: n }),
        o && /* @__PURE__ */ m("div", { css: g.iconWrapper, children: /* @__PURE__ */ m(Pt, { name: o, color: wpe(d, i) }) }),
        /* @__PURE__ */ Y("div", { css: g.wrapperTexts, children: [
          /* @__PURE__ */ m(tr, { variant: "subheading", color: Cpe(d, i), showOnClarity: !0, children: r }),
          t && /* @__PURE__ */ m(tr, { variant: "label", showOnClarity: !0, children: t })
        ] })
      ] }),
      /* @__PURE__ */ Y("div", { css: g.headerRightSection, children: [
        a && /* @__PURE__ */ m(Bi, { ...a }),
        f && /* @__PURE__ */ m(io, { "aria-label": "arrow-up", color: d.colors.neutral[200] }),
        !f && /* @__PURE__ */ m(Nn, { "aria-label": "arrow-down", color: d.colors.neutral[200] })
      ] })
    ] }),
    /* @__PURE__ */ m(Cf, { in: f, children: e })
  ] });
}, Ope = Ne({
  root: ({
    colors: e,
    border: r
  }, {
    hasAction: t
  }) => M`
    border: 0.5px solid ${e.neutral[100]};
    border-radius: ${r.radius.lg};
    user-select: none;
    cursor: ${t ? "pointer" : "auto"};

    > div {
      &:first-of-type {
        border-radius: ${r.radius.lg} ${r.radius.lg} 0 0;
      }

      &:last-of-type {
        border-radius: 0 0 ${r.radius.lg} ${r.radius.lg};
      }
    }
  `
}), Ppe = Ne({
  content: (e, {
    background: r
  }) => M`
    background-color: ${r};
    padding: ${e.spacing.sm} ${e.spacing.xs};
  `
}), IO = ({
  children: e,
  background: r = "white",
  cy: t
}) => {
  const n = Ppe({
    background: r
  });
  return /* @__PURE__ */ m("div", { css: n.content, "data-cy": Ee("card-section", t), children: e });
};
IO.displayName = "Card.Section";
const EO = ({
  onClick: e,
  children: r,
  cy: t,
  ...n
}) => {
  const o = Ope({
    hasAction: !!e
  });
  return /* @__PURE__ */ m("div", { css: o.root, onClick: e, ...n, "data-cy": Ee("card-wrapper", t), children: r });
};
EO.displayName = "Card.Root";
const j5e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Root: EO,
  Section: IO
}, Symbol.toStringTag, { value: "Module" })), Spe = Ne({
  ul: (e, {
    disabled: r
  }) => M`
    cursor: ${r ? "not-allowed" : "pointer"};
    gap: 4px;

    .Mui-selected {
      font-family: ${e.typography.label.fontFamily};
      background-color: ${e.colors.brand.primary[300]};
      border-radius: ${e.border.radius.xs};
      color: ${e.colors.background.white};

      :hover {
        background-color: ${e.colors.brand.primary[300]};
        color: ${e.colors.background.white};
        border: none;
      }
    }

    li:last-of-type,
    li:first-of-type {
      button {
        padding: 21px 4px;
        :hover {
          background-color: transparent;
          border: none;
        }
      }
    }

    li {
      font-family: ${e.typography.label.fontFamily};
      button {
        height: 24px;
        min-width: 24px;
        font-size: ${e.fontSizes.sm};
        background-color: transparent;
        color: ${e.colors.neutral[200]};
        border: none;
        padding: 0 4px;
        border-radius: ${e.border.radius.xs};

        :disabled {
          pointer-events: initial;
          cursor: not-allowed;

          :hover {
            color: ${e.colors.neutral[200]};
            background-color: transparent;
            border: none;
          }
        }

        :hover {
          color: ${e.colors.brand.primary[300]};
          background-color: ${e.colors.neutral[100]};
          border: 1px solid ${e.colors.brand.primary[300]};
        }
      }
    }
  `
}), L5e = ({
  id: e,
  count: r,
  prevLabel: t,
  nextLabel: n,
  disabled: o,
  cy: a,
  ...i
}) => {
  const l = Spe({
    disabled: o
  }), s = ke(e), u = $e(() => /* @__PURE__ */ Y(Br, { children: [
    /* @__PURE__ */ m(v2, { "aria-label": "arrow-left" }),
    t
  ] }), [t]), d = $e(() => /* @__PURE__ */ Y(Br, { children: [
    n,
    /* @__PURE__ */ m(yu, { "aria-label": "arrow-right" })
  ] }), [n]), f = $e((p) => {
    if (p.type === "previous")
      return Ee("pagination-previous-action", a == null ? void 0 : a.prevAction);
    if (p.type === "next")
      return Ee("pagination-next-action", a == null ? void 0 : a.nextAction);
  }, [a == null ? void 0 : a.nextAction, a == null ? void 0 : a.prevAction]);
  return /* @__PURE__ */ m(ooe, { id: s, count: r, sx: l, disabled: o, "data-cy": Ee("pagination-wrapper", a == null ? void 0 : a.wrapper), renderItem: (p) => /* @__PURE__ */ m(tx, { ...p, "data-cy": f(p), slots: {
    previous: u,
    next: d
  } }), ...i });
}, Ipe = ["10", "15", "25", "50", "100", "250"], Epe = Ne({
  container: (e) => M`
    display: flex;
    align-items: center;
    gap: ${e.spacing.xs};
  `,
  dropdownWrapper: M`
    width: 60px;
  `
}), Gv = ur(), z5e = ({
  id: e,
  valuePerPage: r = 10,
  onChange: t,
  itemsOptions: n,
  totalItems: o,
  currentPage: a = 1,
  cy: i,
  ...l
}) => {
  const s = Epe(), u = ke(e), d = ke(e), f = Je(() => (a - 1) * r + 1, [a, r]), p = Je(() => r * a, [a, r]), g = Je(() => {
    const h = o > 1 ? "itens" : "item", v = Math.min(p, o);
    return `${f}-${v} de ${o || "-"} ${h}`;
  }, [f, p, o]);
  return /* @__PURE__ */ Y("div", { css: s.container, id: u, ...l, "data-cy": Ee("paginationOptions-wrapper", i == null ? void 0 : i.wrapper), children: [
    !!o && /* @__PURE__ */ m(tr, { variant: "microCopy", color: Gv.colors.neutral[400], children: g }),
    t && /* @__PURE__ */ Y(Br, { children: [
      /* @__PURE__ */ m(tr, { variant: "microCopy", color: Gv.colors.neutral[300], children: "Itens por página" }),
      /* @__PURE__ */ m("div", { css: s.dropdownWrapper, children: /* @__PURE__ */ m(H$, { id: d, value: String(r), data: n || Ipe, onChange: t, fullWidth: !0, size: "small", cy: {
        input: Ee("paginationOptions-input", i == null ? void 0 : i.input)
      } }) })
    ] })
  ] });
}, Ud = {
  finishedStepBar: (e) => M`
    background-color: ${e.colors.feedback.success[300]};
  `,
  finishedParagraph: (e) => M`
    color: ${e.colors.feedback.success[300]};
  `,
  finishedPrefix: (e) => M`
    color: ${e.colors.neutral[300]};
  `
}, Rpe = Ne({
  container: (e, {
    isActive: r,
    notFinished: t
  }) => M`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    font-family: ${e.typography.label.fontFamily};
    cursor: ${t && !r ? "not-allowed" : "pointer"};
    width: ${r && t ? "150%" : "100%"};
    transition: width 0.5s ease-in-out;

    :hover {
      width: 150%;

      h5 {
        max-width: 100%;
      }
    }

    h5 {
      color: ${r ? e.colors.brand.primary[500] : e.colors.neutral[200]};
      margin-top: 4px;
      padding-bottom: 4px;
      max-width: calc(100% - 20px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transition: max-width 0.5s ease-in-out;

      ${!t && Ud.finishedPrefix(e)}
    }

    p {
      color: ${r ? e.colors.brand.primary[300] : e.colors.neutral[300]};

      ${!t && Ud.finishedParagraph(e)}
    }
  `,
  stepBar: (e, {
    isActive: r,
    notFinished: t
  }) => M`
    width: 100%;
    height: 4px;
    border-radius: ${e.border.radius.full};
    margin-bottom: ${e.spacing.xs};
    background-color: ${r ? e.colors.brand.primary[300] : e.colors.brand.primary[200]};

    ${!t && Ud.finishedStepBar(e)}
  `
}), Xv = ur(), Yv = ({
  step: e,
  label: r,
  isActive: t = !1,
  stepPrefix: n,
  id: o,
  hasStepBar: a = !0,
  notFinished: i,
  onClick: l,
  ...s
}) => {
  const u = Rpe({
    isActive: t,
    notFinished: i
  }), d = ke(o), f = Je(() => t ? Xv.colors.brand.primary[300] : Xv.colors.neutral[300], [t]), p = $e(() => {
    if (l && (!i || t))
      return l();
  }, [t, i, l]);
  return /* @__PURE__ */ Y("div", { css: u.container, tabIndex: -1, id: d, onClick: p, ...s, children: [
    a && /* @__PURE__ */ m("div", { css: u.stepBar }),
    /* @__PURE__ */ Y(tr, { variant: "paragraphSmall", renderAs: "p", color: f, showOnClarity: !0, children: [
      n,
      " ",
      e
    ] }),
    /* @__PURE__ */ m(tr, { variant: "paragraphLarge", renderAs: "h5", "aria-label": r, children: r })
  ] });
}, Ape = Ne({
  container: (e) => M`
    display: flex;
    gap: ${e.spacing.xs};
    margin-top: ${e.spacing.xs};
  `,
  stepMobile: M`
    width: 100%;
  `
}), V5e = ({
  currentStep: e,
  items: r,
  stepPrefix: t,
  completedLabel: n,
  id: o,
  ...a
}) => {
  const i = Ape(), l = ke(o), s = ke(o), u = ke(o), d = ke(o), {
    isMobile: f
  } = Hi(), p = $e(() => e <= 0 ? 0 : e > (r == null ? void 0 : r.length) ? (r == null ? void 0 : r.length) - 1 : e - 1, [e, r == null ? void 0 : r.length]), g = $e((C) => p() - 1 < C, [p]), h = $e((C) => {
    const x = C + 1;
    return g(C) ? x : n;
  }, [n, g]), v = $e((C) => g(C) ? t : "", [g, t]), y = Je(() => Math.floor((p() + 1) * 100 / r.length), [p, r.length]), w = $e(() => /* @__PURE__ */ m(Br, { children: r == null ? void 0 : r.map((C, x) => /* @__PURE__ */ m(Yv, { id: d, stepPrefix: v(x), "aria-current": p() === x, isActive: p() >= x, step: h(x), label: C.label, notFinished: g(x), onClick: C.onClick }, C.step)) }), [p, h, v, r, g, d]), $ = $e(() => /* @__PURE__ */ Y("div", { css: i.stepMobile, children: [
    /* @__PURE__ */ m(nO, { value: y, id: u }),
    /* @__PURE__ */ m(Yv, { id: s, isActive: !0, step: `${p() + 1}/${r == null ? void 0 : r.length}`, label: r[p()].label, hasStepBar: !1, notFinished: !!(r != null && r.length) })
  ] }), [p, r, u, y, s, i.stepMobile]);
  return /* @__PURE__ */ m("div", { css: i.container, tabIndex: -1, id: l, ...a, children: f ? /* @__PURE__ */ m($, {}) : /* @__PURE__ */ m(w, {}) });
}, kpe = Ne({
  tab: (e, {
    fullWidth: r
  }) => M`
    padding: 12px ${e.spacing.xs};
    border-bottom: 2px solid ${e.colors.brand.primary[200]};
    width: ${r ? "100%" : "auto"};

    svg {
      color: ${e.colors.neutral[200]};
      width: 20px;
      height: 20px;
    }

    :hover > div > svg * {
      fill: ${e.colors.neutral[300]};
    }

    :hover {
      background-color: ${e.colors.brand.primary[100]};
      border-color: ${e.colors.brand.primary[200]};
      transition: background 0.5s ease;

      .mantine-Tabs-tabRightSection {
        > div {
          background-color: ${e.colors.brand.primary[200]};
          color: ${e.colors.brand.primary[300]};
          transition: background 0.5s ease;
        }
      }
    }

    &:disabled {
      opacity: 1;
      border-color: ${e.colors.brand.primary[100]};

      > div {
        color: ${e.colors.neutral[200]};
      }

      .mantine-Tabs-tabRightSection {
        > div {
          color: ${e.colors.neutral[300]};
          background-color: ${e.colors.neutral[100]};
        }
      }
    }

    &[data-active] {
      border-color: ${e.colors.brand.primary[300]};
      color: ${e.colors.brand.primary[500]};

      svg {
        color: ${e.colors.brand.primary[300]};
      }

      :hover > div > svg * {
        fill: ${e.colors.brand.primary[300]};
      }

      .mantine-Tabs-tabRightSection {
        > div {
          background-color: ${e.colors.brand.primary[300]};
          color: ${e.colors.background.white};
          transition: background 0.5s ease;
        }
      }

      :hover {
        border-color: ${e.colors.brand.primary[300]};
      }
    }

    &[data-active][data-error='true'] {
      border-color: ${e.colors.feedback.error[300]};

      .mantine-Tabs-tabRightSection {
        > div {
          background-color: ${e.colors.feedback.error[300]};
        }
      }

      :hover {
        border-color: ${e.colors.feedback.error[300]};

        .mantine-Tabs-tabRightSection {
          > div {
            background-color: ${e.colors.feedback.error[300]};
            color: ${e.colors.background.white};
          }
        }
      }
    }

    &[data-error='true'] {
      border-color: ${e.colors.feedback.error[200]};

      svg {
        color: ${e.colors.feedback.error[400]};
      }

      :hover {
        background-color: ${e.colors.feedback.error[100]};
        border-color: ${e.colors.feedback.error[200]};
        transition: background 0.5s ease;

        .mantine-Tabs-tabRightSection {
          > div {
            background-color: ${e.colors.feedback.error[200]};
            color: ${e.colors.feedback.error[300]};
            transition: background 0.5s ease;
          }
        }
      }

      &:disabled {
        opacity: 1;
        border-color: ${e.colors.neutral[100]};

        > div {
          color: ${e.colors.neutral[200]};
        }

        svg {
          color: ${e.colors.neutral[200]};
        }

        .mantine-Tabs-tabRightSection {
          > div {
            color: ${e.colors.neutral[300]};
            background-color: ${e.colors.neutral[100]};
          }
        }

        :hover {
          background-color: transparent;
        }
      }
    }
  `,
  tabIcon: M`
    :not(:only-child) {
      margin-right: 8px;
    }
  `,
  tabRightSection: M`
    :not(:only-child) {
      margin-left: 8px;
    }
  `,
  tabsList: (e, {
    fullWidth: r
  }) => M`
    width: ${r ? "100%" : "fit-content"};
    border: none;
    max-width: 100%;
    padding-bottom: 2px;

    flex-wrap: initial;
    display: inline-flex;
    overflow-x: auto;
    overflow-y: hidden;

    ::-webkit-scrollbar {
      display: none;
      background: ${e.colors.neutral[100]};
      border-radius: ${e.spacing.xxs};
    }
  `,
  tabLabel: (e) => M`
    font-family: ${e.typography.label.fontFamily};
    font-size: ${e.fontSizes.md};
    color: ${e.colors.brand.primary[500]};

    button[data-error='true'] & {
      color: ${e.colors.feedback.error[500]};
    }
  `,
  panel: (e, {
    orientation: r
  }) => M`
    margin-top: ${r === "horizontal" ? e.spacing.xs : 0};
    margin-left: ${r === "vertical" ? e.spacing.xs : 0};
  `
}), Mpe = [{
  value: 1,
  symbol: ""
}, {
  value: 1e3,
  symbol: "mil"
}, {
  value: 1e6,
  symbol: "milhão"
}, {
  value: 1e9,
  symbol: "bilhão"
}], Npe = (e) => {
  if (e === 0)
    return "0";
  const r = Mpe.filter((a) => e >= a.value).pop(), t = e / r.value;
  return `${Number.isInteger(t) ? t.toFixed(0) : t.toFixed(1)} ${r.symbol}`;
}, RO = ({
  id: e,
  icon: r,
  notification: t,
  error: n = !1,
  cy: o,
  ...a
}) => {
  const i = ke(e), l = $e(() => t || t === 0 ? /* @__PURE__ */ m(Bi, { id: i, variant: n ? "error" : "information", size: "small", children: Npe(t) }) : null, [n, t, i]), s = $e(() => {
    if (r)
      return /* @__PURE__ */ m(Pt, { name: r });
    if (r && n)
      return /* @__PURE__ */ m(Pt, { name: "warning" });
  }, [n, r]);
  return /* @__PURE__ */ m(oo.Tab, { "data-error": n, id: i, icon: s(), rightSection: l(), "data-cy": Ee("tabs-tab", o), ...a });
};
RO.displayName = "Tabs.Tab";
const AO = ({
  cy: e,
  ...r
}) => /* @__PURE__ */ m(oo.List, { ...r, "data-cy": Ee("tabs-list", e) });
AO.displayName = "Tabs.List";
const kO = ({
  cy: e,
  ...r
}) => /* @__PURE__ */ m(oo.Panel, { ...r, "data-cy": Ee("tabs-panel", e) });
kO.displayName = "Tabs.Panel";
const L1 = ({
  children: e,
  orientation: r = "horizontal",
  fullWidth: t,
  cy: n,
  ...o
}) => {
  const a = kpe({
    orientation: r,
    fullWidth: t
  });
  return /* @__PURE__ */ m(oo, { styles: a, orientation: r, ...o, "data-cy": Ee("tabs", n), children: e });
};
L1.List = AO;
L1.Tab = RO;
L1.Panel = kO;
L1.displayName = "Tabs";
const Tpe = Ne({
  root: (e) => M`
    display: flex;
    align-items: center;
    width: fit-content;
    gap: 4px;
    height: 18px;

    svg:not(:first-of-type) {
      color: ${e.colors.neutral[200]};
    }
  `,
  button: (e) => M`
    background: none;
    border: none;

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    svg {
      fill: ${e.colors.neutral[200]};
    }
  `,
  itemMobileWrapper: ({
    colors: e,
    typography: r
  }) => M`
    display: flex;
    align-items: center;
    gap: 4px;
    ${r.paragraphLarge};

    svg {
      color: ${e.neutral[200]};
    }
  `
}), Dpe = (e) => M`
  a {
    ${e.typography.subheading};
    color: ${e.colors.brand.primary[500]};
    line-height: 0;

    &:hover {
      color: ${e.colors.brand.primary[500]};
      cursor: initial;
    }
  }
`, jpe = (e) => M`
  a {
    color: ${e.colors.neutral[200]};
    cursor: not-allowed;

    &:hover {
      color: ${e.colors.neutral[200]};
    }
  }
`, Lpe = Ne({
  root: (e, {
    active: r,
    disabled: t
  }) => M`
    a {
      ${e.typography.paragraphLarge};
      color: ${e.colors.neutral[400]};
      line-height: 0;

      &:hover {
        color: ${e.colors.brand.primary[300]};
      }
    }
    ${r && Dpe(e)};
    ${t && jpe(e)};
  `
}), MO = ue(({
  children: e,
  active: r,
  disabled: t,
  id: n
}, o) => {
  const a = Lpe({
    active: r,
    disabled: t
  }), i = (l) => {
    if (t)
      return l.preventDefault(), l.stopPropagation(), !1;
  };
  return /* @__PURE__ */ m("div", { css: a.root, "data-testid": "breadcrumb-item", onClick: i, ref: o, id: n, children: e });
});
MO.displayName = "Breadcrumbs.Item";
const zpe = 3, Vpe = 5, NO = ({
  children: e
}) => {
  const r = Tpe(), t = ur(), {
    windowSize: n,
    isMobile: o
  } = Hi(), a = Je(() => Number(n.width) >= 1920 ? Vpe : zpe, [n.width]), i = (g) => /* @__PURE__ */ Y(Br, { children: [
    /* @__PURE__ */ m(yu, { size: "small", "aria-label": "arrow-right", color: t.colors.neutral[200] }),
    /* @__PURE__ */ Y(Nr, { position: "bottom-start", children: [
      /* @__PURE__ */ m(Nr.Target, { children: /* @__PURE__ */ m("button", { css: r.button, "aria-label": "Name", "data-testid": "button-overflow", children: /* @__PURE__ */ m(vx, { size: "medium", "aria-label": "overflow", "data-testid": "overflow-icon" }) }) }),
      /* @__PURE__ */ m(Nr.Dropdown, { children: Gr.map(g, (h) => /* @__PURE__ */ m(Nr.Item, { children: Wr(h) })) })
    ] })
  ] }), l = (g) => /* @__PURE__ */ Y(Br, { children: [
    /* @__PURE__ */ m(yu, { size: "small", "aria-label": "arrow-right" }),
    Wr(g)
  ] }), s = $e(() => /* @__PURE__ */ Y("div", { css: r.itemMobileWrapper, children: [
    /* @__PURE__ */ m(v2, { size: "medium" }),
    "Voltar"
  ] }), [r.itemMobileWrapper]), u = ({
    childrenIsLarge: g,
    sizeChildren: h,
    maxRenderItems: v
  }) => {
    const y = g ? e.slice(h - v, h) : e.slice(1, h), w = e.slice(1, h - v);
    return {
      reduceChildren: y,
      restChildren: w
    };
  }, d = () => {
    const g = Gr.count(e), h = g - 1 > a, {
      reduceChildren: v,
      restChildren: y
    } = u({
      childrenIsLarge: h,
      sizeChildren: g,
      maxRenderItems: a
    });
    return /* @__PURE__ */ Y(Br, { children: [
      h && i(y),
      Gr.map(v, l)
    ] });
  }, f = Ve(null), p = $e(() => {
    if (o && f.current) {
      const g = f.current.querySelector("a");
      if (g) {
        g.innerHTML = "";
        const h = document.createElement("div");
        ni.render(/* @__PURE__ */ m(s, {}), h), g.appendChild(h);
      }
    }
  }, [s, o]);
  return Fe(() => {
    p();
  }, [p]), o ? /* @__PURE__ */ m("div", { children: Gr.map(e.slice(e.length - 2, e.length - 1), (g) => Wr(g, {
    ref: f
  })) }) : /* @__PURE__ */ Y("div", { css: r.root, children: [
    Gr.map(e.slice(0, 1), (g) => Wr(g)),
    d()
  ] });
};
NO.displayName = "Breadcrumbs.Root";
const F5e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Item: MO,
  Root: NO
}, Symbol.toStringTag, { value: "Module" })), Qo = (e) => ({
  colorful: {
    primaryTextColor: "#1900AF",
    secondaryTextColor: "#FF646E"
  },
  "colorful-inverse": {
    primaryTextColor: e.colors.background.white,
    secondaryTextColor: "#FF646E"
  },
  neutral: {
    primaryTextColor: e.colors.background.white,
    secondaryTextColor: e.colors.background.white
  }
}), Z5e = ({
  base: e,
  inverse: r,
  width: t = 406,
  height: n = 155,
  ...o
}) => {
  const a = ur(), i = Je(() => r && e === "colorful" ? `${e}-inverse` : `${e}`, [e, r]);
  return /* @__PURE__ */ Y("svg", { width: t, height: n, viewBox: "0 0 406 155", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...o, children: [
    /* @__PURE__ */ m("path", { d: "M246.039 155C240.836 155 236.165 153.782 232.027 151.346C227.888 148.91 224.605 145.61 222.169 141.436C219.733 137.266 218.482 132.579 218.414 127.376V80.6379C218.414 79.3029 218.797 78.2542 219.563 77.4839C220.33 76.7175 221.382 76.3344 222.718 76.3344C223.984 76.3344 225 76.7175 225.771 77.4839C226.537 78.2502 226.92 79.3029 226.92 80.6379V109.258C229.123 106.257 231.99 103.838 235.528 102.002C239.065 100.167 242.998 99.2516 247.338 99.2516C252.408 99.2516 256.945 100.47 260.95 102.906C264.956 105.342 268.106 108.661 270.409 112.864C272.712 117.067 273.861 121.806 273.861 127.073C273.861 132.413 272.643 137.181 270.207 141.384C267.771 145.586 264.467 148.906 260.297 151.342C256.13 153.782 251.375 155 246.039 155ZM246.039 147.393C249.774 147.393 253.13 146.494 256.098 144.691C259.067 142.888 261.402 140.472 263.104 137.435C264.806 134.398 265.657 130.945 265.657 127.077C265.657 123.274 264.806 119.838 263.104 116.768C261.402 113.699 259.067 111.283 256.098 109.512C253.13 107.746 249.778 106.858 246.039 106.858C242.437 106.858 239.15 107.742 236.181 109.512C233.213 111.279 230.893 113.699 229.227 116.768C227.558 119.838 226.727 123.274 226.727 127.077C226.727 130.949 227.562 134.402 229.227 137.435C230.893 140.472 233.213 142.888 236.181 144.691C239.15 146.494 242.437 147.393 246.039 147.393Z", fill: Qo(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M314.196 155C308.722 155 303.886 153.814 299.683 151.447C295.48 149.079 292.177 145.792 289.777 141.589C287.373 137.387 286.175 132.583 286.175 127.178C286.175 121.709 287.309 116.885 289.58 112.715C291.846 108.544 294.968 105.257 298.937 102.857C302.906 100.454 307.496 99.2557 312.699 99.2557C317.769 99.2557 322.19 100.405 325.961 102.708C329.728 105.011 332.632 108.198 334.669 112.267C336.702 116.337 337.722 120.975 337.722 126.178C337.722 127.311 337.355 128.231 336.621 128.929C335.887 129.631 334.952 129.981 333.818 129.981H291.975V123.076H334.31L330.007 126.077C330.071 122.407 329.406 119.108 328.006 116.167C326.606 113.231 324.602 110.932 322 109.262C319.399 107.597 316.297 106.762 312.691 106.762C308.888 106.762 305.568 107.629 302.733 109.363C299.897 111.097 297.727 113.517 296.227 116.619C294.726 119.721 293.976 123.242 293.976 127.178C293.976 131.115 294.843 134.62 296.578 137.685C298.312 140.754 300.696 143.158 303.733 144.893C306.77 146.627 310.255 147.494 314.191 147.494C316.458 147.494 318.778 147.095 321.145 146.292C323.513 145.489 325.4 144.489 326.8 143.291C327.603 142.69 328.518 142.376 329.551 142.339C330.583 142.307 331.434 142.59 332.104 143.19C333.104 144.058 333.62 144.993 333.657 145.994C333.689 146.994 333.237 147.861 332.306 148.595C330.103 150.463 327.3 151.999 323.9 153.197C320.5 154.399 317.261 155 314.196 155Z", fill: Qo(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M347.621 109.061C346.483 109.061 345.551 108.71 344.817 108.008C344.083 107.306 343.716 106.455 343.716 105.455C343.716 104.39 344.083 103.503 344.817 102.805C345.551 102.103 346.483 101.752 347.621 101.752H372.341C373.475 101.752 374.411 102.103 375.145 102.805C375.879 103.507 376.246 104.39 376.246 105.455C376.246 106.455 375.879 107.306 375.145 108.008C374.411 108.71 373.475 109.061 372.341 109.061H347.621ZM371.64 154.5C368.171 154.5 365.065 153.665 362.33 151.999C359.596 150.333 357.442 148.03 355.877 145.094C354.308 142.158 353.525 138.855 353.525 135.184V86.5427C353.525 85.3408 353.909 84.3405 354.675 83.5419C355.441 82.7393 356.458 82.34 357.728 82.34C358.93 82.34 359.931 82.7393 360.729 83.5419C361.532 84.3445 361.931 85.3448 361.931 86.5427V135.18C361.931 138.318 362.847 140.92 364.682 142.985C366.517 145.054 368.836 146.086 371.64 146.086H374.64C375.705 146.086 376.609 146.486 377.343 147.288C378.077 148.087 378.444 149.091 378.444 150.289C378.444 151.556 377.992 152.576 377.093 153.342C376.193 154.109 375.04 154.492 373.64 154.492H371.64V154.5Z", fill: Qo(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M396.663 154.5C395.396 154.5 394.36 154.117 393.561 153.35C392.763 152.584 392.359 151.535 392.359 150.196V104.059C392.359 102.724 392.759 101.676 393.561 100.905C394.36 100.139 395.396 99.7558 396.663 99.7558C397.929 99.7558 398.946 100.139 399.716 100.905C400.483 101.672 400.866 102.724 400.866 104.059V150.196C400.866 151.531 400.483 152.584 399.716 153.35C398.946 154.117 397.929 154.5 396.663 154.5Z", fill: Qo(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M396.562 89.846C394.961 89.846 393.594 89.2611 392.46 88.0955C391.327 86.9299 390.758 85.5424 390.758 83.9412C390.758 82.2754 391.343 80.9041 392.509 79.8393C393.674 78.7745 395.025 78.2381 396.562 78.2381C398.095 78.2381 399.446 78.7745 400.616 79.8393C401.781 80.9081 402.366 82.2754 402.366 83.9412C402.366 85.5424 401.797 86.9299 400.664 88.0955C399.531 89.2652 398.163 89.846 396.562 89.846Z", fill: Qo(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M33.4734 13.3139C39.58 13.3139 44.8355 15.5121 49.111 20.0334L58.1458 10.6278C58.1499 10.6237 58.1499 10.6197 58.1458 10.6157C51.5431 3.53721 43.3714 0 33.4734 0C24.0634 0 16.1256 3.17421 9.64795 9.40567C3.1743 15.6371 0 23.3327 0 32.6174C0 41.898 3.1743 49.7186 9.64795 55.95C16.1256 62.1815 24.0634 65.2347 33.4734 65.2347C43.3674 65.2347 51.5431 61.6975 58.1499 54.611C58.1539 54.6069 58.1539 54.6029 58.1499 54.5989L49.115 45.2013C44.8355 49.7186 39.584 51.9208 33.4774 51.9208C28.0968 51.9208 23.5794 50.0856 19.917 46.4193C16.3636 42.7531 14.5324 38.1148 14.5324 32.6174C14.5324 27.1159 16.3636 22.4776 19.913 18.8113C23.5754 15.1451 28.0928 13.3139 33.4734 13.3139ZM171.88 0.730029C163.087 0.730029 156.122 4.7593 153.189 10.7488V1.94809H138.657V63.5246H153.189V28.096C153.189 19.6664 159.179 13.802 167.484 13.802C175.672 13.802 180.556 19.0533 180.556 27.487V63.5286H195.218V25.4058C195.218 10.1357 186.542 0.730029 171.88 0.730029ZM94.971 0.120999C85.561 0.120999 77.6232 3.29925 71.1455 9.52667C64.6679 15.7581 61.3766 23.5787 61.3766 32.7384C61.3766 41.898 64.6679 49.7186 71.1455 55.95C77.6232 62.1815 85.561 65.3557 94.971 65.3557C104.381 65.3557 112.319 62.1815 118.796 55.95C125.274 49.7186 128.565 41.898 128.565 32.7384C128.565 23.5787 125.274 15.7581 118.796 9.52667C112.323 3.29925 104.385 0.120999 94.971 0.120999ZM108.531 46.5444C104.869 50.2106 100.343 52.0418 94.971 52.0418C89.4694 52.0418 84.9519 50.2106 81.2936 46.5444C77.7442 42.7531 75.913 38.2398 75.913 32.7384C75.913 27.241 77.7442 22.7196 81.2936 19.0533C84.956 15.2701 89.4694 13.4349 94.971 13.4349C100.343 13.4349 104.869 15.2701 108.531 19.0533C112.202 22.7196 114.033 27.241 114.033 32.7384C114.033 38.2398 112.202 42.7531 108.531 46.5444ZM329.156 1.94809H313.151L299.841 20.3964L286.401 1.94809H270.514L291.774 31.0242L268.436 63.5246H284.203L299.841 41.781L315.478 63.5246H331.237L307.899 30.9072L329.156 1.94809ZM404.927 52.1628L401.947 52.1668C398.643 52.1668 397.429 50.2106 397.429 44.9552V1.94809H382.768V10.8698C380.449 5.00937 372.987 0.604996 363.101 0.604996C354.425 0.604996 347.096 3.65821 341.107 9.88967C335.238 15.9961 332.314 23.5707 332.314 32.7343C332.314 41.898 335.238 49.4725 341.107 55.704C347.096 61.9355 354.425 64.9887 363.101 64.9887C372.87 64.9887 379.952 61.8104 384.232 55.3329C384.849 58.5112 386.559 60.9513 389.245 62.7905C391.444 64.1336 394.251 64.7467 397.792 64.7467C400.975 64.7467 403.411 64.3797 405 63.7666C405.004 63.7666 405.004 63.7626 405.004 63.7585V52.2273C405 52.195 404.968 52.1628 404.927 52.1628ZM378.367 46.1773C374.826 49.7186 370.3 51.5537 365.045 51.5537C359.793 51.5537 355.514 49.7186 351.973 46.1773C348.552 42.6361 346.838 38.1148 346.838 32.7384C346.838 27.366 348.548 22.8447 351.973 19.2994C355.514 15.7581 359.793 13.927 365.045 13.927C370.296 13.927 374.822 15.7581 378.367 19.2994C382.03 22.8447 383.857 27.366 383.857 32.7384C383.861 38.1148 382.03 42.6361 378.367 46.1773ZM237.189 0.241998C227.779 0.241998 220.088 3.17018 213.981 9.15964C207.992 15.1451 204.938 22.9616 204.938 32.7343V33.2224C204.938 42.8781 207.992 50.5696 213.981 56.3171C219.959 62.0565 227.909 64.9927 237.556 64.9927C247.939 64.9927 256.481 61.3305 263.443 54.002C263.447 53.9979 263.447 53.9939 263.443 53.9899L254.654 45.4473C249.891 50.2106 244.397 52.5298 238.04 52.5298C227.166 52.5298 219.955 46.1773 219.467 36.4046H267.355C267.484 34.8195 267.605 33.1054 267.605 31.2783C267.605 22.4776 264.798 15.1491 259.051 9.16367C253.432 3.17421 246.111 0.241998 237.189 0.241998ZM219.838 26.1439C220.205 22.3526 222.036 19.1824 225.339 16.6132C228.631 14.048 232.672 12.7049 237.185 12.7049C241.465 12.7049 245.006 14.048 248.06 16.7382C251.113 19.2994 252.706 22.4776 252.706 26.1439H219.838Z", fill: Qo(a)[i].primaryTextColor })
  ] });
}, ea = (e) => ({
  colorful: {
    primaryTextColor: "#1900AF",
    secondaryTextColor: "#FF646E"
  },
  "colorful-inverse": {
    primaryTextColor: e.colors.background.white,
    secondaryTextColor: "#FF646E"
  },
  neutral: {
    primaryTextColor: e.colors.background.white,
    secondaryTextColor: e.colors.background.white
  }
}), W5e = ({
  base: e,
  inverse: r,
  width: t = 406,
  height: n = 138,
  ...o
}) => {
  const a = ur(), i = Je(() => r && e === "colorful" ? `${e}-inverse` : `${e}`, [e, r]);
  return /* @__PURE__ */ Y("svg", { width: t, height: n, viewBox: "0 0 406 138", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...o, children: [
    /* @__PURE__ */ m("path", { d: "M169.935 134.921C166.361 132.922 163.566 130.163 161.556 126.638C159.543 123.114 158.536 119.189 158.536 114.86C158.536 110.421 159.514 106.44 161.471 102.911C163.429 99.387 166.162 96.6397 169.681 94.6692C173.199 92.6987 177.17 91.7154 181.594 91.7154C188.286 91.7154 193.847 94.2119 198.271 99.209C198.837 99.82 199.12 100.54 199.12 101.374C199.12 102.596 198.493 103.623 197.248 104.453C196.681 104.841 196.026 105.036 195.29 105.036C193.984 105.036 192.88 104.538 191.97 103.538C190.551 102.041 189.006 100.945 187.332 100.249C185.658 99.557 183.745 99.209 181.59 99.209C177.222 99.209 173.676 100.637 170.954 103.498C168.233 106.359 166.87 110.146 166.87 114.864C166.87 117.862 167.509 120.541 168.783 122.896C170.061 125.254 171.844 127.1 174.145 128.431C176.442 129.762 179.066 130.43 182.014 130.43C185.872 130.43 188.99 129.458 191.372 127.516C192.447 126.739 193.499 126.351 194.518 126.351C195.311 126.351 196.051 126.602 196.73 127.1C197.806 127.99 198.347 128.989 198.347 130.098C198.347 130.931 198.008 131.68 197.328 132.347C193.244 136.066 188.141 137.927 182.014 137.927C177.534 137.915 173.51 136.92 169.935 134.921Z", fill: ea(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M253.571 93.1275C254.363 93.9044 254.763 94.9322 254.763 96.2067V133.339C254.763 134.561 254.367 135.572 253.571 136.377C252.774 137.183 251.727 137.583 250.424 137.583C249.175 137.583 248.14 137.183 247.319 136.377C246.494 135.572 246.085 134.561 246.085 133.339V132.424C244.27 134.201 242.114 135.576 239.619 136.543C237.124 137.514 234.455 138 231.62 138C227.706 138 224.188 137.166 221.07 135.503C217.948 133.841 215.51 131.413 213.755 128.22C211.996 125.028 211.118 121.184 211.118 116.689V96.2108C211.118 94.9888 211.531 93.9772 212.351 93.1721C213.172 92.3669 214.208 91.9663 215.457 91.9663C216.703 91.9663 217.738 92.3709 218.563 93.1721C219.384 93.9772 219.796 94.9888 219.796 96.2108V116.689C219.796 121.184 221.03 124.583 223.496 126.885C225.963 129.187 229.239 130.341 233.323 130.341C235.705 130.341 237.876 129.871 239.834 128.924C241.791 127.982 243.323 126.707 244.427 125.097C245.535 123.486 246.085 121.682 246.085 119.687V96.2108C246.085 94.9362 246.498 93.9085 247.319 93.1316C248.14 92.3547 249.175 91.9663 250.424 91.9663C251.727 91.9622 252.778 92.3507 253.571 93.1275Z", fill: ea(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M271.311 83.012C270.203 81.9317 269.653 80.6409 269.653 79.1398C269.653 77.6427 270.207 76.352 271.311 75.2676C272.419 74.1832 273.737 73.6451 275.266 73.6451C276.798 73.6451 278.117 74.1872 279.221 75.2676C280.329 76.3479 280.879 77.6387 280.879 79.1398C280.879 80.6369 280.325 81.9276 279.221 83.012C278.113 84.0964 276.794 84.6346 275.266 84.6346C273.737 84.6346 272.419 84.0964 271.311 83.012ZM272.164 136.377C271.339 135.572 270.931 134.561 270.931 133.339V96.2917C270.931 95.0171 271.343 93.9894 272.164 93.2125C272.985 92.4356 274.02 92.0472 275.27 92.0472C276.576 92.0472 277.623 92.4356 278.42 93.2125C279.213 93.9894 279.613 95.0171 279.613 96.2917V133.339C279.613 134.561 279.217 135.572 278.42 136.377C277.623 137.183 276.576 137.583 275.27 137.583C274.02 137.583 272.985 137.183 272.164 136.377Z", fill: ea(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M339.078 73.73C339.871 74.5069 340.271 75.5346 340.271 76.8092V114.771C340.271 119.1 339.236 123.029 337.165 126.549C335.095 130.073 332.284 132.849 328.742 134.876C325.195 136.903 321.241 137.915 316.873 137.915C312.506 137.915 308.519 136.903 304.92 134.876C301.316 132.849 298.494 130.078 296.452 126.549C294.41 123.025 293.391 119.1 293.391 114.771C293.391 110.441 294.341 106.516 296.241 102.992C298.142 99.4679 300.75 96.7084 304.07 94.7096C307.39 92.7108 311.09 91.7114 315.175 91.7114C318.462 91.7114 321.528 92.379 324.362 93.7102C327.197 95.0414 329.607 96.9027 331.593 99.2899V76.8132C331.593 75.5387 332.005 74.5109 332.826 73.7341C333.647 72.9572 334.682 72.5688 335.932 72.5688C337.234 72.5647 338.285 72.9531 339.078 73.73ZM324.573 128.386C326.87 127.027 328.669 125.153 329.975 122.766C331.277 120.379 331.933 117.716 331.933 114.775C331.933 111.833 331.282 109.183 329.975 106.824C328.669 104.465 326.87 102.608 324.573 101.244C322.276 99.8847 319.708 99.2049 316.873 99.2049C314.034 99.2049 311.471 99.8847 309.174 101.244C306.877 102.604 305.061 104.465 303.727 106.824C302.392 109.183 301.729 111.833 301.729 114.775C301.729 117.716 302.396 120.383 303.727 122.766C305.057 125.153 306.877 127.027 309.174 128.386C311.471 129.746 314.038 130.425 316.873 130.425C319.708 130.425 322.276 129.746 324.573 128.386Z", fill: ea(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M388.555 94.7501C392.097 96.7772 394.908 99.5529 396.978 103.077C399.049 106.601 400.084 110.526 400.084 114.856V133.42C400.084 134.642 399.671 135.653 398.85 136.458C398.025 137.264 396.99 137.664 395.745 137.664C394.495 137.664 393.46 137.264 392.639 136.458C391.814 135.653 391.406 134.642 391.406 133.42V130.341C389.42 132.728 387.01 134.585 384.175 135.92C381.336 137.251 378.275 137.919 374.988 137.919C370.903 137.919 367.203 136.92 363.883 134.921C360.563 132.922 357.955 130.162 356.054 126.638C354.154 123.114 353.203 119.189 353.203 114.86C353.203 110.53 354.222 106.605 356.264 103.081C358.307 99.557 361.129 96.7813 364.732 94.7541C368.335 92.727 372.319 91.7154 376.686 91.7154C381.053 91.7114 385.008 92.727 388.555 94.7501ZM384.385 128.386C386.682 127.027 388.482 125.169 389.788 122.806C391.09 120.448 391.745 117.797 391.745 114.856C391.745 111.914 391.094 109.252 389.788 106.864C388.482 104.477 386.682 102.604 384.385 101.244C382.089 99.8847 379.521 99.2049 376.686 99.2049C373.847 99.2049 371.283 99.8847 368.986 101.244C366.69 102.604 364.874 104.477 363.539 106.864C362.205 109.252 361.542 111.914 361.542 114.856C361.542 117.797 362.209 120.448 363.539 122.806C364.87 125.165 366.69 127.027 368.986 128.386C371.283 129.746 373.851 130.425 376.686 130.425C379.521 130.425 382.089 129.746 384.385 128.386Z", fill: ea(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M33.556 13.3565C39.6784 13.3565 44.9435 15.5617 49.2341 20.0975L58.2923 10.6658C58.2964 10.6618 58.2964 10.6577 58.2923 10.6537C51.6725 3.54853 43.4756 0 33.556 0C24.1217 0 16.1633 3.18437 9.67292 9.43576C3.18252 15.6872 0 23.4033 0 32.7176C0 42.028 3.18252 49.8695 9.67292 56.1209C16.1633 62.3723 24.1217 65.4353 33.556 65.4353C43.4756 65.4353 51.6725 61.8868 58.2923 54.7816C58.2964 54.7776 58.2964 54.7735 58.2923 54.7695L49.2341 45.3418C44.9476 49.8736 39.6824 52.0828 33.556 52.0828C28.1615 52.0828 23.6323 50.2418 19.9646 46.5638C16.406 42.8858 14.57 38.2326 14.57 32.7176C14.57 27.1986 16.406 22.5455 19.9646 18.8675C23.6364 15.1935 28.1615 13.3565 33.556 13.3565ZM172.305 0.732364C163.489 0.732364 156.51 4.77453 153.566 10.7791V1.95432H138.996V63.7197H153.566V28.1818C153.566 19.7253 159.571 13.8421 167.897 13.8421C176.106 13.8421 180.999 19.1102 180.999 27.5668V63.7197H195.699V25.483C195.699 10.1681 187.004 0.732364 172.305 0.732364ZM95.2088 0.121386C85.7744 0.121386 77.8161 3.3098 71.3257 9.55715C64.8353 15.8085 61.5314 23.6501 61.5314 32.8431C61.5314 42.0361 64.8312 49.8776 71.3257 56.129C77.8161 62.3804 85.7744 65.5648 95.2088 65.5648C104.643 65.5648 112.601 62.3804 119.092 56.129C125.582 49.8776 128.886 42.0361 128.886 32.8431C128.886 23.6501 125.586 15.8085 119.092 9.55715C112.601 3.30575 104.643 0.121386 95.2088 0.121386ZM108.8 46.6892C105.128 50.3672 100.591 52.2001 95.2088 52.2001C89.6929 52.2001 85.1678 50.3632 81.496 46.6892C77.9374 42.8858 76.1015 38.3581 76.1015 32.839C76.1015 27.324 77.9374 22.7923 81.496 19.1143C85.1678 15.3189 89.6929 13.4779 95.2088 13.4779C100.595 13.4779 105.132 15.3189 108.8 19.1143C112.48 22.7923 114.316 27.3281 114.316 32.839C114.316 38.3581 112.48 42.8858 108.8 46.6892ZM329.971 1.95432H313.925L300.58 20.4576L287.11 1.95432H271.182L292.493 31.1194L269.099 63.7197H284.906L300.585 41.9066L316.263 63.7197H332.058L308.664 31.0021L329.971 1.95432ZM405.927 52.3215L402.939 52.3256C399.627 52.3256 398.41 50.3632 398.41 45.091V1.95432H383.71V10.9045C381.389 5.02539 373.908 0.606931 363.996 0.606931C355.302 0.606931 347.95 3.66991 341.945 9.9213C336.061 16.0473 333.13 23.646 333.13 32.835C333.13 42.0239 336.061 49.6227 341.945 55.8741C347.95 62.1255 355.298 65.1885 363.996 65.1885C373.791 65.1885 380.892 62.0001 385.178 55.5059C385.797 58.6943 387.511 61.1423 390.205 62.9833C392.409 64.3307 395.219 64.9457 398.77 64.9457C401.96 64.9457 404.399 64.5775 405.996 63.9625C406 63.9625 406 63.9584 406 63.9544V52.3903C406 52.3539 405.968 52.3215 405.927 52.3215ZM379.306 46.321C375.756 49.8736 371.219 51.7146 365.954 51.7146C360.689 51.7146 356.398 49.8736 352.851 46.321C349.422 42.7684 347.708 38.2326 347.708 32.839C347.708 27.4495 349.422 22.9137 352.851 19.3571C356.402 15.8045 360.689 13.9675 365.954 13.9675C371.219 13.9675 375.756 15.8045 379.306 19.3571C382.974 22.9137 384.81 27.4495 384.81 32.839C384.81 38.2326 382.974 42.7684 379.306 46.321ZM237.775 0.242773C228.341 0.242773 220.633 3.18032 214.511 9.18894C208.506 15.1895 205.445 23.0351 205.445 32.839V33.3286C205.445 43.0112 208.506 50.7314 214.511 56.4932C220.504 62.2509 228.474 65.1925 238.147 65.1925C248.556 65.1925 257.121 61.5186 264.101 54.1666C264.105 54.1625 264.105 54.1585 264.101 54.1545L255.293 45.5846C250.517 50.3632 245.01 52.6897 238.641 52.6897C227.742 52.6897 220.512 46.317 220.023 36.513H268.031C268.161 34.9228 268.282 33.2032 268.282 31.3703C268.282 22.5455 265.472 15.1895 259.705 9.18894C254.06 3.18437 246.72 0.242773 237.775 0.242773ZM220.383 26.2235C220.751 22.42 222.586 19.2397 225.898 16.6623C229.198 14.0889 233.25 12.7415 237.775 12.7415C242.062 12.7415 245.612 14.0889 248.673 16.7877C251.735 19.3571 253.332 22.5455 253.332 26.2235H220.383Z", fill: ea(a)[i].primaryTextColor })
  ] });
}, Bt = (e) => ({
  colorful: {
    primaryTextColor: "#1900AF",
    secondaryTextColor: "#FF646E"
  },
  "colorful-inverse": {
    primaryTextColor: e.colors.background.white,
    secondaryTextColor: "#FF646E"
  },
  neutral: {
    primaryTextColor: e.colors.background.white,
    secondaryTextColor: e.colors.background.white
  }
}), B5e = ({
  base: e,
  inverse: r,
  width: t = 406,
  height: n = 143,
  ...o
}) => {
  const a = ur(), i = Je(() => r && e === "colorful" ? `${e}-inverse` : `${e}`, [e, r]);
  return /* @__PURE__ */ Y("svg", { width: t, height: n, viewBox: "0 0 406 143", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...o, children: [
    /* @__PURE__ */ m("g", { clipPath: "url(#clip0_1485_17803)", children: /* @__PURE__ */ m("path", { d: "M33.5578 13.3225C39.6817 13.3225 44.9487 15.5211 49.233 20.049L58.2905 10.6406C58.2953 10.6358 58.2953 10.6309 58.2905 10.6261C51.6728 3.54203 43.477 0 33.5578 0C24.1227 0 16.1641 3.17478 9.67231 9.4132C3.18054 15.6468 0 23.3494 0 32.6418C0 41.9293 3.18054 49.7527 9.67231 55.9911C16.1641 62.2296 24.1227 65.2835 33.5578 65.2835C43.477 65.2835 51.6728 61.7415 58.2953 54.6526C58.3001 54.6478 58.3001 54.6429 58.2953 54.6381L49.233 45.2346C44.9438 49.7527 39.6817 51.9562 33.5578 51.9562C28.1649 51.9562 23.6338 50.12 19.9643 46.4523C16.4061 42.7846 14.5714 38.1409 14.5714 32.6418C14.5714 27.1378 16.4061 22.4941 19.9643 18.8264C23.6338 15.1539 28.1601 13.3225 33.5578 13.3225ZM172.306 0.729668C163.49 0.729668 156.509 4.75975 153.566 10.7517V1.95222H138.995V63.5681H153.566V28.114C153.566 19.6769 159.569 13.8105 167.896 13.8105C176.101 13.8105 181 19.068 181 27.5051V63.5681H195.697V25.4224C195.697 10.1429 187.003 0.729668 172.306 0.729668ZM95.2079 0.120806C85.7728 0.120806 77.8142 3.30042 71.3224 9.534C64.8307 15.7724 61.5291 23.5958 61.5291 32.7626C61.5291 41.9293 64.8307 49.7527 71.3224 55.9911C77.8142 62.2296 85.7728 65.4043 95.2079 65.4043C104.643 65.4043 112.602 62.2296 119.093 55.9911C125.585 49.7527 128.887 41.9293 128.887 32.7626C128.887 23.5958 125.585 15.7676 119.089 9.52917C112.597 3.30042 104.643 0.120806 95.2079 0.120806ZM108.801 46.5779C105.132 50.2456 100.596 52.077 95.2079 52.077C89.694 52.077 85.1677 50.2456 81.4982 46.5779C77.9401 42.7846 76.1053 38.2665 76.1053 32.7626C76.1053 27.2635 77.9401 22.7405 81.4982 19.068C85.1677 15.2795 89.694 13.4433 95.2079 13.4433C100.591 13.4433 105.132 15.2795 108.801 19.068C112.481 22.7357 114.315 27.2587 114.315 32.7626C114.315 38.2665 112.481 42.7846 108.801 46.5779ZM329.967 1.95222H313.919L300.578 20.4114L287.105 1.95222H271.178L292.488 31.0471L269.092 63.5681H284.898L300.573 41.8085L316.248 63.5681H332.044L308.657 30.9263L329.967 1.95222ZM405.923 52.1978L402.936 52.2027C399.624 52.2027 398.409 50.2456 398.409 44.9881V1.95222H383.712V10.8822C381.388 5.01586 373.909 0.608862 363.995 0.608862C355.3 0.608862 347.947 3.66284 341.944 9.90125C336.062 16.014 333.128 23.5958 333.128 32.7626C333.128 41.9293 336.062 49.5111 341.944 55.7495C347.947 61.9879 355.295 65.0419 363.995 65.0419C373.788 65.0419 380.89 61.8623 385.174 55.3823C385.794 58.5619 387.507 61.007 390.199 62.8433C392.402 64.1866 395.214 64.8003 398.768 64.8003C401.958 64.8003 404.398 64.4331 405.995 63.8194C406 63.8194 406 63.8145 406 63.8145V52.2751C406 52.2317 405.966 52.1978 405.923 52.1978ZM379.302 46.2059C375.753 49.7479 371.213 51.5841 365.95 51.5841C360.683 51.5841 356.399 49.7479 352.846 46.2059C349.414 42.6638 347.7 38.136 347.7 32.7577C347.7 27.3843 349.414 22.8565 352.846 19.3096C356.394 15.7676 360.683 13.9362 365.95 13.9362C371.217 13.9362 375.753 15.7676 379.302 19.3096C382.971 22.8565 384.806 27.3843 384.806 32.7577C384.806 38.1409 382.971 42.6638 379.302 46.2059ZM237.77 0.241612C228.335 0.241612 220.629 3.17478 214.505 9.16675C208.502 15.1539 205.442 22.9773 205.442 32.7577V33.2458C205.442 42.9054 208.502 50.608 214.505 56.3536C220.498 62.0991 228.466 65.0322 238.138 65.0322C248.547 65.0322 257.11 61.3646 264.091 54.0341C264.096 54.0292 264.096 54.0244 264.091 54.0196L255.28 45.4714C250.502 50.2408 244.998 52.5602 238.627 52.5602C227.725 52.5602 220.498 46.2059 220.009 36.4254H268.017C268.148 34.8356 268.269 33.125 268.269 31.2936C268.269 22.4892 265.456 15.1539 259.691 9.16675C254.056 3.17478 246.717 0.241612 237.77 0.241612ZM220.382 26.1617C220.75 22.3684 222.584 19.1936 225.896 16.6277C229.197 14.0618 233.244 12.7136 237.77 12.7136C242.06 12.7136 245.608 14.057 248.672 16.7485C251.732 19.3096 253.329 22.4941 253.329 26.1617H220.382Z", fill: Bt(a)[i].primaryTextColor }) }),
    /* @__PURE__ */ m("path", { d: "M104.555 127.405C100.981 127.405 97.7939 126.65 94.9946 125.141C92.2384 123.589 90.0635 121.476 88.4701 118.803C86.9197 116.086 86.1445 112.982 86.1445 109.489C86.1445 105.953 86.8767 102.849 88.3409 100.176C89.8482 97.4593 91.9154 95.3465 94.5424 93.8374C97.1694 92.2851 100.184 91.509 103.586 91.509C106.945 91.509 109.831 92.2636 112.243 93.7727C114.654 95.2387 116.485 97.2868 117.733 99.917C119.025 102.504 119.671 105.501 119.671 108.907C119.671 109.726 119.392 110.416 118.832 110.977C118.272 111.494 117.561 111.753 116.7 111.753H90.6665V106.579H116.506L113.858 108.39C113.814 106.234 113.384 104.315 112.566 102.633C111.747 100.909 110.585 99.5505 109.077 98.5588C107.57 97.5671 105.74 97.0712 103.586 97.0712C101.132 97.0712 99.0213 97.6102 97.2556 98.6881C95.5329 99.7661 94.2194 101.254 93.315 103.151C92.4106 105.005 91.9585 107.118 91.9585 109.489C91.9585 111.861 92.4968 113.973 93.5734 115.827C94.6501 117.682 96.1359 119.148 98.0308 120.226C99.9257 121.303 102.101 121.842 104.555 121.842C105.89 121.842 107.247 121.605 108.625 121.131C110.046 120.614 111.187 120.031 112.049 119.385C112.695 118.91 113.384 118.673 114.116 118.673C114.891 118.63 115.559 118.846 116.119 119.32C116.851 119.967 117.238 120.678 117.281 121.454C117.324 122.23 116.98 122.899 116.248 123.459C114.783 124.624 112.953 125.572 110.757 126.305C108.603 127.038 106.536 127.405 104.555 127.405Z", fill: Bt(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M158.631 142.28C157.64 142.28 156.822 141.957 156.176 141.31C155.573 140.707 155.272 139.93 155.272 138.982V121.519C153.807 123.33 151.999 124.774 149.845 125.852C147.692 126.887 145.345 127.405 142.804 127.405C139.66 127.405 136.839 126.629 134.342 125.076C131.844 123.481 129.863 121.347 128.398 118.673C126.977 115.957 126.267 112.895 126.267 109.489C126.267 106.083 127.042 103.021 128.592 100.305C130.186 97.5886 132.317 95.4543 134.988 93.902C137.701 92.3067 140.737 91.509 144.096 91.509C147.455 91.509 150.47 92.3067 153.14 93.902C155.81 95.4543 157.92 97.5886 159.471 100.305C161.064 103.021 161.861 106.083 161.861 109.489V138.982C161.861 139.93 161.559 140.707 160.956 141.31C160.353 141.957 159.578 142.28 158.631 142.28ZM144.096 121.584C146.292 121.584 148.252 121.066 149.975 120.031C151.697 118.954 153.054 117.509 154.044 115.698C155.035 113.844 155.53 111.774 155.53 109.489C155.53 107.161 155.035 105.091 154.044 103.28C153.054 101.426 151.697 99.9817 149.975 98.9468C148.252 97.8689 146.292 97.3299 144.096 97.3299C141.943 97.3299 139.983 97.8689 138.217 98.9468C136.495 99.9817 135.117 101.426 134.083 103.28C133.093 105.091 132.597 107.161 132.597 109.489C132.597 111.774 133.093 113.844 134.083 115.698C135.117 117.509 136.495 118.954 138.217 120.031C139.983 121.066 141.943 121.584 144.096 121.584Z", fill: Bt(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M188.354 127.469C185.383 127.469 182.713 126.844 180.344 125.594C178.019 124.3 176.167 122.425 174.789 119.967C173.454 117.509 172.786 114.491 172.786 110.912V95.0015C172.786 94.0529 173.088 93.2768 173.69 92.6732C174.336 92.0264 175.133 91.703 176.081 91.703C177.028 91.703 177.803 92.0264 178.406 92.6732C179.052 93.2768 179.375 94.0529 179.375 95.0015V110.912C179.375 113.327 179.827 115.332 180.732 116.927C181.636 118.479 182.864 119.643 184.414 120.42C185.964 121.153 187.708 121.519 189.646 121.519C191.498 121.519 193.135 121.153 194.556 120.42C196.02 119.687 197.183 118.695 198.044 117.444C198.906 116.194 199.336 114.793 199.336 113.24H203.406C203.406 115.914 202.739 118.328 201.403 120.484C200.111 122.64 198.324 124.343 196.042 125.594C193.802 126.844 191.24 127.469 188.354 127.469ZM202.631 127.146C201.683 127.146 200.887 126.844 200.241 126.24C199.638 125.594 199.336 124.796 199.336 123.847V95.0015C199.336 94.0098 199.638 93.2121 200.241 92.6085C200.887 92.0048 201.683 91.703 202.631 91.703C203.621 91.703 204.418 92.0048 205.021 92.6085C205.624 93.2121 205.925 94.0098 205.925 95.0015V123.847C205.925 124.796 205.624 125.594 205.021 126.24C204.418 126.844 203.621 127.146 202.631 127.146Z", fill: Bt(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M221.471 127.146C220.523 127.146 219.726 126.844 219.08 126.24C218.477 125.594 218.176 124.796 218.176 123.847V95.0662C218.176 94.0745 218.477 93.2768 219.08 92.6732C219.726 92.0695 220.523 91.7677 221.471 91.7677C222.461 91.7677 223.258 92.0695 223.861 92.6732C224.464 93.2768 224.765 94.0745 224.765 95.0662V123.847C224.765 124.796 224.464 125.594 223.861 126.24C223.258 126.844 222.461 127.146 221.471 127.146ZM221.471 86.0115C220.308 86.0115 219.296 85.6018 218.434 84.7826C217.616 83.9202 217.207 82.907 217.207 81.7428C217.207 80.5786 217.616 79.5869 218.434 78.7677C219.296 77.9053 220.308 77.4741 221.471 77.4741C222.633 77.4741 223.624 77.9053 224.442 78.7677C225.303 79.5869 225.734 80.5786 225.734 81.7428C225.734 82.907 225.303 83.9202 224.442 84.7826C223.624 85.6018 222.633 86.0115 221.471 86.0115Z", fill: Bt(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M245.421 127.146C243.526 127.146 241.847 126.629 240.382 125.594C238.918 124.559 237.777 123.158 236.959 121.39C236.14 119.579 235.731 117.509 235.731 115.181V79.8672C235.731 78.9186 236.033 78.1424 236.636 77.5388C237.239 76.9351 238.014 76.6333 238.961 76.6333C239.909 76.6333 240.684 76.9351 241.287 77.5388C241.89 78.1424 242.191 78.9186 242.191 79.8672V115.181C242.191 116.776 242.493 118.091 243.096 119.126C243.699 120.161 244.474 120.678 245.421 120.678H247.036C247.897 120.678 248.587 120.98 249.103 121.584C249.663 122.187 249.943 122.964 249.943 123.912C249.943 124.861 249.534 125.637 248.716 126.24C247.898 126.844 246.842 127.146 245.55 127.146H245.421Z", fill: Bt(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M260.331 127.146C259.384 127.146 258.587 126.844 257.941 126.24C257.338 125.594 257.036 124.796 257.036 123.847V95.0662C257.036 94.0745 257.338 93.2768 257.941 92.6732C258.587 92.0695 259.384 91.7677 260.331 91.7677C261.322 91.7677 262.118 92.0695 262.721 92.6732C263.324 93.2768 263.626 94.0745 263.626 95.0662V123.847C263.626 124.796 263.324 125.594 262.721 126.24C262.118 126.844 261.322 127.146 260.331 127.146ZM260.589 86.2055C259.642 86.2055 258.845 85.9037 258.199 85.3C257.596 84.6532 257.295 83.8556 257.295 82.907C257.295 82.0015 257.553 81.2685 258.07 80.708L264.401 74.3696C265.047 73.7229 265.822 73.3995 266.726 73.3995C267.717 73.3995 268.514 73.7229 269.116 74.3696C269.719 75.0164 270.021 75.8141 270.021 76.7627C270.021 77.1938 269.956 77.6035 269.827 77.9915C269.698 78.3796 269.461 78.7245 269.116 79.0264L262.85 85.3C262.247 85.9037 261.494 86.2055 260.589 86.2055Z", fill: Bt(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M293.648 127.405C290.289 127.405 287.275 126.629 284.605 125.076C281.934 123.481 279.824 121.325 278.274 118.609C276.724 115.892 275.927 112.831 275.884 109.424V79.9318C275.884 78.9401 276.185 78.1424 276.788 77.5388C277.434 76.9351 278.231 76.6333 279.178 76.6333C280.169 76.6333 280.965 76.9351 281.568 77.5388C282.171 78.1424 282.473 78.9401 282.473 79.9318V97.3946C283.98 95.5836 285.789 94.1607 287.899 93.1259C290.052 92.048 292.4 91.509 294.94 91.509C298.084 91.509 300.905 92.3067 303.403 93.902C305.901 95.4543 307.86 97.5886 309.281 100.305C310.746 102.978 311.478 106.018 311.478 109.424C311.478 112.831 310.681 115.892 309.088 118.609C307.537 121.325 305.427 123.481 302.757 125.076C300.087 126.629 297.051 127.405 293.648 127.405ZM293.648 121.584C295.845 121.584 297.804 121.066 299.527 120.031C301.25 118.954 302.606 117.488 303.597 115.633C304.63 113.779 305.147 111.71 305.147 109.424C305.147 107.096 304.63 105.026 303.597 103.216C302.606 101.405 301.25 99.9817 299.527 98.9468C297.804 97.8689 295.845 97.3299 293.648 97.3299C291.495 97.3299 289.536 97.8689 287.77 98.9468C286.047 99.9817 284.691 101.405 283.7 103.216C282.71 105.026 282.214 107.096 282.214 109.424C282.214 111.71 282.71 113.779 283.7 115.633C284.691 117.488 286.047 118.954 287.77 120.031C289.536 121.066 291.495 121.584 293.648 121.584Z", fill: Bt(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M324.47 105.026C324.47 102.439 325.095 100.133 326.344 98.106C327.636 96.0364 329.358 94.3979 331.512 93.1906C333.665 91.9833 336.034 91.3796 338.618 91.3796C341.201 91.3796 343.118 91.8108 344.367 92.6732C345.659 93.4924 346.154 94.4841 345.853 95.6483C345.723 96.252 345.465 96.7263 345.077 97.0712C344.733 97.373 344.324 97.5671 343.85 97.6533C343.376 97.7395 342.86 97.718 342.3 97.5886C339.543 97.0281 337.067 96.985 334.871 97.4593C332.674 97.9336 330.93 98.8175 329.638 100.111C328.389 101.405 327.765 103.043 327.765 105.026H324.47ZM324.535 127.146C323.501 127.146 322.705 126.887 322.145 126.37C321.585 125.809 321.305 124.99 321.305 123.912V95.0015C321.305 93.9667 321.585 93.169 322.145 92.6085C322.705 92.048 323.501 91.7677 324.535 91.7677C325.612 91.7677 326.408 92.048 326.925 92.6085C327.485 93.1259 327.765 93.9236 327.765 95.0015V123.912C327.765 124.947 327.485 125.745 326.925 126.305C326.408 126.866 325.612 127.146 324.535 127.146Z", fill: Bt(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M356.662 127.146C355.714 127.146 354.918 126.844 354.272 126.24C353.669 125.594 353.367 124.796 353.367 123.847V95.0662C353.367 94.0745 353.669 93.2768 354.272 92.6732C354.918 92.0695 355.714 91.7677 356.662 91.7677C357.652 91.7677 358.449 92.0695 359.052 92.6732C359.655 93.2768 359.956 94.0745 359.956 95.0662V123.847C359.956 124.796 359.655 125.594 359.052 126.24C358.449 126.844 357.652 127.146 356.662 127.146ZM356.662 86.0115C355.499 86.0115 354.487 85.6018 353.626 84.7826C352.807 83.9202 352.398 82.907 352.398 81.7428C352.398 80.5786 352.807 79.5869 353.626 78.7677C354.487 77.9053 355.499 77.4741 356.662 77.4741C357.825 77.4741 358.815 77.9053 359.633 78.7677C360.495 79.5869 360.925 80.5786 360.925 81.7428C360.925 82.907 360.495 83.9202 359.633 84.7826C358.815 85.6018 357.825 86.0115 356.662 86.0115Z", fill: Bt(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M388.235 127.405C384.747 127.405 381.668 126.65 378.998 125.141C376.327 123.589 374.217 121.476 372.667 118.803C371.159 116.086 370.406 112.982 370.406 109.489C370.406 105.953 371.159 102.849 372.667 100.176C374.217 97.4593 376.327 95.3465 378.998 93.8374C381.668 92.2851 384.747 91.509 388.235 91.509C391.68 91.509 394.738 92.2851 397.408 93.8374C400.078 95.3465 402.167 97.4593 403.674 100.176C405.225 102.849 406 105.953 406 109.489C406 112.982 405.246 116.086 403.739 118.803C402.232 121.476 400.143 123.589 397.473 125.141C394.803 126.65 391.724 127.405 388.235 127.405ZM388.235 121.584C390.475 121.584 392.456 121.066 394.178 120.031C395.901 118.997 397.236 117.574 398.183 115.763C399.174 113.952 399.669 111.861 399.669 109.489C399.669 107.118 399.174 105.026 398.183 103.216C397.236 101.361 395.901 99.917 394.178 98.8822C392.456 97.8473 390.475 97.3299 388.235 97.3299C385.996 97.3299 384.015 97.8473 382.292 98.8822C380.569 99.917 379.213 101.361 378.222 103.216C377.232 105.026 376.737 107.118 376.737 109.489C376.737 111.861 377.232 113.952 378.222 115.763C379.213 117.574 380.569 118.997 382.292 120.031C384.015 121.066 385.996 121.584 388.235 121.584Z", fill: Bt(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", { id: "clip0_1485_17803", children: /* @__PURE__ */ m("rect", { width: 406, height: 65.3995, fill: "white" }) }) })
  ] });
}, en = (e) => ({
  colorful: {
    primaryTextColor: "#1900AF",
    secondaryTextColor: "#FF646E"
  },
  "colorful-inverse": {
    primaryTextColor: e.colors.background.white,
    secondaryTextColor: "#FF646E"
  },
  neutral: {
    primaryTextColor: e.colors.background.white,
    secondaryTextColor: e.colors.background.white
  }
}), H5e = ({
  base: e,
  inverse: r,
  width: t = 406,
  height: n = 127,
  ...o
}) => {
  const a = ur(), i = Je(() => r && e === "colorful" ? `${e}-inverse` : `${e}`, [e, r]);
  return /* @__PURE__ */ Y("svg", { width: t, height: n, viewBox: "0 0 406 127", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...o, children: [
    /* @__PURE__ */ m("g", { clipPath: "url(#clip0_1485_17813)", children: /* @__PURE__ */ m("path", { d: "M33.5578 13.3225C39.6817 13.3225 44.9487 15.5211 49.233 20.049L58.2905 10.6406C58.2953 10.6358 58.2953 10.6309 58.2905 10.6261C51.6728 3.54203 43.477 0 33.5578 0C24.1227 0 16.1641 3.17478 9.67231 9.4132C3.18054 15.6468 0 23.3494 0 32.6418C0 41.9293 3.18054 49.7527 9.67231 55.9911C16.1641 62.2296 24.1227 65.2835 33.5578 65.2835C43.477 65.2835 51.6728 61.7415 58.2953 54.6526C58.3001 54.6478 58.3001 54.6429 58.2953 54.6381L49.233 45.2346C44.9438 49.7527 39.6817 51.9562 33.5578 51.9562C28.1649 51.9562 23.6338 50.12 19.9643 46.4523C16.4061 42.7846 14.5714 38.1409 14.5714 32.6418C14.5714 27.1378 16.4061 22.4941 19.9643 18.8264C23.6338 15.1539 28.1601 13.3225 33.5578 13.3225ZM172.306 0.729668C163.49 0.729668 156.509 4.75975 153.566 10.7517V1.95222H138.995V63.5681H153.566V28.114C153.566 19.6769 159.569 13.8105 167.896 13.8105C176.101 13.8105 181 19.068 181 27.5051V63.5681H195.697V25.4224C195.697 10.1429 187.003 0.729668 172.306 0.729668ZM95.2079 0.120806C85.7728 0.120806 77.8142 3.30042 71.3224 9.534C64.8307 15.7724 61.5291 23.5958 61.5291 32.7626C61.5291 41.9293 64.8307 49.7527 71.3224 55.9911C77.8142 62.2296 85.7728 65.4043 95.2079 65.4043C104.643 65.4043 112.602 62.2296 119.093 55.9911C125.585 49.7527 128.887 41.9293 128.887 32.7626C128.887 23.5958 125.585 15.7676 119.089 9.52917C112.597 3.30042 104.643 0.120806 95.2079 0.120806ZM108.801 46.5779C105.132 50.2456 100.596 52.077 95.2079 52.077C89.694 52.077 85.1677 50.2456 81.4982 46.5779C77.9401 42.7846 76.1053 38.2665 76.1053 32.7626C76.1053 27.2635 77.9401 22.7405 81.4982 19.068C85.1677 15.2795 89.694 13.4433 95.2079 13.4433C100.591 13.4433 105.132 15.2795 108.801 19.068C112.481 22.7357 114.315 27.2587 114.315 32.7626C114.315 38.2665 112.481 42.7846 108.801 46.5779ZM329.967 1.95222H313.919L300.578 20.4114L287.105 1.95222H271.178L292.488 31.0471L269.092 63.5681H284.898L300.573 41.8085L316.248 63.5681H332.044L308.657 30.9263L329.967 1.95222ZM405.923 52.1978L402.936 52.2027C399.624 52.2027 398.409 50.2456 398.409 44.9881V1.95222H383.712V10.8822C381.388 5.01586 373.909 0.608862 363.995 0.608862C355.3 0.608862 347.947 3.66284 341.944 9.90125C336.062 16.014 333.128 23.5958 333.128 32.7626C333.128 41.9293 336.062 49.5111 341.944 55.7495C347.947 61.9879 355.295 65.0419 363.995 65.0419C373.788 65.0419 380.89 61.8623 385.174 55.3823C385.794 58.5619 387.507 61.007 390.199 62.8433C392.402 64.1866 395.214 64.8003 398.768 64.8003C401.958 64.8003 404.398 64.4331 405.995 63.8194C406 63.8194 406 63.8145 406 63.8145V52.2751C406 52.2317 405.966 52.1978 405.923 52.1978ZM379.302 46.2059C375.753 49.7479 371.213 51.5841 365.95 51.5841C360.683 51.5841 356.399 49.7479 352.846 46.2059C349.414 42.6638 347.7 38.136 347.7 32.7577C347.7 27.3843 349.414 22.8565 352.846 19.3096C356.394 15.7676 360.683 13.9362 365.95 13.9362C371.217 13.9362 375.753 15.7676 379.302 19.3096C382.971 22.8565 384.806 27.3843 384.806 32.7577C384.806 38.1409 382.971 42.6638 379.302 46.2059ZM237.77 0.241612C228.335 0.241612 220.629 3.17478 214.505 9.16675C208.502 15.1539 205.442 22.9773 205.442 32.7577V33.2458C205.442 42.9054 208.502 50.608 214.505 56.3536C220.498 62.0991 228.466 65.0322 238.138 65.0322C248.547 65.0322 257.11 61.3646 264.091 54.0341C264.096 54.0292 264.096 54.0244 264.091 54.0196L255.28 45.4714C250.502 50.2408 244.998 52.5602 238.627 52.5602C227.725 52.5602 220.498 46.2059 220.009 36.4254H268.017C268.148 34.8356 268.269 33.125 268.269 31.2936C268.269 22.4892 265.456 15.1539 259.691 9.16675C254.056 3.17478 246.717 0.241612 237.77 0.241612ZM220.382 26.1617C220.75 22.3684 222.584 19.1936 225.896 16.6277C229.197 14.0618 233.244 12.7136 237.77 12.7136C242.06 12.7136 245.608 14.057 248.672 16.7485C251.732 19.3096 253.329 22.4941 253.329 26.1617H220.382Z", fill: en(a)[i].primaryTextColor }) }),
    /* @__PURE__ */ m("path", { d: "M105.81 126.329C101.964 126.329 98.5348 125.513 95.5227 123.88C92.557 122.201 90.2169 119.915 88.5023 117.023C86.8341 114.084 86 110.725 86 106.947C86 103.121 86.7878 99.7625 88.3633 96.8702C89.9852 93.9313 92.2095 91.6454 95.0361 90.0127C97.8628 88.3333 101.107 87.4936 104.767 87.4936C108.382 87.4936 111.487 88.31 114.082 89.9427C116.677 91.5288 118.646 93.7447 119.99 96.5903C121.38 99.3893 122.075 102.631 122.075 106.317C122.075 107.203 121.774 107.95 121.171 108.556C120.569 109.116 119.804 109.396 118.878 109.396H90.8656V103.798H118.669L115.819 105.757C115.773 103.424 115.31 101.349 114.429 99.5292C113.549 97.6633 112.297 96.1938 110.676 95.1208C109.054 94.0479 107.084 93.5114 104.767 93.5114C102.126 93.5114 99.8554 94.0946 97.9555 95.2608C96.1019 96.427 94.6886 98.0365 93.7155 100.089C92.7424 102.095 92.2558 104.381 92.2558 106.947C92.2558 109.512 92.835 111.798 93.9935 113.804C95.152 115.81 96.7507 117.396 98.7896 118.562C100.829 119.729 103.169 120.312 105.81 120.312C107.247 120.312 108.706 120.055 110.189 119.542C111.718 118.982 112.946 118.352 113.873 117.653C114.568 117.14 115.31 116.883 116.097 116.883C116.931 116.836 117.65 117.07 118.252 117.583C119.04 118.282 119.457 119.052 119.503 119.892C119.55 120.732 119.179 121.455 118.391 122.061C116.816 123.321 114.846 124.347 112.483 125.14C110.166 125.933 107.942 126.329 105.81 126.329Z", fill: en(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M155.705 126.05C155.241 126.05 154.801 125.98 154.384 125.84C153.967 125.7 153.573 125.397 153.203 124.93L141.038 110.235L138.536 107.716L126.442 93.3015C125.839 92.5551 125.515 91.7621 125.469 90.9224C125.422 90.036 125.654 89.2896 126.164 88.6832C126.673 88.0767 127.438 87.7735 128.457 87.7735C129.57 87.7735 130.45 88.17 131.099 88.9631L142.985 103.238L144.792 104.917L157.86 120.662C158.555 121.501 158.879 122.341 158.833 123.181C158.833 123.974 158.532 124.65 157.929 125.21C157.373 125.77 156.632 126.05 155.705 126.05ZM129.152 126.05C128.226 126.05 127.484 125.77 126.928 125.21C126.418 124.603 126.164 123.88 126.164 123.041C126.164 122.201 126.488 121.361 127.137 120.522L138.953 105.617L142.707 110.935L131.655 124.93C130.96 125.676 130.126 126.05 129.152 126.05ZM146.321 108.066L141.525 103.938L152.716 88.9631C153.087 88.4966 153.481 88.1934 153.898 88.0534C154.315 87.8668 154.778 87.7735 155.288 87.7735C156.307 87.7735 157.072 88.1001 157.582 88.7532C158.091 89.3596 158.323 90.106 158.277 90.9923C158.277 91.8787 157.952 92.7417 157.304 93.5814L146.321 108.066Z", fill: en(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M181.481 126.329C177.774 126.329 174.461 125.49 171.541 123.81C168.668 122.084 166.398 119.775 164.73 116.883C163.108 113.944 162.297 110.632 162.297 106.947C162.297 103.168 163.108 99.8091 164.73 96.8702C166.351 93.9313 168.576 91.6454 171.402 90.0127C174.229 88.3333 177.473 87.4936 181.134 87.4936C183.868 87.4936 186.37 88.0301 188.641 89.103C190.911 90.1293 192.95 91.6921 194.757 93.7913C195.406 94.5377 195.638 95.3074 195.452 96.1005C195.267 96.8935 194.757 97.5933 193.923 98.1997C193.274 98.6662 192.556 98.8295 191.768 98.6896C190.981 98.503 190.262 98.0831 189.614 97.43C187.343 95.0042 184.516 93.7913 181.134 93.7913C178.77 93.7913 176.685 94.3511 174.878 95.4707C173.071 96.5437 171.657 98.0598 170.638 100.019C169.618 101.978 169.109 104.288 169.109 106.947C169.109 109.466 169.618 111.705 170.638 113.664C171.704 115.623 173.163 117.186 175.017 118.352C176.87 119.472 179.025 120.032 181.481 120.032C183.103 120.032 184.516 119.845 185.721 119.472C186.972 119.052 188.108 118.422 189.127 117.583C189.869 116.976 190.633 116.65 191.421 116.603C192.209 116.51 192.904 116.72 193.506 117.233C194.294 117.886 194.734 118.632 194.827 119.472C194.92 120.265 194.642 120.988 193.993 121.641C190.656 124.767 186.486 126.329 181.481 126.329Z", fill: en(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M215.025 126.05C212.986 126.05 211.179 125.49 209.603 124.37C208.028 123.251 206.8 121.735 205.919 119.822C205.039 117.863 204.599 115.623 204.599 113.104V74.8982C204.599 73.8719 204.923 73.0322 205.572 72.3791C206.221 71.726 207.055 71.3995 208.074 71.3995C209.094 71.3995 209.928 71.726 210.577 72.3791C211.225 73.0322 211.55 73.8719 211.55 74.8982V113.104C211.55 114.83 211.874 116.253 212.523 117.373C213.172 118.492 214.006 119.052 215.025 119.052H216.763C217.69 119.052 218.431 119.379 218.987 120.032C219.59 120.685 219.891 121.525 219.891 122.551C219.891 123.577 219.451 124.417 218.57 125.07C217.69 125.723 216.554 126.05 215.164 126.05H215.025Z", fill: en(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M242.815 126.399C239.618 126.399 236.745 125.723 234.196 124.37C231.694 122.971 229.701 120.941 228.218 118.282C226.782 115.623 226.063 112.358 226.063 108.486V91.2722C226.063 90.246 226.388 89.4063 227.037 88.7532C227.732 88.0534 228.589 87.7035 229.608 87.7035C230.628 87.7035 231.462 88.0534 232.111 88.7532C232.806 89.4063 233.153 90.246 233.153 91.2722V108.486C233.153 111.098 233.64 113.268 234.613 114.994C235.586 116.673 236.907 117.933 238.575 118.772C240.243 119.565 242.12 119.962 244.205 119.962C246.198 119.962 247.959 119.565 249.488 118.772C251.063 117.979 252.315 116.906 253.241 115.553C254.168 114.201 254.632 112.684 254.632 111.005H259.011C259.011 113.897 258.292 116.51 256.856 118.842C255.466 121.175 253.543 123.017 251.087 124.37C248.677 125.723 245.92 126.399 242.815 126.399ZM258.177 126.05C257.157 126.05 256.3 125.723 255.605 125.07C254.956 124.37 254.632 123.507 254.632 122.481V91.2722C254.632 90.1993 254.956 89.3363 255.605 88.6832C256.3 88.0301 257.157 87.7035 258.177 87.7035C259.242 87.7035 260.1 88.0301 260.748 88.6832C261.397 89.3363 261.721 90.1993 261.721 91.2722V122.481C261.721 123.507 261.397 124.37 260.748 125.07C260.1 125.723 259.242 126.05 258.177 126.05Z", fill: en(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M288.04 126.329C284.797 126.329 281.785 125.84 279.004 124.86C276.27 123.834 274.139 122.551 272.609 121.011C271.914 120.265 271.613 119.425 271.706 118.492C271.845 117.513 272.308 116.72 273.096 116.113C274.023 115.367 274.926 115.064 275.807 115.204C276.734 115.297 277.521 115.693 278.17 116.393C278.958 117.279 280.209 118.119 281.924 118.912C283.684 119.659 285.631 120.032 287.762 120.032C290.45 120.032 292.489 119.589 293.879 118.702C295.316 117.816 296.057 116.673 296.103 115.274C296.15 113.874 295.478 112.661 294.088 111.635C292.744 110.609 290.265 109.769 286.65 109.116C281.97 108.183 278.564 106.783 276.432 104.917C274.347 103.051 273.304 100.765 273.304 98.0598C273.304 95.6806 274 93.7214 275.39 92.1819C276.78 90.5958 278.564 89.4296 280.742 88.6832C282.92 87.8901 285.19 87.4936 287.554 87.4936C290.612 87.4936 293.323 87.9834 295.686 88.9631C298.05 89.9427 299.926 91.2956 301.316 93.0216C301.965 93.768 302.266 94.5611 302.22 95.4007C302.174 96.1938 301.78 96.8702 301.038 97.43C300.297 97.9432 299.417 98.1064 298.397 97.9198C297.378 97.7332 296.52 97.3134 295.825 96.6603C294.667 95.5407 293.416 94.771 292.072 94.3511C290.728 93.9313 289.176 93.7214 287.415 93.7214C285.376 93.7214 283.638 94.0712 282.202 94.771C280.811 95.4707 280.116 96.497 280.116 97.8499C280.116 98.6896 280.325 99.4593 280.742 100.159C281.205 100.812 282.086 101.419 283.383 101.978C284.681 102.492 286.581 103.005 289.083 103.518C292.558 104.218 295.292 105.104 297.285 106.177C299.324 107.25 300.784 108.509 301.664 109.955C302.544 111.355 302.985 112.988 302.985 114.854C302.985 117 302.405 118.936 301.247 120.662C300.135 122.388 298.467 123.764 296.242 124.79C294.064 125.816 291.33 126.329 288.04 126.329Z", fill: en(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M316.189 126.05C315.17 126.05 314.312 125.723 313.617 125.07C312.969 124.37 312.644 123.507 312.644 122.481V91.3422C312.644 90.2693 312.969 89.4063 313.617 88.7532C314.312 88.1001 315.17 87.7735 316.189 87.7735C317.255 87.7735 318.112 88.1001 318.761 88.7532C319.41 89.4063 319.734 90.2693 319.734 91.3422V122.481C319.734 123.507 319.41 124.37 318.761 125.07C318.112 125.723 317.255 126.05 316.189 126.05ZM316.189 81.5458C314.938 81.5458 313.849 81.1026 312.922 80.2163C312.042 79.2833 311.602 78.187 311.602 76.9275C311.602 75.6679 312.042 74.595 312.922 73.7086C313.849 72.7756 314.938 72.3091 316.189 72.3091C317.44 72.3091 318.506 72.7756 319.387 73.7086C320.313 74.595 320.777 75.6679 320.777 76.9275C320.777 78.187 320.313 79.2833 319.387 80.2163C318.506 81.1026 317.44 81.5458 316.189 81.5458Z", fill: en(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M345.783 125.98C344.347 125.98 343.234 125.21 342.447 123.67L327.711 92.3918C327.34 91.5988 327.294 90.8291 327.572 90.0827C327.896 89.2896 328.499 88.6832 329.379 88.2633C330.167 87.8435 330.955 87.7735 331.742 88.0534C332.576 88.3333 333.202 88.8698 333.619 89.6628L347.382 119.542H344.045L357.669 89.6628C358.086 88.8698 358.712 88.3333 359.546 88.0534C360.426 87.7735 361.307 87.8435 362.187 88.2633C363.021 88.6365 363.577 89.2197 363.855 90.0127C364.133 90.8057 364.087 91.5988 363.716 92.3918L348.981 123.67C348.285 125.21 347.22 125.98 345.783 125.98Z", fill: en(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M385.495 126.329C382.112 126.329 379.077 125.49 376.389 123.81C373.702 122.084 371.57 119.775 369.994 116.883C368.465 113.944 367.701 110.632 367.701 106.947C367.701 103.261 368.535 99.9491 370.203 97.0102C371.918 94.0712 374.211 91.7621 377.084 90.0827C380.004 88.3566 383.271 87.4936 386.885 87.4936C390.5 87.4936 393.743 88.3566 396.616 90.0827C399.489 91.7621 401.76 94.0712 403.428 97.0102C405.143 99.9491 406 103.261 406 106.947H403.289C403.289 110.632 402.501 113.944 400.926 116.883C399.397 119.775 397.288 122.084 394.601 123.81C391.913 125.49 388.878 126.329 385.495 126.329ZM386.885 120.032C389.248 120.032 391.357 119.472 393.21 118.352C395.064 117.186 396.524 115.623 397.589 113.664C398.655 111.658 399.188 109.419 399.188 106.947C399.188 104.427 398.655 102.188 397.589 100.229C396.524 98.2231 395.064 96.6603 393.21 95.5407C391.357 94.3745 389.248 93.7913 386.885 93.7913C384.568 93.7913 382.46 94.3745 380.56 95.5407C378.706 96.6603 377.223 98.2231 376.111 100.229C375.045 102.188 374.512 104.427 374.512 106.947C374.512 109.419 375.045 111.658 376.111 113.664C377.223 115.623 378.706 117.186 380.56 118.352C382.46 119.472 384.568 120.032 386.885 120.032ZM402.455 126.12C401.436 126.12 400.578 125.793 399.883 125.14C399.234 124.44 398.91 123.577 398.91 122.551V111.845L400.231 104.427L406 106.947V122.551C406 123.577 405.652 124.44 404.957 125.14C404.309 125.793 403.474 126.12 402.455 126.12Z", fill: en(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", { id: "clip0_1485_17813", children: /* @__PURE__ */ m("rect", { width: 406, height: 65.3995, fill: "white" }) }) })
  ] });
}, Ht = (e) => ({
  colorful: {
    primaryTextColor: "#1900AF",
    secondaryTextColor: e.colors.feedback.information[300]
  },
  "colorful-inverse": {
    primaryTextColor: e.colors.background.white,
    secondaryTextColor: e.colors.feedback.information[300]
  },
  neutral: {
    primaryTextColor: e.colors.background.white,
    secondaryTextColor: e.colors.background.white
  }
}), G5e = ({
  base: e,
  inverse: r,
  width: t = 405,
  height: n = 140,
  ...o
}) => {
  const a = ur(), i = Je(() => r && e === "colorful" ? `${e}-inverse` : `${e}`, [e, r]);
  return /* @__PURE__ */ Y("svg", { width: t, height: n, viewBox: "0 0 405 140", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...o, children: [
    /* @__PURE__ */ m("path", { d: "M33.4764 13.2951C39.5834 13.2951 44.8378 15.4923 49.1169 20.0038L58.1548 10.6137C58.1601 10.6084 58.1601 10.6031 58.1548 10.6031C51.5469 3.53259 43.3723 0 33.4764 0C24.0655 0 16.1254 3.17082 9.65072 9.39009C3.17072 15.6147 0 23.2917 0 32.5647C0 41.8325 3.17072 49.6372 9.65072 55.8618C16.1254 62.0863 24.0655 65.1348 33.4764 65.1348C43.3723 65.1348 51.5469 61.6022 58.1495 54.5317C58.1548 54.5264 58.1548 54.5211 58.1495 54.5211L49.1116 45.131C44.8324 49.6372 39.5834 51.8397 33.4711 51.8397C28.0889 51.8397 23.5753 50.0096 19.9143 46.3493C16.3652 42.689 14.532 38.0552 14.532 32.5701C14.532 27.0797 16.3599 22.4458 19.9143 18.7855C23.5753 15.1199 28.0942 13.2951 33.4764 13.2951ZM171.88 0.728863C163.087 0.728863 156.122 4.75091 153.186 10.7308V1.94718H138.654V63.4217H153.186V28.0532C153.186 19.6367 159.176 13.7792 167.483 13.7792C175.669 13.7792 180.555 19.0249 180.555 27.4414V63.4217H195.221V25.3666C195.221 10.119 186.545 0.728863 171.88 0.728863ZM94.9725 0.117044C85.5616 0.117044 77.6214 3.28786 71.1468 9.50714C64.6721 15.7317 61.3788 23.5364 61.3788 32.6818C61.3788 41.8272 64.6721 49.6372 71.1468 55.8564C77.6214 62.081 85.5616 65.2465 94.9725 65.2465C104.383 65.2465 112.324 62.081 118.798 55.8564C125.273 49.6318 128.566 41.8272 128.566 32.6818C128.566 23.5364 125.273 15.7264 118.798 9.50714C112.324 3.29318 104.383 0.117044 94.9725 0.117044ZM108.529 46.4717C104.868 50.1319 100.344 51.9568 94.9725 51.9568C89.473 51.9568 84.9541 50.1319 81.2931 46.4717C77.744 42.689 75.9109 38.1775 75.9109 32.6871C75.9109 27.202 77.7387 22.6852 81.2931 19.0249C84.9541 15.2476 89.4677 13.4121 94.9725 13.4121C100.344 13.4121 104.868 15.2423 108.529 19.0249C112.201 22.6852 114.029 27.1967 114.029 32.6871C114.034 38.1775 112.201 42.6837 108.529 46.4717ZM329.158 1.94718H313.15L299.839 20.3656L286.399 1.94718H270.513L291.771 30.9793L268.435 63.427H284.203L299.844 41.7154L315.484 63.427H331.242L307.896 30.857L329.158 1.94718ZM404.925 52.0791L401.947 52.0844C398.643 52.0844 397.428 50.1319 397.428 44.8862V1.94718H382.762V10.8531C380.444 5.00096 372.984 0.601179 363.093 0.601179C354.418 0.601179 347.085 3.64963 341.101 9.87423C335.233 15.9711 332.308 23.5364 332.308 32.6818C332.308 41.8272 335.233 49.3924 341.101 55.6117C347.09 61.8363 354.423 64.8848 363.093 64.8848C372.861 64.8848 379.943 61.7139 384.222 55.2446C384.841 58.4154 386.551 60.8574 389.237 62.6875C391.438 64.0282 394.241 64.64 397.785 64.64C400.966 64.64 403.401 64.2729 404.995 63.6611L405 63.6558V52.1483C405 52.111 404.968 52.0791 404.925 52.0791ZM378.371 46.1046C374.828 49.6425 370.303 51.4726 365.049 51.4726C359.795 51.4726 355.521 49.6425 351.977 46.1046C348.556 42.5667 346.845 38.0552 346.845 32.6871C346.845 27.3244 348.556 22.8076 351.977 19.2696C355.521 15.7317 359.795 13.9069 365.049 13.9069C370.303 13.9069 374.828 15.7317 378.371 19.2696C382.032 22.8129 383.86 27.3244 383.86 32.6871C383.86 38.0552 382.032 42.5667 378.371 46.1046ZM237.186 0.244728C227.775 0.244728 220.086 3.17082 213.979 9.15069C207.989 15.1252 204.935 22.9299 204.935 32.6871V33.1712C204.935 42.8114 207.989 50.4937 213.979 56.2288C219.958 61.9587 227.908 64.8901 237.554 64.8901C247.935 64.8901 256.477 61.2351 263.442 53.9199C263.447 53.9146 263.447 53.9093 263.442 53.9039L254.654 45.3757C249.89 50.1319 244.396 52.4462 238.044 52.4462C227.173 52.4462 219.958 46.1046 219.473 36.3474H267.364C267.492 34.762 267.614 33.0542 267.614 31.2294C267.614 22.4458 264.811 15.1252 259.061 9.15069C253.434 3.17082 246.112 0.244728 237.186 0.244728ZM219.84 26.1007C220.208 22.3181 222.041 19.1473 225.34 16.5883C228.633 14.024 232.673 12.6833 237.186 12.6833C241.465 12.6833 245.004 14.024 248.057 16.7106C251.111 19.2696 252.704 22.4405 252.704 26.1007H219.84Z", fill: Ht(a)[i].primaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M12.992 88.1605C11.9635 87.1603 11.4519 85.9632 11.4519 84.5747C11.4519 83.1861 11.9635 81.9944 12.992 80.9889C14.0205 79.9887 15.2408 79.4833 16.6636 79.4833C18.0864 79.4833 19.3068 79.9834 20.3353 80.9889C21.3637 81.9891 21.8753 83.1861 21.8753 84.5747C21.8753 85.9632 21.3637 87.155 20.3353 88.1605C19.3068 89.1607 18.0864 89.6661 16.6636 89.6661C15.2408 89.6661 14.0151 89.1607 12.992 88.1605Z", fill: Ht(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M13.7807 137.574C13.0187 136.829 12.635 135.893 12.635 134.76V100.455C12.635 99.2743 13.0187 98.322 13.7807 97.6038C14.5428 96.8856 15.502 96.5238 16.6637 96.5238C17.8734 96.5238 18.8486 96.8856 19.584 97.6038C20.3194 98.322 20.687 99.2743 20.687 100.455V134.76C20.687 135.893 20.3194 136.829 19.584 137.574C18.8432 138.319 17.8734 138.691 16.6637 138.691C15.502 138.691 14.5428 138.319 13.7807 137.574Z", fill: Ht(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M92.1855 100.535C94.9992 103.467 96.4113 107.552 96.4113 112.793V134.84C96.4113 135.973 96.0436 136.909 95.3029 137.654C94.5675 138.399 93.5923 138.771 92.3827 138.771C91.2263 138.771 90.2617 138.399 89.4997 137.654C88.7377 136.909 88.354 135.973 88.354 134.84V112.793C88.354 109.659 87.5493 107.281 85.9453 105.664C84.3413 104.046 82.1937 103.232 79.5079 103.232C76.7688 103.232 74.52 104.158 72.7561 106.01C70.9923 107.861 70.113 110.223 70.113 113.101V134.84C70.113 135.973 69.7453 136.909 69.0099 137.654C68.2692 138.399 67.2993 138.771 66.0896 138.771C64.9332 138.771 63.9687 138.399 63.2067 137.654C62.4446 136.909 62.0609 135.973 62.0609 134.84V112.793C62.0609 109.659 61.2563 107.281 59.6523 105.664C58.0483 104.046 55.9007 103.232 53.2202 103.232C50.4279 103.232 48.1524 104.158 46.3885 106.01C44.6246 107.861 43.7454 110.223 43.7454 113.101V134.84C43.7454 135.973 43.3777 136.909 42.6369 137.654C41.9015 138.399 40.9263 138.771 39.7167 138.771C38.5603 138.771 37.5958 138.399 36.8337 137.654C36.0717 136.909 35.688 135.973 35.688 134.84V100.535C35.688 99.3541 36.0717 98.4018 36.8337 97.6836C37.5958 96.9653 38.555 96.6036 39.7167 96.6036C40.8731 96.6036 41.8216 96.9494 42.557 97.6463C43.2924 98.3433 43.6867 99.253 43.74 100.381C45.1096 99.0455 46.7402 98.0081 48.6373 97.2579C50.5344 96.5131 52.5861 96.1407 54.7976 96.1407C57.4834 96.1407 59.8921 96.6674 62.0236 97.7208C64.1552 98.7742 65.9031 100.28 67.2727 102.232C68.85 100.333 70.8271 98.838 73.1931 97.7634C75.5645 96.6834 78.1917 96.146 81.0906 96.146C85.6682 96.1407 89.3665 97.6038 92.1855 100.535Z", fill: Ht(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M147.495 119.379C146.812 120.023 145.944 120.342 144.889 120.342H114.881C115.462 123.939 117.13 126.843 119.896 129.051C122.656 131.259 126.04 132.366 130.042 132.366C131.625 132.366 133.266 132.084 134.977 131.52C136.687 130.956 138.094 130.259 139.203 129.44C139.938 128.876 140.807 128.594 141.809 128.594C142.81 128.594 143.599 128.849 144.175 129.365C145.123 130.137 145.597 131.009 145.597 131.988C145.597 132.914 145.176 133.685 144.334 134.302C142.544 135.691 140.322 136.819 137.663 137.697C135.003 138.569 132.462 139.005 130.042 139.005C125.726 139.005 121.857 138.096 118.436 136.265C115.015 134.441 112.339 131.908 110.421 128.674C108.497 125.439 107.538 121.763 107.538 117.65C107.538 113.538 108.449 109.851 110.261 106.59C112.078 103.328 114.604 100.78 117.839 98.9604C121.074 97.1356 124.745 96.2205 128.854 96.2205C132.909 96.2205 136.405 97.0983 139.357 98.8434C142.304 100.594 144.569 103.036 146.146 106.164C147.724 109.297 148.512 112.899 148.512 116.959C148.523 117.927 148.182 118.741 147.495 119.379ZM119.507 105.93C117.109 107.983 115.601 110.734 114.967 114.176H141.26C140.785 110.734 139.469 107.983 137.311 105.93C135.153 103.876 132.334 102.844 128.859 102.844C125.017 102.844 121.9 103.876 119.507 105.93Z", fill: Ht(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M197.395 79.5631C198.13 80.2866 198.503 81.2336 198.503 82.4147V117.565C198.503 121.571 197.544 125.21 195.62 128.471C193.697 131.738 191.091 134.308 187.803 136.18C184.51 138.058 180.838 138.995 176.788 138.995C172.733 138.995 169.034 138.058 165.693 136.18C162.352 134.308 159.73 131.738 157.838 128.471C155.941 125.21 154.998 121.571 154.998 117.565C154.998 113.559 155.877 109.92 157.641 106.659C159.405 103.397 161.824 100.838 164.904 98.987C167.984 97.1356 171.416 96.2099 175.205 96.2099C178.259 96.2099 181.099 96.827 183.731 98.0613C186.364 99.2956 188.602 101.014 190.441 103.227V82.4147C190.441 81.2336 190.824 80.2813 191.586 79.5631C192.348 78.8449 193.308 78.4831 194.469 78.4831C195.684 78.4884 196.66 78.8449 197.395 79.5631ZM183.934 130.174C186.066 128.913 187.734 127.179 188.949 124.971C190.158 122.763 190.766 120.294 190.766 117.57C190.766 114.846 190.158 112.394 188.949 110.207C187.739 108.026 186.066 106.302 183.934 105.041C181.802 103.78 179.42 103.153 176.788 103.153C174.155 103.153 171.773 103.78 169.642 105.041C167.51 106.302 165.826 108.021 164.59 110.207C163.354 112.394 162.735 114.846 162.735 117.57C162.735 120.294 163.354 122.763 164.59 124.971C165.826 127.179 167.51 128.913 169.642 130.174C171.773 131.435 174.155 132.062 176.788 132.062C179.42 132.062 181.802 131.435 183.934 130.174Z", fill: Ht(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M213.861 88.1605C212.833 87.1603 212.321 85.9632 212.321 84.5747C212.321 83.1861 212.833 81.9944 213.861 80.9889C214.89 79.9887 216.11 79.4833 217.533 79.4833C218.956 79.4833 220.176 79.9834 221.205 80.9889C222.233 81.9891 222.745 83.1861 222.745 84.5747C222.745 85.9632 222.233 87.155 221.205 88.1605C220.176 89.1607 218.956 89.6661 217.533 89.6661C216.11 89.6661 214.89 89.1607 213.861 88.1605ZM214.65 137.574C213.888 136.829 213.504 135.893 213.504 134.76V100.455C213.504 99.2743 213.888 98.322 214.65 97.6038C215.412 96.8855 216.371 96.5238 217.533 96.5238C218.743 96.5238 219.718 96.8855 220.453 97.6038C221.189 98.322 221.556 99.2743 221.556 100.455V134.76C221.556 135.893 221.189 136.829 220.453 137.574C219.713 138.319 218.743 138.691 217.533 138.691C216.371 138.691 215.412 138.319 214.65 137.574Z", fill: Ht(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M244.929 136.223C241.614 134.371 239.019 131.818 237.154 128.551C235.284 125.29 234.351 121.651 234.351 117.645C234.351 113.532 235.262 109.845 237.074 106.584C238.886 103.323 241.428 100.775 244.695 98.9551C247.956 97.1303 251.644 96.2152 255.747 96.2152C261.955 96.2152 267.119 98.5295 271.222 103.153C271.75 103.717 272.011 104.387 272.011 105.158C272.011 106.292 271.43 107.239 270.274 108.01C269.746 108.366 269.138 108.547 268.456 108.547C267.241 108.547 266.218 108.084 265.376 107.159C264.06 105.77 262.626 104.754 261.07 104.11C259.52 103.467 257.74 103.147 255.741 103.147C251.686 103.147 248.398 104.472 245.872 107.116C243.346 109.766 242.083 113.272 242.083 117.64C242.083 120.417 242.675 122.896 243.863 125.077C245.046 127.264 246.704 128.971 248.835 130.206C250.967 131.44 253.402 132.057 256.141 132.057C259.722 132.057 262.616 131.158 264.827 129.36C265.829 128.642 266.804 128.28 267.748 128.28C268.483 128.28 269.17 128.509 269.799 128.971C270.801 129.796 271.302 130.722 271.302 131.749C271.302 132.52 270.988 133.212 270.353 133.829C266.565 137.271 261.827 138.995 256.141 138.995C251.985 139 248.244 138.074 244.929 136.223Z", fill: Ht(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M285.157 88.1605C284.129 87.1603 283.617 85.9632 283.617 84.5747C283.617 83.1861 284.129 81.9944 285.157 80.9889C286.186 79.9887 287.406 79.4833 288.829 79.4833C290.252 79.4833 291.472 79.9834 292.501 80.9889C293.529 81.9891 294.041 83.1861 294.041 84.5747C294.041 85.9632 293.529 87.155 292.501 88.1605C291.472 89.1607 290.252 89.6661 288.829 89.6661C287.411 89.6661 286.186 89.1607 285.157 88.1605ZM285.951 137.574C285.189 136.829 284.806 135.893 284.806 134.76V100.455C284.806 99.2743 285.189 98.322 285.951 97.6038C286.713 96.8855 287.673 96.5238 288.834 96.5238C290.044 96.5238 291.019 96.8855 291.754 97.6038C292.49 98.322 292.858 99.2743 292.858 100.455V134.76C292.858 135.893 292.49 136.829 291.754 137.574C291.014 138.319 290.044 138.691 288.834 138.691C287.673 138.691 286.713 138.319 285.951 137.574Z", fill: Ht(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M339.129 98.4497C342.022 99.9925 344.287 102.243 345.918 105.196C347.549 108.148 348.364 111.708 348.364 115.873V134.84C348.364 135.973 347.98 136.909 347.218 137.654C346.456 138.399 345.492 138.771 344.335 138.771C343.179 138.771 342.214 138.399 341.452 137.654C340.69 136.909 340.307 135.973 340.307 134.84V115.873C340.307 111.713 339.161 108.563 336.875 106.43C334.583 104.297 331.546 103.232 327.752 103.232C325.54 103.232 323.526 103.669 321.714 104.541C319.897 105.419 318.474 106.595 317.451 108.09C316.422 109.579 315.911 111.25 315.911 113.101V134.84C315.911 135.973 315.543 136.909 314.802 137.654C314.067 138.399 313.092 138.771 311.882 138.771C310.726 138.771 309.761 138.399 308.999 137.654C308.237 136.909 307.853 135.973 307.853 134.84V100.461C307.853 99.2796 308.237 98.3273 308.999 97.6091C309.761 96.8909 310.72 96.5291 311.882 96.5291C313.092 96.5291 314.067 96.8909 314.802 97.6091C315.538 98.3273 315.911 99.2796 315.911 100.461V101.307C317.595 99.6627 319.593 98.3911 321.911 97.492C324.229 96.5929 326.702 96.1407 329.334 96.1407C332.969 96.1407 336.23 96.9121 339.129 98.4497Z", fill: Ht(a)[i].secondaryTextColor }),
    /* @__PURE__ */ m("path", { d: "M392.306 99.0296C395.594 100.908 398.2 103.477 400.124 106.738C402.042 110 403.007 113.639 403.007 117.645V134.834C403.007 135.967 402.623 136.904 401.861 137.649C401.099 138.393 400.14 138.766 398.978 138.766C397.822 138.766 396.863 138.393 396.095 137.649C395.333 136.904 394.95 135.967 394.95 134.834V131.983C393.106 134.191 390.868 135.914 388.241 137.149C385.608 138.383 382.762 139 379.714 139C375.925 139 372.488 138.074 369.413 136.223C366.333 134.371 363.914 131.818 362.15 128.551C360.386 125.29 359.507 121.651 359.507 117.645C359.507 113.639 360.455 110 362.347 106.738C364.244 103.477 366.861 100.908 370.202 99.0296C373.543 97.1569 377.242 96.2152 381.297 96.2152C385.342 96.2152 389.013 97.1569 392.306 99.0296ZM388.438 130.174C390.569 128.913 392.237 127.195 393.452 125.008C394.662 122.821 395.269 120.369 395.269 117.645C395.269 114.921 394.662 112.458 393.452 110.244C392.243 108.037 390.569 106.302 388.438 105.041C386.306 103.78 383.924 103.153 381.292 103.153C378.659 103.153 376.277 103.78 374.145 105.041C372.014 106.302 370.33 108.037 369.094 110.244C367.857 112.452 367.239 114.921 367.239 117.645C367.239 120.369 367.857 122.821 369.094 125.008C370.33 127.195 372.014 128.913 374.145 130.174C376.277 131.435 378.659 132.062 381.292 132.062C383.924 132.062 386.306 131.435 388.438 130.174Z", fill: Ht(a)[i].secondaryTextColor })
  ] });
}, Jd = (e) => ({
  colorful: {
    textColor: e.colors.background.white,
    primaryLogoColor: "#FF646E",
    secondaryLogoColor: "#FF78AA"
  },
  "colorful-inverse": {
    textColor: "#1900AF",
    primaryLogoColor: "#FF646E",
    secondaryLogoColor: "#FF78AA"
  },
  neutral: {
    textColor: e.colors.background.white,
    primaryLogoColor: e.colors.background.white,
    secondaryLogoColor: e.colors.background.white
  },
  "neutral-inverse": {
    textColor: "#000000",
    primaryLogoColor: "#000000",
    secondaryLogoColor: "#000000"
  },
  corporate: {
    textColor: "#666666",
    primaryLogoColor: "#1900AF",
    secondaryLogoColor: "#1900AF"
  }
}), X5e = ({
  base: e,
  inverse: r,
  width: t = 112,
  height: n = 25,
  ...o
}) => {
  const a = ur(), [i, l] = Se(r);
  Fe(() => {
    e === "corporate" && l(!1);
  }, [e]);
  const s = Je(() => i ? `${e}-inverse` : `${e}`, [e, i]);
  return /* @__PURE__ */ Y("svg", { width: t, height: n, viewBox: "0 0 406 89", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...o, children: [
    /* @__PURE__ */ m("path", { d: "M7.75 25.5378H3.12C1.4 25.5378 0 26.9378 0 28.6578V40.8978C0 42.6178 1.4 44.0178 3.12 44.0178H35.3C38.05 44.0178 39.76 46.9878 38.39 49.3678L22.3 77.2278C21.44 78.7178 21.95 80.6278 23.44 81.4878L34.04 87.6078C35.53 88.4678 37.44 87.9578 38.3 86.4678L40.61 82.4578C55.22 57.1678 36.96 25.5378 7.75 25.5378Z", fill: Jd(a)[s].primaryLogoColor }),
    /* @__PURE__ */ m("path", { d: "M85.82 44.0178H53.64C50.89 44.0178 49.18 41.0478 50.55 38.6678L66.65 10.7978C67.51 9.30784 67 7.39784 65.5 6.53784L54.9 0.417838C53.41 -0.442162 51.5 0.0678382 50.64 1.55784L48.33 5.56784C33.72 30.8678 51.98 62.4978 81.2 62.4978H85.82C87.54 62.4978 88.94 61.0978 88.94 59.3778V47.1378C88.95 45.4078 87.55 44.0178 85.82 44.0178Z", fill: Jd(a)[s].secondaryLogoColor }),
    /* @__PURE__ */ m("path", { d: "M134.4 29.8729C138.86 29.8729 142.7 31.4829 145.83 34.7829L152.43 27.9129V27.9029C147.6 22.7329 141.63 20.1429 134.4 20.1429C127.52 20.1429 121.72 22.4629 116.99 27.0129C112.26 31.5629 109.94 37.1929 109.94 43.9729C109.94 50.7529 112.26 56.4629 116.99 61.0229C121.72 65.5729 127.52 67.8029 134.4 67.8029C141.63 67.8029 147.6 65.2129 152.43 60.0429V60.0329L145.83 53.1629C142.7 56.4629 138.87 58.0729 134.4 58.0729C130.47 58.0729 127.17 56.7329 124.49 54.0529C121.9 51.3729 120.56 47.9829 120.56 43.9729C120.56 39.9529 121.9 36.5629 124.49 33.8829C127.16 31.2029 130.46 29.8729 134.4 29.8729ZM235.52 20.6729C229.09 20.6729 224.01 23.6129 221.86 27.9929V21.5629H211.24V66.5529H221.86V40.6729C221.86 34.5129 226.24 30.2329 232.3 30.2329C238.28 30.2329 241.85 34.0729 241.85 40.2329V66.5629H252.56V38.7029C252.57 27.5429 246.23 20.6729 235.52 20.6729ZM179.33 20.2229C172.45 20.2229 166.65 22.5429 161.92 27.0929C157.19 31.6429 154.78 37.3629 154.78 44.0529C154.78 50.7429 157.19 56.4629 161.92 61.0129C166.65 65.5629 172.45 67.8829 179.33 67.8829C186.21 67.8829 192.01 65.5629 196.74 61.0129C201.47 56.4629 203.88 50.7429 203.88 44.0529C203.88 37.3629 201.47 31.6429 196.74 27.0929C192 22.5529 186.2 20.2229 179.33 20.2229ZM189.23 54.1529C186.56 56.8329 183.25 58.1729 179.32 58.1729C175.3 58.1729 172 56.8329 169.33 54.1529C166.74 51.3829 165.4 48.0829 165.4 44.0629C165.4 40.0429 166.74 36.7429 169.33 34.0629C172 31.2929 175.3 29.9529 179.32 29.9529C183.24 29.9529 186.55 31.2929 189.23 34.0629C191.91 36.7429 193.25 40.0429 193.25 44.0629C193.25 48.0829 191.92 51.3829 189.23 54.1529ZM350.43 21.5629H338.74L329.02 35.0429L319.2 21.5629H307.59L323.12 42.8029L306.07 66.5429H317.59L329.02 50.6529L340.45 66.5429H351.96L334.89 42.7229L350.43 21.5629ZM405.79 58.2529H403.61C401.2 58.2529 400.31 56.8229 400.31 52.9829V21.5629H389.6V28.0829C387.91 23.8029 382.46 20.5829 375.23 20.5829C368.89 20.5829 363.54 22.8129 359.16 27.3629C354.87 31.8229 352.74 37.3629 352.74 44.0529C352.74 50.7429 354.88 56.2829 359.16 60.8329C363.54 65.3829 368.89 67.6129 375.23 67.6129C382.37 67.6129 387.54 65.2929 390.67 60.5629C391.12 62.8829 392.37 64.6729 394.33 66.0129C395.94 66.9929 397.99 67.4429 400.57 67.4429C402.89 67.4429 404.67 67.1729 405.84 66.7329V58.3129C405.84 58.2729 405.82 58.2529 405.79 58.2529ZM386.38 53.8829C383.79 56.4729 380.49 57.8129 376.65 57.8129C372.81 57.8129 369.69 56.4729 367.1 53.8829C364.6 51.2929 363.35 47.9929 363.35 44.0629C363.35 40.1429 364.6 36.8329 367.1 34.2429C369.69 31.6529 372.81 30.3229 376.65 30.3229C380.49 30.3229 383.79 31.6629 386.38 34.2429C389.05 36.8329 390.39 40.1329 390.39 44.0629C390.39 47.9929 389.06 51.2929 386.38 53.8829ZM283.23 20.3229C276.35 20.3229 270.74 22.4629 266.27 26.8429C261.89 31.2129 259.66 36.9229 259.66 44.0729V44.4329C259.66 51.4829 261.89 57.1129 266.27 61.3029C270.64 65.4929 276.45 67.6428 283.5 67.6428C291.09 67.6428 297.33 64.9628 302.41 59.6129V59.6029L295.99 53.3629C292.51 56.8428 288.5 58.5329 283.85 58.5329C275.91 58.5329 270.64 53.8929 270.28 46.7529H305.27C305.36 45.5929 305.45 44.3429 305.45 43.0029C305.45 36.5729 303.4 31.2129 299.2 26.8429C295.1 22.4629 289.75 20.3229 283.23 20.3229ZM270.56 39.2429C270.83 36.4729 272.17 34.1529 274.58 32.2829C276.99 30.4029 279.94 29.4229 283.24 29.4229C286.37 29.4229 288.95 30.4029 291.18 32.3729C293.41 34.2429 294.57 36.5629 294.57 39.2429H270.56Z", fill: Jd(a)[s].textColor })
  ] });
}, Uv = (e) => ({
  conexa: {
    primaryLogoColor: "#FF646E",
    secondaryLogoColor: "#FF78AA"
  },
  pv: {
    primaryLogoColor: "#AF55DC",
    secondaryLogoColor: "#8255FF"
  },
  "neutral-white": {
    primaryLogoColor: e.colors.background.white,
    secondaryLogoColor: e.colors.background.white
  },
  "neutral-black": {
    primaryLogoColor: "#000000",
    secondaryLogoColor: "#000000"
  },
  corporate: {
    primaryLogoColor: "#1900AF",
    secondaryLogoColor: "#1900AF"
  }
}), Y5e = ({
  color: e,
  width: r = 25,
  height: t = 24,
  ...n
}) => {
  const o = ur();
  return /* @__PURE__ */ Y("svg", { width: r, height: t, viewBox: "0 0 79 78", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n, children: [
    /* @__PURE__ */ m("path", { d: "M6.88386 22.6292H2.77131C1.24354 22.6292 0 23.8698 0 25.3939V36.2398C0 37.7639 1.24354 39.0044 2.77131 39.0044H31.3549C33.7975 39.0044 35.3164 41.6362 34.0995 43.7451L19.8077 68.432C19.0439 69.7523 19.4969 71.4447 20.8203 72.2068L30.2357 77.6298C31.5592 78.3918 33.2557 77.9399 34.0196 76.6196L36.0714 73.0663C49.0486 50.6567 32.8293 22.6292 6.88386 22.6292Z", fill: Uv(o)[e].primaryLogoColor }),
    /* @__PURE__ */ m("path", { d: "M76.2286 39.0044H47.6451C45.2024 39.0044 43.6835 36.3727 44.9004 34.2638L59.2011 9.56802C59.965 8.24772 59.512 6.55526 58.1796 5.79321L48.7643 0.370249C47.4408 -0.391802 45.7442 0.0601118 44.9803 1.38041L42.9285 4.93369C29.9513 27.3521 46.1706 55.3797 72.125 55.3797H76.2286C77.7564 55.3797 78.9999 54.1391 78.9999 52.615V41.7691C79.0088 40.2361 77.7653 39.0044 76.2286 39.0044Z", fill: Uv(o)[e].secondaryLogoColor })
  ] });
}, mo = (e) => ({
  colorful: {
    textColor: "#1900AF",
    logoColor: e.colors.feedback.information[300]
  },
  neutral: {
    textColor: e.colors.background.white,
    logoColor: e.colors.background.white
  }
}), U5e = ({
  base: e,
  inverse: r,
  width: t = 402,
  height: n = 143,
  ...o
}) => {
  const a = ur();
  return /* @__PURE__ */ Y("svg", { width: t, height: n, viewBox: "0 0 402 143", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...o, children: [
    /* @__PURE__ */ m("path", { d: "M25.7169 16.648C30.4079 16.648 34.4436 18.3456 37.7303 21.8348L44.6732 14.5792C44.6781 14.5742 44.6781 14.5742 44.6732 14.5693C39.5978 9.1053 33.3201 6.37827 25.7169 6.37827C18.4882 6.37827 12.3879 8.82814 7.41104 13.6339C2.43914 18.4396 0 24.3787 0 31.5403C0 38.7018 2.43914 44.735 7.41104 49.5456C12.3879 54.3563 18.4833 56.7122 25.7169 56.7122C33.3201 56.7122 39.5978 53.9802 44.6732 48.5162C44.6781 48.5112 44.6781 48.5112 44.6732 48.5063L37.7303 41.2556C34.4436 44.7399 30.4079 46.4425 25.7169 46.4425C21.5827 46.4425 18.1137 45.027 15.3001 42.196C12.5702 39.365 11.1658 35.7867 11.1658 31.5452C11.1658 27.2988 12.5702 23.7204 15.3001 20.8895C18.1137 18.0585 21.5827 16.648 25.7169 16.648ZM132.044 6.93753C125.288 6.93753 119.937 10.0457 117.685 14.6683V7.87789H106.519V55.3907H117.685V28.056C117.685 21.5527 122.287 17.0241 128.668 17.0241C134.956 17.0241 138.711 21.0775 138.711 27.5809V55.3907H149.975V25.9773C149.975 14.1931 143.308 6.93753 132.044 6.93753ZM72.9623 6.46735C65.7336 6.46735 59.6333 8.92218 54.6564 13.723C49.6796 18.5336 47.1518 24.5668 47.1518 31.6343C47.1518 38.7018 49.6796 44.735 54.6564 49.5456C59.6333 54.3563 65.7286 56.8012 72.9623 56.8012C80.191 56.8012 86.2913 54.3514 91.2682 49.5456C96.245 44.735 98.7728 38.7018 98.7728 31.6343C98.7728 24.5668 96.245 18.5336 91.2682 13.723C86.2913 8.91723 80.191 6.46735 72.9623 6.46735ZM83.3791 42.29C80.5655 45.121 77.0916 46.5315 72.9623 46.5315C68.7345 46.5315 65.2654 45.121 62.4518 42.29C59.7219 39.365 58.3176 35.8808 58.3176 31.6343C58.3176 27.3928 59.7219 23.9036 62.4518 21.0775C65.2654 18.1575 68.7345 16.742 72.9623 16.742C77.0916 16.742 80.5655 18.1575 83.3791 21.0775C86.1977 23.9085 87.607 27.3928 87.607 31.6343C87.602 35.8808 86.1977 39.365 83.3791 42.29ZM252.872 7.87789H240.578L230.353 22.1119L220.03 7.87789H207.825L224.154 30.3128L206.223 55.3907H218.335L230.348 38.6127L242.362 55.3907H254.469L236.537 30.2188L252.872 7.87789ZM311.081 46.6206L308.79 46.6256C306.252 46.6256 305.321 45.1161 305.321 41.0626V7.87789H294.057V14.7623C292.278 10.2387 286.542 6.83855 278.949 6.83855C272.287 6.83855 266.655 9.19439 262.052 14.0051C257.544 18.7168 255.297 24.5618 255.297 31.6343C255.297 38.7068 257.544 44.5469 262.052 49.3576C266.655 54.1682 272.287 56.5241 278.949 56.5241C286.453 56.5241 291.893 54.0693 295.18 49.0755C295.653 51.5303 296.969 53.411 299.034 54.8265C300.724 55.8609 302.877 56.336 305.597 56.336C308.041 56.336 309.914 56.0539 311.136 55.5788L311.141 55.5738V46.68C311.136 46.6503 311.111 46.6206 311.081 46.6206ZM290.676 42.003C287.956 44.735 284.478 46.1505 280.442 46.1505C276.406 46.1505 273.12 44.735 270.4 42.003C267.768 39.271 266.457 35.7818 266.457 31.6343C266.457 27.4868 267.773 24.0026 270.4 21.2656C273.12 18.5336 276.406 17.1181 280.442 17.1181C284.478 17.1181 287.956 18.5287 290.676 21.2656C293.49 24.0026 294.894 27.4918 294.894 31.6343C294.894 35.7818 293.49 39.271 290.676 42.003ZM182.216 6.56139C174.987 6.56139 169.079 8.8232 164.388 13.4408C159.786 18.0585 157.44 24.0916 157.44 31.6343V32.0104C157.44 39.4591 159.786 45.3982 164.388 49.8327C168.981 54.2623 175.086 56.5241 182.502 56.5241C190.48 56.5241 197.043 53.6981 202.389 48.046C202.394 48.0411 202.394 48.0361 202.389 48.0361L195.639 41.4437C191.977 45.121 187.76 46.9077 182.876 46.9077C174.524 46.9077 168.981 42.0079 168.606 34.4653H205.395C205.494 33.2428 205.587 31.9214 205.587 30.5059C205.587 23.7155 203.434 18.0585 199.014 13.4408C194.697 8.8232 189.07 6.56139 182.216 6.56139ZM168.887 26.5465C169.168 23.6215 170.577 21.1716 173.115 19.1919C175.643 17.2122 178.747 16.1728 182.216 16.1728C185.503 16.1728 188.223 17.2072 190.568 19.2859C192.914 21.2607 194.136 23.7155 194.136 26.5415H168.887V26.5465Z", fill: mo(a)[e].textColor }),
    /* @__PURE__ */ m("path", { d: "M361.422 57.3546C363.52 57.3496 365.383 56.5871 367.038 55.3095C368.402 54.2499 369.52 52.9229 370.742 51.7147C371.786 50.6847 372.885 49.6894 373.727 48.4614C375.151 46.3917 375.737 44.0842 375.55 41.5886C375.51 41.0687 375.673 40.6923 376.038 40.3507C377.412 39.0632 377.648 37.4243 377.235 35.711C376.801 33.9037 374.988 32.532 373.126 32.4083C371.121 32.2746 369.333 33.3243 368.52 35.2257C367.791 36.934 368.097 38.9989 369.579 40.4101C369.767 40.5883 370.013 40.7468 370.028 41.0588C370.111 42.8562 369.944 44.5645 368.575 45.9361C367.151 47.3572 365.762 48.8081 364.353 50.2391C363.314 51.2888 362.062 51.8087 360.58 51.8087C350.452 51.8038 340.324 51.8087 330.196 51.8038C327.915 51.8038 326.531 50.3876 326.526 48.0901C326.526 46.0302 326.526 43.9703 326.521 41.9154H326.546C326.546 38.7761 326.541 35.6318 326.546 32.4924C326.546 32.1557 326.59 31.8388 326.669 31.5368C326.772 31.3932 326.821 31.2248 326.826 31.0664C326.935 30.8138 327.073 30.5811 327.235 30.3682C327.309 30.3335 327.388 30.2642 327.486 30.1652C328.201 29.4323 329.092 29.1055 330.151 29.1105C334.112 29.1451 338.077 29.1253 342.038 29.1303C344.112 29.1352 345.895 28.3776 347.393 26.9862C349.043 25.4562 349.89 23.5151 349.9 21.2522C349.925 17.2216 349.895 13.186 349.905 9.15541C349.91 7.09553 351.338 5.6447 353.383 5.6447C358.56 5.6348 363.732 5.6447 368.91 5.66451C369.52 5.66451 370.141 5.73878 370.693 6.06559C371.855 6.74891 372.446 7.73429 372.437 9.11084C372.417 12.572 372.417 16.0332 372.437 19.4895C372.442 20.663 372.939 21.6038 374.018 22.1386C375.008 22.6337 375.988 22.5446 376.89 21.9009C377.742 21.2918 378.042 20.4105 378.042 19.3805C378.033 15.9193 378.042 12.4631 378.042 9.00191C378.042 7.6204 377.762 6.28841 377.131 5.06041C375.397 1.68835 372.54 0.0840211 368.846 0.0394565C363.698 -0.0199631 358.545 -0.0100598 353.393 0.0543113C351.196 0.0840211 349.136 0.643555 347.422 2.18846C345.437 3.976 344.329 6.14482 344.334 8.8484C344.334 12.8295 344.329 16.8156 344.324 20.7967C344.324 22.2029 343.457 23.5894 341.6 23.5597C337.688 23.5003 333.772 23.525 329.861 23.5646C327.876 23.5845 326.009 24.0945 324.437 25.372C322.925 26.6049 321.876 28.0657 321.358 29.8681C321.334 29.9423 321.304 30.0166 321.285 30.0909C321.048 30.8832 320.994 31.715 320.994 32.537C320.989 33.9284 320.989 35.3198 320.989 36.7112C320.974 36.8499 320.989 37.0133 320.989 37.1717C320.989 38.7463 320.984 40.3259 320.984 41.9005H320.989C320.984 43.9654 320.984 46.0252 320.989 48.0901C320.994 50.0113 321.309 51.8137 322.467 53.4576C324.117 55.7948 326.235 57.3149 329.107 57.3298C339.875 57.3892 350.649 57.3645 361.422 57.3546ZM372.885 35.3743C373.831 35.404 374.51 36.1517 374.476 37.1123C374.441 38.0333 373.648 38.786 372.742 38.7562C371.772 38.7265 371.047 37.9541 371.072 36.9737C371.092 36.0378 371.88 35.3446 372.885 35.3743Z", fill: mo(a)[e].logoColor }),
    /* @__PURE__ */ m("path", { d: "M401.303 40.0932C401.303 38.0284 401.303 35.9685 401.298 33.9037C401.293 31.9824 400.978 30.18 399.82 28.5361C398.17 26.1989 396.052 24.6788 393.18 24.6639C382.407 24.6045 371.639 24.6293 360.865 24.6441C358.767 24.6491 356.905 25.4116 355.25 26.6891C353.885 27.7488 352.767 29.0758 351.545 30.284C350.501 31.314 349.402 32.3092 348.56 33.5372C347.136 35.607 346.55 37.9145 346.737 40.4101C346.777 40.93 346.614 41.3063 346.25 41.648C344.875 42.9354 344.639 44.5744 345.053 46.2877C345.486 48.095 347.299 49.4666 349.161 49.5904C351.166 49.7241 352.954 48.6744 353.767 46.7729C354.496 45.0646 354.191 42.9998 352.708 41.5886C352.521 41.4103 352.274 41.2519 352.26 40.9399C352.176 39.1425 352.343 37.4342 353.713 36.0626C355.136 34.6414 356.525 33.1906 357.934 31.7596C358.974 30.7099 360.225 30.1899 361.708 30.1899C371.836 30.1949 381.964 30.1899 392.092 30.1949C394.372 30.1949 395.757 31.6111 395.761 33.9086C395.761 35.9685 395.761 38.0284 395.766 40.0833H395.742C395.742 43.2226 395.747 46.3669 395.742 49.5062C395.742 49.8429 395.697 50.1599 395.619 50.4619C395.515 50.6055 395.466 50.7739 395.461 50.9323C395.353 51.1848 395.215 51.4176 395.052 51.6305C394.978 51.6651 394.899 51.7345 394.801 51.8335C394.087 52.5663 393.195 52.8931 392.136 52.8882C388.175 52.8535 384.21 52.8733 380.249 52.8684C378.175 52.8634 376.392 53.621 374.895 55.0124C373.244 56.5425 372.397 58.4835 372.387 60.7464C372.363 64.7771 372.392 68.8126 372.382 72.8433C372.378 74.9031 370.949 76.354 368.905 76.354C363.727 76.3639 358.555 76.354 353.378 76.3342C352.767 76.3342 352.146 76.2599 351.595 75.9331C350.432 75.2498 349.841 74.2644 349.851 72.8878C349.87 69.4266 349.87 65.9654 349.851 62.5092C349.846 61.3357 349.348 60.3949 348.269 59.8601C347.279 59.3649 346.299 59.4541 345.398 60.0978C344.545 60.7068 344.245 61.5882 344.245 62.6181C344.255 66.0793 344.245 69.5356 344.245 72.9968C344.245 74.3783 344.526 75.7103 345.156 76.9383C346.89 80.3103 349.747 81.9146 353.442 81.9592C358.59 82.0186 363.742 82.0087 368.895 81.9444C371.092 81.9146 373.151 81.3551 374.865 79.8102C376.85 78.0227 377.959 75.8538 377.954 73.1503C377.954 69.1692 377.959 65.1831 377.964 61.202C377.964 59.7957 378.831 58.4093 380.688 58.439C384.599 58.4984 388.515 58.4736 392.427 58.434C394.412 58.4142 396.279 57.9042 397.85 56.6267C399.362 55.3937 400.412 53.933 400.929 52.1306C400.953 52.0563 400.983 51.982 401.003 51.9078C401.239 51.1155 401.293 50.2836 401.293 49.4617C401.298 48.0703 401.298 46.6789 401.298 45.2874C401.313 45.1488 401.298 44.9854 401.298 44.8269C401.298 43.2474 401.303 41.6678 401.303 40.0932ZM349.402 46.6244C348.457 46.5947 347.777 45.847 347.811 44.8864C347.846 43.9654 348.639 43.2127 349.545 43.2424C350.516 43.2721 351.24 44.0446 351.215 45.025C351.196 45.9609 350.407 46.6591 349.402 46.6244Z", fill: mo(a)[e].logoColor }),
    /* @__PURE__ */ m("path", { d: "M177.416 142.088C176.773 142.088 176.228 141.864 175.782 141.417C175.386 141.02 175.188 140.498 175.188 139.852V103.858C175.287 99.9333 176.228 96.4556 178.011 93.425C179.843 90.3448 182.319 87.9104 185.438 86.1218C188.558 84.3333 192.049 83.439 195.911 83.439C199.872 83.439 203.413 84.3581 206.532 86.1963C209.701 87.9849 212.177 90.469 213.96 93.6486C215.792 96.7785 216.708 100.331 216.708 104.305C216.708 108.23 215.792 111.782 213.96 114.962C212.177 118.092 209.701 120.576 206.532 122.414C203.413 124.203 199.872 125.097 195.911 125.097C192.346 125.097 189.127 124.327 186.255 122.787C183.433 121.247 181.229 119.185 179.645 116.601V139.852C179.645 140.498 179.447 141.02 179.051 141.417C178.654 141.864 178.11 142.088 177.416 142.088ZM195.911 120.924C199.03 120.924 201.803 120.203 204.23 118.763C206.705 117.272 208.661 115.285 210.097 112.801C211.533 110.267 212.251 107.435 212.251 104.305C212.251 101.126 211.533 98.2938 210.097 95.8097C208.661 93.276 206.705 91.2887 204.23 89.8479C201.803 88.3575 199.03 87.6123 195.911 87.6123C192.841 87.6123 190.068 88.3575 187.592 89.8479C185.116 91.2887 183.16 93.276 181.724 95.8097C180.338 98.2938 179.645 101.126 179.645 104.305C179.645 107.435 180.338 110.267 181.724 112.801C183.16 115.285 185.116 117.272 187.592 118.763C190.068 120.203 192.841 120.924 195.911 120.924Z", fill: mo(a)[e].textColor }),
    /* @__PURE__ */ m("path", { d: "M236.018 124.65C234.136 124.65 232.453 124.128 230.967 123.085C229.531 122.042 228.392 120.601 227.551 118.763C226.758 116.924 226.362 114.788 226.362 112.354V68.6836C226.362 67.9881 226.56 67.4416 226.956 67.0441C227.402 66.6467 227.947 66.448 228.591 66.448C229.284 66.448 229.828 66.6467 230.225 67.0441C230.621 67.4416 230.819 67.9881 230.819 68.6836V112.354C230.819 114.639 231.289 116.527 232.23 118.017C233.22 119.458 234.483 120.178 236.018 120.178H237.875C238.42 120.178 238.865 120.377 239.212 120.775C239.558 121.172 239.732 121.719 239.732 122.414C239.732 123.06 239.534 123.606 239.138 124.054C238.741 124.451 238.197 124.65 237.503 124.65H236.018Z", fill: mo(a)[e].textColor }),
    /* @__PURE__ */ m("path", { d: "M265.916 125.171C262.351 125.171 259.157 124.451 256.334 123.01C253.512 121.52 251.259 119.359 249.575 116.527C247.941 113.695 247.124 110.242 247.124 106.168V86.1218C247.124 85.476 247.322 84.9543 247.719 84.5569C248.164 84.1097 248.709 83.8862 249.353 83.8862C249.996 83.8862 250.516 84.1097 250.912 84.5569C251.358 84.9543 251.581 85.476 251.581 86.1218V106.168C251.581 109.398 252.2 112.105 253.438 114.291C254.725 116.428 256.433 118.042 258.563 119.135C260.741 120.178 263.192 120.7 265.916 120.7C268.59 120.7 270.991 120.178 273.12 119.135C275.25 118.092 276.933 116.701 278.171 114.962C279.409 113.173 280.028 111.161 280.028 108.926H283.742C283.544 112.006 282.628 114.788 280.994 117.272C279.36 119.706 277.23 121.644 274.606 123.085C272.031 124.476 269.134 125.171 265.916 125.171ZM282.256 124.65C281.613 124.65 281.068 124.451 280.622 124.054C280.226 123.606 280.028 123.06 280.028 122.414V86.1218C280.028 85.4263 280.226 84.8798 280.622 84.4823C281.068 84.0849 281.613 83.8862 282.256 83.8862C282.95 83.8862 283.494 84.0849 283.89 84.4823C284.286 84.8798 284.485 85.4263 284.485 86.1218V122.414C284.485 123.06 284.286 123.606 283.89 124.054C283.494 124.451 282.95 124.65 282.256 124.65Z", fill: mo(a)[e].textColor }),
    /* @__PURE__ */ m("path", { d: "M311.658 125.097C309.083 125.097 306.385 124.625 303.562 123.681C300.74 122.737 298.388 121.147 296.506 118.912C296.11 118.415 295.937 117.893 295.986 117.347C296.085 116.75 296.407 116.254 296.952 115.856C297.447 115.508 297.967 115.384 298.511 115.484C299.106 115.583 299.576 115.856 299.923 116.303C301.359 117.992 303.092 119.185 305.122 119.88C307.202 120.526 309.455 120.849 311.881 120.849C316.04 120.849 318.986 120.104 320.72 118.614C322.453 117.123 323.319 115.384 323.319 113.397C323.319 111.459 322.378 109.87 320.497 108.628C318.665 107.336 315.817 106.417 311.955 105.87C307.003 105.175 303.339 103.833 300.962 101.846C298.586 99.8588 297.397 97.5486 297.397 94.9154C297.397 92.4314 298.016 90.3448 299.254 88.6556C300.492 86.9167 302.176 85.625 304.305 84.7804C306.484 83.8862 308.959 83.439 311.732 83.439C315.099 83.439 317.947 84.06 320.274 85.3021C322.601 86.4944 324.483 88.1091 325.919 90.146C326.315 90.6428 326.439 91.1893 326.29 91.7855C326.191 92.332 325.82 92.7791 325.176 93.1269C324.681 93.3753 324.161 93.4498 323.616 93.3505C323.072 93.2511 322.601 92.953 322.205 92.4562C320.967 90.8664 319.457 89.6741 317.674 88.8791C315.941 88.0346 313.911 87.6123 311.584 87.6123C308.464 87.6123 306.038 88.283 304.305 89.6244C302.572 90.9658 301.705 92.5804 301.705 94.4683C301.705 95.76 302.052 96.9027 302.745 97.8963C303.488 98.8403 304.676 99.66 306.31 100.356C307.944 101.001 310.123 101.523 312.846 101.921C316.56 102.417 319.482 103.262 321.611 104.454C323.79 105.647 325.325 107.038 326.216 108.628C327.157 110.168 327.627 111.832 327.627 113.621C327.627 115.956 326.884 117.992 325.399 119.731C323.913 121.47 321.957 122.812 319.531 123.756C317.105 124.65 314.48 125.097 311.658 125.097Z", fill: mo(a)[e].textColor })
  ] });
}, Ur = (e) => ({
  colorful: {
    textColor: e.colors.background.white,
    primaryLogoColor: "#AF55DC",
    secondaryLogoColor: "#8255FF"
  },
  "colorful-inverse": {
    textColor: "#1900AF",
    primaryLogoColor: "#AF55DC",
    secondaryLogoColor: "#8255FF"
  },
  neutral: {
    textColor: e.colors.background.white,
    primaryLogoColor: e.colors.background.white,
    secondaryLogoColor: e.colors.background.white
  },
  "neutral-inverse": {
    textColor: "#000000",
    primaryLogoColor: "#000000",
    secondaryLogoColor: "#000000"
  }
}), J5e = ({
  base: e,
  inverse: r,
  width: t = 533,
  height: n = 97,
  ...o
}) => {
  const a = ur(), i = Je(() => r ? `${e}-inverse` : `${e}`, [e, r]);
  return /* @__PURE__ */ Y("svg", { width: t, height: n, viewBox: "0 0 533 97", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...o, children: [
    /* @__PURE__ */ m("path", { d: "M104.25 67.9427H96.21V21.2427H104.25V26.1327C105.39 22.8527 109.48 20.5027 115.04 20.5027C119.8 20.5027 123.82 22.1827 127.03 25.5927C130.31 28.9427 131.92 33.1027 131.92 38.1227C131.92 43.1527 130.31 47.3027 127.03 50.7227C123.81 54.0727 119.79 55.7527 115.04 55.7527C109.48 55.7527 105.39 53.4127 104.25 50.1227V67.9427ZM106.6 30.7527C104.66 32.6927 103.65 35.1727 103.65 38.1227C103.65 41.0727 104.65 43.5527 106.6 45.4927C108.61 47.4327 111.09 48.4427 113.97 48.4427C116.85 48.4427 119.2 47.4327 121.07 45.4927C123.01 43.5527 123.95 41.0727 123.95 38.1227C123.95 35.1727 123.01 32.6927 121.07 30.7527C119.19 28.8127 116.85 27.8027 113.97 27.8027C111.09 27.8027 108.61 28.8127 106.6 30.7527Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M137.35 45.5927C140.02 47.2627 143.54 48.9727 148.16 48.9727C152.26 48.9727 153.84 47.2427 153.84 45.3527C153.84 42.9927 148.79 42.1627 144.63 40.6927C138.33 38.4727 135.34 35.6727 135.34 30.7327C135.34 24.2027 140.94 20.1627 148.92 20.1627C153.53 20.1627 157.01 21.7727 159.33 23.0327L156.59 29.1227C153.65 27.8827 151.34 27.0727 148.78 27.0727C145.51 27.0727 143.04 27.9027 143.04 30.5227C143.04 32.8727 148.22 33.8427 152.52 35.2927C158.76 37.4027 161.54 40.7027 161.54 45.1427C161.54 51.1627 156.85 55.9327 147.67 55.9327C142.45 55.9327 138.45 54.6127 134.17 52.0927L137.35 45.5927Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M165.31 12.5327C165.31 9.8527 167.45 7.77271 170.13 7.77271C172.74 7.77271 174.89 9.8527 174.89 12.5327C174.89 15.2127 172.75 17.2927 170.13 17.2927C167.45 17.2827 165.31 15.2127 165.31 12.5327ZM166.11 55.0127V21.2427H174.15V55.0127H166.11Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M211.13 25.9927L206.17 31.1527C203.82 28.6727 200.94 27.4727 197.59 27.4727C194.64 27.4727 192.16 28.4827 190.15 30.4927C188.21 32.5027 187.2 35.0527 187.2 38.0627C187.2 41.0727 188.2 43.6227 190.15 45.6327C192.16 47.6427 194.64 48.6527 197.59 48.6527C200.94 48.6527 203.82 47.4427 206.17 44.9627L211.13 50.1227C207.51 54.0127 203.02 55.9527 197.59 55.9527C192.43 55.9527 188.07 54.2727 184.52 50.8627C180.97 47.4427 179.23 43.1527 179.23 38.0627C179.23 32.9727 180.97 28.7527 184.52 25.3327C188.07 21.9127 192.43 20.1727 197.59 20.1727C203.02 20.1627 207.51 22.1127 211.13 25.9927Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M212.49 38.1227C212.49 33.0927 214.3 28.8127 217.85 25.3927C221.4 21.9727 225.76 20.2327 230.92 20.2327C236.08 20.2327 240.44 21.9727 243.99 25.3927C247.54 28.8127 249.35 33.1027 249.35 38.1227C249.35 43.1527 247.54 47.4327 243.99 50.8527C240.44 54.2727 236.08 56.0127 230.92 56.0127C225.76 56.0127 221.41 54.2727 217.85 50.8527C214.3 47.4427 212.49 43.1527 212.49 38.1227ZM238.35 45.6927C240.36 43.6127 241.37 41.1327 241.37 38.1227C241.37 35.1027 240.36 32.6327 238.35 30.6227C236.34 28.5427 233.86 27.5427 230.91 27.5427C227.89 27.5427 225.42 28.5427 223.41 30.6227C221.47 32.6327 220.46 35.1127 220.46 38.1227C220.46 41.1427 221.46 43.6127 223.41 45.6927C225.42 47.7027 227.9 48.7127 230.91 48.7127C233.86 48.7127 236.34 47.7027 238.35 45.6927Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M254.26 8.3027H262.3V43.9527C262.3 47.2327 263.37 48.6427 266.32 48.6427C267.26 48.6427 268.06 48.5727 268.73 48.3727V55.5427C267.79 55.8127 266.52 55.9427 264.91 55.9427C257.81 55.9427 254.26 52.3227 254.26 45.0227V8.3027Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M270.07 38.1227C270.07 33.0927 271.88 28.8127 275.43 25.3927C278.98 21.9727 283.34 20.2327 288.5 20.2327C293.66 20.2327 298.02 21.9727 301.57 25.3927C305.12 28.8127 306.93 33.1027 306.93 38.1227C306.93 43.1527 305.12 47.4327 301.57 50.8527C298.02 54.2727 293.66 56.0127 288.5 56.0127C283.34 56.0127 278.99 54.2727 275.43 50.8527C271.88 47.4427 270.07 43.1527 270.07 38.1227ZM295.94 45.6927C297.95 43.6127 298.96 41.1327 298.96 38.1227C298.96 35.1027 297.95 32.6327 295.94 30.6227C293.93 28.5427 291.45 27.5427 288.5 27.5427C285.48 27.5427 283.01 28.5427 281 30.6227C279.06 32.6327 278.05 35.1127 278.05 38.1227C278.05 41.1427 279.06 43.6127 281 45.6927C283.01 47.7027 285.49 48.7127 288.5 48.7127C291.45 48.7127 293.93 47.7027 295.94 45.6927Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M337.8 21.2427H345.84V49.3827C345.84 57.4927 344.7 62.4527 340.14 66.0027C336.92 68.4827 332.97 69.7527 328.21 69.7527C321.91 69.7527 316.48 68.1427 311.86 64.8627L315.75 58.9027C319.44 61.3827 323.32 62.5827 327.34 62.5827C330.49 62.5827 332.97 61.9127 334.78 60.5727C336.92 59.0327 338 56.1527 338 51.9927V50.3127C336.39 53.1927 332.37 55.2727 327.01 55.2727C322.25 55.2727 318.23 53.6027 314.95 50.3127C311.73 47.0327 310.13 42.8727 310.13 37.9827C310.13 33.0927 311.74 28.9327 315.02 25.5827C318.3 22.1627 322.26 20.4927 327.01 20.4927C332.57 20.4927 336.66 22.8427 337.8 26.1227V21.2427ZM335.39 45.2927C337.4 43.3527 338.4 40.8727 338.4 37.9927C338.4 35.1127 337.39 32.7027 335.39 30.7527C333.45 28.8127 330.97 27.8027 328.09 27.8027C325.21 27.8027 322.86 28.8127 320.92 30.7527C319.04 32.6927 318.11 35.1127 318.11 37.9927C318.11 40.8727 319.05 43.3527 320.92 45.2927C322.86 47.2327 325.21 48.1727 328.09 48.1727C330.97 48.1727 333.45 47.2327 335.39 45.2927Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M352.01 12.5327C352.01 9.8527 354.15 7.77271 356.83 7.77271C359.44 7.77271 361.59 9.8527 361.59 12.5327C361.59 15.2127 359.45 17.2927 356.83 17.2927C354.15 17.2827 352.01 15.2127 352.01 12.5327ZM352.81 55.0127V21.2427H360.85V55.0127H352.81Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M393.6 26.1327V21.2427H401.64V44.8327C401.64 47.7127 402.31 48.7827 404.12 48.7827C404.59 48.7827 405.19 48.7127 405.8 48.6527V55.1527C404.93 55.4927 403.59 55.6927 401.85 55.6927C399.91 55.6927 398.37 55.3627 397.16 54.6227C395.69 53.6127 394.75 52.2727 394.41 50.5327C392.06 54.0827 388.18 55.8227 382.82 55.8227C378.06 55.8227 374.04 54.1427 370.76 50.7327C367.54 47.3127 365.94 43.1627 365.94 38.1327C365.94 33.1027 367.55 28.9527 370.76 25.6027C374.04 22.1827 378.06 20.5127 382.82 20.5127C388.24 20.5027 392.33 22.9127 393.6 26.1327ZM391.19 45.4927C393.2 43.5527 394.2 41.0727 394.2 38.1227C394.2 35.1727 393.2 32.6927 391.19 30.7527C389.25 28.8127 386.77 27.8027 383.89 27.8027C381.01 27.8027 378.66 28.8127 376.72 30.7527C374.84 32.6927 373.91 35.1727 373.91 38.1227C373.91 41.0727 374.85 43.5527 376.72 45.4927C378.66 47.4327 381.01 48.4427 383.89 48.4427C386.77 48.4427 389.25 47.4427 391.19 45.4927Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M421.61 55.0127L407.14 21.2427H415.45L425.03 44.1627L434.55 21.2427H442.86L428.39 55.0127H421.61Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M445.39 12.5327C445.39 9.8527 447.53 7.77271 450.21 7.77271C452.82 7.77271 454.97 9.8527 454.97 12.5327C454.97 15.2127 452.83 17.2927 450.21 17.2927C447.54 17.2827 445.39 15.2127 445.39 12.5327ZM446.2 55.0127V21.2427H454.24V55.0127H446.2Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M471.99 55.0127L457.52 21.2427H465.83L475.41 44.1627L484.93 21.2427H493.24L478.77 55.0127H471.99Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M520.65 26.1327V21.2427H528.69V44.8327C528.69 47.7127 529.36 48.7827 531.17 48.7827C531.64 48.7827 532.24 48.7127 532.85 48.6527V55.1527C531.98 55.4927 530.64 55.6927 528.9 55.6927C526.96 55.6927 525.42 55.3627 524.21 54.6227C522.74 53.6127 521.8 52.2727 521.46 50.5327C519.11 54.0827 515.23 55.8227 509.87 55.8227C505.11 55.8227 501.09 54.1427 497.81 50.7327C494.59 47.3127 492.99 43.1627 492.99 38.1327C492.99 33.1027 494.6 28.9527 497.81 25.6027C501.09 22.1827 505.11 20.5127 509.87 20.5127C515.29 20.5027 519.38 22.9127 520.65 26.1327ZM518.24 45.4927C520.25 43.5527 521.25 41.0727 521.25 38.1227C521.25 35.1727 520.24 32.6927 518.24 30.7527C516.3 28.8127 513.82 27.8027 510.94 27.8027C508.06 27.8027 505.71 28.8127 503.77 30.7527C501.89 32.6927 500.96 35.1727 500.96 38.1227C500.96 41.0727 501.9 43.5527 503.77 45.4927C505.71 47.4327 508.06 48.4427 510.94 48.4427C513.82 48.4427 516.3 47.4427 518.24 45.4927Z", fill: Ur(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M42.54 4.9027L44.58 1.3727C45.34 0.0626956 47.02 -0.387304 48.33 0.362696L57.66 5.7427C58.97 6.5027 59.42 8.1827 58.67 9.4927L44.5 34.0327C43.29 36.1227 44.8 38.7427 47.22 38.7427H75.54C77.06 38.7427 78.29 39.9727 78.29 41.4927V52.2627C78.29 53.7827 77.06 55.0127 75.54 55.0127H71.47C45.75 55.0027 29.68 27.1727 42.54 4.9027Z", fill: Ur(a)[i].primaryLogoColor }),
    /* @__PURE__ */ m("path", { d: "M35.74 72.5827L33.7 76.1127C32.94 77.4227 31.26 77.8727 29.95 77.1227L20.62 71.7427C19.31 70.9827 18.86 69.3027 19.61 67.9927L33.77 43.4727C34.98 41.3827 33.47 38.7627 31.05 38.7627H2.73C1.23 38.7427 0 37.5127 0 35.9927V25.2227C0 23.7027 1.23 22.4727 2.75 22.4727H6.82C32.53 22.4827 48.6 50.3127 35.74 72.5827Z", fill: Ur(a)[i].secondaryLogoColor }),
    /* @__PURE__ */ m("path", { d: "M424.608 81.3609C426.386 81.3609 427.921 82.0023 429.163 83.3121L431.795 80.5793V80.5739C429.871 78.5149 427.488 77.4854 424.603 77.4854C421.864 77.4854 419.551 78.4071 417.66 80.2182C415.774 82.0292 414.85 84.2661 414.85 86.9665C414.85 89.6616 415.774 91.9362 417.66 93.7473C419.545 95.5583 421.858 96.4477 424.603 96.4477C427.488 96.4477 429.866 95.4182 431.795 93.3592V93.3538L429.163 90.621C427.915 91.9362 426.386 92.5722 424.608 92.5722C423.041 92.5722 421.723 92.0386 420.659 90.9714C419.621 89.9041 419.092 88.5566 419.092 86.9612C419.092 85.3603 419.627 84.0128 420.659 82.9456C421.723 81.8945 423.041 81.3609 424.608 81.3609ZM464.934 77.701C462.373 77.701 460.341 78.8707 459.487 80.6117V78.0568H455.251V95.9518H459.487V85.6568C459.487 83.2043 461.232 81.501 463.653 81.501C466.036 81.501 467.462 83.0264 467.462 85.4789V95.9518H471.737V84.8752C471.731 80.4338 469.208 77.701 464.934 77.701ZM442.526 77.5231C439.786 77.5231 437.468 78.4448 435.583 80.2559C433.697 82.067 432.735 84.3416 432.735 87.0043C432.735 89.667 433.697 91.9416 435.583 93.7526C437.468 95.5637 439.781 96.4854 442.526 96.4854C445.265 96.4854 447.578 95.5637 449.469 93.7526C451.355 91.9416 452.317 89.667 452.317 87.0043C452.317 84.3416 451.355 82.067 449.469 80.2559C447.584 78.4502 445.265 77.5231 442.526 77.5231ZM446.476 91.0199C445.411 92.0871 444.093 92.6153 442.526 92.6153C440.921 92.6153 439.608 92.0817 438.538 91.0199C437.506 89.9203 436.971 88.6051 436.971 87.0043C436.971 85.4088 437.506 84.0936 438.538 83.0264C439.603 81.9268 440.921 81.3932 442.526 81.3932C444.093 81.3932 445.411 81.9268 446.476 83.0264C447.546 84.0936 448.081 85.4034 448.081 87.0043C448.081 88.6051 447.546 89.9149 446.476 91.0199ZM510.76 78.0568H506.097L502.217 83.4199L498.299 78.0568H493.669L499.861 86.5084L493.064 95.9518H497.656L502.211 89.6292L506.767 95.9518H511.359L504.562 86.4707L510.76 78.0568ZM532.832 92.6531H531.962C531.001 92.6531 530.644 92.0871 530.644 90.5563V78.0568H526.37V80.6494C525.695 78.9461 523.522 77.6633 520.642 77.6633C518.114 77.6633 515.979 78.5526 514.234 80.3637C512.527 82.137 511.673 84.3416 511.673 87.0043C511.673 89.667 512.527 91.8715 514.234 93.6826C515.979 95.4936 518.114 96.383 520.642 96.383C523.49 96.383 525.554 95.4613 526.797 93.5748C526.975 94.4965 527.478 95.208 528.256 95.7416C528.899 96.1297 529.715 96.3075 530.747 96.3075C531.676 96.3075 532.384 96.1997 532.849 96.0219V92.6746C532.854 92.6585 532.843 92.6531 532.832 92.6531ZM525.095 90.9121C524.063 91.9416 522.744 92.4752 521.215 92.4752C519.686 92.4752 518.438 91.9416 517.406 90.9121C516.406 89.8826 515.909 88.5674 515.909 87.0043C515.909 85.4412 516.406 84.1314 517.406 83.0965C518.438 82.067 519.686 81.5334 521.215 81.5334C522.744 81.5334 524.063 82.067 525.095 83.0965C526.159 84.126 526.694 85.4412 526.694 87.0043C526.694 88.5674 526.165 89.8826 525.095 90.9121ZM483.964 77.5609C481.225 77.5609 478.982 78.4125 477.205 80.1535C475.459 81.8945 474.568 84.1637 474.568 87.0043V87.1444C474.568 89.9526 475.459 92.1841 477.205 93.8551C478.945 95.526 481.263 96.3776 484.072 96.3776C487.098 96.3776 489.584 95.3104 491.616 93.1813V93.1759L489.054 90.6911C487.666 92.0763 486.066 92.7501 484.213 92.7501C481.047 92.7501 478.945 90.9067 478.804 88.0607H492.756C492.793 87.5972 492.826 87.1013 492.826 86.5677C492.826 84.0128 492.01 81.8783 490.335 80.1427C488.698 78.4125 486.563 77.5609 483.964 77.5609ZM478.907 85.0908C479.015 83.9912 479.55 83.0695 480.512 82.3203C481.473 81.5765 482.646 81.183 483.964 81.183C485.213 81.183 486.245 81.5711 487.131 82.358C488.022 83.1019 488.482 84.029 488.482 85.0908H478.907Z", fill: Ur(a)[i].textColor })
  ] });
}, Gt = (e) => ({
  colorful: {
    textColor: e.colors.background.white,
    primarylogoColor: "#AF55DC",
    secondarylogoColor: "#8255FF"
  },
  "colorful-inverse": {
    textColor: "#1900AF",
    primarylogoColor: "#AF55DC",
    secondarylogoColor: "#8255FF"
  },
  neutral: {
    textColor: e.colors.background.white,
    primarylogoColor: e.colors.background.white,
    secondarylogoColor: e.colors.background.white
  },
  "neutral-inverse": {
    textColor: "#000000",
    primarylogoColor: "#000000",
    secondarylogoColor: "#000000"
  }
}), q5e = ({
  base: e,
  inverse: r,
  width: t = 405,
  height: n = 111,
  ...o
}) => {
  const a = ur(), i = Je(() => r ? `${e}-inverse` : `${e}`, [e, r]);
  return /* @__PURE__ */ Y("svg", { width: t, height: n, viewBox: "0 0 405 111", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...o, children: [
    /* @__PURE__ */ m("path", { d: "M122.736 79.7987H113.271V24.9497H122.736V30.693C124.078 26.8406 128.894 24.0805 135.44 24.0805C141.044 24.0805 145.776 26.0537 149.556 30.0587C153.417 33.9933 155.313 38.8792 155.313 44.7752C155.313 50.6829 153.417 55.557 149.556 59.5738C145.765 63.5084 141.032 65.4815 135.44 65.4815C128.894 65.4815 124.078 62.7332 122.736 58.8691V79.7987ZM125.503 36.1191C123.219 38.3976 122.03 41.3104 122.03 44.7752C122.03 48.2399 123.207 51.1527 125.503 53.4312C127.869 55.7097 130.789 56.896 134.18 56.896C137.571 56.896 140.337 55.7097 142.539 53.4312C144.823 51.1527 145.93 48.2399 145.93 44.7752C145.93 41.3104 144.823 38.3976 142.539 36.1191C140.325 33.8406 137.571 32.6544 134.18 32.6544C130.789 32.6544 127.869 33.8406 125.503 36.1191Z", fill: Gt(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M161.706 53.5487C164.849 55.5101 168.993 57.5185 174.433 57.5185C179.26 57.5185 181.12 55.4866 181.12 53.2668C181.12 50.495 175.174 49.5201 170.277 47.7936C162.859 45.1862 159.339 41.8977 159.339 36.0956C159.339 28.4262 165.932 23.6812 175.327 23.6812C180.755 23.6812 184.852 25.5722 187.583 27.052L184.357 34.2047C180.896 32.7483 178.176 31.797 175.163 31.797C171.313 31.797 168.405 32.7718 168.405 35.849C168.405 38.6091 174.503 39.7483 179.566 41.4513C186.912 43.9295 190.185 47.8054 190.185 53.0201C190.185 60.0906 184.664 65.693 173.856 65.693C167.71 65.693 163.001 64.1426 157.962 61.1829L161.706 53.5487Z", fill: Gt(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M286.114 10.5738H295.579V52.4446C295.579 56.297 296.839 57.953 300.312 57.953C301.419 57.953 302.361 57.8708 303.15 57.6359V66.057C302.043 66.3742 300.548 66.5268 298.652 66.5268C290.293 66.5268 286.114 62.2752 286.114 53.7013V10.5738Z", fill: Gt(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M307.647 14.708C307.647 11.5604 310.166 9.11743 313.322 9.11743C316.394 9.11743 318.926 11.5604 318.926 14.708C318.926 17.8557 316.406 20.2986 313.322 20.2986C310.166 20.2986 307.647 17.8557 307.647 14.708ZM308.589 64.6007V24.9379H318.054V64.6007H308.589Z", fill: Gt(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M267.488 30.646V24.9027H276.954V52.6091C276.954 55.9916 277.743 57.2483 279.874 57.2483C280.427 57.2483 281.134 57.1661 281.852 57.0956V64.7299C280.827 65.1292 279.25 65.3641 277.201 65.3641C274.917 65.3641 273.104 64.9765 271.68 64.1074C269.949 62.9211 268.842 61.3473 268.442 59.3037C265.675 63.4731 261.107 65.5168 254.797 65.5168C249.193 65.5168 244.46 63.5436 240.598 59.5386C236.807 55.5218 234.924 50.6476 234.924 44.7399C234.924 38.8322 236.819 33.958 240.598 30.0235C244.46 26.0067 249.193 24.0453 254.797 24.0453C261.178 24.0335 265.993 26.8758 267.488 30.646ZM264.651 53.396C267.017 51.1174 268.195 48.2047 268.195 44.7399C268.195 41.2752 267.017 38.3624 264.651 36.0839C262.367 33.8054 259.447 32.6191 256.057 32.6191C252.666 32.6191 249.899 33.8054 247.615 36.0839C245.402 38.3624 244.307 41.2752 244.307 44.7399C244.307 48.2047 245.414 51.1174 247.615 53.396C249.899 55.6745 252.666 56.8607 256.057 56.8607C259.447 56.8607 262.355 55.6745 264.651 53.396Z", fill: Gt(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M339.682 64.5302L322.646 24.8674H332.43L343.708 51.7869L354.917 24.8674H364.7L347.664 64.5302H339.682Z", fill: Gt(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M50.0834 5.75838L52.4852 1.61241C53.3799 0.0738189 55.3578 -0.454705 56.9001 0.426168L67.8846 6.74496C69.4269 7.63758 69.9567 9.61073 69.0737 11.1493L52.391 39.9715C50.9664 42.4262 52.7442 45.5033 55.5933 45.5033H88.9352C90.7247 45.5033 92.1728 46.948 92.1728 48.7332V61.3825C92.1728 63.1678 90.7247 64.6124 88.9352 64.6124H84.1434C53.8626 64.6007 34.943 31.9144 50.0834 5.75838Z", fill: Gt(a)[i].primarylogoColor }),
    /* @__PURE__ */ m("path", { d: "M42.0776 85.2483L39.6759 89.3943C38.7811 90.9329 36.8032 91.4614 35.2609 90.5805L24.2765 84.2617C22.7342 83.3691 22.2044 81.396 23.0874 79.8574L39.7583 51.0587C41.1828 48.604 39.4051 45.5268 36.556 45.5268H3.2141C1.44811 45.5033 0 44.0587 0 42.2735V29.6242C0 27.8389 1.44811 26.3943 3.23765 26.3943H8.02936C38.2984 26.406 57.218 59.0923 42.0776 85.2483Z", fill: Gt(a)[i].secondarylogoColor }),
    /* @__PURE__ */ m("path", { d: "M234.488 24.9379L210.259 80.8674H199.05L206.738 63.109L191.527 24.9379H202.735L208.457 40.0302L212.531 51.8456L217.005 40.0302L223.197 24.9379H234.488Z", fill: Gt(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M404.753 47.9933H374.401C375.119 52.9144 379.417 56.1795 385.798 56.1795C390.024 56.1795 394.239 54.7466 396.794 52.4446L402.692 58.4815C398.548 62.698 392.261 65.1527 385.409 65.1527C372.105 65.1527 363.664 57.1309 363.664 44.5755C363.664 32.3372 372.023 24.0688 384.373 24.0688C398.619 24.0805 406.507 33.453 404.753 47.9933ZM374.566 41.005H394.804C394.404 35.9195 390.578 32.7366 384.691 32.7366C379.111 32.7366 375.367 35.755 374.566 41.005Z", fill: Gt(a)[i].textColor }),
    /* @__PURE__ */ m("path", { d: "M296.753 94.8818C298.531 94.8818 300.065 95.5232 301.308 96.833L303.94 94.1002V94.0949C302.016 92.0359 299.633 91.0063 296.748 91.0063C294.008 91.0063 291.696 91.928 289.804 93.7391C287.919 95.5502 286.995 97.7871 286.995 100.487C286.995 103.183 287.919 105.457 289.804 107.268C291.69 109.079 294.003 109.969 296.748 109.969C299.633 109.969 302.011 108.939 303.94 106.88V106.875L301.308 104.142C300.06 105.457 298.531 106.093 296.753 106.093C295.186 106.093 293.868 105.56 292.803 104.492C291.766 103.425 291.236 102.078 291.236 100.482C291.236 98.8812 291.771 97.5337 292.803 96.4665C293.868 95.4154 295.186 94.8818 296.753 94.8818ZM337.078 91.222C334.517 91.222 332.486 92.3916 331.632 94.1326V91.5777H327.396V109.473H331.632V99.1777C331.632 96.7252 333.377 95.022 335.798 95.022C338.181 95.022 339.607 96.5473 339.607 98.9998V109.473H343.881V98.3961C343.876 93.9547 341.352 91.222 337.078 91.222ZM314.671 91.0441C311.931 91.0441 309.613 91.9658 307.727 93.7768C305.842 95.5879 304.88 97.8625 304.88 100.525C304.88 103.188 305.842 105.463 307.727 107.274C309.613 109.085 311.926 110.006 314.671 110.006C317.41 110.006 319.723 109.085 321.614 107.274C323.5 105.463 324.462 103.188 324.462 100.525C324.462 97.8625 323.5 95.5879 321.614 93.7768C319.728 91.9712 317.41 91.0441 314.671 91.0441ZM318.62 104.541C317.556 105.608 316.238 106.136 314.671 106.136C313.066 106.136 311.753 105.603 310.683 104.541C309.651 103.441 309.116 102.126 309.116 100.525C309.116 98.9298 309.651 97.6146 310.683 96.5473C311.747 95.4478 313.066 94.9141 314.671 94.9141C316.238 94.9141 317.556 95.4478 318.62 96.5473C319.69 97.6146 320.225 98.9244 320.225 100.525C320.225 102.126 319.69 103.436 318.62 104.541ZM382.904 91.5777H378.241L374.362 96.9408L370.444 91.5777H365.813L372.006 100.029L365.208 109.473H369.801L374.356 103.15L378.911 109.473H383.504L376.707 99.9916L382.904 91.5777ZM404.977 106.174H404.107C403.145 106.174 402.789 105.608 402.789 104.077V91.5777H398.515V94.1703C397.839 92.4671 395.667 91.1842 392.787 91.1842C390.258 91.1842 388.124 92.0736 386.379 93.8846C384.671 95.658 383.817 97.8625 383.817 100.525C383.817 103.188 384.671 105.392 386.379 107.204C388.124 109.015 390.258 109.904 392.787 109.904C395.635 109.904 397.699 108.982 398.941 107.096C399.12 108.017 399.622 108.729 400.4 109.263C401.043 109.651 401.859 109.828 402.891 109.828C403.821 109.828 404.529 109.721 404.993 109.543V106.196C404.999 106.179 404.988 106.174 404.977 106.174ZM397.239 104.433C396.207 105.463 394.889 105.996 393.36 105.996C391.831 105.996 390.582 105.463 389.55 104.433C388.551 103.404 388.054 102.088 388.054 100.525C388.054 98.9621 388.551 97.6523 389.55 96.6174C390.582 95.5879 391.831 95.0543 393.36 95.0543C394.889 95.0543 396.207 95.5879 397.239 96.6174C398.304 97.6469 398.839 98.9621 398.839 100.525C398.839 102.088 398.309 103.404 397.239 104.433ZM356.109 91.0818C353.369 91.0818 351.127 91.9334 349.349 93.6744C347.604 95.4154 346.713 97.6846 346.713 100.525V100.665C346.713 103.474 347.604 105.705 349.349 107.376C351.089 109.047 353.407 109.899 356.217 109.899C359.243 109.899 361.729 108.831 363.76 106.702V106.697L361.199 104.212C359.81 105.597 358.211 106.271 356.358 106.271C353.191 106.271 351.089 104.428 350.949 101.582H364.9C364.938 101.118 364.971 100.622 364.971 100.089C364.971 97.5337 364.155 95.3993 362.48 93.6637C360.842 91.9334 358.708 91.0818 356.109 91.0818ZM351.051 98.6117C351.16 97.5122 351.694 96.5905 352.656 95.8412C353.618 95.0974 354.791 94.7039 356.109 94.7039C357.357 94.7039 358.389 95.092 359.275 95.879C360.167 96.6228 360.626 97.5499 360.626 98.6117H351.051Z", fill: Gt(a)[i].textColor })
  ] });
}, hn = ur(), Fpe = (e) => {
  const r = {
    left: {
      borderTopRightRadius: `${hn.border.radius.lg}`,
      borderBottomRightRadius: `${hn.border.radius.lg}`
    },
    right: {
      borderTopLeftRadius: `${hn.border.radius.lg}`,
      borderBottomLeftRadius: `${hn.border.radius.lg}`
    },
    top: {
      borderBottomLeftRadius: `${hn.border.radius.lg}`,
      borderBottomRightRadius: `${hn.border.radius.lg}`
    },
    bottom: {
      borderTopLeftRadius: `${hn.border.radius.lg}`,
      borderTopRightRadius: `${hn.border.radius.lg}`
    },
    default: {
      borderRadius: `${hn.border.radius.none}`
    }
  };
  return r[e] || (r == null ? void 0 : r.default);
}, Jv = () => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between"
}), Zpe = Ne({
  drawer: (e, {
    position: r
  }) => M`
    box-shadow: none;
    overflow-y: auto;

    ${Jv()}
    ${Fpe(r)}

    ::-webkit-scrollbar {
      width: 4px;
      background: ${e.colors.neutral[100]};
      border-radius: ${e.spacing.xxs};
    }
    ::-webkit-scrollbar-track {
      background-color: ${e.colors.neutral[100]};
    }
    ::-webkit-scrollbar-thumb {
      background: ${e.colors.neutral[200]};
      border-radius: ${e.spacing.xxs};
    }
  `,
  body: (e) => M`
    padding: 0;
    margin: 0 ${e.spacing.sm};
    height: 92vh;

    ${Jv()};
  `,
  headerWrapper: M`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  title: M`
    margin-right: 0;
  `,
  header: (e, {
    labelButtonHeader: r
  }) => M`
    border-bottom: 1px solid ${e.colors.neutral[200]};
    display: ${r ? "block" : "flex"};
    margin: 0 ${e.spacing.sm};
    padding: ${e.spacing.sm} 0;
    position: sticky;
    top: 0;
    background-color: ${e.colors.background.white};
    z-index: 999;
  `,
  closeButton: (e) => M`
    background-color: ${e.colors.background.white};

    :hover {
      background-color: ${e.colors.background.white};
    }

    :active,
    :focus {
      border: none;
      background-color: ${e.colors.background.white};
    }
  `,
  footer: (e) => M`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    gap: ${e.spacing.xs};
    border-top: 1px solid ${e.colors.neutral[200]};
    padding: ${e.spacing.sm} 0;
    margin-top: ${e.spacing.sm};
    background-color: ${e.colors.background.white};
    position: sticky;
    bottom: 0;
  `
}), Wpe = ur(), K5e = ({
  children: e,
  id: r,
  withCloseButton: t = !1,
  position: n,
  title: o,
  labelButtonHeader: a,
  primaryLabel: i,
  secondaryLabel: l,
  disabledPrimaryAction: s,
  disabledSecondaryAction: u,
  actionButtonHeader: d,
  actionPrimary: f,
  actionSecondary: p,
  cy: g,
  ...h
}) => {
  const v = Zpe({
    position: n,
    labelButtonHeader: a
  }), y = ke(r), w = ke(r), $ = $e(() => {
    const C = /* @__PURE__ */ m(tr, { variant: "headingSmall", color: Wpe.colors.brand.primary[500], cy: Ee("drawer-title", g == null ? void 0 : g.title), showOnClarity: !0, children: o });
    return a && o ? /* @__PURE__ */ Y("div", { css: v.headerWrapper, children: [
      C,
      /* @__PURE__ */ m(st, { onClick: d, variant: "tertiary", cy: Ee("drawer-header-action", g == null ? void 0 : g.headerAction), children: a })
    ] }) : C;
  }, [g == null ? void 0 : g.title, g == null ? void 0 : g.headerAction, o, a, v.headerWrapper, d]);
  return /* @__PURE__ */ Y(kn, { id: y, styles: v, title: $(), withinPortal: !0, withCloseButton: t, position: n, "data-cy": Ee("drawer-wrapper", g == null ? void 0 : g.wrapper), ...h, children: [
    /* @__PURE__ */ m("div", { "data-cy": Ee("drawer-content", g == null ? void 0 : g.content), children: e }),
    /* @__PURE__ */ Y("div", { css: v.footer, children: [
      /* @__PURE__ */ m(st, { variant: "tertiary", onClick: p, id: w, disabled: u, cy: Ee("drawer-secondary-action", g == null ? void 0 : g.secondaryAction), children: l }),
      /* @__PURE__ */ m(st, { variant: "primary", onClick: f, id: w, disabled: s, cy: Ee("drawer-primary-action", g == null ? void 0 : g.primaryAction), children: i })
    ] })
  ] });
}, Bpe = Ne({
  root: (e) => M`
    font-family: ${e.typography.paragraphLarge.fontFamily};
  `,
  header: (e) => M`
    border-bottom: 1px solid ${e.colors.neutral[200]};
    padding: ${e.spacing.xs} 0;
    width: calc(100% - ${e.spacing.sm});
    margin: 0 auto;
  `,
  title: (e) => M`
    width: 100%;
    ${e.typography.headingSmall};
  `,
  titleWrapper: (e) => M`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    gap: ${e.spacing.xxs};
  `,
  inner: (e) => M`
    @media only screen and (max-width: ${e.grid.breakpoint.sm}) {
      padding: 0;
      margin: 0 auto;
      top: initial;
    }
  `,
  contentWrapper: (e) => M`
    ::-webkit-scrollbar {
      width: 4px;
      background: ${e.colors.neutral[100]};
      border-radius: ${e.spacing.xxs};
    }
    ::-webkit-scrollbar-track {
      background-color: ${e.colors.neutral[100]};
    }
    ::-webkit-scrollbar-thumb {
      background: ${e.colors.neutral[200]};
      border-radius: ${e.spacing.xxs};
    }

    @media only screen and (max-width: ${e.grid.breakpoint.sm}) {
      max-height: 55vh;
      overflow-y: auto;
    }

    @media only screen and (max-width: 320px) {
      height: 55%;
    }
  `,
  body: (e, {
    hasCustomHeader: r
  }) => M`
    @media only screen and (max-width: ${e.grid.breakpoint.sm}) {
      max-height: ${r ? "80%" : "88%"};
      height: auto;
    }

    @media only screen and (max-width: 320px) {
      height: 85%;
    }
  `,
  content: (e) => M`
    border-radius: ${e.border.radius.lg};

    @media only screen and (max-width: ${e.grid.breakpoint.sm}) {
      margin-bottom: 0;
      border-bottom-left-radius: ${e.border.radius.none};
      border-bottom-right-radius: ${e.border.radius.none};
    }
  `,
  footer: (e, {
    hasSecondaryAction: r
  }) => M`
    display: flex;
    align-items: flex-end;
    justify-content: ${r ? "space-between" : "flex-end"};
    gap: ${e.spacing.xs};

    > div {
      display: flex;
      gap: ${e.spacing.xs};
    }

    @media only screen and (max-width: ${e.grid.breakpoint.sm}) {
      width: 100%;
      bottom: 0;
      left: 0;
      padding: ${e.spacing.xs} 0;

      justify-content: center;
      align-items: center;
      flex-direction: column-reverse;

      button {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      > div {
        width: 100%;
        justify-content: center;
        align-items: center;
        flex-direction: column-reverse;
      }
    }
  `
}), qv = 450, Hpe = 700, Q5e = ({
  id: e,
  children: r,
  title: t,
  iconTitle: n,
  customHeader: o,
  size: a = Hpe,
  primaryActionLabel: i,
  secondaryActionLabel: l,
  negativeActionLabel: s,
  primaryAction: u,
  secondaryAction: d,
  negativeAction: f,
  disabledPrimaryAction: p,
  disabledSecondaryAction: g,
  busyPrimaryAction: h,
  busySecondaryAction: v,
  withinPortal: y = !0,
  primaryActionClassName: w,
  primaryActionId: $,
  cy: C,
  styles: x,
  ...b
}) => {
  const O = Bpe({
    hasSecondaryAction: !!l,
    hasCustomHeader: !!o
  }), _ = ur(), P = ke(e), S = ke(e), I = ke(e), N = ke(e), k = $e((V) => ({
    information: /* @__PURE__ */ m(Zi, { color: _.colors.brand.primary[300] }),
    warning: /* @__PURE__ */ m(Wi, { color: _.colors.feedback.warning[300] }),
    fail: /* @__PURE__ */ m(Fi, { color: _.colors.feedback.error[300] })
  })[V], [_.colors.brand.primary, _.colors.feedback.error, _.colors.feedback.warning]), j = $e(() => n ? /* @__PURE__ */ Y("div", { css: O.titleWrapper, "data-cy": Ee("text-modal-title", C == null ? void 0 : C.title), children: [
    k(n),
    " ",
    t
  ] }) : /* @__PURE__ */ m("div", { "data-cy": Ee("text-modal-title", C == null ? void 0 : C.title), children: t }), [k, n, O.titleWrapper, t, C]), R = $e(() => o || j(), [o, j]), D = $e(() => a <= qv ? qv : a, [a]), T = Mt(O, x || {});
  return /* @__PURE__ */ Y(gn, { styles: T, id: P, size: D(), title: R(), withinPortal: y, centered: !0, ...b, children: [
    /* @__PURE__ */ m("div", { css: [O.contentWrapper, x == null ? void 0 : x.contentWrapper, process.env.NODE_ENV === "production" ? "" : ";label:Modal;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], "data-cy": Ee("modal-content", C == null ? void 0 : C.content), children: r }),
    /* @__PURE__ */ Y("div", { css: [O.footer, x == null ? void 0 : x.footer, process.env.NODE_ENV === "production" ? "" : ";label:Modal;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2NvbmV4YS1oZXJvL2NvbmV4YS1oZXJvL3NyYy9jb21wb25lbnRzL292ZXJsYXlzL01vZGFsL01vZGFsLmNvbXBvbmVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNEhXIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL2NvbmV4YS1oZXJvL2NvbmV4YS1oZXJvL3NyYy9jb21wb25lbnRzL292ZXJsYXlzL01vZGFsL01vZGFsLmNvbXBvbmVudC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBGdW5jdGlvbkNvbXBvbmVudCwgdXNlQ2FsbGJhY2sgfSBmcm9tICdyZWFjdCdcbmltcG9ydCB7IE1vZGFsUHJvcHMgfSBmcm9tICcuL2luZGV4J1xuaW1wb3J0IGdldFN0eWxlcyBmcm9tICcuL01vZGFsLnN0eWxlcydcbmltcG9ydCB7IE1vZGFsIGFzIEJhc2VNb2RhbCwgTW9kYWxCYXNlU3R5bGVzTmFtZXMsIFN0eWxlcyB9IGZyb20gJ0BtYW50aW5lL2NvcmUnXG5pbXBvcnQge1xuICBJbmZvcm1hdGlvbiBhcyBJbmZvcm1hdGlvbkljb24sXG4gIFdhcm5pbmcgYXMgV2FybmluZ0ljb24sXG4gIEZhaWwgYXMgRmFpbEljb24sXG59IGZyb20gJ0Bjb25leGFzYXVkZS9pY29ucydcbmltcG9ydCB7IGdldFRoZW1lIH0gZnJvbSAnQC9jb250cm9sbGVycy90aGVtZUNvbnRyb2xsZXInXG5pbXBvcnQgeyBCdXR0b24gfSBmcm9tICdAL2NvbXBvbmVudHMvZm9ybS9CdXR0b24nXG5pbXBvcnQgeyB1c2VJZCB9IGZyb20gJ0BtYW50aW5lL2hvb2tzJ1xuaW1wb3J0IHsgTUFYX1NJWkVfREVTS1RPUF9ERUZBVUxULCBERUZBVUxUX1NJWkUgfSBmcm9tICcuL01vZGFsLmNvbnN0YW50cydcbmltcG9ydCB7IGdlbmVyYXRlQ3kgfSBmcm9tICdAL3V0aWxzL2dlbmVyYXRlQ3knXG5pbXBvcnQgbWVyZ2UgZnJvbSAndHMtZGVlcG1lcmdlJ1xuXG5leHBvcnQgY29uc3QgTW9kYWw6IEZ1bmN0aW9uQ29tcG9uZW50PE1vZGFsUHJvcHM+ID0gKHtcbiAgaWQsXG4gIGNoaWxkcmVuLFxuICB0aXRsZSxcbiAgaWNvblRpdGxlLFxuICBjdXN0b21IZWFkZXIsXG4gIHNpemUgPSBERUZBVUxUX1NJWkUsXG4gIHByaW1hcnlBY3Rpb25MYWJlbCxcbiAgc2Vjb25kYXJ5QWN0aW9uTGFiZWwsXG4gIG5lZ2F0aXZlQWN0aW9uTGFiZWwsXG4gIHByaW1hcnlBY3Rpb24sXG4gIHNlY29uZGFyeUFjdGlvbixcbiAgbmVnYXRpdmVBY3Rpb24sXG4gIGRpc2FibGVkUHJpbWFyeUFjdGlvbixcbiAgZGlzYWJsZWRTZWNvbmRhcnlBY3Rpb24sXG4gIGJ1c3lQcmltYXJ5QWN0aW9uLFxuICBidXN5U2Vjb25kYXJ5QWN0aW9uLFxuICB3aXRoaW5Qb3J0YWwgPSB0cnVlLFxuICBwcmltYXJ5QWN0aW9uQ2xhc3NOYW1lLFxuICBwcmltYXJ5QWN0aW9uSWQsXG4gIGN5LFxuICBzdHlsZXM6IGN1c3RvbVN0eWxlcyxcbiAgLi4ucmVzdFxufSkgPT4ge1xuICBjb25zdCBzdHlsZXMgPSBnZXRTdHlsZXMoe1xuICAgIGhhc1NlY29uZGFyeUFjdGlvbjogISFzZWNvbmRhcnlBY3Rpb25MYWJlbCxcbiAgICBoYXNDdXN0b21IZWFkZXI6ICEhY3VzdG9tSGVhZGVyLFxuICB9KVxuICBjb25zdCB0aGVtZSA9IGdldFRoZW1lKClcbiAgY29uc3QgbW9kYWxJZCA9IHVzZUlkKGlkKVxuICBjb25zdCBnZW5lcmF0ZVByaW1hcnlBY3Rpb25JZCA9IHVzZUlkKGlkKVxuICBjb25zdCBuZWdhdGl2ZUFjdGlvbklkID0gdXNlSWQoaWQpXG4gIGNvbnN0IHNlY29uZGFyeUFjdGlvbklkID0gdXNlSWQoaWQpXG5cbiAgY29uc3QgZ2V0SWNvblRpdGxlID0gdXNlQ2FsbGJhY2soXG4gICAgKGljb25OYW1lOiBNb2RhbFByb3BzWydpY29uVGl0bGUnXSkgPT4ge1xuICAgICAgY29uc3QgaWNvbnMgPSB7XG4gICAgICAgIGluZm9ybWF0aW9uOiAoXG4gICAgICAgICAgPEluZm9ybWF0aW9uSWNvbiBjb2xvcj17dGhlbWUuY29sb3JzLmJyYW5kLnByaW1hcnlbMzAwXX0gLz5cbiAgICAgICAgKSxcbiAgICAgICAgd2FybmluZzogPFdhcm5pbmdJY29uIGNvbG9yPXt0aGVtZS5jb2xvcnMuZmVlZGJhY2sud2FybmluZ1szMDBdfSAvPixcbiAgICAgICAgZmFpbDogPEZhaWxJY29uIGNvbG9yPXt0aGVtZS5jb2xvcnMuZmVlZGJhY2suZXJyb3JbMzAwXX0gLz4sXG4gICAgICB9XG5cbiAgICAgIHJldHVybiBpY29uc1tpY29uTmFtZV1cbiAgICB9LFxuICAgIFtcbiAgICAgIHRoZW1lLmNvbG9ycy5icmFuZC5wcmltYXJ5LFxuICAgICAgdGhlbWUuY29sb3JzLmZlZWRiYWNrLmVycm9yLFxuICAgICAgdGhlbWUuY29sb3JzLmZlZWRiYWNrLndhcm5pbmcsXG4gICAgXSxcbiAgKVxuXG4gIGNvbnN0IGhhbmRsZVRyYW5zZm9ybVRpdGxlID0gdXNlQ2FsbGJhY2soKCkgPT4ge1xuICAgIGlmIChpY29uVGl0bGUpIHtcbiAgICAgIHJldHVybiAoXG4gICAgICAgIDxkaXZcbiAgICAgICAgICBjc3M9e3N0eWxlcy50aXRsZVdyYXBwZXJ9XG4gICAgICAgICAgZGF0YS1jeT17Z2VuZXJhdGVDeSgndGV4dC1tb2RhbC10aXRsZScsIGN5Py50aXRsZSl9XG4gICAgICAgID5cbiAgICAgICAgICB7Z2V0SWNvblRpdGxlKGljb25UaXRsZSl9IHt0aXRsZX1cbiAgICAgICAgPC9kaXY+XG4gICAgICApXG4gICAgfVxuXG4gICAgcmV0dXJuIChcbiAgICAgIDxkaXYgZGF0YS1jeT17Z2VuZXJhdGVDeSgndGV4dC1tb2RhbC10aXRsZScsIGN5Py50aXRsZSl9Pnt0aXRsZX08L2Rpdj5cbiAgICApXG4gIH0sIFtnZXRJY29uVGl0bGUsIGljb25UaXRsZSwgc3R5bGVzLnRpdGxlV3JhcHBlciwgdGl0bGUsIGN5XSlcblxuICBjb25zdCBoYW5kbGVSZW5kZXJUaXRsZSA9IHVzZUNhbGxiYWNrKCgpID0+IHtcbiAgICBpZiAoY3VzdG9tSGVhZGVyKSB7XG4gICAgICByZXR1cm4gY3VzdG9tSGVhZGVyXG4gICAgfVxuXG4gICAgcmV0dXJuIGhhbmRsZVRyYW5zZm9ybVRpdGxlKClcbiAgfSwgW2N1c3RvbUhlYWRlciwgaGFuZGxlVHJhbnNmb3JtVGl0bGVdKVxuXG4gIGNvbnN0IGhhbmRsZU1vZGFsU2l6ZSA9IHVzZUNhbGxiYWNrKCgpID0+IHtcbiAgICBpZiAoc2l6ZSA8PSBNQVhfU0laRV9ERVNLVE9QX0RFRkFVTFQpIHtcbiAgICAgIHJldHVybiBNQVhfU0laRV9ERVNLVE9QX0RFRkFVTFRcbiAgICB9XG5cbiAgICByZXR1cm4gc2l6ZVxuICB9LCBbc2l6ZV0pXG5cbiAgY29uc3QgbWVyZ2VkU3R5bGVzID0gbWVyZ2UoXG4gICAgc3R5bGVzLFxuICAgIGN1c3RvbVN0eWxlcyB8fCB7fSxcbiAgKSBhcyB1bmtub3duIGFzIFN0eWxlczxNb2RhbEJhc2VTdHlsZXNOYW1lcz5cblxuICByZXR1cm4gKFxuICAgIDxCYXNlTW9kYWxcbiAgICAgIHN0eWxlcz17bWVyZ2VkU3R5bGVzfVxuICAgICAgaWQ9e21vZGFsSWR9XG4gICAgICBzaXplPXtoYW5kbGVNb2RhbFNpemUoKX1cbiAgICAgIHRpdGxlPXtoYW5kbGVSZW5kZXJUaXRsZSgpfVxuICAgICAgd2l0aGluUG9ydGFsPXt3aXRoaW5Qb3J0YWx9XG4gICAgICBjZW50ZXJlZFxuICAgICAgey4uLnJlc3R9XG4gICAgPlxuICAgICAgPGRpdlxuICAgICAgICBjc3M9e1tzdHlsZXMuY29udGVudFdyYXBwZXIsIGN1c3RvbVN0eWxlcz8uY29udGVudFdyYXBwZXJdfVxuICAgICAgICBkYXRhLWN5PXtnZW5lcmF0ZUN5KCdtb2RhbC1jb250ZW50JywgY3k/LmNvbnRlbnQpfVxuICAgICAgPlxuICAgICAgICB7Y2hpbGRyZW59XG4gICAgICA8L2Rpdj5cblxuICAgICAgPGRpdiBjc3M9e1tzdHlsZXMuZm9vdGVyLCBjdXN0b21TdHlsZXM/LmZvb3Rlcl19PlxuICAgICAgICB7c2Vjb25kYXJ5QWN0aW9uTGFiZWwgJiYgKFxuICAgICAgICAgIDxCdXR0b25cbiAgICAgICAgICAgIGlkPXtzZWNvbmRhcnlBY3Rpb25JZH1cbiAgICAgICAgICAgIHZhcmlhbnQ9XCJ0ZXJ0aWFyeVwiXG4gICAgICAgICAgICBvbkNsaWNrPXtzZWNvbmRhcnlBY3Rpb259XG4gICAgICAgICAgICBkaXNhYmxlZD17ZGlzYWJsZWRTZWNvbmRhcnlBY3Rpb259XG4gICAgICAgICAgICBidXN5PXtidXN5U2Vjb25kYXJ5QWN0aW9ufVxuICAgICAgICAgICAgY3k9e2dlbmVyYXRlQ3koJ21vZGFsLXNlY29uZGFyeS1hY3Rpb24nLCBjeT8uc2Vjb25kYXJ5QWN0aW9uKX1cbiAgICAgICAgICA+XG4gICAgICAgICAgICB7c2Vjb25kYXJ5QWN0aW9uTGFiZWx9XG4gICAgICAgICAgPC9CdXR0b24+XG4gICAgICAgICl9XG5cbiAgICAgICAgPGRpdj5cbiAgICAgICAgICB7bmVnYXRpdmVBY3Rpb25MYWJlbCAmJiAoXG4gICAgICAgICAgICA8QnV0dG9uXG4gICAgICAgICAgICAgIHZhcmlhbnQ9XCJzZWNvbmRhcnlcIlxuICAgICAgICAgICAgICBpZD17bmVnYXRpdmVBY3Rpb25JZH1cbiAgICAgICAgICAgICAgb25DbGljaz17bmVnYXRpdmVBY3Rpb259XG4gICAgICAgICAgICAgIGN5PXtnZW5lcmF0ZUN5KCdtb2RhbC1uZWdhdGl2ZS1hY3Rpb24nLCBjeT8ubmVnYXRpdmVBY3Rpb24pfVxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICB7bmVnYXRpdmVBY3Rpb25MYWJlbH1cbiAgICAgICAgICAgIDwvQnV0dG9uPlxuICAgICAgICAgICl9XG4gICAgICAgICAge3ByaW1hcnlBY3Rpb25MYWJlbCAmJiAoXG4gICAgICAgICAgICA8QnV0dG9uXG4gICAgICAgICAgICAgIGlkPXtwcmltYXJ5QWN0aW9uSWQgPz8gZ2VuZXJhdGVQcmltYXJ5QWN0aW9uSWR9XG4gICAgICAgICAgICAgIG9uQ2xpY2s9e3ByaW1hcnlBY3Rpb259XG4gICAgICAgICAgICAgIGJ1c3k9e2J1c3lQcmltYXJ5QWN0aW9ufVxuICAgICAgICAgICAgICBkaXNhYmxlZD17ZGlzYWJsZWRQcmltYXJ5QWN0aW9ufVxuICAgICAgICAgICAgICBjbGFzc05hbWU9e3ByaW1hcnlBY3Rpb25DbGFzc05hbWV9XG4gICAgICAgICAgICAgIGN5PXtnZW5lcmF0ZUN5KCdtb2RhbC1wcmltYXJ5LWFjdGlvbicsIGN5Py5wcmltYXJ5QWN0aW9uKX1cbiAgICAgICAgICAgID5cbiAgICAgICAgICAgICAge3ByaW1hcnlBY3Rpb25MYWJlbH1cbiAgICAgICAgICAgIDwvQnV0dG9uPlxuICAgICAgICAgICl9XG4gICAgICAgIDwvZGl2PlxuICAgICAgPC9kaXY+XG4gICAgPC9CYXNlTW9kYWw+XG4gIClcbn1cbiJdfQ== */"], children: [
      l && /* @__PURE__ */ m(st, { id: N, variant: "tertiary", onClick: d, disabled: g, busy: v, cy: Ee("modal-secondary-action", C == null ? void 0 : C.secondaryAction), children: l }),
      /* @__PURE__ */ Y("div", { children: [
        s && /* @__PURE__ */ m(st, { variant: "secondary", id: I, onClick: f, cy: Ee("modal-negative-action", C == null ? void 0 : C.negativeAction), children: s }),
        i && /* @__PURE__ */ m(st, { id: $ != null ? $ : S, onClick: u, busy: h, disabled: p, className: w, cy: Ee("modal-primary-action", C == null ? void 0 : C.primaryAction), children: i })
      ] })
    ] })
  ] });
}, Gpe = (e, r) => ({
  primary: "none",
  error: r.colors.feedback.error[100],
  success: r.colors.feedback.success[100],
  done: r.colors.brand.primary[100]
})[e], ho = {
  fileWrapper: {
    isMobile: M`
      max-width: 80px;
    `,
    error: M`
      display: block;
      gap: 2px;
    `,
    done: M`
      display: block;
      gap: 0;
    `
  },
  fileType: {
    hasImage: M`
      padding: 0;

      :hover {
        img {
          filter: brightness(0.5);
          transition: filter 0.3s ease-in-out;
        }
      }
    `,
    hasIcon: M`
      :hover {
        background-color: rgba(0, 0, 0, 0.6);
        transition: background-color 0.3s ease-in-out;

        svg {
          opacity: 0.4;
        }
      }
    `,
    viewFile: M`
      :hover::after {
        content: url('../src/assets/eye-on.png');
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    `
  },
  fileContentWrapper: {
    isMobile: (e) => M`
      flex-direction: column-reverse;
      align-items: flex-end;
      gap: ${e.spacing.xxs};
    `
  }
}, Xpe = Ne({
  container: (e, {
    width: r
  }) => M`
    display: flex;
    gap: ${e.spacing.xs};
    align-items: center;
    border-radius: ${e.border.radius.lg};
    background: ${e.colors.background.white};
    font-family: ${e.typography.label.fontFamily};
    padding: 20px;
    height: 80px;
    width: ${r || "100%"};
  `,
  fileWrapper: (e, {
    variant: r,
    isMobile: t
  }) => M`
    flex: 1;
    min-width: 0;
    flex-wrap: wrap;
    justify-content: space-between;
    display: flex;
    gap: 4px;

    ${r === "error" && ho.fileWrapper.error}
    ${r === "done" && ho.fileWrapper.done}

    p:first-of-type {
      color: ${e.colors.brand.primary[500]};
    }

    p {
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      ${t && ho.fileWrapper.isMobile}
    }
  `,
  fileType: (e, {
    variant: r,
    viewFile: t,
    hasImageUrl: n
  }) => M`
    background-color: ${Gpe(r, e)};
    border-radius: ${e.border.radius.lg};
    height: 48px;
    position: relative;
    cursor: ${t ? "pointer" : "default"};
    padding: ${e.spacing.xxs};

    ${t && ho.fileType.viewFile}

    ${!n && t && ho.fileType.hasIcon}

    ${r === "done" && t && n && ho.fileType.hasImage}
  `,
  description: (e) => M`
    width: 100%;
    color: ${e.colors.neutral[300]};
  `,
  removeActionWrapper: (e, {
    isMobile: r
  }) => M`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
      max-width: ${r ? "220px" : "100%"};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `,
  iconWrapper: (e) => M`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${e.spacing.xs};
    cursor: pointer;
  `,
  iconRemoveWrapper: (e) => M`
    display: flex;
    gap: ${e.spacing.xxs};

    svg {
      border: 1px solid ${e.colors.neutral[100]};
      border-radius: ${e.border.radius.lg};
      cursor: pointer;
    }
  `,
  fileContentWrapper: (e, {
    isMobile: r
  }) => M`
    display: flex;
    align-items: center;
    gap: ${e.spacing.xs};

    ${r && ho.fileContentWrapper.isMobile(e)}
  `,
  imageFileWrapper: (e) => M`
    width: 48px;
    height: 48px;
    border-radius: ${e.border.radius.lg};
  `
}), qd = {
  hasGap: {
    wrapper: (e) => M`
      gap: ${e.spacing.xxs};
      border: 1px solid transparent;
    `,
    attachmentsWithoutLastChild: M`
      border-bottom: 'initial';
    `,
    allAttachments: (e) => M`
      > div:has(:last-child) {
        border: 1px solid ${e.colors.neutral[100]};
        border-bottom-left-radius: ${e.border.radius.lg};
        border-bottom-right-radius: ${e.border.radius.lg};
      }
    `
  }
}, Ype = Ne({
  root: (e, {
    hasGap: r
  }) => M`
    display: flex;
    flex-direction: column;
    gap: 0;
    border: 1px solid ${e.colors.neutral[100]};
    border-radius: ${e.border.radius.lg};
    ${r && qd.hasGap.wrapper(e)}

    > div:not(:last-child) {
      border-bottom: 1px solid ${e.colors.neutral[100]};
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      ${r && qd.hasGap.attachmentsWithoutLastChild}
    }

    ${r && qd.hasGap.allAttachments(e)}
  `
}), TO = ({
  children: e,
  hasGap: r
}) => {
  const t = Ype({
    hasGap: r
  });
  return /* @__PURE__ */ m("div", { css: t.root, children: e });
};
TO.displayName = "Attachments.Group";
const DO = ({
  id: e,
  fileName: r,
  fileSize: t,
  iconFile: n,
  width: o = "100%",
  progressValue: a,
  variant: i,
  descriptionFile: l,
  error: s,
  cy: u,
  tagProps: d,
  actionList: f,
  imageUrl: p,
  handleRemoveFile: g,
  handleOpenFile: h
}) => {
  const v = ur(), y = ke(e), w = ke(e), [$, C] = fP(), {
    isMobile: x
  } = Hi(), b = Xpe({
    width: o,
    variant: i,
    isMobile: x,
    viewFile: !!h,
    hasImageUrl: !!p
  }), O = $e((k) => {
    const j = {
      pdf: /* @__PURE__ */ m(yx, { size: "large", color: v.colors.brand.primary[300] }),
      png: /* @__PURE__ */ m(bx, { size: "large", color: v.colors.brand.primary[300] }),
      doc: /* @__PURE__ */ m(Z0, { size: "large", color: v.colors.brand.primary[300] }),
      docx: /* @__PURE__ */ m(Z0, { size: "large", color: v.colors.brand.primary[300] }),
      csv: /* @__PURE__ */ m(F0, { size: "large", color: v.colors.brand.primary[300] }),
      xlsx: /* @__PURE__ */ m(F0, { size: "large", color: v.colors.brand.primary[300] }),
      default: /* @__PURE__ */ m(hx, { size: "large", color: v.colors.brand.primary[300] })
    };
    return j[k] || (j == null ? void 0 : j.default);
  }, [v.colors.brand.primary]), _ = $e(() => {
    const k = {
      primary: /* @__PURE__ */ m(Ex, { size: "large", ringColor: v.colors.brand.primary[500], spinColor: v.colors.brand.primary[300] }),
      error: /* @__PURE__ */ m(Cx, { size: "large", color: v.colors.feedback.error[300] }),
      success: /* @__PURE__ */ m(mx, { size: "large", color: v.colors.feedback.success[300] }),
      done: O(n)
    };
    return k[i] || (k == null ? void 0 : k.primary);
  }, [n, i, v.colors.brand.primary, v.colors.feedback.error, v.colors.feedback.success, O]), P = Je(() => ({
    error: i === "error",
    done: i === "done",
    primary: i === "primary",
    diffPrimary: i !== "primary",
    diffError: i !== "error"
  }), [i]), S = $e((k) => {
    const j = {
      error: /* @__PURE__ */ m(tr, { renderAs: "p", variant: "paragraphSmall", color: v.colors.feedback.error[300], children: s }),
      done: /* @__PURE__ */ m(tr, { renderAs: "p", variant: "paragraphSmall", css: b.description, children: l }),
      default: /* @__PURE__ */ m(nO, { id: w, value: (P == null ? void 0 : P.primary) && a, variant: k })
    };
    return j[k] || (j == null ? void 0 : j.default);
  }, [l, s, a, w, b.description, v.colors.feedback.error, P == null ? void 0 : P.primary]), I = $e(() => x ? "Excluir arquivo" : "Confirmar a exclusão do arquivo", [x]), N = $e(() => {
    const k = {
      default: /* @__PURE__ */ Y("div", { css: b.fileWrapper, children: [
        /* @__PURE__ */ m(tr, { variant: "subheading", children: r }),
        (P == null ? void 0 : P.diffError) && /* @__PURE__ */ m(tr, { renderAs: "span", variant: "paragraphSmall", color: v.colors.neutral[300], children: t }),
        S(i)
      ] }),
      done: /* @__PURE__ */ Y(Br, { children: [
        /* @__PURE__ */ Y("div", { css: b.fileWrapper, children: [
          /* @__PURE__ */ m(tr, { variant: "subheading", children: r }),
          S(i)
        ] }),
        (P == null ? void 0 : P.diffError) && /* @__PURE__ */ Y("div", { css: b.fileContentWrapper, children: [
          d && /* @__PURE__ */ m(Bi, { size: x ? "small" : "medium", ...d }),
          /* @__PURE__ */ m(tr, { renderAs: "span", variant: "paragraphSmall", color: v.colors.neutral[300], children: t })
        ] })
      ] })
    };
    return k[i] || (k == null ? void 0 : k.default);
  }, [b.fileWrapper, b.fileContentWrapper, r, P == null ? void 0 : P.diffError, v.colors.neutral, t, S, i, d, x]);
  return /* @__PURE__ */ m("div", { css: b.container, id: y, "data-cy": Ee("attachments-wrapper", u == null ? void 0 : u.wrapper), children: $ ? /* @__PURE__ */ Y("div", { css: b.removeActionWrapper, children: [
    /* @__PURE__ */ Y(tr, { variant: "paragraphLarge", color: v.colors.brand.primary[500], children: [
      I(),
      " ",
      /* @__PURE__ */ m("b", { children: `"${r}"` }),
      "?"
    ] }),
    /* @__PURE__ */ Y("div", { css: b.iconRemoveWrapper, children: [
      /* @__PURE__ */ m(Fo, { color: v.colors.feedback.error[300], size: "large", onClick: C }),
      /* @__PURE__ */ m(M1, { color: v.colors.feedback.success[300], size: "large", onClick: g, "data-testid": "confirm-delete-icon" })
    ] })
  ] }) : /* @__PURE__ */ Y(Br, { children: [
    /* @__PURE__ */ m("div", { css: b.fileType, onClick: P != null && P.done ? h : null, children: p != null && p.length && (P != null && P.done) ? /* @__PURE__ */ m("img", { src: p, alt: r, css: b.imageFileWrapper, "data-testid": "image" }) : _() }),
    N(),
    g && !f && /* @__PURE__ */ m("div", { css: b.iconWrapper, children: /* @__PURE__ */ m(px, { color: v.colors.neutral[200], onClick: C, "data-testid": "delete-icon" }) }),
    (f == null ? void 0 : f.length) > 0 && /* @__PURE__ */ m("div", { css: b.iconWrapper, children: /* @__PURE__ */ Y(Nr, { children: [
      /* @__PURE__ */ m(Nr.Target, { children: /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(dx, { color: v.colors.neutral[200], "data-testid": "more-options" }) }) }),
      /* @__PURE__ */ Y(Nr.Dropdown, { children: [
        g && /* @__PURE__ */ m(Nr.Item, { onClick: C, children: "Excluir arquivo" }),
        f == null ? void 0 : f.map((k) => /* @__PURE__ */ m(Nr.Item, { onClick: k == null ? void 0 : k.onClick, children: k == null ? void 0 : k.children }, k == null ? void 0 : k.id))
      ] })
    ] }) })
  ] }) });
};
DO.displayName = "Attachments";
DO.Group = TO;
const Upe = (e) => e ? "148px" : "172px", Jpe = 1, qpe = Ne({
  root: (e, {
    width: r,
    isMobile: t
  }) => M`
    background-color: ${e.colors.background.white};
    border: 2px dashed ${e.colors.neutral[200]};
    border-radius: ${e.border.radius.lg};
    padding: ${e.spacing.md} ${e.spacing.xs};
    height: ${Upe(t)};
    width: ${r || "100%"};
    margin-bottom: ${e.spacing.xs};
    cursor: pointer;

    :hover {
      background-color: ${e.colors.neutral[100]};
    }
  `,
  contentWrapper: (e) => M`
    display: flex;
    gap: 4px;
    text-align: center;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    button {
      margin-top: ${e.spacing.xxs};
      border: none;
    }
  `
}), zl = ur(), Kpe = ue((e, r) => {
  const {
    id: t,
    onDrop: n,
    buttonLabel: o,
    width: a,
    caption: i,
    error: l,
    actionClassName: s,
    maxFiles: u,
    cy: d,
    ...f
  } = e, {
    isMobile: p,
    isDesktop: g
  } = Hi(), h = qpe({
    width: a,
    isMobile: p
  }), v = ke(t), y = ke(t), w = Je(() => l ? zl.colors.feedback.error[300] : zl.colors.neutral[200], [l]), $ = Je(() => u === Jpe, [u]), C = Je(() => $ ? p ? "Carregue seu arquivo" : "Arraste seu arquivo até aqui" : p ? "Carregue seus arquivos" : "Arraste seus arquivos até aqui", [p, $]), x = Je(() => $ ? "ou carregue o arquivo que está no seu computador" : "ou carregue arquivos que estão no seu computador", [$]);
  return /* @__PURE__ */ Y(Br, { children: [
    /* @__PURE__ */ m(SK, { id: v, onDrop: n, styles: h, unstyled: !0, ref: r, "data-cy": Ee("uploader-dropzone", d == null ? void 0 : d.dropzone), ...f, children: /* @__PURE__ */ Y("div", { css: h.contentWrapper, children: [
      /* @__PURE__ */ m("div", { children: /* @__PURE__ */ m(tr, { variant: "headingSmall", color: zl.colors.brand.primary[500], children: C }) }),
      /* @__PURE__ */ m(tr, { renderAs: "span", variant: "paragraphSmall", color: zl.colors.neutral[300], children: g && x }),
      /* @__PURE__ */ m(st, { id: y, type: "button", className: s, cy: Ee("uploader-action", d == null ? void 0 : d.action), children: o })
    ] }) }),
    /* @__PURE__ */ m(tr, { variant: "microCopy", color: w, children: i })
  ] });
});
Kpe.displayName = "Uploader";
const Qpe = Ne({
  wrapper: ({
    spacing: e
  }) => M`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: fit-content;

    button {
      margin-top: ${e.xxs};
      background: transparent;
    }

    input {
      display: none;
    }
  `
}), e7e = ({
  src: e,
  onClick: r,
  onChange: t,
  buttonLabel: n,
  id: o,
  cy: a,
  ...i
}) => {
  const l = Qpe(), s = Ve(null), u = ke(o), d = $e((p) => {
    var h;
    (h = p.target.files) != null && h[0] && t && t(p);
  }, [t]);
  function f(p) {
    s.current.value = "", s.current.click(), r && r(p);
  }
  return /* @__PURE__ */ Y("div", { css: l.wrapper, "data-cy": Ee("imageUploader-wrapper", a == null ? void 0 : a.wrapper), children: [
    /* @__PURE__ */ m("div", { onClick: f, children: /* @__PURE__ */ m(Ta, { id: o, src: e, size: "x-large" }) }),
    /* @__PURE__ */ m(st, { id: o, onClick: f, variant: "tertiary", type: "button", cy: Ee("imageUploader-button", a == null ? void 0 : a.button), children: n }),
    /* @__PURE__ */ m("input", { type: "file", accept: "image/*", onChange: d, ref: s, "data-testid": "image-uploader-input", id: u, "data-cy": Ee("imageUploader-input", a == null ? void 0 : a.input), ...i })
  ] });
};
export {
  Nr as ActionList,
  $5e as Alert,
  DD as AppShell,
  YD as AspectRatio,
  DO as Attachments,
  Ix as Autocomplete,
  Ta as Avatar,
  P5e as Banner,
  T5e as Box,
  F5e as Breadcrumbs,
  st as Button,
  j5e as Card,
  h5e as Center,
  b2 as Checkbox,
  Ax as CheckboxGroup,
  kx as Chip,
  D5e as Collapse,
  Z5e as ConexaBetiLogo,
  W5e as ConexaCuidaLogo,
  B5e as ConexaEquilibrioLogo,
  H5e as ConexaExclusivaLogo,
  G5e as ConexaImedicinaLogo,
  X5e as ConexaLogo,
  Y5e as ConexaLogoIcon,
  U5e as ConexaPlusLogo,
  Wfe as CurrencyInput,
  ofe as DatePicker,
  K5e as Drawer,
  H$ as Dropdown,
  S5e as EnvironmentIdentifier,
  IB as Flex,
  Oy as Grid,
  Ey as Group,
  R5e as Header,
  b5e as IMAGE_MIME_TYPE,
  e7e as ImageUploader,
  Sx as Input,
  gfe as InputPassword,
  Ex as Loader,
  at as MIME_TYPES,
  w5e as MS_EXCEL_MIME_TYPE,
  _5e as MS_POWERPOINT_MIME_TYPE,
  C5e as MS_WORD_MIME_TYPE,
  JM as MantineProvider,
  FH as MediaQuery,
  A5e as Menu,
  Q5e as Modal,
  Afe as MonthPicker,
  jfe as MultiSelect,
  y5e as PDF_MIME_TYPE,
  L5e as Pagination,
  z5e as PaginationOptions,
  Hfe as PinInput,
  nO as Progress,
  J5e as PsicologiaVivaLogo,
  q5e as PsyAliveLogo,
  Y$ as Radio,
  X$ as RadioGroup,
  I5e as Rating,
  SA as ResetStyles,
  M5e as ScrollArea,
  wfe as SearchBox,
  k5e as Sidebar,
  _U as SimpleGrid,
  SU as Space,
  x5e as Spoiler,
  LU as Stack,
  Yv as Step,
  V5e as Stepper,
  bfe as Switch,
  N5e as Table,
  L1 as Tabs,
  Bi as Tag,
  tr as Text,
  $fe as Textarea,
  v5e as ThemeProvider,
  Pfe as TimeInput,
  E5e as TimerCountDown,
  f2e as ToastCompact,
  O5e as ToastContainer,
  g2e as ToastExpanded,
  e2e as Tooltip,
  Kpe as Uploader,
  M as css,
  ur as getTheme,
  Ne as makeStyles,
  VP as setTheme,
  lk as toast,
  u1 as useBreakpointMatch,
  r8 as useClickOutside,
  t5e as useCounter,
  n5e as useDebouncedValue,
  H0 as useDisclosure,
  o5e as useForceUpdate,
  c5e as useFullscreen,
  ke as useId,
  p5e as useInputState,
  a5e as useInterval,
  i5e as useLocalStorage,
  u5e as useLogger,
  t8 as useMediaQuery,
  g5e as useNetwork,
  d5e as useOs,
  l5e as usePagination,
  f5e as useSetState,
  fP as useToggle,
  s5e as useViewportSize
};
//# sourceMappingURL=index.es.js.map
